// Comprehensive CPT Code Database with 2026 CMS wRVU Values
// Source: CMS CY 2026 Physician Fee Schedule (CMS-1832-F), PPRRVU2026_Jan - Released 12/29/2025
// Total codes: 11,624 | Effective: January 1, 2026

export const CPT_LOOKUP = {
 "00100": { name: "Anesthesia Procedure Salivary Gland With Biopsy", wrvu: 0.00 },
 "00102": { name: "Anesthesia Procedure Plastic Repair Cleft Lip", wrvu: 0.00 },
 "00103": { name: "Anesthesia Reconstructive Procedure Eyelid", wrvu: 0.00 },
 "00104": { name: "Anesthesia Electroconvulsive Therapeutic", wrvu: 0.00 },
 "00120": { name: "Anesthesia Procedure Ear With Biopsy Not Otherwise Specified", wrvu: 0.00 },
 "00124": { name: "Anesthesia Procedure Ear Otoscopy", wrvu: 0.00 },
 "00126": { name: "Anesthesia Procedure Ear Tympanotomy", wrvu: 0.00 },
 "00140": { name: "Anesthesia Procedures On Eye Not Otherwise Specified", wrvu: 0.00 },
 "00142": { name: "Anesthesia Procedure On Eye Lens Surgery", wrvu: 0.00 },
 "00144": { name: "Anesthesia Procedure Eye Corneal Transplant", wrvu: 0.00 },
 "00145": { name: "Anesthesia Procedure Eye Vitreoretinal Surgery", wrvu: 0.00 },
 "00147": { name: "Anesthesia Procedure On Eye Iridectomy", wrvu: 0.00 },
 "00148": { name: "Anesthesia Procedure Eye Ophthalmoscopy", wrvu: 0.00 },
 "00160": { name: "Anesthesia Procedure Nose and sinus Not Otherwise Specified", wrvu: 0.00 },
 "00162": { name: "Anesthesia Procedure Nose and sinus Radical Surgery", wrvu: 0.00 },
 "00164": { name: "Anesthesia Procedure Nose and Sinus Biopsy Soft Tissue", wrvu: 0.00 },
 "00170": { name: "Anesthesia Intraoral Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00172": { name: "Anesthesia Intraoral Procedure Repair Cleft Palate", wrvu: 0.00 },
 "00174": { name: "Anesthesia Ntrorl Excision Retropharyngeal Tumor", wrvu: 0.00 },
 "00176": { name: "Anesthesia Intraoral Procedure Radical Surgery", wrvu: 0.00 },
 "00190": { name: "Anesthesia Procedure Facial Bone/skull Not Otherwise Specified", wrvu: 0.00 },
 "00192": { name: "Anesthesia Procedure Facial Bone/skl Radical Surgery", wrvu: 0.00 },
 "00210": { name: "Anesthesia Intracranial Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00211": { name: "Anesthesia Intracranial Procedure Cranial/Cranial Hematoma", wrvu: 0.00 },
 "00212": { name: "Anesthesia Intracranial Procedure Subdural Taps", wrvu: 0.00 },
 "00214": { name: "Anesthesia Intracranial Procedure Burr Holes", wrvu: 0.00 },
 "00215": { name: "Anesthesia Intracranial Procedure Crnop/elvtn Fracture", wrvu: 0.00 },
 "00216": { name: "Anesthesia Intracranial Procedure Vascular Procedure", wrvu: 0.00 },
 "00218": { name: "Anesthesia Intracranial Procedure In Sitting Pos", wrvu: 0.00 },
 "00220": { name: "Anesthesia Intracranial Procedure Cerebrospinal Fluid Shunting Procedure", wrvu: 0.00 },
 "00222": { name: "Anesthesia Intracranial Procedure Electrocoagulation Intracranial Nerve", wrvu: 0.00 },
 "00300": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Integumentary Head/Neck/Posterior Trunk", wrvu: 0.00 },
 "00320": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Neck Not Otherwise Specified 1yr/>", wrvu: 0.00 },
 "00322": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Neck Needle Biopsy Thyroid", wrvu: 0.00 },
 "00326": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Larynx and trach<1yr", wrvu: 0.00 },
 "00350": { name: "Anesthesia Procedure Major Vessel Neck Not Otherwise Specified", wrvu: 0.00 },
 "00352": { name: "Anesthesia Procedure Maj Vessel Neck Simple Ligation", wrvu: 0.00 },
 "00400": { name: "Anesthesia Integumentary System Not Otherwise Specified", wrvu: 0.00 },
 "00402": { name: "Anesthesia Integumentary System Reconstructive Breast", wrvu: 0.00 },
 "00404": { name: "Anesthesia Integumentary System Radical/Modified Breast", wrvu: 0.00 },
 "00406": { name: "Anesthesia Integumentary System Radical Breast Dissection", wrvu: 0.00 },
 "00410": { name: "Anesthesia Integumentary System Conv Arrhythmia", wrvu: 0.00 },
 "00450": { name: "Anesthesia Procedure Clavicle and scapula Not Otherwise Specified", wrvu: 0.00 },
 "00454": { name: "Anesthesia Procedure Clavicle and scapula Biopsy Clavicle", wrvu: 0.00 },
 "00470": { name: "Anesthesia Partial Rib Resection Not Otherwise Specified", wrvu: 0.00 },
 "00472": { name: "Anesthesia Partial Rib Resection Thoracop", wrvu: 0.00 },
 "00474": { name: "Anesthesia Partial Rib Resection Radical Procedure", wrvu: 0.00 },
 "00500": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure On Esophagus", wrvu: 0.00 },
 "00520": { name: "Anesthesia Closed Chest Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00522": { name: "Anesthesia Closed Chest Procedure Needle Biopsy Pleura", wrvu: 0.00 },
 "00524": { name: "Anesthesia Closed Chest Procedure Pneumocentesis", wrvu: 0.00 },
 "00528": { name: "Anesthesia Closed Chest Mediastinal and Thoracic Without", wrvu: 0.00 },
 "00529": { name: "Anesthesia Closed Chest Mediastinal and Thoracic W/", wrvu: 0.00 },
 "00530": { name: "Anesthesia Permanent Transvenous Pacemaker Insertion", wrvu: 0.00 },
 "00532": { name: "Anesthesia Access Central Venous Circulation", wrvu: 0.00 },
 "00534": { name: "Anesthesia Insertion/Replacement Cardioverter-Defibrillator", wrvu: 0.00 },
 "00537": { name: "Anesthesia Cardiac Electrophysiology Procedures", wrvu: 0.00 },
 "00539": { name: "Anesthesia Tracheobronchial Reconstruction", wrvu: 0.00 },
 "00540": { name: "Anesthesia Thoracotomy Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00541": { name: "Anesthesia Thoracotomy Procedure 1 Lung Ventilation", wrvu: 0.00 },
 "00542": { name: "Anesthesia Thoracotomy Procedure Decortication", wrvu: 0.00 },
 "00546": { name: "Anesthesia Thoracotomy Procedure Pulm Resection", wrvu: 0.00 },
 "00548": { name: "Anesthesia Thoracotomy Procedure Trach and bronchi", wrvu: 0.00 },
 "00550": { name: "Anesthesia For Sternal Debridement", wrvu: 0.00 },
 "00560": { name: "Anesthesia Procedure Heart Without Pump Oxygenation", wrvu: 0.00 },
 "00561": { name: "Anesthesia Procedure Heart With Pump<1 Year", wrvu: 0.00 },
 "00562": { name: "Anesthesia Procedure Heart With Pump Age 1yr+", wrvu: 0.00 },
 "00563": { name: "Anesthesia Procedure Heart With Pump Circulatory Arst", wrvu: 0.00 },
 "00566": { name: "Anesthesia Direct Coronary Artery Bypass Graft Without Pump", wrvu: 0.00 },
 "00567": { name: "Anesthesia Direct Coronary Artery Bypass Graft With Pump", wrvu: 0.00 },
 "00580": { name: "Anesthesia Heart/lung Transplant", wrvu: 0.00 },
 "00600": { name: "Anesthesia Procedure Cervical Spine and cord Not Otherwise Specified", wrvu: 0.00 },
 "00604": { name: "Anesthesia Procedure Cervical Spine and Cord Sitting", wrvu: 0.00 },
 "00620": { name: "Anesthesia Procedure Thoracic Spine and cord Not Otherwise Specified", wrvu: 0.00 },
 "00625": { name: "Anesthesia Thoracic Spine without 1-lung Ventilation", wrvu: 0.00 },
 "00626": { name: "Anesthesia Thoracic Spine With 1 Lung Ventilation", wrvu: 0.00 },
 "00630": { name: "Anesthesia Procedure Lumbar Region Not Otherwise Specified", wrvu: 0.00 },
 "00632": { name: "Anesthesia Procedure Lumbar Sympathectomy", wrvu: 0.00 },
 "00635": { name: "Anesthesia Diagnosis/Therapeutic Lumbar Puncture", wrvu: 0.00 },
 "00640": { name: "Anesthesia Spine Manipulation", wrvu: 0.00 },
 "00670": { name: "Anesthesia Extensive Spine and Spinal Cord Procedure", wrvu: 0.00 },
 "00700": { name: "Anesthesia Procedure Upper Anterior Abdominal Wall Not Otherwise Specified", wrvu: 0.00 },
 "00702": { name: "Anesthesia Upper Anterior Abdominal Wall Liver Biopsy", wrvu: 0.00 },
 "00730": { name: "Anesthesia Procedure Upper Pst Abdominal Wall", wrvu: 0.00 },
 "00731": { name: "Anesthesia Upper Gastrointestinal Endoscopy Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00732": { name: "Anesthesia Upper Gastrointestinal Endoscopy Procedure ERCP", wrvu: 0.00 },
 "00750": { name: "Anesthesia Hernia Repair Upper Abdominal Not Otherwise Specified", wrvu: 0.00 },
 "00752": { name: "Anesthesia Hernia Repair Lumbar and ventral&/dehiscence", wrvu: 0.00 },
 "00754": { name: "Anesthesia Hernia Repair Omphalocele", wrvu: 0.00 },
 "00756": { name: "Anesthesia Hernia Repair Diaphragmatic Hernia", wrvu: 0.00 },
 "00770": { name: "Anesthesia Procedure Maj Abdominal Blood Vessel", wrvu: 0.00 },
 "00790": { name: "Anesthesia Iper Upper Abdominal Not Otherwise Specified", wrvu: 0.00 },
 "00792": { name: "Anesthesia Iper Upper Abdominal Partial Hepatectomy", wrvu: 0.00 },
 "00794": { name: "Anesthesia Iper Upper Abdominal Pancreatectomy", wrvu: 0.00 },
 "00796": { name: "Anesthesia Iper Upper Abdominal Liver Transplant", wrvu: 0.00 },
 "00797": { name: "Anesthesia Iper Upper Abdominal Gastric Procedure Month", wrvu: 0.00 },
 "00800": { name: "Anesthesia Procedure Lower Anterior Abdominal Wal Not Otherwise Specified", wrvu: 0.00 },
 "00802": { name: "Anesthesia Procedure Lower Abdominal Wal Pannic", wrvu: 0.00 },
 "00811": { name: "Anesthesia Lower Intst Endoscopy Not Otherwise Specified", wrvu: 0.00 },
 "00812": { name: "Anesthesia Lower Intst Scr Colsc", wrvu: 0.00 },
 "00813": { name: "Anesthesia Upper Lower Gastrointestinal Endoscopy Procedure", wrvu: 0.00 },
 "00820": { name: "Anesthesia Procedure Lower Posterior Abdominal Wall", wrvu: 0.00 },
 "00830": { name: "Anesthesia Hernia Repair Lower Abdominal Not Otherwise Specified", wrvu: 0.00 },
 "00832": { name: "Anesthesia Hernia Repair Ventral and incisional", wrvu: 0.00 },
 "00834": { name: "Anesthesia Hernia Repair<1 Year Age", wrvu: 0.00 },
 "00836": { name: "Anesthesia Hernia Repair<37wk Birth<50", wrvu: 0.00 },
 "00840": { name: "Anesthesia Iper Procedure Lower Abdominal Not Otherwise Specified", wrvu: 0.00 },
 "00842": { name: "Anesthesia Iper Procedure Amniocentesis", wrvu: 0.00 },
 "00844": { name: "Anesthesia Iper Procedure Abdmnprnl Resection", wrvu: 0.00 },
 "00846": { name: "Anesthesia Iper Procedure Radical Hystrectomy", wrvu: 0.00 },
 "00848": { name: "Anesthesia Iper Procedure Pel Exentration", wrvu: 0.00 },
 "00851": { name: "Anesthesia Iper Procedure Tubal Ligation", wrvu: 0.00 },
 "00860": { name: "Anesthesia Xtrprtl Procedure Lower Abdominal Not Otherwise Specified", wrvu: 0.00 },
 "00862": { name: "Anesthesia Xtrprtl Lower Abdominal Rnl Procedure", wrvu: 0.00 },
 "00864": { name: "Anesthesia Xtrprt Lower Abdominal Tot Cstc", wrvu: 0.00 },
 "00865": { name: "Anesthesia Xtrprt Lower Abdominal Prst8ect", wrvu: 0.00 },
 "00866": { name: "Anesthesia Xtrprt Lw Abdominal Adrnlctmy", wrvu: 0.00 },
 "00868": { name: "Anesthesia Xtrprtl Procedure Rnl Transpl", wrvu: 0.00 },
 "00870": { name: "Anesthesia Xtrprtl Cystolithotomy", wrvu: 0.00 },
 "00872": { name: "Anesthesia Lithotrp Esw Water Bath", wrvu: 0.00 },
 "00873": { name: "Anesthesia Lithotrp Esw without Wtr Bth", wrvu: 0.00 },
 "00880": { name: "Anesthesia Maj Lower Abdominal Vessel Not Otherwise Specified", wrvu: 0.00 },
 "00882": { name: "Anesthesia Maj Lower Adb Vessel Ivc Ligation", wrvu: 0.00 },
 "00902": { name: "Anesthesia Anorectal Procedure", wrvu: 0.00 },
 "00904": { name: "Anesthesia Radical Perineal Procedure", wrvu: 0.00 },
 "00906": { name: "Anesthesia Vulvectomy", wrvu: 0.00 },
 "00908": { name: "Anesthesia Perineal Prostatectomy", wrvu: 0.00 },
 "00910": { name: "Anesthesia Transurethral Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00912": { name: "Anesthesia Trurl Procedure Resection Bladder Tumor", wrvu: 0.00 },
 "00914": { name: "Anesthesia Trurl Procedure Resection Prst8", wrvu: 0.00 },
 "00916": { name: "Anesthesia Trurl Procedure Resection Bleeding", wrvu: 0.00 },
 "00918": { name: "Anesthesia Trurl Procedure Urtrl Cal Removal", wrvu: 0.00 },
 "00920": { name: "Anesthesia Procedure Male Genitalia Not Otherwise Specified", wrvu: 0.00 },
 "00921": { name: "Anesthesia Procedure Male Genitalia Vasec", wrvu: 0.00 },
 "00922": { name: "Anesthesia Procedure Male Gent Sem Ves", wrvu: 0.00 },
 "00924": { name: "Anesthesia Male Gent Undscnd Tstis", wrvu: 0.00 },
 "00926": { name: "Anesthesia Male Gent Radical Orchiopexy Ing", wrvu: 0.00 },
 "00928": { name: "Anesthesia Male Gent Radical Orchiopexy Abdominal", wrvu: 0.00 },
 "00930": { name: "Anesthesia Procedure Male Gent Orchiopexy", wrvu: 0.00 },
 "00932": { name: "Anesthesia Male Gent Compl Amp Pns", wrvu: 0.00 },
 "00934": { name: "Anesthesia Radical Amp Penis Ingun Lym", wrvu: 0.00 },
 "00936": { name: "Anesthesia Radical Amp Pns Ingun and ilac", wrvu: 0.00 },
 "00938": { name: "Anesthesia Insertion Penile Prosthesis", wrvu: 0.00 },
 "00940": { name: "Anesthesia Vaginal Procedure Not Otherwise Specified", wrvu: 0.00 },
 "00942": { name: "Anesthesia Vaginal Procedure Clptmy Vgnc Clpr", wrvu: 0.00 },
 "00944": { name: "Anesthesia Vaginal Procedure Vaginal Hysterectomy", wrvu: 0.00 },
 "00948": { name: "Anesthesia Vaginal Procedure Cervical Cerclage", wrvu: 0.00 },
 "00950": { name: "Anesthesia Vaginal Procedure Culdoscopy", wrvu: 0.00 },
 "00952": { name: "Anesthesia Vaginal Procedure Hystsc&/hsg", wrvu: 0.00 },
 "01112": { name: "Anesthesia Bone Marrow Aspiration&/Biopsy", wrvu: 0.00 },
 "01120": { name: "Anesthesia Procedure On Bony Pelvis", wrvu: 0.00 },
 "01130": { name: "Anesthesia Body Cast Application/revj", wrvu: 0.00 },
 "01140": { name: "Anesthesia Ntrplvabdmnl Amputation", wrvu: 0.00 },
 "01150": { name: "Anesthesia Radical Procedure Tumor Of Pelvis", wrvu: 0.00 },
 "01160": { name: "Anesthesia Closed Procedure Symph Pub/si Joint", wrvu: 0.00 },
 "01170": { name: "Anesthesia Open Procedure Symph Pub/si Joint", wrvu: 0.00 },
 "01173": { name: "Anesthesia Open Repair Fracture Disruption Pelvis", wrvu: 0.00 },
 "01200": { name: "Anesthesia Acute Lymphoblastic Leukemia Closed Procedure Hip Joint", wrvu: 0.00 },
 "01202": { name: "Anesthesia Arthroscopic Procedure Hip Joint", wrvu: 0.00 },
 "01210": { name: "Anesthesia Open Procedure Hip Joint Not Otherwise Specified", wrvu: 0.00 },
 "01212": { name: "Anesthesia Open Procedure Hip Joint Disarticulation", wrvu: 0.00 },
 "01214": { name: "Anesthesia Open Procedure Tot Hip Arthrp", wrvu: 0.00 },
 "01215": { name: "Anesthesia Open Revj Tot Hip Arthrp", wrvu: 0.00 },
 "01220": { name: "Anesthesia Closed Procedure Upper 2/3 Femur", wrvu: 0.00 },
 "01230": { name: "Anesthesia Open Upper 2/3 Femur Not Otherwise Specified", wrvu: 0.00 },
 "01232": { name: "Anesthesia Open Procedure Upper 2/3 Fem Amp", wrvu: 0.00 },
 "01234": { name: "Anesthesia Open Upper 2/3 Fem Radical Res", wrvu: 0.00 },
 "01250": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Nerve Muscle Upper Leg", wrvu: 0.00 },
 "01260": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Veins Upper Leg", wrvu: 0.00 },
 "01270": { name: "Anesthesia Procedure Arteries Upper Leg Not Otherwise Specified", wrvu: 0.00 },
 "01272": { name: "Anesthesia Procedure Artery Femoral Artery Ligation", wrvu: 0.00 },
 "01274": { name: "Anesthesia Procedure Artery Fem Artery Emblc", wrvu: 0.00 },
 "01320": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Nerve Msc Knee&/pop", wrvu: 0.00 },
 "01340": { name: "Anesthesia Closed Procedure Lower 1/3 Femur", wrvu: 0.00 },
 "01360": { name: "Anesthesia Open Procedure Lower 1/3 Femur", wrvu: 0.00 },
 "01380": { name: "Anesthesia Acute Lymphoblastic Leukemia Closed Procedure Knee Joint", wrvu: 0.00 },
 "01382": { name: "Anesthesia Diagnosis Arthroscopy Procedure Knee Joint", wrvu: 0.00 },
 "01390": { name: "Anesthesia Cls Procedure Upper Tibial Fibular&/pat", wrvu: 0.00 },
 "01392": { name: "Anesthesia Open Procedure Upper Tibial Fibular&/pat", wrvu: 0.00 },
 "01400": { name: "Anesthesia Open/Arthroscopy Knee Joint Not Otherwise Specified", wrvu: 0.00 },
 "01402": { name: "Anesthesia Open/arth Tot Knee Arthrp", wrvu: 0.00 },
 "01404": { name: "Anesthesia Open/Arthroscopy Disarticulation Knee", wrvu: 0.00 },
 "01420": { name: "Anesthesia Cast Application Removal/Repair Knee Joint", wrvu: 0.00 },
 "01430": { name: "Anesthesia Procedure Veins Knee and pop Not Otherwise Specified", wrvu: 0.00 },
 "01432": { name: "Anesthesia Procedure Vein Knee and pop Av Fistula", wrvu: 0.00 },
 "01440": { name: "Anesthesia Procedure Artery Knee and pop Not Otherwise Specified", wrvu: 0.00 },
 "01442": { name: "Anesthesia Procedure Artery Knee and pop Teaec", wrvu: 0.00 },
 "01444": { name: "Anesthesia Procedure Artery Knee and pop Excision and grf", wrvu: 0.00 },
 "01462": { name: "Anesthesia Closed Procedure Lower Lips/Arms/Feet", wrvu: 0.00 },
 "01464": { name: "Anesthesia Arthroscopy Procedure Ankle&/foot", wrvu: 0.00 },
 "01470": { name: "Anesthesia Procedure Nerve Msc Lw Lips/Arms/Feet Not Otherwise Specified", wrvu: 0.00 },
 "01472": { name: "Anesthesia Repair Report Achilles Tendon", wrvu: 0.00 },
 "01474": { name: "Anesthesia Gastrocnemius Recession", wrvu: 0.00 },
 "01480": { name: "Anesthesia Open Procedure Lower Lips/Arms/Feet Not Otherwise Specified", wrvu: 0.00 },
 "01482": { name: "Anesthesia Open Lower Lips/Arms/Feet Radical Resection", wrvu: 0.00 },
 "01484": { name: "Anesthesia Open Lw Lips/Arms/Feet Oste/ostpl", wrvu: 0.00 },
 "01486": { name: "Anesthesia Open Total Ankle Replacement", wrvu: 0.00 },
 "01490": { name: "Anesthesia Lower Leg Cast Application Removal/Repair", wrvu: 0.00 },
 "01500": { name: "Anesthesia Procedure Artery Lower Leg Not Otherwise Specified", wrvu: 0.00 },
 "01502": { name: "Anesthesia Procedure Artery Lower Leg Emblc", wrvu: 0.00 },
 "01520": { name: "Anesthesia Procedure Veins Lower Leg Not Otherwise Specified", wrvu: 0.00 },
 "01522": { name: "Anesthesia Procedure Vein Lower Leg Ven Thrombosis", wrvu: 0.00 },
 "01610": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Nerve Muscle Shoulder and axillary", wrvu: 0.00 },
 "01620": { name: "Anesthesia Closed Procedure Shoulder Joint", wrvu: 0.00 },
 "01622": { name: "Anesthesia Diagnosis Arthr Procedure Shoulder Joint", wrvu: 0.00 },
 "01630": { name: "Anesthesia Open/arthr Procedure Shoulder Joint Not Otherwise Specified", wrvu: 0.00 },
 "01634": { name: "Anesthesia Open/Arthroscopy Shoulder Disarticulation", wrvu: 0.00 },
 "01636": { name: "Anesthesia Open/arthr Ntrthrc Amp", wrvu: 0.00 },
 "01638": { name: "Anesthesia Open/arthr Tot Shoulder Rplcm", wrvu: 0.00 },
 "01650": { name: "Anesthesia Artery Shoulder and Axillary Not Otherwise Specified", wrvu: 0.00 },
 "01652": { name: "Anesthesia Artery Shoulder and Axillary Axillary-brch Arsm", wrvu: 0.00 },
 "01654": { name: "Anesthesia Artery Shoulder and Axillary Bypass Grf", wrvu: 0.00 },
 "01656": { name: "Anesthesia Artery Shoulder and Axillary Axillary-fem Bpg", wrvu: 0.00 },
 "01670": { name: "Anesthesia Acute Lymphoblastic Leukemia Procedure Vein Shoulder and axillary", wrvu: 0.00 },
 "01680": { name: "Anesthesia Shoulder Cast Application Removal/Repair", wrvu: 0.00 },
 "01710": { name: "Anesthesia Procedure Nerve Muscle Upper A and e Not Otherwise Specified", wrvu: 0.00 },
 "01712": { name: "Anesthesia Procedure Nerve Msc Upper A and e Tnot", wrvu: 0.00 },
 "01714": { name: "Anesthesia Nerve Msc Upper A and e Tnplsty", wrvu: 0.00 },
 "01716": { name: "Anesthesia Nerve Msc Upper A and e Tndsis", wrvu: 0.00 },
 "01730": { name: "Anesthesia Closed Procedure Humerus and elbow", wrvu: 0.00 },
 "01732": { name: "Anesthesia Diagnosis Arthroscopy Procedure Elbow Joint", wrvu: 0.00 },
 "01740": { name: "Anesthesia Open/Arthroscopy Procedure Elbow Not Otherwise Specified", wrvu: 0.00 },
 "01742": { name: "Anesthesia Open/Arthroscopy Elbow Osteot", wrvu: 0.00 },
 "01744": { name: "Anesthesia Open/Arthroscopy Elbow Repair Humeral", wrvu: 0.00 },
 "01756": { name: "Anesthesia Open/Arthroscopy Elbow Radical Procedure", wrvu: 0.00 },
 "01758": { name: "Anesthesia Open/Arthroscopy Elbow Excision Cst", wrvu: 0.00 },
 "01760": { name: "Anesthesia Open/arthr Elb Tot Rplct", wrvu: 0.00 },
 "01770": { name: "Anesthesia Procedure Artery Upper Arm and elbow Not Otherwise Specified", wrvu: 0.00 },
 "01772": { name: "Anesthesia Artery Upper Arm and elbow Emblc", wrvu: 0.00 },
 "01780": { name: "Anesthesia Procedure Vein Upper Arm and elbow Not Otherwise Specified", wrvu: 0.00 },
 "01782": { name: "Anesthesia Vein Upper Arm and elbow Phlbrpy", wrvu: 0.00 },
 "01810": { name: "Anesthesia Procedure Nerve Muscle Forearm Wrist", wrvu: 0.00 },
 "01820": { name: "Anesthesia Closed Procedure Rds U/with H Bones", wrvu: 0.00 },
 "01829": { name: "Anesthesia Diagnosis Arthroscopic Procedure Wrist", wrvu: 0.00 },
 "01830": { name: "Anesthesia Arthr/Endoscopy Wrist/hnd Not Otherwise Specified", wrvu: 0.00 },
 "01832": { name: "Anesthesia Arthr/Endoscopy Tot Wrist Rpl", wrvu: 0.00 },
 "01840": { name: "Anesthesia Artery Forearm Wrist and hnd Not Otherwise Specified", wrvu: 0.00 },
 "01842": { name: "Anesthesia Artery Farm Wrist and hnd Emblc", wrvu: 0.00 },
 "01844": { name: "Anesthesia Vasc Shunt/shunt Revj", wrvu: 0.00 },
 "01850": { name: "Anesthesia Vein Forearm Wrist and hnd Not Otherwise Specified", wrvu: 0.00 },
 "01852": { name: "Anesthesia Procedure Vein Forearm Phlbrrhaphy", wrvu: 0.00 },
 "01860": { name: "Anesthesia Forearm Wrist/hand Cast", wrvu: 0.00 },
 "01916": { name: "Anesthesia Diagnosis Arteriography/vngrph", wrvu: 0.00 },
 "01920": { name: "Anesthesia Cardiac Catheterization", wrvu: 0.00 },
 "01922": { name: "Anesthesia N-invas Imaging/radj Therapeutic", wrvu: 0.00 },
 "01924": { name: "Anesthesia Therapeutic Ivntl Radical Artl Not Otherwise Specified", wrvu: 0.00 },
 "01925": { name: "Anesthesia Ivntl Radical Artl Crtd/c", wrvu: 0.00 },
 "01926": { name: "Anesthesia Ivntl Radical Intracranial Icar/aort", wrvu: 0.00 },
 "01930": { name: "Anesthesia Therapeutic Ivntl Radical Ven Not Otherwise Specified", wrvu: 0.00 },
 "01931": { name: "Anesthesia Ivnt Radical Ntrhpt/prt Circulatory", wrvu: 0.00 },
 "01932": { name: "Anesthesia Th Ivnt Radical Ntrthrc/jug", wrvu: 0.00 },
 "01933": { name: "Anesthesia Therapeutic Ivntl Radical Procedure Intracranial", wrvu: 0.00 },
 "01937": { name: "Anesthesia Drainage/Aspiration Cervical/Thoracic", wrvu: 0.00 },
 "01938": { name: "Anesthesia Drainage/Aspiration Lumbar/Sacral", wrvu: 0.00 },
 "01939": { name: "Anesthesia Nulyt Agt Cervical/Thoracic", wrvu: 0.00 },
 "01940": { name: "Anesthesia Nulyt Agt Lumbar/Sacral", wrvu: 0.00 },
 "01941": { name: "Anesthesia Neuromd/ntrvrt Cervical/Thoracic", wrvu: 0.00 },
 "01942": { name: "Anesthesia Neuromd/ntrvrt Lumbar/Sacral", wrvu: 0.00 },
 "01951": { name: "Anesthesia 2 and 3 Burn Less 4 % Tbsa", wrvu: 0.00 },
 "01952": { name: "Anesthesia 2 and 3 Burn 4-9% Tbsa", wrvu: 0.00 },
 "01953": { name: "Anesthesia 2 and 3 Burn Each Add 9% Tbsa", wrvu: 0.00 },
 "01958": { name: "Anesthesia Xtrnl Cephalic Version", wrvu: 0.00 },
 "01960": { name: "Anesthesia Vaginal Delivery Only", wrvu: 0.00 },
 "01961": { name: "Anesthesia Cesarean Delivery Only", wrvu: 0.00 },
 "01962": { name: "Anesthesia Urgent Hysterectomy", wrvu: 0.00 },
 "01963": { name: "Anesthesia Cesarean Hysterectomy", wrvu: 0.00 },
 "01965": { name: "Anesthesia Incompl/missed Ab Procedure", wrvu: 0.00 },
 "01966": { name: "Anesthesia Induced Abortion Procedure", wrvu: 0.00 },
 "01967": { name: "Neuraxl Labor Anesthesia Vaginal Dlvr", wrvu: 0.00 },
 "01968": { name: "Anesthesia/analg Cs Dlvr Neuraxial", wrvu: 0.00 },
 "01969": { name: "Anesthesia C Hyst Flwg Neuraxial", wrvu: 0.00 },
 "01990": { name: "Physiol Support Hrvg Organs", wrvu: 0.00 },
 "01991": { name: "Anesthesia Diagnosis/Therapeutic Nerve Blk and Injection Oth", wrvu: 0.00 },
 "01992": { name: "Anesthesia Diagnosis/Therapeutic Nerve Blk and Injection Prn", wrvu: 0.00 },
 "01996": { name: "Dly Hospital Management Edrl Prescription Administration", wrvu: 0.00 },
 "01999": { name: "Unlisted Anesthesia Procedure", wrvu: 0.00 },
 "10004": { name: "FNA Biopsy Without Imaging Guidance Each Additional", wrvu: 0.78 },
 "10005": { name: "FNA Biopsy With Ultrasound Guidance 1st Lesion", wrvu: 1.42 },
 "10006": { name: "FNA Biopsy With Ultrasound Guidance Each Additional", wrvu: 0.98 },
 "10007": { name: "FNA Biopsy With Fluoroscopic Guidance 1st Lesion", wrvu: 1.76 },
 "10008": { name: "FNA Biopsy With Fluoroscopic Guidance Each Additional", wrvu: 1.15 },
 "10009": { name: "FNA Biopsy With CT Guidance 1st Lesion", wrvu: 2.20 },
 "10010": { name: "FNA Biopsy With CT Guidance Each Additional", wrvu: 1.61 },
 "10011": { name: "FNA Biopsy With Mr Guidance 1st Lesion", wrvu: 0.00 },
 "10012": { name: "FNA Biopsy With Mr Guidance Each Additional", wrvu: 0.00 },
 "10021": { name: "FNA Biopsy Without Imaging Guidance 1st Lesion", wrvu: 1.00 },
 "10030": { name: "Image-Guided Fluid Collection Drainage Soft Tissue", wrvu: 2.68 },
 "10035": { name: "Placement Soft Tissue Localization Device 1st", wrvu: 1.66 },
 "10036": { name: "Placement Soft Tissue Localization Device Each", wrvu: 0.83 },
 "10040": { name: "Extraction", wrvu: 0.89 },
 "10060": { name: "Incision & Drainage, Simple Abscess", wrvu: 1.19 },
 "10061": { name: "Incision & Drainage, Complicated Abscess", wrvu: 2.39 },
 "10080": { name: "Incision & Drainage, Pilonidal Cyst, Simple", wrvu: 1.19 },
 "10081": { name: "Incision & Drainage, Pilonidal Cyst, Complicated", wrvu: 2.44 },
 "10120": { name: "Incision, Foreign Body Removal, Simple", wrvu: 1.19 },
 "10121": { name: "Incision, Foreign Body Removal, Complicated", wrvu: 2.67 },
 "10140": { name: "Incision & Drainage Hematoma Seroma/fluid Collj", wrvu: 1.54 },
 "10160": { name: "Puncture Aspiration of Abscess/Hematoma/Cyst", wrvu: 1.22 },
 "10180": { name: "Incision & Drainage Complex Posterior-Op Wound Infected", wrvu: 2.24 },
 "11000": { name: "Dbrdmt Ecz/infected Skin<10%", wrvu: 0.59 },
 "11001": { name: "Dbrdmt Ecz/infected Skin Each Additional", wrvu: 0.29 },
 "11004": { name: "Dbrdmt Skin Xtrnl Gent and per", wrvu: 10.53 },
 "11005": { name: "Dbrdmt Skin Abdominal Wall", wrvu: 13.88 },
 "11006": { name: "Dbrdmt Skin Xtrnl Gent Per", wrvu: 12.77 },
 "11008": { name: "Removal Prosthetic Material/mesh Abdominal Wall", wrvu: 4.88 },
 "11010": { name: "Debride Skin At Fracture Site", wrvu: 4.09 },
 "11011": { name: "Debride Skin Muscle At Fracture Site", wrvu: 4.82 },
 "11012": { name: "Debridement Skin Bone At Fracture Site", wrvu: 6.70 },
 "11042": { name: "Dbrdmt Subcutaneous Tis 1st 20sqcm/<", wrvu: 0.98 },
 "11043": { name: "Dbrdmt Muscle&/fsca 1st 20/<", wrvu: 2.63 },
 "11044": { name: "Dbrdmt Bone 1st 20 subcutaneous cm/<", wrvu: 4.00 },
 "11045": { name: "Dbrdmt Subcutaneous Tiss Each Additional", wrvu: 0.49 },
 "11046": { name: "Dbrdmt Muscle&/fsca Each Additional", wrvu: 1.00 },
 "11047": { name: "Dbrdmt Bone Each Additional", wrvu: 1.76 },
 "11055": { name: "Paring/Cutting Benign Hyperkeratosis Lesion 1", wrvu: 0.34 },
 "11056": { name: "Parng/Cutting Benign Hyprkr Lesion 2-4", wrvu: 0.49 },
 "11057": { name: "Parng/Cutting Benign Hyprkr Lesion >4", wrvu: 0.63 },
 "11102": { name: "Tangential Biopsy of Skin, Single Lesion", wrvu: 0.64 },
 "11103": { name: "Tangential Biopsy of Skin, Each Additional Lesion", wrvu: 0.37 },
 "11104": { name: "Punch Biopsy of Skin, Single Lesion", wrvu: 0.81 },
 "11105": { name: "Punch Biopsy of Skin, Each Additional Lesion", wrvu: 0.44 },
 "11106": { name: "Incisional Biopsy of Skin, Single Lesion", wrvu: 0.98 },
 "11107": { name: "Incisional Biopsy of Skin, Each Additional Lesion", wrvu: 0.53 },
 "11200": { name: "Skin Tag Removal, Up to 15 Lesions", wrvu: 0.80 },
 "11201": { name: "Skin Tag Removal, Each Additional 10 Lesions", wrvu: 0.28 },
 "11300": { name: "Shaving of Epidermal Lesion, Trunk/Arm/Leg, 0.5 cm or less", wrvu: 0.59 },
 "11301": { name: "Shaving of Epidermal Lesion, Trunk/Arm/Leg, 0.6-1.0 cm", wrvu: 0.88 },
 "11302": { name: "Shaving of Epidermal Lesion, Trunk/Arm/Leg, 1.1-2.0 cm", wrvu: 1.02 },
 "11303": { name: "Shave Skin Lesion >2.0 Cm", wrvu: 1.22 },
 "11305": { name: "Shaving of Epidermal Lesion, Scalp/Neck/Hands/Feet/Genitalia, 0.5 cm or less", wrvu: 0.78 },
 "11306": { name: "Shaving of Epidermal Lesion, Scalp/Neck/Hands/Feet/Genitalia, 0.6-1.0 cm", wrvu: 0.94 },
 "11307": { name: "Shave Skin Lesion 1.1-2.0 Cm", wrvu: 1.17 },
 "11308": { name: "Shave Skin Lesion >2.0 Cm", wrvu: 1.42 },
 "11310": { name: "Shaving of Epidermal Lesion, Face, 0.5 cm or less", wrvu: 0.78 },
 "11311": { name: "Shaving of Epidermal Lesion, Face, 0.6-1.0 cm", wrvu: 1.07 },
 "11312": { name: "Shave Skin Lesion 1.1-2.0 Cm", wrvu: 1.27 },
 "11313": { name: "Shave Skin Lesion >2.0 Cm", wrvu: 1.64 },
 "11400": { name: "Excision, Benign Lesion, Trunk/Arm/Leg, 0.5 cm or less", wrvu: 0.88 },
 "11401": { name: "Excision, Benign Lesion, Trunk/Arm/Leg, 0.6-1.0 cm", wrvu: 1.25 },
 "11402": { name: "Excision, Benign Lesion, Trunk/Arm/Leg, 1.1-2.0 cm", wrvu: 1.41 },
 "11403": { name: "Excision, Benign Lesion, Trunk/Arm/Leg, 2.1-3.0 cm", wrvu: 1.79 },
 "11404": { name: "Excision Tr-External Benign+marg 3.1-4 Cm", wrvu: 2.06 },
 "11406": { name: "Excision, Benign Lesion, Trunk/Arm/Leg, 3.1-4.0 cm", wrvu: 3.43 },
 "11420": { name: "Excision, Benign Lesion, Scalp/Neck/Hands/Feet/Genitalia, 0.5 cm or less", wrvu: 1.00 },
 "11421": { name: "Excision, Benign Lesion, Scalp/Neck/Hands/Feet/Genitalia, 0.6-1.0 cm", wrvu: 1.43 },
 "11422": { name: "Excision H-f-nk-sp Benign+marg 1.1-2", wrvu: 1.64 },
 "11423": { name: "Excision H-f-nk-sp Benign+marg 2.1-3", wrvu: 2.01 },
 "11424": { name: "Excision H-f-nk-sp Benign+marg 3.1-4", wrvu: 2.42 },
 "11426": { name: "Excision H-f-nk-sp Benign+marg >4 Cm", wrvu: 3.99 },
 "11440": { name: "Excision, Benign Lesion, Face, 0.5 cm or less", wrvu: 1.02 },
 "11441": { name: "Excision, Benign Lesion, Face, 0.6-1.0 cm", wrvu: 1.49 },
 "11442": { name: "Excision Face-Multiple Myeloma Benign+marg 1.1-2 Cm", wrvu: 1.73 },
 "11443": { name: "Excision Face-Multiple Myeloma Benign+marg 2.1-3 Cm", wrvu: 2.28 },
 "11444": { name: "Excision Face-Multiple Myeloma Benign+marg 3.1-4 Cm", wrvu: 3.11 },
 "11446": { name: "Excision Face-Multiple Myeloma Benign+marg >4 Cm", wrvu: 4.68 },
 "11450": { name: "Excision Skin Hidradenitis Axillary Simple/intermediate", wrvu: 3.14 },
 "11451": { name: "Excision Skin Hidradenitis Axillary Complex", wrvu: 4.32 },
 "11462": { name: "Excision Skin Hidradenitis Inguinal Simple/intermediate", wrvu: 2.93 },
 "11463": { name: "Excision Skin Hidradenitis Inguinal Complex", wrvu: 4.32 },
 "11470": { name: "Excision Skin Hidradenitis/Perianal/Perineal/Umbilical Simple/intermediate", wrvu: 3.65 },
 "11471": { name: "Excision Skin Hidradenitis/Perianal/Perineal/Umbilical Complex", wrvu: 4.77 },
 "11600": { name: "Excision, Malignant Lesion, Trunk/Arm/Leg, 0.5 cm or less", wrvu: 1.59 },
 "11601": { name: "Excision, Malignant Lesion, Trunk/Arm/Leg, 0.6-1.0 cm", wrvu: 2.02 },
 "11602": { name: "Excision, Malignant Lesion, Trunk/Arm/Leg, 1.1-2.0 cm", wrvu: 2.21 },
 "11603": { name: "Excision Tr-External Mal+marg 2.1-3 Cm", wrvu: 2.75 },
 "11604": { name: "Excision Tr-External Mal+marg 3.1-4 Cm", wrvu: 3.09 },
 "11606": { name: "Excision Tr-External Mal+marg >4 Cm", wrvu: 4.89 },
 "11620": { name: "Excision, Malignant Lesion, Scalp/Neck/Hands/Feet/Genitalia, 0.5 cm or less", wrvu: 1.60 },
 "11621": { name: "Excision, Malignant Lesion, Scalp/Neck/Hands/Feet/Genitalia, 0.6-1.0 cm", wrvu: 2.03 },
 "11622": { name: "Excision Scalp/Neck/Hands/Feet/Genitalia Malignant + Margin 1.1-2", wrvu: 2.35 },
 "11623": { name: "Excision Scalp/Neck/Hands/Feet/Genitalia Malignant + Margin 2.1-3", wrvu: 3.03 },
 "11624": { name: "Excision Scalp/Neck/Hands/Feet/Genitalia Malignant + Margin 3.1-4", wrvu: 3.53 },
 "11626": { name: "Excision Scalp/Neck/Hands/Feet/Genitalia Malignant + Margin >4 Cm", wrvu: 4.49 },
 "11640": { name: "Excision, Malignant Lesion, Face, 0.5 cm or less", wrvu: 1.63 },
 "11641": { name: "Excision, Malignant Lesion, Face, 0.6-1.0 cm", wrvu: 2.12 },
 "11642": { name: "Excision Face/Ears/Eyelids/Nose/Lips Malignant + Margin 1.1-2", wrvu: 2.55 },
 "11643": { name: "Excision Face/Ears/Eyelids/Nose/Lips Malignant + Margin 2.1-3", wrvu: 3.33 },
 "11644": { name: "Excision Face/Ears/Eyelids/Nose/Lips Malignant + Margin 3.1-4", wrvu: 4.23 },
 "11646": { name: "Excision Face/Ears/Eyelids/Nose/Lips Malignant + Margin >4 Cm", wrvu: 6.10 },
 "11719": { name: "Trim Nail(s) Any Number", wrvu: 0.17 },
 "11720": { name: "Debride Nail 1-5", wrvu: 0.31 },
 "11721": { name: "Debride Nail 6 Or More", wrvu: 0.53 },
 "11730": { name: "Avulsion Nail Plate Simple 1", wrvu: 1.02 },
 "11732": { name: "Avulsion Nail Plate Simple Each", wrvu: 0.37 },
 "11740": { name: "Evacuation Subungual Hematoma", wrvu: 0.36 },
 "11750": { name: "Excision Nail and nail Matrix", wrvu: 1.54 },
 "11755": { name: "Biopsy Nail Unit", wrvu: 1.22 },
 "11760": { name: "Repair Of Nail Bed", wrvu: 1.59 },
 "11762": { name: "Reconstruction Of Nail Bed", wrvu: 2.87 },
 "11765": { name: "Wedge Excision Skin Nail Fold", wrvu: 1.19 },
 "11770": { name: "Excision Pilonidal Cyst Simple", wrvu: 2.59 },
 "11771": { name: "Excision Pilonidal Cyst Extensive", wrvu: 5.94 },
 "11772": { name: "Excision Pilonidal Cyst Comp", wrvu: 7.17 },
 "11900": { name: "Inject Skin Lesions </w 7", wrvu: 0.51 },
 "11901": { name: "Inject Skin Lesions >7", wrvu: 0.78 },
 "11920": { name: "Correct Skin Color 6.0 Cm/<", wrvu: 1.57 },
 "11921": { name: "Correct Skin Color 6.1-20.0cm", wrvu: 1.88 },
 "11922": { name: "Correct Skin Color Each 20.0cm", wrvu: 0.48 },
 "11950": { name: "Subcutaneous Injection Filling Matrl 1cc/<", wrvu: 0.82 },
 "11951": { name: "Subcutaneous Injection Fil Matrl 1.1-5.0cc", wrvu: 1.16 },
 "11952": { name: "Subcutaneous Injection Fil Matrl 5.1-10cc", wrvu: 1.65 },
 "11954": { name: "Subcutaneous Injection Fil Matrl>10.0 Cc", wrvu: 1.80 },
 "11960": { name: "Insert Tissue Expander(s)", wrvu: 11.20 },
 "11970": { name: "Replacement Tiss Xpndr Permanent Implt", wrvu: 7.30 },
 "11971": { name: "Removal Tis Xpndr without Insertion Implt", wrvu: 6.84 },
 "11976": { name: "Removal of Contraceptive Capsules (Nexplanon)", wrvu: 1.74 },
 "11980": { name: "Implant Hormone Pellet(s)", wrvu: 1.07 },
 "11981": { name: "Insertion of Contraceptive Capsules (Nexplanon)", wrvu: 1.11 },
 "11982": { name: "Removal of Contraceptive Capsules, Non-Palpable", wrvu: 1.31 },
 "11983": { name: "Removal with Reinsertion of Contraceptive Capsules", wrvu: 1.86 },
 "12001": { name: "Simple Repair, Scalp/Neck/Trunk/Extremities, 2.5 cm or less", wrvu: 0.82 },
 "12002": { name: "Simple Repair, Scalp/Neck/Trunk/Extremities, 2.6-7.5 cm", wrvu: 1.11 },
 "12004": { name: "Simple Repair, Scalp/Neck/Trunk/Extremities, 7.6-12.5 cm", wrvu: 1.40 },
 "12005": { name: "Simple Repair, Scalp/Neck/Trunk/Extremities, 12.6-20.0 cm", wrvu: 1.92 },
 "12006": { name: "Repair Scalp/Neck/Axillae/Genitalia/Trunk 20.1-30.0cm", wrvu: 2.33 },
 "12007": { name: "Repair Scalp/Neck/Axillae/Genitalia/Trunk >30.0 Cm", wrvu: 2.83 },
 "12011": { name: "Simple Repair, Face/Ears/Eyelids/Nose/Lips/Mucosae, 2.5 cm or less", wrvu: 1.04 },
 "12013": { name: "Simple Repair, Face/Ears/Eyelids/Nose/Lips/Mucosae, 2.6-5.0 cm", wrvu: 1.19 },
 "12014": { name: "Simple Repair, Face/Ears/Eyelids/Nose/Lips/Mucosae, 5.1-7.5 cm", wrvu: 1.53 },
 "12015": { name: "Repair Face/Ears/Eyelids/Nose/Lips/Mucosae 7.6-12.5 Cm", wrvu: 1.93 },
 "12016": { name: "Repair FEar/Eye/ExtremityNose/Lip/Mouth 12.6-20.0 Cm", wrvu: 2.61 },
 "12017": { name: "Repair FEar/Eye/ExtremityNose/Lip/Mouth 20.1-30.0 Cm", wrvu: 3.10 },
 "12018": { name: "Repair Face/Ears/Eyelids/Nose/Lips/Mucosae >30.0 Cm", wrvu: 3.52 },
 "12020": { name: "Treatment Supfc Wound Dehiscence Simple Closure", wrvu: 2.60 },
 "12021": { name: "Treatment Supfc Wound Dehiscence With Packing", wrvu: 1.84 },
 "12031": { name: "Intermediate Repair, Scalp/Trunk/Extremities, 2.5 cm or less", wrvu: 1.95 },
 "12032": { name: "Intermediate Repair, Scalp/Trunk/Extremities, 2.6-7.5 cm", wrvu: 2.46 },
 "12034": { name: "Intermediate Repair, Scalp/Trunk/Extremities, 7.6-12.5 cm", wrvu: 2.90 },
 "12035": { name: "Intermediate Repair Scalp/Axillae/Trunk/Extremity 12.6-20", wrvu: 3.41 },
 "12036": { name: "Intermediate Repair Scalp/Axillae/Trunk/Extremity 20.1-30", wrvu: 4.12 },
 "12037": { name: "Intermediate Repair Scalp/Trunk/Extremities >30.0 Cm", wrvu: 4.88 },
 "12041": { name: "Intermediate Repair Neck/Hands/Feet/Genitalia, 2.5cm/<", wrvu: 2.05 },
 "12042": { name: "Intermediate Repair Neck/Hands/Feet/Genitalia, 2.6-7.5", wrvu: 2.72 },
 "12044": { name: "Intermediate Repair Neck/Hands/Feet/Genitalia, 7.6-12.5", wrvu: 3.11 },
 "12045": { name: "Intermediate Repair Neck/Hands/Feet/Genitalia, 12.6-20", wrvu: 3.66 },
 "12046": { name: "Intermediate Repair Neck/Hands/Feet/Genitalia, 20.1-30", wrvu: 4.19 },
 "12047": { name: "Intermediate Repair Neck/Hands/Feet/Genitalia >30.0cm", wrvu: 4.83 },
 "12051": { name: "Intermediate Repair, Face/Ears/Eyelids/Nose/Lips/Mucosae, 2.5 cm or less", wrvu: 2.27 },
 "12052": { name: "Intermediate Repair, Face/Ears/Eyelids/Nose/Lips/Mucosae, 2.6-5.0 cm", wrvu: 2.80 },
 "12053": { name: "Intermediate Repair Face/Multiple Myeloma 5.1-7.5 Cm", wrvu: 3.09 },
 "12054": { name: "Intermediate Repair Face/Multiple Myeloma 7.6-12.5cm", wrvu: 3.41 },
 "12055": { name: "Intermediate Repair Face/Multiple Myeloma 12.6-20 Cm", wrvu: 4.39 },
 "12056": { name: "Intermediate Repair Face/Multiple Myeloma 20.1-30.0", wrvu: 5.17 },
 "12057": { name: "Intermediate Repair Face/Multiple Myeloma >30.0 Cm", wrvu: 5.85 },
 "13100": { name: "Complex Repair Trunk 1.1-2.5 Cm", wrvu: 2.93 },
 "13101": { name: "Complex Repair Trunk 2.6-7.5 Cm", wrvu: 3.41 },
 "13102": { name: "Complex Repair Trunk Additional 5cm/<", wrvu: 1.21 },
 "13120": { name: "Complex Repair Scalp/Arms/Legs 1.1-2.5 Cm", wrvu: 3.15 },
 "13121": { name: "Complex Repair Scalp/Arms/Legs 2.6-7.5 Cm", wrvu: 3.90 },
 "13122": { name: "Complex Repair Scalp/Arms/Legs Additional 5 Cm/>", wrvu: 1.40 },
 "13131": { name: "Complex Repair Face/Cheeks/Chin/Mouth/Neck/Axillae/Genitalia/Hands/Feet", wrvu: 3.64 },
 "13132": { name: "Complex Repair Face/Cheeks/Chin/Mouth/Neck/Axillae/Genitalia/Hands/Feet", wrvu: 4.66 },
 "13133": { name: "Complex Repair Face/Cheeks/Chin/Mouth/Neck/Axillae/Genitalia/Hands/Feet", wrvu: 2.14 },
 "13151": { name: "Complex Repair Eyelids/Nose/Ears/Lips 1.1-2.5 Cm", wrvu: 4.23 },
 "13152": { name: "Complex Repair Eyelids/Nose/Ears/Lips 2.6-7.5 Cm", wrvu: 5.21 },
 "13153": { name: "Complex Repair Eyelids/Nose/Ears/Lips Additional 5cm/<", wrvu: 2.32 },
 "13160": { name: "Secondary Closure Surgery Wound/Dehiscence Extension", wrvu: 11.74 },
 "14000": { name: "Tis Trnfr Trunk 10 subcutaneous cm/<", wrvu: 6.21 },
 "14001": { name: "Tis Trnfr Trunk 10.1-30sqcm", wrvu: 8.56 },
 "14020": { name: "Tis Trnfr Scalp/Arms/Legs 10 subcutaneous cm/<", wrvu: 7.04 },
 "14021": { name: "Tis Trnfr Scalp/Arms/Legs 10.1-30 Sqcm", wrvu: 9.48 },
 "14040": { name: "Tis Trnfr Face/Cheeks/Chin/Mouth/NecKnee/Ankle/Groin/h/f", wrvu: 8.39 },
 "14041": { name: "Tis Trnfr Face/Cheeks/Chin/Mouth/NecKnee/Ankle/Groin/h/f", wrvu: 10.56 },
 "14060": { name: "Tis Trnfr Eyelids/Nose/Ears/Lips 10 subcutaneous cm/<", wrvu: 9.00 },
 "14061": { name: "Tis Trnfr Ear/Nose/Eye/l 10.1-30sqcm", wrvu: 11.19 },
 "14301": { name: "Tis Trnfr Any 30.1-60 subcutaneous cm", wrvu: 12.33 },
 "14302": { name: "Tis Trnfr Additional 30 subcutaneous cm", wrvu: 3.64 },
 "14350": { name: "Filleted Finger/toe Flap", wrvu: 10.77 },
 "15002": { name: "Wound Prep Trunk/arm/leg", wrvu: 3.56 },
 "15003": { name: "Wound Prep Additional 100 Cm", wrvu: 0.78 },
 "15004": { name: "Wound Prep Face/Neck/Handsf/g", wrvu: 4.47 },
 "15005": { name: "Wound Prep Face/Neck/Handsf/g Additional Cm", wrvu: 1.56 },
 "15011": { name: "Hrv Skin Chronic Lymphocytic Leukemia Skin Substitute Autograft 1st 25", wrvu: 0.00 },
 "15012": { name: "Hrv Skin Chronic Lymphocytic Leukemia Skin Substitute Autograft Each Add", wrvu: 0.00 },
 "15013": { name: "Prepj Skin Chronic Lymphocytic Leukemia Skin Substitute Autograft 1st", wrvu: 0.00 },
 "15014": { name: "Prepj Skin Chronic Lymphocytic Leukemia Skin Substitute Autograft Each", wrvu: 0.00 },
 "15015": { name: "Application Skin Cellular Skin Substitute Autograft Trunk/Arms/Legs 1", wrvu: 0.00 },
 "15016": { name: "Application Skin Cellular Skin Substitute Agrf Trunk/Arms/Legs Each", wrvu: 0.00 },
 "15017": { name: "Application Skin Chronic Lymphocytic Leukemia Skin Substitute Face/Neck/Genitalia/hf 1st", wrvu: 0.00 },
 "15018": { name: "Application Skin Chronic Lymphocytic Leukemia Skin Substitute Face/Neck/Genitalia/hf Each", wrvu: 0.00 },
 "15040": { name: "Harvest Cultured Skin Graft", wrvu: 1.95 },
 "15050": { name: "Pinch Graft Up To 2 cm Diam", wrvu: 5.43 },
 "15100": { name: "Split Thickness Autograft Trunk/Arms/Legs 1st 100sqcm", wrvu: 9.65 },
 "15101": { name: "Split Thickness Autograft Trunk/Arms/Legs Each Additional 100", wrvu: 1.68 },
 "15110": { name: "Epidrm Autograft Trunk/Arms/Legs 1st 100", wrvu: 10.70 },
 "15111": { name: "Epidrm Autograft Trunk/Arms/Legs Each Additional", wrvu: 1.80 },
 "15115": { name: "Epidermal Autograft Face/Scalp/Neck/Hands/Feet/Genitalia/Mucous Membrane 1", wrvu: 11.00 },
 "15116": { name: "Epidermal Autograft Face/Scalp/Neck/Hands/Feet/Genitalia/Mucous Membrane Each", wrvu: 2.44 },
 "15120": { name: "Split Thickness Autograft Face/Scalp/Neck/Hands/Feet/Genitalia/Mucous Membrane 1st", wrvu: 9.90 },
 "15121": { name: "Split Thickness Autograft Face/Scalp/Neck/Hands/Feet/Genitalia/Mucous Membrane Each", wrvu: 1.95 },
 "15130": { name: "Drm Autograft Trunk/Arms/Legs 1st 100 Sqcm", wrvu: 7.34 },
 "15131": { name: "Drm Autograft Trunk/Arms/Legs Each Additional", wrvu: 1.46 },
 "15135": { name: "Drm Autograft Face/Scalp/Neck/Hands/Feet/Genitalia/Mucous Membrane 1st", wrvu: 10.75 },
 "15136": { name: "Drm Autograft Face/Scalp/Neck/Hands/Feet/Genitalia/Mucous Membrane Each", wrvu: 1.46 },
 "15150": { name: "Tis Cltr Skin Autograft Trunk/Arms/Legs 1st", wrvu: 9.16 },
 "15151": { name: "Tis Cltr Skin Autograft Trunk/Arms/Legs Add", wrvu: 1.95 },
 "15152": { name: "Tis Cltr Skin Autograft Trunk/Arms/Legs Each", wrvu: 2.44 },
 "15155": { name: "Tis Cltr Autograft F/Scalp/Neck/Hands/Feet/Genitalia, 1", wrvu: 9.89 },
 "15156": { name: "Tis Clt Autograft F/Scalp/Neck/Hands/Feet/Genitalia Ad", wrvu: 2.68 },
 "15157": { name: "Tis Clt Autograft F/Scalp/Neck/Hands/Feet/Genitalia Each", wrvu: 2.93 },
 "15200": { name: "Full Thickness/Graft Fr Trunk 20 subcutaneous cm/<", wrvu: 8.92 },
 "15201": { name: "Full Thickness/Graft Fr Trunk Each Additional", wrvu: 1.29 },
 "15220": { name: "Full Thickness/Graft Fr Scalp/Arms/Legs 20 subcutaneous cm/<", wrvu: 7.89 },
 "15221": { name: "Full Thickness/Graft Fr Scalp/Arms/Legs Each Additional", wrvu: 1.16 },
 "15240": { name: "Full Thickness/Graft Face/Cheeks/Chin/Mouth/Neck/axillarEye/Gland/Head/f20", wrvu: 10.15 },
 "15241": { name: "Full Thickness/Graft Face/Cheeks/Chin/Mouth/NecKnee/Ankle/Groin/h/f Each", wrvu: 1.81 },
 "15260": { name: "Full Thickness/Graft Fr Nose/Ear/Eye/l 20 Sqcm/<", wrvu: 11.35 },
 "15261": { name: "Full Thickness/Graft Fr Nose/Ear/Eye/l Each Additional", wrvu: 2.17 },
 "15271": { name: "Skin Sub Graft Trunk/arm/leg", wrvu: 1.46 },
 "15272": { name: "Skin Sub Graft Trunk/Arms/Legs Add-on", wrvu: 0.32 },
 "15273": { name: "Skin Sub Graft T/arm/lg Child", wrvu: 3.41 },
 "15274": { name: "Skin Sub Graft Trunk/Arms/Legs Child Add", wrvu: 0.78 },
 "15275": { name: "Skin Sub Graft Face/nk/hf/g", wrvu: 1.78 },
 "15276": { name: "Skin Sub Graft Face/Neck/Handsf/g Additional", wrvu: 0.49 },
 "15277": { name: "Skin Sub Graft Face/Neck/Handsf/g Child", wrvu: 3.90 },
 "15278": { name: "Skin Sub Graft Face/Neck/Handsf/g Chest Add", wrvu: 0.98 },
 "15570": { name: "Skin Pedicle Flap Trunk", wrvu: 9.95 },
 "15572": { name: "Skin Pedicle Flap Arms/legs", wrvu: 9.87 },
 "15574": { name: "Pedcle Fh/chest/chesTrunk/Mid/Neck/axillarEye/Gland/Head/f", wrvu: 10.43 },
 "15576": { name: "Pedicle Eyelids/Nose/Ears/Lips/intraoral", wrvu: 9.14 },
 "15600": { name: "Delay Flap Trunk", wrvu: 1.96 },
 "15610": { name: "Delay Flap Arms/legs", wrvu: 2.46 },
 "15620": { name: "Delay Flap Face/Cheek/Chin/n/axillarEye/Gland/Head/f", wrvu: 3.66 },
 "15630": { name: "Delay Flap Eye/Not Otherwise Specified/ear/lip", wrvu: 3.98 },
 "15650": { name: "Transfer Skin Pedicle Flap", wrvu: 4.65 },
 "15730": { name: "Mdfc Flap With Prsrv Vasc Pedcl", wrvu: 13.16 },
 "15731": { name: "Forehead Flap With Vasc Pedicle", wrvu: 14.02 },
 "15733": { name: "Muscle Myoq/fscq Flap H and n Pedcl", wrvu: 15.29 },
 "15734": { name: "Muscle-skin Graft Trunk", wrvu: 22.43 },
 "15736": { name: "Muscle-skin Graft Arm", wrvu: 16.61 },
 "15738": { name: "Muscle-skin Graft Leg", wrvu: 18.56 },
 "15740": { name: "Island Pedicle Flap Graft", wrvu: 11.51 },
 "15750": { name: "Neurovascular Pedicle Flap", wrvu: 12.64 },
 "15756": { name: "Free Myo/skin Flap Microvasc", wrvu: 36.02 },
 "15757": { name: "Free Skin Flap Microvasc", wrvu: 36.22 },
 "15758": { name: "Free Fascial Flap Microvasc", wrvu: 35.98 },
 "15760": { name: "Composite Skin Graft", wrvu: 9.61 },
 "15769": { name: "Grfg Autol Soft Tiss Dir Excision", wrvu: 6.51 },
 "15770": { name: "Derma-fat-fascia Graft", wrvu: 8.74 },
 "15771": { name: "Grfg Autol Fat Lipo 50 Cc/<", wrvu: 6.56 },
 "15772": { name: "Grfg Autol Fat Lipo Each Additional", wrvu: 2.44 },
 "15773": { name: "Grfg Autol Fat Lipo 25 Cc/<", wrvu: 6.66 },
 "15774": { name: "Gfrg Autol Fat Lipo Each Additional", wrvu: 2.35 },
 "15775": { name: "Hair Transplant 1-15 Punch Grfts", wrvu: 3.85 },
 "15776": { name: "Hair Transplant >15 Punch Grafts", wrvu: 5.39 },
 "15777": { name: "Acellular Derm Matrix Implt", wrvu: 3.56 },
 "15778": { name: "Impl Absrb Msh/Prosthesis Dly Cls", wrvu: 6.87 },
 "15780": { name: "Dermabrasion Total Face", wrvu: 8.51 },
 "15781": { name: "Dermabrasion Segmental Face", wrvu: 4.89 },
 "15782": { name: "Dermabrasion Other Than Face", wrvu: 4.33 },
 "15783": { name: "Dermabrasion Suprfl Any Site", wrvu: 4.30 },
 "15786": { name: "Abrasion Lesion Single", wrvu: 2.03 },
 "15787": { name: "Abrasion Lesions Add-on", wrvu: 0.32 },
 "15788": { name: "Chemical Peel Facial Epidrm", wrvu: 2.04 },
 "15789": { name: "Chemical Peel Facial Dermal", wrvu: 4.79 },
 "15792": { name: "Chem Peel Nonfacial Epidrm", wrvu: 1.81 },
 "15793": { name: "Chemical Peel Nonfacial Drm", wrvu: 3.86 },
 "15820": { name: "Blepharoplasty Lower Eyelid", wrvu: 6.11 },
 "15821": { name: "Blepharp Lower Eyelid Fat Pad", wrvu: 6.67 },
 "15822": { name: "Blepharoplasty Upper Eyelid", wrvu: 4.50 },
 "15823": { name: "Blepharp Upper Eyelid Xcsv Skin", wrvu: 6.64 },
 "15824": { name: "Rhytidectomy Forehead", wrvu: 0.00 },
 "15825": { name: "Rhytdct Neck Pltysml Tghtg", wrvu: 0.00 },
 "15826": { name: "Rhytidectomy Glblr Frn Lines", wrvu: 0.00 },
 "15828": { name: "Rhytidectomy Cheek Chn & Neck", wrvu: 0.00 },
 "15829": { name: "Rhytidectomy Smas Flap", wrvu: 0.00 },
 "15830": { name: "Excision Excessive Skin Abdomen", wrvu: 16.68 },
 "15832": { name: "Excision Excessive Skin Thigh", wrvu: 12.53 },
 "15833": { name: "Excision Excessive Skin Leg", wrvu: 11.60 },
 "15834": { name: "Excision Excessive Skin Hip", wrvu: 11.87 },
 "15835": { name: "Excision Excessive Skin Buttock", wrvu: 12.67 },
 "15836": { name: "Excision Excessive Skin Arm", wrvu: 10.34 },
 "15837": { name: "Excision Excsv Skin Forearm/hand", wrvu: 9.31 },
 "15838": { name: "Excision Excsv Submental Fat Pad", wrvu: 8.04 },
 "15839": { name: "Excision Excessive Skin Other Area", wrvu: 10.24 },
 "15840": { name: "Nerve Palsy Fascial Graft", wrvu: 14.62 },
 "15841": { name: "Nerve Palsy Muscle Graft", wrvu: 25.34 },
 "15842": { name: "Nerve Palsy Microsurg Graft", wrvu: 39.98 },
 "15845": { name: "Skin And Muscle Repair Face", wrvu: 13.96 },
 "15847": { name: "Excision Skin Abdominal Add-on", wrvu: 0.00 },
 "15851": { name: "Removal Suture/staple Req Anesthesia", wrvu: 1.07 },
 "15852": { name: "Dressing Change Not For Burn", wrvu: 0.84 },
 "15853": { name: "Removal Suture/staple Xreq Anesthesia", wrvu: 0.00 },
 "15854": { name: "Removal Suture and staple Xreq Anesthesia", wrvu: 0.00 },
 "15860": { name: "Intravenous Injection Tst Vasc Flo Flap/grf", wrvu: 1.90 },
 "15876": { name: "Suction Lipectomy Head and neck", wrvu: 0.00 },
 "15877": { name: "Suction Lipectomy Trunk", wrvu: 0.00 },
 "15878": { name: "Suction Lipectomy Upper Extrem", wrvu: 0.00 },
 "15879": { name: "Suction Lipectomy Lower Extrem", wrvu: 0.00 },
 "15920": { name: "Excision Coccygl Per Ulcer Prim Suture", wrvu: 8.08 },
 "15922": { name: "Excision Coccygl Per Ulcer Flap Closure", wrvu: 10.12 },
 "15931": { name: "Excision Sacral Per Ulcer Prim Suture", wrvu: 9.82 },
 "15933": { name: "Excision Sac Per Ulcer Prim Str Ostc", wrvu: 11.48 },
 "15934": { name: "Excision Sacral Per Ulcer Skin Flap", wrvu: 13.34 },
 "15935": { name: "Excision Sac Per Ulcer Skin Flap Ostc", wrvu: 15.39 },
 "15936": { name: "Excision Sac Per Ulcer Prep Mus Flap", wrvu: 12.83 },
 "15937": { name: "Excision Sac Per Ulcer Prep Mus Ostc", wrvu: 14.76 },
 "15940": { name: "Excision Ischial Per Ulcer Prim Suture", wrvu: 9.95 },
 "15941": { name: "Excision Isch Per Ulcer Prm Sut Ostc", wrvu: 12.10 },
 "15944": { name: "Excision Isch Per Ulcer Skin Flap Closure", wrvu: 12.13 },
 "15945": { name: "Excision Isch Per Ulcer Skin Flap Ostc", wrvu: 13.41 },
 "15946": { name: "Excision Isch Per Ulcer Prep Mus Flp", wrvu: 23.52 },
 "15950": { name: "Excision Trchntr Per Ulcer Prim Suture", wrvu: 7.83 },
 "15951": { name: "Excision Trchntr Per Ulcer Ostc", wrvu: 11.29 },
 "15952": { name: "Excision Trchntr Per Ulcer Flap Closure", wrvu: 12.00 },
 "15953": { name: "Excision Trchntr Per Ulcer Flap Ostc", wrvu: 13.23 },
 "15956": { name: "Excision Trchntr Per Ulcer Prep Flap", wrvu: 16.37 },
 "15958": { name: "Excision Trchntr Per Ulcer Prep Ostc", wrvu: 16.33 },
 "15999": { name: "Unlisted Procedure Excision Pressure Ulcer", wrvu: 0.00 },
 "16000": { name: "Initial Treatment Of Burn(s)", wrvu: 0.87 },
 "16020": { name: "Dress/Debridement P-thick Burn S", wrvu: 0.69 },
 "16025": { name: "Dress/Debridement P-thick Burn M", wrvu: 1.70 },
 "16030": { name: "Dress/Debridement P-thick Burn L", wrvu: 2.03 },
 "16035": { name: "Escharotomy 1st Incision", wrvu: 3.65 },
 "16036": { name: "Escharotomy Each Additional Incision", wrvu: 1.46 },
 "17000": { name: "Destruction, Premalignant Lesion, First Lesion", wrvu: 0.59 },
 "17003": { name: "Destruction, Premalignant Lesions, 2-14 Lesions, each", wrvu: 0.04 },
 "17004": { name: "Destruction, Premalignant Lesions, 15 or more", wrvu: 1.34 },
 "17106": { name: "Dstr Cut Vsc Prlf Lesion<10sqcm", wrvu: 3.60 },
 "17107": { name: "Dstr Cut Vsc Prlf Les10-50sq", wrvu: 4.67 },
 "17108": { name: "Dstr Cut Vsc Prlf Lesion>50sqcm", wrvu: 7.30 },
 "17110": { name: "Destruction, Benign Lesions (warts, etc.), Up to 14 Lesions", wrvu: 0.68 },
 "17111": { name: "Destruction, Benign Lesions (warts, etc.), 15 or more Lesions", wrvu: 0.95 },
 "17250": { name: "Chem Caut Of Granltj Tissue", wrvu: 0.49 },
 "17260": { name: "Dstrj Malignant Lesion Trunk/Arms/Legs 0.5 Cm/<", wrvu: 0.94 },
 "17261": { name: "Dstrj Malignant Lesion Trunk/Arms/Legs .6-1.0cm", wrvu: 1.19 },
 "17262": { name: "Dstrj Malignant Lesion Trunk/Arms/Legs 1.1-2.0", wrvu: 1.59 },
 "17263": { name: "Dstrj Malignant Lesion Trunk/Arms/Legs 2.1-3.0", wrvu: 1.79 },
 "17264": { name: "Dstrj Malignant Lesion Trunk/Arms/Legs 3.1-4.0", wrvu: 1.94 },
 "17266": { name: "Dstrj Malignant Lesion Trunk/Arms/Legs >4.0 Cm", wrvu: 2.33 },
 "17270": { name: "Dstr Malignant Lesion Scalp/Neck/Hands/Feet/Genitalia .5 /<", wrvu: 1.34 },
 "17271": { name: "Dstr Malignant Lesion Scalp/Neck/Hands/Feet/Genitalia, 0.6-1", wrvu: 1.50 },
 "17272": { name: "Dstr Malignant Lesion Scalp/Neck/Hands/Feet/Genitalia, 1.1-2", wrvu: 1.77 },
 "17273": { name: "Dstr Malignant Lesion Scalp/Neck/Hands/Feet/Genitalia, 2.1-3", wrvu: 2.05 },
 "17274": { name: "Dstr Malignant Lesion Scalp/Neck/Hands/Feet/Genitalia, 3.1-4", wrvu: 2.57 },
 "17276": { name: "Dstr Malignant Lesion Scalp/Neck/Hands/Feet/Genitalia >4.0", wrvu: 3.17 },
 "17280": { name: "Dstr Malignant Ls Face/Ears/Eyelids/Nose/Lips/Mucosae .5/<", wrvu: 1.19 },
 "17281": { name: "Dstr Malignant Ls Face/Ears/Eyelids/Nose/Lips/Mucosae .6-1", wrvu: 1.73 },
 "17282": { name: "Dstr Malignant Ls Face/Ears/Eyelids/Nose/Lips/m 1.1-2", wrvu: 2.04 },
 "17283": { name: "Dstr Malignant Ls Face/Ears/Eyelids/Nose/Lips/m 2.1-3", wrvu: 2.62 },
 "17284": { name: "Dstr Malignant Ls Face/Ears/Eyelids/Nose/Lips/m 3.1-4", wrvu: 3.12 },
 "17286": { name: "Dstr Malignant Ls Face/Ears/Eyelids/Nose/Lips/Mucosae>4.0", wrvu: 4.37 },
 "17311": { name: "Mohs 1 Stage Head/Neck/Hands/Feet/Genitalia", wrvu: 6.05 },
 "17312": { name: "Mohs Additional Stage", wrvu: 3.22 },
 "17313": { name: "Mohs 1 Stage Trunk/Arms/Legs", wrvu: 5.42 },
 "17314": { name: "Mohs Additional Stage Trunk/Arms/Legs", wrvu: 2.98 },
 "17315": { name: "Mohs Surgery Additional Block", wrvu: 0.85 },
 "17340": { name: "Cryotherapy For Acne", wrvu: 0.75 },
 "17360": { name: "Chemical Exfoliation Acne", wrvu: 1.42 },
 "17380": { name: "Electrolysis Epilation Each 30", wrvu: 0.00 },
 "17999": { name: "Unlistd Procedure Skin Muc Memb Subcutaneous", wrvu: 0.00 },
 "19000": { name: "Puncture Aspiration Cyst Breast", wrvu: 0.82 },
 "19001": { name: "Puncture Aspiration Cyst Breast Each", wrvu: 0.41 },
 "19020": { name: "Mastotomy Expl Drainage Abscess Dp", wrvu: 3.73 },
 "19030": { name: "Injection Procedure Only Mam Ducto/glcto", wrvu: 1.49 },
 "19081": { name: "Biopsy Breast 1st Lesion Strtctc", wrvu: 3.21 },
 "19082": { name: "Biopsy Breast Add Lesion Strtctc", wrvu: 1.61 },
 "19083": { name: "Biopsy Breast 1st Lesion Ultrasound Imag", wrvu: 3.02 },
 "19084": { name: "Biopsy Breast Add Lesion Ultrasound Imag", wrvu: 1.51 },
 "19085": { name: "Biopsy Breast 1st Lesion Mr Imag", wrvu: 3.55 },
 "19086": { name: "Biopsy Breast Add Lesion Mr Imag", wrvu: 1.77 },
 "19100": { name: "Biopsy Breast Percutaneous Without Image", wrvu: 1.24 },
 "19101": { name: "Biopsy Of Breast Open", wrvu: 3.15 },
 "19105": { name: "Cryosurg Ablate Fa Each", wrvu: 3.60 },
 "19110": { name: "Nipple Exploration", wrvu: 4.33 },
 "19112": { name: "Excise Breast Duct Fistula", wrvu: 3.71 },
 "19120": { name: "Removal Of Breast Lesion", wrvu: 5.77 },
 "19125": { name: "Excision Breast Lesion", wrvu: 6.52 },
 "19126": { name: "Excision Additional Breast Lesion", wrvu: 2.86 },
 "19281": { name: "Percutaneous Device Breast 1st Imag", wrvu: 1.95 },
 "19282": { name: "Percutaneous Device Breast Each Imag", wrvu: 0.98 },
 "19283": { name: "Percutaneous Device Breast 1st Strtctc", wrvu: 1.95 },
 "19284": { name: "Percutaneous Device Breast Add Strtctc", wrvu: 0.98 },
 "19285": { name: "Percutaneous Device Breast 1st Ultrasound Imag", wrvu: 1.66 },
 "19286": { name: "Percutaneous Device Breast Add Ultrasound Imag", wrvu: 0.83 },
 "19287": { name: "Percutaneous Device Breast 1st Mr Guide", wrvu: 2.49 },
 "19288": { name: "Percutaneous Device Breast Add Mr Guide", wrvu: 1.25 },
 "19294": { name: "Prepj Tumor Cav Iort Partial Mast", wrvu: 2.93 },
 "19296": { name: "Place Po Breast Catheter For Rad", wrvu: 3.54 },
 "19297": { name: "Place Breast Catheter For Rad", wrvu: 1.68 },
 "19298": { name: "Place Breast Radical Tube/caths", wrvu: 5.61 },
 "19300": { name: "Mastectomy For Gynecomastia", wrvu: 5.18 },
 "19301": { name: "Partial Mastectomy", wrvu: 9.88 },
 "19302": { name: "P-mastectomy With Lymphatic Node Removal", wrvu: 13.64 },
 "19303": { name: "Mast Simple Complete", wrvu: 14.63 },
 "19305": { name: "Mast Radical", wrvu: 17.02 },
 "19306": { name: "Mast Radical Urban Type", wrvu: 17.68 },
 "19307": { name: "Mast Moderate Rad", wrvu: 17.54 },
 "19316": { name: "Mastopexy", wrvu: 10.81 },
 "19318": { name: "Breast Reduction", wrvu: 15.63 },
 "19325": { name: "Breast Augmentation With Implt", wrvu: 7.92 },
 "19328": { name: "Removal Intact Breast Implant", wrvu: 7.25 },
 "19330": { name: "Removal Ruptured Breast Implant", wrvu: 8.78 },
 "19340": { name: "Insertion Breast Implt Sm D Mast", wrvu: 10.22 },
 "19342": { name: "Insertion/Replacement Breast Implt Sep D", wrvu: 10.22 },
 "19350": { name: "Nipple/areola Reconstruction", wrvu: 8.88 },
 "19355": { name: "Correct Inverted Nipple(s)", wrvu: 8.31 },
 "19357": { name: "Tiss Xpndr Placement Breast Reconstruction", wrvu: 14.47 },
 "19361": { name: "Breast Reconstruction Latsms Drsi Flap", wrvu: 22.78 },
 "19364": { name: "Breast Reconstruction Free Flap", wrvu: 41.52 },
 "19367": { name: "Breast Reconstruction 1 Pdcl Tram Flap", wrvu: 26.13 },
 "19368": { name: "Breast Reconstruction 1pdcl Tram Anast", wrvu: 33.05 },
 "19369": { name: "Breast Reconstruction 2 Pdcl Tram Flap", wrvu: 30.53 },
 "19370": { name: "Revj Peri-implt Capsule Breast", wrvu: 8.94 },
 "19371": { name: "Peri-implt Capslc Breast Compl", wrvu: 9.73 },
 "19380": { name: "Revj Reconstructed Breast", wrvu: 10.89 },
 "19396": { name: "Design Custom Breast Implant", wrvu: 2.12 },
 "19499": { name: "Unlisted Procedure Breast", wrvu: 0.00 },
 "20100": { name: "Expl Pentrg Wound Neck", wrvu: 10.12 },
 "20101": { name: "Expl Pentrg Wound Chest", wrvu: 3.15 },
 "20102": { name: "Expl Pentrg Wound Abdominal/flnk/bk", wrvu: 3.88 },
 "20103": { name: "Expl Pentrg Wound Extremity", wrvu: 5.21 },
 "20150": { name: "Excision Epiphyseal Bar", wrvu: 14.38 },
 "20200": { name: "Muscle Biopsy Superficial", wrvu: 1.42 },
 "20205": { name: "Deep Muscle Biopsy", wrvu: 2.29 },
 "20206": { name: "Biopsy Muscle Percutaneous Needle", wrvu: 0.97 },
 "20220": { name: "Bone Biopsy Trocar/Needle Supfc", wrvu: 1.61 },
 "20225": { name: "Bone Biopsy Trocar/Needle Deep", wrvu: 2.39 },
 "20240": { name: "Bone Biopsy Open Superficial", wrvu: 2.54 },
 "20245": { name: "Bone Biopsy Open Deep", wrvu: 5.85 },
 "20250": { name: "Biopsy Vrt Bdy Open Thoracic", wrvu: 5.06 },
 "20251": { name: "Biopsy Vrt Bdy Open Lumbar/Cervical", wrvu: 5.58 },
 "20500": { name: "Injection Sinus Tract Therapeutic", wrvu: 1.25 },
 "20501": { name: "Injection Sinus Tract Diagnostic", wrvu: 0.74 },
 "20520": { name: "Removal Fb Muscle/tdn Simple", wrvu: 1.85 },
 "20525": { name: "Removal Fb Muscle/tdn Deep/comp", wrvu: 3.45 },
 "20526": { name: "Therapeutic Injection Carpal Tunnel", wrvu: 0.92 },
 "20527": { name: "Injection Nzm Palmar Fascial Cord", wrvu: 0.98 },
 "20550": { name: "Injection 1 Tendon Sheath/ligation", wrvu: 0.73 },
 "20551": { name: "Injection 1 Tendon Origin/insertion", wrvu: 0.73 },
 "20552": { name: "Injection, Single or Multiple Trigger Point(s), 1-2 Muscle(s)", wrvu: 0.64 },
 "20553": { name: "Injection, Single or Multiple Trigger Point(s), 3+ Muscle(s)", wrvu: 0.73 },
 "20555": { name: "Place Needle Muscle/tis For Right", wrvu: 5.85 },
 "20560": { name: "Needle Insertion Without Injection 1 Or 2 Muscle", wrvu: 0.31 },
 "20561": { name: "Needle Insertion Without Injection 3+ Muscle", wrvu: 0.47 },
 "20600": { name: "Arthrocentesis, Small Joint/Bursa (e.g., fingers, toes)", wrvu: 0.64 },
 "20604": { name: "Arthrocentesis, Small Joint/Bursa, with Ultrasound Guidance", wrvu: 0.87 },
 "20605": { name: "Arthrocentesis, Intermediate Joint/Bursa (e.g., wrist, elbow, ankle)", wrvu: 0.66 },
 "20606": { name: "Arthrocentesis, Intermediate Joint/Bursa, with Ultrasound Guidance", wrvu: 0.98 },
 "20610": { name: "Arthrocentesis, Major Joint/Bursa (e.g., shoulder, hip, knee)", wrvu: 0.77 },
 "20611": { name: "Arthrocentesis, Major Joint/Bursa, with Ultrasound Guidance", wrvu: 1.07 },
 "20612": { name: "Aspirate/Injection Ganglion Cyst", wrvu: 0.68 },
 "20615": { name: "Treatment Of Bone Cyst", wrvu: 2.27 },
 "20650": { name: "Insert And Remove Bone Pin", wrvu: 2.22 },
 "20660": { name: "Apply Rem Fixation Device", wrvu: 3.90 },
 "20661": { name: "Application Halo Cranial", wrvu: 5.13 },
 "20662": { name: "Application Halo Pelvic", wrvu: 6.22 },
 "20663": { name: "Application Halo Femoral", wrvu: 5.60 },
 "20664": { name: "Application Halo Cranial 6+pins", wrvu: 9.81 },
 "20665": { name: "Removal Tongs/halo Anthr Indiv", wrvu: 1.33 },
 "20670": { name: "Removal Implant Superficial", wrvu: 1.75 },
 "20680": { name: "Removal Of Implant Deep", wrvu: 5.81 },
 "20690": { name: "Application Unipln Uni External Fixj System", wrvu: 8.56 },
 "20692": { name: "Application Mltpln Uni External Fixj System", wrvu: 15.86 },
 "20693": { name: "Adjmt/revj External Fixj System Anesthesia", wrvu: 5.91 },
 "20694": { name: "Removal External Fixj System Under Anesthesia", wrvu: 4.17 },
 "20696": { name: "Application Mltpln Uni Xtrnl Fix 1st", wrvu: 17.12 },
 "20697": { name: "Application Mltpln Uni Xtrnl Fix Xch", wrvu: 0.00 },
 "20700": { name: "Mnl Prep and insertion Dp Prescription Dlvr Device", wrvu: 1.46 },
 "20701": { name: "Removal Deep Prescription Delivery Device", wrvu: 1.10 },
 "20702": { name: "Mnl Prep and insertion Imed Prescription Device", wrvu: 2.44 },
 "20703": { name: "Removal Imed Prescription Delivery Device", wrvu: 1.76 },
 "20704": { name: "Mnl Prep and insertion I-articular Prescription Device", wrvu: 2.54 },
 "20705": { name: "Removal I-articular Prescription Delivery Device", wrvu: 2.10 },
 "20802": { name: "Replantation Arm Complete", wrvu: 41.55 },
 "20805": { name: "Replant Forearm Complete", wrvu: 50.17 },
 "20808": { name: "Replantation Hand Complete", wrvu: 61.51 },
 "20816": { name: "Replantation Digit Complete", wrvu: 31.15 },
 "20822": { name: "Replantation Digit Complete", wrvu: 25.99 },
 "20824": { name: "Replantation Thumb Complete", wrvu: 31.15 },
 "20827": { name: "Replantation Thumb Complete", wrvu: 26.79 },
 "20838": { name: "Replantation Foot Complete", wrvu: 41.81 },
 "20900": { name: "Removal Of Bone For Graft", wrvu: 2.93 },
 "20902": { name: "Removal Of Bone For Graft", wrvu: 4.47 },
 "20910": { name: "Remove Cartilage For Graft", wrvu: 5.39 },
 "20912": { name: "Remove Cartilage For Graft", wrvu: 6.38 },
 "20920": { name: "Removal Of Fascia For Graft", wrvu: 5.37 },
 "20922": { name: "Removal Of Fascia For Graft", wrvu: 6.76 },
 "20924": { name: "Removal Of Tendon For Graft", wrvu: 6.51 },
 "20930": { name: "Sp Bone Algrft Morsel Add-on", wrvu: 0.00 },
 "20931": { name: "Sp Bone Algrft Struct Add-on", wrvu: 1.76 },
 "20932": { name: "Osteoart Algrft With Surf & Bone", wrvu: 12.68 },
 "20933": { name: "Hemicrt Intrclry Algrft Partial", wrvu: 11.64 },
 "20934": { name: "Intercalary Algrft Compl", wrvu: 12.68 },
 "20936": { name: "Sp Bone Autograft Local Add-on", wrvu: 0.00 },
 "20937": { name: "Sp Bone Autograft Morsel Add-on", wrvu: 2.72 },
 "20938": { name: "Sp Bone Autograft Struct Add-on", wrvu: 2.94 },
 "20939": { name: "Bone Marrow Aspiration Bone Grfg", wrvu: 1.13 },
 "20950": { name: "Mntr Intrstitial Fluid Pressure", wrvu: 1.23 },
 "20955": { name: "Fibula Bone Graft Microvasc", wrvu: 39.25 },
 "20956": { name: "Iliac Bone Graft Microvasc", wrvu: 40.15 },
 "20957": { name: "Mt Bone Graft Microvasc", wrvu: 41.54 },
 "20962": { name: "Other Bone Graft Microvasc", wrvu: 38.23 },
 "20969": { name: "Bone/skin Graft Microvasc", wrvu: 44.29 },
 "20970": { name: "Bone/skin Graft Iliac Crest", wrvu: 43.47 },
 "20972": { name: "Bone/skin Graft Metatarsal", wrvu: 43.40 },
 "20973": { name: "Bone/skin Graft Great Toe", wrvu: 46.09 },
 "20974": { name: "Estim Aid Bone Healg N-invas", wrvu: 0.60 },
 "20975": { name: "Estim Aid Bone Healg Invasiv", wrvu: 2.54 },
 "20979": { name: "Lw Ntsty Ultrasound Stimj Bone Healg", wrvu: 0.60 },
 "20982": { name: "Ablate Bone Tumor(s) Percutaneous", wrvu: 6.84 },
 "20983": { name: "Ablate Bone Tumor(s) Percutaneous", wrvu: 6.71 },
 "20985": { name: "Cptr-asst Dir Ms Procedure", wrvu: 2.44 },
 "20999": { name: "Unlisted Procedure Muscskel General", wrvu: 0.00 },
 "21010": { name: "Incision Of Jaw Joint", wrvu: 10.76 },
 "21011": { name: "Excision Face Lesion Subcutaneous <2 Cm", wrvu: 2.92 },
 "21012": { name: "Excision Face Lesion Sbq 2 Cm/>", wrvu: 4.34 },
 "21013": { name: "Excision Face Tumor Deep < 2 Cm", wrvu: 5.28 },
 "21014": { name: "Excision Face Tumor Deep 2 Cm/>", wrvu: 6.95 },
 "21015": { name: "Resection Face/scalp Tumor < 2 Cm", wrvu: 9.64 },
 "21016": { name: "Resection Face/scalp Tumor 2 Cm/>", wrvu: 14.88 },
 "21025": { name: "Excision Of Bone Lower Jaw", wrvu: 9.78 },
 "21026": { name: "Excision Of Facial Bone(s)", wrvu: 5.56 },
 "21029": { name: "Contour Of Face Bone Lesion", wrvu: 8.18 },
 "21030": { name: "Excise Max/zygoma Benign Tumor", wrvu: 4.79 },
 "21031": { name: "Remove Exostosis Mandible", wrvu: 3.22 },
 "21032": { name: "Remove Exostosis Maxilla", wrvu: 3.26 },
 "21034": { name: "Excise Max/zygoma Malignant Tumor", wrvu: 16.95 },
 "21040": { name: "Excise Mandible Lesion", wrvu: 4.79 },
 "21044": { name: "Removal Of Jaw Bone Lesion", wrvu: 12.48 },
 "21045": { name: "Extensive Jaw Surgery", wrvu: 17.91 },
 "21046": { name: "Remove Mandible Cyst Complex", wrvu: 13.85 },
 "21047": { name: "Excise Lower Jaw Cyst With Repair", wrvu: 19.57 },
 "21048": { name: "Remove Maxilla Cyst Complex", wrvu: 14.34 },
 "21049": { name: "Excision Uppr Jaw Cyst With Repair", wrvu: 18.84 },
 "21050": { name: "Removal Of Jaw Joint", wrvu: 11.47 },
 "21060": { name: "Remove Jaw Joint Cartilage", wrvu: 10.79 },
 "21070": { name: "Remove Coronoid Process", wrvu: 8.40 },
 "21073": { name: "Manipulation Of Tmj With Anesth", wrvu: 3.36 },
 "21076": { name: "Impres and prep Surgery Obt Prosth", wrvu: 13.07 },
 "21077": { name: "Impres and prep Orbital Prosth", wrvu: 32.86 },
 "21079": { name: "Impres and prep Intrm Obt Prosth", wrvu: 21.75 },
 "21080": { name: "Impres and prep Def Obt Prosth", wrvu: 24.43 },
 "21081": { name: "Impres and prep Mandibular Res Prosth", wrvu: 22.28 },
 "21082": { name: "Impres and prep Paltl Aug Prosth", wrvu: 20.32 },
 "21083": { name: "Impres and prep Paltl Liver Function Tests Prosth", wrvu: 18.79 },
 "21084": { name: "Impres and prep Sp Aid Prosth", wrvu: 21.92 },
 "21085": { name: "Impres and prep Oral Surgery Splint", wrvu: 8.77 },
 "21086": { name: "Impres and prep Auricular Prosth", wrvu: 24.26 },
 "21087": { name: "Impres and prep Nasal Prosth", wrvu: 24.26 },
 "21088": { name: "Impres and prep Facial Prosth", wrvu: 0.00 },
 "21089": { name: "Unlisted Maxlfcl Prosth Procedure", wrvu: 0.00 },
 "21100": { name: "Maxillofacial Fixation", wrvu: 4.61 },
 "21110": { name: "Interdental Fixation", wrvu: 5.84 },
 "21116": { name: "Injection Jaw Joint X-ray", wrvu: 0.79 },
 "21120": { name: "Genioplasty Augmentation", wrvu: 4.97 },
 "21121": { name: "Geniop Sldg Osteot 1", wrvu: 7.61 },
 "21122": { name: "Geniop Sldg Osteot 2/>", wrvu: 8.49 },
 "21123": { name: "Geniop Sldg Augmentation", wrvu: 11.06 },
 "21125": { name: "Augmentation Mndblr Prostc", wrvu: 10.53 },
 "21127": { name: "Augmentation Mndblr Bone Grf", wrvu: 12.13 },
 "21137": { name: "Rdctj Forehead Cntrg Only", wrvu: 9.98 },
 "21138": { name: "Rdctj Forehead Cntrg and prostc", wrvu: 12.55 },
 "21139": { name: "Rdctj Forehead Cntrg and setback", wrvu: 14.64 },
 "21141": { name: "Reconstruction Midface Lefort I 1pc", wrvu: 19.08 },
 "21142": { name: "Reconstruction Midface Lefort I 2pcs", wrvu: 19.77 },
 "21143": { name: "Reconstruction Mdface Lefort I 3/>pc", wrvu: 20.52 },
 "21145": { name: "Reconstruction Mdfc Lefort I 1 With Grf", wrvu: 23.34 },
 "21146": { name: "Reconstruction Mdfc Lefort I 2 With Grf", wrvu: 24.25 },
 "21147": { name: "Reconstruction Mdfc Lefort I 3/>grf", wrvu: 25.81 },
 "21150": { name: "Reconstruction Mdfc Lefrtii Anterior Ntru", wrvu: 25.31 },
 "21151": { name: "Reconstruction Mdfc Lefrtii With Bone Grf", wrvu: 28.29 },
 "21154": { name: "Reconstruction Mdfc Lefort Iii Without I", wrvu: 30.51 },
 "21155": { name: "Reconstruction Mdfc Lefort Iii With I", wrvu: 34.34 },
 "21159": { name: "Rcnst Mdfc Lfrtiii Advm without I", wrvu: 42.06 },
 "21160": { name: "Rcnst Mdfc Lfrtiii Advm With I", wrvu: 46.01 },
 "21172": { name: "Rcnst Superior-Lateral Orb Rm and lw Fhd", wrvu: 27.50 },
 "21175": { name: "Rcnst Bfrnt Sp Orb Rm and lw Fhd", wrvu: 32.72 },
 "21179": { name: "Reconstruction Forehead With Grafts", wrvu: 22.08 },
 "21180": { name: "Reconstruction Forehead With Autograft", wrvu: 24.94 },
 "21181": { name: "Rcnst Cntrg Benign Tumor Cranial Xtrc", wrvu: 10.02 },
 "21182": { name: "Reconstruct Cranial Bone", wrvu: 31.77 },
 "21183": { name: "Reconstruct Cranial Bone", wrvu: 34.81 },
 "21184": { name: "Reconstruct Cranial Bone", wrvu: 37.65 },
 "21188": { name: "Reconstruction Of Midface", wrvu: 22.57 },
 "21193": { name: "Reconst Lower Jaw Without Graft", wrvu: 18.43 },
 "21194": { name: "Reconst Lower Jaw With Graft", wrvu: 21.27 },
 "21195": { name: "Reconst Lower Jaw Without Fixation", wrvu: 18.68 },
 "21196": { name: "Reconst Lower Jaw With Fixation", wrvu: 20.31 },
 "21198": { name: "Reconstr Lower Jaw Segment", wrvu: 15.32 },
 "21199": { name: "Reconstr Lower Jaw With Advance", wrvu: 16.31 },
 "21206": { name: "Reconstruct Upper Jaw Bone", wrvu: 15.20 },
 "21208": { name: "Augmentation Of Facial Bones", wrvu: 11.13 },
 "21209": { name: "Reduction Of Facial Bones", wrvu: 7.62 },
 "21210": { name: "Face Bone Graft", wrvu: 11.40 },
 "21215": { name: "Lower Jaw Bone Graft", wrvu: 11.92 },
 "21230": { name: "Rib Cartilage Graft", wrvu: 10.89 },
 "21235": { name: "Ear Cartilage Graft", wrvu: 7.31 },
 "21240": { name: "Reconstruction Of Jaw Joint", wrvu: 15.67 },
 "21242": { name: "Reconstruction Of Jaw Joint", wrvu: 14.23 },
 "21243": { name: "Reconstruction Of Jaw Joint", wrvu: 23.92 },
 "21244": { name: "Reconstruction Of Lower Jaw", wrvu: 13.28 },
 "21245": { name: "Reconstruction Of Jaw", wrvu: 12.79 },
 "21246": { name: "Reconstruction Of Jaw", wrvu: 12.60 },
 "21247": { name: "Reconstruct Lower Jaw Bone", wrvu: 23.76 },
 "21248": { name: "Reconstruction Of Jaw", wrvu: 12.42 },
 "21249": { name: "Reconstruction Of Jaw", wrvu: 18.30 },
 "21255": { name: "Reconstruct Lower Jaw Bone", wrvu: 18.00 },
 "21256": { name: "Reconstruction Of Orbit", wrvu: 17.22 },
 "21260": { name: "Revise Eye Sockets", wrvu: 17.45 },
 "21261": { name: "Revise Eye Sockets", wrvu: 33.22 },
 "21263": { name: "Revise Eye Sockets", wrvu: 30.23 },
 "21267": { name: "Revise Eye Sockets", wrvu: 20.17 },
 "21268": { name: "Revise Eye Sockets", wrvu: 26.39 },
 "21270": { name: "Augmentation Cheek Bone", wrvu: 10.36 },
 "21275": { name: "Revision Orbitofacial Bones", wrvu: 11.47 },
 "21280": { name: "Medial Canthopexy", wrvu: 6.95 },
 "21282": { name: "Lateral Canthopexy", wrvu: 4.16 },
 "21295": { name: "Revision Of Jaw Muscle/bone", wrvu: 1.85 },
 "21296": { name: "Revision Of Jaw Muscle/bone", wrvu: 4.66 },
 "21299": { name: "Unlisted Cranfcl and maxlfcl Procedure", wrvu: 0.00 },
 "21315": { name: "Closed Treatment Nasal Fracture Manipulation without Stblj", wrvu: 0.94 },
 "21320": { name: "Closed Treatment Nasal Fracture With Manipulation and stablj", wrvu: 1.55 },
 "21325": { name: "Open Treatment Nose Fracture Uncomplicatd", wrvu: 4.08 },
 "21330": { name: "Open Treatment Nose Fracture With Skele Fixj", wrvu: 5.65 },
 "21335": { name: "Open Treatment Nose & Septal Fracture", wrvu: 8.79 },
 "21336": { name: "Open Treatment Septal Fracture With without Stabj", wrvu: 6.60 },
 "21337": { name: "Closed Treatment Septal and nose Fracture", wrvu: 3.31 },
 "21338": { name: "Open Nasoethmoid Fracture Without Fixj", wrvu: 6.70 },
 "21339": { name: "Open Nasoethmoid Fracture W/ Fixj", wrvu: 8.29 },
 "21340": { name: "Percutaneous Treatment Nasoethmoid Fracture", wrvu: 11.20 },
 "21343": { name: "Open Treatment Dprsd Front Sinus Fracture", wrvu: 13.96 },
 "21344": { name: "Open Treatment Compl Front Sinus Fracture", wrvu: 21.03 },
 "21345": { name: "Closed Treatment Nose/jaw Fracture", wrvu: 8.83 },
 "21346": { name: "Open Treatment Nasomax Fracture With Fixj", wrvu: 11.16 },
 "21347": { name: "Open Treatment Nasomax Fracture Multple", wrvu: 13.19 },
 "21348": { name: "Open Treatment Nasomax Fracture With Graft", wrvu: 17.08 },
 "21355": { name: "Percutaneous Treatment Malar Fracture", wrvu: 4.34 },
 "21356": { name: "Open Treatment Dprsd Zygomatic Arch", wrvu: 4.71 },
 "21360": { name: "Open Treatment Dprsd Malar Fracture", wrvu: 7.01 },
 "21365": { name: "Open Treatment Complex Malar Fracture", wrvu: 16.35 },
 "21366": { name: "Open Treatment Complex Malar With Graft", wrvu: 18.14 },
 "21385": { name: "Open Treatment Orbit Fracture Transantral", wrvu: 9.33 },
 "21386": { name: "Open Treatment Orbit Fracture Periorbital", wrvu: 9.33 },
 "21387": { name: "Open Treatment Orbit Fracture Combined", wrvu: 9.86 },
 "21390": { name: "Open Treatment Orbit Periorbtl Implt", wrvu: 10.95 },
 "21395": { name: "Open Treatment Orbit Periorbt With Graft", wrvu: 14.33 },
 "21400": { name: "Closed Treatment Orbit Without Manipulj", wrvu: 1.46 },
 "21401": { name: "Closed Treatment Orbit With Manipulj", wrvu: 3.59 },
 "21406": { name: "Open Treatment Orbit Fracture Without Implant", wrvu: 7.23 },
 "21407": { name: "Open Treatment Orbit Fracture With Implant", wrvu: 8.79 },
 "21408": { name: "Open Treatment Orbit Fracture With Bone Graft", wrvu: 12.46 },
 "21421": { name: "Closed Treatment Palatal/max Fracture Wire Fix", wrvu: 5.87 },
 "21422": { name: "Optx Palatal/max Fracture", wrvu: 8.51 },
 "21423": { name: "Optx Palatal/max Fracture Comp", wrvu: 10.58 },
 "21431": { name: "Closed Treatment Craniofacial Separation", wrvu: 7.70 },
 "21432": { name: "Optx Cranfcl Sep With Wiring", wrvu: 8.60 },
 "21433": { name: "Optx Cranfcl Sep Comp Mlt", wrvu: 25.63 },
 "21435": { name: "Optx Crnfc Sep Comp Int&/xtr", wrvu: 19.75 },
 "21436": { name: "Optx Crnfcl Sep Comp Mlt Int", wrvu: 29.54 },
 "21440": { name: "Closed Treatment Mndblr/max Alv Ridge Fracture", wrvu: 3.35 },
 "21445": { name: "Optx Mndblr/max Alv Ridge Fracture", wrvu: 6.10 },
 "21450": { name: "Closed Treatment Mndblr Fracture Without Manipulation", wrvu: 3.62 },
 "21451": { name: "Closed Treatment Mndblr Fracture With Manipulation", wrvu: 5.51 },
 "21452": { name: "Percutaneous Treatment Mndblr Fracture Xtrnl Fixj", wrvu: 2.34 },
 "21453": { name: "Closed Treatment Mndblr Fracture Ntrdntl Fixj", wrvu: 6.47 },
 "21454": { name: "Optx Mndblr Fracture Xtrnl Fixj", wrvu: 7.18 },
 "21461": { name: "Optx Mndblr Fracture without Ntrdntl", wrvu: 9.08 },
 "21462": { name: "Optx Mndblr Fracture With Ntrdntl", wrvu: 10.73 },
 "21465": { name: "Optx Mndblr Cndylr Fracture", wrvu: 12.79 },
 "21470": { name: "Optx Complicated Mndblr Fracture", wrvu: 17.10 },
 "21480": { name: "Closed Treatment Tmprmand Dislc 1st/Subsequent", wrvu: 0.59 },
 "21485": { name: "Closed Treatment Tmprmand Dislc Comp", wrvu: 4.65 },
 "21490": { name: "Optx Tmprmand Dislocation", wrvu: 12.63 },
 "21497": { name: "Interdental Wirg Other Than Fracture", wrvu: 4.52 },
 "21499": { name: "Unlisted Muscskel Procedure Head", wrvu: 0.00 },
 "21501": { name: "Incision & Drainage Dp Abscess/Hematoma Sft Ts Neck", wrvu: 3.88 },
 "21502": { name: "Incision & Drainage Dp Abs/Hematoma Neck Rib Ostc", wrvu: 7.36 },
 "21510": { name: "Inc Deep Opng Bone Crtx Thorax", wrvu: 6.05 },
 "21550": { name: "Biopsy Of Neck/chest", wrvu: 2.06 },
 "21552": { name: "Excision Neck Lesion Subcutaneous 3 Cm/>", wrvu: 6.33 },
 "21554": { name: "Excision Neck Tumor Deep 5 Cm/>", wrvu: 10.85 },
 "21555": { name: "Excision Neck Lesion Subcutaneous < 3 Cm", wrvu: 3.86 },
 "21556": { name: "Excision Neck Tumor Deep < 5 Cm", wrvu: 7.47 },
 "21557": { name: "Resection Neck Thorax Tumor<5cm", wrvu: 14.38 },
 "21558": { name: "Resection Neck Tumor 5 Cm/>", wrvu: 21.04 },
 "21600": { name: "Partial Removal Of Rib", wrvu: 7.08 },
 "21601": { name: "Excision Chest Wall Tumor With Ribs", wrvu: 17.34 },
 "21602": { name: "Excision Chest Wal Tumor Without Lymphadec", wrvu: 21.64 },
 "21603": { name: "Excision Chest Wal Tumor With Lymphadec", wrvu: 24.54 },
 "21610": { name: "Costotransversectomy", wrvu: 15.51 },
 "21615": { name: "Excision 1st &/cervical Rib", wrvu: 10.19 },
 "21616": { name: "Excision 1st&/Cervical Rib With Sympth", wrvu: 12.37 },
 "21620": { name: "Ostectomy Sternum Partial", wrvu: 7.10 },
 "21627": { name: "Sternal Debridement", wrvu: 7.12 },
 "21630": { name: "Radical Resection Sternum", wrvu: 18.70 },
 "21685": { name: "Hyoid Myotomy & Suspension", wrvu: 14.88 },
 "21700": { name: "Revision Of Neck Muscle", wrvu: 6.15 },
 "21705": { name: "Revision Of Neck Muscle/rib", wrvu: 9.67 },
 "21720": { name: "Revision Of Neck Muscle", wrvu: 5.66 },
 "21725": { name: "Revision Of Neck Muscle", wrvu: 7.01 },
 "21740": { name: "Reconstruction Of Sternum", wrvu: 17.13 },
 "21742": { name: "Repair Stern/nuss Without Scope", wrvu: 0.00 },
 "21743": { name: "Repair Sternum/nuss With Scope", wrvu: 0.00 },
 "21750": { name: "Repair Of Sternum Separation", wrvu: 11.12 },
 "21811": { name: "Optx Of Rib Fracture With Fixj Scope", wrvu: 10.52 },
 "21812": { name: "Treatment Of Rib Fracture", wrvu: 12.68 },
 "21813": { name: "Treatment Of Rib Fracture", wrvu: 17.17 },
 "21820": { name: "Treat Sternum Fracture", wrvu: 1.33 },
 "21825": { name: "Treat Sternum Fracture", wrvu: 7.57 },
 "21899": { name: "Unlisted Procedure Neck/thorax", wrvu: 0.00 },
 "21920": { name: "Biopsy Soft Tissue Of Back", wrvu: 2.06 },
 "21925": { name: "Biopsy Soft Tissue Of Back", wrvu: 4.51 },
 "21930": { name: "Excision Back Lesion Subcutaneous < 3 Cm", wrvu: 4.82 },
 "21931": { name: "Excision Back Lesion Subcutaneous 3 Cm/>", wrvu: 6.71 },
 "21932": { name: "Excision Back Tumor Deep < 5 Cm", wrvu: 9.57 },
 "21933": { name: "Excision Back Tumor Deep 5 Cm/>", wrvu: 10.85 },
 "21935": { name: "Resection Back Tumor < 5 Cm", wrvu: 15.33 },
 "21936": { name: "Resection Back Tumor 5 Cm/>", wrvu: 21.99 },
 "22010": { name: "Incision & Drainage P-spine Chest/Thorax/Cardiacervical-thoracic", wrvu: 12.43 },
 "22015": { name: "Incision & Drainage Abscess P-spine Lumbar/Sacral/ls", wrvu: 12.32 },
 "22100": { name: "Remove Part Of Neck Vertebra", wrvu: 10.73 },
 "22101": { name: "Remove Part Thorax Vertebra", wrvu: 10.80 },
 "22102": { name: "Remove Part Lumbar Vertebra", wrvu: 10.80 },
 "22103": { name: "Remove Extra Spine Segment", wrvu: 2.28 },
 "22110": { name: "Remove Part Of Neck Vertebra", wrvu: 13.65 },
 "22112": { name: "Remove Part Thorax Vertebra", wrvu: 13.72 },
 "22114": { name: "Remove Part Lumbar Vertebra", wrvu: 13.72 },
 "22116": { name: "Remove Extra Spine Segment", wrvu: 2.26 },
 "22206": { name: "Incis Spine 3 Column Thoracic", wrvu: 36.25 },
 "22207": { name: "Incis Spine 3 Column Lumbar", wrvu: 35.76 },
 "22208": { name: "Incis Spine 3 Column Adl Seg", wrvu: 9.42 },
 "22210": { name: "Incis 1 Vertebral Seg Cervical", wrvu: 24.75 },
 "22212": { name: "Incis 1 Vertebral Seg Thoracic", wrvu: 20.47 },
 "22214": { name: "Incis 1 Vertebral Seg Lumbar", wrvu: 20.49 },
 "22216": { name: "Incis Additional Spine Segment", wrvu: 5.88 },
 "22220": { name: "Osteot Dsc Anterior 1 Vrt Sgm Cervical", wrvu: 22.37 },
 "22222": { name: "Osteot Dsc Anterior 1vrt Sgm Thoracic", wrvu: 22.51 },
 "22224": { name: "Osteot Dsc Anterior 1vrt Sgm Lumbar", wrvu: 22.51 },
 "22226": { name: "Osteot Dsc Anterior 1vrt Sgm Each", wrvu: 5.88 },
 "22310": { name: "Closed Treatment Vert Fracture Without Manj", wrvu: 3.36 },
 "22315": { name: "Closed Treatment Vert Fracture With Manj", wrvu: 9.86 },
 "22318": { name: "Treat Odontoid Fracture Without Graft", wrvu: 22.15 },
 "22319": { name: "Treat Odontoid Fracture With Graft", wrvu: 24.70 },
 "22325": { name: "Treat Spine Fracture", wrvu: 19.37 },
 "22326": { name: "Treat Neck Spine Fracture", wrvu: 20.32 },
 "22327": { name: "Treat Thorax Spine Fracture", wrvu: 20.25 },
 "22328": { name: "Treat Each Add Spine Fracture", wrvu: 4.49 },
 "22505": { name: "Manipulation Of Spine", wrvu: 1.82 },
 "22510": { name: "Percutaneous Cervicothoracic Inject", wrvu: 7.70 },
 "22511": { name: "Percutaneous Lumbosacral Injection", wrvu: 7.15 },
 "22512": { name: "Vertebroplasty Additional Inject", wrvu: 3.90 },
 "22513": { name: "Percutaneous Vertebral Augmentation", wrvu: 8.43 },
 "22514": { name: "Percutaneous Vertebral Augmentation", wrvu: 7.79 },
 "22515": { name: "Percutaneous Vertebral Augmentation", wrvu: 3.90 },
 "22526": { name: "Idet Single Level", wrvu: 5.70 },
 "22527": { name: "Idet 1 Or More Levels", wrvu: 2.95 },
 "22532": { name: "Arthrd Lateral Xtrcvtry Tq Thoracic", wrvu: 25.34 },
 "22533": { name: "Arthrd Lateral Xtrcvtry Tq Lumbar", wrvu: 24.17 },
 "22534": { name: "Arthrd Lateral Xtrcvtry Tq Each Ad", wrvu: 5.84 },
 "22548": { name: "Arthrd Anterior Toral/xoral C1-c2", wrvu: 26.38 },
 "22551": { name: "Arthrd Anterior Ntrbdy Cervical", wrvu: 24.38 },
 "22552": { name: "Arthrd Anterior Ntrbd Cervical Each", wrvu: 6.34 },
 "22554": { name: "Arthrd Anterior Ntrbd minutes Dsc Cervical", wrvu: 17.25 },
 "22556": { name: "Arthrd Anterior Ntrbd minutes Dsc Thc", wrvu: 24.08 },
 "22558": { name: "Arthrd Anterior Ntrbd minutes Dsc Lum", wrvu: 22.94 },
 "22585": { name: "Arthrd Anterior Ntrbd minutes Dsc Each", wrvu: 5.38 },
 "22586": { name: "Arthrd Pre-sac Ntrbdy L5-s1", wrvu: 27.42 },
 "22590": { name: "Arthrd Pst Tq Craniocervical", wrvu: 21.22 },
 "22595": { name: "Arthrd Pst Tq Atlas-axis", wrvu: 20.12 },
 "22600": { name: "Arthrd Pst Tq 1ntrspc Cervical", wrvu: 16.97 },
 "22610": { name: "Arthrd Pst Tq 1ntrspc Thoracic", wrvu: 16.85 },
 "22612": { name: "Arthrd Pst Tq 1ntrspc Lumbar", wrvu: 22.94 },
 "22614": { name: "Arthrd Pst Tq 1ntrspc Each Add", wrvu: 6.27 },
 "22630": { name: "Arthrd Pst Tq 1ntrspc Lum", wrvu: 21.54 },
 "22632": { name: "Arthrd Pst Tq 1ntrspc Lm Each", wrvu: 5.09 },
 "22633": { name: "Arthrd Cmbn 1ntrspc Lumbar", wrvu: 26.13 },
 "22634": { name: "Arthrd Cmbn 1ntrspc Each Additional", wrvu: 7.76 },
 "22800": { name: "Arthrd Pst Dfrm<6 Vrt Sgm", wrvu: 19.01 },
 "22802": { name: "Arthrd Pst Dfrm 7-12 Vrt Sgm", wrvu: 31.31 },
 "22804": { name: "Arthrd Pst Dfrm 13+ Vrt Sgm", wrvu: 36.56 },
 "22808": { name: "Arthrd Anterior Dfrm 2-3 Vrt Sgm", wrvu: 26.82 },
 "22810": { name: "Arthrd Anterior Dfrm 4-7 Vrt Sgm", wrvu: 30.71 },
 "22812": { name: "Arthrd Anterior Dfrm 8+ Vrt Sgm", wrvu: 33.39 },
 "22818": { name: "Kyphectomy 1-2 Segments", wrvu: 33.47 },
 "22819": { name: "Kyphectomy 3 Or More", wrvu: 38.40 },
 "22830": { name: "Exploration Of Spinal Fusion", wrvu: 10.94 },
 "22836": { name: "Anterior Thoracic Vrt Body Tethrg <7", wrvu: 31.20 },
 "22837": { name: "Anterior Thoracic Vrt Body Tethrg 8+", wrvu: 34.61 },
 "22838": { name: "Revision Rplc/Removal Thoracic Vrt Tethrg", wrvu: 35.10 },
 "22840": { name: "Insert Spine Fixation Device", wrvu: 12.21 },
 "22841": { name: "Insert Spine Fixation Device", wrvu: 0.00 },
 "22842": { name: "Insert Spine Fixation Device", wrvu: 12.25 },
 "22843": { name: "Insert Spine Fixation Device", wrvu: 13.10 },
 "22844": { name: "Insert Spine Fixation Device", wrvu: 16.01 },
 "22845": { name: "Insert Spine Fixation Device", wrvu: 11.64 },
 "22846": { name: "Insert Spine Fixation Device", wrvu: 12.09 },
 "22847": { name: "Insert Spine Fixation Device", wrvu: 13.44 },
 "22848": { name: "Insert Pelv Fixation Device", wrvu: 5.84 },
 "22849": { name: "Reinsert Spinal Fixation", wrvu: 18.69 },
 "22850": { name: "Remove Spine Fixation Device", wrvu: 9.57 },
 "22852": { name: "Remove Spine Fixation Device", wrvu: 9.14 },
 "22853": { name: "Insertion Biomechanical Device", wrvu: 4.14 },
 "22854": { name: "Insertion Biomechanical Device", wrvu: 5.36 },
 "22855": { name: "Removal Anterior Instrmj", wrvu: 15.46 },
 "22856": { name: "Tot Disc Arthrp 1ntrspc Cervical", wrvu: 23.45 },
 "22857": { name: "Tot Disc Arthrp 1ntrspc Lumbar", wrvu: 26.45 },
 "22858": { name: "Tot Disc Arthrp 2nd Lvl Cervical", wrvu: 8.19 },
 "22859": { name: "Insertion Biomechanical Device", wrvu: 5.36 },
 "22860": { name: "Tot Disc Arthrp 2ntrspc Lumbar", wrvu: 6.71 },
 "22861": { name: "Revision Rplcm Arthrp 1ntrspc Cervical", wrvu: 32.53 },
 "22862": { name: "Revision Rplcm Rthrp 1ntrspc Lumbar", wrvu: 31.81 },
 "22864": { name: "Removal Tot Arthrp 1ntrspc Cervical", wrvu: 28.67 },
 "22865": { name: "Removal Tot Arthrp 1ntrspc Lumbar", wrvu: 30.96 },
 "22867": { name: "Insertion Stablj Device With Dcmprn", wrvu: 14.63 },
 "22868": { name: "Insertion Stablj Device With Dcmprn", wrvu: 3.90 },
 "22869": { name: "Insertion Stablj Device Without Dcmprn", wrvu: 6.85 },
 "22870": { name: "Insertion Stablj Device Without Dcmprn", wrvu: 2.28 },
 "22899": { name: "Unlisted Procedure Spine", wrvu: 0.00 },
 "22900": { name: "Excision Abdominal Tumor Deep < 5 Cm", wrvu: 8.11 },
 "22901": { name: "Excision Abdominal Tumor Deep 5 Cm/>", wrvu: 9.86 },
 "22902": { name: "Excision Abdominal Lesion Subcutaneous < 3 Cm", wrvu: 4.31 },
 "22903": { name: "Excision Abdominal Lesion Subcutaneous 3 Cm/>", wrvu: 6.23 },
 "22904": { name: "Radical Resection Abdominal Tumor<5cm", wrvu: 16.27 },
 "22905": { name: "Radical Resection Abdominal Tumor 5 Cm/>", wrvu: 21.04 },
 "22999": { name: "Unlisted Procedure Abdomen Muscskel", wrvu: 0.00 },
 "23000": { name: "Removal Sbdltd Clcreous Dilatation and Evacuation Procedure Open", wrvu: 4.37 },
 "23020": { name: "Capsular Contracture Release", wrvu: 9.13 },
 "23030": { name: "Incision & Drainage Shoulder Deep Abscess/Hematoma", wrvu: 3.38 },
 "23031": { name: "Incision & Drainage Shoulder Infected Bursa", wrvu: 2.72 },
 "23035": { name: "Incision Bone Cortex Shoulder", wrvu: 8.93 },
 "23040": { name: "Arthrt Growth Hormone Joint Expl/Drainage/Removal Fb", wrvu: 9.51 },
 "23044": { name: "Arthrt Ac Subcutaneous Joint Exp/Removal Fb", wrvu: 7.40 },
 "23065": { name: "Biopsy Shoulder Tissues", wrvu: 2.24 },
 "23066": { name: "Biopsy Shoulder Tissues", wrvu: 4.19 },
 "23071": { name: "Excision Shoulder Lesion Subcutaneous 3 Cm/>", wrvu: 5.76 },
 "23073": { name: "Excision Shoulder Tumor Deep 5 Cm/>", wrvu: 9.88 },
 "23075": { name: "Excision Shoulder Lesion Subcutaneous < 3 Cm", wrvu: 4.10 },
 "23076": { name: "Excision Shoulder Tumor Deep < 5 Cm", wrvu: 7.22 },
 "23077": { name: "Radical Resection Tumor Shoulder<5 Cm", wrvu: 17.22 },
 "23078": { name: "Radical Resection Tumor Shoulder 5cm/>", wrvu: 21.99 },
 "23100": { name: "Arthrotomy Glenhumrl Joint With Biopsy", wrvu: 6.05 },
 "23101": { name: "Arthrt Acrmclv/strnclav Joint", wrvu: 5.58 },
 "23105": { name: "Arthrotomy Glenohumeral Joint", wrvu: 8.27 },
 "23106": { name: "Arthrotomy Strnclav Joint", wrvu: 5.98 },
 "23107": { name: "Arthrt Glenhumrl Joint With Expl", wrvu: 8.65 },
 "23120": { name: "Claviculectomy Partial", wrvu: 7.21 },
 "23125": { name: "Claviculectomy Total", wrvu: 9.40 },
 "23130": { name: "Acromp/acromionectomy Partial", wrvu: 7.58 },
 "23140": { name: "Removal Of Bone Lesion", wrvu: 6.94 },
 "23145": { name: "Removal Of Bone Lesion", wrvu: 9.17 },
 "23146": { name: "Removal Of Bone Lesion", wrvu: 7.88 },
 "23150": { name: "Removal Of Humerus Lesion", wrvu: 8.69 },
 "23155": { name: "Removal Of Humerus Lesion", wrvu: 10.59 },
 "23156": { name: "Removal Of Humerus Lesion", wrvu: 8.88 },
 "23170": { name: "Sequestrectomy Clavicle", wrvu: 7.03 },
 "23172": { name: "Sequestrectomy Scapula", wrvu: 7.13 },
 "23174": { name: "Sqstrctmy Humrl Head Srg Neck", wrvu: 9.80 },
 "23180": { name: "Partial Excision Bone Clavicle", wrvu: 8.77 },
 "23182": { name: "Partial Excision Bone Scapula", wrvu: 8.39 },
 "23184": { name: "Partial Excision Bone Proximal Humeral", wrvu: 9.65 },
 "23190": { name: "Ostectomy Scapula Partial", wrvu: 7.28 },
 "23195": { name: "Resection Humeral Head", wrvu: 10.10 },
 "23200": { name: "Radical Resection Tumor Clavicle", wrvu: 22.14 },
 "23210": { name: "Radical Resection Tumor Scapula", wrvu: 26.53 },
 "23220": { name: "Radical Resection Tumor Proximal Humeral", wrvu: 29.45 },
 "23330": { name: "Remove Shoulder Foreign Body", wrvu: 1.85 },
 "23333": { name: "Remove Shoulder Fb Deep", wrvu: 5.85 },
 "23334": { name: "Shoulder Prosthesis Removal", wrvu: 15.11 },
 "23335": { name: "Shoulder Prosthesis Removal", wrvu: 18.53 },
 "23350": { name: "Injection For Shoulder X-ray", wrvu: 0.98 },
 "23395": { name: "Muscle Transfer Shoulder/arm", wrvu: 18.08 },
 "23397": { name: "Muscle Transfers", wrvu: 16.34 },
 "23400": { name: "Fixation Of Shoulder Blade", wrvu: 13.52 },
 "23405": { name: "Incision Of Tendon & Muscle", wrvu: 8.33 },
 "23406": { name: "Incise Tendon(s) & Muscle(s)", wrvu: 10.73 },
 "23410": { name: "Repair Rotator Cuff Acute", wrvu: 11.11 },
 "23412": { name: "Repair Rotator Cuff Chronic", wrvu: 11.63 },
 "23415": { name: "Release Of Shoulder Ligation", wrvu: 9.00 },
 "23420": { name: "Repair Of Shoulder", wrvu: 13.20 },
 "23430": { name: "Repair Biceps Tendon", wrvu: 9.92 },
 "23440": { name: "Remove/transplant Tendon", wrvu: 10.37 },
 "23450": { name: "Repair Shoulder Capsule", wrvu: 13.36 },
 "23455": { name: "Repair Shoulder Capsule", wrvu: 14.30 },
 "23460": { name: "Repair Shoulder Capsule", wrvu: 15.42 },
 "23462": { name: "Repair Shoulder Capsule", wrvu: 15.33 },
 "23465": { name: "Repair Shoulder Capsule", wrvu: 15.89 },
 "23466": { name: "Repair Shoulder Capsule", wrvu: 15.41 },
 "23470": { name: "Reconstruct Shoulder Joint", wrvu: 17.44 },
 "23472": { name: "Reconstruct Shoulder Joint", wrvu: 21.58 },
 "23473": { name: "Revis Reconst Shoulder Joint", wrvu: 24.38 },
 "23474": { name: "Revis Reconst Shoulder Joint", wrvu: 26.53 },
 "23480": { name: "Revision Of Collar Bone", wrvu: 11.25 },
 "23485": { name: "Revision Of Collar Bone", wrvu: 13.56 },
 "23490": { name: "Reinforce Clavicle", wrvu: 11.86 },
 "23491": { name: "Reinforce Shoulder Bones", wrvu: 14.18 },
 "23500": { name: "Closed Treatment Clavicular Fracture Without Manipulation", wrvu: 2.15 },
 "23505": { name: "Closed Treatment Clavicular Fracture With Manipulation", wrvu: 3.73 },
 "23515": { name: "Optx Clavicular Fracture With Int Fix", wrvu: 9.45 },
 "23520": { name: "Closed Treatment Strnclav Dislc Without Manipulation", wrvu: 2.23 },
 "23525": { name: "Closed Treatment Strnclav Dislc With Manipulation", wrvu: 3.70 },
 "23530": { name: "Optx Strnclav Dislc Aqt/chrn", wrvu: 7.29 },
 "23532": { name: "Optx Strclv Dslc Aq/chrn Grf", wrvu: 8.00 },
 "23540": { name: "Closed Treatment Acromclav Dislc without Manipulation", wrvu: 2.30 },
 "23545": { name: "Closed Treatment Acromclav Dislc With Manipulation", wrvu: 3.34 },
 "23550": { name: "Optx Acromclv Dislc Aqt/chrn", wrvu: 7.40 },
 "23552": { name: "Optx Acrclv Dslc Aq/chrn Grf", wrvu: 8.60 },
 "23570": { name: "Closed Treatment Scapular Fracture Without Manipulation", wrvu: 2.30 },
 "23575": { name: "Closed Treatment Scapula Fracture With Manipulation +-tractj", wrvu: 4.12 },
 "23585": { name: "Optx Scapular Fracture With Int Fixj", wrvu: 13.87 },
 "23600": { name: "Closed Treatment Proximal Humrl Fracture Without Manipulation", wrvu: 2.93 },
 "23605": { name: "Closed Treatment Prx Hmrl Fracture Manipulation+-tract", wrvu: 4.93 },
 "23615": { name: "Optx Proximal Humrl Fracture With Int Fix", wrvu: 11.99 },
 "23616": { name: "Optx Prx Hmrl Fracture Fix Repair Rpl", wrvu: 17.91 },
 "23620": { name: "Closed Treatment Gr Hmrl Tbrs Fracture without Manipulation", wrvu: 2.49 },
 "23625": { name: "Closed Treatment Gr Hmrl Tbrs Fracture With Manipulation", wrvu: 4.00 },
 "23630": { name: "Optx Gr Hmrl Tbrs Fracture Int Fix", wrvu: 10.31 },
 "23650": { name: "Closed Treatment Shoulder Dslc With Manipulation without Anesthesia", wrvu: 3.44 },
 "23655": { name: "Closed Treatment Shoulder Dslc With Manipulation With Anesthesia", wrvu: 4.64 },
 "23660": { name: "Optx Acute Shoulder Dislc", wrvu: 7.47 },
 "23665": { name: "Closed Treatment Shoulder Dslc Fracture Gr Hmrl Tbr", wrvu: 4.54 },
 "23670": { name: "Optx Shoulder Dislc Fracture", wrvu: 11.97 },
 "23675": { name: "Closed Treatment Shoulder Dislc Neck Fracture Manipulation", wrvu: 6.11 },
 "23680": { name: "Optx Shoulder Dislc Neck Fracture Fixj", wrvu: 12.82 },
 "23700": { name: "Manipulation Anesthesia Shoulder Joint Fixj Aprats", wrvu: 2.51 },
 "23800": { name: "Arthrodesis Glenohumeral Joint", wrvu: 14.36 },
 "23802": { name: "Arthrd Glenohumeral Joint With Grf", wrvu: 17.96 },
 "23900": { name: "Interthoracoscplr Amputation", wrvu: 20.20 },
 "23920": { name: "Disarticulation Shoulder", wrvu: 15.82 },
 "23921": { name: "Disarticulation Shoulder Secondary Closure", wrvu: 5.58 },
 "23929": { name: "Unlisted Procedure Shoulder", wrvu: 0.00 },
 "23930": { name: "Incision & Drainage Upper Arm/Elbow Dp Abscess/Hematoma", wrvu: 2.92 },
 "23931": { name: "Incision & Drainage Upper Arm/Elbow Bursa", wrvu: 1.79 },
 "23935": { name: "Inc Dp Open Bone Crtx Humeral/elbow", wrvu: 6.22 },
 "24000": { name: "Arthrt Elbow Expl Drainage/Removal Fb", wrvu: 5.93 },
 "24006": { name: "Arthrt Elbow Capsl Excision Rls", wrvu: 9.50 },
 "24065": { name: "Biopsy Arm/elbow Soft Tissue", wrvu: 2.08 },
 "24066": { name: "Biopsy Arm/elbow Soft Tissue", wrvu: 5.22 },
 "24071": { name: "Excision Arm/elbow Lesion Subcutaneous 3 Cm/>", wrvu: 5.56 },
 "24073": { name: "Excision Arm/elbow Tumor Deep 5 Cm/>", wrvu: 9.88 },
 "24075": { name: "Excision Arm/elbow Lesion Subcutaneous < 3 Cm", wrvu: 4.13 },
 "24076": { name: "Excision Arm/elbow Tumor Deep < 5 Cm", wrvu: 7.22 },
 "24077": { name: "Radical Resection Tumor Tiss Arm/Elbow <5cm", wrvu: 15.33 },
 "24079": { name: "Radical Resection Tumor Tiss Arm/Elbow 5 Cm+", wrvu: 20.09 },
 "24100": { name: "Arthrt Elbow Synovial Biopsy Only", wrvu: 4.94 },
 "24101": { name: "Arthrt Elbow Joint Expl Biopsy Removal", wrvu: 6.14 },
 "24102": { name: "Arthrt Elbow With Synovectomy", wrvu: 8.05 },
 "24105": { name: "Excision Olecranon Bursa", wrvu: 3.69 },
 "24110": { name: "Excision/curtg Bone Cst/Benign Tumor Humeral", wrvu: 7.39 },
 "24115": { name: "Excision/crtg Bone Cst/tumor Humeral Agrf", wrvu: 9.87 },
 "24116": { name: "Excision/crtg Bone Cst/tumor Humeral Algr", wrvu: 11.92 },
 "24120": { name: "Excision/crtg Bone Cst/Benign Tumor Rds", wrvu: 6.65 },
 "24125": { name: "Excision/crtg Bone Cst/tumor Rds Agrf", wrvu: 7.94 },
 "24126": { name: "Excision/crtg Bone Cst/tumor Rds Algr", wrvu: 8.40 },
 "24130": { name: "Excision Radical Head", wrvu: 6.26 },
 "24134": { name: "Sequestrectomy Shft/dstl Humeral", wrvu: 9.96 },
 "24136": { name: "Sequestrectomy Radical H/n", wrvu: 8.19 },
 "24138": { name: "Sequestrectomy Olecrn Proces", wrvu: 8.29 },
 "24140": { name: "Partial Excision Bone Humerus", wrvu: 9.31 },
 "24145": { name: "Partial Excision Bone Radical H/n", wrvu: 7.61 },
 "24147": { name: "Partial Excision Bone Olecrn Process", wrvu: 7.64 },
 "24149": { name: "Radical Resection Of Elbow", wrvu: 15.81 },
 "24150": { name: "Radical Resection Tumor Dstl/shft Humeral", wrvu: 22.87 },
 "24152": { name: "Radical Resection Tumor Radical H/n", wrvu: 19.49 },
 "24155": { name: "Resection Of Elbow Joint", wrvu: 11.79 },
 "24160": { name: "Removal Prosthhumrl and ulnar Cmpnt", wrvu: 18.16 },
 "24164": { name: "Removal Prosth Radical Head", wrvu: 9.75 },
 "24200": { name: "Removal Fb Upper Arm/elbow Subcutaneous", wrvu: 1.76 },
 "24201": { name: "Removal Fb Upper Arm/elbow Deep", wrvu: 4.58 },
 "24220": { name: "Injection Procedure For Elbow Arthg", wrvu: 1.28 },
 "24300": { name: "Manipulation Elbow Under Anesthesia", wrvu: 3.94 },
 "24301": { name: "Muscle/tdn Transfer Upper Arm/Elbow 1", wrvu: 10.12 },
 "24305": { name: "Tendon Lngth Upper Arm/Elbow Each Tdn", wrvu: 7.43 },
 "24310": { name: "Tnot Open Elbow To Shoulder Each Tdn", wrvu: 5.97 },
 "24320": { name: "Tenoplasty Elbow To Shoulder 1", wrvu: 10.59 },
 "24330": { name: "Flexor-plasty Elbow", wrvu: 9.55 },
 "24331": { name: "Flexor-plasty Elbow With Advmnt", wrvu: 10.68 },
 "24332": { name: "Tenolysis Triceps", wrvu: 7.71 },
 "24340": { name: "Tenodesis Biceps Tdn At Elbow", wrvu: 7.88 },
 "24341": { name: "Repair Tdn/Muscle Upper Arm/Elbow Each", wrvu: 9.25 },
 "24342": { name: "Repair Of Ruptured Tendon", wrvu: 10.59 },
 "24343": { name: "Repr Elbow Lateral Ligmnt With Tiss", wrvu: 8.93 },
 "24344": { name: "Reconstruct Elbow Lateral Ligmnt", wrvu: 14.83 },
 "24345": { name: "Repr Elbow Medial Ligmnt With Tissu", wrvu: 8.93 },
 "24346": { name: "Reconstruct Elbow Medial Ligmnt", wrvu: 14.83 },
 "24357": { name: "Repair Elbow Percutaneous", wrvu: 5.30 },
 "24358": { name: "Repair Elbow With Debridement Open", wrvu: 6.49 },
 "24359": { name: "Repair Elbow Debridement/attch Open", wrvu: 8.76 },
 "24360": { name: "Reconstruct Elbow Joint", wrvu: 12.35 },
 "24361": { name: "Reconstruct Elbow Joint", wrvu: 14.05 },
 "24362": { name: "Reconstruct Elbow Joint", wrvu: 14.94 },
 "24363": { name: "Replace Elbow Joint", wrvu: 21.45 },
 "24365": { name: "Reconstruct Head Of Radius", wrvu: 8.40 },
 "24366": { name: "Reconstruct Head Of Radius", wrvu: 9.13 },
 "24370": { name: "Revise Reconst Elbow Joint", wrvu: 22.96 },
 "24371": { name: "Revise Reconst Elbow Joint", wrvu: 26.81 },
 "24400": { name: "Osteot Humerus With without Int Fixj", wrvu: 11.05 },
 "24410": { name: "Mlt Osteot Rlgnm Imed Rd Humeral", wrvu: 14.73 },
 "24420": { name: "Osteoplasty Humerus", wrvu: 13.39 },
 "24430": { name: "Repair Non/Malignant Humerus without Graft", wrvu: 14.87 },
 "24435": { name: "Repair Non/Malignant Humeral With Autograft", wrvu: 14.62 },
 "24470": { name: "Hemiepiphyseal Arrest", wrvu: 8.71 },
 "24495": { name: "Decompression Fasct Forearm", wrvu: 8.20 },
 "24498": { name: "Prophylactic Treatment With without Mthylmthcrylt", wrvu: 11.97 },
 "24500": { name: "Closed Treatment Humrl Shft Fracture Without Manipulation", wrvu: 3.32 },
 "24505": { name: "Closed Treatment Humrl Shft Fracture With Manipulation", wrvu: 5.26 },
 "24515": { name: "Optx Humrl Shft Fracture Plate/scr", wrvu: 11.82 },
 "24516": { name: "Treatment Humrl Shaft Fracture Imed Implt", wrvu: 11.89 },
 "24530": { name: "Closed Treatment Sprcndylr Humeral Fracture Without", wrvu: 3.60 },
 "24535": { name: "Closed Treatment Sprcndylr Humeral Fracture W/", wrvu: 6.93 },
 "24538": { name: "Prq Skel Fix Sprcndlr Humeral Fracture", wrvu: 9.53 },
 "24545": { name: "Optx Humeral Fracture without Ntrcndylr Extension", wrvu: 12.82 },
 "24546": { name: "Optx Humeral Fracture With Ntrcndylr Extension", wrvu: 14.54 },
 "24560": { name: "Closed Treatment Humeral Epcndylr Fracture without Manipulation", wrvu: 2.91 },
 "24565": { name: "Closed Treatment Humeral Epcndylr Fracture With Manipulation", wrvu: 5.64 },
 "24566": { name: "Prq Skel Fix Epcndylr Humeral Fracture", wrvu: 8.83 },
 "24575": { name: "Optx Humeral Epcndylr Fracture", wrvu: 9.47 },
 "24576": { name: "Closed Treatment Humrl Cndylr Fracture without Manipulation", wrvu: 2.98 },
 "24577": { name: "Closed Treatment Humrl Cndylr Fracture With Manipulation", wrvu: 5.86 },
 "24579": { name: "Optx Humrl Cndylr Fracture", wrvu: 11.15 },
 "24582": { name: "Prq Skel Fix Humrl Cndylr Fracture", wrvu: 9.89 },
 "24586": { name: "Optx Partclr Fracture&/dislc Elbow", wrvu: 15.39 },
 "24587": { name: "Optx Partclr Fracture&/dslc Elbow W", wrvu: 15.40 },
 "24600": { name: "Treatment Closed Elbow Dislc Without Anesthesia", wrvu: 4.26 },
 "24605": { name: "Treatment Closed Elbow Dislc Req Anesthesia", wrvu: 5.50 },
 "24615": { name: "Optx Aqt/chrnc Elbow Dislc", wrvu: 9.58 },
 "24620": { name: "Closed Treatment Monteggia Fracture Dislc Elbow", wrvu: 7.04 },
 "24635": { name: "Optx Monteggia Fracture Dislc Elbow", wrvu: 8.58 },
 "24640": { name: "Closed Treatment Rdl Head Sublxtj Nrsemd", wrvu: 1.22 },
 "24650": { name: "Closed Treatment Rdl Head/Neck Fracture without Manipulation", wrvu: 2.25 },
 "24655": { name: "Closed Treatment Rdl Head/Neck Fracture With Manipulation", wrvu: 4.50 },
 "24665": { name: "Optx Radical Head/neck Fracture", wrvu: 8.15 },
 "24666": { name: "Optx Radical Head/Neck Fracture Rplc", wrvu: 9.61 },
 "24670": { name: "Closed Treatment Ulnar Fracture Proximal Without Manipulation", wrvu: 2.62 },
 "24675": { name: "Closed Treatment Ulnar Fracture Proximal With Manipulation", wrvu: 4.79 },
 "24685": { name: "Optx Ulnar Fracture Proximal End With Fix", wrvu: 8.16 },
 "24800": { name: "Arthrodesis Elbow Joint Local", wrvu: 11.12 },
 "24802": { name: "Arthrd Elbow Joint Autog Graft", wrvu: 13.96 },
 "24900": { name: "Amputation Of Upper Arm", wrvu: 9.93 },
 "24920": { name: "Amputation Of Upper Arm", wrvu: 9.88 },
 "24925": { name: "Amputation Follow-up Surgery", wrvu: 7.12 },
 "24930": { name: "Amputation Follow-up Surgery", wrvu: 10.56 },
 "24931": { name: "Amputate Upper Arm & Implant", wrvu: 13.10 },
 "24935": { name: "Revision Of Amputation", wrvu: 16.04 },
 "24940": { name: "Revision Of Upper Arm", wrvu: 0.00 },
 "24999": { name: "Unlisted Procedure Humerus/elbow", wrvu: 0.00 },
 "25000": { name: "Incision Of Tendon Sheath", wrvu: 3.46 },
 "25001": { name: "Incise Flexor Carpi Radialis", wrvu: 3.70 },
 "25020": { name: "Decompress Forearm 1 Space", wrvu: 5.91 },
 "25023": { name: "Decompress Forearm 1 Space", wrvu: 13.48 },
 "25024": { name: "Decompress Forearm 2 Spaces", wrvu: 10.52 },
 "25025": { name: "Decompress Forearm 2 Spaces", wrvu: 17.49 },
 "25028": { name: "Incision & Drainage Forearm&/Wrist Dp Abscess/Hematoma", wrvu: 5.26 },
 "25031": { name: "Incision & Drainage Forearm&/wrist Bursa", wrvu: 4.15 },
 "25035": { name: "Inc Dp Bone Crtx Forearm&/Wrist", wrvu: 7.46 },
 "25040": { name: "Arthrt Rdcrpl/midcarpl Joint", wrvu: 7.31 },
 "25065": { name: "Biopsy Forearm Soft Tissues", wrvu: 1.99 },
 "25066": { name: "Biopsy Forearm Soft Tissues", wrvu: 4.16 },
 "25071": { name: "Excision Forearm Lesion Subcutaneous 3 Cm/>", wrvu: 5.76 },
 "25073": { name: "Excision Forearm Tumor Deep 3 Cm/>", wrvu: 6.95 },
 "25075": { name: "Excision Forearm Lesion Subcutaneous < 3 Cm", wrvu: 3.86 },
 "25076": { name: "Excision Forearm Tumor Deep < 3 Cm", wrvu: 6.57 },
 "25077": { name: "Resection Forearm/wrist Tumor<3cm", wrvu: 12.61 },
 "25078": { name: "Resection Forarm/wrist Tumor 3cm>", wrvu: 17.25 },
 "25085": { name: "Incision Of Wrist Capsule", wrvu: 5.50 },
 "25100": { name: "Biopsy Of Wrist Joint", wrvu: 3.92 },
 "25101": { name: "Explore/treat Wrist Joint", wrvu: 4.71 },
 "25105": { name: "Remove Wrist Joint Lining", wrvu: 5.87 },
 "25107": { name: "Remove Wrist Joint Cartilage", wrvu: 7.51 },
 "25109": { name: "Excise Tendon Forearm/wrist", wrvu: 6.77 },
 "25110": { name: "Remove Wrist Tendon Lesion", wrvu: 3.94 },
 "25111": { name: "Remove Wrist Tendon Lesion", wrvu: 3.44 },
 "25112": { name: "Reremove Wrist Tendon Lesion", wrvu: 4.55 },
 "25115": { name: "Remove Wrist/forearm Lesion", wrvu: 9.84 },
 "25116": { name: "Remove Wrist/forearm Lesion", wrvu: 7.37 },
 "25118": { name: "Excise Wrist Tendon Sheath", wrvu: 4.40 },
 "25119": { name: "Partial Removal Of Ulna", wrvu: 6.05 },
 "25120": { name: "Removal Of Forearm Lesion", wrvu: 6.11 },
 "25125": { name: "Remove/graft Forearm Lesion", wrvu: 7.48 },
 "25126": { name: "Remove/graft Forearm Lesion", wrvu: 7.55 },
 "25130": { name: "Removal Of Wrist Lesion", wrvu: 5.29 },
 "25135": { name: "Remove & Graft Wrist Lesion", wrvu: 6.90 },
 "25136": { name: "Remove & Graft Wrist Lesion", wrvu: 5.99 },
 "25145": { name: "Remove Forearm Bone Lesion", wrvu: 6.38 },
 "25150": { name: "Partial Removal Of Ulna", wrvu: 7.20 },
 "25151": { name: "Partial Removal Of Radius", wrvu: 7.49 },
 "25170": { name: "Resection Radius/ulnar Tumor", wrvu: 21.65 },
 "25210": { name: "Removal Of Wrist Bone", wrvu: 5.97 },
 "25215": { name: "Removal Of Wrist Bones", wrvu: 7.94 },
 "25230": { name: "Partial Removal Of Radius", wrvu: 5.24 },
 "25240": { name: "Partial Removal Of Ulna", wrvu: 5.18 },
 "25246": { name: "Injection For Wrist X-ray", wrvu: 1.41 },
 "25248": { name: "Remove Forearm Foreign Body", wrvu: 5.18 },
 "25250": { name: "Removal Of Wrist Prosthesis", wrvu: 6.60 },
 "25251": { name: "Removal Of Wrist Prosthesis", wrvu: 9.57 },
 "25259": { name: "Manipulate Wrist With Anesthes", wrvu: 3.94 },
 "25260": { name: "Repair Forearm Tendon/muscle", wrvu: 7.84 },
 "25263": { name: "Repair Forearm Tendon/muscle", wrvu: 7.84 },
 "25265": { name: "Repair Forearm Tendon/muscle", wrvu: 9.85 },
 "25270": { name: "Repair Forearm Tendon/muscle", wrvu: 6.02 },
 "25272": { name: "Repair Forearm Tendon/muscle", wrvu: 7.03 },
 "25274": { name: "Repair Forearm Tendon/muscle", wrvu: 8.72 },
 "25275": { name: "Repair Forearm Tendon Sheath", wrvu: 8.74 },
 "25280": { name: "Revise Wrist/forearm Tendon", wrvu: 7.21 },
 "25290": { name: "Incise Wrist/forearm Tendon", wrvu: 5.29 },
 "25295": { name: "Release Wrist/forearm Tendon", wrvu: 6.55 },
 "25300": { name: "Fusion Of Tendons At Wrist", wrvu: 8.79 },
 "25301": { name: "Fusion Of Tendons At Wrist", wrvu: 8.38 },
 "25310": { name: "Transplant Forearm Tendon", wrvu: 8.78 },
 "25312": { name: "Transplant Forearm Tendon", wrvu: 9.57 },
 "25315": { name: "Revise Palsy Hand Tendon(s)", wrvu: 10.41 },
 "25316": { name: "Revise Palsy Hand Tendon(s)", wrvu: 12.58 },
 "25320": { name: "Repair/revise Wrist Joint", wrvu: 12.43 },
 "25332": { name: "Revise Wrist Joint", wrvu: 11.45 },
 "25335": { name: "Centralization Wrist On Ulna", wrvu: 13.06 },
 "25337": { name: "Reconstruct Ulna/radioulnar", wrvu: 11.44 },
 "25350": { name: "Revision Of Radius", wrvu: 8.86 },
 "25355": { name: "Revision Of Radius", wrvu: 10.27 },
 "25360": { name: "Revision Of Ulna", wrvu: 8.52 },
 "25365": { name: "Revise Radius & Ulna", wrvu: 12.59 },
 "25370": { name: "Revise Radius Or Ulna", wrvu: 13.75 },
 "25375": { name: "Revise Radius & Ulna", wrvu: 13.21 },
 "25390": { name: "Shorten Radius Or Ulna", wrvu: 10.43 },
 "25391": { name: "Lengthen Radius Or Ulna", wrvu: 13.92 },
 "25392": { name: "Shorten Radius & Ulna", wrvu: 14.22 },
 "25393": { name: "Lengthen Radius & Ulna", wrvu: 16.15 },
 "25394": { name: "Repair Carpal Bone Shorten", wrvu: 10.58 },
 "25400": { name: "Repair Radius Or Ulna", wrvu: 11.00 },
 "25405": { name: "Repair/graft Radius Or Ulna", wrvu: 14.63 },
 "25415": { name: "Repair Radius & Ulna", wrvu: 13.46 },
 "25420": { name: "Repair/graft Radius & Ulna", wrvu: 16.61 },
 "25425": { name: "Repair/graft Radius Or Ulna", wrvu: 13.38 },
 "25426": { name: "Repair/graft Radius & Ulna", wrvu: 16.04 },
 "25430": { name: "Vasc Graft Into Carpal Bone", wrvu: 9.47 },
 "25431": { name: "Repair Nonunion Carpal Bone", wrvu: 10.62 },
 "25440": { name: "Repair Nonu Scphd Carpl Bone", wrvu: 10.41 },
 "25441": { name: "Arthrp With Prostc Dstl Rds", wrvu: 12.96 },
 "25442": { name: "Arthrp With Prostc Dstl Ulna", wrvu: 10.84 },
 "25443": { name: "Arthrp Prostc Dstl Scph Crpl", wrvu: 10.39 },
 "25444": { name: "Arthrp With Prostc Lunate", wrvu: 11.13 },
 "25445": { name: "Arthrp With Prostc Trapezium", wrvu: 9.63 },
 "25446": { name: "Arthrp With Prostc Dst Rds and crps", wrvu: 16.87 },
 "25447": { name: "Arthrp Ntrcrp/C-Reactive Protein/mtcr Ntrps", wrvu: 10.24 },
 "25448": { name: "Arthrp Ntrcrpl/C-Reactive Protein/mtcrp Skin Substitute", wrvu: 11.55 },
 "25449": { name: "Revj Arthrp Wrist Joint", wrvu: 14.57 },
 "25450": { name: "Epiphysl Arrst Dstl Rds/ulna", wrvu: 7.86 },
 "25455": { name: "Epiphysl Arrst Dstl Rds and ulna", wrvu: 9.47 },
 "25490": { name: "Prophylactic Treatment Radius", wrvu: 9.49 },
 "25491": { name: "Prophylactic Treatment Ulna", wrvu: 9.90 },
 "25492": { name: "Prophylactic Treatment Radius and ulna", wrvu: 12.34 },
 "25500": { name: "Closed Treatment Rdl Shft Fracture Without Manipulation", wrvu: 2.54 },
 "25505": { name: "Closed Treatment Rdl Shft Fracture With Manipulation", wrvu: 5.31 },
 "25515": { name: "Optx Radical Shaft Fracture", wrvu: 8.58 },
 "25520": { name: "Closed Treatment Rdl Shft Fracture and dislc", wrvu: 6.34 },
 "25525": { name: "Optx Rdl Shft Fracture and Closed Treatment Rad/ul", wrvu: 10.29 },
 "25526": { name: "Optx Rdl Shft Fracture and dstl Rad/ul", wrvu: 12.82 },
 "25530": { name: "Closed Treatment Ulnar Shft Fracture Without Manipulation", wrvu: 2.18 },
 "25535": { name: "Closed Treatment Ulnar Shft Fracture With Manipulation", wrvu: 5.23 },
 "25545": { name: "Optx Ulnar Shft Fracture Int Fixj", wrvu: 7.74 },
 "25560": { name: "Closed Treatment Rdl and Ulnar Shft Fracture without Manipulation", wrvu: 2.53 },
 "25565": { name: "Closed Treatment Rdl and Ulnar Shft Fracture With Manipulation", wrvu: 5.70 },
 "25574": { name: "Optx Rdl and Ulnar Shft Fracture Rds/Ulnar", wrvu: 8.58 },
 "25575": { name: "Optx Rdl and Ulnar Shft Fracture Rds and Ulnar", wrvu: 11.98 },
 "25600": { name: "Closed Treatment Dst Rdl Fracture/ephys Sep Without", wrvu: 2.71 },
 "25605": { name: "Closed Treatment Dst Rdl Fracture/ephys Sep W/", wrvu: 6.09 },
 "25606": { name: "Percutaneous Skel Fixj Dstl Rdl Fracture", wrvu: 8.10 },
 "25607": { name: "Optx Dst Rd Xartc Fracture/epi Sep", wrvu: 9.32 },
 "25608": { name: "Optx Dst Rd Xart Fracture/epi Sep2", wrvu: 10.79 },
 "25609": { name: "Optx Dst Rd Xart Fracture/Electrophysiology Sep3+", wrvu: 14.02 },
 "25622": { name: "Closed Treatment Carpl Scphd Fracture Without Manipulation", wrvu: 2.72 },
 "25624": { name: "Closed Treatment Carpl Scphd Fracture With Manipulation", wrvu: 4.65 },
 "25628": { name: "Optx Carpl Scphd Fracture Int Fixj", wrvu: 9.43 },
 "25630": { name: "Closed Treatment Carpl Fracture Without Manipulation Each Bone", wrvu: 2.95 },
 "25635": { name: "Closed Treatment Carpl Fracture With Manipulation Each Bone", wrvu: 4.49 },
 "25645": { name: "Optx Crpl Fracture Other Than Scph Each", wrvu: 7.23 },
 "25650": { name: "Closed Treatment Ulnar Styloid Fracture", wrvu: 3.15 },
 "25651": { name: "Percutaneous Skel Fix Ulnar Styld Fracture", wrvu: 5.67 },
 "25652": { name: "Optx Ulnar Styloid Fracture", wrvu: 7.86 },
 "25660": { name: "Closed Treatment Rdcrpl/ntrcrpl Dislc 1+", wrvu: 4.86 },
 "25670": { name: "Optx Rdcrpl/ntrcrpl Dislc 1+", wrvu: 7.89 },
 "25671": { name: "Percutaneous Skel Fix Rad/Ulnar Dislc", wrvu: 6.30 },
 "25675": { name: "Closed Treatment Dstl Rad/Ulnar Dislc Manipulation", wrvu: 4.77 },
 "25676": { name: "Optx Rad/Ulnar Dislc Aqt/chrnc", wrvu: 8.08 },
 "25680": { name: "Closed Treatment Trns-scphprlnr Fracture Manipulation", wrvu: 6.07 },
 "25685": { name: "Optx Trns-scphprlnr Fracture Dislc", wrvu: 9.84 },
 "25690": { name: "Closed Treatment Lunate Dislc With Manipulation", wrvu: 5.58 },
 "25695": { name: "Optx Lunate Dislocation", wrvu: 8.30 },
 "25800": { name: "Arthrd Wrist Complete without Grf", wrvu: 9.82 },
 "25805": { name: "Arthrd Wrist With Sliding Graft", wrvu: 11.44 },
 "25810": { name: "Arthrd Wrist Iliac/oth Autograft", wrvu: 11.65 },
 "25820": { name: "Arthrd Wrist Lmtd Without Bone Grf", wrvu: 7.45 },
 "25825": { name: "Arthrd Wrist With Autograft", wrvu: 9.45 },
 "25830": { name: "Arthrd Dst Rad/ul Joint Sgm Rsc", wrvu: 10.61 },
 "25900": { name: "Amputation Of Forearm", wrvu: 9.37 },
 "25905": { name: "Amputation Of Forearm", wrvu: 9.35 },
 "25907": { name: "Amputation Follow-up Surgery", wrvu: 7.89 },
 "25909": { name: "Amputation Follow-up Surgery", wrvu: 9.08 },
 "25915": { name: "Amputation Of Forearm", wrvu: 17.08 },
 "25920": { name: "Amputate Hand At Wrist", wrvu: 8.80 },
 "25922": { name: "Amputate Hand At Wrist", wrvu: 7.46 },
 "25924": { name: "Amputation Follow-up Surgery", wrvu: 8.59 },
 "25927": { name: "Amputation Of Hand", wrvu: 8.86 },
 "25929": { name: "Amputation Follow-up Surgery", wrvu: 7.62 },
 "25931": { name: "Amputation Follow-up Surgery", wrvu: 7.84 },
 "25999": { name: "Unlisted Procedure Forearm/wrist", wrvu: 0.00 },
 "26010": { name: "Drainage Of Finger Abscess", wrvu: 1.55 },
 "26011": { name: "Drainage Of Finger Abscess", wrvu: 2.18 },
 "26020": { name: "Drain Hand Tendon Sheath", wrvu: 6.67 },
 "26025": { name: "Drainage Of Palm Bursa", wrvu: 4.95 },
 "26030": { name: "Drainage Of Palm Bursas", wrvu: 6.09 },
 "26034": { name: "Treat Hand Bone Lesion", wrvu: 6.46 },
 "26035": { name: "Decompress Fingers/hand", wrvu: 11.09 },
 "26037": { name: "Decompress Fingers/hand", wrvu: 7.38 },
 "26040": { name: "Release Palm Contracture", wrvu: 3.37 },
 "26045": { name: "Release Palm Contracture", wrvu: 5.59 },
 "26055": { name: "Incise Finger Tendon Sheath", wrvu: 3.03 },
 "26060": { name: "Incision Of Finger Tendon", wrvu: 2.84 },
 "26070": { name: "Explore/treat Hand Joint", wrvu: 3.71 },
 "26075": { name: "Explore/treat Finger Joint", wrvu: 3.81 },
 "26080": { name: "Explore/treat Finger Joint", wrvu: 4.36 },
 "26100": { name: "Biopsy Hand Joint Lining", wrvu: 3.70 },
 "26105": { name: "Biopsy Finger Joint Lining", wrvu: 3.73 },
 "26110": { name: "Biopsy Finger Joint Lining", wrvu: 3.56 },
 "26111": { name: "Excision Hand Lesion Subcutaneous 1.5 Cm/>", wrvu: 5.28 },
 "26113": { name: "Excision Hand Tumor Deep 1.5 Cm/>", wrvu: 6.95 },
 "26115": { name: "Excision Hand Lesion Subcutaneous < 1.5 Cm", wrvu: 3.86 },
 "26116": { name: "Excision Hand Tumor Deep < 1.5 Cm", wrvu: 6.57 },
 "26117": { name: "Radical Resection Hand Tumor < 3 Cm", wrvu: 9.88 },
 "26118": { name: "Radical Resection Hand Tumor 3 Cm/>", wrvu: 14.44 },
 "26121": { name: "Release Palm Contracture", wrvu: 7.54 },
 "26123": { name: "Release Palm Contracture", wrvu: 10.61 },
 "26125": { name: "Release Palm Contracture", wrvu: 4.49 },
 "26130": { name: "Remove Wrist Joint Lining", wrvu: 5.45 },
 "26135": { name: "Revise Finger Joint Each", wrvu: 6.95 },
 "26140": { name: "Revise Finger Joint Each", wrvu: 6.18 },
 "26145": { name: "Tendon Excision Palm/finger", wrvu: 6.33 },
 "26160": { name: "Remove Tendon Sheath Lesion", wrvu: 3.48 },
 "26170": { name: "Removal Of Palm Tendon Each", wrvu: 4.79 },
 "26180": { name: "Removal Of Finger Tendon", wrvu: 5.22 },
 "26185": { name: "Remove Finger Bone", wrvu: 6.36 },
 "26200": { name: "Remove Hand Bone Lesion", wrvu: 5.51 },
 "26205": { name: "Remove/graft Bone Lesion", wrvu: 7.73 },
 "26210": { name: "Removal Of Finger Lesion", wrvu: 5.19 },
 "26215": { name: "Remove/graft Finger Lesion", wrvu: 7.09 },
 "26230": { name: "Partial Removal Of Hand Bone", wrvu: 6.31 },
 "26235": { name: "Partial Removal Finger Bone", wrvu: 6.17 },
 "26236": { name: "Partial Removal Finger Bone", wrvu: 5.32 },
 "26250": { name: "Extensive Hand Surgery", wrvu: 14.83 },
 "26260": { name: "Resection Proximal Finger Tumor", wrvu: 10.88 },
 "26262": { name: "Resection Distal Finger Tumor", wrvu: 8.08 },
 "26320": { name: "Removal Of Implant From Hand", wrvu: 4.00 },
 "26340": { name: "Manipulate Finger With Anesth", wrvu: 2.73 },
 "26341": { name: "Manipulat Palm Cord Posterior Injection", wrvu: 0.89 },
 "26350": { name: "Repair Finger/hand Tendon", wrvu: 6.05 },
 "26352": { name: "Repair/graft Hand Tendon", wrvu: 7.67 },
 "26356": { name: "Repair Finger/hand Tendon", wrvu: 9.32 },
 "26357": { name: "Repair Finger/hand Tendon", wrvu: 10.73 },
 "26358": { name: "Repair/graft Hand Tendon", wrvu: 12.29 },
 "26370": { name: "Repair Finger/hand Tendon", wrvu: 7.10 },
 "26372": { name: "Repair/graft Hand Tendon", wrvu: 8.78 },
 "26373": { name: "Repair Finger/hand Tendon", wrvu: 8.20 },
 "26390": { name: "Revise Hand/finger Tendon", wrvu: 9.19 },
 "26392": { name: "Repair/graft Hand Tendon", wrvu: 10.24 },
 "26410": { name: "Repair Hand Tendon", wrvu: 4.65 },
 "26412": { name: "Repair/graft Hand Tendon", wrvu: 6.32 },
 "26415": { name: "Excision Hand/finger Tendon", wrvu: 8.30 },
 "26416": { name: "Graft Hand Or Finger Tendon", wrvu: 9.32 },
 "26418": { name: "Repair Finger Tendon", wrvu: 4.36 },
 "26420": { name: "Repair/graft Finger Tendon", wrvu: 6.77 },
 "26426": { name: "Repair Finger/hand Tendon", wrvu: 6.16 },
 "26428": { name: "Repair/graft Finger Tendon", wrvu: 7.22 },
 "26432": { name: "Repair Finger Tendon", wrvu: 4.06 },
 "26433": { name: "Repair Finger Tendon", wrvu: 4.58 },
 "26434": { name: "Repair/graft Finger Tendon", wrvu: 6.10 },
 "26437": { name: "Realignment Of Tendons", wrvu: 5.84 },
 "26440": { name: "Release Palm/finger Tendon", wrvu: 5.03 },
 "26442": { name: "Release Palm & Finger Tendon", wrvu: 9.51 },
 "26445": { name: "Release Hand/finger Tendon", wrvu: 4.34 },
 "26449": { name: "Release Forearm/hand Tendon", wrvu: 8.38 },
 "26450": { name: "Incision Of Palm Tendon", wrvu: 3.70 },
 "26455": { name: "Incision Of Finger Tendon", wrvu: 3.67 },
 "26460": { name: "Incise Hand/finger Tendon", wrvu: 3.49 },
 "26471": { name: "Fusion Of Finger Tendons", wrvu: 5.75 },
 "26474": { name: "Fusion Of Finger Tendons", wrvu: 5.35 },
 "26476": { name: "Tendon Lengthening", wrvu: 5.22 },
 "26477": { name: "Tendon Shortening", wrvu: 5.19 },
 "26478": { name: "Lengthening Of Hand Tendon", wrvu: 5.82 },
 "26479": { name: "Shortening Of Hand Tendon", wrvu: 5.76 },
 "26480": { name: "Transplant Hand Tendon", wrvu: 8.78 },
 "26483": { name: "Transplant/graft Hand Tendon", wrvu: 8.27 },
 "26485": { name: "Transplant Palm Tendon", wrvu: 7.69 },
 "26489": { name: "Transplant/graft Palm Tendon", wrvu: 9.61 },
 "26490": { name: "Revise Thumb Tendon", wrvu: 8.39 },
 "26492": { name: "Tendon Transfer With Graft", wrvu: 9.59 },
 "26494": { name: "Hand Tendon/muscle Transfer", wrvu: 8.44 },
 "26496": { name: "Revise Thumb Tendon", wrvu: 9.54 },
 "26497": { name: "Finger Tendon Transfer", wrvu: 9.52 },
 "26498": { name: "Finger Tendon Transfer", wrvu: 13.85 },
 "26499": { name: "Correction Claw Finger Other", wrvu: 8.94 },
 "26500": { name: "Hand Tendon Reconstruction", wrvu: 5.98 },
 "26502": { name: "Hand Tendon Reconstruction", wrvu: 7.13 },
 "26508": { name: "Release Thumb Contracture", wrvu: 6.03 },
 "26510": { name: "Thumb Tendon Transfer", wrvu: 5.46 },
 "26516": { name: "Fusion Of Knuckle Joint", wrvu: 7.14 },
 "26517": { name: "Fusion Of Knuckle Joints", wrvu: 8.85 },
 "26518": { name: "Fusion Of Knuckle Joints", wrvu: 9.04 },
 "26520": { name: "Release Knuckle Contracture", wrvu: 5.33 },
 "26525": { name: "Release Finger Contracture", wrvu: 5.36 },
 "26530": { name: "Revise Knuckle Joint", wrvu: 6.71 },
 "26531": { name: "Revise Knuckle With Implant", wrvu: 7.93 },
 "26535": { name: "Revise Finger Joint", wrvu: 5.27 },
 "26536": { name: "Revise/implant Finger Joint", wrvu: 6.40 },
 "26540": { name: "Repair Hand Joint", wrvu: 6.44 },
 "26541": { name: "Repair Hand Joint With Graft", wrvu: 8.59 },
 "26542": { name: "Repair Hand Joint With Graft", wrvu: 6.78 },
 "26545": { name: "Reconstruct Finger Joint", wrvu: 6.93 },
 "26546": { name: "Repair Nonunion Hand", wrvu: 10.56 },
 "26548": { name: "Reconstruct Finger Joint", wrvu: 8.01 },
 "26550": { name: "Pollicization Digit", wrvu: 21.14 },
 "26551": { name: "Great Toe-hand Transfer", wrvu: 47.27 },
 "26553": { name: "Single Transfer Toe-hand", wrvu: 46.97 },
 "26554": { name: "Double Transfer Toe-hand", wrvu: 55.58 },
 "26555": { name: "Positional Change Of Finger", wrvu: 16.65 },
 "26556": { name: "Toe Joint Transfer", wrvu: 48.51 },
 "26560": { name: "Repair Of Web Finger", wrvu: 5.38 },
 "26561": { name: "Repair Of Web Finger", wrvu: 10.82 },
 "26562": { name: "Repair Of Web Finger", wrvu: 16.26 },
 "26565": { name: "Correct Metacarpal Flaw", wrvu: 6.74 },
 "26567": { name: "Correct Finger Deformity", wrvu: 6.82 },
 "26568": { name: "Lengthen Metacarpal/finger", wrvu: 9.04 },
 "26580": { name: "Repair Cleft Hand", wrvu: 19.26 },
 "26587": { name: "Reconstruct Extra Finger", wrvu: 14.14 },
 "26590": { name: "Repair Finger Deformity", wrvu: 18.20 },
 "26591": { name: "Repair Muscles Of Hand", wrvu: 3.30 },
 "26593": { name: "Release Muscles Of Hand", wrvu: 5.36 },
 "26596": { name: "Excision Constricting Tissue", wrvu: 8.91 },
 "26600": { name: "Closed Treatment of Metacarpal Fracture, without Manipulation", wrvu: 2.54 },
 "26605": { name: "Closed Treatment of Metacarpal Fracture, with Manipulation", wrvu: 2.95 },
 "26607": { name: "Treat Metacarpal Fracture", wrvu: 5.34 },
 "26608": { name: "Treat Metacarpal Fracture", wrvu: 5.41 },
 "26615": { name: "Treat Metacarpal Fracture", wrvu: 6.89 },
 "26641": { name: "Treat Thumb Dislocation", wrvu: 4.03 },
 "26645": { name: "Treat Thumb Fracture", wrvu: 4.47 },
 "26650": { name: "Treat Thumb Fracture", wrvu: 5.22 },
 "26665": { name: "Treat Thumb Fracture", wrvu: 7.74 },
 "26670": { name: "Treat Hand Dislocation", wrvu: 3.73 },
 "26675": { name: "Treat Hand Dislocation", wrvu: 4.71 },
 "26676": { name: "Pin Hand Dislocation", wrvu: 5.60 },
 "26685": { name: "Treat Hand Dislocation", wrvu: 6.89 },
 "26686": { name: "Treat Hand Dislocation", wrvu: 7.97 },
 "26700": { name: "Treat Knuckle Dislocation", wrvu: 3.73 },
 "26705": { name: "Treat Knuckle Dislocation", wrvu: 4.27 },
 "26706": { name: "Pin Knuckle Dislocation", wrvu: 5.18 },
 "26715": { name: "Treat Knuckle Dislocation", wrvu: 6.85 },
 "26720": { name: "Closed Treatment of Phalangeal Shaft Fracture, without Manipulation", wrvu: 1.72 },
 "26725": { name: "Closed Treatment of Phalangeal Shaft Fracture, with Manipulation", wrvu: 3.39 },
 "26727": { name: "Treat Finger Fracture Each", wrvu: 5.28 },
 "26735": { name: "Treat Finger Fracture Each", wrvu: 7.23 },
 "26740": { name: "Treat Finger Fracture Each", wrvu: 2.02 },
 "26742": { name: "Treat Finger Fracture Each", wrvu: 3.89 },
 "26746": { name: "Treat Finger Fracture Each", wrvu: 9.56 },
 "26750": { name: "Closed Treatment of Distal Phalangeal Fracture, without Manipulation", wrvu: 1.76 },
 "26755": { name: "Closed Treatment of Distal Phalangeal Fracture, with Manipulation", wrvu: 3.15 },
 "26756": { name: "Pin Finger Fracture Each", wrvu: 4.47 },
 "26765": { name: "Treat Finger Fracture Each", wrvu: 5.71 },
 "26770": { name: "Treat Finger Dislocation", wrvu: 3.07 },
 "26775": { name: "Treat Finger Dislocation", wrvu: 3.80 },
 "26776": { name: "Pin Finger Dislocation", wrvu: 4.87 },
 "26785": { name: "Treat Finger Dislocation", wrvu: 6.44 },
 "26820": { name: "Thumb Fusion With Graft", wrvu: 8.24 },
 "26841": { name: "Fusion Of Thumb", wrvu: 7.17 },
 "26842": { name: "Thumb Fusion With Graft", wrvu: 8.28 },
 "26843": { name: "Fusion Of Hand Joint", wrvu: 7.59 },
 "26844": { name: "Fusion/graft Of Hand Joint", wrvu: 8.76 },
 "26850": { name: "Fusion Of Knuckle", wrvu: 6.96 },
 "26852": { name: "Fusion Of Knuckle With Graft", wrvu: 8.49 },
 "26860": { name: "Fusion Of Finger Joint", wrvu: 4.76 },
 "26861": { name: "Fusion Of Finger Jnt Add-on", wrvu: 1.70 },
 "26862": { name: "Fusion/graft Of Finger Joint", wrvu: 7.37 },
 "26863": { name: "Fuse/graft Added Joint", wrvu: 3.79 },
 "26910": { name: "Amputate Metacarpal Bone", wrvu: 7.60 },
 "26951": { name: "Amputation Of Finger/thumb", wrvu: 5.89 },
 "26952": { name: "Amputation Of Finger/thumb", wrvu: 6.32 },
 "26989": { name: "Unlisted Procedure Hands/fingers", wrvu: 0.00 },
 "26990": { name: "Drainage Of Pelvis Lesion", wrvu: 7.75 },
 "26991": { name: "Drainage Of Pelvis Bursa", wrvu: 6.88 },
 "26992": { name: "Drainage Of Bone Lesion", wrvu: 13.14 },
 "27000": { name: "Tenotomy Adductor Hip Percutaneous", wrvu: 5.60 },
 "27001": { name: "Tenotomy Adductor Hip Open", wrvu: 6.96 },
 "27003": { name: "Tnot Adductr Subcutaneous Open Neurct", wrvu: 7.61 },
 "27005": { name: "Tenotomy Hip Flexor Open", wrvu: 9.82 },
 "27006": { name: "Tenotomy Abductor&/xtnsr Hip", wrvu: 9.86 },
 "27025": { name: "Fasciotomy Hip/thigh Any Typ", wrvu: 12.57 },
 "27027": { name: "Dcmprn Fasct Pel Compartment", wrvu: 12.71 },
 "27030": { name: "Arthrotomy Hip With Drainage", wrvu: 13.31 },
 "27033": { name: "Arthrt Hip Expl/Removal Loose/fb", wrvu: 13.76 },
 "27035": { name: "Denervation Of Hip Joint", wrvu: 16.94 },
 "27036": { name: "Capsulectomy/capsulotomy Hip", wrvu: 14.02 },
 "27040": { name: "Biopsy Of Soft Tissues", wrvu: 2.85 },
 "27041": { name: "Biopsy Of Soft Tissues", wrvu: 9.93 },
 "27043": { name: "Excision Hip Pelvis Lesion Subcutaneous 3 Cm/>", wrvu: 6.71 },
 "27045": { name: "Excision Hip/pelv Tumor Deep 5 Cm/>", wrvu: 10.85 },
 "27047": { name: "Excision Hip/pelvis Lesion Subcutaneous < 3 Cm", wrvu: 4.82 },
 "27048": { name: "Excision Hip/pelv Tumor Deep < 5 Cm", wrvu: 8.63 },
 "27049": { name: "Resection Hip/pelv Tumor < 5 Cm", wrvu: 21.01 },
 "27050": { name: "Biopsy Of Sacroiliac Joint", wrvu: 4.62 },
 "27052": { name: "Biopsy Of Hip Joint", wrvu: 7.23 },
 "27054": { name: "Removal Of Hip Joint Lining", wrvu: 8.98 },
 "27057": { name: "Buttock Fasciotomy With Dbrdmt", wrvu: 14.54 },
 "27059": { name: "Resection Hip/pelv Tumor 5 Cm/>", wrvu: 28.62 },
 "27060": { name: "Removal Of Ischial Bursa", wrvu: 5.72 },
 "27062": { name: "Remove Femur Lesion/bursa", wrvu: 5.61 },
 "27065": { name: "Remove Hip Bone Lesion Super", wrvu: 6.39 },
 "27066": { name: "Remove Hip Bone Lesion Deep", wrvu: 10.92 },
 "27067": { name: "Remove/graft Hip Bone Lesion", wrvu: 14.35 },
 "27070": { name: "Part Remove Hip Bone Super", wrvu: 11.27 },
 "27071": { name: "Part Removal Hip Bone Deep", wrvu: 12.08 },
 "27075": { name: "Resection Hip Tumor", wrvu: 31.89 },
 "27076": { name: "Resection Hip Tumor Incl Acetabul", wrvu: 39.20 },
 "27077": { name: "Resection Hip Tumor With Innom Bone", wrvu: 44.08 },
 "27078": { name: "Rsect Hip Tumor Incl Femur", wrvu: 31.40 },
 "27080": { name: "Removal Of Tail Bone", wrvu: 6.72 },
 "27086": { name: "Remove Hip Foreign Body", wrvu: 1.87 },
 "27087": { name: "Remove Hip Foreign Body", wrvu: 8.61 },
 "27090": { name: "Removal Of Hip Prosthesis", wrvu: 11.40 },
 "27091": { name: "Removal Of Hip Prosthesis", wrvu: 23.74 },
 "27093": { name: "Injection For Hip X-ray", wrvu: 1.27 },
 "27095": { name: "Injection For Hip X-ray", wrvu: 1.46 },
 "27096": { name: "Inject Sacroiliac Joint", wrvu: 1.44 },
 "27097": { name: "Revision Of Hip Tendon", wrvu: 9.04 },
 "27098": { name: "Transfer Tendon To Pelvis", wrvu: 9.09 },
 "27100": { name: "Transfer Of Abdominal Muscle", wrvu: 11.07 },
 "27105": { name: "Transfer Of Spinal Muscle", wrvu: 11.74 },
 "27110": { name: "Transfer Of Iliopsoas Muscle", wrvu: 13.43 },
 "27111": { name: "Transfer Of Iliopsoas Muscle", wrvu: 12.29 },
 "27120": { name: "Reconstruction Of Hip Socket", wrvu: 18.77 },
 "27122": { name: "Reconstruction Of Hip Socket", wrvu: 15.69 },
 "27125": { name: "Partial Hip Replacement", wrvu: 16.22 },
 "27130": { name: "Total Hip Arthroplasty", wrvu: 19.11 },
 "27132": { name: "Total Hip Arthroplasty", wrvu: 25.05 },
 "27134": { name: "Revise Hip Joint Replacement", wrvu: 29.52 },
 "27137": { name: "Revise Hip Joint Replacement", wrvu: 22.13 },
 "27138": { name: "Revise Hip Joint Replacement", wrvu: 23.11 },
 "27140": { name: "Transplant Femur Ridge", wrvu: 12.46 },
 "27146": { name: "Incision Of Hip Bone", wrvu: 18.45 },
 "27147": { name: "Revision Of Hip Bone", wrvu: 21.52 },
 "27151": { name: "Incision Of Hip Bones", wrvu: 23.52 },
 "27156": { name: "Revision Of Hip Bones", wrvu: 25.57 },
 "27158": { name: "Revision Of Pelvis", wrvu: 20.51 },
 "27161": { name: "Incision Of Neck Of Femur", wrvu: 17.44 },
 "27165": { name: "Incision/fixation Of Femur", wrvu: 19.78 },
 "27170": { name: "Repair/graft Femur Head/neck", wrvu: 17.17 },
 "27175": { name: "Treat Slipped Epiphysis", wrvu: 9.15 },
 "27176": { name: "Treat Slipped Epiphysis", wrvu: 12.60 },
 "27177": { name: "Treat Slipped Epiphysis", wrvu: 15.69 },
 "27178": { name: "Treat Slipped Epiphysis", wrvu: 12.60 },
 "27179": { name: "Revise Head/neck Of Femur", wrvu: 13.62 },
 "27181": { name: "Treat Slipped Epiphysis", wrvu: 15.78 },
 "27185": { name: "Revision Of Femur Epiphysis", wrvu: 9.55 },
 "27187": { name: "Reinforce Hip Bones", wrvu: 13.87 },
 "27197": { name: "Closed Treatment Pelvic Ring Fracture", wrvu: 1.49 },
 "27198": { name: "Closed Treatment Pelvic Ring Fracture", wrvu: 4.63 },
 "27200": { name: "Treat Tail Bone Fracture", wrvu: 1.87 },
 "27202": { name: "Treat Tail Bone Fracture", wrvu: 7.13 },
 "27215": { name: "Treat Pelvic Fracture(s)", wrvu: 10.19 },
 "27216": { name: "Treat Pelvic Ring Fracture", wrvu: 15.34 },
 "27217": { name: "Treat Pelvic Ring Fracture", wrvu: 14.28 },
 "27218": { name: "Treat Pelvic Ring Fracture", wrvu: 20.41 },
 "27220": { name: "Treat Hip Socket Fracture", wrvu: 5.36 },
 "27222": { name: "Treat Hip Socket Fracture", wrvu: 13.76 },
 "27226": { name: "Treat Hip Wall Fracture", wrvu: 15.18 },
 "27227": { name: "Treat Hip Fracture(s)", wrvu: 24.77 },
 "27228": { name: "Treat Hip Fracture(s)", wrvu: 28.60 },
 "27230": { name: "Treat Thigh Fracture", wrvu: 5.66 },
 "27232": { name: "Treat Thigh Fracture", wrvu: 11.43 },
 "27235": { name: "Treat Thigh Fracture", wrvu: 12.68 },
 "27236": { name: "Treat Thigh Fracture", wrvu: 17.17 },
 "27238": { name: "Treat Thigh Fracture", wrvu: 5.61 },
 "27240": { name: "Treat Thigh Fracture", wrvu: 13.46 },
 "27244": { name: "Treat Thigh Fracture", wrvu: 17.73 },
 "27245": { name: "Treat Thigh Fracture", wrvu: 17.73 },
 "27246": { name: "Treat Thigh Fracture", wrvu: 4.71 },
 "27248": { name: "Treat Thigh Fracture", wrvu: 10.51 },
 "27250": { name: "Treat Hip Dislocation", wrvu: 3.72 },
 "27252": { name: "Treat Hip Dislocation", wrvu: 10.75 },
 "27253": { name: "Treat Hip Dislocation", wrvu: 13.24 },
 "27254": { name: "Treat Hip Dislocation", wrvu: 18.47 },
 "27256": { name: "Treat Hip Dislocation", wrvu: 4.17 },
 "27257": { name: "Treat Hip Dislocation", wrvu: 5.25 },
 "27258": { name: "Treat Hip Dislocation", wrvu: 15.78 },
 "27259": { name: "Treat Hip Dislocation", wrvu: 22.68 },
 "27265": { name: "Treat Hip Dislocation", wrvu: 5.11 },
 "27266": { name: "Treat Hip Dislocation", wrvu: 7.59 },
 "27267": { name: "Closed Treatment Thigh Fracture", wrvu: 5.36 },
 "27268": { name: "Closed Treatment Thigh Fracture With Manipulation", wrvu: 6.94 },
 "27269": { name: "Optx Thigh Fracture", wrvu: 18.42 },
 "27275": { name: "Manipulation Of Hip Joint", wrvu: 2.26 },
 "27278": { name: "Arthrd Si Joint Placement Iartic Device", wrvu: 7.66 },
 "27279": { name: "Arthrd Si Joint Placement Tartclr Dv", wrvu: 11.83 },
 "27280": { name: "Arthr Si Joint Open B1grf Instrm", wrvu: 19.50 },
 "27282": { name: "Arthrodesis Symphysis Pubis", wrvu: 11.55 },
 "27284": { name: "Arthrodesis Hip Joint", wrvu: 24.43 },
 "27286": { name: "Arthrd Hip Joint Sbtrchc Osteot", wrvu: 24.54 },
 "27290": { name: "Amputation Of Leg At Hip", wrvu: 23.94 },
 "27295": { name: "Amputation Of Leg At Hip", wrvu: 19.17 },
 "27299": { name: "Unlisted Procedure Pelvis/hip Joint", wrvu: 0.00 },
 "27301": { name: "Drain Thigh/knee Lesion", wrvu: 6.61 },
 "27303": { name: "Drainage Of Bone Lesion", wrvu: 8.41 },
 "27305": { name: "Incise Thigh Tendon & Fascia", wrvu: 6.03 },
 "27306": { name: "Incision Of Thigh Tendon", wrvu: 4.62 },
 "27307": { name: "Incision Of Thigh Tendons", wrvu: 5.91 },
 "27310": { name: "Exploration Of Knee Joint", wrvu: 9.75 },
 "27323": { name: "Biopsy Thigh Soft Tissues", wrvu: 2.27 },
 "27324": { name: "Biopsy Thigh Soft Tissues", wrvu: 4.91 },
 "27325": { name: "Neurectomy Hamstring", wrvu: 7.02 },
 "27326": { name: "Neurectomy Popliteal", wrvu: 6.31 },
 "27327": { name: "Excision Thigh/knee Lesion Subcutaneous < 3 Cm", wrvu: 3.86 },
 "27328": { name: "Excision Thigh/knee Tumor Deep <5cm", wrvu: 8.63 },
 "27329": { name: "Resection Thigh/knee Tumor < 5 Cm", wrvu: 15.33 },
 "27330": { name: "Biopsy Knee Joint Lining", wrvu: 4.98 },
 "27331": { name: "Explore/treat Knee Joint", wrvu: 5.87 },
 "27332": { name: "Removal Of Knee Cartilage", wrvu: 8.25 },
 "27333": { name: "Removal Of Knee Cartilage", wrvu: 7.36 },
 "27334": { name: "Remove Knee Joint Lining", wrvu: 8.96 },
 "27335": { name: "Remove Knee Joint Lining", wrvu: 10.29 },
 "27337": { name: "Excision Thigh/knee Lesion Subcutaneous 3 Cm/>", wrvu: 5.76 },
 "27339": { name: "Excision Thigh/knee Tumor Dilatation and Evacuation Procedure 5cm/>", wrvu: 10.85 },
 "27340": { name: "Removal Of Kneecap Bursa", wrvu: 4.21 },
 "27345": { name: "Removal Of Knee Cyst", wrvu: 5.94 },
 "27347": { name: "Remove Knee Cyst", wrvu: 6.56 },
 "27350": { name: "Removal Of Kneecap", wrvu: 8.44 },
 "27355": { name: "Remove Femur Lesion", wrvu: 7.80 },
 "27356": { name: "Remove Femur Lesion/graft", wrvu: 9.84 },
 "27357": { name: "Remove Femur Lesion/graft", wrvu: 10.88 },
 "27358": { name: "Remove Femur Lesion/fixation", wrvu: 4.61 },
 "27360": { name: "Partial Removal Leg Bone(s)", wrvu: 11.17 },
 "27364": { name: "Resection Thigh/knee Tumor 5 Cm/>", wrvu: 23.88 },
 "27365": { name: "Resection Femur/knee Tumor", wrvu: 31.40 },
 "27369": { name: "Injection Contrast Knee Arthg/ct/mri", wrvu: 0.75 },
 "27372": { name: "Removal Of Foreign Body", wrvu: 5.08 },
 "27380": { name: "Repair Of Kneecap Tendon", wrvu: 7.26 },
 "27381": { name: "Repair/graft Kneecap Tendon", wrvu: 10.49 },
 "27385": { name: "Repair Of Thigh Muscle", wrvu: 6.76 },
 "27386": { name: "Repair/graft Of Thigh Muscle", wrvu: 10.85 },
 "27390": { name: "Incision Of Thigh Tendon", wrvu: 5.39 },
 "27391": { name: "Incision Of Thigh Tendons", wrvu: 7.30 },
 "27392": { name: "Incision Of Thigh Tendons", wrvu: 9.39 },
 "27393": { name: "Lengthening Of Thigh Tendon", wrvu: 6.43 },
 "27394": { name: "Lengthening Of Thigh Tendons", wrvu: 8.57 },
 "27395": { name: "Lengthening Of Thigh Tendons", wrvu: 11.93 },
 "27396": { name: "Transplant Of Thigh Tendon", wrvu: 7.95 },
 "27397": { name: "Transplants Of Thigh Tendons", wrvu: 12.34 },
 "27400": { name: "Revise Thigh Muscles/tendons", wrvu: 9.10 },
 "27403": { name: "Repair Of Knee Cartilage", wrvu: 8.40 },
 "27405": { name: "Repair Of Knee Ligation", wrvu: 8.85 },
 "27407": { name: "Repair Of Knee Ligation", wrvu: 10.58 },
 "27409": { name: "Repair Of Knee Ligaments", wrvu: 13.37 },
 "27412": { name: "Autochondrocyte Implant Knee", wrvu: 24.12 },
 "27415": { name: "Osteochondral Knee Allograft", wrvu: 19.50 },
 "27416": { name: "Osteochondral Knee Autograft", wrvu: 13.81 },
 "27418": { name: "Repair Degenerated Kneecap", wrvu: 11.31 },
 "27420": { name: "Revision Of Unstable Kneecap", wrvu: 10.00 },
 "27422": { name: "Revision Of Unstable Kneecap", wrvu: 9.95 },
 "27424": { name: "Revision/removal Of Kneecap", wrvu: 9.98 },
 "27425": { name: "Lateral Retinacular Release Open", wrvu: 5.26 },
 "27427": { name: "Reconstruction Knee", wrvu: 9.55 },
 "27428": { name: "Reconstruction Knee", wrvu: 15.19 },
 "27429": { name: "Reconstruction Knee", wrvu: 17.10 },
 "27430": { name: "Revision Of Thigh Muscles", wrvu: 9.91 },
 "27435": { name: "Incision Of Knee Joint", wrvu: 10.61 },
 "27437": { name: "Revise Kneecap", wrvu: 8.71 },
 "27438": { name: "Revise Kneecap With Implant", wrvu: 11.59 },
 "27440": { name: "Revision Of Knee Joint", wrvu: 10.81 },
 "27441": { name: "Revision Of Knee Joint", wrvu: 11.25 },
 "27442": { name: "Revision Of Knee Joint", wrvu: 12.06 },
 "27443": { name: "Revision Of Knee Joint", wrvu: 11.12 },
 "27446": { name: "Revision Of Knee Joint", wrvu: 16.70 },
 "27447": { name: "Total Knee Arthroplasty", wrvu: 19.11 },
 "27448": { name: "Incision Of Thigh", wrvu: 11.31 },
 "27450": { name: "Incision Of Thigh", wrvu: 14.24 },
 "27454": { name: "Realignment Of Thigh Bone", wrvu: 18.69 },
 "27455": { name: "Realignment Of Knee", wrvu: 13.03 },
 "27457": { name: "Realignment Of Knee", wrvu: 13.68 },
 "27458": { name: "Osteot Femur Imed Lngth Device", wrvu: 26.65 },
 "27465": { name: "Shortening Of Thigh Bone", wrvu: 20.60 },
 "27466": { name: "Lengthening Of Thigh Bone", wrvu: 22.08 },
 "27470": { name: "Repair Of Thigh", wrvu: 16.71 },
 "27472": { name: "Repair/graft Of Thigh", wrvu: 18.25 },
 "27475": { name: "Surgery To Stop Leg Growth", wrvu: 8.71 },
 "27477": { name: "Surgery To Stop Leg Growth", wrvu: 9.89 },
 "27479": { name: "Surgery To Stop Leg Growth", wrvu: 12.83 },
 "27485": { name: "Surgery To Stop Leg Growth", wrvu: 8.90 },
 "27486": { name: "Revise/replace Knee Joint", wrvu: 20.59 },
 "27487": { name: "Revise/replace Knee Joint", wrvu: 26.43 },
 "27488": { name: "Removal Of Knee Prosthesis", wrvu: 17.16 },
 "27495": { name: "Reinforce Thigh", wrvu: 16.13 },
 "27496": { name: "Decompression Of Thigh/knee", wrvu: 6.61 },
 "27497": { name: "Decompression Of Thigh/knee", wrvu: 7.60 },
 "27498": { name: "Decompression Of Thigh/knee", wrvu: 8.44 },
 "27499": { name: "Decompression Of Thigh/knee", wrvu: 9.19 },
 "27500": { name: "Treatment Of Thigh Fracture", wrvu: 6.14 },
 "27501": { name: "Treatment Of Thigh Fracture", wrvu: 6.29 },
 "27502": { name: "Treatment Of Thigh Fracture", wrvu: 11.08 },
 "27503": { name: "Treatment Of Thigh Fracture", wrvu: 10.99 },
 "27506": { name: "Treatment Of Thigh Fracture", wrvu: 19.16 },
 "27507": { name: "Treatment Of Thigh Fracture", wrvu: 14.12 },
 "27508": { name: "Treatment Of Thigh Fracture", wrvu: 6.05 },
 "27509": { name: "Treatment Of Thigh Fracture", wrvu: 7.94 },
 "27510": { name: "Treatment Of Thigh Fracture", wrvu: 9.56 },
 "27511": { name: "Treatment Of Thigh Fracture", wrvu: 14.73 },
 "27513": { name: "Treatment Of Thigh Fracture", wrvu: 18.77 },
 "27514": { name: "Treatment Of Thigh Fracture", wrvu: 14.24 },
 "27516": { name: "Treat Thigh Fracture Growth Plate", wrvu: 5.45 },
 "27517": { name: "Treat Thigh Fracture Growth Plate", wrvu: 8.89 },
 "27519": { name: "Treat Thigh Fracture Growth Plate", wrvu: 12.92 },
 "27520": { name: "Treat Kneecap Fracture", wrvu: 2.96 },
 "27524": { name: "Treat Kneecap Fracture", wrvu: 10.11 },
 "27530": { name: "Treat Knee Fracture", wrvu: 2.58 },
 "27532": { name: "Treat Knee Fracture", wrvu: 7.36 },
 "27535": { name: "Treat Knee Fracture", wrvu: 13.07 },
 "27536": { name: "Treat Knee Fracture", wrvu: 16.96 },
 "27538": { name: "Treat Knee Fracture(s)", wrvu: 4.96 },
 "27540": { name: "Treat Knee Fracture", wrvu: 11.02 },
 "27550": { name: "Treat Knee Dislocation", wrvu: 5.83 },
 "27552": { name: "Treat Knee Dislocation", wrvu: 7.98 },
 "27556": { name: "Treat Knee Dislocation", wrvu: 12.68 },
 "27557": { name: "Treat Knee Dislocation", wrvu: 15.50 },
 "27558": { name: "Treat Knee Dislocation", wrvu: 17.93 },
 "27560": { name: "Treat Kneecap Dislocation", wrvu: 3.89 },
 "27562": { name: "Treat Kneecap Dislocation", wrvu: 5.83 },
 "27566": { name: "Treat Kneecap Dislocation", wrvu: 12.39 },
 "27570": { name: "Fixation Of Knee Joint", wrvu: 1.75 },
 "27580": { name: "Fusion Of Knee", wrvu: 20.57 },
 "27590": { name: "Amputate Leg At Thigh", wrvu: 13.13 },
 "27591": { name: "Amputate Leg At Thigh", wrvu: 13.59 },
 "27592": { name: "Amputate Leg At Thigh", wrvu: 10.71 },
 "27594": { name: "Amputation Follow-up Surgery", wrvu: 7.11 },
 "27596": { name: "Amputation Follow-up Surgery", wrvu: 11.01 },
 "27598": { name: "Amputate Lower Leg At Knee", wrvu: 10.94 },
 "27599": { name: "Unlisted Procedure Femur/knee", wrvu: 0.00 },
 "27600": { name: "Decompression Of Lower Leg", wrvu: 5.88 },
 "27601": { name: "Decompression Of Lower Leg", wrvu: 5.90 },
 "27602": { name: "Decompression Of Lower Leg", wrvu: 7.62 },
 "27603": { name: "Drain Lower Leg Lesion", wrvu: 5.10 },
 "27604": { name: "Drain Lower Leg Bursa", wrvu: 4.48 },
 "27605": { name: "Incision Of Achilles Tendon", wrvu: 2.85 },
 "27606": { name: "Incision Of Achilles Tendon", wrvu: 4.08 },
 "27607": { name: "Treat Lower Leg Bone Lesion", wrvu: 8.40 },
 "27610": { name: "Explore/treat Ankle Joint", wrvu: 8.90 },
 "27612": { name: "Exploration Of Ankle Joint", wrvu: 7.95 },
 "27613": { name: "Biopsy Lower Leg Soft Tissue", wrvu: 2.16 },
 "27614": { name: "Biopsy Lower Leg Soft Tissue", wrvu: 5.66 },
 "27615": { name: "Resection Leg/ankle Tumor < 5 Cm", wrvu: 15.33 },
 "27616": { name: "Resection Leg/ankle Tumor 5 Cm/>", wrvu: 19.14 },
 "27618": { name: "Excision Leg/ankle Tumor < 3 Cm", wrvu: 3.86 },
 "27619": { name: "Excision Leg/ankle Tumor Deep <5 Cm", wrvu: 6.74 },
 "27620": { name: "Explore/treat Ankle Joint", wrvu: 6.00 },
 "27625": { name: "Remove Ankle Joint Lining", wrvu: 8.28 },
 "27626": { name: "Remove Ankle Joint Lining", wrvu: 8.87 },
 "27630": { name: "Removal Of Tendon Lesion", wrvu: 4.82 },
 "27632": { name: "Excision Leg/ankle Lesion Subcutaneous 3 Cm/>", wrvu: 5.76 },
 "27634": { name: "Excision Leg/ankle Tumor Dilatation and Evacuation Procedure 5 Cm/>", wrvu: 9.88 },
 "27635": { name: "Remove Lower Leg Bone Lesion", wrvu: 7.83 },
 "27637": { name: "Remove/graft Leg Bone Lesion", wrvu: 10.05 },
 "27638": { name: "Remove/graft Leg Bone Lesion", wrvu: 10.72 },
 "27640": { name: "Partial Removal Of Tibia", wrvu: 11.93 },
 "27641": { name: "Partial Removal Of Fibula", wrvu: 9.59 },
 "27645": { name: "Resection Tibia Tumor", wrvu: 26.53 },
 "27646": { name: "Resection Fibula Tumor", wrvu: 22.63 },
 "27647": { name: "Resection Talus/calcaneus Tumor", wrvu: 19.75 },
 "27648": { name: "Injection For Ankle X-ray", wrvu: 0.94 },
 "27650": { name: "Repair Achilles Tendon", wrvu: 8.98 },
 "27652": { name: "Repair/graft Achilles Tendon", wrvu: 10.51 },
 "27654": { name: "Repair Of Achilles Tendon", wrvu: 10.27 },
 "27656": { name: "Repair Leg Fascia Defect", wrvu: 4.59 },
 "27658": { name: "Repair Of Leg Tendon Each", wrvu: 4.99 },
 "27659": { name: "Repair Of Leg Tendon Each", wrvu: 6.92 },
 "27664": { name: "Repair Of Leg Tendon Each", wrvu: 4.61 },
 "27665": { name: "Repair Of Leg Tendon Each", wrvu: 5.43 },
 "27675": { name: "Repair Lower Leg Tendons", wrvu: 7.17 },
 "27676": { name: "Repair Lower Leg Tendons", wrvu: 8.51 },
 "27680": { name: "Release Of Lower Leg Tendon", wrvu: 5.73 },
 "27681": { name: "Release Of Lower Leg Tendons", wrvu: 6.87 },
 "27685": { name: "Revision Of Lower Leg Tendon", wrvu: 6.52 },
 "27686": { name: "Revise Lower Leg Tendons", wrvu: 7.56 },
 "27687": { name: "Revision Of Calf Tendon", wrvu: 6.25 },
 "27690": { name: "Revise Lower Leg Tendon", wrvu: 8.94 },
 "27691": { name: "Revise Lower Leg Tendon", wrvu: 10.23 },
 "27692": { name: "Revise Additional Leg Tendon", wrvu: 1.82 },
 "27695": { name: "Repair Of Ankle Ligation", wrvu: 6.53 },
 "27696": { name: "Repair Of Ankle Ligaments", wrvu: 8.37 },
 "27698": { name: "Repair Of Ankle Ligation", wrvu: 9.37 },
 "27700": { name: "Revision Of Ankle Joint", wrvu: 9.42 },
 "27702": { name: "Reconstruct Ankle Joint", wrvu: 14.06 },
 "27703": { name: "Reconstruction Ankle Joint", wrvu: 16.52 },
 "27704": { name: "Removal Of Ankle Implant", wrvu: 7.61 },
 "27705": { name: "Osteotomy Tibia", wrvu: 10.59 },
 "27707": { name: "Osteotomy Fibula", wrvu: 4.66 },
 "27709": { name: "Osteotomy Tibia & Fibula", wrvu: 17.04 },
 "27712": { name: "Osteot Mlt Relignmt Imed Rod", wrvu: 15.47 },
 "27713": { name: "Osteot Tibia Imed Lngth Device", wrvu: 28.00 },
 "27715": { name: "Ostpl Tibfib Lngth/shrt", wrvu: 21.94 },
 "27720": { name: "Repair Of Tibia", wrvu: 12.05 },
 "27722": { name: "Repair/graft Of Tibia", wrvu: 12.14 },
 "27724": { name: "Repair/graft Of Tibia", wrvu: 18.83 },
 "27725": { name: "Repair Of Lower Leg", wrvu: 16.97 },
 "27726": { name: "Repair Fibula Nonunion", wrvu: 13.98 },
 "27727": { name: "Repair Of Lower Leg", wrvu: 14.47 },
 "27730": { name: "Repair Of Tibia Epiphysis", wrvu: 7.51 },
 "27732": { name: "Repair Of Fibula Epiphysis", wrvu: 5.32 },
 "27734": { name: "Repair Lower Leg Epiphyses", wrvu: 8.61 },
 "27740": { name: "Repair Of Leg Epiphyses", wrvu: 9.37 },
 "27742": { name: "Repair Of Leg Epiphyses", wrvu: 10.36 },
 "27745": { name: "Reinforce Tibia", wrvu: 10.23 },
 "27750": { name: "Treatment Of Tibia Fracture", wrvu: 3.29 },
 "27752": { name: "Treatment Of Tibia Fracture", wrvu: 6.11 },
 "27756": { name: "Treatment Of Tibia Fracture", wrvu: 7.26 },
 "27758": { name: "Treatment Of Tibia Fracture", wrvu: 12.23 },
 "27759": { name: "Treatment Of Tibia Fracture", wrvu: 14.09 },
 "27760": { name: "Closed Treatment Medial Ankle Fracture", wrvu: 3.13 },
 "27762": { name: "Closed Treatment Medial Ankle Fracture With Manipulation", wrvu: 5.33 },
 "27766": { name: "Optx Medial Ankle Fracture", wrvu: 7.69 },
 "27767": { name: "Closed Treatment Posterior Ankle Fracture", wrvu: 2.57 },
 "27768": { name: "Closed Treatment Posterior Ankle Fracture With Manipulation", wrvu: 5.01 },
 "27769": { name: "Optx Posterior Ankle Fracture", wrvu: 9.89 },
 "27780": { name: "Treatment Of Fibula Fracture", wrvu: 2.76 },
 "27781": { name: "Treatment Of Fibula Fracture", wrvu: 4.48 },
 "27784": { name: "Treatment Of Fibula Fracture", wrvu: 9.43 },
 "27786": { name: "Treatment Of Ankle Fracture", wrvu: 2.94 },
 "27788": { name: "Treatment Of Ankle Fracture", wrvu: 4.52 },
 "27792": { name: "Treatment Of Ankle Fracture", wrvu: 8.53 },
 "27808": { name: "Treatment Of Ankle Fracture", wrvu: 2.95 },
 "27810": { name: "Treatment Of Ankle Fracture", wrvu: 5.19 },
 "27814": { name: "Treatment Of Ankle Fracture", wrvu: 10.35 },
 "27816": { name: "Treatment Of Ankle Fracture", wrvu: 2.99 },
 "27818": { name: "Treatment Of Ankle Fracture", wrvu: 5.55 },
 "27822": { name: "Treatment Of Ankle Fracture", wrvu: 10.93 },
 "27823": { name: "Treatment Of Ankle Fracture", wrvu: 12.83 },
 "27824": { name: "Treat Lower Leg Fracture", wrvu: 3.23 },
 "27825": { name: "Treat Lower Leg Fracture", wrvu: 6.52 },
 "27826": { name: "Treat Lower Leg Fracture", wrvu: 10.82 },
 "27827": { name: "Treat Lower Leg Fracture", wrvu: 14.42 },
 "27828": { name: "Treat Lower Leg Fracture", wrvu: 17.97 },
 "27829": { name: "Treat Lower Leg Joint", wrvu: 8.58 },
 "27830": { name: "Treat Lower Leg Dislocation", wrvu: 3.86 },
 "27831": { name: "Treat Lower Leg Dislocation", wrvu: 4.61 },
 "27832": { name: "Treat Lower Leg Dislocation", wrvu: 9.92 },
 "27840": { name: "Treat Ankle Dislocation", wrvu: 4.65 },
 "27842": { name: "Treat Ankle Dislocation", wrvu: 6.30 },
 "27846": { name: "Treat Ankle Dislocation", wrvu: 10.02 },
 "27848": { name: "Treat Ankle Dislocation", wrvu: 11.39 },
 "27860": { name: "Fixation Of Ankle Joint", wrvu: 2.33 },
 "27870": { name: "Fusion Of Ankle Joint Open", wrvu: 15.02 },
 "27871": { name: "Fusion Of Tibiofibular Joint", wrvu: 9.30 },
 "27880": { name: "Amputation Of Lower Leg", wrvu: 14.99 },
 "27881": { name: "Amputation Of Lower Leg", wrvu: 13.13 },
 "27882": { name: "Amputation Of Lower Leg", wrvu: 9.55 },
 "27884": { name: "Amputation Follow-up Surgery", wrvu: 8.54 },
 "27886": { name: "Amputation Follow-up Surgery", wrvu: 9.77 },
 "27888": { name: "Amputation Of Foot At Ankle", wrvu: 10.11 },
 "27889": { name: "Ankle Disarticulation", wrvu: 10.59 },
 "27892": { name: "Decompression Of Leg", wrvu: 7.74 },
 "27893": { name: "Decompression Of Leg", wrvu: 7.70 },
 "27894": { name: "Decompression Of Leg", wrvu: 12.35 },
 "27899": { name: "Unlisted Procedure Leg/ankle", wrvu: 0.00 },
 "28001": { name: "Drainage Of Bursa Of Foot", wrvu: 1.95 },
 "28002": { name: "Treatment Of Foot Infection", wrvu: 2.72 },
 "28003": { name: "Treatment Of Foot Infection", wrvu: 5.15 },
 "28005": { name: "Treat Foot Bone Lesion", wrvu: 9.20 },
 "28008": { name: "Incision Of Foot Fascia", wrvu: 4.48 },
 "28010": { name: "Incision Of Toe Tendon", wrvu: 2.90 },
 "28011": { name: "Incision Of Toe Tendons", wrvu: 4.17 },
 "28020": { name: "Exploration Of Foot Joint", wrvu: 5.02 },
 "28022": { name: "Exploration Of Foot Joint", wrvu: 4.69 },
 "28024": { name: "Exploration Of Toe Joint", wrvu: 4.41 },
 "28035": { name: "Decompression Of Tibia Nerve", wrvu: 5.10 },
 "28039": { name: "Excision Foot/toe Tumor Subcutaneous 1.5 Cm/>", wrvu: 5.28 },
 "28041": { name: "Excision Foot/toe Tumor Dilatation and Evacuation Procedure 1.5cm/>", wrvu: 6.95 },
 "28043": { name: "Excision Foot/toe Tumor Subcutaneous < 1.5 Cm", wrvu: 3.86 },
 "28045": { name: "Excision Foot/toe Tumor Deep <1.5cm", wrvu: 5.31 },
 "28046": { name: "Resection Foot/toe Tumor < 3 Cm", wrvu: 12.07 },
 "28047": { name: "Resection Foot/toe Tumor 3 Cm/>", wrvu: 17.01 },
 "28050": { name: "Biopsy Of Foot Joint Lining", wrvu: 4.28 },
 "28052": { name: "Biopsy Of Foot Joint Lining", wrvu: 3.96 },
 "28054": { name: "Biopsy Of Toe Joint Lining", wrvu: 3.48 },
 "28055": { name: "Neurectomy Foot", wrvu: 6.13 },
 "28060": { name: "Partial Removal Foot Fascia", wrvu: 5.27 },
 "28062": { name: "Removal Of Foot Fascia", wrvu: 6.52 },
 "28070": { name: "Removal Of Foot Joint Lining", wrvu: 5.11 },
 "28072": { name: "Removal Of Foot Joint Lining", wrvu: 4.60 },
 "28080": { name: "Removal Of Foot Lesion", wrvu: 4.74 },
 "28086": { name: "Excise Foot Tendon Sheath", wrvu: 4.80 },
 "28088": { name: "Excise Foot Tendon Sheath", wrvu: 3.88 },
 "28090": { name: "Removal Of Foot Lesion", wrvu: 4.44 },
 "28092": { name: "Removal Of Toe Lesions", wrvu: 3.69 },
 "28100": { name: "Removal Of Ankle/Heel Lesion", wrvu: 5.68 },
 "28102": { name: "Remove/graft Foot Lesion", wrvu: 7.72 },
 "28103": { name: "Remove/graft Foot Lesion", wrvu: 6.50 },
 "28104": { name: "Removal Of Foot Lesion", wrvu: 5.13 },
 "28106": { name: "Remove/graft Foot Lesion", wrvu: 7.17 },
 "28107": { name: "Remove/graft Foot Lesion", wrvu: 5.59 },
 "28108": { name: "Removal Of Toe Lesions", wrvu: 4.19 },
 "28110": { name: "Part Removal Of Metatarsal", wrvu: 4.11 },
 "28111": { name: "Part Removal Of Metatarsal", wrvu: 5.02 },
 "28112": { name: "Part Removal Of Metatarsal", wrvu: 4.51 },
 "28113": { name: "Part Removal Of Metatarsal", wrvu: 5.96 },
 "28114": { name: "Removal Of Metatarsal Heads", wrvu: 11.70 },
 "28116": { name: "Revision Of Foot", wrvu: 8.91 },
 "28118": { name: "Removal Of Heel Bone", wrvu: 5.98 },
 "28119": { name: "Removal Of Heel Spur", wrvu: 5.42 },
 "28120": { name: "Part Removal Of Ankle/Heel", wrvu: 7.13 },
 "28122": { name: "Partial Removal Of Foot Bone", wrvu: 6.59 },
 "28124": { name: "Partial Removal Of Toe", wrvu: 4.88 },
 "28126": { name: "Partial Removal Of Toe", wrvu: 3.55 },
 "28130": { name: "Removal Of Ankle Bone", wrvu: 9.26 },
 "28140": { name: "Removal Of Metatarsal", wrvu: 6.96 },
 "28150": { name: "Removal Of Toe", wrvu: 4.12 },
 "28153": { name: "Partial Removal Of Toe", wrvu: 3.71 },
 "28160": { name: "Partial Removal Of Toe", wrvu: 3.78 },
 "28171": { name: "Resection Tarsal Tumor", wrvu: 16.00 },
 "28173": { name: "Resection Metatarsal Tumor", wrvu: 13.81 },
 "28175": { name: "Resection Phalanx Of Toe Tumor", wrvu: 8.08 },
 "28190": { name: "Removal Of Foot Foreign Body", wrvu: 1.96 },
 "28192": { name: "Removal Of Foot Foreign Body", wrvu: 4.66 },
 "28193": { name: "Removal Of Foot Foreign Body", wrvu: 5.75 },
 "28200": { name: "Repair Of Foot Tendon", wrvu: 4.62 },
 "28202": { name: "Repair/graft Of Foot Tendon", wrvu: 6.89 },
 "28208": { name: "Repair Of Foot Tendon", wrvu: 4.40 },
 "28210": { name: "Repair/graft Of Foot Tendon", wrvu: 6.36 },
 "28220": { name: "Release Of Foot Tendon", wrvu: 4.55 },
 "28222": { name: "Release Of Foot Tendons", wrvu: 5.62 },
 "28225": { name: "Release Of Foot Tendon", wrvu: 3.69 },
 "28226": { name: "Release Of Foot Tendons", wrvu: 4.55 },
 "28230": { name: "Incision Of Foot Tendon(s)", wrvu: 4.25 },
 "28232": { name: "Incision Of Toe Tendon", wrvu: 3.42 },
 "28234": { name: "Incision Of Foot Tendon", wrvu: 3.45 },
 "28238": { name: "Revision Of Foot Tendon", wrvu: 7.76 },
 "28240": { name: "Release Of Big Toe", wrvu: 4.37 },
 "28250": { name: "Revision Of Foot Fascia", wrvu: 5.91 },
 "28260": { name: "Release Of Midfoot Joint", wrvu: 7.99 },
 "28261": { name: "Revision Of Foot Tendon", wrvu: 12.78 },
 "28262": { name: "Revision Of Foot And Ankle", wrvu: 16.78 },
 "28264": { name: "Release Of Midfoot Joint", wrvu: 10.38 },
 "28270": { name: "Release Of Foot Contracture", wrvu: 4.81 },
 "28272": { name: "Release Of Toe Joint Each", wrvu: 3.82 },
 "28280": { name: "Fusion Of Toes", wrvu: 5.20 },
 "28285": { name: "Repair Of Hammertoe", wrvu: 5.48 },
 "28286": { name: "Repair Of Hammertoe", wrvu: 4.58 },
 "28288": { name: "Partial Removal Of Foot Bone", wrvu: 5.87 },
 "28289": { name: "Corrj Halux Rigdus Without Implt", wrvu: 6.73 },
 "28291": { name: "Corrj Halux Rigdus With Implt", wrvu: 7.81 },
 "28292": { name: "Cor Hlx Vlgs Rsc Prx Phlx Bs", wrvu: 7.25 },
 "28295": { name: "Cor Hlx Vlgs Prx Mtar Osteot", wrvu: 8.36 },
 "28296": { name: "Cor Hlx Vlgs Dstl Mtar Osteo", wrvu: 8.04 },
 "28297": { name: "Cor Hlx Vlgs Joint Arthrd", wrvu: 9.06 },
 "28298": { name: "Cor Hlx Vlgs Prx Phlx Osteot", wrvu: 7.56 },
 "28299": { name: "Cor Hlx Vlgs Double Osteot", wrvu: 9.06 },
 "28300": { name: "Incision Of Heel Bone", wrvu: 9.49 },
 "28302": { name: "Incision Of Ankle Bone", wrvu: 9.50 },
 "28304": { name: "Incision Of Midfoot Bones", wrvu: 9.17 },
 "28305": { name: "Incise/graft Midfoot Bones", wrvu: 10.50 },
 "28306": { name: "Incision Of Metatarsal", wrvu: 5.85 },
 "28307": { name: "Incision Of Metatarsal", wrvu: 6.34 },
 "28308": { name: "Incision Of Metatarsal", wrvu: 5.34 },
 "28309": { name: "Incision Of Metatarsals", wrvu: 13.81 },
 "28310": { name: "Revision Of Big Toe", wrvu: 5.43 },
 "28312": { name: "Revision Of Toe", wrvu: 4.57 },
 "28313": { name: "Repair Deformity Of Toe", wrvu: 5.02 },
 "28315": { name: "Removal Of Sesamoid Bone", wrvu: 4.88 },
 "28320": { name: "Repair Of Foot Bones", wrvu: 9.14 },
 "28322": { name: "Repair Of Metatarsals", wrvu: 8.32 },
 "28340": { name: "Resection Enlarged Toe Tissue", wrvu: 6.97 },
 "28341": { name: "Resection Enlarged Toe", wrvu: 8.50 },
 "28344": { name: "Repair Extra Toe(s)", wrvu: 4.29 },
 "28345": { name: "Repair Webbed Toe(s)", wrvu: 5.94 },
 "28360": { name: "Reconstruct Cleft Foot", wrvu: 14.55 },
 "28400": { name: "Closed Treatment Calcaneal Fracture Without Manipulation", wrvu: 2.25 },
 "28405": { name: "Closed Treatment Calcaneal Fracture With Manipulation", wrvu: 4.62 },
 "28406": { name: "Prq Skel Fix Clcnl Fracture With Manipulation", wrvu: 6.40 },
 "28415": { name: "Optx Calcaneal Fracture", wrvu: 15.79 },
 "28420": { name: "Optx Calcaneal Fracture With Bone Grf", wrvu: 17.08 },
 "28430": { name: "Closed Treatment Talus Fracture Without Manipulation", wrvu: 2.16 },
 "28435": { name: "Closed Treatment Talus Fracture With Manipulation", wrvu: 3.45 },
 "28436": { name: "Prq Skel Fix Talus Fracture With Manipulation", wrvu: 4.78 },
 "28445": { name: "Optx Talus Fracture", wrvu: 15.37 },
 "28446": { name: "Open Osteochondrl Autograft Talus", wrvu: 17.27 },
 "28450": { name: "Treatment Tarsal Bone Fracture Without Manipulation Each", wrvu: 1.98 },
 "28455": { name: "Treatment Tarsal Bone Fracture With Manipulation Each", wrvu: 3.16 },
 "28456": { name: "Prq Skel Fix Tarsl Fracture With Manipulation", wrvu: 2.79 },
 "28465": { name: "Optx Tarsal Bone Fracture Each", wrvu: 8.58 },
 "28470": { name: "Closed Treatment of Metatarsal Fracture, without Manipulation", wrvu: 1.98 },
 "28475": { name: "Closed Treatment of Metatarsal Fracture, with Manipulation", wrvu: 2.93 },
 "28476": { name: "Prq Skel Fix Metar Fracture With Manipulation", wrvu: 3.51 },
 "28485": { name: "Optx Metatarsal Fracture Each", wrvu: 7.25 },
 "28490": { name: "Treat Big Toe Fracture", wrvu: 1.14 },
 "28495": { name: "Treat Big Toe Fracture", wrvu: 1.64 },
 "28496": { name: "Treat Big Toe Fracture", wrvu: 2.42 },
 "28505": { name: "Treat Big Toe Fracture", wrvu: 7.25 },
 "28510": { name: "Closed Treatment of Toe Phalangeal Fracture, without Manipulation", wrvu: 1.14 },
 "28515": { name: "Closed Treatment of Toe Phalangeal Fracture, with Manipulation", wrvu: 1.52 },
 "28525": { name: "Treat Toe Fracture", wrvu: 5.48 },
 "28530": { name: "Treat Sesamoid Bone Fracture", wrvu: 1.08 },
 "28531": { name: "Treat Sesamoid Bone Fracture", wrvu: 2.51 },
 "28540": { name: "Treat Foot Dislocation", wrvu: 2.14 },
 "28545": { name: "Treat Foot Dislocation", wrvu: 2.54 },
 "28546": { name: "Treat Foot Dislocation", wrvu: 3.32 },
 "28555": { name: "Repair Foot Dislocation", wrvu: 9.41 },
 "28570": { name: "Treat Foot Dislocation", wrvu: 1.72 },
 "28575": { name: "Treat Foot Dislocation", wrvu: 3.40 },
 "28576": { name: "Treat Foot Dislocation", wrvu: 4.49 },
 "28585": { name: "Repair Foot Dislocation", wrvu: 10.85 },
 "28600": { name: "Treat Foot Dislocation", wrvu: 1.97 },
 "28605": { name: "Treat Foot Dislocation", wrvu: 2.82 },
 "28606": { name: "Treat Foot Dislocation", wrvu: 4.96 },
 "28615": { name: "Repair Foot Dislocation", wrvu: 10.43 },
 "28630": { name: "Treat Toe Dislocation", wrvu: 1.71 },
 "28635": { name: "Treat Toe Dislocation", wrvu: 1.91 },
 "28636": { name: "Treat Toe Dislocation", wrvu: 2.70 },
 "28645": { name: "Repair Toe Dislocation", wrvu: 7.25 },
 "28660": { name: "Treat Toe Dislocation", wrvu: 1.25 },
 "28665": { name: "Treat Toe Dislocation", wrvu: 1.92 },
 "28666": { name: "Treat Toe Dislocation", wrvu: 2.59 },
 "28675": { name: "Repair Of Toe Dislocation", wrvu: 5.48 },
 "28705": { name: "Arthrodesis Pantalar", wrvu: 19.82 },
 "28715": { name: "Arthrodesis Triple", wrvu: 13.08 },
 "28725": { name: "Arthrodesis Subtalar", wrvu: 10.94 },
 "28730": { name: "Fusion Of Foot Bones", wrvu: 10.43 },
 "28735": { name: "Fusion Of Foot Bones", wrvu: 11.92 },
 "28737": { name: "Revision Of Foot Bones", wrvu: 10.75 },
 "28740": { name: "Fusion Of Foot Bones", wrvu: 9.06 },
 "28750": { name: "Fusion Of Big Toe Joint", wrvu: 8.53 },
 "28755": { name: "Fusion Of Big Toe Joint", wrvu: 7.31 },
 "28760": { name: "Fusion Of Big Toe Joint", wrvu: 8.91 },
 "28800": { name: "Amputation Of Midfoot", wrvu: 8.57 },
 "28805": { name: "Amputation Thru Metatarsal", wrvu: 12.39 },
 "28810": { name: "Amputation Toe & Metatarsal", wrvu: 6.47 },
 "28820": { name: "Amputation Of Toe", wrvu: 3.42 },
 "28825": { name: "Partial Amputation Of Toe", wrvu: 3.32 },
 "28890": { name: "High Enrgy Extracorporeal Shockwave Therapy Plantar Fascia", wrvu: 3.36 },
 "28899": { name: "Unlisted Procedure Foot/toes", wrvu: 0.00 },
 "29000": { name: "Application Halo Type Body Cast", wrvu: 2.19 },
 "29010": { name: "Application Risser Jacket Body Only", wrvu: 2.01 },
 "29015": { name: "Application Rissr Jacket Bdy With Head", wrvu: 2.35 },
 "29035": { name: "Application Body Cast Shoulder To Hips", wrvu: 1.73 },
 "29040": { name: "Application Bdy Cast Shoulder To Hip Head", wrvu: 2.16 },
 "29044": { name: "Application Bdy Cast Shoulder To Hip 1thi", wrvu: 2.07 },
 "29046": { name: "Application Bdy Cast Shoulder To Hip B Th", wrvu: 2.35 },
 "29049": { name: "Application Cast Figure-of-eight", wrvu: 0.87 },
 "29055": { name: "Application Cast Shoulder Spica", wrvu: 1.74 },
 "29058": { name: "Application Cast Plaster Velpeau", wrvu: 1.28 },
 "29065": { name: "Application Cast Shoulder To Hand Lung Arm", wrvu: 0.85 },
 "29075": { name: "Application Cast Elbow Finger Short Arm", wrvu: 0.75 },
 "29085": { name: "Application Cast Hand and Lower Forearm", wrvu: 0.85 },
 "29086": { name: "Application Cast Finger", wrvu: 0.60 },
 "29105": { name: "Application of Long Arm Splint (shoulder to hand)", wrvu: 0.78 },
 "29125": { name: "Application of Short Arm Splint, Forearm to Hand, Static", wrvu: 0.49 },
 "29126": { name: "Application of Short Arm Splint, Dynamic", wrvu: 0.66 },
 "29130": { name: "Application of Finger Splint, Static", wrvu: 0.49 },
 "29131": { name: "Application of Finger Splint, Dynamic", wrvu: 0.54 },
 "29200": { name: "Strapping Thorax", wrvu: 0.38 },
 "29240": { name: "Strapping Of Shoulder", wrvu: 0.38 },
 "29260": { name: "Strapping Of Elbow Or Wrist", wrvu: 0.38 },
 "29280": { name: "Strapping, Hand or Finger", wrvu: 0.38 },
 "29305": { name: "Application Hip Spica Cast 1 Leg", wrvu: 1.98 },
 "29325": { name: "Application Hip Spica Cast1 and 1/2", wrvu: 2.26 },
 "29345": { name: "Application Of Long Leg Cast", wrvu: 1.37 },
 "29355": { name: "Application Long Leg Cast Walker", wrvu: 1.49 },
 "29358": { name: "Application Long Leg Cast Brace", wrvu: 1.39 },
 "29365": { name: "Application Cylinder Cast", wrvu: 1.15 },
 "29405": { name: "Application Short Leg Cast", wrvu: 0.78 },
 "29425": { name: "Application Short Leg Cast Walking", wrvu: 0.78 },
 "29435": { name: "Application Patllr Tdn Bearing Cast", wrvu: 1.15 },
 "29440": { name: "Adding Walker To Prev Cast", wrvu: 0.56 },
 "29445": { name: "Application Rigid Tot Cntc Leg Cast", wrvu: 1.74 },
 "29450": { name: "Application Clubfoot Cast", wrvu: 2.03 },
 "29505": { name: "Application of Long Leg Splint (thigh to ankle/toes)", wrvu: 0.67 },
 "29515": { name: "Application of Short Leg Splint (calf to foot)", wrvu: 0.71 },
 "29520": { name: "Strapping, Hip", wrvu: 0.38 },
 "29530": { name: "Strapping, Knee", wrvu: 0.38 },
 "29540": { name: "Strapping, Ankle", wrvu: 0.38 },
 "29550": { name: "Strapping, Toes", wrvu: 0.24 },
 "29580": { name: "Strapping Unna Boot", wrvu: 0.54 },
 "29581": { name: "Application Multlayer Cmprn System Leg", wrvu: 0.59 },
 "29584": { name: "Application Mltlay Cmprn System Up Arm", wrvu: 0.34 },
 "29700": { name: "Removal/Bivalve Gauntlet Boot/cst", wrvu: 0.56 },
 "29705": { name: "Removal/Bivalve Full Arm/leg Cast", wrvu: 0.74 },
 "29710": { name: "Removal/Bivalve Shoulder/hip Spica", wrvu: 1.31 },
 "29720": { name: "Repair Spica Body Cst/jacket", wrvu: 0.66 },
 "29730": { name: "Windowing Of Cast", wrvu: 0.73 },
 "29740": { name: "Wedging Of Cast", wrvu: 1.09 },
 "29750": { name: "Wedging Of Clubfoot Cast", wrvu: 1.23 },
 "29799": { name: "Unlisted Procedure Casting/strpg", wrvu: 0.00 },
 "29800": { name: "Jaw Arthroscopy/surgery", wrvu: 6.67 },
 "29804": { name: "Jaw Arthroscopy/surgery", wrvu: 8.65 },
 "29805": { name: "Shoulder Arthroscopy Diagnosis +- Synovial Biopsy", wrvu: 5.88 },
 "29806": { name: "Shoulder Arthroscopy Srg Capsulorraphy", wrvu: 14.76 },
 "29807": { name: "Shoulder Arthroscopy Srg Repair Slap Lesion", wrvu: 14.30 },
 "29819": { name: "Shoulder Arthroscopy Srg Removal Loose/fb", wrvu: 7.60 },
 "29820": { name: "Shoulder Arthroscopy Srg Partial Synvct", wrvu: 7.03 },
 "29821": { name: "Shoulder Arthroscopy Srg Compl Synvct", wrvu: 7.69 },
 "29822": { name: "Shoulder Arthroscopy Srg Lmtd Dbrdmt", wrvu: 6.85 },
 "29823": { name: "Shoulder Arthroscopy Srg Extensive Dbrdmt", wrvu: 7.78 },
 "29824": { name: "Shoulder Arthroscopy Srg Dstl Claviclc", wrvu: 8.76 },
 "29825": { name: "Shoulder Arthroscopy Srg Lss and resection Ads", wrvu: 7.60 },
 "29826": { name: "Shoulder Arthroscopy Srg Decompression", wrvu: 2.93 },
 "29827": { name: "Shoulder Arthroscopy Srg Rt8tr Cuf Repair", wrvu: 15.20 },
 "29828": { name: "Shoulder Arthroscopy Srg Bicp Tenodsis", wrvu: 12.83 },
 "29830": { name: "Elbow Arthroscopy", wrvu: 5.73 },
 "29834": { name: "Elbow Arthroscopy/surgery", wrvu: 6.26 },
 "29835": { name: "Elbow Arthroscopy/surgery", wrvu: 6.45 },
 "29836": { name: "Elbow Arthroscopy/surgery", wrvu: 7.53 },
 "29837": { name: "Elbow Arthroscopy/surgery", wrvu: 6.83 },
 "29838": { name: "Elbow Arthroscopy/surgery", wrvu: 7.68 },
 "29840": { name: "Wrist Arthroscopy", wrvu: 5.54 },
 "29843": { name: "Wrist Arthroscopy/surgery", wrvu: 6.00 },
 "29844": { name: "Wrist Arthroscopy/surgery", wrvu: 6.35 },
 "29845": { name: "Wrist Arthroscopy/surgery", wrvu: 7.50 },
 "29846": { name: "Wrist Arthroscopy/surgery", wrvu: 6.72 },
 "29847": { name: "Wrist Arthroscopy/surgery", wrvu: 7.04 },
 "29848": { name: "Wrist Endoscopy/surgery", wrvu: 6.23 },
 "29850": { name: "Knee Arthroscopy/surgery", wrvu: 8.06 },
 "29851": { name: "Knee Arthroscopy/surgery", wrvu: 12.93 },
 "29855": { name: "Tibial Arthroscopy/surgery", wrvu: 10.49 },
 "29856": { name: "Tibial Arthroscopy/surgery", wrvu: 13.92 },
 "29860": { name: "Hip Arthroscopy Diagnosis", wrvu: 8.78 },
 "29861": { name: "Hip Arthroscopic With Fb Removal", wrvu: 9.85 },
 "29862": { name: "Hip Arthr0 With Debridement", wrvu: 10.89 },
 "29863": { name: "Hip Arthr0 With Synovectomy", wrvu: 10.89 },
 "29866": { name: "Autgrft Implant Knee With Scope", wrvu: 14.30 },
 "29867": { name: "Allgrft Implant Knee With Scope", wrvu: 17.93 },
 "29868": { name: "Meniscal Transplant Knee With Scpe", wrvu: 24.47 },
 "29870": { name: "Arthroscopy Knee Diagnosis With without Syn Biopsy", wrvu: 5.06 },
 "29871": { name: "Arthroscopy Knee Surgery For Infected", wrvu: 6.52 },
 "29873": { name: "Arthroscopy Knee Surgery With Lateral Rls", wrvu: 6.08 },
 "29874": { name: "Arthroscopy Knee Surgery Removal Loos/fb", wrvu: 7.01 },
 "29875": { name: "Arthroscopy Knee Surgery Synvct Lmtd", wrvu: 6.29 },
 "29876": { name: "Arthroscopy Knee Surgery Synvct Maj", wrvu: 8.65 },
 "29877": { name: "Arthroscopy Knee Surgery Dbrdmt/shvg", wrvu: 8.09 },
 "29879": { name: "Arthroscopy Knee Srg Abrasj Arthrp", wrvu: 8.77 },
 "29880": { name: "Arthroscopy Knee Srg Mnisectmy M and l", wrvu: 7.21 },
 "29881": { name: "Arthroscopy Knee Srg Mnisectmy M/l", wrvu: 6.85 },
 "29882": { name: "Arthroscopy Knee Srg Mnisc Repair M/l", wrvu: 9.36 },
 "29883": { name: "Arthroscopy Knee Srg Mnisc Repair M and l", wrvu: 11.48 },
 "29884": { name: "Arthroscopy Knee Surgery Lysis Ads", wrvu: 8.07 },
 "29885": { name: "Arthroscopy Knee Srg Drlg Ost Diss", wrvu: 9.95 },
 "29886": { name: "Arthroscopy Knee Surgery Drlg Od Lesion", wrvu: 8.28 },
 "29887": { name: "Arthroscopy Knee Srg Drlg Od Fixj", wrvu: 9.91 },
 "29888": { name: "Arthroscopy Aid Acl Repair/agmntj", wrvu: 13.94 },
 "29889": { name: "Arthroscopy Aid Pcl Repair/agmntj", wrvu: 16.97 },
 "29891": { name: "Arthr Ank Ostchn Df Tal&/Tibial", wrvu: 9.43 },
 "29892": { name: "Arthroscopy Aid Repair Od Lesion/Tibial Fracture", wrvu: 10.01 },
 "29893": { name: "Endoscopic Plantr Fasciotomy", wrvu: 6.16 },
 "29894": { name: "Ankle Arthroscopy/surgery", wrvu: 7.17 },
 "29895": { name: "Ankle Arthroscopy/surgery", wrvu: 6.95 },
 "29897": { name: "Ankle Arthroscopy/surgery", wrvu: 7.14 },
 "29898": { name: "Ankle Arthroscopy/surgery", wrvu: 8.28 },
 "29899": { name: "Ankle Arthroscopy/surgery", wrvu: 15.02 },
 "29900": { name: "Mcp Joint Arthroscopy Diagnosis", wrvu: 5.73 },
 "29901": { name: "Mcp Joint Arthroscopy Surgery", wrvu: 6.43 },
 "29902": { name: "Mcp Joint Arthroscopy Surgery", wrvu: 6.98 },
 "29904": { name: "Subtalar Arthroscopic With Fb Removal", wrvu: 8.43 },
 "29905": { name: "Subtalar Arthroscopic With Excision", wrvu: 8.95 },
 "29906": { name: "Subtalar Arthroscopic With Debridement", wrvu: 9.41 },
 "29907": { name: "Subtalar Arthroscopic With Fusion", wrvu: 11.88 },
 "29914": { name: "Hip Arthroscopic With Femoroplasty", wrvu: 14.30 },
 "29915": { name: "Hip Arthroscopic Acetabuloplasty", wrvu: 14.63 },
 "29916": { name: "Hip Arthroscopic With Labral Repair", wrvu: 14.63 },
 "29999": { name: "Unlisted Procedure Arthroscopy", wrvu: 0.00 },
 "30000": { name: "Drainage Of Nose Lesion", wrvu: 1.44 },
 "30020": { name: "Drainage Of Nose Lesion", wrvu: 1.44 },
 "30100": { name: "Intranasal Biopsy", wrvu: 0.92 },
 "30110": { name: "Removal Of Nose Polyp(s)", wrvu: 1.64 },
 "30115": { name: "Removal Of Nose Polyp(s)", wrvu: 4.33 },
 "30117": { name: "Removal Of Intranasal Lesion", wrvu: 3.81 },
 "30118": { name: "Removal Of Intranasal Lesion", wrvu: 7.56 },
 "30120": { name: "Revision Of Nose", wrvu: 5.26 },
 "30124": { name: "Removal Of Nose Lesion", wrvu: 3.12 },
 "30125": { name: "Removal Of Nose Lesion", wrvu: 7.12 },
 "30130": { name: "Excise Inferior Turbinate", wrvu: 3.38 },
 "30140": { name: "Resection Inferior Turbinate", wrvu: 2.93 },
 "30150": { name: "Rhinectomy Partial", wrvu: 9.31 },
 "30160": { name: "Rhinectomy Total", wrvu: 9.74 },
 "30200": { name: "Injection Treatment Of Nose", wrvu: 0.76 },
 "30210": { name: "Nasal Sinus Therapy", wrvu: 1.10 },
 "30220": { name: "Insert Nasal Septal Button", wrvu: 1.55 },
 "30300": { name: "Removal of Foreign Body, Intranasal, Office", wrvu: 1.06 },
 "30310": { name: "Remove Nasal Foreign Body", wrvu: 1.96 },
 "30320": { name: "Remove Nasal Foreign Body", wrvu: 4.52 },
 "30400": { name: "Reconstruction Of Nose", wrvu: 10.59 },
 "30410": { name: "Reconstruction Of Nose", wrvu: 13.65 },
 "30420": { name: "Reconstruction Of Nose", wrvu: 16.48 },
 "30430": { name: "Revision Of Nose", wrvu: 8.03 },
 "30435": { name: "Revision Of Nose", wrvu: 12.41 },
 "30450": { name: "Revision Of Nose", wrvu: 19.17 },
 "30460": { name: "Revision Of Nose", wrvu: 10.06 },
 "30462": { name: "Revision Of Nose", wrvu: 19.77 },
 "30465": { name: "Repair Nasal Stenosis", wrvu: 12.05 },
 "30468": { name: "Repair Nasal Vlv Collapse With Implt", wrvu: 2.73 },
 "30469": { name: "Repair Nasal Vlv Collapse With Rmdlg", wrvu: 2.38 },
 "30520": { name: "Repair Of Nasal Septum", wrvu: 6.83 },
 "30540": { name: "Repair Choanal Atresia Ntranasl", wrvu: 7.72 },
 "30545": { name: "Repair Choanal Atresia Trsnpltn", wrvu: 11.33 },
 "30560": { name: "Lysis Intranasal Synechia", wrvu: 1.28 },
 "30580": { name: "Repair Upper Jaw Fistula", wrvu: 6.71 },
 "30600": { name: "Repair Mouth/nose Fistula", wrvu: 6.01 },
 "30620": { name: "Intranasal Reconstruction", wrvu: 6.01 },
 "30630": { name: "Repair Nasal Septum Defect", wrvu: 7.11 },
 "30801": { name: "Ablate Inferior Turbinate Superf", wrvu: 1.11 },
 "30802": { name: "Ablate Inferior Turbinate Submuc", wrvu: 2.03 },
 "30901": { name: "Control of Nasal Hemorrhage, Anterior, Simple", wrvu: 1.07 },
 "30903": { name: "Control of Nasal Hemorrhage, Anterior, Complex", wrvu: 1.50 },
 "30905": { name: "Control of Nasal Hemorrhage, Posterior, Initial", wrvu: 1.92 },
 "30906": { name: "Control of Nasal Hemorrhage, Posterior, Subsequent", wrvu: 2.39 },
 "30915": { name: "Ligation Nasal Sinus Artery", wrvu: 7.25 },
 "30920": { name: "Ligation Upper Jaw Artery", wrvu: 10.86 },
 "30930": { name: "Therapeutic Fracture Nasal Inferior Turbinate", wrvu: 1.28 },
 "30999": { name: "Unlisted Procedure Nose", wrvu: 0.00 },
 "31000": { name: "Irrigation Maxillary Sinus", wrvu: 1.17 },
 "31002": { name: "Irrigation Sphenoid Sinus", wrvu: 1.91 },
 "31020": { name: "Exploration Maxillary Sinus", wrvu: 2.99 },
 "31030": { name: "Exploration Maxillary Sinus", wrvu: 5.86 },
 "31032": { name: "Explore Sinus Remove Polyps", wrvu: 6.52 },
 "31040": { name: "Exploration Behind Upper Jaw", wrvu: 9.53 },
 "31050": { name: "Exploration Sphenoid Sinus", wrvu: 5.24 },
 "31051": { name: "Sphenoid Sinus Surgery", wrvu: 7.07 },
 "31070": { name: "Exploration Of Frontal Sinus", wrvu: 4.29 },
 "31075": { name: "Exploration Of Frontal Sinus", wrvu: 9.27 },
 "31080": { name: "Removal Of Frontal Sinus", wrvu: 12.42 },
 "31081": { name: "Removal Of Frontal Sinus", wrvu: 13.84 },
 "31084": { name: "Removal Of Frontal Sinus", wrvu: 14.58 },
 "31085": { name: "Removal Of Frontal Sinus", wrvu: 15.25 },
 "31086": { name: "Removal Of Frontal Sinus", wrvu: 14.00 },
 "31087": { name: "Removal Of Frontal Sinus", wrvu: 14.21 },
 "31090": { name: "Exploration Of Sinuses", wrvu: 10.89 },
 "31200": { name: "Removal Of Ethmoid Sinus", wrvu: 5.01 },
 "31201": { name: "Removal Of Ethmoid Sinus", wrvu: 8.39 },
 "31205": { name: "Removal Of Ethmoid Sinus", wrvu: 10.32 },
 "31225": { name: "Removal Of Upper Jaw", wrvu: 26.03 },
 "31230": { name: "Removal Of Upper Jaw", wrvu: 30.05 },
 "31231": { name: "Nasal Endoscopy Diagnosis", wrvu: 1.07 },
 "31233": { name: "Nasal/Sinus Endoscopy Diagnosis Max Sinuscopy", wrvu: 2.13 },
 "31235": { name: "Nasal/Sinus Endoscopy Diagnosis Sphn Sinuscopy", wrvu: 2.57 },
 "31237": { name: "Nasal/Sinus Endoscopy Surgery Biopsy Polypc", wrvu: 2.54 },
 "31238": { name: "Nasal/Sinus Endoscopy Srg Nasal Hemrrg", wrvu: 2.67 },
 "31239": { name: "Nasal/Sinus Endoscopy Surgery Dcr", wrvu: 8.81 },
 "31240": { name: "Nasal/sns Endoscopy Cnch Bull Resection", wrvu: 2.54 },
 "31241": { name: "Nasal/sns Endoscopy Ligation Sphnptn Artery", wrvu: 7.80 },
 "31242": { name: "Nasal/Sinus Endoscopy Radiofrequency Abltj Pnn", wrvu: 2.63 },
 "31243": { name: "Nasal/Sinus Endoscopy Cryoabltj Pnn", wrvu: 2.63 },
 "31253": { name: "Nasal/Sinus Endoscopy Total", wrvu: 8.78 },
 "31254": { name: "Nasal/Sinus Endoscopy With Partial Ethmdct", wrvu: 4.16 },
 "31255": { name: "Nasal/Sinus Endoscopy With Tot Ethmdct", wrvu: 5.61 },
 "31256": { name: "Exploration Maxillary Sinus", wrvu: 3.03 },
 "31257": { name: "Nasal/Sinus Endoscopy Tot With Sphendt", wrvu: 7.80 },
 "31259": { name: "Nasal/Sinus Endoscopy Sphn Tiss Removal", wrvu: 8.27 },
 "31267": { name: "Endoscopy Maxillary Sinus", wrvu: 4.56 },
 "31276": { name: "Nasal/Sinus Endoscopy Frnt Tiss Removal", wrvu: 6.58 },
 "31287": { name: "Nasal/sinus Endoscopy Surgery", wrvu: 3.41 },
 "31288": { name: "Nasal/sinus Endoscopy Surgery", wrvu: 4.00 },
 "31290": { name: "Nasal/sinus Endoscopy Surgery", wrvu: 18.14 },
 "31291": { name: "Nasal/sinus Endoscopy Surgery", wrvu: 19.07 },
 "31292": { name: "Nasal/Sinus Endoscopy Medial/inferior Dcmprn", wrvu: 15.50 },
 "31293": { name: "Nasal/Sinus Endoscopy Medial and inferior Dcmprn", wrvu: 17.03 },
 "31294": { name: "Nasal/Sinus Endoscopy Surgery On Dcmprn", wrvu: 19.80 },
 "31295": { name: "Nasal/Sinus Endoscopy Surgery Max Sinus", wrvu: 2.63 },
 "31296": { name: "Nasal/Sinus Endoscopy Surgery Frnt Sinus", wrvu: 3.02 },
 "31297": { name: "Nasal/Sinus Endoscopy Surgery Sphn Sinus", wrvu: 2.38 },
 "31298": { name: "Nasal/Sinus Endoscopy Surgery Frnt and sphn", wrvu: 4.39 },
 "31299": { name: "Unlisted Procedure Accessory Sinus", wrvu: 0.00 },
 "31300": { name: "Removal Of Larynx Lesion", wrvu: 15.51 },
 "31360": { name: "Removal Of Larynx", wrvu: 29.16 },
 "31365": { name: "Removal Of Larynx", wrvu: 37.84 },
 "31367": { name: "Partial Removal Of Larynx", wrvu: 29.81 },
 "31368": { name: "Partial Removal Of Larynx", wrvu: 33.34 },
 "31370": { name: "Partial Removal Of Larynx", wrvu: 26.88 },
 "31375": { name: "Partial Removal Of Larynx", wrvu: 25.42 },
 "31380": { name: "Partial Removal Of Larynx", wrvu: 24.93 },
 "31382": { name: "Partial Removal Of Larynx", wrvu: 27.86 },
 "31390": { name: "Removal Of Larynx & Pharynx", wrvu: 41.45 },
 "31395": { name: "Reconstruct Larynx & Pharynx", wrvu: 42.71 },
 "31400": { name: "Revision Of Larynx", wrvu: 11.31 },
 "31420": { name: "Epiglottidectomy", wrvu: 11.14 },
 "31500": { name: "Insert Emergency Airway", wrvu: 2.93 },
 "31502": { name: "Change Of Windpipe Airway", wrvu: 0.63 },
 "31505": { name: "Diagnostic Laryngoscopy", wrvu: 0.59 },
 "31510": { name: "Laryngoscopy With Biopsy", wrvu: 1.87 },
 "31511": { name: "Remove Foreign Body Larynx", wrvu: 2.11 },
 "31512": { name: "Removal Of Larynx Lesion", wrvu: 2.02 },
 "31513": { name: "Injection Into Vocal Cord", wrvu: 2.05 },
 "31515": { name: "Laryngoscopy For Aspiration", wrvu: 1.76 },
 "31520": { name: "Diagnosis Laryngoscopy Newborn", wrvu: 2.50 },
 "31525": { name: "Diagnosis Laryngoscopy Excl Nb", wrvu: 2.56 },
 "31526": { name: "Diagnosis Laryngoscopy With Oper Scope", wrvu: 2.51 },
 "31527": { name: "Laryngoscopy For Treatment", wrvu: 3.19 },
 "31528": { name: "Laryngoscopy And Dilation", wrvu: 2.31 },
 "31529": { name: "Laryngoscopy And Dilation", wrvu: 2.61 },
 "31530": { name: "Laryngoscopy With Fb Removal", wrvu: 3.30 },
 "31531": { name: "Laryngoscopy With Fb & Op Scope", wrvu: 3.49 },
 "31535": { name: "Laryngoscopy With Biopsy", wrvu: 3.08 },
 "31536": { name: "Laryngoscopy With Biopsy & Op Scope", wrvu: 3.46 },
 "31540": { name: "Laryngoscopy With Excision Of Tumor", wrvu: 4.02 },
 "31541": { name: "Larynscop With Tumr Excision + Scope", wrvu: 4.41 },
 "31545": { name: "Remove Vc Lesion With Scope", wrvu: 6.14 },
 "31546": { name: "Remove Vc Lesion Scope/graft", wrvu: 9.49 },
 "31551": { name: "Laryngoplasty Laryngeal Sten", wrvu: 20.96 },
 "31552": { name: "Laryngoplasty Laryngeal Sten", wrvu: 19.99 },
 "31553": { name: "Laryngoplasty Laryngeal Sten", wrvu: 21.45 },
 "31554": { name: "Laryngoplasty Laryngeal Sten", wrvu: 21.45 },
 "31560": { name: "Laryngoscop With Arytenoidectom", wrvu: 5.31 },
 "31561": { name: "Larynscop Remve Cartilage + Scop", wrvu: 5.84 },
 "31570": { name: "Laryngoscope With Vc Injection", wrvu: 3.76 },
 "31571": { name: "Laryngoscop With Vc Injection + Scope", wrvu: 4.15 },
 "31572": { name: "Largsc With Laser Dstrj Lesion", wrvu: 2.93 },
 "31573": { name: "Largsc With Therapeutic Injection", wrvu: 2.37 },
 "31574": { name: "Largsc With Injection Augmentation", wrvu: 2.37 },
 "31575": { name: "Diagnostic Laryngoscopy", wrvu: 0.92 },
 "31576": { name: "Laryngoscopy With Biopsy", wrvu: 1.84 },
 "31577": { name: "Largsc With Removal Foreign Bdy(s)", wrvu: 2.14 },
 "31578": { name: "Largsc With Removal Lesion", wrvu: 2.37 },
 "31579": { name: "Laryngoscopy Telescopic", wrvu: 1.83 },
 "31580": { name: "Laryngoplasty Laryngeal Web", wrvu: 14.24 },
 "31584": { name: "Laryngoplasty Fracture Rdctj Fixj", wrvu: 17.14 },
 "31587": { name: "Laryngoplasty Cricoid Split", wrvu: 14.89 },
 "31590": { name: "Reinnervate Larynx", wrvu: 7.65 },
 "31591": { name: "Laryngoplasty Medialization", wrvu: 13.22 },
 "31592": { name: "Cricotracheal Resection", wrvu: 24.38 },
 "31599": { name: "Unlisted Procedure Larynx", wrvu: 0.00 },
 "31600": { name: "Planned Tracheostomy", wrvu: 5.42 },
 "31601": { name: "Planned Tracheostomy<2 Years", wrvu: 7.80 },
 "31603": { name: "Emer Tracheostomy Ttrach", wrvu: 5.85 },
 "31605": { name: "Emer Tracheostomy Cthyr Mem", wrvu: 6.29 },
 "31610": { name: "Tracheostomy Fenest Skin Flp", wrvu: 11.70 },
 "31611": { name: "Constj Trachesophgl Fistula", wrvu: 5.85 },
 "31612": { name: "Percutaneous Trchl Puncture Ttrach Aspiration", wrvu: 0.89 },
 "31613": { name: "Tracheostoma Revj Simple", wrvu: 4.59 },
 "31614": { name: "Tracheostoma Revj Complex", wrvu: 8.41 },
 "31615": { name: "Trcheobrnchsc Established Trachs Inc", wrvu: 1.79 },
 "31622": { name: "Diagnosis Bronchoscope/wash", wrvu: 2.47 },
 "31623": { name: "Diagnosis Bronchoscope/brush", wrvu: 2.56 },
 "31624": { name: "Diagnosis Bronchoscope/lavage", wrvu: 2.56 },
 "31625": { name: "Bronchoscopy With Biopsy(s)", wrvu: 3.03 },
 "31626": { name: "Bronchoscopy With Markers", wrvu: 3.81 },
 "31627": { name: "Navigational Bronchoscopy", wrvu: 1.95 },
 "31628": { name: "Bronchoscopy/lung Biopsy Each", wrvu: 3.46 },
 "31629": { name: "Bronchoscopy/needle Biopsy Each", wrvu: 3.66 },
 "31630": { name: "Bronchoscopy Dilate/Fracture Repr", wrvu: 3.71 },
 "31631": { name: "Bronchoscopy Dilate With Stent", wrvu: 4.25 },
 "31632": { name: "Bronchoscopy/lung Biopsy Additional", wrvu: 1.00 },
 "31633": { name: "Bronchoscopy/needle Biopsy Additional", wrvu: 1.29 },
 "31634": { name: "Bronch With Balloon Occlusion", wrvu: 3.66 },
 "31635": { name: "Bronchoscopy With Fb Removal", wrvu: 3.33 },
 "31636": { name: "Bronchoscopy Bronch Stents", wrvu: 4.19 },
 "31637": { name: "Bronchoscopy Stent Add-on", wrvu: 1.54 },
 "31638": { name: "Bronchoscopy Revise Stent", wrvu: 4.76 },
 "31640": { name: "Bronchoscopy With Tumor Excise", wrvu: 4.81 },
 "31641": { name: "Bronchoscopy Treat Blockage", wrvu: 4.89 },
 "31643": { name: "Diagnostic Bronchoscope/catheter", wrvu: 3.40 },
 "31645": { name: "Brnchsc With Therapeutic Aspiration 1st", wrvu: 2.81 },
 "31646": { name: "Brnchsc With Therapeutic Aspiration Subsequent", wrvu: 2.71 },
 "31647": { name: "Bronchial Valve Init Insert", wrvu: 4.05 },
 "31648": { name: "Bronchial Valve Remov Init", wrvu: 3.85 },
 "31649": { name: "Bronchial Valve Remov Additional", wrvu: 1.40 },
 "31651": { name: "Bronchial Valve Additional Insert", wrvu: 1.54 },
 "31652": { name: "Bronch Ebus Samplng 1/2 Node", wrvu: 4.35 },
 "31653": { name: "Bronch Ebus Samplng 3/> Node", wrvu: 4.84 },
 "31654": { name: "Bronch Ebus Ivntj Perph Lesion", wrvu: 1.37 },
 "31660": { name: "Bronch Thermoplsty 1 Lobe", wrvu: 3.90 },
 "31661": { name: "Bronch Thermoplsty 2/> Lobes", wrvu: 4.14 },
 "31717": { name: "Bronchial Brush Biopsy", wrvu: 2.07 },
 "31720": { name: "Clearance Of Airways", wrvu: 1.03 },
 "31725": { name: "Clearance Of Airways", wrvu: 1.67 },
 "31730": { name: "Intro Windpipe Wire/tube", wrvu: 2.78 },
 "31750": { name: "Tracheoplasty Cervical", wrvu: 15.01 },
 "31755": { name: "Trachplsty Trchphryngl Fstlj", wrvu: 17.10 },
 "31760": { name: "Tracheoplasty Intrathoracic", wrvu: 22.89 },
 "31766": { name: "Carinal Reconstruction", wrvu: 30.88 },
 "31770": { name: "Repair/graft Of Bronchus", wrvu: 22.95 },
 "31775": { name: "Reconstruct Bronchus", wrvu: 23.98 },
 "31780": { name: "Reconstruct Windpipe", wrvu: 19.34 },
 "31781": { name: "Reconstruct Windpipe", wrvu: 24.23 },
 "31785": { name: "Remove Windpipe Lesion", wrvu: 17.89 },
 "31786": { name: "Remove Windpipe Lesion", wrvu: 24.78 },
 "31800": { name: "Repair Of Windpipe Injury", wrvu: 7.98 },
 "31805": { name: "Repair Of Windpipe Injury", wrvu: 13.08 },
 "31820": { name: "Closure Of Windpipe Lesion", wrvu: 4.52 },
 "31825": { name: "Repair Of Windpipe Defect", wrvu: 6.89 },
 "31830": { name: "Revise Windpipe Scar", wrvu: 4.50 },
 "31899": { name: "Unlisted Procedure Trachea Bronchi", wrvu: 0.00 },
 "32035": { name: "Thoracostomy With Rib Resection", wrvu: 11.01 },
 "32036": { name: "Thoracostomy With Flap Drainage", wrvu: 11.99 },
 "32096": { name: "Open Wedge/Biopsy Lung Infiltr", wrvu: 13.41 },
 "32097": { name: "Open Wedge/Biopsy Lung Nodule", wrvu: 13.41 },
 "32098": { name: "Open Biopsy Of Lung Pleura", wrvu: 12.59 },
 "32100": { name: "Exploration Of Chest", wrvu: 13.41 },
 "32110": { name: "Explore/repair Chest", wrvu: 24.65 },
 "32120": { name: "Re-exploration Of Chest", wrvu: 14.03 },
 "32124": { name: "Explore Chest Free Adhesions", wrvu: 15.06 },
 "32140": { name: "Removal Of Lung Lesion(s)", wrvu: 16.24 },
 "32141": { name: "Remove/treat Lung Lesions", wrvu: 26.50 },
 "32150": { name: "Removal Of Lung Lesion(s)", wrvu: 16.40 },
 "32151": { name: "Remove Lung Foreign Body", wrvu: 16.52 },
 "32160": { name: "Open Chest Heart Massage", wrvu: 12.77 },
 "32200": { name: "Drain Open Lung Lesion", wrvu: 18.21 },
 "32215": { name: "Treat Chest Lining", wrvu: 12.72 },
 "32220": { name: "Release Of Lung", wrvu: 25.98 },
 "32225": { name: "Partial Release Of Lung", wrvu: 16.33 },
 "32310": { name: "Removal Of Chest Lining", wrvu: 14.90 },
 "32320": { name: "Free/remove Chest Lining", wrvu: 26.57 },
 "32400": { name: "Needle Biopsy Chest Lining", wrvu: 1.72 },
 "32408": { name: "Core Needle Biopsy Lung/Medial Percutaneous", wrvu: 3.10 },
 "32440": { name: "Remove Lung Pneumonectomy", wrvu: 26.60 },
 "32442": { name: "Sleeve Pneumonectomy", wrvu: 55.06 },
 "32445": { name: "Removal Of Lung Extrapleural", wrvu: 62.24 },
 "32480": { name: "Partial Removal Of Lung", wrvu: 25.17 },
 "32482": { name: "Bilobectomy", wrvu: 26.75 },
 "32484": { name: "Segmentectomy", wrvu: 24.75 },
 "32486": { name: "Sleeve Lobectomy", wrvu: 41.81 },
 "32488": { name: "Completion Pneumonectomy", wrvu: 41.92 },
 "32491": { name: "Lung Volume Reduction", wrvu: 24.61 },
 "32501": { name: "Repair Bronchus Add-on", wrvu: 4.56 },
 "32503": { name: "Resection Apical Lung Tumor", wrvu: 30.95 },
 "32504": { name: "Resection Apical Lung Tumor/chest", wrvu: 35.63 },
 "32505": { name: "Wedge Resection Of Lung Initial", wrvu: 15.36 },
 "32506": { name: "Wedge Resection Of Lung Add-on", wrvu: 2.93 },
 "32507": { name: "Wedge Resection Of Lung Diagnostic", wrvu: 2.93 },
 "32540": { name: "Removal Of Lung Lesion", wrvu: 29.59 },
 "32550": { name: "Insert Pleural Catheter", wrvu: 3.82 },
 "32551": { name: "Insertion Of Chest Tube", wrvu: 2.96 },
 "32552": { name: "Remove Lung Catheter", wrvu: 2.47 },
 "32553": { name: "Ins Mark Thoracic For Right Percutaneous", wrvu: 3.46 },
 "32554": { name: "Aspirate Pleura Without Imaging", wrvu: 1.77 },
 "32555": { name: "Aspirate Pleura W/ Imaging", wrvu: 2.21 },
 "32556": { name: "Insert Catheter Pleura Without Image", wrvu: 2.44 },
 "32557": { name: "Insert Catheter Pleura W/ Image", wrvu: 3.04 },
 "32560": { name: "Treat Pleurodesis With Agent", wrvu: 1.50 },
 "32561": { name: "Lyse Chest Fibrin Init Day", wrvu: 1.36 },
 "32562": { name: "Lyse Chest Fibrin Subcutaneous Day", wrvu: 1.21 },
 "32601": { name: "Thoracoscopy Diagnostic", wrvu: 5.36 },
 "32604": { name: "Thoracoscopy Wbx Sac", wrvu: 8.55 },
 "32606": { name: "Thoracoscopy With Biopsy Medial Space", wrvu: 8.18 },
 "32607": { name: "Thoracoscopy With Biopsy Infiltrate", wrvu: 5.36 },
 "32608": { name: "Thoracoscopy With Biopsy Nodule", wrvu: 6.67 },
 "32609": { name: "Thoracoscopy With Biopsy Pleura", wrvu: 4.47 },
 "32650": { name: "Thoracoscopy With Pleurodesis", wrvu: 10.56 },
 "32651": { name: "Thoracoscopy Remove Cortex", wrvu: 18.31 },
 "32652": { name: "Thoracoscopy Rem Totl Cortex", wrvu: 28.40 },
 "32653": { name: "Thoracoscopy Remov Fb/fibrin", wrvu: 17.72 },
 "32654": { name: "Thoracoscopy Contrl Bleeding", wrvu: 20.01 },
 "32655": { name: "Thoracoscopy Resection Bullae", wrvu: 15.77 },
 "32656": { name: "Thoracoscopy With Pleurectomy", wrvu: 12.93 },
 "32658": { name: "Thoracoscopy With Sac Fb Remove", wrvu: 11.42 },
 "32659": { name: "Thoracoscopy With Sac Drainage", wrvu: 11.64 },
 "32661": { name: "Thoracoscopy With Pericard Excision", wrvu: 13.00 },
 "32662": { name: "Thoracoscopy With Mediastinal Excision", wrvu: 14.62 },
 "32663": { name: "Thoracoscopy With Lobectomy", wrvu: 24.02 },
 "32664": { name: "Thoracoscopy W/ Th Nerve Excision", wrvu: 13.92 },
 "32665": { name: "Thoracoscop With Esophageal Muscle Excision", wrvu: 20.99 },
 "32666": { name: "Thoracoscopy With Wedge Resection", wrvu: 14.14 },
 "32667": { name: "Thoracoscopy With W Resection Additional", wrvu: 2.93 },
 "32668": { name: "Thoracoscopy With W Resection Diagnostic", wrvu: 2.93 },
 "32669": { name: "Thoracoscopy Remove Segment", wrvu: 22.94 },
 "32670": { name: "Thoracoscopy Bilobectomy", wrvu: 27.81 },
 "32671": { name: "Thoracoscopy Pneumonectomy", wrvu: 31.12 },
 "32672": { name: "Thoracoscopy For Lvrs", wrvu: 26.33 },
 "32673": { name: "Thoracoscopy With Thymus Resection", wrvu: 20.60 },
 "32674": { name: "Thoracoscopy Lymphatic Node Excision", wrvu: 4.02 },
 "32701": { name: "Thorax Stereo Radical Targetw/Treatment", wrvu: 4.08 },
 "32800": { name: "Repair Lung Hernia", wrvu: 15.32 },
 "32810": { name: "Close Chest After Drainage", wrvu: 14.58 },
 "32815": { name: "Close Bronchial Fistula", wrvu: 48.78 },
 "32820": { name: "Reconstruct Injured Chest", wrvu: 21.95 },
 "32850": { name: "Donor Pneumonectomy", wrvu: 0.00 },
 "32851": { name: "Lung Transplant Single", wrvu: 58.15 },
 "32852": { name: "Lung Transplant With Bypass", wrvu: 63.86 },
 "32853": { name: "Lung Transplant Double", wrvu: 82.37 },
 "32854": { name: "Lung Transplant With Bypass", wrvu: 87.75 },
 "32855": { name: "Prepare Donor Lung Single", wrvu: 0.00 },
 "32856": { name: "Prepare Donor Lung Double", wrvu: 0.00 },
 "32900": { name: "Removal Of Rib(s)", wrvu: 23.21 },
 "32905": { name: "Revise & Repair Chest Wall", wrvu: 22.71 },
 "32906": { name: "Revise & Repair Chest Wall", wrvu: 28.57 },
 "32940": { name: "Revision Of Lung", wrvu: 20.81 },
 "32960": { name: "Therapeutic Pneumothorax", wrvu: 1.79 },
 "32994": { name: "Ablate Pulm Tumor Percutaneous Crybl", wrvu: 8.80 },
 "32997": { name: "Total Lung Lavage", wrvu: 7.13 },
 "32998": { name: "Ablate Pulm Tumor Percutaneous Rf", wrvu: 8.80 },
 "32999": { name: "Unlisted Procedure Lungs & Pleura", wrvu: 0.00 },
 "33016": { name: "Pericardiocentesis With Imaging", wrvu: 4.29 },
 "33017": { name: "Pericardial Drainage 6yr+ Without Cgen Car", wrvu: 4.50 },
 "33018": { name: "Pericardial Drainage 0-5yr Or With Anomly", wrvu: 5.27 },
 "33019": { name: "Percutaneous Pericardial Drainage Insertion Catheter CT", wrvu: 4.18 },
 "33020": { name: "Incision Of Heart Sac", wrvu: 13.95 },
 "33025": { name: "Incision Of Heart Sac", wrvu: 12.87 },
 "33030": { name: "Partial Removal Of Heart Sac", wrvu: 35.10 },
 "33031": { name: "Partial Removal Of Heart Sac", wrvu: 43.88 },
 "33050": { name: "Resection Heart Sac Lesion", wrvu: 16.55 },
 "33120": { name: "Excision Icar Tumor Resc With Card Byp", wrvu: 37.49 },
 "33130": { name: "Resection External Cardiac Tumor", wrvu: 23.57 },
 "33140": { name: "Heart Revascularize (tmr)", wrvu: 27.63 },
 "33141": { name: "Heart Tmr With Other Procedure", wrvu: 2.48 },
 "33202": { name: "Insert Epicard Eltrd Open", wrvu: 12.87 },
 "33203": { name: "Insert Epicard Eltrd Endoscopic", wrvu: 13.62 },
 "33206": { name: "Insert Heart Pacemaker Atrial", wrvu: 6.96 },
 "33207": { name: "Insert Heart Pacemaker Ventricular", wrvu: 7.61 },
 "33208": { name: "Insert Heart Pacemaker Atrial & Ventilation", wrvu: 8.31 },
 "33210": { name: "Insert Electrd/pacemaker Catheter Sngl", wrvu: 2.97 },
 "33211": { name: "Insert Card Electrodes Dual", wrvu: 3.06 },
 "33212": { name: "Insert Pulse Genital Sngl Lead", wrvu: 4.88 },
 "33213": { name: "Insert Pulse Genital Dual Leads", wrvu: 5.15 },
 "33214": { name: "Upgrade Of Pacemaker System", wrvu: 7.40 },
 "33215": { name: "Reposition Pacing-defib Lead", wrvu: 4.80 },
 "33216": { name: "Insert 1 Electrode Pacemaker-defib", wrvu: 5.48 },
 "33217": { name: "Insert 2 Electrode Pacemaker-defib", wrvu: 5.45 },
 "33218": { name: "Repair Lead Pace-defib One", wrvu: 5.67 },
 "33220": { name: "Repair Lead Pace-defib Dual", wrvu: 5.75 },
 "33221": { name: "Insert Pulse Genital Mult Leads", wrvu: 5.41 },
 "33222": { name: "Relocation Pocket Pacemaker", wrvu: 4.73 },
 "33223": { name: "Relocate Pocket For Defib", wrvu: 6.14 },
 "33224": { name: "Insert Pacing Lead & Connect", wrvu: 8.81 },
 "33225": { name: "L Ventric Pacing Lead Add-on", wrvu: 8.12 },
 "33226": { name: "Reposition L Ventric Lead", wrvu: 8.46 },
 "33227": { name: "Remove and replace Pacemaker Genital Singl", wrvu: 5.12 },
 "33228": { name: "Remv and replc Pacemaker Genital Dual Lead", wrvu: 5.38 },
 "33229": { name: "Remv and replc Pacemaker Genital Mult Leads", wrvu: 5.65 },
 "33230": { name: "Insert Pulse Genital With Dual Leads", wrvu: 5.92 },
 "33231": { name: "Insert Pulse Genital With Mult Leads", wrvu: 6.18 },
 "33233": { name: "Removal Of Pacemaker Generator", wrvu: 3.06 },
 "33234": { name: "Removal Of Pacemaker System", wrvu: 7.47 },
 "33235": { name: "Removal Pacemaker Electrode", wrvu: 9.65 },
 "33236": { name: "Remove Electrode/thoracotomy", wrvu: 12.41 },
 "33237": { name: "Remove Electrode/thoracotomy", wrvu: 13.49 },
 "33238": { name: "Remove Electrode/thoracotomy", wrvu: 15.02 },
 "33240": { name: "Insert Pulse Genital With Singl Lead", wrvu: 5.66 },
 "33241": { name: "Remove Pulse Generator", wrvu: 2.96 },
 "33243": { name: "Remove Eltrd/thoracotomy", wrvu: 22.98 },
 "33244": { name: "Remove Electrode Transvenously", wrvu: 13.40 },
 "33249": { name: "Insertion/Replacement Defib With Lead(s)", wrvu: 14.55 },
 "33250": { name: "Ablate Heart Dysrhythm Focus", wrvu: 25.25 },
 "33251": { name: "Ablate Heart Dysrhythm Focus", wrvu: 28.20 },
 "33254": { name: "Ablate Atria Lmtd", wrvu: 23.12 },
 "33255": { name: "Ablate Atria Without Bypass External", wrvu: 28.31 },
 "33256": { name: "Ablate Atria With Bypass Exten", wrvu: 34.03 },
 "33257": { name: "Ablate Atria Lmtd Add-on", wrvu: 9.39 },
 "33258": { name: "Ablate Atria X10sv Add-on", wrvu: 10.73 },
 "33259": { name: "Ablate Atria With Bypass Add-on", wrvu: 13.79 },
 "33261": { name: "Ablate Heart Dysrhythm Focus", wrvu: 28.20 },
 "33262": { name: "Removal& Replc Pulse Genital 1 Lead", wrvu: 5.66 },
 "33263": { name: "Removal & Replacement Dfb Genital 2 Lead", wrvu: 5.93 },
 "33264": { name: "Removal & Replacement Dfb Genital Mlt Ld", wrvu: 6.19 },
 "33265": { name: "Ablate Atria Lmtd Endoscopic", wrvu: 23.12 },
 "33266": { name: "Ablate Atria X10sv Endoscopic", wrvu: 32.21 },
 "33267": { name: "Excl Laa Open Any Method", wrvu: 18.04 },
 "33268": { name: "Excl Laa Open Oth Procedure Any Meth", wrvu: 2.44 },
 "33269": { name: "Excl Laa Thrscp Any Method", wrvu: 13.95 },
 "33270": { name: "Ins/rep Subcutaneous Defibrillator", wrvu: 8.87 },
 "33271": { name: "Insertion Subcutaneous Impltbl Dfb Electrode", wrvu: 7.31 },
 "33272": { name: "Removal Of Subcutaneous Defibrillator", wrvu: 5.28 },
 "33273": { name: "Repos Prev Impltbl Subcutaneous Dfb", wrvu: 6.34 },
 "33274": { name: "Tcat Insertion/rpl Permanent Ldls Pacemaker", wrvu: 7.61 },
 "33275": { name: "Tcat Removal Permanent Ldls Pacemaker With Imaging", wrvu: 8.38 },
 "33276": { name: "Insertion Phrnc Nerve Stimulation System", wrvu: 9.26 },
 "33277": { name: "Insertion Phrnc Nerve Stimulation Transvenous", wrvu: 5.29 },
 "33278": { name: "Removal Phrnc Nerve Stimulation System", wrvu: 9.31 },
 "33279": { name: "Removal Phrnc Nerve Stimulation Transvenous", wrvu: 5.28 },
 "33280": { name: "Removal Phrnc Nerve Stimulation Pg Only", wrvu: 2.96 },
 "33281": { name: "Reposg Phrnc Nerve Stimulation Trnsvn", wrvu: 5.85 },
 "33285": { name: "Insertion Subcutaneous Car Rhythm Mntr", wrvu: 1.49 },
 "33286": { name: "Removal Subcutaneous Car Rhythm Mntr", wrvu: 1.46 },
 "33287": { name: "Removal and Replacement Phrnc Nerve Stimulation Pg", wrvu: 5.90 },
 "33288": { name: "Removal and Replacement Phrnc Nerve Stimulation Ld", wrvu: 8.30 },
 "33289": { name: "Tcat Impl Wrls P-Artery Prs Snr", wrvu: 5.85 },
 "33300": { name: "Repair Of Heart Wound", wrvu: 43.85 },
 "33305": { name: "Repair Of Heart Wound", wrvu: 75.01 },
 "33310": { name: "Exploratory Heart Surgery", wrvu: 19.83 },
 "33315": { name: "Exploratory Heart Surgery", wrvu: 34.13 },
 "33320": { name: "Repair Major Blood Vessel(s)", wrvu: 18.08 },
 "33321": { name: "Repair Major Vessel", wrvu: 20.29 },
 "33322": { name: "Repair Major Blood Vessel(s)", wrvu: 23.81 },
 "33330": { name: "Insert Major Vessel Graft", wrvu: 24.66 },
 "33335": { name: "Insert Major Vessel Graft", wrvu: 33.06 },
 "33340": { name: "Percutaneous Closure Tcat L Atr Apndge", wrvu: 9.99 },
 "33361": { name: "Replace Aortic Valve Percutaneous", wrvu: 21.91 },
 "33362": { name: "Replace Aortic Valve Open", wrvu: 23.93 },
 "33363": { name: "Replace Aortic Valve Open", wrvu: 24.83 },
 "33364": { name: "Replace Aortic Valve Open", wrvu: 25.32 },
 "33365": { name: "Replace Aortic Valve Open", wrvu: 25.93 },
 "33366": { name: "Trcath Replace Aortic Valve", wrvu: 28.62 },
 "33367": { name: "Replace Aortic Valve With Byp", wrvu: 11.58 },
 "33368": { name: "Replace Aortic Valve With Byp", wrvu: 14.03 },
 "33369": { name: "Replace Aortic Valve With Byp", wrvu: 18.53 },
 "33370": { name: "Tcat Placement and Removal Cepd Percutaneous", wrvu: 2.44 },
 "33390": { name: "Valvuloplasty Aortic Valve", wrvu: 34.13 },
 "33391": { name: "Valvuloplasty Aortic Valve", wrvu: 40.46 },
 "33404": { name: "Prepare Heart-aorta Conduit", wrvu: 30.59 },
 "33405": { name: "Replacement Aortic Valve Open", wrvu: 40.29 },
 "33406": { name: "Replacement Aortic Valve Open", wrvu: 51.36 },
 "33410": { name: "Replacement Aortic Valve Open", wrvu: 45.25 },
 "33411": { name: "Replacement Of Aortic Valve", wrvu: 60.52 },
 "33412": { name: "Replacement Of Aortic Valve", wrvu: 57.53 },
 "33413": { name: "Replacement Of Aortic Valve", wrvu: 58.37 },
 "33414": { name: "Repair Of Aortic Valve", wrvu: 38.39 },
 "33415": { name: "Revision Subvalvular Tissue", wrvu: 36.34 },
 "33416": { name: "Revise Ventricle Muscle", wrvu: 35.65 },
 "33417": { name: "Repair Of Aortic Valve", wrvu: 28.60 },
 "33418": { name: "Repair Tcat Mitral Valve", wrvu: 31.44 },
 "33419": { name: "Repair Tcat Mitral Valve", wrvu: 7.73 },
 "33420": { name: "Revision Of Mitral Valve", wrvu: 25.15 },
 "33422": { name: "Revision Of Mitral Valve", wrvu: 28.99 },
 "33425": { name: "Repair Of Mitral Valve", wrvu: 48.71 },
 "33426": { name: "Repair Of Mitral Valve", wrvu: 42.20 },
 "33427": { name: "Repair Of Mitral Valve", wrvu: 43.71 },
 "33430": { name: "Replacement Of Mitral Valve", wrvu: 49.66 },
 "33440": { name: "Replacement A-valve Tlcj Autol Pv", wrvu: 62.40 },
 "33460": { name: "Revision Of Tricuspid Valve", wrvu: 43.58 },
 "33463": { name: "Valvuloplasty Tricuspid", wrvu: 55.65 },
 "33464": { name: "Valvuloplasty Tricuspid", wrvu: 43.50 },
 "33465": { name: "Replace Tricuspid Valve", wrvu: 49.45 },
 "33468": { name: "Revision Of Tricuspid Valve", wrvu: 44.00 },
 "33474": { name: "Revision Of Pulmonary Valve", wrvu: 38.42 },
 "33475": { name: "Replacement Pulmonary Valve", wrvu: 41.34 },
 "33476": { name: "Revision Of Heart Chamber", wrvu: 25.91 },
 "33477": { name: "Implant Tcat Pulm Vlv Percutaneous", wrvu: 24.38 },
 "33478": { name: "Revision Of Heart Chamber", wrvu: 26.85 },
 "33496": { name: "Repair Prosth Valve Clot", wrvu: 29.09 },
 "33500": { name: "Repair Heart Vessel Fistula", wrvu: 27.24 },
 "33501": { name: "Repair Heart Vessel Fistula", wrvu: 19.02 },
 "33502": { name: "Coronary Artery Correction", wrvu: 21.30 },
 "33503": { name: "Coronary Artery Graft", wrvu: 21.95 },
 "33504": { name: "Coronary Artery Graft", wrvu: 24.82 },
 "33505": { name: "Repair Artery With Tunnel", wrvu: 37.44 },
 "33506": { name: "Repair Artery Translocation", wrvu: 36.90 },
 "33507": { name: "Repair Artery Intramural", wrvu: 30.62 },
 "33508": { name: "Endoscopic Vein Harvest", wrvu: 0.30 },
 "33509": { name: "Endoscopy Hrv Uxtr Artery 1 Sgm Cab", wrvu: 3.26 },
 "33510": { name: "Coronary Artery Bypass Graft Vein Single", wrvu: 34.11 },
 "33511": { name: "Coronary Artery Bypass Graft Vein Two", wrvu: 37.49 },
 "33512": { name: "Coronary Artery Bypass Graft Vein Three", wrvu: 42.88 },
 "33513": { name: "Coronary Artery Bypass Graft Vein Four", wrvu: 44.24 },
 "33514": { name: "Coronary Artery Bypass Graft Vein Five", wrvu: 46.88 },
 "33516": { name: "Coronary Artery Bypass Graft Vein Six Or More", wrvu: 48.52 },
 "33517": { name: "Coronary Artery Bypass Graft Artery-vein Single", wrvu: 3.52 },
 "33518": { name: "Coronary Artery Bypass Graft Artery-vein Two", wrvu: 7.73 },
 "33519": { name: "Coronary Artery Bypass Graft Artery-vein Three", wrvu: 10.23 },
 "33521": { name: "Coronary Artery Bypass Graft Artery-vein Four", wrvu: 12.28 },
 "33522": { name: "Coronary Artery Bypass Graft Artery-vein Five", wrvu: 13.79 },
 "33523": { name: "Coronary Artery Bypass Graft Artery-vein Six Or More", wrvu: 15.68 },
 "33530": { name: "Coronary Artery Bypass/reop", wrvu: 9.88 },
 "33533": { name: "Coronary Artery Bypass Graft Arterial Single", wrvu: 32.91 },
 "33534": { name: "Coronary Artery Bypass Graft Arterial Two", wrvu: 38.88 },
 "33535": { name: "Coronary Artery Bypass Graft Arterial Three", wrvu: 43.63 },
 "33536": { name: "Coronary Artery Bypass Graft Arterial Four Or More", wrvu: 47.22 },
 "33542": { name: "Removal Of Heart Lesion", wrvu: 47.00 },
 "33545": { name: "Repair Of Heart Damage", wrvu: 55.63 },
 "33548": { name: "Restore/remodel Ventricle", wrvu: 52.79 },
 "33572": { name: "Open Coronary Endarterectomy", wrvu: 4.33 },
 "33600": { name: "Closure Of Valve", wrvu: 29.55 },
 "33602": { name: "Closure Of Valve", wrvu: 28.61 },
 "33606": { name: "Anastomosis/artery-aorta", wrvu: 30.74 },
 "33608": { name: "Repair Anomaly With Conduit", wrvu: 31.08 },
 "33610": { name: "Repair By Enlargement", wrvu: 30.62 },
 "33611": { name: "Repair Double Ventricle", wrvu: 34.68 },
 "33612": { name: "Repair Double Ventricle", wrvu: 35.66 },
 "33615": { name: "Repair Modified Fontan", wrvu: 34.99 },
 "33617": { name: "Repair Single Ventricle", wrvu: 38.11 },
 "33619": { name: "Repair Single Ventricle", wrvu: 47.54 },
 "33620": { name: "Apply R and l Pulm Artery Bands", wrvu: 29.25 },
 "33621": { name: "Transthor Catheter For Stent", wrvu: 15.78 },
 "33622": { name: "Redo Compl Cardiac Anomaly", wrvu: 62.40 },
 "33641": { name: "Repair Heart Septum Defect", wrvu: 28.84 },
 "33645": { name: "Revision Of Heart Veins", wrvu: 30.52 },
 "33647": { name: "Repair Heart Septum Defects", wrvu: 32.18 },
 "33660": { name: "Repair Of Heart Defects", wrvu: 31.03 },
 "33665": { name: "Repair Of Heart Defects", wrvu: 33.98 },
 "33670": { name: "Repair Of Heart Chambers", wrvu: 35.71 },
 "33675": { name: "Close Mult Vsd", wrvu: 35.05 },
 "33676": { name: "Close Mult Vsd With Resection", wrvu: 36.03 },
 "33677": { name: "Clinical Mult Vsd With Rem Pul Band", wrvu: 37.49 },
 "33681": { name: "Closure 1 Vsd With without Patch", wrvu: 31.53 },
 "33684": { name: "Closure 1 Vsd With without Patch With Vlvt", wrvu: 33.51 },
 "33688": { name: "Closure 1vsd With without Ptch Removal Bnd", wrvu: 33.88 },
 "33690": { name: "Banding Pulmonary Artery", wrvu: 19.85 },
 "33692": { name: "Comp Repair Tof without Pulm Atresia", wrvu: 35.25 },
 "33694": { name: "Comprehensive Metabolic Panel Repair Tof without Plm Atrs Ptch", wrvu: 34.68 },
 "33697": { name: "Compl Repair Tof With Pulm Atresia", wrvu: 36.63 },
 "33702": { name: "Repair Of Heart Defects", wrvu: 26.56 },
 "33710": { name: "Repair Of Heart Defects", wrvu: 36.56 },
 "33720": { name: "Repair Of Heart Defect", wrvu: 26.58 },
 "33724": { name: "Repair Venous Anomaly", wrvu: 26.94 },
 "33726": { name: "Repair Pul Venous Stenosis", wrvu: 36.19 },
 "33730": { name: "Repair Heart-vein Defect(s)", wrvu: 35.24 },
 "33732": { name: "Repair Heart-vein Defect", wrvu: 28.24 },
 "33735": { name: "Revision Of Heart Chamber", wrvu: 21.65 },
 "33736": { name: "Revision Of Heart Chamber", wrvu: 23.71 },
 "33741": { name: "Tas Congenital Car Anomal", wrvu: 13.65 },
 "33745": { name: "Tis Cgen Car Anomal 1st Shunt", wrvu: 19.50 },
 "33746": { name: "Tis Cgen Car Anomal Each Additional", wrvu: 7.80 },
 "33750": { name: "Shunt Subclavian To Pulm Artery", wrvu: 21.66 },
 "33755": { name: "Shunt As-Aortic To Pulm Artery", wrvu: 22.04 },
 "33762": { name: "Shunt Desc Aorta To Pulm Artery", wrvu: 22.04 },
 "33764": { name: "Shunt Central With Prostc Graft", wrvu: 22.04 },
 "33766": { name: "Shunt Superior V/c P-Artery 1 Lung", wrvu: 22.98 },
 "33767": { name: "Shunt Superior V/c P-Artery Bth Lung", wrvu: 24.67 },
 "33768": { name: "Anast Cavopulm Secondary Superior V/c", wrvu: 7.80 },
 "33770": { name: "Repair Tga Without Surgery Enlgmnt Vsd", wrvu: 38.09 },
 "33771": { name: "Repair Tga With Surgery Enlgmnt Vsd", wrvu: 39.61 },
 "33774": { name: "Repair Tga Atrial Baffle Procedure", wrvu: 30.94 },
 "33775": { name: "Repair Tga Atr Bfl Removal Plm Bnd", wrvu: 32.17 },
 "33776": { name: "Repair Tga Atr Bfl Closure Vsd", wrvu: 33.88 },
 "33777": { name: "Repair Tga Bfl Repair Sbpulm Obstr", wrvu: 33.32 },
 "33778": { name: "Repair Tga Aortic Pulm Artery Rcns", wrvu: 41.68 },
 "33779": { name: "Repair Tga Reconstruction Removal Plm Bnd", wrvu: 42.15 },
 "33780": { name: "Repair Tga Reconstruction Closure Vsd", wrvu: 42.80 },
 "33781": { name: "Repair Tga Reconstruction Repair Sbpl Obst", wrvu: 42.13 },
 "33782": { name: "Nikaidoh Procedure", wrvu: 58.58 },
 "33783": { name: "Nikaidoh Procedure With Ostia Implt", wrvu: 63.45 },
 "33786": { name: "Repair Arterial Trunk", wrvu: 40.82 },
 "33788": { name: "Revision Of Pulmonary Artery", wrvu: 26.73 },
 "33800": { name: "Aortic Suspension", wrvu: 16.85 },
 "33802": { name: "Division Aberrant Vessel", wrvu: 17.91 },
 "33803": { name: "Div Aberrant Vessel With Reanast", wrvu: 19.80 },
 "33814": { name: "Obltrj A-pulm Sep Def With Byp", wrvu: 25.91 },
 "33820": { name: "Repair Pda By Ligation", wrvu: 16.27 },
 "33822": { name: "Repair Pda Div<18 Years", wrvu: 17.27 },
 "33824": { name: "Repair Pda Div 18 Years and older", wrvu: 19.72 },
 "33840": { name: "Excision Coa With Direct Anastomosis", wrvu: 20.81 },
 "33845": { name: "Excision Coa With Graft", wrvu: 22.36 },
 "33851": { name: "Excision Coa Repair L Subcl Artery/Prostate", wrvu: 21.43 },
 "33852": { name: "Repair Hypopl A-arch without Byp", wrvu: 23.80 },
 "33853": { name: "Repair Hypopl A-arch With Byp", wrvu: 31.70 },
 "33858": { name: "As-Aortic Grf F/aortic Dissection", wrvu: 61.82 },
 "33859": { name: "As-Aortic Grf F/ds Other Than Dissection", wrvu: 44.00 },
 "33863": { name: "Ascending Aortic Graft", wrvu: 57.32 },
 "33864": { name: "Ascending Aortic Graft", wrvu: 58.58 },
 "33866": { name: "Aortic Hemiarch Graft", wrvu: 17.31 },
 "33871": { name: "Transvrs A-arch Grf Hypthrm", wrvu: 59.36 },
 "33875": { name: "Thoracic Aortic Graft", wrvu: 49.45 },
 "33877": { name: "Thoracoabdominal Graft", wrvu: 67.30 },
 "33880": { name: "Evasc Repair Ta Ndgft Cov Lsa", wrvu: 26.33 },
 "33881": { name: "Evasc Repair Ta Ndgft Xcov Lsa", wrvu: 21.97 },
 "33882": { name: "Evasc Repair Ta Dplmt Mltpc System", wrvu: 35.00 },
 "33883": { name: "Delayed Placement Proximal Extension Prosth", wrvu: 19.41 },
 "33886": { name: "Delayed Placement Dstl Extension Prosth", wrvu: 19.41 },
 "33894": { name: "Evasc Speech Therapy Repair Thoracic/aa Acrs Br", wrvu: 17.81 },
 "33895": { name: "Evasc Speech Therapy Repair Thoracic/aa X Crsg", wrvu: 14.18 },
 "33897": { name: "Percutaneous Trluml Angp Nt/recr Coa", wrvu: 10.54 },
 "33900": { name: "Percutaneous P-Artery Revsc 1 Nm Nt Uni", wrvu: 10.75 },
 "33901": { name: "Percutaneous P-Artery Revsc 1 Nm Nt Bi", wrvu: 14.14 },
 "33902": { name: "Percutaneous P-Artery Revsc 1 Abnor Uni", wrvu: 13.65 },
 "33903": { name: "Percutaneous P-Artery Revsc 1 Abnor Bi", wrvu: 16.09 },
 "33904": { name: "Percutaneous P-Artery Revsc Each Additional", wrvu: 5.39 },
 "33910": { name: "Remove Lung Artery Emboli", wrvu: 47.00 },
 "33915": { name: "Remove Lung Artery Emboli", wrvu: 24.33 },
 "33916": { name: "Surgery Of Great Vessel", wrvu: 76.05 },
 "33917": { name: "Repair Pulmonary Artery", wrvu: 24.67 },
 "33920": { name: "Repair Pulmonary Atresia", wrvu: 31.92 },
 "33922": { name: "Transect Pulmonary Artery", wrvu: 23.61 },
 "33924": { name: "Remove Pulmonary Shunt", wrvu: 5.35 },
 "33925": { name: "Repair Pul Artery Unifocal Without Cpb", wrvu: 30.52 },
 "33926": { name: "Repr Pul Artery Unifocal With Cpb", wrvu: 43.61 },
 "33927": { name: "Impltj Tot Replacement Heart System", wrvu: 47.78 },
 "33928": { name: "Removal & Replacement Tot Heart System", wrvu: 0.00 },
 "33929": { name: "Removal Replacement Heart System F/transplant", wrvu: 0.00 },
 "33930": { name: "Removal Of Donor Heart/lung", wrvu: 0.00 },
 "33933": { name: "Prepare Donor Heart/lung", wrvu: 0.00 },
 "33935": { name: "Transplantation Heart/lung", wrvu: 89.49 },
 "33940": { name: "Removal Of Donor Heart", wrvu: 0.00 },
 "33944": { name: "Prepare Donor Heart", wrvu: 0.00 },
 "33945": { name: "Transplantation Of Heart", wrvu: 87.26 },
 "33946": { name: "ECMO/ECLS Initiation Venous", wrvu: 5.85 },
 "33947": { name: "ECMO/ECLS Initiation Artery", wrvu: 6.46 },
 "33948": { name: "ECMO/ECLS Daily Management-venous", wrvu: 4.61 },
 "33949": { name: "ECMO/ECLS Daily Management Artery", wrvu: 4.49 },
 "33951": { name: "ECMO/ECLS Insertion Prph Cannula", wrvu: 7.95 },
 "33952": { name: "ECMO/ECLS Insertion Prph Cannula", wrvu: 7.95 },
 "33953": { name: "ECMO/ECLS Insertion Prph Cannula", wrvu: 8.88 },
 "33954": { name: "ECMO/ECLS Insertion Prph Cannula", wrvu: 8.88 },
 "33955": { name: "ECMO/ECLS Insertion Central Cannula", wrvu: 15.60 },
 "33956": { name: "ECMO/ECLS Insertion Central Cannula", wrvu: 15.60 },
 "33957": { name: "ECMO/ECLS Repos Perph Cnula", wrvu: 3.42 },
 "33958": { name: "ECMO/ECLS Repos Perph Cnula", wrvu: 3.42 },
 "33959": { name: "ECMO/ECLS Repos Perph Cnula", wrvu: 4.36 },
 "33962": { name: "ECMO/ECLS Repos Perph Cnula", wrvu: 4.36 },
 "33963": { name: "ECMO/ECLS Repos Perph Cnula", wrvu: 8.78 },
 "33964": { name: "ECMO/ECLS Repos Perph Cnula", wrvu: 9.26 },
 "33965": { name: "ECMO/ECLS Removal Perph Cannula", wrvu: 3.42 },
 "33966": { name: "ECMO/ECLS Removal Prph Cannula", wrvu: 4.39 },
 "33967": { name: "Insert I-Aortic Percutaneous Device", wrvu: 4.72 },
 "33968": { name: "Remove Aortic Assist Device", wrvu: 0.62 },
 "33969": { name: "ECMO/ECLS Removal Perph Cannula", wrvu: 5.09 },
 "33970": { name: "Aortic Circulation Assist", wrvu: 6.57 },
 "33971": { name: "Aortic Circulation Assist", wrvu: 11.69 },
 "33973": { name: "Insert Balloon Device", wrvu: 9.51 },
 "33974": { name: "Remove Intra-aortic Balloon", wrvu: 14.65 },
 "33975": { name: "Implant Ventricular Device", wrvu: 24.38 },
 "33976": { name: "Implant Ventricular Device", wrvu: 29.98 },
 "33977": { name: "Remove Ventricular Device", wrvu: 20.34 },
 "33978": { name: "Remove Ventricular Device", wrvu: 24.38 },
 "33979": { name: "Insert Intracorporeal Device", wrvu: 36.56 },
 "33980": { name: "Remove Intracorporeal Device", wrvu: 32.66 },
 "33981": { name: "Replace Vad Pump External", wrvu: 15.71 },
 "33982": { name: "Replace Vad Intra Without Bp", wrvu: 36.91 },
 "33983": { name: "Replace Vad Intra With Bp", wrvu: 43.43 },
 "33984": { name: "ECMO/ECLS Removal Prph Cannula", wrvu: 5.32 },
 "33985": { name: "ECMO/ECLS Removal Central Cannula", wrvu: 9.64 },
 "33986": { name: "ECMO/ECLS Removal Central Cannula", wrvu: 9.75 },
 "33987": { name: "Artery Expos/graft Artery", wrvu: 3.94 },
 "33988": { name: "Insertion Of Left Heart Ventilation", wrvu: 14.63 },
 "33989": { name: "Removal Of Left Heart Ventilation", wrvu: 9.26 },
 "33990": { name: "Insertion Percutaneous Vad L Heart Arterial", wrvu: 6.58 },
 "33991": { name: "Insertion Percutaneous Vad L Heart Artl and ven", wrvu: 8.62 },
 "33992": { name: "Removal Percutaneous Left Heart Vad", wrvu: 3.46 },
 "33993": { name: "Reposg Percutaneous R/l Heart Vad", wrvu: 3.02 },
 "33995": { name: "Insertion Percutaneous Vad R Heart Venous", wrvu: 6.58 },
 "33997": { name: "Removal Percutaneous Right Heart Vad", wrvu: 2.93 },
 "33999": { name: "Unlisted Procedure Cardiac Surgery", wrvu: 0.00 },
 "34001": { name: "Removal Of Artery Clot", wrvu: 17.43 },
 "34051": { name: "Removal Of Artery Clot", wrvu: 16.57 },
 "34101": { name: "Removal Of Artery Clot", wrvu: 10.66 },
 "34111": { name: "Removal Of Arm Artery Clot", wrvu: 10.66 },
 "34151": { name: "Removal Of Artery Clot", wrvu: 25.86 },
 "34201": { name: "Removal Of Artery Clot", wrvu: 18.99 },
 "34203": { name: "Removal Of Leg Artery Clot", wrvu: 17.41 },
 "34401": { name: "Removal Of Vein Clot", wrvu: 25.86 },
 "34421": { name: "Removal Of Vein Clot", wrvu: 13.04 },
 "34451": { name: "Removal Of Vein Clot", wrvu: 27.81 },
 "34471": { name: "Removal Of Vein Clot", wrvu: 20.58 },
 "34490": { name: "Removal Of Vein Clot", wrvu: 10.64 },
 "34501": { name: "Repair Valve Femoral Vein", wrvu: 16.43 },
 "34502": { name: "Reconstruct Vena Cava", wrvu: 27.37 },
 "34510": { name: "Transposition Of Vein Valve", wrvu: 19.41 },
 "34520": { name: "Cross-over Vein Graft", wrvu: 18.70 },
 "34530": { name: "Leg Vein Fusion", wrvu: 17.48 },
 "34701": { name: "Evasc Repair A-ao Ndgft", wrvu: 23.12 },
 "34702": { name: "Evasc Repair A-ao Ndgft Rpt", wrvu: 35.10 },
 "34703": { name: "Evasc Repair A-unilac Ndgft", wrvu: 25.86 },
 "34704": { name: "Evasc Repair A-unilac Ndgft Rpt", wrvu: 43.88 },
 "34705": { name: "Evac Repair A-biiliac Ndgft", wrvu: 28.84 },
 "34706": { name: "Evasc Repair A-biiliac Rpt", wrvu: 43.88 },
 "34707": { name: "Evasc Repair Ilio-iliac Ndgft", wrvu: 21.72 },
 "34708": { name: "Evasc Repair Ilio-iliac Rpt", wrvu: 35.59 },
 "34709": { name: "Placement Extension Prosth Evasc Repair", wrvu: 6.34 },
 "34710": { name: "Dlyd Placement Extension Prosth 1st Vessel", wrvu: 14.63 },
 "34711": { name: "Dlyd Placement Extension Prosth Each Additional", wrvu: 5.85 },
 "34712": { name: "Tcat Dlvr Enhncd Fixj Device", wrvu: 11.70 },
 "34713": { name: "Percutaneous Access & Closure Fem Artery", wrvu: 2.44 },
 "34714": { name: "Open Fem Artery Expos Cndt Crtj", wrvu: 5.12 },
 "34715": { name: "Open Axillary/subcla Artery Expos", wrvu: 5.85 },
 "34716": { name: "Open Axillary/subcla Artery Expos Cndt", wrvu: 7.01 },
 "34717": { name: "Evasc Repair A-iliac Ndgft", wrvu: 8.78 },
 "34718": { name: "Evasc Repair N/a A-iliac Ndgft", wrvu: 23.40 },
 "34808": { name: "Endovas Iliac A Device Addon", wrvu: 4.02 },
 "34812": { name: "Open Fem Artery Expos", wrvu: 4.03 },
 "34813": { name: "Femoral Endovas Graft Add-on", wrvu: 4.67 },
 "34820": { name: "Open Iliac Artery Expos", wrvu: 6.83 },
 "34830": { name: "Open Aortic Tube Prosth Repr", wrvu: 34.35 },
 "34831": { name: "Open Aortoiliac Prosth Repr", wrvu: 37.03 },
 "34832": { name: "Open Aortofemor Prosth Repr", wrvu: 37.03 },
 "34833": { name: "Open Ilac Artery Expos Cndt Crtj", wrvu: 7.96 },
 "34834": { name: "Open Brach Artery Expos", wrvu: 2.58 },
 "34839": { name: "Plnning Prothrombin Time Specimen Fenest Graft", wrvu: 0.00 },
 "34841": { name: "Endovasc Visc Aorta 1 Graft", wrvu: 0.00 },
 "34842": { name: "Endovasc Visc Aorta 2 Graft", wrvu: 0.00 },
 "34843": { name: "Endovasc Visc Aorta 3 Graft", wrvu: 0.00 },
 "34844": { name: "Endovasc Visc Aorta 4 Graft", wrvu: 0.00 },
 "34845": { name: "Visc & Infraren Abdominal 1 Prosth", wrvu: 0.00 },
 "34846": { name: "Visc & Infraren Abdominal 2 Prosth", wrvu: 0.00 },
 "34847": { name: "Visc & Infraren Abdominal 3 Prosth", wrvu: 0.00 },
 "34848": { name: "Visc & Infraren Abdominal 4+ Prost", wrvu: 0.00 },
 "35001": { name: "Repair Defect Of Artery", wrvu: 20.29 },
 "35002": { name: "Repair Artery Rupture Neck", wrvu: 21.67 },
 "35005": { name: "Repair Defect Of Artery", wrvu: 18.81 },
 "35011": { name: "Repair Defect Of Artery", wrvu: 18.12 },
 "35013": { name: "Repair Artery Rupture Arm", wrvu: 22.65 },
 "35021": { name: "Repair Defect Of Artery", wrvu: 21.62 },
 "35022": { name: "Repair Artery Rupture Chest", wrvu: 25.06 },
 "35045": { name: "Repair Defect Of Arm Artery", wrvu: 17.56 },
 "35081": { name: "Repair Defect Of Artery", wrvu: 32.69 },
 "35082": { name: "Repair Artery Rupture Aorta", wrvu: 41.04 },
 "35091": { name: "Repair Defect Of Artery", wrvu: 34.47 },
 "35092": { name: "Repair Artery Rupture Aorta", wrvu: 49.70 },
 "35102": { name: "Repair Defect Of Artery", wrvu: 35.62 },
 "35103": { name: "Repair Artery Rupture Aorta", wrvu: 42.53 },
 "35111": { name: "Repair Defect Of Artery", wrvu: 25.62 },
 "35112": { name: "Repair Artery Rupture Spleen", wrvu: 31.76 },
 "35121": { name: "Repair Defect Of Artery", wrvu: 30.73 },
 "35122": { name: "Repair Artery Rupture Belly", wrvu: 36.94 },
 "35131": { name: "Repair Defect Of Artery", wrvu: 25.74 },
 "35132": { name: "Repair Artery Rupture Groin", wrvu: 31.76 },
 "35141": { name: "Repair Defect Of Artery", wrvu: 20.39 },
 "35142": { name: "Repair Artery Rupture Thigh", wrvu: 24.53 },
 "35151": { name: "Repair Defect Of Artery", wrvu: 23.13 },
 "35152": { name: "Repair Ruptd Popliteal Artery", wrvu: 26.97 },
 "35180": { name: "Repair Cgen Av Fistula Head and Neck", wrvu: 14.72 },
 "35182": { name: "Repair Cgen Av Fistula Thrx and Abdominal", wrvu: 30.92 },
 "35184": { name: "Repair Cgen Av Fistula Xtr", wrvu: 18.35 },
 "35188": { name: "Repair Acq Av Fistula Head and neck", wrvu: 17.55 },
 "35189": { name: "Repair Acq Av Fistula Thrx and Abdominal", wrvu: 29.23 },
 "35190": { name: "Repair Acq Av Fistula Xtr", wrvu: 13.08 },
 "35201": { name: "Repair Blood Vessel Dir Neck", wrvu: 16.51 },
 "35206": { name: "Repair Blood Vessel Dir Uxtr", wrvu: 13.49 },
 "35207": { name: "Repair Bld Vessel Dir Hand Finger", wrvu: 10.67 },
 "35211": { name: "Repair Blvsl Dir Ntrathrc With Byp", wrvu: 23.97 },
 "35216": { name: "Repair Blvsl Dir Ntrthrc without Byp", wrvu: 35.69 },
 "35221": { name: "Repair Bld Vessel Dir Intra-Abdominal", wrvu: 25.95 },
 "35226": { name: "Repair Blood Vessel Dir Lxtr", wrvu: 14.92 },
 "35231": { name: "Repair Blvsl Vein Grf Neck", wrvu: 20.63 },
 "35236": { name: "Repair Blvsl Vein Grf Uxtr", wrvu: 17.57 },
 "35241": { name: "Repair Blvsl Vein Grf Ntrthrc With B", wrvu: 24.94 },
 "35246": { name: "Repair Blvsl Vein Grf Ntrthrc Without", wrvu: 27.52 },
 "35251": { name: "Repair Blvsl Vein Grf Intra-Abdominal", wrvu: 31.11 },
 "35256": { name: "Repair Blvsl Vein Grf Lxtr", wrvu: 18.58 },
 "35261": { name: "Repair Blvsl Grf Other Than Vein Neck", wrvu: 18.49 },
 "35266": { name: "Repair Blvsl Grf Oth/th Vein Uxtr", wrvu: 15.43 },
 "35271": { name: "Repair Blvs Gr Ot/th Vein Ntrth W", wrvu: 23.97 },
 "35276": { name: "Repair Blvs Gr Ot/t Vein Ntrth Without", wrvu: 25.18 },
 "35281": { name: "Repair Blvsl Gr Ot/th Vein Ntr-ab", wrvu: 29.31 },
 "35286": { name: "Repair Blvsl Grf Oth/th Vein Lxtr", wrvu: 16.76 },
 "35301": { name: "Rechanneling Of Artery", wrvu: 20.63 },
 "35302": { name: "Rechanneling Of Artery", wrvu: 20.82 },
 "35303": { name: "Rechanneling Of Artery", wrvu: 23.01 },
 "35304": { name: "Rechanneling Of Artery", wrvu: 23.99 },
 "35305": { name: "Rechanneling Of Artery", wrvu: 23.01 },
 "35306": { name: "Rechanneling Of Artery", wrvu: 9.02 },
 "35311": { name: "Rechanneling Of Artery", wrvu: 27.89 },
 "35321": { name: "Rechanneling Of Artery", wrvu: 16.18 },
 "35331": { name: "Rechanneling Of Artery", wrvu: 27.03 },
 "35341": { name: "Rechanneling Of Artery", wrvu: 25.55 },
 "35351": { name: "Rechanneling Of Artery", wrvu: 23.99 },
 "35355": { name: "Rechanneling Of Artery", wrvu: 19.36 },
 "35361": { name: "Rechanneling Of Artery", wrvu: 29.48 },
 "35363": { name: "Rechanneling Of Artery", wrvu: 31.54 },
 "35371": { name: "Rechanneling Of Artery", wrvu: 14.93 },
 "35372": { name: "Rechanneling Of Artery", wrvu: 18.12 },
 "35390": { name: "Reoperation Carotid Add-on", wrvu: 3.11 },
 "35400": { name: "Angioscopy", wrvu: 2.93 },
 "35500": { name: "Harvest Vein For Bypass", wrvu: 6.28 },
 "35501": { name: "Artery Byp Graft Ipsilateral Carotid", wrvu: 28.36 },
 "35506": { name: "Artery Byp Graft Subclav-carotid", wrvu: 24.70 },
 "35508": { name: "Artery Byp Graft Carotid-vertbrl", wrvu: 25.44 },
 "35509": { name: "Artery Byp Graft Contral Carotid", wrvu: 27.39 },
 "35510": { name: "Artery Byp Graft Carotid-brchial", wrvu: 23.78 },
 "35511": { name: "Artery Byp Graft Subclav-subclav", wrvu: 21.65 },
 "35512": { name: "Artery Byp Graft Subclav-brchial", wrvu: 23.29 },
 "35515": { name: "Artery Byp Graft Subclav-vertbrl", wrvu: 25.44 },
 "35516": { name: "Artery Byp Graft Subclav-axilary", wrvu: 23.60 },
 "35518": { name: "Artery Byp Graft Axillary-axilry", wrvu: 22.08 },
 "35521": { name: "Artery Byp Graft Axill-femoral", wrvu: 23.53 },
 "35522": { name: "Artery Byp Graft Axill-brachial", wrvu: 22.57 },
 "35523": { name: "Artery Byp Graft Brchl-ulnr-rdl", wrvu: 23.53 },
 "35525": { name: "Artery Byp Graft Brachial-brchl", wrvu: 21.15 },
 "35526": { name: "Artery Byp Graft Aor/carot/innom", wrvu: 30.76 },
 "35531": { name: "Artery Byp Graft Aorcel/aormesen", wrvu: 38.13 },
 "35533": { name: "Artery Byp Graft Axill/fem/fem", wrvu: 29.17 },
 "35535": { name: "Artery Byp Graft Hepatorenal", wrvu: 37.18 },
 "35536": { name: "Artery Byp Graft Splenorenal", wrvu: 32.89 },
 "35537": { name: "Artery Byp Graft Aortoiliac", wrvu: 40.83 },
 "35538": { name: "Artery Byp Graft Aortobi-iliac", wrvu: 45.85 },
 "35539": { name: "Artery Byp Graft Aortofemoral", wrvu: 43.01 },
 "35540": { name: "Artery Byp Graft Aortbifemoral", wrvu: 48.10 },
 "35556": { name: "Artery Byp Graft Fem-popliteal", wrvu: 26.08 },
 "35558": { name: "Artery Byp Graft Fem-femoral", wrvu: 22.55 },
 "35560": { name: "Artery Byp Graft Aortorenal", wrvu: 33.18 },
 "35563": { name: "Artery Byp Graft Ilioiliac", wrvu: 25.47 },
 "35565": { name: "Artery Byp Graft Iliofemoral", wrvu: 24.50 },
 "35566": { name: "Artery Byp Fem-Anterior-Posterior Tibial/prl", wrvu: 31.54 },
 "35570": { name: "Artery Byp Tibial-Tibial/peroneal", wrvu: 28.42 },
 "35571": { name: "Artery Byp Pop-tibl-prl-other", wrvu: 24.88 },
 "35572": { name: "Harvest Femoropopliteal Vein", wrvu: 6.64 },
 "35583": { name: "Vein Byp Graft Fem-popliteal", wrvu: 27.06 },
 "35585": { name: "Vein Byp Fem-tibial Peroneal", wrvu: 31.54 },
 "35587": { name: "Vein Byp Pop-tibl Peroneal", wrvu: 25.55 },
 "35600": { name: "Open Hrv Uxtr Artery 1 Sgm Cab", wrvu: 3.50 },
 "35601": { name: "Bpg Com Crtd-ipsi Int Crtd", wrvu: 26.41 },
 "35602": { name: "Bpg Crtd-clat Crtd", wrvu: 23.53 },
 "35606": { name: "Bpg Carotid-subclavian", wrvu: 21.90 },
 "35612": { name: "Bpg Subclavian-subclavian", wrvu: 19.84 },
 "35616": { name: "Bpg Subclavian-axillary", wrvu: 21.27 },
 "35621": { name: "Bpg Axillary-femoral", wrvu: 20.50 },
 "35623": { name: "Bpg Axillary-pop/-tibial", wrvu: 25.27 },
 "35626": { name: "Bpg Aor-subcla/innom/carotid", wrvu: 28.41 },
 "35631": { name: "Bpg Aor-celiac-msn-renal", wrvu: 35.13 },
 "35632": { name: "Bpg Ilio-celiac", wrvu: 35.23 },
 "35633": { name: "Bpg Ilio-mesenteric", wrvu: 38.13 },
 "35634": { name: "Bpg Iliorenal", wrvu: 34.45 },
 "35636": { name: "Bpg Splenorenal", wrvu: 30.96 },
 "35637": { name: "Bpg Aortoiliac", wrvu: 32.22 },
 "35638": { name: "Bpg Aortobi-iliac", wrvu: 32.76 },
 "35642": { name: "Bpg Carotid-vertebral", wrvu: 18.47 },
 "35645": { name: "Bpg Subclavian-vertebral", wrvu: 17.97 },
 "35646": { name: "Bpg Aortobifemoral", wrvu: 32.16 },
 "35647": { name: "Bpg Aortofemoral", wrvu: 28.99 },
 "35650": { name: "Bpg Axillary-axillary", wrvu: 19.66 },
 "35654": { name: "Bpg Axillary-femoral-femoral", wrvu: 25.62 },
 "35656": { name: "Bpg Femoral-popliteal", wrvu: 19.96 },
 "35661": { name: "Bpg Femoral-femoral", wrvu: 19.84 },
 "35663": { name: "Bpg Ilioiliac", wrvu: 23.33 },
 "35665": { name: "Bpg Iliofemoral", wrvu: 21.79 },
 "35666": { name: "Bpg Fem-Anterior Tibial Pst Tibial/prnl", wrvu: 23.07 },
 "35671": { name: "Bpg Pop-tibl/-prnl Artery", wrvu: 20.25 },
 "35681": { name: "Composite Byp Graft Pros and vein", wrvu: 1.56 },
 "35682": { name: "Composite Byp Graft 2 Veins", wrvu: 7.01 },
 "35683": { name: "Composite Byp Graft 3/> Segmt", wrvu: 8.28 },
 "35685": { name: "Bypass Graft Patency/patch", wrvu: 3.94 },
 "35686": { name: "Bypass Graft/av Fist Patency", wrvu: 3.26 },
 "35691": { name: "Artery Trnsposj Vertbrl Carotid", wrvu: 17.95 },
 "35693": { name: "Artery Trnsposj Subclavian", wrvu: 15.34 },
 "35694": { name: "Artery Trnsposj Subclav Carotid", wrvu: 18.80 },
 "35695": { name: "Artery Trnsposj Carotid Subclav", wrvu: 19.56 },
 "35697": { name: "Reimplant Artery Each", wrvu: 2.93 },
 "35700": { name: "Reoperation Bypass Graft", wrvu: 3.00 },
 "35701": { name: "Expl N/flwd Surgery Neck Artery", wrvu: 7.31 },
 "35702": { name: "Expl N/flwd Surgery Uxtr Artery", wrvu: 6.94 },
 "35703": { name: "Expl N/flwd Surgery Lxtr Artery", wrvu: 7.31 },
 "35800": { name: "Explore Neck Vessels", wrvu: 11.70 },
 "35820": { name: "Explore Chest Vessels", wrvu: 35.97 },
 "35840": { name: "Explore Abdominal Vessels", wrvu: 20.23 },
 "35860": { name: "Explore Limb Vessels", wrvu: 14.87 },
 "35870": { name: "Repair Vessel Graft Defect", wrvu: 23.89 },
 "35875": { name: "Removal Of Clot In Graft", wrvu: 10.45 },
 "35876": { name: "Removal Of Clot In Graft", wrvu: 17.37 },
 "35879": { name: "Revise Graft With Vein", wrvu: 16.97 },
 "35881": { name: "Revise Graft With Vein", wrvu: 18.87 },
 "35883": { name: "Revj Fem Anast Nonautog Grf", wrvu: 22.57 },
 "35884": { name: "Revj Fem Anast Autog Vein Grf", wrvu: 24.03 },
 "35901": { name: "Excision Graft Neck", wrvu: 8.17 },
 "35903": { name: "Excision Graft Extremity", wrvu: 9.29 },
 "35905": { name: "Excision Graft Thorax", wrvu: 32.68 },
 "35907": { name: "Excision Graft Abdomen", wrvu: 36.34 },
 "36000": { name: "Place Needle In Vein", wrvu: 0.18 },
 "36002": { name: "Pseudoaneurysm Injection Trt", wrvu: 1.91 },
 "36005": { name: "Injection External Venography", wrvu: 0.93 },
 "36010": { name: "Place Catheter In Vein", wrvu: 2.13 },
 "36011": { name: "Place Catheter In Vein", wrvu: 3.06 },
 "36012": { name: "Place Catheter In Vein", wrvu: 3.42 },
 "36013": { name: "Place Catheter In Artery", wrvu: 2.46 },
 "36014": { name: "Place Catheter In Artery", wrvu: 2.94 },
 "36015": { name: "Place Catheter In Artery", wrvu: 3.42 },
 "36100": { name: "Establish Access To Artery", wrvu: 2.94 },
 "36140": { name: "Intro Needle Icath Upper/lxtr Artery", wrvu: 1.72 },
 "36160": { name: "Establish Access To Aorta", wrvu: 2.46 },
 "36200": { name: "Place Catheter In Aorta", wrvu: 2.70 },
 "36215": { name: "Place Catheter In Artery", wrvu: 4.07 },
 "36216": { name: "Place Catheter In Artery", wrvu: 5.14 },
 "36217": { name: "Place Catheter In Artery", wrvu: 6.13 },
 "36218": { name: "Place Catheter In Artery", wrvu: 0.98 },
 "36221": { name: "Place Catheter Thoracic Aorta", wrvu: 3.82 },
 "36222": { name: "Place Catheter Carotid/inom Artery", wrvu: 5.15 },
 "36223": { name: "Place Catheter Carotid/inom Artery", wrvu: 5.61 },
 "36224": { name: "Place Catheter Carotd Artery", wrvu: 6.09 },
 "36225": { name: "Place Catheter Subclavian Artery", wrvu: 5.61 },
 "36226": { name: "Place Catheter Vertebral Artery", wrvu: 6.09 },
 "36227": { name: "Place Catheter Xtrnl Carotid", wrvu: 2.04 },
 "36228": { name: "Place Catheter Intracranial Artery", wrvu: 4.14 },
 "36245": { name: "Ins Catheter Abdominal/l-External Artery 1st", wrvu: 4.53 },
 "36246": { name: "Ins Catheter Abdominal/l-External Artery 2nd", wrvu: 4.89 },
 "36247": { name: "Ins Catheter Abdominal/l-External Artery 3rd", wrvu: 5.89 },
 "36248": { name: "Ins Catheter Abdominal/l-External Artery Additional", wrvu: 0.98 },
 "36251": { name: "Ins Catheter Ren Artery 1st Unilateral", wrvu: 4.97 },
 "36252": { name: "Ins Catheter Ren Artery 1st Bilateral", wrvu: 6.57 },
 "36253": { name: "Ins Catheter Ren Artery 2nd+ Unilateral", wrvu: 7.12 },
 "36254": { name: "Ins Catheter Ren Artery 2nd+ Bilateral", wrvu: 7.70 },
 "36260": { name: "Insertion Of Infusion Pump", wrvu: 9.66 },
 "36261": { name: "Revision Of Infusion Pump", wrvu: 5.49 },
 "36262": { name: "Removal Of Infusion Pump", wrvu: 4.01 },
 "36299": { name: "Unlisted Procedure Vascular Injection", wrvu: 0.00 },
 "36400": { name: "Vnpnxr<3yrs Physician/Qualified Health Professional Health Professional Femoral/Jugular", wrvu: 0.37 },
 "36405": { name: "Vnpnxr<3yrs Physician/Qualified Health Professional Health Professional Scalp Vein", wrvu: 0.30 },
 "36406": { name: "Vnpnxr<3yrs Physician/Qualified Health Professional Health Professional Other Vein", wrvu: 0.18 },
 "36410": { name: "Vnpnxr 3yr/> Physician/Qualified Health Professional Health Professional Diagnosis/Therapeutic", wrvu: 0.18 },
 "36415": { name: "Venipuncture, Routine Collection", wrvu: 0.00 },
 "36416": { name: "Capillary Blood Collection (e.g., finger, Heel, ear stick)", wrvu: 0.00 },
 "36420": { name: "Venipuncture Cutdown < 1 Year", wrvu: 0.98 },
 "36425": { name: "Venipuncture Cutdown 1 Year/>", wrvu: 0.74 },
 "36430": { name: "Transfusion Bld/bld Compnt", wrvu: 0.00 },
 "36440": { name: "Bld Push Tfuj 2 Year/<", wrvu: 1.00 },
 "36450": { name: "Bld Exchange Truj Newborn", wrvu: 3.41 },
 "36455": { name: "Bld Exchange Truj Oth Thn Nb", wrvu: 2.37 },
 "36456": { name: "Partial Exchange Transfuse Nb", wrvu: 1.95 },
 "36460": { name: "Intrauterine Transfusion Ftl", wrvu: 6.42 },
 "36465": { name: "Injection Noncmpnd Sclrsnt 1 Vein", wrvu: 2.29 },
 "36466": { name: "Injection Noncmpnd Sclrsnt Mlt Vein", wrvu: 2.93 },
 "36468": { name: "Injection Sclrsnt Spider Veins", wrvu: 0.00 },
 "36470": { name: "Injection Sclrsnt 1 Incmptnt Vein", wrvu: 0.73 },
 "36471": { name: "Injection Sclrsnt Mlt Incmptnt Vein", wrvu: 1.46 },
 "36473": { name: "Endovenous Mchnchem 1st Vein", wrvu: 3.41 },
 "36474": { name: "Endovenous Mchnchem Add-on", wrvu: 1.71 },
 "36475": { name: "Endovenous Rheumatoid Factor 1st Vein", wrvu: 5.17 },
 "36476": { name: "Endovenous Rheumatoid Factor Vein Add-on", wrvu: 2.58 },
 "36478": { name: "Endovenous Laser 1st Vein", wrvu: 5.17 },
 "36479": { name: "Endovenous Laser Vein Addon", wrvu: 2.58 },
 "36481": { name: "Insertion Of Catheter Vein", wrvu: 6.56 },
 "36482": { name: "Endoven Therapeutic Chem Adhes 1st", wrvu: 3.41 },
 "36483": { name: "Endoven Therapeutic Chem Adhes Subsequent", wrvu: 1.71 },
 "36500": { name: "Insertion Of Catheter Vein", wrvu: 3.42 },
 "36510": { name: "Insertion Of Catheter Vein", wrvu: 1.06 },
 "36511": { name: "Apheresis White Blood Cell", wrvu: 1.95 },
 "36512": { name: "Apheresis Reduction Blood Cell", wrvu: 1.95 },
 "36513": { name: "Apheresis Platelets", wrvu: 1.95 },
 "36514": { name: "Apheresis Plasma", wrvu: 1.76 },
 "36516": { name: "Apheresis Immunoads Slctv", wrvu: 1.52 },
 "36522": { name: "Photopheresis", wrvu: 1.71 },
 "36555": { name: "Insert Non-tunnel Cv Catheter", wrvu: 1.88 },
 "36556": { name: "Insert Non-tunnel Cv Catheter", wrvu: 1.71 },
 "36557": { name: "Insert Tunneled Cv Catheter", wrvu: 4.77 },
 "36558": { name: "Insert Tunneled Cv Catheter", wrvu: 4.48 },
 "36560": { name: "Insert Tunneled Cv Catheter", wrvu: 5.89 },
 "36561": { name: "Insert Tunneled Cv Catheter", wrvu: 5.65 },
 "36563": { name: "Insert Tunneled Cv Catheter", wrvu: 5.84 },
 "36565": { name: "Insert Tunneled Cv Catheter", wrvu: 5.65 },
 "36566": { name: "Insert Tunneled Cv Catheter", wrvu: 6.13 },
 "36568": { name: "Insertion Picc <5 Year Without Imaging", wrvu: 2.06 },
 "36569": { name: "Insertion Picc 5 Year+ Without Imaging", wrvu: 1.85 },
 "36570": { name: "Insert Picvad Catheter", wrvu: 4.98 },
 "36571": { name: "Insert Picvad Catheter", wrvu: 4.96 },
 "36572": { name: "Insertion Picc Rs and i <5 Year", wrvu: 1.77 },
 "36573": { name: "Insertion Picc Rs and i 5 Year+", wrvu: 1.66 },
 "36575": { name: "Repair Tunneled Cv Catheter", wrvu: 0.65 },
 "36576": { name: "Repair Tunneled Cv Catheter", wrvu: 2.92 },
 "36578": { name: "Replace Tunneled Cv Catheter", wrvu: 3.21 },
 "36580": { name: "Replace Cvad Catheter", wrvu: 1.28 },
 "36581": { name: "Replace Tunneled Cv Catheter", wrvu: 3.15 },
 "36582": { name: "Replace Tunneled Cv Catheter", wrvu: 4.87 },
 "36583": { name: "Replace Tunneled Cv Catheter", wrvu: 4.91 },
 "36584": { name: "Compl Replacement Picc Rs and i", wrvu: 1.17 },
 "36585": { name: "Replace Picvad Catheter", wrvu: 4.48 },
 "36589": { name: "Removal Tunneled Cv Catheter", wrvu: 2.22 },
 "36590": { name: "Removal Tunneled Cv Catheter", wrvu: 3.02 },
 "36591": { name: "Draw Blood Off Venous Device", wrvu: 0.00 },
 "36592": { name: "Collect Blood From Picc", wrvu: 0.00 },
 "36593": { name: "Declot Vascular Device", wrvu: 0.00 },
 "36595": { name: "Mech Remov Tunneled Cv Catheter", wrvu: 3.50 },
 "36596": { name: "Mech Remov Tunneled Cv Catheter", wrvu: 0.73 },
 "36597": { name: "Reposition Venous Catheter", wrvu: 1.18 },
 "36598": { name: "Injection With Fluoroscopic Evaluation Cv Device", wrvu: 0.72 },
 "36600": { name: "Withdrawal Of Arterial Blood", wrvu: 0.31 },
 "36620": { name: "Insertion Catheter Artery", wrvu: 0.98 },
 "36625": { name: "Insertion Catheter Artery", wrvu: 2.06 },
 "36640": { name: "Insertion Catheter Artery", wrvu: 2.05 },
 "36660": { name: "Insertion Catheter Artery", wrvu: 1.37 },
 "36680": { name: "Insert Needle Bone Cavity", wrvu: 1.17 },
 "36800": { name: "Insertion Of Cannula", wrvu: 2.37 },
 "36810": { name: "Insertion Of Cannula", wrvu: 3.86 },
 "36815": { name: "Insertion Of Cannula", wrvu: 2.55 },
 "36818": { name: "Av Fuse Uppr Arm Cephalic", wrvu: 12.08 },
 "36819": { name: "Av Fuse Uppr Arm Basilic", wrvu: 12.96 },
 "36820": { name: "Av Fusion/forearm Vein", wrvu: 12.74 },
 "36821": { name: "Av Fusion Direct Any Site", wrvu: 11.60 },
 "36823": { name: "Insertion Of Cannula(s)", wrvu: 22.41 },
 "36825": { name: "Artery-vein Autograft", wrvu: 13.82 },
 "36830": { name: "Artery-vein Nonautograft", wrvu: 11.73 },
 "36831": { name: "Open Thrombect Av Fistula", wrvu: 10.73 },
 "36832": { name: "Av Fistula Revision Open", wrvu: 13.16 },
 "36833": { name: "Av Fistula Revision", wrvu: 14.14 },
 "36835": { name: "Insertion Thomas Shunt", wrvu: 7.32 },
 "36836": { name: "Prq Av Fistula Crtj Uxtr 1 Acs", wrvu: 7.02 },
 "36837": { name: "Prq Av Fistula Crt Uxtr Sep Acs", wrvu: 9.07 },
 "36838": { name: "Distal Revas Ligation Hemo", wrvu: 21.15 },
 "36860": { name: "External Cannula Declotting", wrvu: 1.96 },
 "36861": { name: "Cannula Declotting", wrvu: 2.46 },
 "36901": { name: "Intro Catheter Dialysis Circuit", wrvu: 3.28 },
 "36902": { name: "Intro Catheter Dialysis Circuit", wrvu: 4.71 },
 "36903": { name: "Intro Catheter Dialysis Circuit", wrvu: 6.23 },
 "36904": { name: "Thrmbc/nfs Dialysis Circuit", wrvu: 7.31 },
 "36905": { name: "Thrmbc/nfs Dialysis Circuit", wrvu: 8.78 },
 "36906": { name: "Thrmbc/nfs Dialysis Circuit", wrvu: 10.16 },
 "36907": { name: "Balo Angiop Central Dialysis Seg", wrvu: 2.93 },
 "36908": { name: "Stent Placement Central Dialysis Seg", wrvu: 4.14 },
 "36909": { name: "Dialysis Circuit Embolj", wrvu: 4.02 },
 "37140": { name: "Revision Of Circulation", wrvu: 39.00 },
 "37145": { name: "Revision Of Circulation", wrvu: 36.08 },
 "37160": { name: "Revision Of Circulation", wrvu: 37.05 },
 "37180": { name: "Revision Of Circulation", wrvu: 35.59 },
 "37181": { name: "Splice Spleen/kidney Veins", wrvu: 39.00 },
 "37182": { name: "Insert Hepatectomy Shunt (tips)", wrvu: 16.55 },
 "37183": { name: "Revision Tips", wrvu: 7.55 },
 "37184": { name: "Prim Artery M-thrmbc 1st Vessel", wrvu: 8.20 },
 "37185": { name: "Prim Artery M-thrmbc Subsequent Vessel", wrvu: 3.20 },
 "37186": { name: "Secondary Artery Thrombectomy Add-on", wrvu: 4.80 },
 "37187": { name: "Venous Mech Thrombectomy", wrvu: 7.59 },
 "37188": { name: "Ven Mechnl Thrmbc Repeat Treatment", wrvu: 5.32 },
 "37191": { name: "Ins Endovas Vena Cava Filtr", wrvu: 4.35 },
 "37192": { name: "Redo Endovas Vena Cava Filtr", wrvu: 6.92 },
 "37193": { name: "Rem Endovas Vena Cava Filter", wrvu: 6.92 },
 "37195": { name: "Thrombolytic Therapy Stroke", wrvu: 0.00 },
 "37197": { name: "Remove Intrvas Foreign Body", wrvu: 5.89 },
 "37200": { name: "Transcatheter Biopsy", wrvu: 4.44 },
 "37211": { name: "Thrombolytic Artery Therapy", wrvu: 7.56 },
 "37212": { name: "Thrombolytic Venous Therapy", wrvu: 6.64 },
 "37213": { name: "Thromblytic Artery/ven Therapy", wrvu: 4.63 },
 "37214": { name: "Cessj Therapy Catheter Removal", wrvu: 2.43 },
 "37215": { name: "Transcath Stent Cca With Eps", wrvu: 17.31 },
 "37216": { name: "Transcath Stent Cca Without Eps", wrvu: 17.53 },
 "37217": { name: "Stent Placemt Retro Carotid", wrvu: 19.87 },
 "37218": { name: "Stent Placemt Ante Carotid", wrvu: 14.38 },
 "37236": { name: "Open/Percutaneous Place Stent 1st", wrvu: 8.53 },
 "37237": { name: "Open/Percutaneous Place Stent Each Add", wrvu: 4.14 },
 "37238": { name: "Open/Percutaneous Place Stent Same", wrvu: 5.89 },
 "37239": { name: "Open/Percutaneous Place Stent Each Add", wrvu: 2.90 },
 "37241": { name: "Vasc Embolize/occlude Venous", wrvu: 8.53 },
 "37242": { name: "Vasc Embolize/occlude Artery", wrvu: 9.56 },
 "37243": { name: "Vasc Embolize/occlude Organ", wrvu: 11.45 },
 "37244": { name: "Vasc Embolize/occlude Bleed", wrvu: 13.41 },
 "37246": { name: "Trluml Balo Angiop 1st Artery", wrvu: 6.83 },
 "37247": { name: "Trluml Balo Angiop Additional Artery", wrvu: 3.41 },
 "37248": { name: "Trluml Balo Angiop 1st Vein", wrvu: 5.85 },
 "37249": { name: "Trluml Balo Angiop Additional Vein", wrvu: 2.90 },
 "37252": { name: "Intrvasc Ultrasound Noncoronary 1st", wrvu: 1.76 },
 "37253": { name: "Intrvasc Ultrasound Noncoronary Additional", wrvu: 1.40 },
 "37254": { name: "Revsc Evasc Ivt Angiography Sf 1st", wrvu: 7.30 },
 "37255": { name: "Revsc Evasc Ivt Angiography Sf Each", wrvu: 3.00 },
 "37256": { name: "Revsc Evasc Ivt Angiography Cplx 1", wrvu: 10.75 },
 "37257": { name: "Revsc Evsc Ivt Angiography Cplx Each", wrvu: 3.89 },
 "37258": { name: "Revsc Evasc Ivt Stent Sf 1st", wrvu: 8.75 },
 "37259": { name: "Revsc Evasc Ivt Stent Sf Each", wrvu: 4.00 },
 "37260": { name: "Revsc Evasc Ivt Staple Cplx 1st", wrvu: 12.69 },
 "37261": { name: "Revsc Evasc Ivt Staple Cplx Each", wrvu: 4.25 },
 "37262": { name: "Intravenous Lithotrp Ivt With In Sm Artery", wrvu: 3.00 },
 "37263": { name: "Revsc Evasc Fpvt Angiography Sf 1", wrvu: 7.75 },
 "37264": { name: "Revsc Evasc Fpvt Angiography Sf Each", wrvu: 3.00 },
 "37265": { name: "Revsc Evsc Fpvt Angiography Cplx 1", wrvu: 10.50 },
 "37266": { name: "Rvsc Evsc Fpvt Angiography Cplx Each", wrvu: 4.00 },
 "37267": { name: "Revsc Evsc Fpvt Stent Sf 1st", wrvu: 8.75 },
 "37268": { name: "Revsc Evasc Fpvt Stent Sf Each", wrvu: 3.73 },
 "37269": { name: "Revsc Evasc Fpvt Staple Cplx 1st", wrvu: 14.75 },
 "37270": { name: "Revsc Evasc Fpvt Staple Cplx Each", wrvu: 5.00 },
 "37271": { name: "Revsc Evsc Fpvt Athrc Sf 1st", wrvu: 9.00 },
 "37272": { name: "Revsc Evsc Fpvt Athrc Sf Each", wrvu: 4.00 },
 "37273": { name: "Revsc Evsc Fpvt Athrc Cplx 1", wrvu: 12.63 },
 "37274": { name: "Rvsc Evsc Fpvt Athrc Cplx Each", wrvu: 5.50 },
 "37275": { name: "Rvsc Evsc Fpvt Speech Therapy Athrc Sf 1", wrvu: 11.00 },
 "37276": { name: "Rvsc Evsc Fpvt Speech Therapy Athr Sf Each", wrvu: 4.25 },
 "37277": { name: "Rvsc Evsc Fpvt Speech Therapy Athr Cpx 1", wrvu: 15.00 },
 "37278": { name: "Rvsc Evsc Fpvt Speech Therapy Ath Cpx Each", wrvu: 6.00 },
 "37279": { name: "Intravenous Lithotrp Fpvt With In Sm Artery", wrvu: 4.00 },
 "37280": { name: "Revsc Evsc Tpvt Angiography Sf 1st", wrvu: 9.80 },
 "37281": { name: "Revsc Evsc Tpvt Angiography Sf Each", wrvu: 3.00 },
 "37282": { name: "Rvsc Evsc Tpvt Angiography Cplx 1", wrvu: 12.31 },
 "37283": { name: "Rvsc Evsc Tpvt Angiography Cplx Each", wrvu: 4.26 },
 "37284": { name: "Revsc Evasc Tpvt Speech Therapy Sf 1st", wrvu: 10.00 },
 "37285": { name: "Revsc Evasc Tpvt Speech Therapy Sf Each", wrvu: 3.34 },
 "37286": { name: "Revsc Evasc Tpvt Staple Cplx 1st", wrvu: 13.46 },
 "37287": { name: "Revsc Evasc Tpvt Staple Cplx Each", wrvu: 5.00 },
 "37288": { name: "Revsc Evsc Tpvt Athrc Sf 1st", wrvu: 13.50 },
 "37289": { name: "Revsc Evsc Tpvt Athrc Sf Each", wrvu: 4.75 },
 "37290": { name: "Revsc Evsc Tpvt Athrc Cplx 1", wrvu: 17.00 },
 "37291": { name: "Revsc Evsc Tpvt Athr Cplx Each", wrvu: 6.50 },
 "37292": { name: "Rvsc Evsc Tpvt Speech Therapy Athrc Sf 1", wrvu: 15.00 },
 "37293": { name: "Rvsc Evsc Tpvt Speech Therapy Athr Sf Each", wrvu: 6.50 },
 "37294": { name: "Rvsc Evsc Tpvt Speech Therapy Athr Cpx 1", wrvu: 18.00 },
 "37295": { name: "Rvsc Evsc Tpvt Speech Therapy Ath Cpx Each", wrvu: 8.16 },
 "37296": { name: "Revsc Evasc Imvt Angiography Sf 1", wrvu: 11.00 },
 "37297": { name: "Revsc Evasc Imvt Angiography Sf Each", wrvu: 4.00 },
 "37298": { name: "Revsc Evsc Imvt Angiography Cplx 1", wrvu: 13.70 },
 "37299": { name: "Revsc Evsc Imvt Angiography Cpx Each", wrvu: 5.00 },
 "37501": { name: "Unlisted Vasc Endoscopy Procedure", wrvu: 0.00 },
 "37565": { name: "Ligation Int Jugular Vein", wrvu: 11.75 },
 "37600": { name: "Ligation Xtrnl Carotid Artery", wrvu: 12.11 },
 "37605": { name: "Ligation Int/com Carotid Artery", wrvu: 13.92 },
 "37606": { name: "Ligation Int/com Carotid Artery Occl", wrvu: 8.59 },
 "37607": { name: "Ligation/banding Angioacs Av Fistula", wrvu: 6.09 },
 "37609": { name: "Ligation/Biopsy Temporal Artery", wrvu: 2.97 },
 "37615": { name: "Ligation Major Artery Neck", wrvu: 7.61 },
 "37616": { name: "Ligation Major Artery Chest", wrvu: 18.50 },
 "37617": { name: "Ligation Major Artery Abdominal", wrvu: 23.20 },
 "37618": { name: "Ligation Major Artery Xtr", wrvu: 5.88 },
 "37619": { name: "Ligation Of Inferior Vena Cava", wrvu: 29.25 },
 "37650": { name: "Ligation Of Femoral Vein", wrvu: 8.28 },
 "37660": { name: "Ligation Common Iliac Vein", wrvu: 21.72 },
 "37700": { name: "Ligation and div Long Saph Vein", wrvu: 3.72 },
 "37718": { name: "Ligation Div and strpg Short Saph Vein", wrvu: 6.95 },
 "37722": { name: "Ligation Div and strpg Long Saph Vein", wrvu: 7.96 },
 "37735": { name: "Ligation and div and compl Strpg Saph Vein", wrvu: 10.63 },
 "37760": { name: "Ligation Prfratr Vein Radical 1 Leg", wrvu: 10.51 },
 "37761": { name: "Ligate Leg Veins Open", wrvu: 8.90 },
 "37765": { name: "Stab Phleb Veins Xtr 10-20", wrvu: 4.68 },
 "37766": { name: "Phleb Veins - Extrem 20+", wrvu: 5.85 },
 "37780": { name: "Revision Of Leg Vein", wrvu: 3.83 },
 "37785": { name: "Ligate/divide/excise Vein", wrvu: 3.83 },
 "37788": { name: "Revascularization Penis", wrvu: 22.75 },
 "37790": { name: "Penile Venous Occlusion", wrvu: 8.22 },
 "37799": { name: "Unlisted Procedure Vascular Surgery", wrvu: 0.00 },
 "38100": { name: "Removal Of Spleen Total", wrvu: 19.06 },
 "38101": { name: "Removal Of Spleen Partial", wrvu: 19.06 },
 "38102": { name: "Removal Of Spleen Total", wrvu: 4.67 },
 "38115": { name: "Repair Of Ruptured Spleen", wrvu: 21.33 },
 "38120": { name: "Laparoscopy Splenectomy", wrvu: 16.64 },
 "38129": { name: "Unlisted Laps Procedure Spleen", wrvu: 0.00 },
 "38200": { name: "Injection For Spleen X-ray", wrvu: 2.57 },
 "38204": { name: "Bl Donor Search Management", wrvu: 1.95 },
 "38205": { name: "Harvest Allogeneic Stem Cell", wrvu: 1.46 },
 "38206": { name: "Harvest Auto Stem Cells", wrvu: 1.46 },
 "38207": { name: "Cryopreserve Stem Cells", wrvu: 0.87 },
 "38208": { name: "Thaw Preserved Stem Cells", wrvu: 0.55 },
 "38209": { name: "Wash Harvest Stem Cells", wrvu: 0.23 },
 "38210": { name: "T-cell Depletion Of Harvest", wrvu: 1.53 },
 "38211": { name: "Tumor Cell Deplete Of Harvst", wrvu: 1.38 },
 "38212": { name: "Reduction Blood Cell Depletion Of Harvest", wrvu: 0.92 },
 "38213": { name: "Platelet Deplete Of Harvest", wrvu: 0.23 },
 "38214": { name: "Volume Deplete Of Harvest", wrvu: 0.79 },
 "38215": { name: "Harvest Stem Cell Concentrte", wrvu: 0.92 },
 "38220": { name: "Diagnosis Bone Marrow Aspirations", wrvu: 1.17 },
 "38221": { name: "Diagnosis Bone Marrow Biopsies", wrvu: 1.25 },
 "38222": { name: "Diagnosis Bone Marrow Biopsy & Aspiration", wrvu: 1.40 },
 "38225": { name: "Car-t Hrv Bld-drv T Lymphcyt", wrvu: 1.89 },
 "38226": { name: "Car-t Prep T Lymphcyt F/trns", wrvu: 0.77 },
 "38227": { name: "Car-t Receipt and prepj Admn", wrvu: 0.78 },
 "38228": { name: "Car-t Admn Autologous", wrvu: 3.00 },
 "38230": { name: "Bone Marrow Harvest Allogen", wrvu: 3.41 },
 "38232": { name: "Bone Marrow Harvest Autolog", wrvu: 3.41 },
 "38240": { name: "Transplt Allo Hematocrit/donor", wrvu: 3.90 },
 "38241": { name: "Transplt Autol Hematocrit/donor", wrvu: 2.93 },
 "38242": { name: "Transplt Allo Lymphocytes", wrvu: 2.06 },
 "38243": { name: "Transplj Hematopoietic Boost", wrvu: 2.08 },
 "38300": { name: "Drainage Lymphatic Node Lesion", wrvu: 2.30 },
 "38305": { name: "Drainage Lymphatic Node Lesion", wrvu: 6.51 },
 "38308": { name: "Incision Of Lymphatic Channels", wrvu: 6.64 },
 "38380": { name: "Thoracic Duct Procedure", wrvu: 8.25 },
 "38381": { name: "Thoracic Duct Procedure", wrvu: 13.05 },
 "38382": { name: "Thoracic Duct Procedure", wrvu: 10.38 },
 "38500": { name: "Biopsy/removal Lymphatic Nodes", wrvu: 3.70 },
 "38505": { name: "Needle Biopsy Lymphatic Nodes", wrvu: 1.55 },
 "38510": { name: "Biopsy/removal Lymphatic Nodes", wrvu: 6.57 },
 "38520": { name: "Biopsy/removal Lymphatic Nodes", wrvu: 6.85 },
 "38525": { name: "Biopsy/removal Lymphatic Nodes", wrvu: 6.27 },
 "38530": { name: "Biopsy/removal Lymphatic Nodes", wrvu: 8.13 },
 "38531": { name: "Open Biopsy/Excision Inguinofem Nodes", wrvu: 6.57 },
 "38542": { name: "Explore Deep Node(s) Neck", wrvu: 7.75 },
 "38550": { name: "Removal Neck/armpit Lesion", wrvu: 6.93 },
 "38555": { name: "Removal Neck/armpit Lesion", wrvu: 15.20 },
 "38562": { name: "Removal Pelvic Lymphatic Nodes", wrvu: 10.78 },
 "38564": { name: "Removal Abdomen Lymphatic Nodes", wrvu: 11.10 },
 "38570": { name: "Laparoscopy Lymphatic Node Biop", wrvu: 8.28 },
 "38571": { name: "Laparoscopy Lymphadenectomy", wrvu: 11.70 },
 "38572": { name: "Laparoscopy Lymphadenectomy", wrvu: 15.21 },
 "38573": { name: "Laps Pelvic Lymphadec", wrvu: 19.50 },
 "38589": { name: "Unlisted Laps Procedure Lymphtc System", wrvu: 0.00 },
 "38700": { name: "Removal Of Lymphatic Nodes Neck", wrvu: 12.49 },
 "38720": { name: "Removal Of Lymphatic Nodes Neck", wrvu: 21.40 },
 "38724": { name: "Removal Of Lymphatic Nodes Neck", wrvu: 23.35 },
 "38740": { name: "Remove Armpit Lymphatic Nodes", wrvu: 10.43 },
 "38745": { name: "Remove Armpit Lymphatic Nodes", wrvu: 13.52 },
 "38746": { name: "Remove Thoracic Lymphatic Nodes", wrvu: 4.02 },
 "38747": { name: "Remove Abdominal Lymphatic Nodes", wrvu: 4.76 },
 "38760": { name: "Remove Groin Lymphatic Nodes", wrvu: 13.28 },
 "38765": { name: "Remove Groin Lymphatic Nodes", wrvu: 21.36 },
 "38770": { name: "Remove Pelvis Lymphatic Nodes", wrvu: 13.71 },
 "38780": { name: "Remove Abdomen Lymphatic Nodes", wrvu: 17.26 },
 "38790": { name: "Inject For Lymphatic X-ray", wrvu: 1.26 },
 "38792": { name: "Ra Tracer Id Of Sentinl Node", wrvu: 0.63 },
 "38794": { name: "Access Thoracic Lymphatic Duct", wrvu: 4.50 },
 "38900": { name: "Io Map Of Sent Lymphatic Node", wrvu: 2.44 },
 "38999": { name: "Unlistd Procedure Hemic/lymphtc System", wrvu: 0.00 },
 "39000": { name: "Exploration Of Chest", wrvu: 7.38 },
 "39010": { name: "Exploration Of Chest", wrvu: 12.86 },
 "39200": { name: "Resection Mediastinal Cyst", wrvu: 14.71 },
 "39220": { name: "Resection Mediastinal Tumor", wrvu: 19.06 },
 "39401": { name: "Mediastinoscpy With Medstnl Biopsy", wrvu: 5.30 },
 "39402": { name: "Mediastinoscpy With Lmph Nod Biopsy", wrvu: 7.07 },
 "39499": { name: "Unlisted Procedure Mediastinum", wrvu: 0.00 },
 "39501": { name: "Repair Diaphragm Laceration", wrvu: 13.63 },
 "39503": { name: "Repair Of Diaphragm Hernia", wrvu: 106.19 },
 "39540": { name: "Repair Of Diaphragm Hernia", wrvu: 14.21 },
 "39541": { name: "Repair Of Diaphragm Hernia", wrvu: 15.36 },
 "39545": { name: "Revision Of Diaphragm", wrvu: 14.30 },
 "39560": { name: "Resection Diaphragm Simple", wrvu: 12.73 },
 "39561": { name: "Resection Diaphragm Complex", wrvu: 19.49 },
 "39599": { name: "Unlisted Procedure Diaphragm", wrvu: 0.00 },
 "40490": { name: "Biopsy Of Lip", wrvu: 1.19 },
 "40500": { name: "Partial Excision Of Lip", wrvu: 4.36 },
 "40510": { name: "Partial Excision Of Lip", wrvu: 4.70 },
 "40520": { name: "Partial Excision Of Lip", wrvu: 4.67 },
 "40525": { name: "Reconstruct Lip With Flap", wrvu: 7.53 },
 "40527": { name: "Reconstruct Lip With Flap", wrvu: 9.09 },
 "40530": { name: "Partial Removal Of Lip", wrvu: 5.40 },
 "40650": { name: "Repair Lip Full Thickness Vermilion Only", wrvu: 3.69 },
 "40652": { name: "Repair Lip Full Thickness<half Ver Height", wrvu: 4.32 },
 "40654": { name: "Repair Lip Full Thickness>1half Ver Ht/cpx", wrvu: 5.34 },
 "40700": { name: "Repair Cleft Lip/nasal", wrvu: 13.82 },
 "40701": { name: "Repair Cleft Lip/nasal", wrvu: 16.80 },
 "40702": { name: "Repair Cleft Lip/nasal", wrvu: 13.91 },
 "40720": { name: "Repair Cleft Lip/nasal", wrvu: 14.35 },
 "40761": { name: "Repair Cleft Lip/nasal", wrvu: 15.44 },
 "40799": { name: "Unlisted Procedure Lips", wrvu: 0.00 },
 "40800": { name: "Drainage Of Mouth Lesion", wrvu: 1.20 },
 "40801": { name: "Drainage Of Mouth Lesion", wrvu: 2.56 },
 "40804": { name: "Removal Foreign Body Mouth", wrvu: 1.27 },
 "40805": { name: "Removal Foreign Body Mouth", wrvu: 2.72 },
 "40806": { name: "Incision Of Lip Fold", wrvu: 0.30 },
 "40808": { name: "Biopsy Of Mouth Lesion", wrvu: 1.02 },
 "40810": { name: "Excision Of Mouth Lesion", wrvu: 1.33 },
 "40812": { name: "Excise/repair Mouth Lesion", wrvu: 2.31 },
 "40814": { name: "Excise/repair Mouth Lesion", wrvu: 3.43 },
 "40816": { name: "Excision Of Mouth Lesion", wrvu: 3.68 },
 "40818": { name: "Excise Oral Mucosa For Graft", wrvu: 2.76 },
 "40819": { name: "Excise Lip Or Cheek Fold", wrvu: 2.45 },
 "40820": { name: "Treatment Of Mouth Lesion", wrvu: 1.31 },
 "40830": { name: "Repair Mouth Laceration", wrvu: 1.77 },
 "40831": { name: "Repair Mouth Laceration", wrvu: 2.51 },
 "40840": { name: "Reconstruction Of Mouth", wrvu: 8.92 },
 "40842": { name: "Reconstruction Of Mouth", wrvu: 8.92 },
 "40843": { name: "Reconstruction Of Mouth", wrvu: 12.47 },
 "40844": { name: "Reconstruction Of Mouth", wrvu: 16.38 },
 "40845": { name: "Reconstruction Of Mouth", wrvu: 18.88 },
 "40899": { name: "Unlisted Procedure Vestibule Mouth", wrvu: 0.00 },
 "41000": { name: "Drainage Of Mouth Lesion", wrvu: 1.32 },
 "41005": { name: "Drainage Of Mouth Lesion", wrvu: 1.28 },
 "41006": { name: "Drainage Of Mouth Lesion", wrvu: 3.26 },
 "41007": { name: "Drainage Of Mouth Lesion", wrvu: 3.12 },
 "41008": { name: "Drainage Of Mouth Lesion", wrvu: 3.37 },
 "41009": { name: "Drainage Of Mouth Lesion", wrvu: 3.62 },
 "41010": { name: "Incision Of Tongue Fold", wrvu: 1.08 },
 "41015": { name: "Drainage Of Mouth Lesion", wrvu: 3.98 },
 "41016": { name: "Drainage Of Mouth Lesion", wrvu: 4.09 },
 "41017": { name: "Drainage Of Mouth Lesion", wrvu: 4.09 },
 "41018": { name: "Drainage Of Mouth Lesion", wrvu: 5.09 },
 "41019": { name: "Place Needles H and n For Right", wrvu: 8.62 },
 "41100": { name: "Biopsy Of Tongue", wrvu: 1.38 },
 "41105": { name: "Biopsy Of Tongue", wrvu: 1.43 },
 "41108": { name: "Biopsy Of Floor Of Mouth", wrvu: 1.07 },
 "41110": { name: "Excision Of Tongue Lesion", wrvu: 1.52 },
 "41112": { name: "Excision Of Tongue Lesion", wrvu: 2.76 },
 "41113": { name: "Excision Of Tongue Lesion", wrvu: 3.21 },
 "41114": { name: "Excision Of Tongue Lesion", wrvu: 8.60 },
 "41115": { name: "Excision Of Tongue Fold", wrvu: 1.75 },
 "41116": { name: "Excision Of Mouth Lesion", wrvu: 2.46 },
 "41120": { name: "Partial Removal Of Tongue", wrvu: 10.86 },
 "41130": { name: "Partial Removal Of Tongue", wrvu: 15.35 },
 "41135": { name: "Tongue And Neck Surgery", wrvu: 29.39 },
 "41140": { name: "Removal Of Tongue", wrvu: 28.42 },
 "41145": { name: "Tongue Removal Neck Surgery", wrvu: 36.98 },
 "41150": { name: "Tongue Mouth Jaw Surgery", wrvu: 29.11 },
 "41153": { name: "Tongue Mouth Neck Surgery", wrvu: 32.75 },
 "41155": { name: "Tongue Jaw & Neck Surgery", wrvu: 43.19 },
 "41250": { name: "Repair Tongue Laceration", wrvu: 1.91 },
 "41251": { name: "Repair Tongue Laceration", wrvu: 2.26 },
 "41252": { name: "Repair Tongue Laceration", wrvu: 2.94 },
 "41510": { name: "Tongue To Lip Surgery", wrvu: 3.42 },
 "41512": { name: "Tongue Suspension", wrvu: 6.69 },
 "41520": { name: "Reconstruction Tongue Fold", wrvu: 2.76 },
 "41530": { name: "Tongue Base Vol Reduction", wrvu: 3.41 },
 "41599": { name: "Unlisted Procedure Tongue Flr Mouth", wrvu: 0.00 },
 "41800": { name: "Drainage Of Gum Lesion", wrvu: 1.24 },
 "41805": { name: "Removal Foreign Body Gum", wrvu: 1.31 },
 "41806": { name: "Removal Foreign Body Jawbone", wrvu: 2.72 },
 "41820": { name: "Excision Gum Each Quadrant", wrvu: 0.00 },
 "41821": { name: "Excision Of Gum Flap", wrvu: 0.00 },
 "41822": { name: "Excision Of Gum Lesion", wrvu: 2.35 },
 "41823": { name: "Excision Of Gum Lesion", wrvu: 3.68 },
 "41825": { name: "Excision Of Gum Lesion", wrvu: 1.37 },
 "41826": { name: "Excision Of Gum Lesion", wrvu: 2.35 },
 "41827": { name: "Excision Of Gum Lesion", wrvu: 3.73 },
 "41828": { name: "Excision Of Gum Lesion", wrvu: 3.06 },
 "41830": { name: "Removal Of Gum Tissue", wrvu: 3.36 },
 "41850": { name: "Treatment Of Gum Lesion", wrvu: 0.00 },
 "41870": { name: "Periodontal Mucosal Grafting", wrvu: 0.00 },
 "41872": { name: "Gingivoplasty Each Quadrant", wrvu: 2.93 },
 "41874": { name: "Alveoloplasty Each Quadrant", wrvu: 3.11 },
 "41899": { name: "Unlisted Procedure Dentalvlr Strux", wrvu: 0.00 },
 "42000": { name: "Drainage Mouth Roof Lesion", wrvu: 1.25 },
 "42100": { name: "Biopsy Roof Of Mouth", wrvu: 1.33 },
 "42104": { name: "Excision Lesion Mouth Roof", wrvu: 1.65 },
 "42106": { name: "Excision Lesion Mouth Roof", wrvu: 2.10 },
 "42107": { name: "Excision Lesion Mouth Roof", wrvu: 4.45 },
 "42120": { name: "Remove Palate/lesion", wrvu: 11.56 },
 "42140": { name: "Excision Of Uvula", wrvu: 1.66 },
 "42145": { name: "Repair Palate Pharynx/uvula", wrvu: 9.54 },
 "42160": { name: "Treatment Mouth Roof Lesion", wrvu: 1.80 },
 "42180": { name: "Repair Laceration Palate<2 Cm", wrvu: 2.49 },
 "42182": { name: "Repair Palate", wrvu: 3.77 },
 "42200": { name: "Reconstruct Cleft Palate", wrvu: 12.22 },
 "42205": { name: "Reconstruct Cleft Palate", wrvu: 13.32 },
 "42210": { name: "Reconstruct Cleft Palate", wrvu: 14.65 },
 "42215": { name: "Reconstruct Cleft Palate", wrvu: 8.77 },
 "42220": { name: "Reconstruct Cleft Palate", wrvu: 6.98 },
 "42225": { name: "Reconstruct Cleft Palate", wrvu: 9.53 },
 "42226": { name: "Lengthening Of Palate", wrvu: 10.09 },
 "42227": { name: "Lengthening Of Palate", wrvu: 9.65 },
 "42235": { name: "Repair Palate", wrvu: 7.81 },
 "42260": { name: "Repair Nose To Lip Fistula", wrvu: 9.96 },
 "42280": { name: "Preparation Palate Mold", wrvu: 1.55 },
 "42281": { name: "Insertion Palate Prosthesis", wrvu: 1.93 },
 "42299": { name: "Unlisted Procedure Palate Uvula", wrvu: 0.00 },
 "42300": { name: "Drainage Of Salivary Gland", wrvu: 1.93 },
 "42305": { name: "Drainage Of Salivary Gland", wrvu: 6.15 },
 "42310": { name: "Drainage Of Salivary Gland", wrvu: 1.57 },
 "42320": { name: "Drainage Of Salivary Gland", wrvu: 2.34 },
 "42330": { name: "Removal Of Salivary Stone", wrvu: 2.20 },
 "42335": { name: "Removal Of Salivary Stone", wrvu: 3.32 },
 "42340": { name: "Removal Of Salivary Stone", wrvu: 4.60 },
 "42400": { name: "Biopsy Of Salivary Gland", wrvu: 0.76 },
 "42405": { name: "Biopsy Of Salivary Gland", wrvu: 3.26 },
 "42408": { name: "Excision Of Salivary Cyst", wrvu: 4.54 },
 "42409": { name: "Drainage Of Salivary Cyst", wrvu: 2.84 },
 "42410": { name: "Excise Parotid Gland/lesion", wrvu: 9.33 },
 "42415": { name: "Excise Parotid Gland/lesion", wrvu: 16.73 },
 "42420": { name: "Excise Parotid Gland/lesion", wrvu: 19.04 },
 "42425": { name: "Excise Parotid Gland/lesion", wrvu: 13.08 },
 "42426": { name: "Excise Parotid Gland/lesion", wrvu: 22.09 },
 "42440": { name: "Excise Submaxillary Gland", wrvu: 5.99 },
 "42450": { name: "Excise Sublingual Gland", wrvu: 4.62 },
 "42500": { name: "Repair Salivary Duct", wrvu: 4.31 },
 "42505": { name: "Repair Salivary Duct", wrvu: 6.16 },
 "42507": { name: "Parotid Duct Diversion", wrvu: 6.09 },
 "42509": { name: "Parotid Duct Diversion", wrvu: 11.47 },
 "42510": { name: "Parotid Duct Diversion", wrvu: 8.14 },
 "42550": { name: "Injection For Salivary X-ray", wrvu: 1.22 },
 "42600": { name: "Closure Of Salivary Fistula", wrvu: 4.82 },
 "42650": { name: "Dilation Of Salivary Duct", wrvu: 0.75 },
 "42660": { name: "Dilation Of Salivary Duct", wrvu: 1.10 },
 "42665": { name: "Ligation Of Salivary Duct", wrvu: 2.56 },
 "42699": { name: "Unlisted Procedure Salivry Glnd/dux", wrvu: 0.00 },
 "42700": { name: "Incision & Drainage Abscess Peritonsillar", wrvu: 1.63 },
 "42720": { name: "Incision & Drainage Abscess Phrngl Ntraorl Appr", wrvu: 6.15 },
 "42725": { name: "Incision & Drainage Abscess Phrngl Xtrnl Appr", wrvu: 12.10 },
 "42800": { name: "Biopsy Of Throat", wrvu: 1.40 },
 "42804": { name: "Biopsy Of Upper Nose/throat", wrvu: 1.26 },
 "42806": { name: "Biopsy Of Upper Nose/throat", wrvu: 1.59 },
 "42808": { name: "Excise Pharynx Lesion", wrvu: 2.29 },
 "42809": { name: "Remove Pharynx Foreign Body", wrvu: 1.81 },
 "42810": { name: "Excision Of Neck Cyst", wrvu: 3.30 },
 "42815": { name: "Excision Of Neck Cyst", wrvu: 7.13 },
 "42820": { name: "Remove Tonsils And Adenoids", wrvu: 4.11 },
 "42821": { name: "Remove Tonsils And Adenoids", wrvu: 4.25 },
 "42825": { name: "Removal Of Tonsils", wrvu: 3.42 },
 "42826": { name: "Removal Of Tonsils", wrvu: 3.36 },
 "42830": { name: "Removal Of Adenoids", wrvu: 2.58 },
 "42831": { name: "Removal Of Adenoids", wrvu: 2.74 },
 "42835": { name: "Removal Of Adenoids", wrvu: 2.32 },
 "42836": { name: "Removal Of Adenoids", wrvu: 3.18 },
 "42842": { name: "Extensive Surgery Of Throat", wrvu: 11.92 },
 "42844": { name: "Extensive Surgery Of Throat", wrvu: 17.34 },
 "42845": { name: "Extensive Surgery Of Throat", wrvu: 31.75 },
 "42860": { name: "Excision Of Tonsil Tags", wrvu: 2.24 },
 "42870": { name: "Excision Of Lingual Tonsil", wrvu: 5.38 },
 "42890": { name: "Limited Pharyngectomy", wrvu: 18.65 },
 "42892": { name: "Revision Of Pharyngeal Walls", wrvu: 25.38 },
 "42894": { name: "Revision Of Pharyngeal Walls", wrvu: 33.07 },
 "42900": { name: "Repair Throat Wound", wrvu: 5.16 },
 "42950": { name: "Reconstruction Of Throat", wrvu: 8.06 },
 "42953": { name: "Repair Throat Esophagus", wrvu: 9.21 },
 "42955": { name: "Surgical Opening Of Throat", wrvu: 7.81 },
 "42960": { name: "Control Throat Bleeding", wrvu: 2.32 },
 "42961": { name: "Control Throat Bleeding", wrvu: 5.63 },
 "42962": { name: "Control Throat Bleeding", wrvu: 7.22 },
 "42970": { name: "Control Nose/throat Bleeding", wrvu: 5.67 },
 "42971": { name: "Control Nose/throat Bleeding", wrvu: 6.44 },
 "42972": { name: "Control Nose/throat Bleeding", wrvu: 7.40 },
 "42975": { name: "Dise Evaluation Slp Do Birth Flx Diagnosis", wrvu: 1.54 },
 "42999": { name: "Unlisted Procedure Pharynx Adenoid/Tonsil", wrvu: 0.00 },
 "43020": { name: "Incision Of Esophagus", wrvu: 8.02 },
 "43030": { name: "Cricopharyngeal Myotomy", wrvu: 7.79 },
 "43045": { name: "Esophagotomy Thoracic Removal Fb", wrvu: 21.33 },
 "43100": { name: "Excision Of Esophagus Lesion", wrvu: 9.42 },
 "43101": { name: "Excision Of Esophagus Lesion", wrvu: 16.64 },
 "43107": { name: "Removal Of Esophagus", wrvu: 50.75 },
 "43108": { name: "Removal Of Esophagus", wrvu: 80.80 },
 "43112": { name: "Esphg Tot With Thoracotomy", wrvu: 60.45 },
 "43113": { name: "Removal Of Esophagus", wrvu: 78.06 },
 "43116": { name: "Partial Removal Of Esophagus", wrvu: 90.67 },
 "43117": { name: "Partial Removal Of Esophagus", wrvu: 56.06 },
 "43118": { name: "Partial Removal Of Esophagus", wrvu: 65.39 },
 "43121": { name: "Partial Removal Of Esophagus", wrvu: 50.14 },
 "43122": { name: "Partial Removal Of Esophagus", wrvu: 43.08 },
 "43123": { name: "Partial Removal Of Esophagus", wrvu: 81.04 },
 "43124": { name: "Removal Of Esophagus", wrvu: 67.36 },
 "43130": { name: "Removal Of Esophagus Pouch", wrvu: 12.22 },
 "43135": { name: "Removal Of Esophagus Pouch", wrvu: 25.52 },
 "43180": { name: "Esophagoscopy Rigid Trnso", wrvu: 8.80 },
 "43191": { name: "Esophagoscopy Rigid Trnso Diagnosis", wrvu: 2.43 },
 "43192": { name: "Esophagoscp Rig Trnso Inject", wrvu: 2.72 },
 "43193": { name: "Esophagoscp Rig Trnso Biopsy", wrvu: 2.72 },
 "43194": { name: "Esophagoscp Rig Trnso Rem Fb", wrvu: 3.42 },
 "43195": { name: "Esophagoscopy Rigid Balloon", wrvu: 2.99 },
 "43196": { name: "Esophagoscp Guide Wire Dilat", wrvu: 3.23 },
 "43197": { name: "Esophagoscopy Flex Diagnosis Brush", wrvu: 1.48 },
 "43198": { name: "Esophagosc Flex Trnsn Biopsy", wrvu: 1.77 },
 "43200": { name: "Esophagoscopy Flexible Brush", wrvu: 1.38 },
 "43201": { name: "Esophageal Scope With Submucous Injection", wrvu: 1.68 },
 "43202": { name: "Esophagoscopy Flex Biopsy", wrvu: 1.68 },
 "43204": { name: "Esophageal Scope With Sclerosis Injection", wrvu: 2.27 },
 "43205": { name: "Esophagus Endoscopy/ligation", wrvu: 2.38 },
 "43206": { name: "Esophageal Optical Endomicroscopy", wrvu: 2.23 },
 "43210": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Esophagogastrc Fndoplsty", wrvu: 7.56 },
 "43211": { name: "Esophagoscop Mucosal Resection", wrvu: 4.10 },
 "43212": { name: "Esophagoscop Stent Placement", wrvu: 3.32 },
 "43213": { name: "Esophagoscopy Retro Balloon", wrvu: 4.51 },
 "43214": { name: "Esophagosc Dilate Balloon 30", wrvu: 3.32 },
 "43215": { name: "Esophagoscopy Flex Remove Fb", wrvu: 2.38 },
 "43216": { name: "Esophagoscopy Lesion Removal", wrvu: 2.24 },
 "43217": { name: "Esophagoscopy Snare Lesion Remv", wrvu: 2.73 },
 "43220": { name: "Esophagoscopy Balloon <30mm", wrvu: 1.95 },
 "43226": { name: "Esophageal Endoscopy Dilation", wrvu: 2.18 },
 "43227": { name: "Esophagoscopy Control Bleed", wrvu: 2.82 },
 "43229": { name: "Esophagoscopy Lesion Ablate", wrvu: 3.40 },
 "43231": { name: "Esophagoscop Ultrasound Exam", wrvu: 2.73 },
 "43232": { name: "Esophagoscopy With Ultrasound Needle Biopsy", wrvu: 3.50 },
 "43233": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Balloon Dil Esoph30 Mm/>", wrvu: 3.97 },
 "43235": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Diagnostic Brush Wash", wrvu: 2.04 },
 "43236": { name: "Uppr Gastrointestinal Scope With Submuc Injection", wrvu: 2.33 },
 "43237": { name: "Endoscopic Ultrasound Exam Esophageal", wrvu: 3.38 },
 "43238": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Ultrasound Fine Needle Biopsy/Aspiration", wrvu: 4.06 },
 "43239": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Biopsy Single/multiple", wrvu: 2.33 },
 "43240": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) With Transmural Drain Cyst", wrvu: 6.97 },
 "43241": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Tube/Catheter Insertion", wrvu: 2.43 },
 "43242": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Ultrasound Fine Needle Biopsy/Aspiration", wrvu: 4.61 },
 "43243": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Injection Varices", wrvu: 4.16 },
 "43244": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Varices Ligation", wrvu: 4.29 },
 "43245": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Dilate Stricture", wrvu: 3.00 },
 "43246": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Place Gastrostomy Tube", wrvu: 3.47 },
 "43247": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Remove Foreign Body", wrvu: 3.03 },
 "43248": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Guide Wire Insertion", wrvu: 2.84 },
 "43249": { name: "Esophageal Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Dilation <30 Mm", wrvu: 2.60 },
 "43250": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Cautery Tumor Polyp", wrvu: 2.90 },
 "43251": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Remove Lesion Snare", wrvu: 3.38 },
 "43252": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Optical Endomicroscopy", wrvu: 2.89 },
 "43253": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Ultrasound Transmural Injxn/mark", wrvu: 4.61 },
 "43254": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Endoscopic Mucosal Resection", wrvu: 4.75 },
 "43255": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Control Bleeding Any", wrvu: 3.47 },
 "43257": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) With Thrml Txmnt Gerd", wrvu: 4.05 },
 "43259": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Ultrasound Exam Duodenum/jejunum", wrvu: 3.94 },
 "43260": { name: "ERCP With Specimen Collection", wrvu: 5.70 },
 "43261": { name: "Endoscopic Cholangiopancreatograph", wrvu: 6.00 },
 "43262": { name: "Endoscopic Cholangiopancreatograph", wrvu: 6.34 },
 "43263": { name: "ERCP Sphincter Pressure Meas", wrvu: 6.34 },
 "43264": { name: "ERCP Remove Duct Calculi", wrvu: 6.46 },
 "43265": { name: "ERCP Lithotripsy Calculi", wrvu: 7.73 },
 "43266": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Endoscopic Stent Place", wrvu: 3.82 },
 "43270": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Lesion Ablation", wrvu: 3.91 },
 "43273": { name: "Endoscopic Pancreatoscopy", wrvu: 2.18 },
 "43274": { name: "ERCP Duct Stent Placement", wrvu: 8.27 },
 "43275": { name: "ERCP Remove Forgn Body Duct", wrvu: 6.69 },
 "43276": { name: "ERCP Stent Exchange With Dilate", wrvu: 8.62 },
 "43277": { name: "ERCP Each Duct/ampulla Dilate", wrvu: 6.73 },
 "43278": { name: "ERCP Lesion Ablate With Dilate", wrvu: 7.72 },
 "43279": { name: "Laparoscopic Myotomy Heller", wrvu: 21.55 },
 "43280": { name: "Laparoscopy Fundoplasty", wrvu: 17.65 },
 "43281": { name: "Laparoscopic Paraesophag Hern Repair", wrvu: 25.94 },
 "43282": { name: "Laparoscopic Paraesoph Her Repair With Mesh", wrvu: 29.35 },
 "43283": { name: "Laparoscopic Esophageal Lengthening", wrvu: 2.88 },
 "43284": { name: "Laps Esophgl Sphnctr Agmntj", wrvu: 9.88 },
 "43285": { name: "Removal Esophgl Sphnctr Device", wrvu: 10.21 },
 "43286": { name: "Esphg Tot With Laps Mobilization", wrvu: 53.63 },
 "43287": { name: "Esphg Dstl 2/3 With Laps Mobilization", wrvu: 61.43 },
 "43288": { name: "Esphg Thoracoscopic Mobilization", wrvu: 64.76 },
 "43289": { name: "Unlisted Laps Procedure Esophageal", wrvu: 0.00 },
 "43290": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Flx Trnsorl Dplmnt Balo", wrvu: 3.03 },
 "43291": { name: "Upper Gastrointestinal Endoscopy (Upper Gastrointestinal Endoscopy (EGD)) (Upper Endoscopy) Flx Trnsorl Removal Balo", wrvu: 2.73 },
 "43300": { name: "Repair Of Esophagus", wrvu: 9.10 },
 "43305": { name: "Repair Esophagus And Fistula", wrvu: 17.65 },
 "43310": { name: "Repair Of Esophagus", wrvu: 25.60 },
 "43312": { name: "Repair Esophagus And Fistula", wrvu: 28.52 },
 "43313": { name: "Esophagoplasty Congenital", wrvu: 47.24 },
 "43314": { name: "Tracheo-esophagoplasty Cong", wrvu: 52.09 },
 "43320": { name: "Fuse Esophagus & Stomach", wrvu: 22.73 },
 "43325": { name: "Revise Esophagus & Stomach", wrvu: 22.04 },
 "43327": { name: "Esophageal Fundoplasty Laparoscopic", wrvu: 13.02 },
 "43328": { name: "Esophageal Fundoplasty Thoracic", wrvu: 19.41 },
 "43330": { name: "Esophagomyotomy Abdominal", wrvu: 21.64 },
 "43331": { name: "Esophagomyotomy Thoracic", wrvu: 22.48 },
 "43332": { name: "Transab Esophageal Hiat Hern Repair", wrvu: 19.13 },
 "43333": { name: "Transab Esophageal Hiat Hern Repair", wrvu: 20.92 },
 "43334": { name: "Transthor Diaphrag Hern Repair", wrvu: 21.57 },
 "43335": { name: "Transthor Diaphrag Hern Repair", wrvu: 23.37 },
 "43336": { name: "Thorabd Diaphr Hern Repair", wrvu: 25.16 },
 "43337": { name: "Thorabd Diaphr Hern Repair", wrvu: 26.96 },
 "43338": { name: "Esophageal Lengthening", wrvu: 2.15 },
 "43340": { name: "Fuse Esophagus & Intestine", wrvu: 22.42 },
 "43341": { name: "Fuse Esophagus & Intestine", wrvu: 23.62 },
 "43351": { name: "Surgical Opening Esophagus", wrvu: 21.50 },
 "43352": { name: "Surgical Opening Esophagus", wrvu: 17.36 },
 "43360": { name: "Gastrointestinal Repair", wrvu: 39.11 },
 "43361": { name: "Gastrointestinal Repair", wrvu: 44.54 },
 "43400": { name: "Ligate Esophagus Veins", wrvu: 24.96 },
 "43405": { name: "Ligate/staple Esophagus", wrvu: 24.11 },
 "43410": { name: "Repair Esophagus Wound", wrvu: 16.00 },
 "43415": { name: "Repair Esophagus Wound", wrvu: 43.76 },
 "43420": { name: "Repair Esophagus Opening", wrvu: 16.36 },
 "43425": { name: "Repair Esophagus Opening", wrvu: 24.41 },
 "43450": { name: "Dilate Esophagus 1/mult Pass", wrvu: 1.25 },
 "43453": { name: "Dilate Esophagus", wrvu: 1.37 },
 "43460": { name: "Pressure Treatment Esophagus", wrvu: 3.70 },
 "43496": { name: "Free Jejunum Flap Microvasc", wrvu: 0.00 },
 "43497": { name: "Transorl Lower Esophgl Myotomy", wrvu: 12.96 },
 "43499": { name: "Unlisted Procedure Esophagus", wrvu: 0.00 },
 "43500": { name: "Surgical Opening Of Stomach", wrvu: 12.47 },
 "43501": { name: "Surgical Repair Of Stomach", wrvu: 22.04 },
 "43502": { name: "Surgical Repair Of Stomach", wrvu: 25.05 },
 "43510": { name: "Surgical Opening Of Stomach", wrvu: 14.76 },
 "43520": { name: "Incision Of Pyloric Muscle", wrvu: 11.01 },
 "43605": { name: "Biopsy Of Stomach", wrvu: 13.38 },
 "43610": { name: "Excision Of Stomach Lesion", wrvu: 15.93 },
 "43611": { name: "Excision Of Stomach Lesion", wrvu: 19.87 },
 "43620": { name: "Removal Of Stomach", wrvu: 33.19 },
 "43621": { name: "Removal Of Stomach", wrvu: 38.54 },
 "43622": { name: "Removal Of Stomach", wrvu: 39.03 },
 "43631": { name: "Removal Of Stomach Partial", wrvu: 23.90 },
 "43632": { name: "Removal Of Stomach Partial", wrvu: 34.26 },
 "43633": { name: "Removal Of Stomach Partial", wrvu: 32.31 },
 "43634": { name: "Removal Of Stomach Partial", wrvu: 35.72 },
 "43635": { name: "Removal Of Stomach Partial", wrvu: 2.01 },
 "43640": { name: "Vagotomy & Pylorus Repair", wrvu: 19.07 },
 "43641": { name: "Vagotomy & Pylorus Repair", wrvu: 19.31 },
 "43644": { name: "Laparoscopic Gastric Bypass/roux-en-y", wrvu: 28.67 },
 "43645": { name: "Laparoscopic Gastr Bypass Incl Smll I", wrvu: 30.74 },
 "43647": { name: "Laparoscopic Impl Electrode Antrum", wrvu: 0.00 },
 "43648": { name: "Laparoscopic Revise/remv Eltrd Antrum", wrvu: 0.00 },
 "43651": { name: "Laparoscopy Vagus Nerve", wrvu: 9.88 },
 "43652": { name: "Laparoscopy Vagus Nerve", wrvu: 11.83 },
 "43653": { name: "Laparoscopy Gastrostomy", wrvu: 8.27 },
 "43659": { name: "Unlisted Laps Procedure Stomach", wrvu: 0.00 },
 "43752": { name: "Nasal/orogastric With Tube Placement", wrvu: 0.79 },
 "43753": { name: "Treatment Gastro Intub With Aspiration", wrvu: 0.44 },
 "43754": { name: "Diagnosis Gastr Intub With Aspiration Specimen", wrvu: 0.44 },
 "43755": { name: "Diagnosis Gastr Intub With Aspiration Specs", wrvu: 0.92 },
 "43756": { name: "Diagnosis Duod Intub With Aspiration Specimen", wrvu: 0.75 },
 "43757": { name: "Diagnosis Duod Intub With Aspiration Specs", wrvu: 1.23 },
 "43761": { name: "Reposition Gastrostomy Tube", wrvu: 1.96 },
 "43762": { name: "Rplc Gtube No Revj Trc", wrvu: 0.73 },
 "43763": { name: "Rplc Gtube Revj Gastrostomy Trc", wrvu: 1.37 },
 "43770": { name: "Laparoscopic Place Gastr Adjustment Device", wrvu: 17.55 },
 "43771": { name: "Laparoscopic Revise Gastr Adjustment Device", wrvu: 20.27 },
 "43772": { name: "Laparoscopic Removal Gastr Adjustment Device", wrvu: 15.31 },
 "43773": { name: "Laparoscopic Replace Gastr Adjustment Device", wrvu: 20.27 },
 "43774": { name: "Laparoscopic Removal Gastr Adjustment Acute Lymphoblastic Leukemia Parts", wrvu: 15.37 },
 "43775": { name: "Laparoscopic Sleeve Gastrectomy", wrvu: 19.87 },
 "43800": { name: "Pyloroplasty", wrvu: 15.04 },
 "43810": { name: "Gastroduodenostomy", wrvu: 16.46 },
 "43820": { name: "Gastrojejunostomy without Vagotmy", wrvu: 21.97 },
 "43825": { name: "Gastrojejunostomy With Vagotomy", wrvu: 21.22 },
 "43830": { name: "Gastrostomy Open without Constj Tube", wrvu: 10.58 },
 "43831": { name: "Gastrostomy Open Neonatal", wrvu: 8.28 },
 "43832": { name: "Gastrostomy Open With Constj Tube", wrvu: 16.91 },
 "43840": { name: "Gstrrphy Suture Duol/Gastric Ulcr", wrvu: 22.26 },
 "43842": { name: "Gastric Rstcv Procedure V-banded Gstp", wrvu: 20.50 },
 "43843": { name: "Gastric Rstcv Other Than V-band", wrvu: 20.68 },
 "43845": { name: "Gastroplasty Duodenal Switch", wrvu: 32.47 },
 "43846": { name: "Gastric Rstcv Procedure Shrt Roux-en-y", wrvu: 26.72 },
 "43847": { name: "Gastric Rstcv Procedure Sm Int Reconstruction", wrvu: 29.52 },
 "43848": { name: "Revj Open Gastric Rstcv Procedure", wrvu: 31.93 },
 "43860": { name: "Revj Gastric/jj Anast Without Vgtmy", wrvu: 27.19 },
 "43865": { name: "Revj Gastric/jj Anast With Vgtmy", wrvu: 28.32 },
 "43870": { name: "Closure Gastrostomy Surgical", wrvu: 11.15 },
 "43880": { name: "Closure Gastrocolic Fistula", wrvu: 26.50 },
 "43881": { name: "Impl/Replacement Gastric Nstim Eltrd", wrvu: 0.00 },
 "43882": { name: "Revision/Removal Gastric Nstim Eltrd", wrvu: 0.00 },
 "43886": { name: "Gastric Rstcv Procedure Open Revj Port", wrvu: 4.52 },
 "43887": { name: "Gastric Rstcv Procedure Open Removal Port", wrvu: 4.21 },
 "43888": { name: "Gastric Rstcv Procedure Open Removal and rplc", wrvu: 6.28 },
 "43889": { name: "Gastric Rstcv Procedure Trnsorl Esg", wrvu: 12.56 },
 "43999": { name: "Unlisted Procedure Stomach", wrvu: 0.00 },
 "44005": { name: "Freeing Of Bowel Adhesion", wrvu: 18.00 },
 "44010": { name: "Incision Of Small Bowel", wrvu: 13.90 },
 "44015": { name: "Insert Needle Catheter Bowel", wrvu: 2.55 },
 "44020": { name: "Explore Small Intestine", wrvu: 15.81 },
 "44021": { name: "Decompress Small Bowel", wrvu: 15.90 },
 "44025": { name: "Incision Of Large Bowel", wrvu: 16.10 },
 "44050": { name: "Reduce Bowel Obstruction", wrvu: 15.13 },
 "44055": { name: "Correct Malrotation Of Bowel", wrvu: 24.99 },
 "44100": { name: "Biopsy Of Bowel", wrvu: 1.96 },
 "44110": { name: "Excise Intestine Lesion(s)", wrvu: 13.69 },
 "44111": { name: "Excision Of Bowel Lesion(s)", wrvu: 16.11 },
 "44120": { name: "Removal Of Small Intestine", wrvu: 20.30 },
 "44121": { name: "Removal Of Small Intestine", wrvu: 4.33 },
 "44125": { name: "Removal Of Small Intestine", wrvu: 19.53 },
 "44126": { name: "Enterectomy Without Taper Cong", wrvu: 41.17 },
 "44127": { name: "Enterectomy With Taper Cong", wrvu: 48.07 },
 "44128": { name: "Enterectomy Cong Add-on", wrvu: 4.33 },
 "44130": { name: "Bowel To Bowel Fusion", wrvu: 21.56 },
 "44132": { name: "Enterectomy Cadaver Donor", wrvu: 0.00 },
 "44133": { name: "Enterectomy Live Donor", wrvu: 0.00 },
 "44135": { name: "Intestine Transplnt Cadaver", wrvu: 0.00 },
 "44136": { name: "Intestine Transplant Live", wrvu: 0.00 },
 "44137": { name: "Remove Intestinal Allograft", wrvu: 0.00 },
 "44139": { name: "Mobilization Of Colon", wrvu: 2.17 },
 "44140": { name: "Partial Removal Of Colon", wrvu: 22.03 },
 "44141": { name: "Partial Removal Of Colon", wrvu: 29.16 },
 "44143": { name: "Partial Removal Of Colon", wrvu: 27.10 },
 "44144": { name: "Partial Removal Of Colon", wrvu: 29.16 },
 "44145": { name: "Partial Removal Of Colon", wrvu: 27.87 },
 "44146": { name: "Partial Removal Of Colon", wrvu: 34.42 },
 "44147": { name: "Partial Removal Of Colon", wrvu: 32.85 },
 "44150": { name: "Removal Of Colon", wrvu: 29.43 },
 "44151": { name: "Removal Of Colon/ileostomy", wrvu: 34.05 },
 "44155": { name: "Removal Of Colon/ileostomy", wrvu: 33.56 },
 "44156": { name: "Removal Of Colon/ileostomy", wrvu: 36.48 },
 "44157": { name: "Colectomy With Ileoanal Anast", wrvu: 34.81 },
 "44158": { name: "Colectomy With Neo-rectum Pouch", wrvu: 35.78 },
 "44160": { name: "Removal Of Colon", wrvu: 20.37 },
 "44180": { name: "Laparoscopic Enterolysis", wrvu: 14.89 },
 "44186": { name: "Laparoscopic Jejunostomy", wrvu: 10.12 },
 "44187": { name: "Laparoscopic Ileo/jejuno-stomy", wrvu: 16.97 },
 "44188": { name: "Laparoscopic Colostomy", wrvu: 18.87 },
 "44202": { name: "Laparoscopic Enterectomy", wrvu: 22.81 },
 "44203": { name: "Laparoscopic Resection S/intestine Additional", wrvu: 4.33 },
 "44204": { name: "Laparoscopic Partial Colectomy", wrvu: 25.76 },
 "44205": { name: "Laparoscopic Colectomy Part With Ileum", wrvu: 22.38 },
 "44206": { name: "Laparoscopic Part Colectomy With Stoma", wrvu: 29.05 },
 "44207": { name: "L Colectomy/coloproctostomy", wrvu: 31.12 },
 "44208": { name: "L Colectomy/coloproctostomy", wrvu: 33.14 },
 "44210": { name: "Laparoscopic Total Proctocolectomy", wrvu: 29.34 },
 "44211": { name: "Laparoscopic Colectomy With Proctectomy", wrvu: 36.15 },
 "44212": { name: "Laparoscopic Total Proctocolectomy", wrvu: 33.72 },
 "44213": { name: "Laparoscopic Mobil Splenic Fl Add-on", wrvu: 3.41 },
 "44227": { name: "Laparoscopic Close Enterostomy", wrvu: 27.90 },
 "44238": { name: "Unlisted Laps Procedure Intestine", wrvu: 0.00 },
 "44300": { name: "Open Bowel To Skin", wrvu: 13.41 },
 "44310": { name: "Ileostomy/jejunostomy", wrvu: 17.15 },
 "44312": { name: "Revision Of Ileostomy", wrvu: 9.19 },
 "44314": { name: "Revision Of Ileostomy", wrvu: 16.32 },
 "44316": { name: "Devise Bowel Pouch", wrvu: 23.00 },
 "44320": { name: "Colostomy", wrvu: 19.41 },
 "44322": { name: "Colostomy With Biopsies", wrvu: 12.99 },
 "44340": { name: "Revision Of Colostomy", wrvu: 9.05 },
 "44345": { name: "Revision Of Colostomy", wrvu: 16.79 },
 "44346": { name: "Revision Of Colostomy", wrvu: 19.14 },
 "44360": { name: "Small Bowel Endoscopy", wrvu: 2.43 },
 "44361": { name: "Small Bowel Endoscopy/biopsy", wrvu: 2.70 },
 "44363": { name: "Small Bowel Endoscopy", wrvu: 3.31 },
 "44364": { name: "Small Bowel Endoscopy", wrvu: 3.54 },
 "44365": { name: "Small Bowel Endoscopy", wrvu: 3.13 },
 "44366": { name: "Small Bowel Endoscopy", wrvu: 4.19 },
 "44369": { name: "Small Bowel Endoscopy", wrvu: 4.30 },
 "44370": { name: "Small Bowel Endoscopy/stent", wrvu: 4.57 },
 "44372": { name: "Small Bowel Endoscopy", wrvu: 4.19 },
 "44373": { name: "Small Bowel Endoscopy", wrvu: 3.31 },
 "44376": { name: "Small Bowel Endoscopy", wrvu: 5.02 },
 "44377": { name: "Small Bowel Endoscopy/biopsy", wrvu: 5.28 },
 "44378": { name: "Small Bowel Endoscopy", wrvu: 6.84 },
 "44379": { name: "S Bowel Endoscope With Stent", wrvu: 7.18 },
 "44380": { name: "Small Bowel Endoscopy Br/wa", wrvu: 0.85 },
 "44381": { name: "Small Bowel Endoscopy Br/wa", wrvu: 1.35 },
 "44382": { name: "Small Bowel Endoscopy", wrvu: 1.14 },
 "44384": { name: "Small Bowel Endoscopy", wrvu: 2.78 },
 "44385": { name: "Endoscopy Of Bowel Pouch", wrvu: 1.17 },
 "44386": { name: "Endoscopy Bowel Pouch/biop", wrvu: 1.46 },
 "44388": { name: "Colonoscopy Thru Stoma Spx", wrvu: 2.65 },
 "44389": { name: "Colonoscopy With Biopsy", wrvu: 2.94 },
 "44390": { name: "Colonoscopy For Foreign Body", wrvu: 3.65 },
 "44391": { name: "Colonoscopy For Bleeding", wrvu: 4.02 },
 "44392": { name: "Colonoscopy & Polypectomy", wrvu: 3.44 },
 "44394": { name: "Colonoscopy With Snare", wrvu: 3.93 },
 "44401": { name: "Colonoscopy With Ablation", wrvu: 4.23 },
 "44402": { name: "Colonoscopy With Stent Plcmt", wrvu: 4.58 },
 "44403": { name: "Colonoscopy With Resection", wrvu: 5.36 },
 "44404": { name: "Colonoscopy With Injection", wrvu: 2.94 },
 "44405": { name: "Colonoscopy With Dilation", wrvu: 3.15 },
 "44406": { name: "Colonoscopy With Ultrasound", wrvu: 4.00 },
 "44407": { name: "Colonoscopy With Needle Aspiration/Biopsy", wrvu: 4.84 },
 "44408": { name: "Colonoscopy With Decompression", wrvu: 4.04 },
 "44500": { name: "Intro Gastrointestinal Tube", wrvu: 0.38 },
 "44602": { name: "Suture Small Intestine", wrvu: 24.10 },
 "44603": { name: "Suture Small Intestine", wrvu: 27.46 },
 "44604": { name: "Suture Large Intestine", wrvu: 17.71 },
 "44605": { name: "Repair Of Bowel Lesion", wrvu: 21.53 },
 "44615": { name: "Intestinal Stricturoplasty", wrvu: 17.71 },
 "44620": { name: "Repair Bowel Opening", wrvu: 14.07 },
 "44625": { name: "Repair Bowel Opening", wrvu: 16.85 },
 "44626": { name: "Repair Bowel Opening", wrvu: 27.20 },
 "44640": { name: "Repair Bowel-skin Fistula", wrvu: 23.60 },
 "44650": { name: "Repair Bowel Fistula", wrvu: 24.49 },
 "44660": { name: "Repair Bowel-bladder Fistula", wrvu: 23.31 },
 "44661": { name: "Repair Bowel-bladder Fistula", wrvu: 26.67 },
 "44680": { name: "Surgical Revision Intestine", wrvu: 17.51 },
 "44700": { name: "Suspend Bowel With Prosthesis", wrvu: 17.04 },
 "44701": { name: "Intraop Colon Lavage Add-on", wrvu: 3.02 },
 "44705": { name: "Prepare Fecal Microbiota", wrvu: 1.38 },
 "44715": { name: "Prepare Donor Intestine", wrvu: 0.00 },
 "44720": { name: "Prep Donor Intestine/venous", wrvu: 4.88 },
 "44721": { name: "Prep Donor Intestine/artery", wrvu: 6.83 },
 "44799": { name: "Unlisted Procedure Small Intestine", wrvu: 0.00 },
 "44800": { name: "Excision Of Bowel Pouch", wrvu: 11.75 },
 "44820": { name: "Excision Of Mesentery Lesion", wrvu: 13.39 },
 "44850": { name: "Repair Of Mesentery", wrvu: 11.81 },
 "44899": { name: "Unlisted Procedure Meckel's Dvrtclm", wrvu: 0.00 },
 "44900": { name: "Incision & Drainage Appendix Abscess Open", wrvu: 12.26 },
 "44950": { name: "Appendectomy", wrvu: 10.34 },
 "44955": { name: "Appendectomy Add-on", wrvu: 1.49 },
 "44960": { name: "Appendectomy", wrvu: 14.14 },
 "44970": { name: "Laparoscopy Appendectomy", wrvu: 9.21 },
 "44979": { name: "Unlisted Laps Procedure Appendix", wrvu: 0.00 },
 "45000": { name: "Drainage Of Pelvic Abscess", wrvu: 6.14 },
 "45005": { name: "Drainage Of Rectal Abscess", wrvu: 1.97 },
 "45020": { name: "Drainage Of Rectal Abscess", wrvu: 8.35 },
 "45100": { name: "Biopsy Of Rectum", wrvu: 3.94 },
 "45108": { name: "Anorectal Myomectomy", wrvu: 4.99 },
 "45110": { name: "Removal Of Rectum", wrvu: 29.99 },
 "45111": { name: "Partial Removal Of Rectum", wrvu: 17.56 },
 "45112": { name: "Removal Of Rectum", wrvu: 32.35 },
 "45113": { name: "Partial Proctectomy", wrvu: 32.39 },
 "45114": { name: "Partial Removal Of Rectum", wrvu: 30.02 },
 "45116": { name: "Partial Removal Of Rectum", wrvu: 27.03 },
 "45119": { name: "Remove Rectum With Reservoir", wrvu: 32.64 },
 "45120": { name: "Removal Of Rectum", wrvu: 25.74 },
 "45121": { name: "Removal Of Rectum And Colon", wrvu: 28.35 },
 "45123": { name: "Partial Proctectomy", wrvu: 18.39 },
 "45126": { name: "Pelvic Exenteration", wrvu: 47.87 },
 "45130": { name: "Excision Of Rectal Prolapse", wrvu: 18.04 },
 "45135": { name: "Excision Of Rectal Prolapse", wrvu: 21.80 },
 "45136": { name: "Excise Ileoanal Reservior", wrvu: 30.05 },
 "45150": { name: "Excision Of Rectal Stricture", wrvu: 5.70 },
 "45160": { name: "Excision Of Rectal Lesion", wrvu: 15.92 },
 "45171": { name: "Excision Rect Tumor Transanal Part", wrvu: 7.93 },
 "45172": { name: "Excision Rect Tumor Transanal Full", wrvu: 11.83 },
 "45190": { name: "Destruction Rectal Tumor", wrvu: 10.16 },
 "45300": { name: "Proctosigmoidoscopy Diagnosis", wrvu: 0.78 },
 "45303": { name: "Proctosigmoidoscopy Dilate", wrvu: 1.37 },
 "45305": { name: "Proctosigmoidoscopy With Biopsy", wrvu: 1.12 },
 "45307": { name: "Proctosigmoidoscopy Fb", wrvu: 1.56 },
 "45308": { name: "Proctosigmoidoscopy Removal", wrvu: 1.27 },
 "45309": { name: "Proctosigmoidoscopy Removal", wrvu: 1.37 },
 "45315": { name: "Proctosigmoidoscopy Removal", wrvu: 1.66 },
 "45317": { name: "Proctosigmoidoscopy Bleed", wrvu: 1.85 },
 "45320": { name: "Proctosigmoidoscopy Ablate", wrvu: 1.64 },
 "45321": { name: "Proctosigmoidoscopy Volvul", wrvu: 1.61 },
 "45327": { name: "Proctosigmoidoscopy With Stent", wrvu: 1.85 },
 "45330": { name: "Diagnostic Sigmoidoscopy", wrvu: 0.82 },
 "45331": { name: "Sigmoidoscopy And Biopsy", wrvu: 1.11 },
 "45332": { name: "Sigmoidoscopy With Fb Removal", wrvu: 1.72 },
 "45333": { name: "Sigmoidoscopy & Polypectomy", wrvu: 1.51 },
 "45334": { name: "Sigmoidoscopy For Bleeding", wrvu: 1.95 },
 "45335": { name: "Sigmoidoscopy With Submuc Injection", wrvu: 1.01 },
 "45337": { name: "Sigmoidoscopy & Decompress", wrvu: 2.05 },
 "45338": { name: "Sigmoidoscopy With Tumr Remove", wrvu: 2.00 },
 "45340": { name: "Sig With Tndsc Balloon Dilation", wrvu: 1.22 },
 "45341": { name: "Sigmoidoscopy With Ultrasound", wrvu: 2.07 },
 "45342": { name: "Sigmoidoscopy With Ultrasound Guide Biopsy", wrvu: 2.91 },
 "45346": { name: "Sigmoidoscopy With Ablation", wrvu: 2.74 },
 "45347": { name: "Sigmoidoscopy With Plcmt Stent", wrvu: 2.65 },
 "45349": { name: "Sigmoidoscopy With Resection", wrvu: 3.43 },
 "45350": { name: "Sigmoidoscopy With Band Ligation", wrvu: 1.64 },
 "45378": { name: "Diagnostic Colonoscopy", wrvu: 3.18 },
 "45379": { name: "Colonoscopy With Fb Removal", wrvu: 4.17 },
 "45380": { name: "Colonoscopy And Biopsy", wrvu: 3.47 },
 "45381": { name: "Colonoscopy Submucous Injection", wrvu: 3.47 },
 "45382": { name: "Colonoscopy With Control Bleed", wrvu: 4.54 },
 "45384": { name: "Colonoscopy With Lesion Removal", wrvu: 3.97 },
 "45385": { name: "Colonoscopy With Lesion Removal", wrvu: 4.46 },
 "45386": { name: "Colonoscopy With Balloon Dilat", wrvu: 3.68 },
 "45388": { name: "Colonoscopy With Ablation", wrvu: 4.76 },
 "45389": { name: "Colonoscopy With Stent Plcmt", wrvu: 5.11 },
 "45390": { name: "Colonoscopy With Resection", wrvu: 5.89 },
 "45391": { name: "Colonoscopy With Endoscope Ultrasound", wrvu: 4.52 },
 "45392": { name: "Colonoscopy With Endoscopic Fnb", wrvu: 5.36 },
 "45393": { name: "Colonoscopy With Decompression", wrvu: 4.56 },
 "45395": { name: "Laparoscopic Removal Of Rectum", wrvu: 32.18 },
 "45397": { name: "Laparoscopic Remove Rectum With Pouch", wrvu: 35.59 },
 "45398": { name: "Colonoscopy With Band Ligation", wrvu: 4.10 },
 "45399": { name: "Unlisted Procedure Colon", wrvu: 0.00 },
 "45400": { name: "Laparoscopic Procedure", wrvu: 18.95 },
 "45402": { name: "Laparoscopic Proctopexy With Sig Resection", wrvu: 25.85 },
 "45499": { name: "Laparoscope Procedure Rectum", wrvu: 0.00 },
 "45500": { name: "Repair Of Rectum", wrvu: 7.54 },
 "45505": { name: "Repair Of Rectum", wrvu: 8.15 },
 "45520": { name: "Treatment Of Rectal Prolapse", wrvu: 0.54 },
 "45540": { name: "Correct Rectal Prolapse", wrvu: 17.67 },
 "45541": { name: "Correct Rectal Prolapse", wrvu: 14.48 },
 "45550": { name: "Repair Rectum/remove Sigmoid", wrvu: 24.18 },
 "45560": { name: "Repair Of Rectocele", wrvu: 11.21 },
 "45562": { name: "Exploration/repair Of Rectum", wrvu: 17.53 },
 "45563": { name: "Exploration/repair Of Rectum", wrvu: 25.72 },
 "45800": { name: "Repair Rect/bladder Fistula", wrvu: 19.80 },
 "45805": { name: "Repair Fistula With Colostomy", wrvu: 22.74 },
 "45820": { name: "Repair Rectourethral Fistula", wrvu: 19.86 },
 "45825": { name: "Repair Fistula With Colostomy", wrvu: 23.57 },
 "45900": { name: "Reduction Of Rectal Prolapse", wrvu: 2.92 },
 "45905": { name: "Dilation Of Anal Sphincter", wrvu: 2.29 },
 "45910": { name: "Dilation Of Rectal Narrowing", wrvu: 2.78 },
 "45915": { name: "Remove Rectal Obstruction", wrvu: 3.11 },
 "45990": { name: "Surgery Diagnosis Exam Anorectal", wrvu: 1.76 },
 "45999": { name: "Unlisted Procedure Rectum", wrvu: 0.00 },
 "46020": { name: "Placement Of Seton", wrvu: 1.81 },
 "46030": { name: "Removal Anal Seton Oth Mrk", wrvu: 1.44 },
 "46040": { name: "Incision & Drainage Ischiorct&/perirct Abscess", wrvu: 5.24 },
 "46045": { name: "Incision & Drainage Abscess Tranal Under Anesthesia", wrvu: 5.72 },
 "46050": { name: "Incision & Drainage Perianal Abscess Supfc", wrvu: 1.21 },
 "46060": { name: "Incision & Drainage Ischiorectal/ntrmrl Abscess", wrvu: 6.21 },
 "46070": { name: "Incision Anal Septum Infant", wrvu: 2.72 },
 "46080": { name: "Sphnctrotmy Anal Div Sphnctr", wrvu: 2.46 },
 "46083": { name: "Inc Thrombosed Hroid Xtrnl", wrvu: 1.41 },
 "46200": { name: "Removal Of Anal Fissure", wrvu: 3.50 },
 "46220": { name: "Excise Anal External Tag/papilla", wrvu: 1.57 },
 "46221": { name: "Ligation Of Hemorrhoid(s)", wrvu: 2.30 },
 "46230": { name: "Removal Of Anal Tags", wrvu: 2.55 },
 "46250": { name: "Remove External Hem Groups 2+", wrvu: 4.14 },
 "46255": { name: "Remove Int/External Hem 1 Group", wrvu: 4.84 },
 "46257": { name: "Remove In/Excision Hem Grp & Fiss", wrvu: 5.62 },
 "46258": { name: "Remove In/Excision Hem Grp With Fistu", wrvu: 6.25 },
 "46260": { name: "Remove In/Excision Hem Groups 2+", wrvu: 6.56 },
 "46261": { name: "Remove In/Excision Hem Grps & Fiss", wrvu: 7.57 },
 "46262": { name: "Remove In/Excision Hem Grps With Fist", wrvu: 7.71 },
 "46270": { name: "Remove Anal Fist Subcutaneous", wrvu: 4.80 },
 "46275": { name: "Remove Anal Fist Inter", wrvu: 5.28 },
 "46280": { name: "Remove Anal Fist Complex", wrvu: 6.23 },
 "46285": { name: "Remove Anal Fist 2 Stage", wrvu: 5.28 },
 "46288": { name: "Repair Anal Fistula", wrvu: 7.61 },
 "46320": { name: "Removal Of Hemorrhoid Clot", wrvu: 1.60 },
 "46500": { name: "Injection Into Hemorrhoid(s)", wrvu: 1.70 },
 "46505": { name: "Chemodenervation Anal Muscle", wrvu: 3.10 },
 "46600": { name: "Diagnostic Anoscopy Spx", wrvu: 0.54 },
 "46601": { name: "Diagnostic Anoscopy", wrvu: 1.56 },
 "46604": { name: "Anoscopy And Dilation", wrvu: 1.00 },
 "46606": { name: "Anoscopy And Biopsy", wrvu: 1.17 },
 "46607": { name: "Diagnostic Anoscopy & Biopsy", wrvu: 2.15 },
 "46608": { name: "Anoscopy Remove For Body", wrvu: 1.27 },
 "46610": { name: "Anoscopy Remove Lesion", wrvu: 1.25 },
 "46611": { name: "Anoscopy", wrvu: 1.27 },
 "46612": { name: "Anoscopy Remove Lesions", wrvu: 1.46 },
 "46614": { name: "Anoscopy Control Bleeding", wrvu: 0.98 },
 "46615": { name: "Anoscopy", wrvu: 1.46 },
 "46700": { name: "Repair Of Anal Stricture", wrvu: 9.56 },
 "46705": { name: "Repair Of Anal Stricture", wrvu: 7.24 },
 "46706": { name: "Repr Of Anal Fistula With Glue", wrvu: 2.38 },
 "46707": { name: "Repair Anorectal Fist With Plug", wrvu: 6.23 },
 "46710": { name: "Repr Per/Vaginal Pouch Sngl Procedure", wrvu: 16.71 },
 "46712": { name: "Repr Per/Vaginal Pouch Dbl Procedure", wrvu: 35.54 },
 "46715": { name: "Rep Perf Anoper Fistu", wrvu: 7.43 },
 "46716": { name: "Rep Perf Anoper/vestib Fistu", wrvu: 17.10 },
 "46730": { name: "Construction Of Absent Anus", wrvu: 29.88 },
 "46735": { name: "Construction Of Absent Anus", wrvu: 35.24 },
 "46740": { name: "Construction Of Absent Anus", wrvu: 33.05 },
 "46742": { name: "Repair Of Imperforated Anus", wrvu: 39.14 },
 "46744": { name: "Repair Of Cloacal Anomaly", wrvu: 57.47 },
 "46746": { name: "Repair Of Cloacal Anomaly", wrvu: 63.80 },
 "46748": { name: "Repair Of Cloacal Anomaly", wrvu: 69.63 },
 "46750": { name: "Repair Of Anal Sphincter", wrvu: 11.85 },
 "46751": { name: "Repair Of Anal Sphincter", wrvu: 9.07 },
 "46753": { name: "Reconstruction Of Anus", wrvu: 8.67 },
 "46754": { name: "Removal Of Suture From Anus", wrvu: 2.93 },
 "46760": { name: "Repair Of Anal Sphincter", wrvu: 17.01 },
 "46761": { name: "Repair Of Anal Sphincter", wrvu: 14.91 },
 "46900": { name: "Destruction Anal Lesion(s)", wrvu: 1.86 },
 "46910": { name: "Destruction Anal Lesion(s)", wrvu: 1.86 },
 "46916": { name: "Cryosurgery Anal Lesion(s)", wrvu: 1.86 },
 "46917": { name: "Laser Surgery Anal Lesions", wrvu: 1.86 },
 "46922": { name: "Excision Of Anal Lesion(s)", wrvu: 1.86 },
 "46924": { name: "Destruction Anal Lesion(s)", wrvu: 2.74 },
 "46930": { name: "Destroy Internal Hemorrhoids", wrvu: 1.57 },
 "46940": { name: "Treatment Of Anal Fissure", wrvu: 2.29 },
 "46942": { name: "Treatment Of Anal Fissure", wrvu: 2.02 },
 "46945": { name: "Int Hrhc Ligation 1 Hroid Without Imaging", wrvu: 3.60 },
 "46946": { name: "Int Hrhc Ligation 2+hroid Without Imaging", wrvu: 4.39 },
 "46947": { name: "Hemorrhoidopexy By Stapling", wrvu: 5.43 },
 "46948": { name: "Int Hrhc Tranal Dartlzj 2+", wrvu: 5.43 },
 "46999": { name: "Unlisted Procedure Anus", wrvu: 0.00 },
 "47000": { name: "Needle Biopsy Of Liver Percutaneous", wrvu: 1.61 },
 "47001": { name: "Needle Biopsy Liver Tm Oth Maj Procedure", wrvu: 1.85 },
 "47010": { name: "Hepatot Open Drainage Abscess/Cast 1/2", wrvu: 18.92 },
 "47015": { name: "Lapt Aspiration&/Injection Hep Prostate Cst", wrvu: 18.04 },
 "47100": { name: "Wedge Biopsy Of Liver", wrvu: 12.59 },
 "47120": { name: "Partial Removal Of Liver", wrvu: 38.03 },
 "47122": { name: "Extensive Removal Of Liver", wrvu: 57.99 },
 "47125": { name: "Partial Removal Of Liver", wrvu: 51.71 },
 "47130": { name: "Partial Removal Of Liver", wrvu: 55.76 },
 "47133": { name: "Removal Of Donor Liver", wrvu: 0.00 },
 "47135": { name: "Transplantation Of Liver", wrvu: 87.75 },
 "47140": { name: "Partial Removal Donor Liver", wrvu: 57.92 },
 "47141": { name: "Partial Removal Donor Liver", wrvu: 69.71 },
 "47142": { name: "Partial Removal Donor Liver", wrvu: 77.45 },
 "47143": { name: "Prep Donor Liver Whole", wrvu: 0.00 },
 "47144": { name: "Prep Donor Liver 3-segment", wrvu: 0.00 },
 "47145": { name: "Prep Donor Liver Lobe Split", wrvu: 0.00 },
 "47146": { name: "Prep Donor Liver/venous", wrvu: 5.85 },
 "47147": { name: "Prep Donor Liver/arterial", wrvu: 6.83 },
 "47300": { name: "Surgery For Liver Lesion", wrvu: 17.69 },
 "47350": { name: "Repair Liver Wound", wrvu: 21.93 },
 "47360": { name: "Repair Liver Wound", wrvu: 30.53 },
 "47361": { name: "Repair Liver Wound", wrvu: 51.29 },
 "47362": { name: "Repair Liver Wound", wrvu: 22.95 },
 "47370": { name: "Laparoscopic Ablate Liver Tumor Rf", wrvu: 20.28 },
 "47371": { name: "Laparoscopic Ablate Liver Cryosurg", wrvu: 20.28 },
 "47379": { name: "Unlisted Laps Procedure Liver", wrvu: 0.00 },
 "47380": { name: "Open Ablate Liver Tumor Rf", wrvu: 23.95 },
 "47381": { name: "Open Ablate Liver Tumor Cryo", wrvu: 24.26 },
 "47382": { name: "Percutaneous Ablate Liver Rf", wrvu: 14.60 },
 "47383": { name: "Percutaneous Abltj Liver Cryoablation", wrvu: 8.66 },
 "47384": { name: "Abltj Ire Liver 1+ Tumor Percutaneous", wrvu: 9.41 },
 "47399": { name: "Unlisted Procedure Liver", wrvu: 0.00 },
 "47400": { name: "Incision Of Liver Duct", wrvu: 35.45 },
 "47420": { name: "Incision Of Bile Duct", wrvu: 21.48 },
 "47425": { name: "Incision Of Bile Duct", wrvu: 21.75 },
 "47460": { name: "Incise Bile Duct Sphincter", wrvu: 20.01 },
 "47480": { name: "Incision Of Gallbladder", wrvu: 12.92 },
 "47490": { name: "Incision Of Gallbladder", wrvu: 4.64 },
 "47531": { name: "Injection For Cholangiogram", wrvu: 1.27 },
 "47532": { name: "Injection For Cholangiogram", wrvu: 4.14 },
 "47533": { name: "Placement Biliary Drainage Catheter", wrvu: 5.25 },
 "47534": { name: "Placement Biliary Drainage Catheter", wrvu: 7.41 },
 "47535": { name: "Conversion External Bil Drainage Catheter", wrvu: 3.85 },
 "47536": { name: "Exchange Biliary Drainage Catheter", wrvu: 2.54 },
 "47537": { name: "Removal Biliary Drainage Catheter", wrvu: 1.79 },
 "47538": { name: "Percutaneous Placement Bile Duct Stent", wrvu: 4.63 },
 "47539": { name: "Percutaneous Placement Bile Duct Stent", wrvu: 8.53 },
 "47540": { name: "Percutaneous Placement Bile Duct Stent", wrvu: 8.80 },
 "47541": { name: "Placement Access Bil Tree Sm Bwl", wrvu: 6.58 },
 "47542": { name: "Dilate Biliary Duct/ampulla", wrvu: 2.78 },
 "47543": { name: "Endoluminal Biopsy Biliary Tree", wrvu: 2.93 },
 "47544": { name: "Removal Duct Glbldr Calculi", wrvu: 3.20 },
 "47550": { name: "Bile Duct Endoscopy Add-on", wrvu: 2.94 },
 "47552": { name: "Biliary Endoscopic Percutaneous Diagnosis With Speci", wrvu: 5.88 },
 "47553": { name: "Biliary Endoscopy Thru Skin", wrvu: 6.18 },
 "47554": { name: "Biliary Endoscopy Thru Skin", wrvu: 8.82 },
 "47555": { name: "Biliary Endoscopy Thru Skin", wrvu: 7.36 },
 "47556": { name: "Biliary Endoscopy Thru Skin", wrvu: 8.34 },
 "47562": { name: "Laparoscopic Cholecystectomy", wrvu: 10.21 },
 "47563": { name: "Laparoscopic Cholecystectomy/graph", wrvu: 11.18 },
 "47564": { name: "Laparoscopic Cholecystectomy/Exploration", wrvu: 17.55 },
 "47570": { name: "Laparoscopic Cholecystoenterostomy", wrvu: 12.25 },
 "47579": { name: "Unlisted Laps Procedure Biliary Trc", wrvu: 0.00 },
 "47600": { name: "Cholecystectomy", wrvu: 17.04 },
 "47605": { name: "Cholecystectomy With Cholang", wrvu: 18.02 },
 "47610": { name: "Removal Of Gallbladder", wrvu: 20.40 },
 "47612": { name: "Removal Of Gallbladder", wrvu: 20.68 },
 "47620": { name: "Removal Of Gallbladder", wrvu: 22.49 },
 "47700": { name: "Exploration Of Bile Ducts", wrvu: 16.09 },
 "47701": { name: "Bile Duct Revision", wrvu: 28.01 },
 "47711": { name: "Excision Of Bile Duct Tumor", wrvu: 25.25 },
 "47712": { name: "Excision Of Bile Duct Tumor", wrvu: 32.88 },
 "47715": { name: "Excision Of Bile Duct Cyst", wrvu: 21.01 },
 "47720": { name: "Fuse Gallbladder & Bowel", wrvu: 17.88 },
 "47721": { name: "Fuse Upper Gastrointestinal Structures", wrvu: 21.44 },
 "47740": { name: "Fuse Gallbladder & Bowel", wrvu: 20.70 },
 "47741": { name: "Fuse Gallbladder & Bowel", wrvu: 23.60 },
 "47760": { name: "Fuse Bile Ducts And Bowel", wrvu: 37.36 },
 "47765": { name: "Fuse Liver Ducts & Bowel", wrvu: 50.89 },
 "47780": { name: "Fuse Bile Ducts And Bowel", wrvu: 41.26 },
 "47785": { name: "Fuse Bile Ducts And Bowel", wrvu: 54.79 },
 "47800": { name: "Reconstruction Of Bile Ducts", wrvu: 25.52 },
 "47801": { name: "Placement Bile Duct Support", wrvu: 17.16 },
 "47900": { name: "Suture Bile Duct Injury", wrvu: 21.88 },
 "47999": { name: "Unlisted Procedure Biliary Tract", wrvu: 0.00 },
 "48000": { name: "Drainage Of Abdomen", wrvu: 31.15 },
 "48001": { name: "Placement Of Drain Pancreas", wrvu: 38.70 },
 "48020": { name: "Removal Of Pancreatic Stone", wrvu: 18.61 },
 "48100": { name: "Biopsy Of Pancreas Open", wrvu: 14.10 },
 "48102": { name: "Needle Biopsy Pancreas", wrvu: 4.58 },
 "48105": { name: "Resection/debride Pancreas", wrvu: 48.03 },
 "48120": { name: "Removal Of Pancreas Lesion", wrvu: 17.95 },
 "48140": { name: "Partial Removal Of Pancreas", wrvu: 25.66 },
 "48145": { name: "Partial Removal Of Pancreas", wrvu: 26.71 },
 "48146": { name: "Pancreatectomy", wrvu: 29.84 },
 "48148": { name: "Removal Of Pancreatic Duct", wrvu: 19.88 },
 "48150": { name: "Partial Removal Of Pancreas", wrvu: 51.52 },
 "48152": { name: "Pancreatectomy", wrvu: 47.43 },
 "48153": { name: "Pancreatectomy", wrvu: 51.47 },
 "48154": { name: "Pancreatectomy", wrvu: 47.66 },
 "48155": { name: "Removal Of Pancreas", wrvu: 28.71 },
 "48160": { name: "Pancreas Removal/transplant", wrvu: 0.00 },
 "48400": { name: "Injection Intraop Add-on", wrvu: 1.90 },
 "48500": { name: "Surgery Of Pancreatic Cyst", wrvu: 17.71 },
 "48510": { name: "Drain Pancreatic Pseudocyst", wrvu: 16.76 },
 "48520": { name: "Fuse Pancreas Cyst And Bowel", wrvu: 17.70 },
 "48540": { name: "Fuse Pancreas Cyst And Bowel", wrvu: 21.39 },
 "48545": { name: "Pancreatorrhaphy", wrvu: 21.67 },
 "48547": { name: "Duodenal Exclusion", wrvu: 29.62 },
 "48548": { name: "Fuse Pancreas And Bowel", wrvu: 27.39 },
 "48550": { name: "Donor Pancreatectomy", wrvu: 0.00 },
 "48551": { name: "Prep Donor Pancreas", wrvu: 0.00 },
 "48552": { name: "Prep Donor Pancreas/venous", wrvu: 4.19 },
 "48554": { name: "Transpl Allograft Pancreas", wrvu: 36.86 },
 "48556": { name: "Removal Allograft Pancreas", wrvu: 18.98 },
 "48999": { name: "Unlisted Procedure Pancreas", wrvu: 0.00 },
 "49000": { name: "Exploration Of Abdomen", wrvu: 12.23 },
 "49002": { name: "Reopening Of Abdomen", wrvu: 17.19 },
 "49010": { name: "Exploration Behind Abdomen", wrvu: 15.66 },
 "49013": { name: "Prpertl Pel Pack Hemrrg Trma", wrvu: 8.14 },
 "49014": { name: "Reexploration Pelvic Wound", wrvu: 6.56 },
 "49020": { name: "Drainage Abdominal Abscess Open", wrvu: 26.00 },
 "49040": { name: "Drain Open Abdominal Abscess", wrvu: 16.11 },
 "49060": { name: "Drain Open Retroperi Abscess", wrvu: 18.07 },
 "49062": { name: "Drain To Peritoneal Cavity", wrvu: 11.91 },
 "49082": { name: "Abdominal Paracentesis", wrvu: 1.21 },
 "49083": { name: "Abdominal Paracentesis With Imaging", wrvu: 1.95 },
 "49084": { name: "Peritoneal Lavage", wrvu: 1.95 },
 "49180": { name: "Biopsy Abdominal Mass", wrvu: 1.69 },
 "49185": { name: "Sclerotx Fluid Collection", wrvu: 2.29 },
 "49186": { name: "Open Excision/dstr Ntra-Abdominal 5 Cm/<", wrvu: 21.45 },
 "49187": { name: "Open Excision/dstr Ntra-Abdominal 5.1-10", wrvu: 27.93 },
 "49188": { name: "Open Excision/dst Ntra-Abdominal 10.1-20", wrvu: 33.15 },
 "49189": { name: "Open Excision/dst Ntra-Abdominal 20.1-30", wrvu: 39.00 },
 "49190": { name: "Open Excision/dstr Ntra-Abdominal >30 Cm", wrvu: 48.75 },
 "49215": { name: "Excise Sacral Spine Tumor", wrvu: 36.86 },
 "49250": { name: "Excision Of Umbilicus", wrvu: 8.78 },
 "49255": { name: "Removal Of Omentum", wrvu: 12.25 },
 "49320": { name: "Diagnostic Laparoscopic Separate Procedure", wrvu: 5.01 },
 "49321": { name: "Laparoscopy Biopsy", wrvu: 5.30 },
 "49322": { name: "Laparoscopy Aspiration", wrvu: 5.86 },
 "49323": { name: "Laparoscopic Drain Lymphocele", wrvu: 9.97 },
 "49324": { name: "Laparoscopic Insert Tunnel Ip Catheter", wrvu: 6.16 },
 "49325": { name: "Laparoscopic Revision Permanent Ip Catheter", wrvu: 6.65 },
 "49326": { name: "Laparoscopic With Omentopexy Add-on", wrvu: 3.41 },
 "49327": { name: "Laparoscopic Ins Device For Right", wrvu: 2.32 },
 "49329": { name: "Unlstd Laps Procedure Abdominal Pertm and omn", wrvu: 0.00 },
 "49400": { name: "Air Injection Into Abdomen", wrvu: 1.83 },
 "49402": { name: "Remove Foreign Body Adbomen", wrvu: 13.74 },
 "49405": { name: "Image Catheter Fluid Colxn Visc", wrvu: 3.90 },
 "49406": { name: "Image Catheter Fluid Peri/retro", wrvu: 3.90 },
 "49407": { name: "Image Catheter Fluid Trns/Vaginal", wrvu: 4.14 },
 "49411": { name: "Ins Mark Abdominal/pel For Right Percutaneous", wrvu: 3.48 },
 "49412": { name: "Ins Device For Right Guide Open", wrvu: 1.46 },
 "49418": { name: "Insert Tun Ip Catheter Percutaneous", wrvu: 3.86 },
 "49419": { name: "Insert Tun Ip Catheter With Port", wrvu: 6.90 },
 "49421": { name: "Ins Tun Ip Catheter For Dial Open", wrvu: 4.10 },
 "49422": { name: "Remove Tunneled Ip Catheter", wrvu: 3.90 },
 "49423": { name: "Exchange Drainage Catheter", wrvu: 1.42 },
 "49424": { name: "Assess Cyst Contrast Inject", wrvu: 0.74 },
 "49425": { name: "Insert Abdomen-venous Drain", wrvu: 11.91 },
 "49426": { name: "Revise Abdomen-venous Shunt", wrvu: 10.15 },
 "49427": { name: "Injection Abdominal Shunt", wrvu: 0.87 },
 "49428": { name: "Ligation Of Shunt", wrvu: 6.70 },
 "49429": { name: "Removal Of Shunt", wrvu: 7.25 },
 "49435": { name: "Insert Subcutaneous Exten To Ip Catheter", wrvu: 2.19 },
 "49436": { name: "Embedded Ip Catheter Exit-site", wrvu: 2.65 },
 "49440": { name: "Place Gastrostomy Tube Percutaneous", wrvu: 3.83 },
 "49441": { name: "Place Duod/jej Tube Percutaneous", wrvu: 4.41 },
 "49442": { name: "Place Cecostomy Tube Percutaneous", wrvu: 3.66 },
 "49446": { name: "Change G-tube To G-j Percutaneous", wrvu: 2.98 },
 "49450": { name: "Replace G/c Tube Percutaneous", wrvu: 1.33 },
 "49451": { name: "Replace Duod/jej Tube Percutaneous", wrvu: 1.79 },
 "49452": { name: "Replace G-j Tube Percutaneous", wrvu: 2.79 },
 "49460": { name: "Fix G/colon Tube With Device", wrvu: 0.94 },
 "49465": { name: "Fluoroscopy Exam Of G/colon Tube", wrvu: 0.60 },
 "49491": { name: "Repair Hern Preemie Reduction", wrvu: 12.22 },
 "49492": { name: "Repair Inguinal Hern Premie Blocked", wrvu: 15.04 },
 "49495": { name: "Repair Inguinal Hernia Baby Reduction", wrvu: 6.05 },
 "49496": { name: "Repair Inguinal Hernia Baby Blocked", wrvu: 9.18 },
 "49500": { name: "Repair Inguinal Hernia Init Reduce", wrvu: 5.69 },
 "49501": { name: "Repair Inguinal Hernia Init Blocked", wrvu: 9.13 },
 "49505": { name: "PRP I/hern Init Reduction >5 Year", wrvu: 7.76 },
 "49507": { name: "PRP I/hern Init Block >5 Year", wrvu: 8.86 },
 "49520": { name: "Rerepair Inguinal Hernia Reduce", wrvu: 9.74 },
 "49521": { name: "Rerepair Inguinal Hernia Blocked", wrvu: 11.19 },
 "49525": { name: "Repair Inguinal Hernia Sliding", wrvu: 8.71 },
 "49540": { name: "Repair Lumbar Hernia", wrvu: 10.47 },
 "49550": { name: "Repair Rem Hernia Init Reduce", wrvu: 8.77 },
 "49553": { name: "Repair Fem Hernia Init Blocked", wrvu: 9.67 },
 "49555": { name: "Rerepair Fem Hernia Reduce", wrvu: 9.16 },
 "49557": { name: "Rerepair Fem Hernia Blocked", wrvu: 11.33 },
 "49591": { name: "Repair Aa Hernia 1st < 3 cm Rdc", wrvu: 5.81 },
 "49592": { name: "Repair Aa Hernia 1st < 3 Incision/Sternum", wrvu: 8.25 },
 "49593": { name: "Repair Aa Hernia 1st 3-10 Rdc", wrvu: 10.00 },
 "49594": { name: "Repair Aa Hernia 1st 3-10 Incision/Sternum", wrvu: 13.12 },
 "49595": { name: "Repair Aa Hernia 1st > 10 Rdc", wrvu: 13.59 },
 "49596": { name: "Repair Aa Hernia 1st > 10 Incision/Sternum", wrvu: 18.20 },
 "49600": { name: "Repair Umbilical Lesion", wrvu: 11.26 },
 "49605": { name: "Repair Umbilical Lesion", wrvu: 84.91 },
 "49606": { name: "Repair Umbilical Lesion", wrvu: 18.53 },
 "49610": { name: "Repair Umbilical Lesion", wrvu: 10.64 },
 "49611": { name: "Repair Umbilical Lesion", wrvu: 9.11 },
 "49613": { name: "Repair Aa Hernia Rcr < 3 Rdc", wrvu: 7.23 },
 "49614": { name: "Repair Aa Hernia Rcr < 3 Incision/Sternum", wrvu: 9.99 },
 "49615": { name: "Repair Aa Hernia Rcr 3-10 Rdc", wrvu: 11.17 },
 "49616": { name: "Repair Aa Hernia Rcr 3-10 Incision/Sternum", wrvu: 15.16 },
 "49617": { name: "Repair Aa Hernia Rcr > 10 Rdc", wrvu: 15.63 },
 "49618": { name: "Repair Aa Hernia Rcr > 10 Incision/Sternum", wrvu: 22.10 },
 "49621": { name: "Repair Parastomal Hernia Rdc", wrvu: 13.36 },
 "49622": { name: "Repair Parastomal Hernia Incision/Sternum", wrvu: 16.63 },
 "49623": { name: "Removal Ninfct Mesh Hernia Repair", wrvu: 3.66 },
 "49650": { name: "Laparoscopic Inguinal Hernia Repair Init", wrvu: 6.20 },
 "49651": { name: "Laparoscopic Inguinal Hernia Repair Recur", wrvu: 8.17 },
 "49659": { name: "Unlstd Laps Procedure Hrnap Hrnrphy", wrvu: 0.00 },
 "49900": { name: "Repair Of Abdominal Wall", wrvu: 12.10 },
 "49904": { name: "Omental Flap Extra-abdominal", wrvu: 21.79 },
 "49905": { name: "Omental Flap Intra-abdominal", wrvu: 6.38 },
 "49906": { name: "Free Omental Flap Microvasc", wrvu: 0.00 },
 "49999": { name: "Unlisted Procedure Abdominal Pertm and omn", wrvu: 0.00 },
 "50010": { name: "Renal Exploration", wrvu: 11.97 },
 "50020": { name: "Drainage Perirnl/renal Abscess Open", wrvu: 17.63 },
 "50040": { name: "Nfros Nfrot With Drainage", wrvu: 16.26 },
 "50045": { name: "Nephrotomy With Exploration", wrvu: 16.40 },
 "50060": { name: "Nl Removal Calculus", wrvu: 20.43 },
 "50065": { name: "Nl Secondary Surgery Operj Calculus", wrvu: 21.76 },
 "50070": { name: "Nl Comp Cgen Kdn Abnormality", wrvu: 21.30 },
 "50075": { name: "Nl Removal Lg Staghorn Calculus", wrvu: 26.41 },
 "50080": { name: "Percutaneous Nl/pl Lithotrp Simple<2cm", wrvu: 12.10 },
 "50081": { name: "Percutaneous Nl/pl Lithotrp Cplx>2cm", wrvu: 20.39 },
 "50100": { name: "Trnsxj/repos Abrrnt Rnl Vsls", wrvu: 17.01 },
 "50120": { name: "Pyelotomy With Exploration", wrvu: 16.78 },
 "50125": { name: "Pyelotomy With Drainage Pyelostomy", wrvu: 17.37 },
 "50130": { name: "Pyelotomy With Removal Calculus", wrvu: 18.35 },
 "50200": { name: "Renal Biopsy Percutaneous", wrvu: 2.32 },
 "50205": { name: "Renal Biopsy Surgery Exposure Kdn", wrvu: 11.98 },
 "50220": { name: "Remove Kidney Open", wrvu: 18.21 },
 "50225": { name: "Removal Kidney Open Complex", wrvu: 21.33 },
 "50230": { name: "Removal Kidney Open Radical", wrvu: 23.21 },
 "50234": { name: "Removal Of Kidney & Ureter", wrvu: 23.45 },
 "50236": { name: "Removal Of Kidney & Ureter", wrvu: 26.27 },
 "50240": { name: "Nephrectomy Partial", wrvu: 23.60 },
 "50250": { name: "Open Abltj 1/> Rnl Mas Crysrg", wrvu: 21.66 },
 "50280": { name: "Excision/unroofing Cyst Kidney", wrvu: 16.66 },
 "50290": { name: "Excision Perinephric Cyst", wrvu: 15.75 },
 "50300": { name: "Remove Cadaver Donor Kidney", wrvu: 0.00 },
 "50320": { name: "Remove Kidney Living Donor", wrvu: 21.87 },
 "50323": { name: "Prep Cadaver Renal Allograft", wrvu: 0.00 },
 "50325": { name: "Prep Donor Renal Graft", wrvu: 0.00 },
 "50327": { name: "Prep Renal Graft/venous", wrvu: 3.90 },
 "50328": { name: "Prep Renal Graft/arterial", wrvu: 3.41 },
 "50329": { name: "Prep Renal Graft/ureteral", wrvu: 3.26 },
 "50340": { name: "Recipient Nephrectomy", wrvu: 13.69 },
 "50360": { name: "Rnl Altrnsplj Without Rcp Nfrct", wrvu: 38.88 },
 "50365": { name: "Rnl Altrnsplj With Rcp Nfrct", wrvu: 44.98 },
 "50370": { name: "Removal Transplanted Rnl Algrft", wrvu: 18.41 },
 "50380": { name: "Rnl Autotrnsplj Rimpltj Kdn", wrvu: 29.36 },
 "50382": { name: "Change Ureter Stent Percutaneous", wrvu: 5.12 },
 "50384": { name: "Remove Ureter Stent Percutaneous", wrvu: 4.63 },
 "50385": { name: "Change Stent Via Transureth", wrvu: 4.09 },
 "50386": { name: "Remove Stent Via Transureth", wrvu: 2.97 },
 "50387": { name: "Change Nephroureteral Catheter", wrvu: 1.71 },
 "50389": { name: "Remove Renal Tube With Fluoroscopy", wrvu: 1.07 },
 "50390": { name: "Drainage Of Kidney Lesion", wrvu: 1.91 },
 "50391": { name: "Instll Prescription Agnt Into Rnal Tub", wrvu: 1.91 },
 "50396": { name: "Measure Kidney Pressure", wrvu: 2.04 },
 "50400": { name: "Revision Of Kidney/ureter", wrvu: 20.74 },
 "50405": { name: "Revision Of Kidney/ureter", wrvu: 25.21 },
 "50430": { name: "Injection Procedure Nfrosgrm &/urtrgrm", wrvu: 2.83 },
 "50431": { name: "Injection Procedure Nfrosgrm &/urtrgrm", wrvu: 1.07 },
 "50432": { name: "Placement Nephrostomy Catheter", wrvu: 3.90 },
 "50433": { name: "Placement Nephroureteral Catheter", wrvu: 4.92 },
 "50434": { name: "Convert Nephrostomy Catheter", wrvu: 3.66 },
 "50435": { name: "Exchange Nephrostomy Catheter", wrvu: 1.77 },
 "50436": { name: "Dilat Xst Trc Ndurlgc Procedure", wrvu: 2.71 },
 "50437": { name: "Dilat Xst Trc New Access Rcs", wrvu: 4.73 },
 "50500": { name: "Repair Of Kidney Wound", wrvu: 20.69 },
 "50520": { name: "Close Kidney-skin Fistula", wrvu: 18.41 },
 "50525": { name: "Close Nephrovisceral Fistula", wrvu: 23.78 },
 "50526": { name: "Close Nephrovisceral Fistula", wrvu: 25.65 },
 "50540": { name: "Revision Of Horseshoe Kidney", wrvu: 20.57 },
 "50541": { name: "Laparoscopic Ablate Renal Cyst", wrvu: 16.44 },
 "50542": { name: "Laparoscopic Ablate Renal Mass", wrvu: 20.83 },
 "50543": { name: "Laparoscopic Partial Nephrectomy", wrvu: 26.72 },
 "50544": { name: "Laparoscopy Pyeloplasty", wrvu: 22.79 },
 "50545": { name: "Laparoscopic Radical Nephrectomy", wrvu: 24.43 },
 "50546": { name: "Laparoscopic Nephrectomy", wrvu: 21.32 },
 "50547": { name: "Laparoscopic Removal Donor Kidney", wrvu: 25.68 },
 "50548": { name: "Laparoscopic Remove With Ureter", wrvu: 24.73 },
 "50549": { name: "Unlisted Laps Procedure Renal", wrvu: 0.00 },
 "50551": { name: "Kidney Endoscopy", wrvu: 5.45 },
 "50553": { name: "Kidney Endoscopy", wrvu: 5.83 },
 "50555": { name: "Kidney Endoscopy & Biopsy", wrvu: 6.36 },
 "50557": { name: "Kidney Endoscopy & Treatment", wrvu: 6.44 },
 "50561": { name: "Kidney Endoscopy & Treatment", wrvu: 7.39 },
 "50562": { name: "Renal Scope With Tumor Resection", wrvu: 10.63 },
 "50570": { name: "Kidney Endoscopy", wrvu: 9.29 },
 "50572": { name: "Kidney Endoscopy", wrvu: 10.07 },
 "50574": { name: "Kidney Endoscopy & Biopsy", wrvu: 10.73 },
 "50575": { name: "Kidney Endoscopy", wrvu: 13.61 },
 "50576": { name: "Kidney Endoscopy & Treatment", wrvu: 10.70 },
 "50580": { name: "Kidney Endoscopy & Treatment", wrvu: 11.54 },
 "50590": { name: "Fragmenting Of Kidney Stone", wrvu: 9.53 },
 "50592": { name: "Percutaneous Radiofrequency Ablate Renal Tumor", wrvu: 6.39 },
 "50593": { name: "Percutaneous Cryo Ablate Renal Tumor", wrvu: 8.66 },
 "50600": { name: "Exploration Of Ureter", wrvu: 16.74 },
 "50605": { name: "Insert Ureteral Support", wrvu: 16.37 },
 "50606": { name: "Endoluminal Biopsy Ureteral Rnl Pelvis", wrvu: 3.08 },
 "50610": { name: "Removal Of Ureter Stone", wrvu: 16.82 },
 "50620": { name: "Removal Of Ureter Stone", wrvu: 16.02 },
 "50630": { name: "Removal Of Ureter Stone", wrvu: 15.80 },
 "50650": { name: "Removal Of Ureter", wrvu: 18.35 },
 "50660": { name: "Removal Of Ureter", wrvu: 20.49 },
 "50684": { name: "Injection For Ureter X-ray", wrvu: 0.74 },
 "50686": { name: "Measure Ureter Pressure", wrvu: 1.47 },
 "50688": { name: "Change Of Ureter Tube/stent", wrvu: 1.17 },
 "50690": { name: "Injection For Ureter X-ray", wrvu: 1.13 },
 "50693": { name: "Placement Ureteral Stent Prq", wrvu: 3.86 },
 "50694": { name: "Placement Ureteral Stent Prq", wrvu: 5.12 },
 "50695": { name: "Placement Ureteral Stent Prq", wrvu: 6.63 },
 "50700": { name: "Revision Of Ureter", wrvu: 16.27 },
 "50705": { name: "Ureteral Embolization/occl", wrvu: 3.93 },
 "50706": { name: "Balloon Dilate Urtrl Strix", wrvu: 3.71 },
 "50715": { name: "Release Of Ureter", wrvu: 20.12 },
 "50722": { name: "Release Of Ureter", wrvu: 17.50 },
 "50725": { name: "Release/revise Ureter", wrvu: 19.70 },
 "50727": { name: "Revise Ureter", wrvu: 8.07 },
 "50728": { name: "Revise Ureter", wrvu: 11.88 },
 "50740": { name: "Fusion Of Ureter & Kidney", wrvu: 19.57 },
 "50750": { name: "Fusion Of Ureter & Kidney", wrvu: 20.69 },
 "50760": { name: "Ureteroureterostomy", wrvu: 19.57 },
 "50770": { name: "Splicing Of Ureters", wrvu: 20.69 },
 "50780": { name: "Reimplant Ureter In Bladder", wrvu: 19.45 },
 "50782": { name: "Reimplant Ureter In Bladder", wrvu: 19.17 },
 "50783": { name: "Reimplant Ureter In Bladder", wrvu: 20.18 },
 "50785": { name: "Reimplant Ureter In Bladder", wrvu: 21.67 },
 "50800": { name: "Implant Ureter In Bowel", wrvu: 16.00 },
 "50810": { name: "Fusion Of Ureter & Bowel", wrvu: 22.04 },
 "50815": { name: "Urine Shunt To Intestine", wrvu: 21.70 },
 "50820": { name: "Construct Bowel Bladder", wrvu: 23.47 },
 "50825": { name: "Construct Bowel Bladder", wrvu: 29.91 },
 "50830": { name: "Revise Urine Flow", wrvu: 32.93 },
 "50840": { name: "Replace Ureter By Bowel", wrvu: 21.83 },
 "50845": { name: "Appendico-vesicostomy", wrvu: 21.90 },
 "50860": { name: "Transplant Ureter To Skin", wrvu: 16.65 },
 "50900": { name: "Repair Of Ureter", wrvu: 14.66 },
 "50920": { name: "Closure Ureter/skin Fistula", wrvu: 15.41 },
 "50930": { name: "Closure Ureter/bowel Fistula", wrvu: 19.69 },
 "50940": { name: "Release Of Ureter", wrvu: 15.53 },
 "50945": { name: "Laparoscopy Ureterolithotomy", wrvu: 17.52 },
 "50947": { name: "Laparoscopic New Ureter/bladder", wrvu: 25.14 },
 "50948": { name: "Laparoscopic New Ureter/bladder", wrvu: 23.22 },
 "50949": { name: "Unlisted Laps Procedure Ureter", wrvu: 0.00 },
 "50951": { name: "Endoscopy Of Ureter", wrvu: 5.68 },
 "50953": { name: "Endoscopy Of Ureter", wrvu: 6.07 },
 "50955": { name: "Ureter Endoscopy & Biopsy", wrvu: 6.57 },
 "50957": { name: "Ureter Endoscopy & Treatment", wrvu: 6.61 },
 "50961": { name: "Ureter Endoscopy & Treatment", wrvu: 5.89 },
 "50970": { name: "Ureter Endoscopy", wrvu: 6.95 },
 "50972": { name: "Ureter Endoscopy & Catheter", wrvu: 6.71 },
 "50974": { name: "Ureter Endoscopy & Biopsy", wrvu: 8.93 },
 "50976": { name: "Ureter Endoscopy & Treatment", wrvu: 8.80 },
 "50980": { name: "Ureter Endoscopy & Treatment", wrvu: 6.67 },
 "51020": { name: "Cystotomy/cystostomy With Fulg", wrvu: 7.50 },
 "51040": { name: "Incise & Drain Bladder", wrvu: 4.38 },
 "51045": { name: "Incise Bladder/drain Ureter", wrvu: 7.61 },
 "51050": { name: "Removal Of Bladder Stone", wrvu: 7.77 },
 "51060": { name: "Removal Of Ureter Stone", wrvu: 9.70 },
 "51065": { name: "Remove Ureter Calculus", wrvu: 9.70 },
 "51080": { name: "Drainage Of Bladder Abscess", wrvu: 6.54 },
 "51100": { name: "Drain Bladder By Needle", wrvu: 0.76 },
 "51101": { name: "Drain Bladder By Trocar/Catheter", wrvu: 0.99 },
 "51102": { name: "Drain Bl With Catheter Insertion", wrvu: 2.63 },
 "51500": { name: "Removal Of Bladder Cyst", wrvu: 10.77 },
 "51520": { name: "Removal Of Bladder Lesion", wrvu: 9.95 },
 "51525": { name: "Removal Of Bladder Lesion", wrvu: 15.03 },
 "51530": { name: "Removal Of Bladder Lesion", wrvu: 13.37 },
 "51535": { name: "Repair Of Ureter Lesion", wrvu: 13.55 },
 "51550": { name: "Partial Removal Of Bladder", wrvu: 16.80 },
 "51555": { name: "Partial Removal Of Bladder", wrvu: 22.60 },
 "51565": { name: "Revise Bladder & Ureter(s)", wrvu: 23.09 },
 "51570": { name: "Removal Of Bladder", wrvu: 26.77 },
 "51575": { name: "Removal Of Bladder & Nodes", wrvu: 33.33 },
 "51580": { name: "Remove Bladder/revise Tract", wrvu: 34.49 },
 "51585": { name: "Removal Of Bladder & Nodes", wrvu: 38.65 },
 "51590": { name: "Remove Bladder/revise Tract", wrvu: 35.42 },
 "51595": { name: "Remove Bladder/revise Tract", wrvu: 40.29 },
 "51596": { name: "Remove Bladder/create Pouch", wrvu: 43.15 },
 "51597": { name: "Removal Of Pelvic Structures", wrvu: 41.79 },
 "51600": { name: "Injection For Bladder X-ray", wrvu: 0.86 },
 "51605": { name: "Preparation For Bladder X-ray", wrvu: 0.62 },
 "51610": { name: "Injection For Bladder X-ray", wrvu: 1.02 },
 "51700": { name: "Irrigation Of Bladder", wrvu: 0.59 },
 "51701": { name: "Bladder Catheterization, Simple (e.g., Foley)", wrvu: 0.49 },
 "51702": { name: "Bladder Catheterization, Temporary (in and out)", wrvu: 0.49 },
 "51703": { name: "Bladder Catheterization, Complicated (difficulty passing)", wrvu: 1.43 },
 "51705": { name: "Change Of Bladder Tube", wrvu: 0.88 },
 "51710": { name: "Change Of Bladder Tube", wrvu: 1.32 },
 "51715": { name: "Endoscopic Injection/implant", wrvu: 3.64 },
 "51720": { name: "Treatment Of Bladder Lesion", wrvu: 0.85 },
 "51721": { name: "Ins Trurl Ablt Trnsdc Thr Ultrasound", wrvu: 3.95 },
 "51725": { name: "Simple Cystometrogram", wrvu: 1.47 },
 "51726": { name: "Complex Cystometrogram", wrvu: 1.67 },
 "51727": { name: "Cystometrogram With Up", wrvu: 2.06 },
 "51728": { name: "Cystometrogram With Vp", wrvu: 2.06 },
 "51729": { name: "Cystometrogram With Vp and up", wrvu: 2.45 },
 "51736": { name: "Urine Flow Measurement", wrvu: 0.17 },
 "51741": { name: "Electro-uroflowmetry First", wrvu: 0.17 },
 "51784": { name: "Anal/urinary Muscle Study", wrvu: 0.73 },
 "51785": { name: "Anal/urinary Muscle Study", wrvu: 1.49 },
 "51792": { name: "Urinary Reflex Study", wrvu: 1.07 },
 "51797": { name: "Intraabdominal Pressure Test", wrvu: 0.78 },
 "51798": { name: "Ultrasound Urine Capacity Measure", wrvu: 0.00 },
 "51800": { name: "Revision Of Bladder/urethra", wrvu: 18.42 },
 "51820": { name: "Revision Of Urinary Tract", wrvu: 19.10 },
 "51840": { name: "Attach Bladder/urethra", wrvu: 11.08 },
 "51841": { name: "Attach Bladder/urethra", wrvu: 13.34 },
 "51845": { name: "Repair Bladder Neck", wrvu: 9.90 },
 "51860": { name: "Repair Of Bladder Wound", wrvu: 12.29 },
 "51865": { name: "Repair Of Bladder Wound", wrvu: 15.41 },
 "51880": { name: "Repair Of Bladder Opening", wrvu: 7.67 },
 "51900": { name: "Repair Bladder/vagina Lesion", wrvu: 14.26 },
 "51920": { name: "Close Bladder-uterus Fistula", wrvu: 13.07 },
 "51925": { name: "Hysterectomy/bladder Repair", wrvu: 17.09 },
 "51940": { name: "Correction Of Bladder Defect", wrvu: 29.89 },
 "51960": { name: "Revision Of Bladder & Bowel", wrvu: 24.77 },
 "51980": { name: "Construct Bladder Opening", wrvu: 12.26 },
 "51990": { name: "Laparoscopic Urethral Suspension", wrvu: 13.03 },
 "51992": { name: "Laparoscopic Sling Operation", wrvu: 14.50 },
 "51999": { name: "Unlisted Laps Procedure Bladder", wrvu: 0.00 },
 "52000": { name: "Cystourethroscopy", wrvu: 1.49 },
 "52001": { name: "Cysto With Irrg and evac Mlt Clots", wrvu: 5.30 },
 "52005": { name: "Cysto With Urtrl Cathj", wrvu: 2.31 },
 "52007": { name: "Cysto Urtrl Cathj Brush Biopsy", wrvu: 2.94 },
 "52010": { name: "Cystoscopy & Duct Catheter", wrvu: 2.94 },
 "52204": { name: "Cystoscopy With Biopsy(s)", wrvu: 2.53 },
 "52214": { name: "Cystoscopy And Treatment", wrvu: 3.41 },
 "52224": { name: "Cystoscopy And Treatment", wrvu: 3.95 },
 "52234": { name: "Cystoscopy And Treatment", wrvu: 4.50 },
 "52235": { name: "Cystoscopy And Treatment", wrvu: 5.30 },
 "52240": { name: "Cystoscopy And Treatment", wrvu: 7.31 },
 "52250": { name: "Cystoscopy And Radiotracer", wrvu: 4.38 },
 "52260": { name: "Cystoscopy And Treatment", wrvu: 3.81 },
 "52265": { name: "Cystoscopy And Treatment", wrvu: 2.87 },
 "52270": { name: "Cystoscopy & Revise Urethra", wrvu: 3.28 },
 "52275": { name: "Cystoscopy & Revise Urethra", wrvu: 4.57 },
 "52276": { name: "Cystoscopy And Treatment", wrvu: 4.87 },
 "52277": { name: "Cystoscopy And Treatment", wrvu: 6.01 },
 "52281": { name: "Cystoscopy And Treatment", wrvu: 2.68 },
 "52282": { name: "Cystoscopy Implant Stent", wrvu: 6.23 },
 "52283": { name: "Cystoscopy And Treatment", wrvu: 3.64 },
 "52284": { name: "Cysto Prescription Balo Catheter Urtl Strx", wrvu: 3.02 },
 "52285": { name: "Cystoscopy And Treatment", wrvu: 3.51 },
 "52287": { name: "Cystoscopy Chemodenervation", wrvu: 3.12 },
 "52290": { name: "Cystoscopy And Treatment", wrvu: 4.47 },
 "52300": { name: "Cystoscopy And Treatment", wrvu: 5.17 },
 "52301": { name: "Cystoscopy And Treatment", wrvu: 5.36 },
 "52305": { name: "Cystoscopy And Treatment", wrvu: 5.17 },
 "52310": { name: "Cystoscopy And Treatment", wrvu: 2.74 },
 "52315": { name: "Cystoscopy And Treatment", wrvu: 5.07 },
 "52317": { name: "Remove Bladder Stone", wrvu: 6.54 },
 "52318": { name: "Remove Bladder Stone", wrvu: 8.95 },
 "52320": { name: "Cystoscopy And Treatment", wrvu: 4.57 },
 "52325": { name: "Cystoscopy Stone Removal", wrvu: 6.00 },
 "52327": { name: "Cystoscopy Inject Material", wrvu: 5.05 },
 "52330": { name: "Cystoscopy And Treatment", wrvu: 4.90 },
 "52332": { name: "Cystoscopy And Treatment", wrvu: 2.75 },
 "52334": { name: "Create Passage To Kidney", wrvu: 3.29 },
 "52341": { name: "Cysto With Ureter Stricture Treatment", wrvu: 5.22 },
 "52342": { name: "Cysto With Up Stricture Treatment", wrvu: 5.70 },
 "52343": { name: "Cysto With Renal Stricture Treatment", wrvu: 6.39 },
 "52344": { name: "Cysto/uretero Stricture Treatment", wrvu: 6.87 },
 "52345": { name: "Cysto/uretero With Up Stricture", wrvu: 7.36 },
 "52346": { name: "Cystouretero With Renal Strict", wrvu: 8.37 },
 "52351": { name: "Cystouretero & Or Pyeloscope", wrvu: 5.61 },
 "52352": { name: "Cystouretero With Stone Remove", wrvu: 6.58 },
 "52353": { name: "Cystouretero With Lithotripsy", wrvu: 7.31 },
 "52354": { name: "Cystouretero With Biopsy", wrvu: 7.80 },
 "52355": { name: "Cystouretero With Excise Tumor", wrvu: 8.78 },
 "52356": { name: "Cysto/uretero With Lithotripsy", wrvu: 7.80 },
 "52400": { name: "Cysto Cgen Posterior Urtl Valves", wrvu: 8.47 },
 "52402": { name: "Cysto Trurl Resection Ejacul Dux", wrvu: 5.14 },
 "52441": { name: "Cysto Insertion Trnsprstc 1 Implt", wrvu: 3.90 },
 "52442": { name: "Cysto Ins Trnsprstc Implt Each", wrvu: 0.98 },
 "52443": { name: "Cysto 1st Trurl Prst8 Comis", wrvu: 3.62 },
 "52450": { name: "Transurethral Inc Prostate", wrvu: 7.59 },
 "52500": { name: "Trurl Resection Bladder Neck", wrvu: 5.85 },
 "52597": { name: "Trurl Robotic Wtrjt Resection Prst8", wrvu: 10.25 },
 "52601": { name: "Prostatectomy (Transurethral Resection of Prostate)", wrvu: 9.75 },
 "52630": { name: "Remove Prostate Regrowth", wrvu: 6.39 },
 "52640": { name: "Relieve Bladder Contracture", wrvu: 4.67 },
 "52648": { name: "Laser Surgery Of Prostate", wrvu: 9.80 },
 "52649": { name: "Prostate Laser Enucleation", wrvu: 12.68 },
 "52700": { name: "Drainage Of Prostate Abscess", wrvu: 7.30 },
 "53000": { name: "Incision Of Urethra", wrvu: 2.27 },
 "53010": { name: "Incision Of Urethra", wrvu: 4.34 },
 "53020": { name: "Incision Of Urethra", wrvu: 1.73 },
 "53025": { name: "Incision Of Urethra", wrvu: 1.10 },
 "53040": { name: "Drainage Of Urethra Abscess", wrvu: 6.39 },
 "53060": { name: "Drainage Of Urethra Abscess", wrvu: 2.61 },
 "53080": { name: "Drainage Of Urinary Leakage", wrvu: 6.75 },
 "53085": { name: "Drainage Of Urinary Leakage", wrvu: 10.90 },
 "53200": { name: "Biopsy Of Urethra", wrvu: 2.53 },
 "53210": { name: "Removal Of Urethra", wrvu: 13.38 },
 "53215": { name: "Removal Of Urethra", wrvu: 16.43 },
 "53220": { name: "Treatment Of Urethra Lesion", wrvu: 7.44 },
 "53230": { name: "Removal Of Urethra Lesion", wrvu: 10.18 },
 "53235": { name: "Removal Of Urethra Lesion", wrvu: 10.72 },
 "53240": { name: "Surgery For Urethra Pouch", wrvu: 6.90 },
 "53250": { name: "Removal Of Urethra Gland", wrvu: 6.36 },
 "53260": { name: "Treatment Of Urethra Lesion", wrvu: 2.95 },
 "53265": { name: "Treatment Of Urethra Lesion", wrvu: 3.09 },
 "53270": { name: "Removal Of Urethra Gland", wrvu: 3.06 },
 "53275": { name: "Repair Of Urethra Defect", wrvu: 4.46 },
 "53400": { name: "Revise Urethra Stage 1", wrvu: 13.78 },
 "53405": { name: "Revise Urethra Stage 2", wrvu: 15.27 },
 "53410": { name: "Reconstruction Of Urethra", wrvu: 17.24 },
 "53415": { name: "Reconstruction Of Urethra", wrvu: 20.18 },
 "53420": { name: "Reconstruct Urethra Stage 1", wrvu: 14.79 },
 "53425": { name: "Reconstruct Urethra Stage 2", wrvu: 16.64 },
 "53430": { name: "Reconstruction Of Urethra", wrvu: 16.99 },
 "53431": { name: "Reconstruct Urethra/bladder", wrvu: 20.65 },
 "53440": { name: "Male Sling Procedure", wrvu: 13.03 },
 "53442": { name: "Remove/revise Male Sling", wrvu: 13.15 },
 "53444": { name: "Insert Tandem Cuff", wrvu: 13.84 },
 "53445": { name: "Insert Uro/ves Neck Sphincter", wrvu: 12.68 },
 "53446": { name: "Remove Uro Sphincter", wrvu: 10.74 },
 "53447": { name: "Remove/replace Ur Sphincter", wrvu: 13.92 },
 "53448": { name: "Remov/replc Ur Sphinctr Comp", wrvu: 22.85 },
 "53449": { name: "Repair Uro Sphincter", wrvu: 10.30 },
 "53450": { name: "Revision Of Urethra", wrvu: 6.60 },
 "53451": { name: "Tprnl Balo Cntnc Device Bi", wrvu: 0.00 },
 "53452": { name: "Tprnl Balo Cntnc Device Uni", wrvu: 0.00 },
 "53453": { name: "Tprnl Balo Cntnc Device Removal Each", wrvu: 0.00 },
 "53454": { name: "Tprnl Balo Cntnc Device Adjmt", wrvu: 0.00 },
 "53460": { name: "Revision Of Urethra", wrvu: 7.56 },
 "53500": { name: "Urethrlys Transvag W/ Scope", wrvu: 12.68 },
 "53502": { name: "Repair Of Urethra Injury", wrvu: 8.05 },
 "53505": { name: "Repair Of Urethra Injury", wrvu: 8.05 },
 "53510": { name: "Repair Of Urethra Injury", wrvu: 10.69 },
 "53515": { name: "Repair Of Urethra Injury", wrvu: 13.86 },
 "53520": { name: "Repair Of Urethra Defect", wrvu: 9.24 },
 "53600": { name: "Dilate Urethra Stricture", wrvu: 1.18 },
 "53601": { name: "Dilate Urethra Stricture", wrvu: 0.96 },
 "53605": { name: "Dilate Urethra Stricture", wrvu: 1.25 },
 "53620": { name: "Dilate Urethra Stricture", wrvu: 1.58 },
 "53621": { name: "Dilate Urethra Stricture", wrvu: 1.32 },
 "53660": { name: "Dilation Of Urethra", wrvu: 0.69 },
 "53661": { name: "Dilation Of Urethra", wrvu: 0.70 },
 "53665": { name: "Dilation Of Urethra", wrvu: 0.74 },
 "53850": { name: "Prostatic Microwave Thermotx", wrvu: 5.28 },
 "53852": { name: "Prostatic Rheumatoid Factor Thermotx", wrvu: 5.78 },
 "53854": { name: "Trurl Dstrj Prst8 Tiss Rheumatoid Factor Wv", wrvu: 5.78 },
 "53855": { name: "Insert Prost Urethral Stent", wrvu: 1.60 },
 "53860": { name: "Transurethral Rheumatoid Factor Treatment", wrvu: 3.87 },
 "53865": { name: "Cysto Insertion Device Ischmc Rmdlg", wrvu: 3.02 },
 "53866": { name: "Cathj Removal Device Ischmc Rmdlg", wrvu: 1.44 },
 "53899": { name: "Unlisted Procedure Urinary System", wrvu: 0.00 },
 "54000": { name: "Slitting Of Prepuce", wrvu: 1.55 },
 "54001": { name: "Slitting Of Prepuce", wrvu: 2.18 },
 "54015": { name: "Incision & Drainage Penis Deep", wrvu: 5.23 },
 "54050": { name: "Destruction Penis Lesion(s)", wrvu: 1.26 },
 "54055": { name: "Destruction Penis Lesion(s)", wrvu: 1.22 },
 "54056": { name: "Cryosurgery Penis Lesion(s)", wrvu: 1.26 },
 "54057": { name: "Laser Surgery Penis Lesion(s)", wrvu: 1.26 },
 "54060": { name: "Excision Of Penis Lesion(s)", wrvu: 1.93 },
 "54065": { name: "Destruction Penis Lesion(s)", wrvu: 2.41 },
 "54100": { name: "Biopsy Of Penis", wrvu: 1.85 },
 "54105": { name: "Biopsy Of Penis", wrvu: 3.45 },
 "54110": { name: "Treatment Of Penis Lesion", wrvu: 10.65 },
 "54111": { name: "Treat Penis Lesion Graft", wrvu: 14.06 },
 "54112": { name: "Treat Penis Lesion Graft", wrvu: 16.56 },
 "54115": { name: "Treatment Of Penis Lesion", wrvu: 6.78 },
 "54120": { name: "Partial Removal Of Penis", wrvu: 10.73 },
 "54125": { name: "Removal Of Penis", wrvu: 14.20 },
 "54130": { name: "Remove Penis & Nodes", wrvu: 21.29 },
 "54135": { name: "Remove Penis & Nodes", wrvu: 27.47 },
 "54150": { name: "Circumcision With Regionl Block", wrvu: 1.85 },
 "54160": { name: "Circumcision Neonate", wrvu: 2.47 },
 "54161": { name: "Circum 28 Days Or Older", wrvu: 3.24 },
 "54162": { name: "Lysis Penil Circumic Lesion", wrvu: 3.24 },
 "54163": { name: "Repair Of Circumcision", wrvu: 3.24 },
 "54164": { name: "Frenulotomy Of Penis", wrvu: 2.75 },
 "54200": { name: "Injection Procedure Peyronie Ds", wrvu: 1.08 },
 "54205": { name: "Injection Procedure Peyronie Ds Exps Plaq", wrvu: 8.75 },
 "54220": { name: "Irrg Crpra Cavrnosa Priapism", wrvu: 2.36 },
 "54230": { name: "Injection Corpora Cavernosograpy", wrvu: 1.31 },
 "54231": { name: "Dynamic Cavernosometry", wrvu: 1.99 },
 "54235": { name: "Injection Corpora Cavernosa Prescription Agt", wrvu: 1.16 },
 "54240": { name: "Penile Plethysmography", wrvu: 1.28 },
 "54250": { name: "Nctrnl Pen Tmscn&/rgdity Tst", wrvu: 2.16 },
 "54300": { name: "Revision Of Penis", wrvu: 10.92 },
 "54304": { name: "Revision Of Penis", wrvu: 12.95 },
 "54308": { name: "Reconstruction Of Urethra", wrvu: 12.30 },
 "54312": { name: "Reconstruction Of Urethra", wrvu: 14.15 },
 "54316": { name: "Reconstruction Of Urethra", wrvu: 17.60 },
 "54318": { name: "Reconstruction Of Urethra", wrvu: 12.12 },
 "54322": { name: "Reconstruction Of Urethra", wrvu: 13.63 },
 "54324": { name: "Reconstruction Of Urethra", wrvu: 17.11 },
 "54326": { name: "Reconstruction Of Urethra", wrvu: 16.59 },
 "54328": { name: "Revise Penis/urethra", wrvu: 16.47 },
 "54332": { name: "Revise Penis/urethra", wrvu: 17.91 },
 "54336": { name: "Revise Penis/urethra", wrvu: 21.08 },
 "54340": { name: "Repair Hypspad Comp Simple", wrvu: 9.47 },
 "54344": { name: "Rrp Hypspad Comp Mobilization and urtp", wrvu: 16.63 },
 "54348": { name: "Repair Hypspad Comp Dissection & Urtp", wrvu: 17.86 },
 "54352": { name: "Revj Prior Hypspad Repair", wrvu: 25.48 },
 "54360": { name: "Penis Plastic Surgery", wrvu: 12.46 },
 "54380": { name: "Repair Penis", wrvu: 13.83 },
 "54385": { name: "Repair Penis", wrvu: 16.15 },
 "54390": { name: "Repair Penis And Bladder", wrvu: 22.20 },
 "54400": { name: "Insert Semi-rigid Prosthesis", wrvu: 8.94 },
 "54401": { name: "Insert Self-contd Prosthesis", wrvu: 10.18 },
 "54405": { name: "Insert Multi-comp Penis Pros", wrvu: 14.16 },
 "54406": { name: "Remove Muti-comp Penis Pros", wrvu: 12.57 },
 "54408": { name: "Repair Multi-comp Penis Pros", wrvu: 13.56 },
 "54410": { name: "Remove/replace Penis Prosth", wrvu: 14.80 },
 "54411": { name: "Remov/replc Penis Pros Comp", wrvu: 17.89 },
 "54415": { name: "Remove Self-contd Penis Pros", wrvu: 8.66 },
 "54416": { name: "Remv/replacement Penis Contain Pros", wrvu: 11.78 },
 "54417": { name: "Remv/replc Penis Pros Compl", wrvu: 15.70 },
 "54420": { name: "Revision Of Penis", wrvu: 12.08 },
 "54430": { name: "Revision Of Penis", wrvu: 10.78 },
 "54435": { name: "Revision Of Penis", wrvu: 6.64 },
 "54437": { name: "Repair Corporeal Tear", wrvu: 11.21 },
 "54440": { name: "Repair Of Penis", wrvu: 0.00 },
 "54450": { name: "Preputial Stretching", wrvu: 1.09 },
 "54500": { name: "Biopsy Of Testis", wrvu: 1.28 },
 "54505": { name: "Biopsy Of Testis", wrvu: 3.41 },
 "54512": { name: "Excise Lesion Testis", wrvu: 9.10 },
 "54520": { name: "Removal Of Testis", wrvu: 5.17 },
 "54522": { name: "Orchiectomy Partial", wrvu: 9.99 },
 "54530": { name: "Removal Of Testis", wrvu: 8.25 },
 "54535": { name: "Extensive Testis Surgery", wrvu: 12.86 },
 "54550": { name: "Exploration For Testis", wrvu: 8.20 },
 "54560": { name: "Exploration For Testis", wrvu: 11.80 },
 "54600": { name: "Reduce Testis Torsion", wrvu: 7.45 },
 "54620": { name: "Suspension Of Testis", wrvu: 5.08 },
 "54640": { name: "Orchiopexy Ingun/scrot Appr", wrvu: 7.54 },
 "54650": { name: "Orchiopexy (fowler-stephens)", wrvu: 12.08 },
 "54660": { name: "Revision Of Testis", wrvu: 5.60 },
 "54670": { name: "Repair Testis Injury", wrvu: 6.48 },
 "54680": { name: "Relocation Of Testis(es)", wrvu: 13.69 },
 "54690": { name: "Laparoscopy Orchiectomy", wrvu: 11.41 },
 "54692": { name: "Laparoscopy Orchiopexy", wrvu: 13.40 },
 "54699": { name: "Unlisted Laps Procedure Testis", wrvu: 0.00 },
 "54700": { name: "Incision & Drainage Epdidyms Tstis&/scrot Sp", wrvu: 3.38 },
 "54800": { name: "Biopsy Of Epididymis", wrvu: 2.27 },
 "54830": { name: "Remove Epididymis Lesion", wrvu: 5.86 },
 "54840": { name: "Remove Epididymis Lesion", wrvu: 5.14 },
 "54860": { name: "Removal Of Epididymis", wrvu: 6.78 },
 "54861": { name: "Removal Of Epididymis", wrvu: 9.46 },
 "54865": { name: "Explore Epididymis", wrvu: 5.63 },
 "54900": { name: "Fusion Of Spermatic Ducts", wrvu: 13.85 },
 "54901": { name: "Fusion Of Spermatic Ducts", wrvu: 18.62 },
 "55000": { name: "Drainage Of Hydrocele", wrvu: 1.39 },
 "55040": { name: "Removal Of Hydrocele", wrvu: 5.31 },
 "55041": { name: "Removal Of Hydroceles", wrvu: 8.33 },
 "55060": { name: "Repair Of Hydrocele", wrvu: 6.00 },
 "55100": { name: "Drainage Of Scrotum Abscess", wrvu: 2.39 },
 "55110": { name: "Explore Scrotum", wrvu: 6.17 },
 "55120": { name: "Removal Of Scrotum Lesion", wrvu: 5.58 },
 "55150": { name: "Removal Of Scrotum", wrvu: 7.94 },
 "55175": { name: "Revision Of Scrotum", wrvu: 5.72 },
 "55180": { name: "Revision Of Scrotum", wrvu: 11.49 },
 "55200": { name: "Incision Of Sperm Duct", wrvu: 4.44 },
 "55250": { name: "Removal Of Sperm Duct(s)", wrvu: 3.29 },
 "55300": { name: "Prepare Sperm Duct X-ray", wrvu: 3.41 },
 "55400": { name: "Repair Of Sperm Duct", wrvu: 8.39 },
 "55500": { name: "Removal Of Hydrocele", wrvu: 6.06 },
 "55520": { name: "Removal Of Sperm Cord Lesion", wrvu: 6.49 },
 "55530": { name: "Revise Spermatic Cord Veins", wrvu: 5.61 },
 "55535": { name: "Revise Spermatic Cord Veins", wrvu: 7.01 },
 "55540": { name: "Revise Hernia & Sperm Veins", wrvu: 8.09 },
 "55550": { name: "Laparoscopic Ligate Spermatic Vein", wrvu: 7.02 },
 "55559": { name: "Unlstd Laps Procedure Sprmatic Cord", wrvu: 0.00 },
 "55600": { name: "Vesiculotomy", wrvu: 6.83 },
 "55605": { name: "Vesiculotomy Complicated", wrvu: 8.54 },
 "55650": { name: "Remove Sperm Duct Pouch", wrvu: 12.33 },
 "55680": { name: "Remove Sperm Pouch Lesion", wrvu: 5.53 },
 "55705": { name: "Biopsy Prst8 Any Approach Nonimg", wrvu: 1.88 },
 "55706": { name: "Biopsy Prst8 Needle Sat Sampling", wrvu: 4.16 },
 "55707": { name: "Biopsy Prst8 Trct Ultrasound Guided", wrvu: 2.63 },
 "55708": { name: "Biopsy Prst8 Trct Ultrasound With MRI Fus 1", wrvu: 3.39 },
 "55709": { name: "Biopsy Prst8 Tprnl Ultrasound Guided", wrvu: 3.23 },
 "55710": { name: "Biopsy Prst8 Tprn Ultrasound With MRI Fus 1", wrvu: 3.81 },
 "55711": { name: "Biopsy Prst8 Trct MRI-ultrasound 1st", wrvu: 2.61 },
 "55712": { name: "Biopsy Prst8 Tprnl MRI-ultrasound 1st", wrvu: 3.10 },
 "55713": { name: "Biopsy Prst8 In-bore CT/mri Biopsy 1", wrvu: 4.00 },
 "55714": { name: "Biopsy Prst8 In-bore CT/mri 1", wrvu: 3.62 },
 "55715": { name: "Biopsy Prst8 Each Add MRI-ultrasound/ct/mr", wrvu: 1.05 },
 "55720": { name: "Drainage Of Prostate Abscess", wrvu: 7.54 },
 "55725": { name: "Drainage Of Prostate Abscess", wrvu: 9.80 },
 "55801": { name: "Removal Of Prostate", wrvu: 19.31 },
 "55810": { name: "Extensive Prostate Surgery", wrvu: 23.68 },
 "55812": { name: "Extensive Prostate Surgery", wrvu: 29.14 },
 "55815": { name: "Extensive Prostate Surgery", wrvu: 32.13 },
 "55821": { name: "Removal Of Prostate", wrvu: 14.80 },
 "55831": { name: "Removal Of Prostate", wrvu: 15.21 },
 "55840": { name: "Extensive Prostate Surgery", wrvu: 20.83 },
 "55842": { name: "Extensive Prostate Surgery", wrvu: 20.83 },
 "55845": { name: "Extensive Prostate Surgery", wrvu: 24.55 },
 "55860": { name: "Surgical Exposure Prostate", wrvu: 15.44 },
 "55862": { name: "Extensive Prostate Surgery", wrvu: 19.54 },
 "55865": { name: "Extensive Prostate Surgery", wrvu: 23.96 },
 "55866": { name: "Laps Surgery Prst8ect Rpbic Rad", wrvu: 21.90 },
 "55867": { name: "Laps Surgery Prst8ect Simple Stot", wrvu: 19.04 },
 "55868": { name: "Laparoscopic Srg Prst8ct Lymphatic Nod Biopsy", wrvu: 22.46 },
 "55869": { name: "Laparoscopic Srg Prst8ct Bi Pl Lmphad", wrvu: 27.41 },
 "55870": { name: "Electroejaculation", wrvu: 2.52 },
 "55873": { name: "Cryoablate Prostate", wrvu: 13.26 },
 "55874": { name: "Tprnl Placement Biodegrdabl Matrl", wrvu: 2.95 },
 "55875": { name: "Transperi Needle Place Pros", wrvu: 13.12 },
 "55876": { name: "Place Right Device/marker Pros", wrvu: 1.69 },
 "55877": { name: "Abltj Ire Prst8 1+ Tumor Percutaneous", wrvu: 13.50 },
 "55880": { name: "Abltj Malignant Prst8 Tiss Hifu", wrvu: 17.29 },
 "55881": { name: "Ablt Trurl Prst8 Tis Thrm Ultrasound", wrvu: 9.56 },
 "55882": { name: "Ablt Trurl Prst8 Tis Trnsdcr", wrvu: 11.21 },
 "55899": { name: "Unlisted Procedure Male Genital System", wrvu: 0.00 },
 "55920": { name: "Place Needles Pelvic For Right", wrvu: 8.10 },
 "55970": { name: "Sex Transformation M To F", wrvu: 0.00 },
 "55980": { name: "Sex Transformation F To M", wrvu: 0.00 },
 "56405": { name: "Incision & Drainage Vulva/perineal Abscess", wrvu: 1.45 },
 "56420": { name: "Incision & Drainage Bartholins Gland Abscess", wrvu: 1.40 },
 "56440": { name: "Mrsplzatn Brthlns Glnd Cst", wrvu: 2.82 },
 "56441": { name: "Lysis Of Labial Adhesions", wrvu: 1.97 },
 "56442": { name: "Hymenotomy", wrvu: 0.66 },
 "56501": { name: "Destroy Vulva Lesions Sim", wrvu: 1.54 },
 "56515": { name: "Destroy Vulva Lesion/s Compl", wrvu: 3.00 },
 "56605": { name: "Biopsy Of Vulva/perineum", wrvu: 1.07 },
 "56606": { name: "Biopsy Of Vulva/perineum", wrvu: 0.54 },
 "56620": { name: "Vulvectomy Simple Partial", wrvu: 7.34 },
 "56625": { name: "Vulvectomy Simple Complete", wrvu: 9.44 },
 "56630": { name: "Vulvectomy Radical Partial", wrvu: 14.43 },
 "56631": { name: "Vlvctmy Radical Partial Uni Lymphad", wrvu: 18.52 },
 "56632": { name: "Vlvctmy Radical Partial Bi Lymphad", wrvu: 21.31 },
 "56633": { name: "Vulvectomy Radical Complete", wrvu: 19.13 },
 "56634": { name: "Vlvctmy Radical Comp Uni Lymphad", wrvu: 20.14 },
 "56637": { name: "Vlvctmy Radical Comp Bi Lymphad", wrvu: 24.13 },
 "56640": { name: "Vlvctmy Radical Comp With Lymphadec", wrvu: 24.16 },
 "56700": { name: "Partial Hymnctmy/revj Hymnl Rng", wrvu: 2.77 },
 "56740": { name: "Excision Bartholins Gland/Cyst", wrvu: 4.76 },
 "56800": { name: "Plastic Repair Introitus", wrvu: 3.83 },
 "56805": { name: "Clitoroplasty Intersex State", wrvu: 19.38 },
 "56810": { name: "Perineoplasty Repair Per Nonob", wrvu: 4.18 },
 "56820": { name: "Colposcopy Vulva", wrvu: 1.46 },
 "56821": { name: "Colposcopy Vulva With Biopsy", wrvu: 2.00 },
 "57000": { name: "Colpotomy With Exploration", wrvu: 2.94 },
 "57010": { name: "Colpotomy Drainage Pel Abscess", wrvu: 6.67 },
 "57020": { name: "Colpocentesis Sep Procedure", wrvu: 1.46 },
 "57022": { name: "Incision & Drainage Vaginal Hematoma Ob/pp", wrvu: 2.66 },
 "57023": { name: "Incision & Drainage Vaginal Hematoma Non-ob", wrvu: 5.05 },
 "57061": { name: "Destruction Vaginal Lesions Simple", wrvu: 1.27 },
 "57065": { name: "Destruction Vaginal Lesion Extensive", wrvu: 2.59 },
 "57100": { name: "Biopsy Vaginal Mucosa Simple", wrvu: 1.17 },
 "57105": { name: "Biopsy Vaginal Mucosa Extensive", wrvu: 1.70 },
 "57106": { name: "Vagnc Partial Removal Vaginal Wall", wrvu: 7.31 },
 "57107": { name: "Vagnc Compl Removal Paravag Tis", wrvu: 23.95 },
 "57109": { name: "Vagnc Bi Total Pel Lymphadec", wrvu: 27.69 },
 "57110": { name: "Vagnc Compl Removal Vaginal Wall", wrvu: 15.09 },
 "57111": { name: "Vagnc Compl Removal Paravag Tis", wrvu: 27.69 },
 "57120": { name: "Colpocleisis Le Fort Type", wrvu: 8.07 },
 "57130": { name: "Excision Vaginal Septum", wrvu: 2.40 },
 "57135": { name: "Excision Vaginal Cyst/tumor", wrvu: 2.63 },
 "57150": { name: "Treat Vagina Infection", wrvu: 0.49 },
 "57155": { name: "Insert Uteri Tandem/ovoids", wrvu: 5.02 },
 "57156": { name: "Ins Vaginal Brachytx Device", wrvu: 2.62 },
 "57160": { name: "Insert Pessary/other Device", wrvu: 0.87 },
 "57170": { name: "Fitting Of Diaphragm/cap", wrvu: 0.89 },
 "57180": { name: "Treat Vaginal Bleeding", wrvu: 1.59 },
 "57200": { name: "Repair Of Vagina", wrvu: 4.31 },
 "57210": { name: "Repair Vagina/perineum", wrvu: 5.57 },
 "57220": { name: "Revision Of Urethra", wrvu: 4.73 },
 "57230": { name: "Repair Of Urethral Lesion", wrvu: 6.14 },
 "57240": { name: "Anterior Colporrhaphy", wrvu: 9.83 },
 "57250": { name: "Repair Rectum & Vagina", wrvu: 9.83 },
 "57260": { name: "Cmbn Anterior Pst Colprhy", wrvu: 12.92 },
 "57265": { name: "Cmbn Ap Colprhy With Ntrcl Repair", wrvu: 14.63 },
 "57267": { name: "Insert Mesh/pelvic Flr Addon", wrvu: 4.76 },
 "57268": { name: "Repair Of Bowel Bulge", wrvu: 7.38 },
 "57270": { name: "Repair Of Bowel Pouch", wrvu: 13.33 },
 "57280": { name: "Suspension Of Vagina", wrvu: 16.30 },
 "57282": { name: "Colpopexy Extraperitoneal", wrvu: 11.34 },
 "57283": { name: "Colpopexy Intraperitoneal", wrvu: 11.37 },
 "57284": { name: "Repair Paravag Defect Open", wrvu: 13.97 },
 "57285": { name: "Repair Paravag Defect Vaginal", wrvu: 11.31 },
 "57287": { name: "Revise/remove Sling Repair", wrvu: 10.87 },
 "57288": { name: "Repair Bladder Defect", wrvu: 11.83 },
 "57289": { name: "Repair Bladder & Vagina", wrvu: 12.48 },
 "57291": { name: "Construction Of Vagina", wrvu: 8.42 },
 "57292": { name: "Construct Vagina With Graft", wrvu: 13.66 },
 "57295": { name: "Revise Vaginal Graft Via Vagina", wrvu: 7.62 },
 "57296": { name: "Revise Vaginal Graft Open Abdominal", wrvu: 16.15 },
 "57300": { name: "Repair Rectum-vagina Fistula", wrvu: 8.49 },
 "57305": { name: "Repair Rectum-vagina Fistula", wrvu: 14.97 },
 "57307": { name: "Fistula Repair & Colostomy", wrvu: 16.74 },
 "57308": { name: "Fistula Repair Transperine", wrvu: 10.33 },
 "57310": { name: "Repair Urethrovaginal Lesion", wrvu: 7.46 },
 "57311": { name: "Repair Urethrovaginal Lesion", wrvu: 8.69 },
 "57320": { name: "Repair Bladder-vagina Lesion", wrvu: 8.66 },
 "57330": { name: "Repair Bladder-vagina Lesion", wrvu: 12.88 },
 "57335": { name: "Repair Vagina", wrvu: 19.52 },
 "57400": { name: "Dilation Of Vagina", wrvu: 2.21 },
 "57410": { name: "Pelvic Examination", wrvu: 1.71 },
 "57415": { name: "Remove Vaginal Foreign Body", wrvu: 2.43 },
 "57420": { name: "Exam Of Vagina With Scope", wrvu: 1.56 },
 "57421": { name: "Exam/biopsy Of Vaginal With Scope", wrvu: 2.15 },
 "57423": { name: "Repair Paravag Defect Laparoscopic", wrvu: 15.68 },
 "57425": { name: "Laparoscopy Surgery Colpopexy", wrvu: 16.60 },
 "57426": { name: "Revise Prosth Vaginal Graft Laparoscopic", wrvu: 13.94 },
 "57452": { name: "Colposcopy of Cervix with Biopsy", wrvu: 1.46 },
 "57454": { name: "Colposcopy with Biopsy and Endocervical Curettage", wrvu: 2.27 },
 "57455": { name: "Colposcopy with Cervical Biopsy", wrvu: 1.94 },
 "57456": { name: "Endocerv Curettage With Scope", wrvu: 1.80 },
 "57460": { name: "Colposcopy with Loop Electrode Biopsy (Loop Electrosurgical Excision Procedure)", wrvu: 2.76 },
 "57461": { name: "Conz Of Cervix With Scope Loop Electrosurgical Excision Procedure", wrvu: 3.34 },
 "57465": { name: "Cam Cervix Uteri Drainage Colp", wrvu: 0.79 },
 "57500": { name: "Biopsy Of Cervix", wrvu: 1.17 },
 "57505": { name: "Endocervical Curettage", wrvu: 1.16 },
 "57510": { name: "Cauterization Of Cervix", wrvu: 1.85 },
 "57511": { name: "Cryocautery Of Cervix", wrvu: 1.90 },
 "57513": { name: "Laser Surgery Of Cervix", wrvu: 1.90 },
 "57520": { name: "Conization Of Cervix", wrvu: 4.01 },
 "57522": { name: "Conization Of Cervix", wrvu: 3.58 },
 "57530": { name: "Removal Of Cervix", wrvu: 5.14 },
 "57531": { name: "Removal Of Cervix Radical", wrvu: 29.20 },
 "57540": { name: "Removal Of Residual Cervix", wrvu: 12.96 },
 "57545": { name: "Remove Cervix/repair Pelvis", wrvu: 13.75 },
 "57550": { name: "Removal Of Residual Cervix", wrvu: 6.18 },
 "57555": { name: "Remove Cervix/repair Vagina", wrvu: 9.69 },
 "57556": { name: "Remove Cervix Repair Bowel", wrvu: 9.13 },
 "57558": { name: "Dilation & Curettage Of Cervical Stump", wrvu: 1.68 },
 "57700": { name: "Revision Of Cervix", wrvu: 4.24 },
 "57720": { name: "Revision Of Cervix", wrvu: 4.49 },
 "57800": { name: "Dilation Of Cervical Canal", wrvu: 0.75 },
 "58100": { name: "Biopsy Of Uterus Lining", wrvu: 1.18 },
 "58110": { name: "Biopsy Done With Colposcopy Add-on", wrvu: 0.75 },
 "58120": { name: "Dilation And Curettage", wrvu: 3.50 },
 "58140": { name: "Myomectomy Abdominal Method", wrvu: 15.40 },
 "58145": { name: "Myomectomy Vaginal Method", wrvu: 8.69 },
 "58146": { name: "Myomectomy Abdominal Complex", wrvu: 19.83 },
 "58150": { name: "Total Hysterectomy", wrvu: 16.88 },
 "58152": { name: "Total Hysterectomy", wrvu: 21.31 },
 "58180": { name: "Partial Hysterectomy", wrvu: 16.19 },
 "58200": { name: "Extensive Hysterectomy", wrvu: 22.52 },
 "58210": { name: "Extensive Hysterectomy", wrvu: 30.14 },
 "58240": { name: "Removal Of Pelvis Contents", wrvu: 48.10 },
 "58260": { name: "Vaginal Hysterectomy", wrvu: 13.80 },
 "58262": { name: "Vaginal Hyst Including Tubes/Ovaries", wrvu: 15.54 },
 "58263": { name: "Vaginal Hyst With Tubes/Ovaries & Vaginal Repair", wrvu: 16.80 },
 "58267": { name: "Vaginal Hyst With Urinary Repair", wrvu: 17.90 },
 "58270": { name: "Vaginal Hyst With Enterocele Repair", wrvu: 14.92 },
 "58275": { name: "Hysterectomy/revise Vagina", wrvu: 16.60 },
 "58280": { name: "Hysterectomy/revise Vagina", wrvu: 17.87 },
 "58285": { name: "Extensive Hysterectomy", wrvu: 22.80 },
 "58290": { name: "Vaginal Hyst Complex", wrvu: 19.76 },
 "58291": { name: "Vaginal Hyst Incl Tubes/Ovaries Complex", wrvu: 21.51 },
 "58292": { name: "Vaginal Hyst Tubes/Ovaries & Repair Compl", wrvu: 22.77 },
 "58294": { name: "Vaginal Hyst With Enterocele Compl", wrvu: 21.01 },
 "58300": { name: "Insertion of Intrauterine Device (Intrauterine Device)", wrvu: 0.98 },
 "58301": { name: "Removal of Intrauterine Device (Intrauterine Device)", wrvu: 1.24 },
 "58321": { name: "Artificial Insemination", wrvu: 0.90 },
 "58322": { name: "Artificial Insemination", wrvu: 1.07 },
 "58323": { name: "Sperm Washing", wrvu: 0.22 },
 "58340": { name: "Catheter For Hysterography", wrvu: 0.86 },
 "58345": { name: "Reopen Fallopian Tube", wrvu: 4.58 },
 "58346": { name: "Insert Heyman Uteri Capsule", wrvu: 7.37 },
 "58350": { name: "Reopen Fallopian Tube", wrvu: 1.03 },
 "58353": { name: "Endometr Ablate Thermal", wrvu: 3.51 },
 "58356": { name: "Endometrial Cryoablation", wrvu: 6.25 },
 "58400": { name: "Suspension Of Uterus", wrvu: 6.96 },
 "58410": { name: "Suspension Of Uterus", wrvu: 13.46 },
 "58520": { name: "Repair Of Ruptured Uterus", wrvu: 13.14 },
 "58540": { name: "Revision Of Uterus", wrvu: 15.32 },
 "58541": { name: "Lsh Uterus 250 G Or Less", wrvu: 11.98 },
 "58542": { name: "Lsh With Tubes/Ovaries Ut 250 G Or Less", wrvu: 13.81 },
 "58543": { name: "Lsh Uterus Above 250 G", wrvu: 14.03 },
 "58544": { name: "Lsh With Tubes/Ovaries Uterus Above 250 G", wrvu: 15.21 },
 "58545": { name: "Laparoscopic Myomectomy", wrvu: 15.16 },
 "58546": { name: "Laparoscopic-myomectomy Complex", wrvu: 19.44 },
 "58548": { name: "Laparoscopic Radical Hyst", wrvu: 30.84 },
 "58550": { name: "Laparoscopic-asst Vaginal Hysterectomy", wrvu: 14.72 },
 "58552": { name: "Laparoscopic-Vaginal Hyst Incl Tubes/Ovaries", wrvu: 16.49 },
 "58553": { name: "Laparoscopic-Vaginal Hyst Complex", wrvu: 19.56 },
 "58554": { name: "Laparoscopic-Vaginal Hyst With Tubes/Ovaries Compl", wrvu: 22.53 },
 "58555": { name: "Hysteroscopy Diagnosis Sep Procedure", wrvu: 2.58 },
 "58558": { name: "Hysteroscopy Biopsy", wrvu: 4.07 },
 "58559": { name: "Hysteroscopy Lysis", wrvu: 5.07 },
 "58560": { name: "Hysteroscopy Resection Septum", wrvu: 5.61 },
 "58561": { name: "Hysteroscopy Remove Myoma", wrvu: 6.44 },
 "58562": { name: "Hysteroscopy Remove Fb", wrvu: 3.90 },
 "58563": { name: "Hysteroscopy Ablation", wrvu: 4.36 },
 "58565": { name: "Hysteroscopy Sterilization", wrvu: 6.94 },
 "58570": { name: "Tlh Uterus 250 G Or Less", wrvu: 13.03 },
 "58571": { name: "Tlh With Tubes/Ovaries 250 G Or Less", wrvu: 14.63 },
 "58572": { name: "Tlh Uterus Over 250 G", wrvu: 17.27 },
 "58573": { name: "Tlh With Tubes/Ovaries Uterus Over 250 G", wrvu: 20.27 },
 "58575": { name: "Laps Tot Hyst Resj Mal", wrvu: 31.79 },
 "58578": { name: "Unlisted Laps Procedure Uterus", wrvu: 0.00 },
 "58579": { name: "Unlisted Hystsc Procedure Uterus", wrvu: 0.00 },
 "58580": { name: "Transcrv Abltj Uterine Fibrd Rf", wrvu: 7.03 },
 "58600": { name: "Division Of Fallopian Tube", wrvu: 5.76 },
 "58605": { name: "Division Of Fallopian Tube", wrvu: 5.15 },
 "58611": { name: "Ligate Oviduct(s) Add-on", wrvu: 1.41 },
 "58615": { name: "Occlude Fallopian Tube(s)", wrvu: 3.84 },
 "58660": { name: "Laparoscopy Lysis", wrvu: 11.30 },
 "58661": { name: "Laparoscopy Remove Adnexa", wrvu: 11.07 },
 "58662": { name: "Laparoscopy Excise Lesions", wrvu: 11.85 },
 "58670": { name: "Laparoscopy Tubal Cautery", wrvu: 5.76 },
 "58671": { name: "Laparoscopy Tubal Block", wrvu: 5.76 },
 "58672": { name: "Laparoscopy Fimbrioplasty", wrvu: 12.59 },
 "58673": { name: "Laparoscopy Salpingostomy", wrvu: 13.69 },
 "58674": { name: "Laps Abltj Uterine Fibroids", wrvu: 13.73 },
 "58679": { name: "Unlisted Laps Procedure Ovidct Ovry", wrvu: 0.00 },
 "58700": { name: "Removal Of Fallopian Tube", wrvu: 12.63 },
 "58720": { name: "Removal Of Ovary/tube(s)", wrvu: 11.86 },
 "58740": { name: "Adhesiolysis Tube Ovary", wrvu: 14.53 },
 "58750": { name: "Repair Oviduct", wrvu: 15.25 },
 "58752": { name: "Revise Ovarian Tube(s)", wrvu: 15.25 },
 "58760": { name: "Fimbrioplasty", wrvu: 13.58 },
 "58770": { name: "Create New Tubal Opening", wrvu: 14.40 },
 "58800": { name: "Drainage Of Ovarian Cyst(s)", wrvu: 4.50 },
 "58805": { name: "Drainage Of Ovarian Cyst(s)", wrvu: 6.26 },
 "58820": { name: "Drain Ovary Abscess Open", wrvu: 4.58 },
 "58822": { name: "Drain Ovary Abscess Percutaneous", wrvu: 11.51 },
 "58825": { name: "Transposition Ovary(s)", wrvu: 11.49 },
 "58900": { name: "Biopsy Of Ovary(s)", wrvu: 6.43 },
 "58920": { name: "Partial Removal Of Ovary(s)", wrvu: 11.65 },
 "58925": { name: "Removal Of Ovarian Cyst(s)", wrvu: 12.12 },
 "58940": { name: "Removal Of Ovary(s)", wrvu: 8.01 },
 "58943": { name: "Removal Of Ovary(s)", wrvu: 19.03 },
 "58950": { name: "Resection Ovarian Malignancy", wrvu: 17.91 },
 "58951": { name: "Resection Ovarian Malignancy", wrvu: 23.65 },
 "58952": { name: "Resection Ovarian Malignancy", wrvu: 26.61 },
 "58953": { name: "Tah Radical Dissect For Debulk", wrvu: 33.28 },
 "58954": { name: "Tah Radical Debulk/Lymphatic Remove", wrvu: 36.20 },
 "58956": { name: "Bso Omentectomy With Tah", wrvu: 22.23 },
 "58958": { name: "Resc Recr Ovary Tbl Pp Utr Mal", wrvu: 28.49 },
 "58960": { name: "Exploration Of Abdomen", wrvu: 15.40 },
 "58970": { name: "Retrieval Of Oocyte", wrvu: 3.43 },
 "58974": { name: "Embryo Transfer Intrauterine", wrvu: 0.00 },
 "58976": { name: "Transfer Of Embryo", wrvu: 3.72 },
 "58999": { name: "Unlisted Procedure Fml Genital System", wrvu: 0.00 },
 "59000": { name: "Amniocentesis Diagnostic", wrvu: 1.27 },
 "59001": { name: "Amniocentesis Therapeutic", wrvu: 2.93 },
 "59012": { name: "Fetal Cord Puncture Prenatal", wrvu: 3.35 },
 "59015": { name: "Chorion Biopsy", wrvu: 2.15 },
 "59020": { name: "Fetal Contract Stress Test", wrvu: 0.64 },
 "59025": { name: "Fetal Non-stress Test", wrvu: 0.52 },
 "59030": { name: "Fetal Scalp Blood Sampling", wrvu: 1.94 },
 "59050": { name: "Fetal Monitor With Report", wrvu: 0.87 },
 "59051": { name: "Fetal Monitor/interpret Only", wrvu: 0.72 },
 "59070": { name: "Transabdom Amnioinfus With Ultrasound", wrvu: 5.11 },
 "59072": { name: "Umbilical Cord Occlud With Ultrasound", wrvu: 8.77 },
 "59074": { name: "Fetal Fluid Drainage With Ultrasound", wrvu: 5.11 },
 "59076": { name: "Fetal Shunt Placement With Ultrasound", wrvu: 8.77 },
 "59100": { name: "Remove Uterus Lesion", wrvu: 13.04 },
 "59120": { name: "Treat Ectopic Pregnancy", wrvu: 12.35 },
 "59121": { name: "Treat Ectopic Pregnancy", wrvu: 12.42 },
 "59130": { name: "Treat Ectopic Pregnancy", wrvu: 14.70 },
 "59136": { name: "Treat Ectopic Pregnancy", wrvu: 13.89 },
 "59140": { name: "Treat Ectopic Pregnancy", wrvu: 5.79 },
 "59150": { name: "Treat Ectopic Pregnancy", wrvu: 11.98 },
 "59151": { name: "Treat Ectopic Pregnancy", wrvu: 11.81 },
 "59160": { name: "D & C After Delivery", wrvu: 2.69 },
 "59200": { name: "Insert Cervical Dilator", wrvu: 1.17 },
 "59300": { name: "Episiotomy Or Vaginal Repair", wrvu: 2.35 },
 "59320": { name: "Revision Of Cervix", wrvu: 2.42 },
 "59325": { name: "Revision Of Cervix", wrvu: 3.96 },
 "59350": { name: "Repair Of Uterus", wrvu: 4.82 },
 "59400": { name: "Obstetrical Care", wrvu: 37.00 },
 "59409": { name: "Obstetrical Care", wrvu: 14.37 },
 "59410": { name: "Obstetrical Care", wrvu: 18.76 },
 "59412": { name: "Antepartum Manipulation", wrvu: 1.71 },
 "59414": { name: "Deliver Placenta", wrvu: 1.61 },
 "59425": { name: "Antepartum Care Only", wrvu: 7.80 },
 "59426": { name: "Antepartum Care Only", wrvu: 14.30 },
 "59430": { name: "Care After Delivery", wrvu: 3.22 },
 "59510": { name: "Cesarean Delivery", wrvu: 41.05 },
 "59514": { name: "Cesarean Delivery Only", wrvu: 16.13 },
 "59515": { name: "Cesarean Delivery", wrvu: 22.79 },
 "59525": { name: "Remove Uterus After Cesarean", wrvu: 8.32 },
 "59610": { name: "Vbac Delivery", wrvu: 38.71 },
 "59612": { name: "Vbac Delivery Only", wrvu: 16.09 },
 "59614": { name: "Vbac Care After Delivery", wrvu: 20.48 },
 "59618": { name: "Attempted Vbac Delivery", wrvu: 41.57 },
 "59620": { name: "Attempted Vbac Delivery Only", wrvu: 16.66 },
 "59622": { name: "Attempted Vbac After Care", wrvu: 23.32 },
 "59812": { name: "Treatment Of Miscarriage", wrvu: 4.33 },
 "59820": { name: "Care Of Miscarriage", wrvu: 4.72 },
 "59821": { name: "Treatment Of Miscarriage", wrvu: 4.96 },
 "59830": { name: "Treat Uterus Infection", wrvu: 6.43 },
 "59840": { name: "Induced Abortion Dilation & Curettage", wrvu: 2.93 },
 "59841": { name: "Induced Abortion Dilat and evac", wrvu: 5.51 },
 "59850": { name: "Induced Abortion 1+ Injection", wrvu: 5.75 },
 "59851": { name: "Induced Abortion 1+Injection Dilation & Curettage", wrvu: 5.77 },
 "59852": { name: "Induced Abortion 1+Injection Hyst", wrvu: 8.02 },
 "59855": { name: "Induced Abortion 1+Vaginal Supp", wrvu: 6.27 },
 "59856": { name: "Induced Ab 1+Vaginal Supp Dilation & Curettage", wrvu: 7.60 },
 "59857": { name: "Induced Ab 1+Vaginal Supp Hyst", wrvu: 9.10 },
 "59866": { name: "Abortion (mpr)", wrvu: 3.89 },
 "59870": { name: "Evacuate Mole Of Uterus", wrvu: 6.41 },
 "59871": { name: "Remove Cerclage Suture", wrvu: 2.08 },
 "59897": { name: "Unlisted Fetal Invas Procedure With Ultrasound", wrvu: 0.00 },
 "59898": { name: "Unlstd Laps Procedure Medication-Assisted Treatment Care and dlvr", wrvu: 0.00 },
 "59899": { name: "Unlisted Procedure Medication-Assisted Treatment Care and dlvr", wrvu: 0.00 },
 "60000": { name: "Incision & Drainage Thyroglssl Dux Cast Infected", wrvu: 1.76 },
 "60100": { name: "Biopsy Of Thyroid", wrvu: 1.52 },
 "60200": { name: "Remove Thyroid Lesion", wrvu: 9.77 },
 "60210": { name: "Partial Thyroid Excision", wrvu: 10.95 },
 "60212": { name: "Partial Thyroid Excision", wrvu: 16.02 },
 "60220": { name: "Partial Removal Of Thyroid", wrvu: 10.91 },
 "60225": { name: "Partial Removal Of Thyroid", wrvu: 14.42 },
 "60240": { name: "Removal Of Thyroid", wrvu: 14.66 },
 "60252": { name: "Removal Of Thyroid", wrvu: 21.46 },
 "60254": { name: "Extensive Thyroid Surgery", wrvu: 27.71 },
 "60260": { name: "Repeat Thyroid Surgery", wrvu: 17.80 },
 "60270": { name: "Removal Of Thyroid", wrvu: 22.62 },
 "60271": { name: "Removal Of Thyroid", wrvu: 17.18 },
 "60280": { name: "Remove Thyroid Duct Lesion", wrvu: 6.01 },
 "60281": { name: "Remove Thyroid Duct Lesion", wrvu: 8.60 },
 "60300": { name: "Aspiration/Injection Thyroid Cyst", wrvu: 0.95 },
 "60500": { name: "Explore Parathyroid Glands", wrvu: 15.21 },
 "60502": { name: "Re-explore Parathyroids", wrvu: 20.62 },
 "60505": { name: "Explore Parathyroid Glands", wrvu: 22.48 },
 "60512": { name: "Autotransplant Parathyroid", wrvu: 4.33 },
 "60520": { name: "Removal Of Thymus Gland", wrvu: 16.73 },
 "60521": { name: "Removal Of Thymus Gland", wrvu: 18.70 },
 "60522": { name: "Removal Of Thymus Gland", wrvu: 22.89 },
 "60540": { name: "Explore Adrenal Gland", wrvu: 17.57 },
 "60545": { name: "Explore Adrenal Gland", wrvu: 20.41 },
 "60600": { name: "Remove Carotid Body Lesion", wrvu: 24.46 },
 "60605": { name: "Remove Carotid Body Lesion", wrvu: 31.16 },
 "60650": { name: "Laparoscopy Adrenalectomy", wrvu: 20.21 },
 "60659": { name: "Unlisted Laps Procedure Endoc System", wrvu: 0.00 },
 "60660": { name: "Abltj 1/+Thyroid Ndul 1lobe Prq", wrvu: 5.61 },
 "60661": { name: "Abltj 1/+Thyroid Ndul Additional Prq", wrvu: 4.14 },
 "60699": { name: "Unlisted Procedure Endocrine System", wrvu: 0.00 },
 "61000": { name: "Remove Cranial Cavity Fluid", wrvu: 1.54 },
 "61001": { name: "Remove Cranial Cavity Fluid", wrvu: 1.45 },
 "61020": { name: "Remove Brain Cavity Fluid", wrvu: 1.47 },
 "61026": { name: "Injection Into Brain Canal", wrvu: 1.65 },
 "61050": { name: "Remove Brain Canal Fluid", wrvu: 1.47 },
 "61055": { name: "Injection Into Brain Canal", wrvu: 2.05 },
 "61070": { name: "Brain Canal Shunt Procedure", wrvu: 0.87 },
 "61105": { name: "Tdh Sdrl/ventr Puncture", wrvu: 5.31 },
 "61107": { name: "Tdh Puncture Implt Ventr Catheter", wrvu: 4.87 },
 "61108": { name: "Tdh Puncture Evac&/Drainage Sdrl Hmta", wrvu: 11.35 },
 "61120": { name: "Burr Hole For Ventr Puncture", wrvu: 9.36 },
 "61140": { name: "Burr Hole/treph Biopsy Brain/Lesion", wrvu: 16.80 },
 "61150": { name: "Bur Hol/trph Drainage Brn Abs/cst", wrvu: 18.43 },
 "61151": { name: "Burr Hole/treph Subsequent Tapping", wrvu: 13.15 },
 "61154": { name: "Burr Hole With Evac&/Drainage Hematoma", wrvu: 16.64 },
 "61156": { name: "Burr Hol Aspiration Hematoma/Cast Icer", wrvu: 17.01 },
 "61210": { name: "Burr Hole Implt Ventr Catheter", wrvu: 5.68 },
 "61215": { name: "Ins Subcutaneous Rsvr Pump/nfs System", wrvu: 5.70 },
 "61250": { name: "Burr Hole/treph Sttl Expl", wrvu: 11.20 },
 "61253": { name: "Burr Hole Treph Ittl Uni/bi", wrvu: 13.15 },
 "61304": { name: "Cranial/Cranial Expl Supratntorl", wrvu: 22.82 },
 "61305": { name: "Cranial/Cranial Expl Infratntorl", wrvu: 27.92 },
 "61312": { name: "Cranial/Cranial Sttl Xdrl/sdrl", wrvu: 29.42 },
 "61313": { name: "Cranial/Cranial Sttl Icere", wrvu: 27.39 },
 "61314": { name: "Cranial/Cranial Ittl Xdrl/sdrl", wrvu: 25.25 },
 "61315": { name: "Cranial/Cranial Ittl Ntracereblr", wrvu: 28.91 },
 "61316": { name: "Inc and subcutaneous Placement Cranial Bone Grf", wrvu: 1.36 },
 "61320": { name: "Cranial/Cranial Drainage Intracranial Abs Sttl", wrvu: 26.73 },
 "61321": { name: "Cranial/Cranial Drainage Intracranial Abs Ittl", wrvu: 29.77 },
 "61322": { name: "Cranial/Cranial Dcmprv Without Lobec", wrvu: 33.40 },
 "61323": { name: "Cranial/Cranial Dcmprv With Lobec", wrvu: 34.18 },
 "61330": { name: "Dcmprn Orbit Only Transcrnl", wrvu: 24.67 },
 "61333": { name: "Expl Orbit With Removal Lesion", wrvu: 28.54 },
 "61340": { name: "Subtemporal Cranial Dcmprn", wrvu: 19.61 },
 "61343": { name: "Coronary Sopl Cervical Lam Dcmprn", wrvu: 31.06 },
 "61345": { name: "Oth Cranial Dcmprn Pst Fossa", wrvu: 28.50 },
 "61450": { name: "Coronary Staple Sctj Cmprn/dcmprn", wrvu: 27.00 },
 "61458": { name: "Coronary Sopl Xpl/dcmpr Crl Nerve", wrvu: 28.12 },
 "61460": { name: "Coronary Sopl Sctj 1+Cranial Nerve", wrvu: 29.48 },
 "61500": { name: "Coronary Excision Tumor/bone Lesion Skull", wrvu: 18.70 },
 "61501": { name: "Craniectomy F/osteomyelitis", wrvu: 15.94 },
 "61510": { name: "Coronary Treph Excision Brn Tumor Sttl", wrvu: 30.06 },
 "61512": { name: "Coronary Treph Excision Mngioma Sttl", wrvu: 36.21 },
 "61514": { name: "Coronary Treph Excision Brn Abs Sttl", wrvu: 26.55 },
 "61516": { name: "Coronary Treph Excision Cyst Sttl", wrvu: 25.92 },
 "61517": { name: "Implt Brn Intrcv Chemotx Agt", wrvu: 1.35 },
 "61518": { name: "Removal Of Brain Lesion", wrvu: 38.89 },
 "61519": { name: "Remove Brain Lining Lesion", wrvu: 42.34 },
 "61520": { name: "Removal Of Brain Lesion", wrvu: 55.66 },
 "61521": { name: "Removal Of Brain Lesion", wrvu: 45.82 },
 "61522": { name: "Removal Of Brain Abscess", wrvu: 30.75 },
 "61524": { name: "Removal Of Brain Lesion", wrvu: 29.14 },
 "61526": { name: "Removal Of Brain Lesion", wrvu: 52.73 },
 "61530": { name: "Removal Of Brain Lesion", wrvu: 44.42 },
 "61531": { name: "Implant Brain Electrodes", wrvu: 16.00 },
 "61533": { name: "Implant Brain Electrodes", wrvu: 20.92 },
 "61534": { name: "Removal Of Brain Lesion", wrvu: 22.43 },
 "61535": { name: "Remove Brain Electrodes", wrvu: 12.82 },
 "61536": { name: "Removal Of Brain Lesion", wrvu: 36.78 },
 "61537": { name: "Removal Of Brain Tissue", wrvu: 35.54 },
 "61538": { name: "Removal Of Brain Tissue", wrvu: 38.46 },
 "61539": { name: "Removal Of Brain Tissue", wrvu: 33.42 },
 "61540": { name: "Removal Of Brain Tissue", wrvu: 30.64 },
 "61541": { name: "Incision Of Brain Tissue", wrvu: 30.17 },
 "61543": { name: "Removal Of Brain Tissue", wrvu: 30.53 },
 "61544": { name: "Remove & Treat Brain Lesion", wrvu: 26.68 },
 "61545": { name: "Excision Of Brain Tumor", wrvu: 45.27 },
 "61546": { name: "Removal Of Pituitary Gland", wrvu: 32.60 },
 "61548": { name: "Removal Of Pituitary Gland", wrvu: 22.79 },
 "61550": { name: "Release Of Skull Seams", wrvu: 15.20 },
 "61552": { name: "Release Of Skull Seams", wrvu: 19.89 },
 "61556": { name: "Incise Skull/sutures", wrvu: 23.49 },
 "61557": { name: "Incise Skull/sutures", wrvu: 22.73 },
 "61558": { name: "Excision Of Skull/sutures", wrvu: 25.84 },
 "61559": { name: "Excision Of Skull/sutures", wrvu: 33.17 },
 "61563": { name: "Excision Of Skull Tumor", wrvu: 27.73 },
 "61564": { name: "Excision Of Skull Tumor", wrvu: 33.87 },
 "61566": { name: "Removal Of Brain Tissue", wrvu: 31.64 },
 "61567": { name: "Incision Of Brain Tissue", wrvu: 36.08 },
 "61570": { name: "Remove Foreign Body Brain", wrvu: 25.85 },
 "61571": { name: "Incise Skull For Brain Wound", wrvu: 27.71 },
 "61575": { name: "Skull Base/brainstem Surgery", wrvu: 35.65 },
 "61576": { name: "Skull Base/brainstem Surgery", wrvu: 53.93 },
 "61580": { name: "Craniofacial Approach Skull", wrvu: 33.65 },
 "61581": { name: "Craniofacial Approach Skull", wrvu: 38.15 },
 "61582": { name: "Craniofacial Approach Skull", wrvu: 34.26 },
 "61583": { name: "Craniofacial Approach Skull", wrvu: 37.54 },
 "61584": { name: "Orbitocranial Approach/skull", wrvu: 36.76 },
 "61585": { name: "Orbitocranial Approach/skull", wrvu: 41.51 },
 "61586": { name: "Resection Nasopharynx Skull", wrvu: 26.79 },
 "61590": { name: "Infratemporal Approach/skull", wrvu: 45.86 },
 "61591": { name: "Infratemporal Approach/skull", wrvu: 45.84 },
 "61592": { name: "Orbitocranial Approach/skull", wrvu: 42.00 },
 "61595": { name: "Transtemporal Approach/skull", wrvu: 32.90 },
 "61596": { name: "Transcochlear Approach/skull", wrvu: 38.44 },
 "61597": { name: "Transcondylar Approach/skull", wrvu: 39.80 },
 "61598": { name: "Transpetrosal Approach/skull", wrvu: 35.62 },
 "61600": { name: "Resection/excise Cranial Lesion", wrvu: 29.26 },
 "61601": { name: "Resection/excise Cranial Lesion", wrvu: 30.36 },
 "61605": { name: "Resection/excise Cranial Lesion", wrvu: 31.76 },
 "61606": { name: "Resection/excise Cranial Lesion", wrvu: 41.00 },
 "61607": { name: "Resection/excise Cranial Lesion", wrvu: 39.91 },
 "61608": { name: "Resection/excise Cranial Lesion", wrvu: 44.40 },
 "61611": { name: "Transect Artery Sinus", wrvu: 7.22 },
 "61613": { name: "Remove Aneurysm Sinus", wrvu: 43.90 },
 "61615": { name: "Resection/excise Lesion Skull", wrvu: 34.88 },
 "61616": { name: "Resection/excise Lesion Skull", wrvu: 45.57 },
 "61618": { name: "Repair Dura", wrvu: 18.22 },
 "61619": { name: "Repair Dura", wrvu: 21.55 },
 "61623": { name: "Evasc Temp Balo Artl Occ H/n", wrvu: 9.70 },
 "61624": { name: "Tcat Permanent Occls/embolj Cns", wrvu: 19.50 },
 "61626": { name: "Tcat Permanent Occls/embol Noncns", wrvu: 14.93 },
 "61630": { name: "Balo Angioplasty Intracranial Percutaneous", wrvu: 21.52 },
 "61635": { name: "Intracran Angioplsty With Stent", wrvu: 23.67 },
 "61640": { name: "Dilate Ic Vasospasm Init", wrvu: 12.32 },
 "61641": { name: "Dilat Ic Vspsm Each Vessel Sm Ter", wrvu: 4.33 },
 "61642": { name: "Dilat Ic Vspsm Each Diff Ter", wrvu: 8.66 },
 "61645": { name: "Percutaneous Artery M-thrombect &/nfs", wrvu: 14.63 },
 "61650": { name: "Evasc Prlng Admn Prescription Agnt 1st", wrvu: 9.75 },
 "61651": { name: "Evasc Prlng Admn Prescription Agnt Add", wrvu: 4.14 },
 "61680": { name: "Intracranial Vessel Surgery", wrvu: 31.74 },
 "61682": { name: "Intracranial Vessel Surgery", wrvu: 61.82 },
 "61684": { name: "Intracranial Vessel Surgery", wrvu: 40.60 },
 "61686": { name: "Intracranial Vessel Surgery", wrvu: 65.81 },
 "61690": { name: "Intracranial Vessel Surgery", wrvu: 30.56 },
 "61692": { name: "Intracranial Vessel Surgery", wrvu: 53.23 },
 "61697": { name: "Brain Aneurysm Repr Complex", wrvu: 61.82 },
 "61698": { name: "Brain Aneurysm Repr Complex", wrvu: 67.89 },
 "61700": { name: "Brain Aneurysm Repr Simple", wrvu: 49.35 },
 "61702": { name: "Inner Skull Vessel Surgery", wrvu: 58.54 },
 "61703": { name: "Clamp Neck Artery", wrvu: 18.33 },
 "61705": { name: "Revise Circulation To Head", wrvu: 37.15 },
 "61708": { name: "Revise Circulation To Head", wrvu: 36.27 },
 "61710": { name: "Revise Circulation To Head", wrvu: 30.51 },
 "61711": { name: "Fusion Of Skull Arteries", wrvu: 37.27 },
 "61715": { name: "Mrgfus Strtctc Ablt Trgt Intracranial", wrvu: 0.00 },
 "61720": { name: "Incise Skull/brain Surgery", wrvu: 17.18 },
 "61735": { name: "Incise Skull/brain Surgery", wrvu: 21.79 },
 "61736": { name: "Litt Intracranial 1 Traj 1 Simple Lesion", wrvu: 18.58 },
 "61737": { name: "Litt Intracranial Mlt Trj Mlt/cplx Ls", wrvu: 22.10 },
 "61750": { name: "Incise Skull/brain Biopsy", wrvu: 19.33 },
 "61751": { name: "Brain Biopsy With CT/mr Guide", wrvu: 18.32 },
 "61760": { name: "Implant Brain Electrodes", wrvu: 21.83 },
 "61770": { name: "Incise Skull For Treatment", wrvu: 22.61 },
 "61781": { name: "Scan Procedure Cranial Intra", wrvu: 3.66 },
 "61782": { name: "Scan Procedure Cranial Extra", wrvu: 3.10 },
 "61783": { name: "Scan Procedure Spinal", wrvu: 3.66 },
 "61790": { name: "Treat Trigeminal Nerve", wrvu: 11.31 },
 "61791": { name: "Treat Trigeminal Tract", wrvu: 15.02 },
 "61796": { name: "Stereotactic Radiosurgery Cranial Lesion Simple", wrvu: 13.58 },
 "61797": { name: "Stereotactic Radiosurgery Cran Lesion Simple Additional", wrvu: 3.39 },
 "61798": { name: "Stereotactic Radiosurgery Cranial Lesion Complex", wrvu: 19.35 },
 "61799": { name: "Stereotactic Radiosurgery Cran Lesion Complex Additional", wrvu: 4.69 },
 "61800": { name: "Apply Stereotactic Radiosurgery Headframe Add-on", wrvu: 2.19 },
 "61850": { name: "Implant Neuroelectrodes", wrvu: 13.01 },
 "61860": { name: "Implant Neuroelectrodes", wrvu: 21.70 },
 "61863": { name: "Implant Neuroelectrode", wrvu: 20.19 },
 "61864": { name: "Implant Neuroelectrde Additional", wrvu: 4.38 },
 "61867": { name: "Implant Neuroelectrode", wrvu: 32.20 },
 "61868": { name: "Implant Neuroelectrde Additional", wrvu: 7.71 },
 "61880": { name: "Revise/remove Neuroelectrode", wrvu: 6.78 },
 "61885": { name: "Insert/redo Neurostim 1 Array", wrvu: 5.90 },
 "61886": { name: "Implant Neurostim Arrays", wrvu: 9.68 },
 "61888": { name: "Revise/remove Neuroreceiver", wrvu: 5.10 },
 "61889": { name: "Ins Sk-mnt Cranial Nstm Pg/rcvr", wrvu: 25.11 },
 "61891": { name: "Revision/Replacement Sk-mnt Cranial Nstm", wrvu: 10.97 },
 "61892": { name: "Removal Sk-mnt Cranial Nstm Pg/rcvr", wrvu: 14.63 },
 "62000": { name: "Treat Skull Fracture", wrvu: 13.58 },
 "62005": { name: "Treat Skull Fracture", wrvu: 17.19 },
 "62010": { name: "Treatment Of Head Injury", wrvu: 20.89 },
 "62100": { name: "Repair Brain Fluid Leakage", wrvu: 22.94 },
 "62115": { name: "Reduction Of Skull Defect", wrvu: 22.34 },
 "62117": { name: "Reduction Of Skull Defect", wrvu: 27.64 },
 "62120": { name: "Repair Skull Cavity Lesion", wrvu: 23.98 },
 "62121": { name: "Incise Skull Repair", wrvu: 22.45 },
 "62140": { name: "Crnop Skull Defect<5 cm Diam", wrvu: 14.19 },
 "62141": { name: "Crnop Skull Defect>5 cm Diam", wrvu: 15.67 },
 "62142": { name: "Removal Bone Flp/prostc Plate Skl", wrvu: 11.53 },
 "62143": { name: "Rpl Bone Flp/prostc Plate Skl", wrvu: 13.80 },
 "62145": { name: "Repair Of Skull & Brain", wrvu: 19.59 },
 "62146": { name: "Crnop With Autograft<5 cm Diam", wrvu: 16.85 },
 "62147": { name: "Crnop With Autograft>5 cm Diam", wrvu: 20.15 },
 "62148": { name: "Retr Bone Flap To Fix Skull", wrvu: 1.95 },
 "62160": { name: "Neuroendoscopy Add-on", wrvu: 2.93 },
 "62161": { name: "Dissect Brain With Scope", wrvu: 20.70 },
 "62162": { name: "Remove Colloid Cyst With Scope", wrvu: 26.13 },
 "62164": { name: "Remove Brain Tumor With Scope", wrvu: 28.69 },
 "62165": { name: "Remove Pituit Tumor With Scope", wrvu: 22.65 },
 "62180": { name: "Establish Brain Cavity Shunt", wrvu: 22.02 },
 "62190": { name: "Establish Brain Cavity Shunt", wrvu: 11.87 },
 "62192": { name: "Establish Brain Cavity Shunt", wrvu: 13.02 },
 "62194": { name: "Replace/irrigate Catheter", wrvu: 5.64 },
 "62200": { name: "Establish Brain Cavity Shunt", wrvu: 18.81 },
 "62201": { name: "Brain Cavity Shunt With Scope", wrvu: 15.64 },
 "62220": { name: "Establish Brain Cavity Shunt", wrvu: 13.75 },
 "62223": { name: "Establish Brain Cavity Shunt", wrvu: 13.70 },
 "62225": { name: "Replace/irrigate Catheter", wrvu: 6.04 },
 "62230": { name: "Replace/revise Brain Shunt", wrvu: 11.14 },
 "62252": { name: "Cerebrospinal Fluid Shunt Reprogram", wrvu: 0.72 },
 "62256": { name: "Remove Brain Cavity Shunt", wrvu: 7.20 },
 "62258": { name: "Replace Brain Cavity Shunt", wrvu: 15.25 },
 "62263": { name: "Epidural Lysis Mult Sessions", wrvu: 4.88 },
 "62264": { name: "Epidural Lysis On Single Day", wrvu: 4.31 },
 "62267": { name: "Interdiscal Percutaneous Aspiration Diagnosis", wrvu: 2.93 },
 "62268": { name: "Drain Spinal Cord Cyst", wrvu: 4.61 },
 "62269": { name: "Needle Biopsy Spinal Cord", wrvu: 4.88 },
 "62270": { name: "Diagnosis Lumbar Spi Puncture", wrvu: 1.19 },
 "62272": { name: "Therapeutic Spi Puncture Drainage Cerebrospinal Fluid", wrvu: 1.54 },
 "62273": { name: "Inject Epidural Patch", wrvu: 2.10 },
 "62280": { name: "Treat Spinal Cord Lesion", wrvu: 2.56 },
 "62281": { name: "Treat Spinal Cord Lesion", wrvu: 2.59 },
 "62282": { name: "Treat Spinal Canal Lesion", wrvu: 2.27 },
 "62284": { name: "Injection For Myelogram", wrvu: 1.50 },
 "62287": { name: "Dcmprn Pq Nuclear Pul 1/mlt Lumbar", wrvu: 9.03 },
 "62290": { name: "Injection Procedure Discography Lumbar", wrvu: 2.93 },
 "62291": { name: "Injection Procedure Discography Cervical/Thoracic", wrvu: 2.84 },
 "62292": { name: "Injection Chemonucleolysis Lumbar", wrvu: 9.24 },
 "62294": { name: "Injection Into Spinal Artery", wrvu: 12.55 },
 "62302": { name: "Myelography Lumbar Injection", wrvu: 2.23 },
 "62303": { name: "Myelography Lumbar Injection", wrvu: 2.23 },
 "62304": { name: "Myelography Lumbar Injection", wrvu: 2.19 },
 "62305": { name: "Myelography Lumbar Injection", wrvu: 2.29 },
 "62320": { name: "Injection Interlaminar Cervical/Thoracic", wrvu: 1.76 },
 "62321": { name: "Injection Interlaminar Cervical/Thoracic", wrvu: 1.90 },
 "62322": { name: "Injection Interlaminar Lumbar/Sacral", wrvu: 1.51 },
 "62323": { name: "Injection Interlaminar Lumbar/Sacral", wrvu: 1.76 },
 "62324": { name: "Injection Interlaminar Cervical/Thoracic", wrvu: 1.84 },
 "62325": { name: "Injection Interlaminar Cervical/Thoracic", wrvu: 2.15 },
 "62326": { name: "Injection Interlaminar Lumbar/Sacral", wrvu: 1.74 },
 "62327": { name: "Injection Interlaminar Lumbar/Sacral", wrvu: 1.85 },
 "62328": { name: "Diagnosis Lumbar Spi Puncture With Fluoroscopic/ct", wrvu: 1.69 },
 "62329": { name: "Therapeutic Spi Puncture Cerebrospinal Fluid Fluoroscopic/ct", wrvu: 1.98 },
 "62330": { name: "Dcmprn Prq Removal Ligation Flv 1lmbr", wrvu: 8.00 },
 "62331": { name: "Dcmprn Prq Removal Ligation Flv Additional", wrvu: 4.25 },
 "62350": { name: "Implant Spinal Canal Catheter", wrvu: 5.90 },
 "62351": { name: "Implant Spinal Canal Catheter", wrvu: 11.37 },
 "62355": { name: "Remove Spinal Canal Catheter", wrvu: 3.46 },
 "62360": { name: "Insert Spine Infusion Device", wrvu: 4.22 },
 "62361": { name: "Implant Spine Infusion Pump", wrvu: 4.88 },
 "62362": { name: "Implant Spine Infusion Pump", wrvu: 5.46 },
 "62365": { name: "Remove Spine Infusion Device", wrvu: 3.83 },
 "62367": { name: "Analyze Spine Infusion Pump", wrvu: 0.47 },
 "62368": { name: "Analyze Sp Inferior Pump With Reprog", wrvu: 0.65 },
 "62369": { name: "Anal Sp Inferior Pump With Reprg and fill", wrvu: 0.65 },
 "62370": { name: "Anl Sp Inferior Pump With Mdreprg and fil", wrvu: 0.88 },
 "62380": { name: "Endoscopy Dcmprn 1 Interspace Lumbar", wrvu: 0.00 },
 "63001": { name: "Remove Spine Lamina 1/2 Crvl", wrvu: 17.17 },
 "63003": { name: "Remove Spine Lamina 1/2 Thoracic", wrvu: 17.30 },
 "63005": { name: "Remove Spine Lamina 1/2 Lumbar", wrvu: 16.02 },
 "63011": { name: "Remove Spine Lamina 1/2 Scrl", wrvu: 15.51 },
 "63012": { name: "Remove Lamina/facets Lumbar", wrvu: 16.43 },
 "63015": { name: "Remove Spine Lamina >2 Crvcl", wrvu: 20.33 },
 "63016": { name: "Remove Spine Lamina >2 Thoracic", wrvu: 21.48 },
 "63017": { name: "Remove Spine Lamina >2 Lumbar", wrvu: 16.90 },
 "63020": { name: "Lamot Dcmprn Nerve Right 1 Cervical", wrvu: 14.54 },
 "63030": { name: "Lamot Dcmprn Nerve Right 1 Lumbar", wrvu: 11.70 },
 "63032": { name: "Lamot Repair Anulr Dfct 1 Lumbar", wrvu: 2.50 },
 "63035": { name: "Lamot Dcmprn Nerve Right Each Additional", wrvu: 3.76 },
 "63040": { name: "Laminotomy Single Cervical", wrvu: 19.80 },
 "63042": { name: "Laminotomy Single Lumbar", wrvu: 18.29 },
 "63043": { name: "Laminotomy Additional Cervical", wrvu: 0.00 },
 "63044": { name: "Laminotomy Additional Lumbar", wrvu: 0.00 },
 "63045": { name: "Lam Facetec & Foramot Cervical", wrvu: 17.50 },
 "63046": { name: "Lam Facetec & Foramot Thoracic", wrvu: 16.82 },
 "63047": { name: "Lam Facetec & Foramot Lumbar", wrvu: 14.99 },
 "63048": { name: "Lam Facetec &foramot Each Additional", wrvu: 3.38 },
 "63050": { name: "Cervical Laminoplsty 2/> Seg", wrvu: 21.46 },
 "63051": { name: "C-laminoplasty With Graft/plate", wrvu: 24.87 },
 "63052": { name: "Lam Facetc/frmt Arthrd Lum 1", wrvu: 4.14 },
 "63053": { name: "Lam Factc/frmt Arthrd Lum Each", wrvu: 3.69 },
 "63055": { name: "Decompress Spinal Cord Thoracic", wrvu: 22.96 },
 "63056": { name: "Decompress Spinal Cord Lumbar", wrvu: 21.31 },
 "63057": { name: "Decompress Spine Cord Add-on", wrvu: 5.12 },
 "63064": { name: "Decompress Spinal Cord Thoracic", wrvu: 25.56 },
 "63066": { name: "Decompress Spine Cord Add-on", wrvu: 3.18 },
 "63075": { name: "Neck Spine Disk Surgery", wrvu: 19.11 },
 "63076": { name: "Neck Spine Disk Surgery", wrvu: 3.94 },
 "63077": { name: "Spine Disk Surgery Thorax", wrvu: 22.31 },
 "63078": { name: "Spine Disk Surgery Thorax", wrvu: 3.20 },
 "63081": { name: "Remove Vert Body Dcmprn Crvl", wrvu: 25.45 },
 "63082": { name: "Remove Vertebral Body Add-on", wrvu: 4.25 },
 "63085": { name: "Remove Vert Body Dcmprn Thoracic", wrvu: 28.73 },
 "63086": { name: "Remove Vertebral Body Add-on", wrvu: 3.11 },
 "63087": { name: "Remov Vertbr Dcmprn Thrclmbr", wrvu: 36.59 },
 "63088": { name: "Remove Vertebral Body Add-on", wrvu: 4.21 },
 "63090": { name: "Remove Vert Body Dcmprn Lumbar", wrvu: 30.16 },
 "63091": { name: "Remove Vertebral Body Add-on", wrvu: 2.95 },
 "63101": { name: "Remove Vert Body Dcmprn Thoracic", wrvu: 33.25 },
 "63102": { name: "Remove Vert Body Dcmprn Lumbar", wrvu: 33.25 },
 "63103": { name: "Remove Vertebral Body Add-on", wrvu: 4.70 },
 "63170": { name: "Incise Spinal Cord Tract(s)", wrvu: 21.65 },
 "63172": { name: "Drainage Of Spinal Cyst", wrvu: 19.27 },
 "63173": { name: "Drainage Of Spinal Cyst", wrvu: 23.70 },
 "63185": { name: "Incise Spine Nerve Half Segmnt", wrvu: 16.08 },
 "63190": { name: "Incise Spine Nerve >2 Segmnts", wrvu: 18.42 },
 "63191": { name: "Incise Spine Accessory Nerve", wrvu: 18.45 },
 "63197": { name: "Lam With Cordotomy 1stg Thoracic", wrvu: 23.48 },
 "63200": { name: "Release Spinal Cord Lumbar", wrvu: 20.90 },
 "63250": { name: "Revise Spinal Cord Vsls Crvl", wrvu: 42.76 },
 "63251": { name: "Revise Spinal Cord Vsls Thoracic", wrvu: 43.52 },
 "63252": { name: "Revise Spine Cord Vessel Thrlmb", wrvu: 43.51 },
 "63265": { name: "Excise Intraspinl Lesion Cervical", wrvu: 23.22 },
 "63266": { name: "Excise Intrspinl Lesion Thoracic", wrvu: 24.06 },
 "63267": { name: "Excise Intrspinl Lesion Lumbar", wrvu: 18.96 },
 "63268": { name: "Excise Intrspinl Lesion Scrl", wrvu: 19.52 },
 "63270": { name: "Excise Intrspinl Lesion Crvl", wrvu: 29.06 },
 "63271": { name: "Excise Intrspinl Lesion Thoracic", wrvu: 29.17 },
 "63272": { name: "Excise Intrspinl Lesion Lumbar", wrvu: 26.81 },
 "63273": { name: "Excise Intrspinl Lesion Scrl", wrvu: 25.81 },
 "63275": { name: "Biopsy/Excision Xdrl Spine Lesn Crvl", wrvu: 25.21 },
 "63276": { name: "Biopsy/Excision Xdrl Spine Lesn Thoracic", wrvu: 25.05 },
 "63277": { name: "Biopsy/Excision Xdrl Spine Lesn Lumbar", wrvu: 21.83 },
 "63278": { name: "Biopsy/Excision Xdrl Spine Lesn Scrl", wrvu: 21.57 },
 "63280": { name: "Biopsy/Excision Idrl Spine Lesn Crvl", wrvu: 29.53 },
 "63281": { name: "Biopsy/Excision Idrl Spine Lesn Thoracic", wrvu: 29.24 },
 "63282": { name: "Biopsy/Excision Idrl Spine Lesn Lumbar", wrvu: 27.45 },
 "63283": { name: "Biopsy/Excision Idrl Spine Lesn Scrl", wrvu: 26.09 },
 "63285": { name: "Biopsy/Excision Idrl Imed Lesn Cervl", wrvu: 37.10 },
 "63286": { name: "Biopsy/Excision Idrl Imed Lesn Thoracic", wrvu: 36.68 },
 "63287": { name: "Biopsy/Excision Idrl Imed Lesn Thrlmb", wrvu: 39.08 },
 "63290": { name: "Biopsy/Excision Xdrl/idrl Lesion Any Lvl", wrvu: 39.80 },
 "63295": { name: "Repair Laminectomy Defect", wrvu: 5.12 },
 "63300": { name: "Remove Vert Xdrl Body Crvcl", wrvu: 26.13 },
 "63301": { name: "Remove Vert Xdrl Body Thoracic", wrvu: 30.78 },
 "63302": { name: "Remove Vert Xdrl Body Thrlmb", wrvu: 30.37 },
 "63303": { name: "Remov Vert Xdrl Bdy Lumbar/Sacral", wrvu: 32.71 },
 "63304": { name: "Remove Vert Idrl Body Crvcl", wrvu: 33.00 },
 "63305": { name: "Remove Vert Idrl Body Thoracic", wrvu: 35.33 },
 "63306": { name: "Remov Vert Idrl Bdy Thrclmbr", wrvu: 34.66 },
 "63307": { name: "Remov Vert Idrl Bdy Lumbar/Sacral", wrvu: 34.09 },
 "63308": { name: "Remove Vertebral Body Add-on", wrvu: 5.11 },
 "63600": { name: "Remove Spinal Cord Lesion", wrvu: 14.74 },
 "63610": { name: "Stimulation Of Spinal Cord", wrvu: 8.50 },
 "63620": { name: "Stereotactic Radiosurgery Spinal Lesion", wrvu: 15.21 },
 "63621": { name: "Stereotactic Radiosurgery Spinal Lesion Additional", wrvu: 3.90 },
 "63650": { name: "Implant Neuroelectrodes", wrvu: 6.97 },
 "63655": { name: "Implant Neuroelectrodes", wrvu: 10.65 },
 "63661": { name: "Remove Spine Eltrd Percutaneous Aray", wrvu: 4.95 },
 "63662": { name: "Remove Spine Eltrd Plate", wrvu: 10.73 },
 "63663": { name: "Revise Spine Eltrd Percutaneous Aray", wrvu: 7.56 },
 "63664": { name: "Revise Spine Eltrd Plate", wrvu: 11.23 },
 "63685": { name: "Ins/rplc Spi Npg/rcvr Pocket", wrvu: 5.06 },
 "63688": { name: "Revision/Removal Imp Sp Npg/r Dtch Cn", wrvu: 4.24 },
 "63700": { name: "Repair Of Spinal Herniation", wrvu: 17.03 },
 "63702": { name: "Repair Of Spinal Herniation", wrvu: 18.92 },
 "63704": { name: "Repair Of Spinal Herniation", wrvu: 21.87 },
 "63706": { name: "Repair Of Spinal Herniation", wrvu: 24.72 },
 "63707": { name: "Repair Spinal Fluid Leakage", wrvu: 12.33 },
 "63709": { name: "Repair Spinal Fluid Leakage", wrvu: 15.26 },
 "63710": { name: "Graft Repair Of Spine Defect", wrvu: 15.02 },
 "63740": { name: "Install Spinal Shunt", wrvu: 12.31 },
 "63741": { name: "Install Spinal Shunt", wrvu: 8.89 },
 "63744": { name: "Revision Of Spinal Shunt", wrvu: 8.72 },
 "63746": { name: "Removal Of Spinal Shunt", wrvu: 7.15 },
 "64400": { name: "Injection, Anesthetic Agent, Trigeminal Nerve", wrvu: 0.73 },
 "64405": { name: "Injection, Anesthetic Agent, Greater Occipital Nerve", wrvu: 0.92 },
 "64408": { name: "Injection Aa&/Steroid Vagus Nerve", wrvu: 0.73 },
 "64415": { name: "Injection Aa&/Steroid Brch Plexus Imaging", wrvu: 1.46 },
 "64416": { name: "Injection Aa&/Steroid Brch Pl Nfs Imaging", wrvu: 1.76 },
 "64417": { name: "Injection Aa&/Steroid Axillary Nerve Imaging", wrvu: 1.28 },
 "64418": { name: "Injection, Anesthetic Agent, Suprascapular Nerve", wrvu: 1.07 },
 "64420": { name: "Injection Aa&/Steroid Ntrcost Nerve 1", wrvu: 1.05 },
 "64421": { name: "Injection Aa&/Steroid Ntrcost Nerve Each", wrvu: 0.49 },
 "64425": { name: "Injection Aa&/Steroid Ii Ih Nerves", wrvu: 0.98 },
 "64430": { name: "Injection Aa&/Steroid Pudendal Nerve", wrvu: 0.98 },
 "64435": { name: "Injection Aa&/Steroid Paracrv Nerve", wrvu: 0.73 },
 "64445": { name: "Injection Aa&/Steroid Sciatic Nerve Imaging", wrvu: 1.36 },
 "64446": { name: "Injection Aa&/Steroid Subcutaneous Nerve Nfs Imaging", wrvu: 1.71 },
 "64447": { name: "Injection Aa&/Steroid Femoral Nerve Imaging", wrvu: 1.31 },
 "64448": { name: "Injection Aa&/Steroid Fem Nerve Nfs Imaging", wrvu: 1.64 },
 "64449": { name: "Injection Aa&/Steroid Lumbar Plex Nfs", wrvu: 1.24 },
 "64450": { name: "Injection, Anesthetic Agent, Other Peripheral Nerve", wrvu: 0.73 },
 "64451": { name: "Injection Aa&/Steroid Nerve Nrvtg Si Joint", wrvu: 1.48 },
 "64454": { name: "Injection Aa&/Steroid Gnclr Nerve Bronchial", wrvu: 1.48 },
 "64455": { name: "Injection Aa&/Steroid Pltr Com Dg Nerve", wrvu: 0.73 },
 "64461": { name: "Pvb Thoracic Single Injection Site", wrvu: 1.71 },
 "64462": { name: "Pvb Thoracic 2nd+ Injection Site", wrvu: 1.07 },
 "64463": { name: "Pvb Thoracic Cont Infusion", wrvu: 1.85 },
 "64466": { name: "Thoracic Fascial Pln Blk Uni Injection", wrvu: 1.46 },
 "64467": { name: "Thoracic Fascial Pln Blk Uni Nfs", wrvu: 1.70 },
 "64468": { name: "Thoracic Fascial Pln Blk Bi Injection", wrvu: 1.63 },
 "64469": { name: "Thoracic Fascial Pln Blk Bi Nfs", wrvu: 1.78 },
 "64473": { name: "Lower Xtr Fscl Pln Blk Uni Injection", wrvu: 1.31 },
 "64474": { name: "Lower Xtr Fscl Pln Blk Uni Nfs", wrvu: 1.63 },
 "64479": { name: "Injection Aa&/Steroid Tfrm Epi C/t 1", wrvu: 2.23 },
 "64480": { name: "Injection Aa&/Steroid Tfrm Epi C/t Each", wrvu: 1.17 },
 "64483": { name: "Injection Aa&/Steroid Tfrm Epi Lumbar/Sacral 1", wrvu: 1.85 },
 "64484": { name: "Injection Aa&/Steroid Tfrm Epi Lumbar/Sacral Each", wrvu: 0.98 },
 "64486": { name: "Tap Block Unil By Injection", wrvu: 1.17 },
 "64487": { name: "Tap Block Uni By Infusion", wrvu: 1.36 },
 "64488": { name: "Tap Block Bi Injection", wrvu: 1.37 },
 "64489": { name: "Tap Block Bi By Infusion", wrvu: 1.71 },
 "64490": { name: "Injection Paravert F Jnt C/t 1 Lev", wrvu: 1.77 },
 "64491": { name: "Injection Paravert F Jnt C/t 2 Lev", wrvu: 1.13 },
 "64492": { name: "Injection Paravert F Jnt C/t 3 Lev", wrvu: 1.13 },
 "64493": { name: "Injection Paravert F Jnt Lumbar/Sacral 1 Lev", wrvu: 1.48 },
 "64494": { name: "Injection Paravert F Jnt Lumbar/Sacral 2 Lev", wrvu: 0.98 },
 "64495": { name: "Injection Paravert F Jnt Lumbar/Sacral 3 Lev", wrvu: 0.98 },
 "64505": { name: "N Block Spenopalatine Gangl", wrvu: 1.33 },
 "64510": { name: "N Block Stellate Ganglion", wrvu: 1.19 },
 "64517": { name: "N Block Injection Hypogas Plexus", wrvu: 2.15 },
 "64520": { name: "N Block Lumbar/thoracic", wrvu: 1.32 },
 "64530": { name: "N Block Injection Celiac Pelus", wrvu: 1.54 },
 "64553": { name: "Implant Neuroelectrodes", wrvu: 5.98 },
 "64555": { name: "Implant Neuroelectrodes", wrvu: 5.62 },
 "64561": { name: "Implant Neuroelectrodes", wrvu: 5.30 },
 "64566": { name: "Neuroeltrd Stimulation Posterior Tibial", wrvu: 0.59 },
 "64567": { name: "Percutaneous Elec Nerve Field Stimj Cn", wrvu: 1.50 },
 "64568": { name: "Open Impltj Cranial Nerve Nea and pg", wrvu: 8.78 },
 "64569": { name: "Revise/replacement Vagus N Eltrd", wrvu: 10.73 },
 "64570": { name: "Remove Vagus N Eltrd", wrvu: 8.87 },
 "64575": { name: "Open Impltj Nea Perph Nerve", wrvu: 4.31 },
 "64580": { name: "Open Impltj Nea Neuromuscular", wrvu: 4.09 },
 "64581": { name: "Open Impltj Nea Sacral Nerve", wrvu: 11.90 },
 "64582": { name: "Open Mpltj Hpglsl Nstm Ary Pg", wrvu: 13.65 },
 "64583": { name: "Revision/rplct Hpglsl Nstm Ary Pg", wrvu: 14.14 },
 "64584": { name: "Removal Hpglsl Nstim Ary Pg", wrvu: 11.70 },
 "64585": { name: "Revision/Removal Perph Nstim Eltrd Ra", wrvu: 2.06 },
 "64590": { name: "Ins/rpl Prph Sac/Gastric Npg/r", wrvu: 4.97 },
 "64595": { name: "Revision/Removal Prph Sac/Gastric Npg/r", wrvu: 3.70 },
 "64596": { name: "Ins/Replacement Prq Eltrd Ra Pn 1", wrvu: 0.00 },
 "64597": { name: "Ins/rplcm Prq Eltrd Ra Pn Each", wrvu: 0.00 },
 "64598": { name: "Revj/Removal Nea Pn With Int Nstim", wrvu: 0.00 },
 "64600": { name: "Injection Treatment Of Nerve", wrvu: 3.40 },
 "64605": { name: "Injection Treatment Of Nerve", wrvu: 5.51 },
 "64610": { name: "Injection Treatment Of Nerve", wrvu: 7.02 },
 "64611": { name: "Chemodenerv Saliv Glands", wrvu: 1.00 },
 "64612": { name: "Destroy Nerve Face Muscle", wrvu: 1.37 },
 "64615": { name: "Chemodenerv Muscle Migraine", wrvu: 1.80 },
 "64616": { name: "Chemodenerv Muscle Neck Dyston", wrvu: 1.49 },
 "64617": { name: "Chemodener Muscle Larynx Emg", wrvu: 1.85 },
 "64620": { name: "Injection Treatment Of Nerve", wrvu: 2.82 },
 "64624": { name: "Dstrj Nulyt Agt Gnclr Nerve", wrvu: 2.44 },
 "64625": { name: "Radiofrequency Abltj Nerve Nrvtg Si Joint", wrvu: 3.31 },
 "64628": { name: "Trml Dstrj Ios Bvn 1st 2 Lumbar/Sacral", wrvu: 6.97 },
 "64629": { name: "Trml Dstrj Ios Bvn Each Additional", wrvu: 3.68 },
 "64630": { name: "Injection Treatment Of Nerve", wrvu: 2.97 },
 "64632": { name: "N Block Injection Common Digit", wrvu: 1.20 },
 "64633": { name: "Destroy Cervical/thoracic Facet Jnt", wrvu: 3.24 },
 "64634": { name: "Destroy C/th Facet Jnt Additional", wrvu: 1.29 },
 "64635": { name: "Destroy Lumbar/sac Facet Jnt", wrvu: 3.24 },
 "64636": { name: "Destroy Lumbar/Sacral Facet Jnt Additional", wrvu: 1.13 },
 "64640": { name: "Injection Treatment Of Nerve", wrvu: 1.93 },
 "64642": { name: "Chemodenerv 1 Extremity 1-4", wrvu: 1.61 },
 "64643": { name: "Chemodenerv 1 Extrem 1-4 Each", wrvu: 1.19 },
 "64644": { name: "Chemodenerv 1 Extrem 5/> Mus", wrvu: 1.77 },
 "64645": { name: "Chemodenerv 1 Extrem 5/> Each", wrvu: 1.36 },
 "64646": { name: "Chemodenerv Trunk Muscle 1-5", wrvu: 1.76 },
 "64647": { name: "Chemodenerv Trunk Muscle 6/>", wrvu: 2.06 },
 "64650": { name: "Chemodenerv Eccrine Glands", wrvu: 0.68 },
 "64653": { name: "Chemodenerv Eccrine Glands", wrvu: 0.86 },
 "64654": { name: "1st Open Implt Bat Modulj System", wrvu: 11.00 },
 "64655": { name: "Revj/Replacement Bat Moderate System Lead", wrvu: 11.30 },
 "64656": { name: "Revj/Replacement Bat Moderate System Pg", wrvu: 8.01 },
 "64657": { name: "Removal Bat Modulj System Tot System", wrvu: 12.13 },
 "64658": { name: "Removal Bat Modul System Lead Only", wrvu: 8.95 },
 "64659": { name: "Removal Bat Modulj System Pg Only", wrvu: 8.23 },
 "64680": { name: "Injection Treatment Of Nerve", wrvu: 2.60 },
 "64681": { name: "Injection Treatment Of Nerve", wrvu: 3.69 },
 "64702": { name: "Revise Finger/toe Nerve", wrvu: 6.10 },
 "64704": { name: "Revise Hand/foot Nerve", wrvu: 4.57 },
 "64708": { name: "Revise Arm/leg Nerve", wrvu: 6.20 },
 "64712": { name: "Revision Of Sciatic Nerve", wrvu: 7.87 },
 "64713": { name: "Revision Of Arm Nerve(s)", wrvu: 11.12 },
 "64714": { name: "Revise Low Back Nerve(s)", wrvu: 10.29 },
 "64716": { name: "Revision Of Cranial Nerve", wrvu: 6.82 },
 "64718": { name: "Revise Ulnar Nerve At Elbow", wrvu: 7.08 },
 "64719": { name: "Revise Ulnar Nerve At Wrist", wrvu: 4.85 },
 "64721": { name: "Carpal Tunnel Surgery", wrvu: 4.85 },
 "64722": { name: "Decompression Unspec Nerve", wrvu: 4.70 },
 "64726": { name: "Dcmprn Plantar Digital Nerve", wrvu: 4.16 },
 "64727": { name: "Internal Neurolysis", wrvu: 3.02 },
 "64728": { name: "Dcmprn Median Nerve Carpl Tunl", wrvu: 2.70 },
 "64732": { name: "Incision Of Brow Nerve", wrvu: 4.77 },
 "64734": { name: "Incision Of Cheek Nerve", wrvu: 5.41 },
 "64736": { name: "Incision Of Chin Nerve", wrvu: 5.10 },
 "64738": { name: "Incision Of Jaw Nerve", wrvu: 6.20 },
 "64740": { name: "Incision Of Tongue Nerve", wrvu: 6.06 },
 "64742": { name: "Incision Of Facial Nerve", wrvu: 6.68 },
 "64744": { name: "Incise Nerve Back Of Head", wrvu: 5.58 },
 "64746": { name: "Incise Diaphragm Nerve", wrvu: 6.40 },
 "64755": { name: "Incision Of Stomach Nerves", wrvu: 14.67 },
 "64760": { name: "Incision Of Vagus Nerve", wrvu: 7.40 },
 "64763": { name: "Incise Hip/thigh Nerve", wrvu: 7.37 },
 "64766": { name: "Incise Hip/thigh Nerve", wrvu: 9.23 },
 "64771": { name: "Sever Cranial Nerve", wrvu: 7.95 },
 "64772": { name: "Incision Of Spinal Nerve", wrvu: 7.64 },
 "64774": { name: "Remove Skin Nerve Lesion", wrvu: 5.66 },
 "64776": { name: "Remove Digit Nerve Lesion", wrvu: 5.46 },
 "64778": { name: "Digit Nerve Surgery Add-on", wrvu: 3.03 },
 "64782": { name: "Remove Limb Nerve Lesion", wrvu: 6.69 },
 "64783": { name: "Limb Nerve Surgery Add-on", wrvu: 3.62 },
 "64784": { name: "Remove Nerve Lesion", wrvu: 10.35 },
 "64786": { name: "Remove Sciatic Nerve Lesion", wrvu: 15.84 },
 "64787": { name: "Implant Nerve End", wrvu: 4.18 },
 "64788": { name: "Remove Skin Nerve Lesion", wrvu: 5.11 },
 "64790": { name: "Removal Of Nerve Lesion", wrvu: 11.80 },
 "64792": { name: "Removal Of Nerve Lesion", wrvu: 15.46 },
 "64795": { name: "Biopsy Of Nerve", wrvu: 2.93 },
 "64802": { name: "Sympathectomy Cervical", wrvu: 10.11 },
 "64804": { name: "Sympathectomy Cervicothorac", wrvu: 15.51 },
 "64809": { name: "Sympathectomy Thoracolumbar", wrvu: 14.34 },
 "64818": { name: "Sympathectomy Lumbar", wrvu: 11.06 },
 "64820": { name: "Sympathectomy Digital Artery", wrvu: 10.47 },
 "64821": { name: "Sympathectomy Radical Artery", wrvu: 9.10 },
 "64822": { name: "Sympathectomy Ulnar Artery", wrvu: 9.10 },
 "64823": { name: "Sympathectomy Supfc Palmar", wrvu: 10.67 },
 "64831": { name: "Repair Of Digit Nerve", wrvu: 8.93 },
 "64832": { name: "Repair Nerve Add-on", wrvu: 5.51 },
 "64834": { name: "Repair Of Hand Or Foot Nerve", wrvu: 10.54 },
 "64835": { name: "Repair Of Hand Or Foot Nerve", wrvu: 11.44 },
 "64836": { name: "Repair Of Hand Or Foot Nerve", wrvu: 11.44 },
 "64837": { name: "Repair Nerve Add-on", wrvu: 6.09 },
 "64840": { name: "Repair Of Leg Nerve", wrvu: 13.67 },
 "64856": { name: "Repair/transpose Nerve", wrvu: 14.69 },
 "64857": { name: "Repair Arm/leg Nerve", wrvu: 15.42 },
 "64858": { name: "Repair Sciatic Nerve", wrvu: 17.37 },
 "64859": { name: "Nerve Surgery", wrvu: 4.14 },
 "64861": { name: "Repair Of Arm Nerves", wrvu: 20.37 },
 "64862": { name: "Repair Of Low Back Nerves", wrvu: 20.56 },
 "64864": { name: "Repair Of Facial Nerve", wrvu: 13.07 },
 "64865": { name: "Repair Of Facial Nerve", wrvu: 15.69 },
 "64866": { name: "Fusion Of Facial/other Nerve", wrvu: 16.41 },
 "64868": { name: "Fusion Of Facial/other Nerve", wrvu: 14.53 },
 "64872": { name: "Subsequent Repair Of Nerve", wrvu: 1.94 },
 "64874": { name: "Repair & Revise Nerve Add-on", wrvu: 2.91 },
 "64876": { name: "Repair Nerve/shorten Bone", wrvu: 3.29 },
 "64885": { name: "Nerve Graft Head/neck <4 Cm", wrvu: 17.16 },
 "64886": { name: "Nerve Graft Head/neck >4 Cm", wrvu: 20.30 },
 "64890": { name: "Nerve Grf 1strnd Hnd/foot <4cm", wrvu: 15.83 },
 "64891": { name: "Nerve Grf 1strnd Hnd/foot >4cm", wrvu: 16.92 },
 "64892": { name: "Nerve Grf 1strnd Arm/leg <4cm", wrvu: 15.35 },
 "64893": { name: "Nerve Grf 1strnd Arm/leg >4 Cm", wrvu: 16.45 },
 "64895": { name: "Nerve Grf Mltst Hnd/foot <4 Cm", wrvu: 19.88 },
 "64896": { name: "Nerve Grf Mltst Hnd/foot >4 Cm", wrvu: 21.41 },
 "64897": { name: "Nerve Grf Mltst Arm/leg <4 Cm", wrvu: 18.90 },
 "64898": { name: "Nerve Grf Mltst Arm/leg >4 Cm", wrvu: 20.45 },
 "64901": { name: "Nerve Graft Add-on", wrvu: 9.95 },
 "64902": { name: "Nerve Graft Add-on", wrvu: 11.51 },
 "64905": { name: "Nerve Pedicle Transfer", wrvu: 14.73 },
 "64907": { name: "Nerve Pedicle Transfer", wrvu: 19.53 },
 "64910": { name: "Nerve Repair With Allograft", wrvu: 10.26 },
 "64911": { name: "Neurorraphy With Vein Autograft", wrvu: 13.65 },
 "64912": { name: "Nerve Repair With Nerve Algrft 1st", wrvu: 11.70 },
 "64913": { name: "Nerve Repair With Nerve Algrft Each Additional", wrvu: 2.93 },
 "64999": { name: "Unlisted Procedure Nervous System", wrvu: 0.00 },
 "65091": { name: "Revise Eye", wrvu: 7.08 },
 "65093": { name: "Revise Eye With Implant", wrvu: 6.86 },
 "65101": { name: "Removal Of Eye", wrvu: 8.09 },
 "65103": { name: "Remove Eye/insert Implant", wrvu: 8.62 },
 "65105": { name: "Remove Eye/attach Implant", wrvu: 9.68 },
 "65110": { name: "Removal Of Eye", wrvu: 15.31 },
 "65112": { name: "Remove Eye/revise Socket", wrvu: 18.05 },
 "65114": { name: "Remove Eye/revise Socket", wrvu: 19.16 },
 "65125": { name: "Revise Ocular Implant", wrvu: 3.19 },
 "65130": { name: "Insert Ocular Implant", wrvu: 8.21 },
 "65135": { name: "Insert Ocular Implant", wrvu: 8.39 },
 "65140": { name: "Attach Ocular Implant", wrvu: 9.22 },
 "65150": { name: "Revise Ocular Implant", wrvu: 6.27 },
 "65155": { name: "Reinsert Ocular Implant", wrvu: 9.85 },
 "65175": { name: "Removal Of Ocular Implant", wrvu: 7.22 },
 "65205": { name: "Removal of Foreign Body, External Eye, Conjunctival, Superficial", wrvu: 0.48 },
 "65210": { name: "Removal of Foreign Body, External Eye, Conjunctival, Embedded", wrvu: 0.59 },
 "65220": { name: "Removal of Foreign Body, External Eye, Corneal, without Slit Lamp", wrvu: 0.69 },
 "65222": { name: "Removal of Foreign Body, External Eye, Corneal, with Slit Lamp", wrvu: 0.82 },
 "65235": { name: "Remove Foreign Body From Eye", wrvu: 8.78 },
 "65260": { name: "Remove Foreign Body From Eye", wrvu: 12.23 },
 "65265": { name: "Remove Foreign Body From Eye", wrvu: 13.98 },
 "65270": { name: "Repair Of Eye Wound", wrvu: 1.90 },
 "65272": { name: "Repair Of Eye Wound", wrvu: 4.50 },
 "65273": { name: "Repair Of Eye Wound", wrvu: 5.03 },
 "65275": { name: "Repair Of Eye Wound", wrvu: 6.13 },
 "65280": { name: "Repair Of Eye Wound", wrvu: 8.87 },
 "65285": { name: "Repair Of Eye Wound", wrvu: 14.98 },
 "65286": { name: "Repair Of Eye Wound", wrvu: 6.46 },
 "65290": { name: "Repair Of Eye Socket Wound", wrvu: 6.37 },
 "65400": { name: "Removal Of Eye Lesion", wrvu: 7.31 },
 "65410": { name: "Biopsy Of Cornea", wrvu: 1.43 },
 "65420": { name: "Removal Of Eye Lesion", wrvu: 4.25 },
 "65426": { name: "Removal Of Eye Lesion", wrvu: 5.90 },
 "65430": { name: "Corneal Smear", wrvu: 1.43 },
 "65435": { name: "Curette/treat Cornea", wrvu: 0.90 },
 "65436": { name: "Curette/treat Cornea", wrvu: 4.70 },
 "65450": { name: "Treatment Of Corneal Lesion", wrvu: 3.38 },
 "65600": { name: "Revision Of Cornea", wrvu: 4.10 },
 "65710": { name: "Corneal Transplant", wrvu: 14.09 },
 "65730": { name: "Corneal Transplant", wrvu: 15.94 },
 "65750": { name: "Corneal Transplant", wrvu: 16.48 },
 "65755": { name: "Corneal Transplant", wrvu: 16.37 },
 "65756": { name: "Corneal Transplant Endothelial", wrvu: 16.42 },
 "65757": { name: "Prep Corneal Endoscopic Allograft", wrvu: 0.00 },
 "65760": { name: "Keratomileusis", wrvu: 0.00 },
 "65765": { name: "Keratophakia", wrvu: 0.00 },
 "65767": { name: "Epikeratoplasty", wrvu: 0.00 },
 "65770": { name: "Keratoprosthesis", wrvu: 19.25 },
 "65771": { name: "Radical Keratotomy", wrvu: 0.00 },
 "65772": { name: "Correction Of Astigmatism", wrvu: 4.96 },
 "65775": { name: "Correction Of Astigmatism", wrvu: 6.74 },
 "65778": { name: "Cover Eye With Membrane", wrvu: 0.82 },
 "65779": { name: "Cover Eye With Membrane Suture", wrvu: 1.71 },
 "65780": { name: "Ocular Reconst Transplant", wrvu: 6.85 },
 "65781": { name: "Ocular Reconst Transplant", wrvu: 17.69 },
 "65782": { name: "Ocular Reconst Transplant", wrvu: 15.04 },
 "65785": { name: "Impltj Ntrstrml Cranial Rng Seg", wrvu: 5.26 },
 "65800": { name: "Drainage Of Eye", wrvu: 1.49 },
 "65810": { name: "Drainage Of Eye", wrvu: 5.67 },
 "65815": { name: "Drainage Of Eye", wrvu: 5.85 },
 "65820": { name: "Goniotomy", wrvu: 8.69 },
 "65850": { name: "Trabeculotomy Ab Externo", wrvu: 11.11 },
 "65855": { name: "Trabeculoplasty Laser Surgery", wrvu: 2.93 },
 "65860": { name: "Severing Ads Anterior Sgm Laser", wrvu: 3.50 },
 "65865": { name: "Incise Inner Eye Adhesions", wrvu: 5.63 },
 "65870": { name: "Incise Inner Eye Adhesions", wrvu: 7.21 },
 "65875": { name: "Incise Inner Eye Adhesions", wrvu: 7.61 },
 "65880": { name: "Incise Inner Eye Adhesions", wrvu: 8.15 },
 "65900": { name: "Remove Eye Lesion", wrvu: 12.20 },
 "65920": { name: "Remove Implant Of Eye", wrvu: 9.74 },
 "65930": { name: "Remove Blood Clot From Eye", wrvu: 8.18 },
 "66020": { name: "Injection Treatment Of Eye", wrvu: 1.60 },
 "66030": { name: "Injection Treatment Of Eye", wrvu: 1.27 },
 "66130": { name: "Remove Eye Lesion", wrvu: 7.63 },
 "66150": { name: "Glaucoma Surgery", wrvu: 10.27 },
 "66155": { name: "Glaucoma Surgery", wrvu: 10.26 },
 "66160": { name: "Glaucoma Surgery", wrvu: 12.08 },
 "66170": { name: "Glaucoma Surgery", wrvu: 13.59 },
 "66172": { name: "Incision Of Eye", wrvu: 14.47 },
 "66174": { name: "Trluml Dil Aq O/f Can Without St", wrvu: 7.43 },
 "66175": { name: "Trluml Dil Aq O/f Can With St", wrvu: 9.11 },
 "66179": { name: "Aqueous Shunt Eye Without Graft", wrvu: 13.65 },
 "66180": { name: "Aqueous Shunt Eye With Graft", wrvu: 14.63 },
 "66183": { name: "Insert Anterior Drainage Device", wrvu: 12.87 },
 "66184": { name: "Revision Of Aqueous Shunt", wrvu: 9.34 },
 "66185": { name: "Revise Aqueous Shunt Eye", wrvu: 10.32 },
 "66225": { name: "Repair/graft Eye Lesion", wrvu: 12.31 },
 "66250": { name: "Follow-up Surgery Of Eye", wrvu: 6.92 },
 "66500": { name: "Incision Of Iris", wrvu: 3.73 },
 "66505": { name: "Incision Of Iris", wrvu: 4.11 },
 "66600": { name: "Remove Iris And Lesion", wrvu: 9.87 },
 "66605": { name: "Removal Of Iris", wrvu: 13.86 },
 "66625": { name: "Removal Of Iris", wrvu: 5.17 },
 "66630": { name: "Removal Of Iris", wrvu: 7.10 },
 "66635": { name: "Removal Of Iris", wrvu: 7.19 },
 "66680": { name: "Repair Iris & Ciliary Body", wrvu: 7.77 },
 "66682": { name: "Repair Iris & Ciliary Body", wrvu: 8.52 },
 "66683": { name: "Implantation Iris Prosthesis", wrvu: 10.40 },
 "66700": { name: "Destruction Ciliary Body", wrvu: 5.01 },
 "66710": { name: "Ciliary Transsleral Therapy", wrvu: 5.01 },
 "66711": { name: "Ecp Ciliary Body Destruction", wrvu: 5.48 },
 "66720": { name: "Destruction Ciliary Body", wrvu: 4.63 },
 "66740": { name: "Destruction Ciliary Body", wrvu: 5.01 },
 "66761": { name: "Revision Of Iris", wrvu: 2.93 },
 "66762": { name: "Revision Of Iris", wrvu: 5.25 },
 "66770": { name: "Removal Of Inner Eye Lesion", wrvu: 5.98 },
 "66820": { name: "Incision Secondary Cataract", wrvu: 3.91 },
 "66821": { name: "After Cataract Laser Surgery", wrvu: 3.33 },
 "66825": { name: "Reposition Intraocular Lens", wrvu: 8.78 },
 "66830": { name: "Removal Of Lens Lesion", wrvu: 9.23 },
 "66840": { name: "Removal Of Lens Material", wrvu: 8.95 },
 "66850": { name: "Removal Of Lens Material", wrvu: 10.29 },
 "66852": { name: "Removal Of Lens Material", wrvu: 11.12 },
 "66920": { name: "Extraction Of Lens", wrvu: 9.88 },
 "66930": { name: "Extraction Of Lens", wrvu: 11.32 },
 "66940": { name: "Extraction Of Lens", wrvu: 10.11 },
 "66982": { name: "Xcapsl Ctrc Removal Cplx without Ecp", wrvu: 9.99 },
 "66983": { name: "Cataract Surgery With Intraocular Lens 1 Stage", wrvu: 0.00 },
 "66984": { name: "Xcapsl Ctrc Removal Without Ecp", wrvu: 7.17 },
 "66985": { name: "Insert Lens Prosthesis", wrvu: 9.73 },
 "66986": { name: "Exchange Lens Prosthesis", wrvu: 11.95 },
 "66987": { name: "Xcapsl Ctrc Removal Cplx With Ecp", wrvu: 0.00 },
 "66988": { name: "Xcapsl Ctrc Removal With Ecp", wrvu: 0.00 },
 "66989": { name: "Xcpsl Ctrc Removal Cplx Insertion 1+", wrvu: 11.83 },
 "66990": { name: "Ophthalmic Endoscope Add-on", wrvu: 1.47 },
 "66991": { name: "Xcapsl Ctrc Removal Insertion 1+", wrvu: 9.00 },
 "66999": { name: "Unlisted Procedure Anterior Segment Eye", wrvu: 0.00 },
 "67005": { name: "Partial Removal Of Eye Fluid", wrvu: 5.74 },
 "67010": { name: "Partial Removal Of Eye Fluid", wrvu: 6.88 },
 "67015": { name: "Release Of Eye Fluid", wrvu: 6.96 },
 "67025": { name: "Replace Eye Fluid", wrvu: 7.91 },
 "67027": { name: "Implant Eye Drug System", wrvu: 11.33 },
 "67028": { name: "Injection Eye Drug", wrvu: 1.40 },
 "67030": { name: "Incise Inner Eye Strands", wrvu: 5.96 },
 "67031": { name: "Laser Surgery Eye Strands", wrvu: 4.36 },
 "67036": { name: "Removal Of Inner Eye Fluid", wrvu: 11.83 },
 "67039": { name: "Laser Treatment Of Retina", wrvu: 12.87 },
 "67040": { name: "Laser Treatment Of Retina", wrvu: 14.14 },
 "67041": { name: "Vit For Macular Pucker", wrvu: 15.92 },
 "67042": { name: "Vit For Macular Hole", wrvu: 15.92 },
 "67043": { name: "Vit For Membrane Dissect", wrvu: 16.97 },
 "67101": { name: "Repair Detached Retina Crtx", wrvu: 3.41 },
 "67105": { name: "Repair Detached Retina Pc", wrvu: 3.31 },
 "67107": { name: "Repair Detached Retina", wrvu: 15.60 },
 "67108": { name: "Repair Detached Retina", wrvu: 16.70 },
 "67110": { name: "Repair Detached Retina", wrvu: 9.99 },
 "67113": { name: "Repair Retinal Detach Cplx", wrvu: 18.53 },
 "67115": { name: "Release Encircling Material", wrvu: 5.96 },
 "67120": { name: "Remove Eye Implant Material", wrvu: 6.92 },
 "67121": { name: "Remove Eye Implant Material", wrvu: 11.94 },
 "67141": { name: "Prophylactic Rta Dtchmnt Crtx Dthrm", wrvu: 2.47 },
 "67145": { name: "Prophylactic Rta Dtchmnt Pc", wrvu: 2.47 },
 "67208": { name: "Treatment Of Retinal Lesion", wrvu: 7.46 },
 "67210": { name: "Treatment Of Retinal Lesion", wrvu: 6.20 },
 "67218": { name: "Treatment Of Retinal Lesion", wrvu: 19.85 },
 "67220": { name: "Treatment Of Choroid Lesion", wrvu: 6.20 },
 "67221": { name: "Ocular Photodynamic Therapeutic", wrvu: 3.36 },
 "67225": { name: "Eye Photodynamic Therapeutic Add-on", wrvu: 0.46 },
 "67227": { name: "Dstrj Extensive Retinopathy", wrvu: 3.41 },
 "67228": { name: "Treatment X10sv Retinopathy", wrvu: 4.28 },
 "67229": { name: "Tr Retinal Lesion Preterm Inferior", wrvu: 15.89 },
 "67250": { name: "Reinforce Eye Wall", wrvu: 9.37 },
 "67255": { name: "Reinforce/graft Eye Wall", wrvu: 8.17 },
 "67299": { name: "Unlisted Procedure Posterior Segmnt", wrvu: 0.00 },
 "67311": { name: "Revise Eye Muscle", wrvu: 5.78 },
 "67312": { name: "Revise Two Eye Muscles", wrvu: 9.26 },
 "67314": { name: "Revise Eye Muscle", wrvu: 5.78 },
 "67316": { name: "Revise Two Eye Muscles", wrvu: 10.05 },
 "67318": { name: "Revise Eye Muscle(s)", wrvu: 9.56 },
 "67320": { name: "Revise Eye Muscle(s) Add-on", wrvu: 2.93 },
 "67331": { name: "Eye Surgery Follow-up Add-on", wrvu: 1.95 },
 "67332": { name: "Rerevise Eye Muscles Add-on", wrvu: 3.41 },
 "67334": { name: "Revise Eye Muscle With Suture", wrvu: 2.01 },
 "67335": { name: "Eye Suture During Surgery", wrvu: 3.15 },
 "67340": { name: "Revise Eye Muscle Add-on", wrvu: 4.88 },
 "67343": { name: "Release Eye Tissue", wrvu: 8.26 },
 "67345": { name: "Destroy Nerve Of Eye Muscle", wrvu: 2.93 },
 "67346": { name: "Biopsy Eye Muscle", wrvu: 2.80 },
 "67399": { name: "Unlisted Procedure Extraocular Muscle", wrvu: 0.00 },
 "67400": { name: "Explore/biopsy Eye Socket", wrvu: 10.92 },
 "67405": { name: "Explore/drain Eye Socket", wrvu: 8.97 },
 "67412": { name: "Explore/treat Eye Socket", wrvu: 10.04 },
 "67413": { name: "Explore/treat Eye Socket", wrvu: 9.98 },
 "67414": { name: "Exploration/decompress Eye Socket", wrvu: 17.49 },
 "67415": { name: "Aspiration Orbital Contents", wrvu: 1.72 },
 "67420": { name: "Explore/treat Eye Socket", wrvu: 21.32 },
 "67430": { name: "Explore/treat Eye Socket", wrvu: 14.91 },
 "67440": { name: "Explore/drain Eye Socket", wrvu: 14.47 },
 "67445": { name: "Exploration/decompress Eye Socket", wrvu: 18.64 },
 "67450": { name: "Explore/biopsy Eye Socket", wrvu: 15.02 },
 "67500": { name: "Inject/treat Eye Socket", wrvu: 1.15 },
 "67505": { name: "Inject/treat Eye Socket", wrvu: 1.15 },
 "67515": { name: "Inject/treat Eye Socket", wrvu: 0.73 },
 "67516": { name: "Sprchoroidal Spc Injection Prescription Agt", wrvu: 1.49 },
 "67550": { name: "Insert Eye Socket Implant", wrvu: 11.48 },
 "67560": { name: "Revise Eye Socket Implant", wrvu: 11.88 },
 "67570": { name: "Decompress Optic Nerve", wrvu: 14.04 },
 "67599": { name: "Unlisted Procedure Orbit", wrvu: 0.00 },
 "67700": { name: "Blepharotomy Drainage Abscess Eyelid", wrvu: 1.37 },
 "67710": { name: "Severing Tarsorrhaphy", wrvu: 1.04 },
 "67715": { name: "Canthotomy", wrvu: 1.24 },
 "67800": { name: "Remove Eyelid Lesion", wrvu: 1.37 },
 "67801": { name: "Remove Eyelid Lesions", wrvu: 1.86 },
 "67805": { name: "Remove Eyelid Lesions", wrvu: 2.21 },
 "67808": { name: "Remove Eyelid Lesion(s)", wrvu: 4.49 },
 "67810": { name: "Incisional Biopsy Eyelid Skin Lid Margin", wrvu: 1.15 },
 "67820": { name: "Revise Eyelashes", wrvu: 0.31 },
 "67825": { name: "Revise Eyelashes", wrvu: 1.39 },
 "67830": { name: "Revise Eyelashes", wrvu: 1.71 },
 "67835": { name: "Revise Eyelashes", wrvu: 5.56 },
 "67840": { name: "Remove Eyelid Lesion", wrvu: 2.04 },
 "67850": { name: "Dstrj Lesion Lid Margin <1cm", wrvu: 1.70 },
 "67875": { name: "Closure Of Eyelid By Suture", wrvu: 1.32 },
 "67880": { name: "Revision Of Eyelid", wrvu: 4.49 },
 "67882": { name: "Revision Of Eyelid", wrvu: 5.87 },
 "67900": { name: "Repair Brow Defect", wrvu: 6.65 },
 "67901": { name: "Repair Eyelid Defect", wrvu: 7.40 },
 "67902": { name: "Repair Eyelid Defect", wrvu: 9.57 },
 "67903": { name: "Repair Eyelid Defect", wrvu: 6.35 },
 "67904": { name: "Repair Eyelid Defect", wrvu: 7.77 },
 "67906": { name: "Repair Eyelid Defect", wrvu: 6.76 },
 "67908": { name: "Repair Eyelid Defect", wrvu: 5.17 },
 "67909": { name: "Revise Eyelid Defect", wrvu: 5.43 },
 "67911": { name: "Revise Eyelid Defect", wrvu: 7.31 },
 "67912": { name: "Correction Eyelid With Implant", wrvu: 6.20 },
 "67914": { name: "Repair Eyelid Defect", wrvu: 3.66 },
 "67915": { name: "Repair Eyelid Defect", wrvu: 1.98 },
 "67916": { name: "Repair Eyelid Defect", wrvu: 5.34 },
 "67917": { name: "Repair Eyelid Defect", wrvu: 5.78 },
 "67921": { name: "Repair Eyelid Defect", wrvu: 3.38 },
 "67922": { name: "Repair Eyelid Defect", wrvu: 1.98 },
 "67923": { name: "Repair Eyelid Defect", wrvu: 5.34 },
 "67924": { name: "Repair Eyelid Defect", wrvu: 5.78 },
 "67930": { name: "Repair Eyelid Wound", wrvu: 3.56 },
 "67935": { name: "Repair Eyelid Wound", wrvu: 6.20 },
 "67938": { name: "Remove Eyelid Foreign Body", wrvu: 1.35 },
 "67950": { name: "Revision Of Eyelid", wrvu: 5.84 },
 "67961": { name: "Revision Of Eyelid", wrvu: 5.71 },
 "67966": { name: "Revision Of Eyelid", wrvu: 8.75 },
 "67971": { name: "Reconstruction Of Eyelid", wrvu: 9.76 },
 "67973": { name: "Reconstruction Of Eyelid", wrvu: 12.80 },
 "67974": { name: "Reconstruction Of Eyelid", wrvu: 12.77 },
 "67975": { name: "Reconstruction Of Eyelid", wrvu: 9.12 },
 "67999": { name: "Unlisted Procedure Eyelids", wrvu: 0.00 },
 "68020": { name: "Incise/drain Eyelid Lining", wrvu: 1.38 },
 "68040": { name: "Treatment Of Eyelid Lesions", wrvu: 0.83 },
 "68100": { name: "Biopsy Conjunctiva", wrvu: 1.32 },
 "68110": { name: "Excision Lesion Conjunctiva <1 Cm", wrvu: 1.77 },
 "68115": { name: "Excision Lesion Conjunctiva >1 Cm", wrvu: 2.35 },
 "68130": { name: "Excision Lesion Conjunctiva Adjustment Scl", wrvu: 4.97 },
 "68135": { name: "Destruction Lesion Conjunctiva", wrvu: 1.84 },
 "68200": { name: "Treat Eyelid By Injection", wrvu: 0.48 },
 "68320": { name: "Revise/graft Eyelid Lining", wrvu: 6.47 },
 "68325": { name: "Revise/graft Eyelid Lining", wrvu: 8.41 },
 "68326": { name: "Revise/graft Eyelid Lining", wrvu: 8.21 },
 "68328": { name: "Revise/graft Eyelid Lining", wrvu: 9.21 },
 "68330": { name: "Revise Eyelid Lining", wrvu: 5.64 },
 "68335": { name: "Revise/graft Eyelid Lining", wrvu: 8.25 },
 "68340": { name: "Separate Eyelid Adhesions", wrvu: 4.85 },
 "68360": { name: "Revise Eyelid Lining", wrvu: 5.04 },
 "68362": { name: "Revise Eyelid Lining", wrvu: 8.39 },
 "68371": { name: "Harvest Eye Tissue Alograft", wrvu: 4.96 },
 "68399": { name: "Unlisted Procedure Conjunctiva", wrvu: 0.00 },
 "68400": { name: "Incision & Drainage Lacrimal Gland", wrvu: 1.70 },
 "68420": { name: "Incision & Drainage Lacrimal Sac", wrvu: 2.29 },
 "68440": { name: "Snip Inc Lacrimal Punctum", wrvu: 0.97 },
 "68500": { name: "Removal Of Tear Gland", wrvu: 12.45 },
 "68505": { name: "Partial Removal Tear Gland", wrvu: 12.37 },
 "68510": { name: "Biopsy Of Tear Gland", wrvu: 4.49 },
 "68520": { name: "Removal Of Tear Sac", wrvu: 8.56 },
 "68525": { name: "Biopsy Of Tear Sac", wrvu: 4.31 },
 "68530": { name: "Clearance Of Tear Duct", wrvu: 3.61 },
 "68540": { name: "Remove Tear Gland Lesion", wrvu: 11.88 },
 "68550": { name: "Remove Tear Gland Lesion", wrvu: 14.78 },
 "68700": { name: "Repair Tear Ducts", wrvu: 7.67 },
 "68705": { name: "Revise Tear Duct Opening", wrvu: 2.06 },
 "68720": { name: "Create Tear Sac Drain", wrvu: 9.71 },
 "68745": { name: "Create Tear Duct Drain", wrvu: 9.65 },
 "68750": { name: "Create Tear Duct Drain", wrvu: 9.85 },
 "68760": { name: "Close Tear Duct Opening", wrvu: 1.74 },
 "68761": { name: "Close Tear Duct Opening", wrvu: 1.37 },
 "68770": { name: "Close Tear System Fistula", wrvu: 8.08 },
 "68801": { name: "Dilate Tear Duct Opening", wrvu: 0.80 },
 "68810": { name: "Probe Nasolacrimal Duct", wrvu: 1.50 },
 "68811": { name: "Probe Nasolacrimal Duct", wrvu: 1.70 },
 "68815": { name: "Probe Nasolacrimal Duct", wrvu: 2.63 },
 "68816": { name: "Probe Nl Duct With Balloon", wrvu: 2.05 },
 "68840": { name: "Explore/irrigate Tear Ducts", wrvu: 1.27 },
 "68841": { name: "Insertion Prescription Elut Implt Laceration Canal", wrvu: 0.48 },
 "68850": { name: "Injection For Tear Sac X-ray", wrvu: 0.78 },
 "68899": { name: "Unlisted Procedure Lacrimal System", wrvu: 0.00 },
 "69000": { name: "Drainage Xtrnl Ear Abscess/hem Simple", wrvu: 1.46 },
 "69005": { name: "Drainage Xtrnl Ear Abscess/hem Comp", wrvu: 2.11 },
 "69020": { name: "Drainage Xtrnl Aud Canal Abscess", wrvu: 1.49 },
 "69090": { name: "Ear Piercing", wrvu: 0.00 },
 "69100": { name: "Biopsy Of External Ear", wrvu: 0.79 },
 "69105": { name: "Biopsy Of External Ear Canal", wrvu: 0.83 },
 "69110": { name: "Remove External Ear Partial", wrvu: 3.44 },
 "69120": { name: "Removal Of External Ear", wrvu: 4.04 },
 "69140": { name: "Remove Ear Canal Lesion(s)", wrvu: 7.94 },
 "69145": { name: "Remove Ear Canal Lesion(s)", wrvu: 2.63 },
 "69150": { name: "Extensive Ear Canal Surgery", wrvu: 13.27 },
 "69155": { name: "Extensive Ear/neck Surgery", wrvu: 22.77 },
 "69200": { name: "Removal of Foreign Body, External Ear Canal, without anesthesia", wrvu: 0.75 },
 "69205": { name: "Removal of Foreign Body, External Ear Canal, with anesthesia", wrvu: 1.18 },
 "69209": { name: "Remove Impacted Ear Wax Uni", wrvu: 0.00 },
 "69210": { name: "Removal of Impacted Cerumen (ear wax), Unilateral", wrvu: 0.59 },
 "69220": { name: "Clean Out Mastoid Cavity", wrvu: 0.81 },
 "69222": { name: "Clean Out Mastoid Cavity", wrvu: 1.41 },
 "69300": { name: "Revise External Ear", wrvu: 6.44 },
 "69310": { name: "Rebuild Outer Ear Canal", wrvu: 10.70 },
 "69320": { name: "Rebuild Outer Ear Canal", wrvu: 16.75 },
 "69399": { name: "Unlisted Procedure External Ear", wrvu: 0.00 },
 "69420": { name: "Incision Of Eardrum", wrvu: 1.35 },
 "69421": { name: "Incision Of Eardrum", wrvu: 1.74 },
 "69424": { name: "Remove Ventilating Tube", wrvu: 0.83 },
 "69433": { name: "Create Eardrum Opening", wrvu: 1.53 },
 "69436": { name: "Create Eardrum Opening", wrvu: 1.96 },
 "69440": { name: "Exploration Of Middle Ear", wrvu: 7.52 },
 "69450": { name: "Eardrum Revision", wrvu: 5.55 },
 "69501": { name: "Mastoidectomy", wrvu: 8.98 },
 "69502": { name: "Mastoidectomy", wrvu: 12.25 },
 "69505": { name: "Remove Mastoid Structures", wrvu: 12.84 },
 "69511": { name: "Extensive Mastoid Surgery", wrvu: 13.36 },
 "69530": { name: "Extensive Mastoid Surgery", wrvu: 19.87 },
 "69535": { name: "Remove Part Of Temporal Bone", wrvu: 36.48 },
 "69540": { name: "Excision Aural Polyp", wrvu: 1.22 },
 "69550": { name: "Excision Aurl Glomus Tumor Trnscanl", wrvu: 10.87 },
 "69552": { name: "Excision Aurl Glomus Tumor Trnsmstd", wrvu: 19.31 },
 "69554": { name: "Excision Aurl Glomus Tumor Extended", wrvu: 35.07 },
 "69601": { name: "Revj Mstdc Rsltg Compl Mstdc", wrvu: 13.11 },
 "69602": { name: "Revision Mstdc Rslt Moderate Radical Mstdc", wrvu: 13.42 },
 "69603": { name: "Revj Mstdc Rsltg Radical Mstdc", wrvu: 13.85 },
 "69604": { name: "Revj Mstdc Rsltg Tympanplsty", wrvu: 13.85 },
 "69610": { name: "Tympanic Membrane Repair", wrvu: 4.36 },
 "69620": { name: "Myringoplasty", wrvu: 5.88 },
 "69631": { name: "Repair Eardrum Structures", wrvu: 9.80 },
 "69632": { name: "Rebuild Eardrum Structures", wrvu: 12.64 },
 "69633": { name: "Rebuild Eardrum Structures", wrvu: 12.00 },
 "69635": { name: "Repair Eardrum Structures", wrvu: 13.17 },
 "69636": { name: "Rebuild Eardrum Structures", wrvu: 15.04 },
 "69637": { name: "Rebuild Eardrum Structures", wrvu: 14.94 },
 "69641": { name: "Revise Middle Ear & Mastoid", wrvu: 12.57 },
 "69642": { name: "Revise Middle Ear & Mastoid", wrvu: 16.63 },
 "69643": { name: "Revise Middle Ear & Mastoid", wrvu: 15.20 },
 "69644": { name: "Revise Middle Ear & Mastoid", wrvu: 16.80 },
 "69645": { name: "Revise Middle Ear & Mastoid", wrvu: 16.29 },
 "69646": { name: "Revise Middle Ear & Mastoid", wrvu: 17.91 },
 "69650": { name: "Stapes Mobilization", wrvu: 9.56 },
 "69660": { name: "Revise Middle Ear Bone", wrvu: 11.73 },
 "69661": { name: "Revise Middle Ear Bone", wrvu: 15.52 },
 "69662": { name: "Revise Middle Ear Bone", wrvu: 15.21 },
 "69666": { name: "Repair Middle Ear Structures", wrvu: 9.64 },
 "69667": { name: "Repair Middle Ear Structures", wrvu: 9.65 },
 "69670": { name: "Remove Mastoid Air Cells", wrvu: 11.44 },
 "69676": { name: "Remove Middle Ear Nerve", wrvu: 9.45 },
 "69700": { name: "Close Mastoid Fistula", wrvu: 8.16 },
 "69705": { name: "Nps Surgery Dilat Eust Tube Uni", wrvu: 2.93 },
 "69706": { name: "Nps Surgery Dilat Eust Tube Bi", wrvu: 4.16 },
 "69710": { name: "Implant/replace Hearing Aid", wrvu: 0.00 },
 "69711": { name: "Remove/repair Hearing Aid", wrvu: 10.35 },
 "69714": { name: "Impl Oi Implt Skull Percutaneous Esp", wrvu: 6.51 },
 "69716": { name: "Impl Oi Implt Sk Tc Esp<100", wrvu: 8.80 },
 "69717": { name: "Replacement Oi Implt Skl Prq Esp", wrvu: 7.71 },
 "69719": { name: "Rplcm Oi Implt Sk Tc Esp<100", wrvu: 9.22 },
 "69720": { name: "Release Facial Nerve", wrvu: 14.34 },
 "69725": { name: "Release Facial Nerve", wrvu: 26.95 },
 "69726": { name: "Removal Ntr Oi Implt Skl Prq Esp", wrvu: 6.20 },
 "69727": { name: "Removal Ntr Oi Imp Sk Tc Esp<100", wrvu: 7.20 },
 "69728": { name: "Removal Ntr Oi Imp Sk Tc>=100", wrvu: 8.29 },
 "69729": { name: "Impl Oi Implt Sk Tc Esp>=100", wrvu: 9.72 },
 "69730": { name: "Rplc Oi Implt Sk Tc Esp>=100", wrvu: 9.99 },
 "69740": { name: "Repair Facial Nerve", wrvu: 15.86 },
 "69745": { name: "Repair Facial Nerve", wrvu: 16.59 },
 "69799": { name: "Unlisted Procedure Middle Ear", wrvu: 0.00 },
 "69801": { name: "Incise Inner Ear", wrvu: 2.01 },
 "69805": { name: "Explore Inner Ear", wrvu: 14.34 },
 "69806": { name: "Explore Inner Ear", wrvu: 12.31 },
 "69905": { name: "Remove Inner Ear", wrvu: 10.98 },
 "69910": { name: "Remove Inner Ear & Mastoid", wrvu: 13.56 },
 "69915": { name: "Incise Inner Ear Nerve", wrvu: 22.20 },
 "69930": { name: "Implant Cochlear Device", wrvu: 17.29 },
 "69949": { name: "Unlisted Procedure Inner Ear", wrvu: 0.00 },
 "69950": { name: "Incise Inner Ear Nerve", wrvu: 26.94 },
 "69955": { name: "Release Facial Nerve", wrvu: 28.68 },
 "69960": { name: "Release Inner Ear Canal", wrvu: 28.68 },
 "69970": { name: "Remove Inner Ear Lesion", wrvu: 31.60 },
 "69979": { name: "Unlisted Procedure Temporal Bone", wrvu: 0.00 },
 "69990": { name: "Microsurgery Add-on", wrvu: 3.37 },
 "70010": { name: "Contrast X-ray Of Brain", wrvu: 1.16 },
 "70015": { name: "Contrast X-ray Of Brain", wrvu: 1.16 },
 "70030": { name: "X-ray Eye For Foreign Body", wrvu: 0.18 },
 "70100": { name: "X-ray Exam Of Jaw <4views", wrvu: 0.18 },
 "70110": { name: "X-ray Exam Of Jaw 4/> Views", wrvu: 0.24 },
 "70120": { name: "X-ray Exam Of Mastoids", wrvu: 0.18 },
 "70130": { name: "X-ray Exam Of Mastoids", wrvu: 0.33 },
 "70134": { name: "X-ray Exam Of Middle Ear", wrvu: 0.33 },
 "70140": { name: "X-ray Exam Of Facial Bones", wrvu: 0.19 },
 "70150": { name: "X-ray Exam Of Facial Bones", wrvu: 0.25 },
 "70160": { name: "X-ray Exam Of Nasal Bones", wrvu: 0.17 },
 "70170": { name: "X-ray Exam Of Tear Duct", wrvu: 0.00 },
 "70190": { name: "X-ray Exam Of Eye Sockets", wrvu: 0.20 },
 "70200": { name: "X-ray Exam Of Eye Sockets", wrvu: 0.27 },
 "70210": { name: "X-ray Exam Of Sinuses", wrvu: 0.17 },
 "70220": { name: "X-ray Exam Of Sinuses", wrvu: 0.21 },
 "70240": { name: "X-ray Exam Pituitary Saddle", wrvu: 0.19 },
 "70250": { name: "X-ray Exam Of Skull", wrvu: 0.18 },
 "70260": { name: "X-ray Exam Of Skull", wrvu: 0.27 },
 "70300": { name: "X-ray Exam Of Teeth", wrvu: 0.10 },
 "70310": { name: "X-ray Exam Of Teeth", wrvu: 0.16 },
 "70320": { name: "Full Mouth X-ray Of Teeth", wrvu: 0.21 },
 "70328": { name: "X-ray Exam Of Jaw Joint", wrvu: 0.18 },
 "70330": { name: "X-ray Exam Of Jaw Joints", wrvu: 0.23 },
 "70332": { name: "X-ray Exam Of Jaw Joint", wrvu: 0.53 },
 "70336": { name: "Magnetic Image Jaw Joint", wrvu: 1.44 },
 "70350": { name: "X-ray Head For Orthodontia", wrvu: 0.17 },
 "70355": { name: "Panoramic X-ray Of Jaws", wrvu: 0.20 },
 "70360": { name: "X-ray Exam Of Neck", wrvu: 0.18 },
 "70370": { name: "Throat X-ray & Fluoroscopy", wrvu: 0.31 },
 "70371": { name: "Speech Evaluation Complex", wrvu: 0.82 },
 "70380": { name: "X-ray Exam Of Salivary Gland", wrvu: 0.17 },
 "70390": { name: "X-ray Exam Of Salivary Duct", wrvu: 0.37 },
 "70450": { name: "CT Head/brain Without Dye", wrvu: 0.83 },
 "70460": { name: "CT Head/brain With Dye", wrvu: 1.10 },
 "70470": { name: "CT Head/brain Without & With Dye", wrvu: 1.24 },
 "70471": { name: "Cta H and n C+ With Noncontrast Imaging", wrvu: 2.50 },
 "70472": { name: "CT Cere Prfu Alys C+with CT/cta", wrvu: 0.77 },
 "70473": { name: "CT Cere Prfu Aly C+without CT/cta", wrvu: 1.00 },
 "70480": { name: "CT Orbit/ear/fossa Without Dye", wrvu: 1.25 },
 "70481": { name: "CT Orbit/ear/fossa With Dye", wrvu: 1.10 },
 "70482": { name: "CT Orbit/ear/fossa Without and with Dye", wrvu: 1.24 },
 "70486": { name: "CT Maxillofacial Without Dye", wrvu: 0.83 },
 "70487": { name: "CT Maxillofacial With Dye", wrvu: 1.10 },
 "70488": { name: "CT Maxillofacial Without & With Dye", wrvu: 1.24 },
 "70490": { name: "CT Soft Tissue Neck Without Dye", wrvu: 1.25 },
 "70491": { name: "CT Soft Tissue Neck With Dye", wrvu: 1.35 },
 "70492": { name: "CT Sft Tsue Neck Without & With Dye", wrvu: 1.58 },
 "70496": { name: "CT Angiography Head", wrvu: 1.71 },
 "70498": { name: "CT Angiography Neck", wrvu: 1.71 },
 "70540": { name: "MRI Orbit/face/neck Without Dye", wrvu: 1.32 },
 "70542": { name: "MRI Orbit/face/neck With Dye", wrvu: 1.58 },
 "70543": { name: "MRI Orbt/fac/Neck Without &with Dye", wrvu: 2.10 },
 "70544": { name: "Mr Angiography Head Without Dye", wrvu: 1.17 },
 "70545": { name: "Mr Angiography Head With Dye", wrvu: 1.17 },
 "70546": { name: "Mr Angiograph Head Without and with Dye", wrvu: 1.44 },
 "70547": { name: "Mr Angiography Neck Without Dye", wrvu: 1.17 },
 "70548": { name: "Mr Angiography Neck With Dye", wrvu: 1.46 },
 "70549": { name: "Mr Angiograph Neck Without and with Dye", wrvu: 1.76 },
 "70551": { name: "MRI Brain Stem Without Dye", wrvu: 1.44 },
 "70552": { name: "MRI Brain Stem With Dye", wrvu: 1.74 },
 "70553": { name: "MRI Brain Stem Without & With Dye", wrvu: 2.23 },
 "70554": { name: "Fmri Brain By Tech", wrvu: 2.06 },
 "70555": { name: "Fmri Brain By Phys/psych", wrvu: 0.00 },
 "70557": { name: "MRI Brain Without Dye", wrvu: 0.00 },
 "70558": { name: "MRI Brain With Dye", wrvu: 0.00 },
 "70559": { name: "MRI Brain Without & With Dye", wrvu: 0.00 },
 "71045": { name: "X-ray Exam Chest 1 View", wrvu: 0.18 },
 "71046": { name: "X-ray Exam Chest 2 Views", wrvu: 0.21 },
 "71047": { name: "X-ray Exam Chest 3 Views", wrvu: 0.26 },
 "71048": { name: "X-ray Exam Chest 4+ Views", wrvu: 0.30 },
 "71100": { name: "X-ray Exam Ribs Uni 2 Views", wrvu: 0.21 },
 "71101": { name: "X-ray Exam Unilateral Ribs/chest", wrvu: 0.26 },
 "71110": { name: "X-ray Exam Ribs Bil 3 Views", wrvu: 0.28 },
 "71111": { name: "X-ray Exam Ribs/chest4/> Views", wrvu: 0.31 },
 "71120": { name: "X-ray Exam Breastbone 2/>Views", wrvu: 0.20 },
 "71130": { name: "X-ray Strenoclavic Joint 3/>Views", wrvu: 0.21 },
 "71250": { name: "CT Thorax Diagnosis C-", wrvu: 1.05 },
 "71260": { name: "CT Thorax Diagnosis C+", wrvu: 1.13 },
 "71270": { name: "CT Thorax Diagnosis C-/c+", wrvu: 1.22 },
 "71271": { name: "CT Thorax Lung Cancer Scr C-", wrvu: 1.05 },
 "71275": { name: "CT Angiography Chest", wrvu: 1.77 },
 "71550": { name: "MRI Chest Without Dye", wrvu: 1.42 },
 "71551": { name: "MRI Chest With Dye", wrvu: 1.69 },
 "71552": { name: "MRI Chest Without & With Dye", wrvu: 2.20 },
 "71555": { name: "MRI Angiography Chest W Or Without Dye", wrvu: 1.76 },
 "72020": { name: "X-ray Exam Of Spine 1 View", wrvu: 0.16 },
 "72040": { name: "X-ray Exam Neck Spine 2-3 Vw", wrvu: 0.21 },
 "72050": { name: "X-ray Exam Neck Spine 4/5vws", wrvu: 0.26 },
 "72052": { name: "X-ray Exam Neck Spine 6/>Views", wrvu: 0.29 },
 "72070": { name: "X-ray Exam Thoracic Spine 2vws", wrvu: 0.20 },
 "72072": { name: "X-ray Exam Thoracic Spine 3vws", wrvu: 0.22 },
 "72074": { name: "X-ray Exam Thoracic Spine4/>vw", wrvu: 0.24 },
 "72080": { name: "X-ray Exam Thoracolmb 2/> Vw", wrvu: 0.20 },
 "72081": { name: "X-ray Exam Entire Spi 1 Vw", wrvu: 0.25 },
 "72082": { name: "X-ray Exam Entire Spi 2/3 Vw", wrvu: 0.30 },
 "72083": { name: "X-ray Exam Entire Spi 4/5 Vw", wrvu: 0.34 },
 "72084": { name: "X-ray Exam Entire Spi 6/> Vw", wrvu: 0.40 },
 "72100": { name: "X-ray Exam L-s Spine 2/3 Views", wrvu: 0.21 },
 "72110": { name: "X-ray Exam L-2 Spine 4/>Views", wrvu: 0.25 },
 "72114": { name: "X-ray Exam L-s Spine Bending", wrvu: 0.29 },
 "72120": { name: "X-ray Bend Only L-s Spine", wrvu: 0.21 },
 "72125": { name: "CT Neck Spine Without Dye", wrvu: 0.98 },
 "72126": { name: "CT Neck Spine With Dye", wrvu: 1.19 },
 "72127": { name: "CT Neck Spine Without & With Dye", wrvu: 1.24 },
 "72128": { name: "CT Chest Spine Without Dye", wrvu: 0.98 },
 "72129": { name: "CT Chest Spine With Dye", wrvu: 1.19 },
 "72130": { name: "CT Chest Spine Without & With Dye", wrvu: 1.24 },
 "72131": { name: "CT Lumbar Spine Without Dye", wrvu: 0.98 },
 "72132": { name: "CT Lumbar Spine With Dye", wrvu: 1.19 },
 "72133": { name: "CT Lumbar Spine Without & With Dye", wrvu: 1.24 },
 "72141": { name: "MRI Neck Spine Without Dye", wrvu: 1.44 },
 "72142": { name: "MRI Neck Spine With Dye", wrvu: 1.74 },
 "72146": { name: "MRI Chest Spine Without Dye", wrvu: 1.44 },
 "72147": { name: "MRI Chest Spine With Dye", wrvu: 1.74 },
 "72148": { name: "MRI Lumbar Spine Without Dye", wrvu: 1.44 },
 "72149": { name: "MRI Lumbar Spine With Dye", wrvu: 1.74 },
 "72156": { name: "MRI Neck Spine Without & With Dye", wrvu: 2.23 },
 "72157": { name: "MRI Chest Spine Without & With Dye", wrvu: 2.23 },
 "72158": { name: "MRI Lumbar Spine Without & With Dye", wrvu: 2.23 },
 "72159": { name: "Mr Angiography Spine Without and with Dye", wrvu: 1.76 },
 "72170": { name: "X-ray Exam Of Pelvis", wrvu: 0.17 },
 "72190": { name: "X-ray Exam Of Pelvis", wrvu: 0.24 },
 "72191": { name: "CT Angiograph Pelv Without and with Dye", wrvu: 1.76 },
 "72192": { name: "CT Pelvis Without Dye", wrvu: 1.06 },
 "72193": { name: "CT Pelvis With Dye", wrvu: 1.13 },
 "72194": { name: "CT Pelvis Without & With Dye", wrvu: 1.19 },
 "72195": { name: "MRI Pelvis Without Dye", wrvu: 1.42 },
 "72196": { name: "MRI Pelvis With Dye", wrvu: 1.69 },
 "72197": { name: "MRI Pelvis Without & With Dye", wrvu: 2.15 },
 "72198": { name: "Mr Angiography Pelvis Without & With Dye", wrvu: 1.76 },
 "72200": { name: "X-ray Exam Si Joints", wrvu: 0.17 },
 "72202": { name: "X-ray Exam Si Joints 3/> Views", wrvu: 0.22 },
 "72220": { name: "X-ray Exam Sacrum Tailbone", wrvu: 0.17 },
 "72240": { name: "Myelography Neck Spine", wrvu: 0.89 },
 "72255": { name: "Myelography Thoracic Spine", wrvu: 0.89 },
 "72265": { name: "Myelography L-s Spine", wrvu: 0.81 },
 "72270": { name: "Myelogphy 2/> Spine Regions", wrvu: 1.30 },
 "72285": { name: "Discography Cervical/thoracic Spine", wrvu: 1.13 },
 "72295": { name: "X-ray Of Lower Spine Disk", wrvu: 0.81 },
 "73000": { name: "X-ray Exam Of Collar Bone", wrvu: 0.16 },
 "73010": { name: "X-ray Exam Of Shoulder Blade", wrvu: 0.17 },
 "73020": { name: "X-ray Exam Of Shoulder", wrvu: 0.15 },
 "73030": { name: "X-ray Exam Of Shoulder", wrvu: 0.18 },
 "73040": { name: "Contrast X-ray Of Shoulder", wrvu: 0.53 },
 "73050": { name: "X-ray Exam Of Shoulders", wrvu: 0.18 },
 "73060": { name: "X-ray Exam Of Humerus", wrvu: 0.16 },
 "73070": { name: "X-ray Exam Of Elbow", wrvu: 0.16 },
 "73080": { name: "X-ray Exam Of Elbow", wrvu: 0.17 },
 "73085": { name: "Contrast X-ray Of Elbow", wrvu: 0.53 },
 "73090": { name: "X-ray Exam Of Forearm", wrvu: 0.16 },
 "73092": { name: "X-ray Exam Of Arm Infant", wrvu: 0.16 },
 "73100": { name: "X-ray Exam Of Wrist", wrvu: 0.16 },
 "73110": { name: "X-ray Exam Of Wrist", wrvu: 0.17 },
 "73115": { name: "Contrast X-ray Of Wrist", wrvu: 0.53 },
 "73120": { name: "X-ray Exam Of Hand", wrvu: 0.16 },
 "73130": { name: "X-ray Exam Of Hand", wrvu: 0.17 },
 "73140": { name: "X-ray Exam Of Finger(s)", wrvu: 0.13 },
 "73200": { name: "CT Upper Extremity Without Dye", wrvu: 0.98 },
 "73201": { name: "CT Upper Extremity With Dye", wrvu: 1.13 },
 "73202": { name: "CT Uppr Extremity Without and with Dye", wrvu: 1.19 },
 "73206": { name: "CT Angiography Upper Extrm Without and with Dye", wrvu: 1.76 },
 "73218": { name: "MRI Upper Extremity Without Dye", wrvu: 1.32 },
 "73219": { name: "MRI Upper Extremity With Dye", wrvu: 1.58 },
 "73220": { name: "MRI Uppr Extremity Without and with Dye", wrvu: 2.10 },
 "73221": { name: "MRI Joint Upper Extrem Without Dye", wrvu: 1.32 },
 "73222": { name: "MRI Joint Upper Extrem With Dye", wrvu: 1.58 },
 "73223": { name: "MRI Joint Upper Extr Without and with Dye", wrvu: 2.10 },
 "73225": { name: "Mr Angiography Upper Extr Without and with Dye", wrvu: 1.69 },
 "73501": { name: "X-ray Exam Hip Uni 1 View", wrvu: 0.18 },
 "73502": { name: "X-ray Exam Hip Uni 2-3 Views", wrvu: 0.21 },
 "73503": { name: "X-ray Exam Hip Uni 4/> Views", wrvu: 0.26 },
 "73521": { name: "X-ray Exam Hips Bi 2 Views", wrvu: 0.21 },
 "73522": { name: "X-ray Exam Hips Bi 3-4 Views", wrvu: 0.28 },
 "73523": { name: "X-ray Exam Hips Bi 5/> Views", wrvu: 0.30 },
 "73525": { name: "Contrast X-ray Of Hip", wrvu: 0.53 },
 "73551": { name: "X-ray Exam Of Femur 1", wrvu: 0.16 },
 "73552": { name: "X-ray Exam Of Femur 2/>", wrvu: 0.18 },
 "73560": { name: "X-ray Exam Of Knee 1 Or 2", wrvu: 0.16 },
 "73562": { name: "X-ray Exam Of Knee 3", wrvu: 0.18 },
 "73564": { name: "X-ray Exam Knee 4 Or More", wrvu: 0.21 },
 "73565": { name: "X-ray Exam Of Knees", wrvu: 0.16 },
 "73580": { name: "Contrast X-ray Of Knee Joint", wrvu: 0.58 },
 "73590": { name: "X-ray Exam Of Lower Leg", wrvu: 0.16 },
 "73592": { name: "X-ray Exam Of Leg Infant", wrvu: 0.16 },
 "73600": { name: "X-ray Exam Of Ankle", wrvu: 0.16 },
 "73610": { name: "X-ray Exam Of Ankle", wrvu: 0.17 },
 "73615": { name: "Contrast X-ray Of Ankle", wrvu: 0.53 },
 "73620": { name: "X-ray Exam Of Foot", wrvu: 0.16 },
 "73630": { name: "X-ray Exam Of Foot", wrvu: 0.17 },
 "73650": { name: "X-ray Exam Of Heel", wrvu: 0.16 },
 "73660": { name: "X-ray Exam Of Toe(s)", wrvu: 0.13 },
 "73700": { name: "CT Lower Extremity Without Dye", wrvu: 0.98 },
 "73701": { name: "CT Lower Extremity With Dye", wrvu: 1.13 },
 "73702": { name: "CT Lower Extremity Without and with Dye", wrvu: 1.19 },
 "73706": { name: "CT Angiography Lower Extr Without and with Dye", wrvu: 1.85 },
 "73718": { name: "MRI Lower Extremity Without Dye", wrvu: 1.32 },
 "73719": { name: "MRI Lower Extremity With Dye", wrvu: 1.58 },
 "73720": { name: "MRI Lower Extremity Without and with Dye", wrvu: 2.10 },
 "73721": { name: "MRI Jnt Of Lower Extre Without Dye", wrvu: 1.32 },
 "73722": { name: "MRI Joint Of Lower Extr With Dye", wrvu: 1.58 },
 "73723": { name: "MRI Joint Lower Extr Without and with Dye", wrvu: 2.10 },
 "73725": { name: "Mr Ang Lower External W Or Without Dye", wrvu: 1.77 },
 "74018": { name: "Radex Abdomen 1 View", wrvu: 0.18 },
 "74019": { name: "Radex Abdomen 2 Views", wrvu: 0.22 },
 "74021": { name: "Radex Abdomen 3+ Views", wrvu: 0.26 },
 "74022": { name: "Radex Compl Aqt Abdominal Series", wrvu: 0.31 },
 "74150": { name: "CT Abdomen Without Contrast", wrvu: 1.16 },
 "74160": { name: "CT Abdomen With Contrast", wrvu: 1.24 },
 "74170": { name: "CT Abdominal without Contrast Flwd Contrast", wrvu: 1.37 },
 "74174": { name: "Cta Abdominal and pelvis With Contrast", wrvu: 2.15 },
 "74175": { name: "Cta Abdomen With Contrast", wrvu: 1.77 },
 "74176": { name: "CT Abdominal & Pelvis Without Contrast", wrvu: 1.70 },
 "74177": { name: "CT Abdominal & Pelvis With Contrast", wrvu: 1.77 },
 "74178": { name: "CT Abdominal and plv without Counter Flwd Counter", wrvu: 1.96 },
 "74181": { name: "MRI Abdomen Without Contrast", wrvu: 1.42 },
 "74182": { name: "MRI Abdomen With Contrast", wrvu: 1.69 },
 "74183": { name: "MRI Abdominal Without Counter Flwd Counter", wrvu: 2.15 },
 "74185": { name: "Mra Abdominal W Or Without Contrast", wrvu: 1.76 },
 "74190": { name: "Peritoneogram Rs and i", wrvu: 0.00 },
 "74210": { name: "X-ray Xm Pharynx&/Cervical Esophageal C+", wrvu: 0.58 },
 "74220": { name: "X-ray Xm Esophagus 1cntrst", wrvu: 0.59 },
 "74221": { name: "X-ray Xm Esophagus 2cntrst", wrvu: 0.68 },
 "74230": { name: "X-ray Xm Swlng Funcj C+", wrvu: 0.52 },
 "74235": { name: "Remove Esophagus Obstruction", wrvu: 0.00 },
 "74240": { name: "X-ray Xm Upper Gastrointestinal Trc 1cntrst", wrvu: 0.78 },
 "74246": { name: "X-ray Xm Upper Gastrointestinal Trc 2cntrst", wrvu: 0.88 },
 "74248": { name: "X-ray Sm Int F-thru STD", wrvu: 0.68 },
 "74250": { name: "X-ray Xm Sm Int 1cntrst STD", wrvu: 0.79 },
 "74251": { name: "X-ray Xm Sm Int 2cntrst STD", wrvu: 1.14 },
 "74261": { name: "CT Colonography Diagnosis", wrvu: 2.34 },
 "74262": { name: "CT Colonography Diagnosis With Dye", wrvu: 2.44 },
 "74263": { name: "CT Colonography Screening", wrvu: 2.22 },
 "74270": { name: "X-ray Xm Colon 1cntrst STD", wrvu: 1.01 },
 "74280": { name: "X-ray Xm Colon 2cntrst STD", wrvu: 1.23 },
 "74283": { name: "Therapeutic Nma Rdctj Intus/obstrcj", wrvu: 1.97 },
 "74290": { name: "Contrast X-ray Gallbladder", wrvu: 0.31 },
 "74300": { name: "X-ray Bile Ducts/pancreas", wrvu: 0.00 },
 "74301": { name: "X-rays At Surgery Add-on", wrvu: 0.00 },
 "74328": { name: "X-ray Bile Duct Endoscopy", wrvu: 0.00 },
 "74329": { name: "X-ray For Pancreas Endoscopy", wrvu: 0.00 },
 "74330": { name: "X-ray Bile/panc Endoscopy", wrvu: 0.00 },
 "74340": { name: "X-ray Guide For Gastrointestinal Tube", wrvu: 0.00 },
 "74355": { name: "X-ray Guide Intestinal Tube", wrvu: 0.00 },
 "74360": { name: "X-ray Guide Gastrointestinal Dilation", wrvu: 0.00 },
 "74363": { name: "X-ray Bile Duct Dilation", wrvu: 0.00 },
 "74400": { name: "Urography Intravenous +-kub Tomog", wrvu: 0.48 },
 "74410": { name: "Urography Nfs Drip&/bolus", wrvu: 0.48 },
 "74415": { name: "Urography Nfs Drip&/bls With Nf", wrvu: 0.48 },
 "74420": { name: "Urography Rtrgr +-kub", wrvu: 0.51 },
 "74425": { name: "Urography Antegrade Rs and i", wrvu: 0.50 },
 "74430": { name: "Contrast X-ray Bladder", wrvu: 0.31 },
 "74440": { name: "X-ray Male Genital Tract", wrvu: 0.37 },
 "74445": { name: "X-ray Exam Of Penis", wrvu: 0.00 },
 "74450": { name: "X-ray Urethra/bladder", wrvu: 0.00 },
 "74455": { name: "X-ray Urethra/bladder", wrvu: 0.32 },
 "74470": { name: "X-ray Exam Of Kidney Lesion", wrvu: 0.00 },
 "74485": { name: "Dilation Ureteral/urt Rs and i", wrvu: 0.81 },
 "74712": { name: "MRI Fetal Sngl/1st Gestation", wrvu: 2.93 },
 "74713": { name: "MRI Fetal Each Additional Gestation", wrvu: 1.80 },
 "74740": { name: "X-ray Female Genital Tract", wrvu: 0.37 },
 "74742": { name: "X-ray Fallopian Tube", wrvu: 0.00 },
 "74775": { name: "X-ray Exam Of Perineum", wrvu: 0.00 },
 "75557": { name: "Cardiac MRI For Morph", wrvu: 2.29 },
 "75559": { name: "Cardiac MRI With Stress Imaging", wrvu: 2.88 },
 "75561": { name: "Cardiac MRI For Morph With Dye", wrvu: 2.54 },
 "75563": { name: "Card MRI With Stress Imaging & Dye", wrvu: 2.93 },
 "75565": { name: "Card MRI Veloc Flow Mapping", wrvu: 0.24 },
 "75571": { name: "CT Heart Without Dye With Ca Test", wrvu: 0.57 },
 "75572": { name: "CT Heart With 3d Image", wrvu: 1.71 },
 "75573": { name: "CT Heart C+ Strux Cgen Heart Ds", wrvu: 2.49 },
 "75574": { name: "CT Angiography Heart With 3d Image", wrvu: 2.34 },
 "75577": { name: "Quan and char C Athrosclrtc Plaq", wrvu: 0.85 },
 "75580": { name: "N-invas Established C Ffr Sw Aly Cta", wrvu: 0.73 },
 "75600": { name: "Contrast Exam Thoracic Aorta", wrvu: 0.48 },
 "75605": { name: "Contrast Exam Thoracic Aorta", wrvu: 1.11 },
 "75625": { name: "Contrast Exam Abdominl Aorta", wrvu: 1.40 },
 "75630": { name: "X-ray Aorta Leg Arteries", wrvu: 1.95 },
 "75635": { name: "CT Angiography Abdominal Arteries", wrvu: 2.34 },
 "75705": { name: "Artery X-rays Spine", wrvu: 2.13 },
 "75710": { name: "Artery X-rays Arm/leg", wrvu: 1.71 },
 "75716": { name: "Artery X-rays Arms/legs", wrvu: 1.92 },
 "75726": { name: "Artery X-rays Abdomen", wrvu: 2.00 },
 "75731": { name: "Artery X-rays Adrenal Gland", wrvu: 1.11 },
 "75733": { name: "Artery X-rays Adrenals", wrvu: 1.28 },
 "75736": { name: "Artery X-rays Pelvis", wrvu: 1.11 },
 "75741": { name: "Artery X-rays Lung", wrvu: 1.28 },
 "75743": { name: "Artery X-rays Lungs", wrvu: 1.62 },
 "75746": { name: "Artery X-rays Lung", wrvu: 1.11 },
 "75756": { name: "Artery X-rays Chest", wrvu: 1.11 },
 "75774": { name: "Artery X-ray Each Vessel", wrvu: 0.98 },
 "75801": { name: "Lymphatic Vessel X-ray Arm/leg", wrvu: 0.00 },
 "75803": { name: "Lymphatic Vessel X-ray Arms/legs", wrvu: 0.00 },
 "75805": { name: "Lymphatic Vessel X-ray Trunk", wrvu: 0.00 },
 "75807": { name: "Lymphatic Vessel X-ray Trunk", wrvu: 0.00 },
 "75809": { name: "Nonvascular Shunt X-ray", wrvu: 0.46 },
 "75810": { name: "Vein X-ray Spleen/liver", wrvu: 0.00 },
 "75820": { name: "Vein X-ray Arm/leg", wrvu: 1.02 },
 "75822": { name: "Vein X-ray Arms/legs", wrvu: 1.44 },
 "75825": { name: "Vein X-ray Trunk", wrvu: 1.11 },
 "75827": { name: "Vein X-ray Chest", wrvu: 1.11 },
 "75831": { name: "Vein X-ray Kidney", wrvu: 1.11 },
 "75833": { name: "Vein X-ray Kidneys", wrvu: 1.45 },
 "75840": { name: "Vein X-ray Adrenal Gland", wrvu: 1.11 },
 "75860": { name: "Vein X-ray Neck", wrvu: 1.11 },
 "75870": { name: "Vein X-ray Skull", wrvu: 1.11 },
 "75872": { name: "Vein X-ray Skull Epidural", wrvu: 1.11 },
 "75880": { name: "Vein X-ray Eye Socket", wrvu: 0.68 },
 "75885": { name: "Vein X-ray Liver With Hemodynam", wrvu: 1.40 },
 "75887": { name: "Vein X-ray Liver Without Hemodyn", wrvu: 1.40 },
 "75889": { name: "Vein X-ray Liver With Hemodynam", wrvu: 1.11 },
 "75891": { name: "Vein X-ray Liver", wrvu: 1.11 },
 "75893": { name: "Venous Sampling By Catheter", wrvu: 0.53 },
 "75894": { name: "X-rays Transcath Therapy", wrvu: 2.19 },
 "75898": { name: "Follow-up Angiography", wrvu: 1.80 },
 "75901": { name: "Remove Cva Device Obstruct", wrvu: 0.48 },
 "75902": { name: "Remove Cva Lumen Obstruct", wrvu: 0.38 },
 "75970": { name: "Vascular Biopsy", wrvu: 0.00 },
 "75984": { name: "X-ray Control Catheter Change", wrvu: 0.81 },
 "75989": { name: "Abscess Drainage Under X-ray", wrvu: 1.16 },
 "76000": { name: "Fluoroscopy <1 hr Physician/Qualified Health Professional Health Professional", wrvu: 0.30 },
 "76010": { name: "X-ray Nose To Rectum", wrvu: 0.18 },
 "76014": { name: "Mr Sfty Implt&/fb Asmt Stf 1", wrvu: 0.00 },
 "76015": { name: "Mr Sfty Mplt&/fb Asmt Stf Each", wrvu: 0.00 },
 "76016": { name: "Mr Safety Deter Physician/Qualified Health Professional Health Professional", wrvu: 0.59 },
 "76017": { name: "Mr Sfty Medial Physics Xm Cstmz", wrvu: 0.74 },
 "76018": { name: "Mr Safety Implant Elec Prepj", wrvu: 0.73 },
 "76019": { name: "Mr Safety Implt Pos&/immoblj", wrvu: 0.59 },
 "76080": { name: "X-ray Exam Of Fistula", wrvu: 0.53 },
 "76098": { name: "X-ray Exam Surgical Specimen", wrvu: 0.30 },
 "76100": { name: "X-ray Exam Of Body Section", wrvu: 0.57 },
 "76120": { name: "Cine/video X-rays", wrvu: 0.37 },
 "76125": { name: "Cine/video X-rays Add-on", wrvu: 0.00 },
 "76140": { name: "X-ray Consultation", wrvu: 0.00 },
 "76145": { name: "Medial Physic Dos Evaluation Radical Exps", wrvu: 0.00 },
 "76376": { name: "3d Render With Intrp Postproces", wrvu: 0.20 },
 "76377": { name: "3d Render With Intrp Postproces", wrvu: 0.77 },
 "76380": { name: "Cat Scan Follow-up Study", wrvu: 0.96 },
 "76390": { name: "Mr Spectroscopy", wrvu: 0.00 },
 "76391": { name: "Mr Elastography", wrvu: 1.07 },
 "76496": { name: "Unlisted Fluoroscopic Procedure", wrvu: 0.00 },
 "76497": { name: "Unlisted CT Procedure", wrvu: 0.00 },
 "76498": { name: "Unlisted Mr Procedure", wrvu: 0.00 },
 "76499": { name: "Unlisted Diagnosis Radiographic Procedure", wrvu: 0.00 },
 "76506": { name: "Echocardiographic Exam Of Head", wrvu: 0.61 },
 "76510": { name: "Oph Ultrasound Diagnosis B-scan and quan A-scan", wrvu: 0.68 },
 "76511": { name: "Oph Ultrasound Diagnosis Quan A-scan Only", wrvu: 0.62 },
 "76512": { name: "Oph Ultrasound Diagnosis B-scan", wrvu: 0.55 },
 "76513": { name: "Oph Ultrasound Diagnosis Anterior Sgm Ultrasound Uni/bi", wrvu: 0.59 },
 "76514": { name: "Echocardiographic Exam Of Eye Thickness", wrvu: 0.14 },
 "76516": { name: "Echocardiographic Exam Of Eye", wrvu: 0.39 },
 "76519": { name: "Echocardiographic Exam Of Eye", wrvu: 0.53 },
 "76529": { name: "Echocardiographic Exam Of Eye", wrvu: 0.56 },
 "76536": { name: "Ultrasound Exam Of Head And Neck", wrvu: 0.55 },
 "76604": { name: "Ultrasound Exam Chest", wrvu: 0.58 },
 "76641": { name: "Ultrasound Breast Complete", wrvu: 0.71 },
 "76642": { name: "Ultrasound Breast Limited", wrvu: 0.66 },
 "76700": { name: "Ultrasound Exam Abdominal Complete", wrvu: 0.79 },
 "76705": { name: "Echocardiographic Exam Of Abdomen", wrvu: 0.58 },
 "76706": { name: "Ultrasound Abdominal Aorta Screen Aaa", wrvu: 0.54 },
 "76770": { name: "Ultrasound Exam Abdo Back Wall Comp", wrvu: 0.72 },
 "76775": { name: "Ultrasound Exam Abdo Back Wall Lim", wrvu: 0.57 },
 "76776": { name: "Ultrasound Exam K Transpl With Doppler", wrvu: 0.74 },
 "76800": { name: "Ultrasound Exam Spinal Canal", wrvu: 1.10 },
 "76801": { name: "Ob Ultrasound < 14 Weeks Single Fetus", wrvu: 0.97 },
 "76802": { name: "Ob Ultrasound < 14 Weeks Additional Fetus", wrvu: 0.81 },
 "76805": { name: "Ob Ultrasound >/= 14 Weeks Sngl Fetus", wrvu: 0.97 },
 "76810": { name: "Ob Ultrasound >/= 14 Weeks Additional Fetus", wrvu: 0.96 },
 "76811": { name: "Ob Ultrasound Detailed Sngl Fetus", wrvu: 1.85 },
 "76812": { name: "Ob Ultrasound Detailed Additional Fetus", wrvu: 1.74 },
 "76813": { name: "Ob Ultrasound Nuchal Meas 1 Gest", wrvu: 1.15 },
 "76814": { name: "Ob Ultrasound Nuchal Meas Add-on", wrvu: 0.97 },
 "76815": { name: "Ob Ultrasound Limited Fetus(s)", wrvu: 0.63 },
 "76816": { name: "Ob Ultrasound Follow-up Per Fetus", wrvu: 0.83 },
 "76817": { name: "Transvaginal Ultrasound Obstetric", wrvu: 0.73 },
 "76818": { name: "Fetal Biophys Profile With Nst", wrvu: 1.02 },
 "76819": { name: "Fetal Biophys Profil Without Nst", wrvu: 0.75 },
 "76820": { name: "Umbilical Artery Echocardiographic", wrvu: 0.49 },
 "76821": { name: "Middle Cerebral Artery Echocardiographic", wrvu: 0.68 },
 "76825": { name: "Echocardiographic Exam Of Fetal Heart", wrvu: 1.63 },
 "76826": { name: "Echocardiographic Exam Of Fetal Heart", wrvu: 0.81 },
 "76827": { name: "Echocardiographic Exam Of Fetal Heart", wrvu: 0.57 },
 "76828": { name: "Echocardiographic Exam Of Fetal Heart", wrvu: 0.55 },
 "76830": { name: "Transvaginal Ultrasound Non-ob", wrvu: 0.67 },
 "76831": { name: "Echocardiographic Exam Uterus", wrvu: 0.70 },
 "76856": { name: "Ultrasound Exam Pelvic Complete", wrvu: 0.67 },
 "76857": { name: "Ultrasound Exam Pelvic Limited", wrvu: 0.49 },
 "76870": { name: "Ultrasound Exam Scrotum", wrvu: 0.62 },
 "76872": { name: "Ultrasound Transrectal", wrvu: 0.65 },
 "76873": { name: "Echograp Trans R Pros Study", wrvu: 1.51 },
 "76881": { name: "Ultrasound Compl Joint R-t With Imaging", wrvu: 0.88 },
 "76882": { name: "Ultrasound Lmtd Joint/facial Evl Nvasc Xtr", wrvu: 0.67 },
 "76883": { name: "Ultrasound Nerve and acc Strux 1xtr Compre", wrvu: 1.18 },
 "76885": { name: "Ultrasound Exam Infant Hips Dynamic", wrvu: 0.72 },
 "76886": { name: "Ultrasound Exam Infant Hips Static", wrvu: 0.60 },
 "76932": { name: "Echocardiographic Guide For Heart Biopsy", wrvu: 0.00 },
 "76936": { name: "Echocardiographic Guide For Artery Repair", wrvu: 1.94 },
 "76937": { name: "Ultrasound Guide Vascular Access", wrvu: 0.29 },
 "76940": { name: "Ultrasound Guide Tissue Ablation", wrvu: 0.00 },
 "76941": { name: "Echocardiographic Guide For Transfusion", wrvu: 0.00 },
 "76942": { name: "Echocardiographic Guide For Biopsy", wrvu: 0.65 },
 "76945": { name: "Echocardiographic Guide Villus Sampling", wrvu: 0.00 },
 "76946": { name: "Echocardiographic Guide For Amniocentesis", wrvu: 0.37 },
 "76948": { name: "Echocardiographic Guide Ova Aspiration", wrvu: 0.65 },
 "76965": { name: "Echocardiographic Guidance Radiotherapy", wrvu: 1.31 },
 "76975": { name: "Gastrointestinal Endoscopic Ultrasound", wrvu: 0.00 },
 "76977": { name: "Ultrasound Bone Density Measure", wrvu: 0.05 },
 "76978": { name: "Ultrasound Trgt Dyn Mbubb 1st Lesion", wrvu: 1.58 },
 "76979": { name: "Ultrasound Trgt Dyn Mbubb Each Additional", wrvu: 0.83 },
 "76981": { name: "Use Parenchyma", wrvu: 0.58 },
 "76982": { name: "Use 1st Target Lesion", wrvu: 0.58 },
 "76983": { name: "Use Each Additional Target Lesion", wrvu: 0.46 },
 "76984": { name: "Diagnosis Intraop Thoracic Aorta Ultrasound", wrvu: 0.00 },
 "76987": { name: "Diagnosis Intraop Epicar Car Ultrasound Chd", wrvu: 0.00 },
 "76988": { name: "Diagnosis Ntrop Epcr Ultrasound Chd Imaging Acq", wrvu: 0.00 },
 "76989": { name: "Diagnosis Intraop Epcar Ultrasound Chd I and r", wrvu: 0.00 },
 "76998": { name: "Ultrasound Guide Intraop", wrvu: 0.00 },
 "76999": { name: "Echocardiographic Examination Procedure", wrvu: 0.00 },
 "77001": { name: "Fluoroguide For Vein Device", wrvu: 0.37 },
 "77002": { name: "Needle Localization By X-ray", wrvu: 0.53 },
 "77003": { name: "Fluoroguide For Spine Inject", wrvu: 0.59 },
 "77011": { name: "CT Scan For Localization", wrvu: 1.18 },
 "77012": { name: "CT Scan For Needle Biopsy", wrvu: 1.46 },
 "77013": { name: "CT Guide For Tissue Ablation", wrvu: 0.00 },
 "77021": { name: "MRI Guidance Needle Placement Rs and i", wrvu: 1.46 },
 "77022": { name: "MRI Guidance Parnchyma Tiss Abltj", wrvu: 0.00 },
 "77046": { name: "MRI Breast C- Unilateral", wrvu: 1.41 },
 "77047": { name: "MRI Breast C- Bilateral", wrvu: 1.56 },
 "77048": { name: "MRI Breast C-+ With Cad Uni", wrvu: 2.05 },
 "77049": { name: "MRI Breast C-+ With Cad Bi", wrvu: 2.24 },
 "77053": { name: "X-ray Of Mammary Duct", wrvu: 0.35 },
 "77054": { name: "X-ray Of Mammary Ducts", wrvu: 0.44 },
 "77061": { name: "Breast Tomosynthesis Uni", wrvu: 0.00 },
 "77062": { name: "Breast Tomosynthesis Bi", wrvu: 0.00 },
 "77063": { name: "Breast Tomosynthesis Bi", wrvu: 0.59 },
 "77065": { name: "Diagnosis Mammo Incl Cad Uni", wrvu: 0.79 },
 "77066": { name: "Diagnosis Mammo Incl Cad Bi", wrvu: 0.98 },
 "77067": { name: "Scr Mammo Bi Incl Cad", wrvu: 0.74 },
 "77071": { name: "Mnl Application Strs Joint Radiography", wrvu: 0.40 },
 "77072": { name: "Bone Age Studies", wrvu: 0.19 },
 "77073": { name: "Bone Length Studies", wrvu: 0.25 },
 "77074": { name: "Radex Osseous Survey Lmtd", wrvu: 0.43 },
 "77075": { name: "Radex Osseous Survey Compl", wrvu: 0.54 },
 "77076": { name: "Radex Osseous Survey Infant", wrvu: 0.68 },
 "77077": { name: "Joint Survey Single View", wrvu: 0.32 },
 "77078": { name: "CT Bone Density Axial", wrvu: 0.24 },
 "77080": { name: "Dxa Bone Density Axial", wrvu: 0.20 },
 "77081": { name: "Dxa Bone Density Appendiculr", wrvu: 0.20 },
 "77084": { name: "MRI Bone Marrow Blood Supply", wrvu: 1.56 },
 "77085": { name: "Dxa Bone Density Axillary Vrt Fracture", wrvu: 0.29 },
 "77086": { name: "Vrt Fracture Assmt Via Dxa", wrvu: 0.17 },
 "77089": { name: "Tbs Dxa Cal With I and r Fracture Risk", wrvu: 0.20 },
 "77090": { name: "Tbs Techl Prep and transmis Data", wrvu: 0.00 },
 "77091": { name: "Tbs Techl Calculation Only", wrvu: 0.00 },
 "77092": { name: "Tbs I and r Fracture Rsk Qualified Health Professional", wrvu: 0.20 },
 "77261": { name: "Therapeutic Radiology Treatment Plng Simple", wrvu: 1.27 },
 "77262": { name: "Therapeutic Radiology Treatment Plng Intrm", wrvu: 1.95 },
 "77263": { name: "Therapeutic Radiology Treatment Plng Cplx", wrvu: 3.06 },
 "77280": { name: "Therapeutic Radical Simulaj Field Simple", wrvu: 0.68 },
 "77285": { name: "Therapeutic Radical Simulaj Field Intrm", wrvu: 1.02 },
 "77290": { name: "Therapeutic Radical Simulaj Field Cplx", wrvu: 1.52 },
 "77293": { name: "Respirator Motion Management Simul", wrvu: 1.95 },
 "77295": { name: "3-d Radiotherapy Plan", wrvu: 4.18 },
 "77299": { name: "Unlisted Procedure Therapeutic Radical Treatment Plng", wrvu: 0.00 },
 "77300": { name: "Radiation Therapy Dose Plan", wrvu: 0.60 },
 "77301": { name: "Radiotherapy Dose Plan Intensity-Modulated Radiation Therapy", wrvu: 7.79 },
 "77306": { name: "Telethx Isodose Plan Simple", wrvu: 1.37 },
 "77307": { name: "Telethx Isodose Plan Cplx", wrvu: 2.83 },
 "77316": { name: "Brachytx Isodose Plan Simple", wrvu: 1.37 },
 "77317": { name: "Brachytx Isodose Intermed", wrvu: 1.78 },
 "77318": { name: "Brachytx Isodose Complex", wrvu: 2.83 },
 "77321": { name: "Special Teletx Port Plan", wrvu: 0.93 },
 "77331": { name: "Special Radiation Dosimetry", wrvu: 0.85 },
 "77332": { name: "Radiation Treatment Aid(s)", wrvu: 0.44 },
 "77333": { name: "Radiation Treatment Aid(s)", wrvu: 0.73 },
 "77334": { name: "Radiation Treatment Aid(s)", wrvu: 1.12 },
 "77336": { name: "Radiation Physics Consult", wrvu: 0.00 },
 "77338": { name: "Design Mlc Device For Intensity-Modulated Radiation Therapy", wrvu: 4.18 },
 "77370": { name: "Radiation Physics Consult", wrvu: 0.00 },
 "77371": { name: "Stereotactic Radiosurgery Multisource", wrvu: 0.00 },
 "77372": { name: "Stereotactic Radiosurgery Linear Based", wrvu: 0.00 },
 "77373": { name: "Strtctc Bdy Radical Therapeutic Treatment Dlvr", wrvu: 0.00 },
 "77387": { name: "Guidance For Radj Treatment Dlvr", wrvu: 0.68 },
 "77399": { name: "Unlisted Procedure Medial Radj Physics", wrvu: 0.00 },
 "77402": { name: "Radiation Treatment Delivery Lvl 1", wrvu: 0.00 },
 "77407": { name: "Radiation Treatment Delivery Lvl 2", wrvu: 0.00 },
 "77412": { name: "Radiation Treatment Delivery Lvl 3", wrvu: 0.00 },
 "77417": { name: "Therapeutic Radiology Port Image(s)", wrvu: 0.00 },
 "77423": { name: "Neutron Beam Treatment Complex", wrvu: 0.00 },
 "77424": { name: "Io Radical Treatment Delivery By X-ray", wrvu: 0.00 },
 "77425": { name: "Io Radical Treatment Deliver By Elctrns", wrvu: 0.00 },
 "77427": { name: "Radiation Treatment Management X5", wrvu: 3.37 },
 "77431": { name: "Radiation Therapy Management", wrvu: 1.76 },
 "77432": { name: "Stereotactic Radiation Trmt", wrvu: 7.72 },
 "77435": { name: "Stereotactic Body Radiation Therapy Management", wrvu: 11.57 },
 "77436": { name: "Surf Radj Therapeutic Treatment Planning", wrvu: 0.77 },
 "77437": { name: "Surf Radj Therapeutic Supfc<=150kv", wrvu: 0.00 },
 "77438": { name: "Surf Radical Thr Orthvlt>150-500", wrvu: 0.00 },
 "77439": { name: "Surf Radical Thr Imaging Guidance Ultrasound Placement", wrvu: 0.30 },
 "77469": { name: "Io Radiation Treatment Management", wrvu: 5.61 },
 "77470": { name: "Special Radiation Treatment", wrvu: 1.98 },
 "77499": { name: "Unlisted Procedure Therapeutic Radical Treatment Management", wrvu: 0.00 },
 "77520": { name: "Proton Trmt Simple Without Comp", wrvu: 0.00 },
 "77522": { name: "Proton Trmt Simple With Comp", wrvu: 0.00 },
 "77523": { name: "Proton Trmt Intermediate", wrvu: 0.00 },
 "77525": { name: "Proton Treatment Complex", wrvu: 0.00 },
 "77600": { name: "Hyperthermia External Genital Supfc", wrvu: 1.28 },
 "77605": { name: "Hyperthermia External Genital Deep", wrvu: 1.79 },
 "77610": { name: "Hyperthermia Ntrstl Prb 5/<", wrvu: 1.28 },
 "77615": { name: "Hyperthermia Ntrstl Prb>5", wrvu: 1.79 },
 "77620": { name: "Hyperthermia Genital Intrcv Prb", wrvu: 1.52 },
 "77750": { name: "Infuse Radioactive Materials", wrvu: 4.88 },
 "77761": { name: "Apply Intrcav Radiat Simple", wrvu: 3.75 },
 "77762": { name: "Apply Intrcav Radiat Interm", wrvu: 5.62 },
 "77763": { name: "Apply Intrcav Radiat Compl", wrvu: 8.44 },
 "77767": { name: "Hdr Rdncl Skin Surf Brachytx", wrvu: 1.02 },
 "77768": { name: "Hdr Rdncl Skin Surf Brachytx", wrvu: 1.37 },
 "77770": { name: "Hdr Rdncl Ntrstl/icav Brchtx", wrvu: 1.90 },
 "77771": { name: "Hdr Rdncl Ntrstl/icav Brchtx", wrvu: 3.71 },
 "77772": { name: "Hdr Rdncl Ntrstl/icav Brchtx", wrvu: 5.27 },
 "77778": { name: "Apply Interstit Radiat Compl", wrvu: 8.56 },
 "77789": { name: "Apply Surf Ldr Radionuclide", wrvu: 1.11 },
 "77790": { name: "Radiation Handling", wrvu: 0.00 },
 "77799": { name: "Unlisted Procedure Clin Brachytx", wrvu: 0.00 },
 "78012": { name: "Thyroid Uptake Measurement", wrvu: 0.19 },
 "78013": { name: "Thyroid Imaging With Blood Flow", wrvu: 0.36 },
 "78014": { name: "Thyroid Imaging With Blood Flow", wrvu: 0.49 },
 "78015": { name: "Thyroid Met Imaging", wrvu: 0.65 },
 "78016": { name: "Thyroid Met Imaging/studies", wrvu: 0.80 },
 "78018": { name: "Thyroid Met Imaging Body", wrvu: 0.84 },
 "78020": { name: "Thyroid Met Uptake", wrvu: 0.59 },
 "78070": { name: "Parathyroid Planar Imaging", wrvu: 0.78 },
 "78071": { name: "Parathyrd Planar With without Subtrj", wrvu: 1.17 },
 "78072": { name: "Parathyrd Planar With SPECT Scan and ct", wrvu: 1.56 },
 "78075": { name: "Adrenal Cortex & Medulla Imaging", wrvu: 0.72 },
 "78099": { name: "Unlisted Endocrine Procedure Diagnosis Nuclear", wrvu: 0.00 },
 "78102": { name: "Bone Marrow Imaging Ltd", wrvu: 0.54 },
 "78103": { name: "Bone Marrow Imaging Mult", wrvu: 0.73 },
 "78104": { name: "Bone Marrow Imaging Body", wrvu: 0.78 },
 "78110": { name: "Plasma Volume Single", wrvu: 0.19 },
 "78111": { name: "Plasma Volume Multiple", wrvu: 0.21 },
 "78120": { name: "Reduction Cell Mass Single", wrvu: 0.22 },
 "78121": { name: "Reduction Cell Mass Multiple", wrvu: 0.31 },
 "78122": { name: "Whl Bld Volume Determination", wrvu: 0.44 },
 "78130": { name: "Reduction Cell Survival Study", wrvu: 0.59 },
 "78140": { name: "Reduction Cell Sequestration", wrvu: 0.59 },
 "78185": { name: "Spleen Imaging", wrvu: 0.39 },
 "78191": { name: "Platelet Survival Study", wrvu: 0.59 },
 "78195": { name: "Lymphatic System Imaging", wrvu: 1.17 },
 "78199": { name: "Unlstd Hematop Ret/endoscopic Lymp", wrvu: 0.00 },
 "78201": { name: "Liver Imaging Static Only", wrvu: 0.43 },
 "78202": { name: "Liver Imaging With Vasc Flow", wrvu: 0.50 },
 "78215": { name: "Liver and spleen Imaging Static Only", wrvu: 0.48 },
 "78216": { name: "Liver and spleen Imaging With Vasc Flow", wrvu: 0.56 },
 "78226": { name: "Hepatobiliary System Imaging", wrvu: 0.72 },
 "78227": { name: "Hepatobil Syst Image With Drug", wrvu: 0.88 },
 "78230": { name: "Salivary Gland Imaging", wrvu: 0.44 },
 "78231": { name: "Salivary Glnd Imaging Serial Imaging", wrvu: 0.51 },
 "78232": { name: "Salivary Gland Function STD", wrvu: 0.46 },
 "78258": { name: "Esophageal Motility", wrvu: 0.72 },
 "78261": { name: "Gastric Mucosa Imaging", wrvu: 0.67 },
 "78262": { name: "Gastroesophageal Reflux STD", wrvu: 0.66 },
 "78264": { name: "Gastric Emptying Imaging Study", wrvu: 0.77 },
 "78265": { name: "Gastric Emptg Imaging Sm Bwl Trnst", wrvu: 0.96 },
 "78266": { name: "Gastric Empt Imaging Sm Bwl and colon", wrvu: 1.05 },
 "78267": { name: "Urea Breath Tst C-14 Acquisj", wrvu: 0.00 },
 "78268": { name: "Urea Breath Test C-14 Alys", wrvu: 0.00 },
 "78278": { name: "Acute Gastrointestinal Blood Loss Imaging", wrvu: 0.97 },
 "78282": { name: "Gastrointestinal Protein Loss", wrvu: 0.00 },
 "78290": { name: "Intestine Imaging", wrvu: 0.66 },
 "78291": { name: "Pertl-ven Shunt Patency Test", wrvu: 0.86 },
 "78299": { name: "Unlisted Gastrointestinal Procedure Diagnosis Nuclear Medial", wrvu: 0.00 },
 "78300": { name: "Bone Imaging Limited Area", wrvu: 0.60 },
 "78305": { name: "Bone Imaging Multiple Areas", wrvu: 0.81 },
 "78306": { name: "Bone Imaging Whole Body", wrvu: 0.84 },
 "78315": { name: "Bone Imaging 3 Phase", wrvu: 0.99 },
 "78350": { name: "Bone Mineral Single Photon", wrvu: 0.21 },
 "78351": { name: "Bone Mineral Dual Photon", wrvu: 0.29 },
 "78399": { name: "Unlisted Muscskel Procedure Diagnosis Nuclear", wrvu: 0.00 },
 "78414": { name: "Non-imaging Heart Function", wrvu: 0.00 },
 "78428": { name: "Cardiac Shunt Imaging", wrvu: 0.76 },
 "78429": { name: "Myocrd Imaging PET Scan 1 STD With CT", wrvu: 0.00 },
 "78430": { name: "Myocrd Imaging PET Scan Rst/strs With CT", wrvu: 0.00 },
 "78431": { name: "Myocrd Imaging PET Scan Rst and strs CT", wrvu: 0.00 },
 "78432": { name: "Myocrd Imaging PET Scan 2rtracer", wrvu: 0.00 },
 "78433": { name: "Myocrd Imaging PET Scan 2rtracer CT", wrvu: 0.00 },
 "78434": { name: "Aqmbf PET Scan Rest & Prescription Stress", wrvu: 0.00 },
 "78445": { name: "Vascular Flow Imaging", wrvu: 0.48 },
 "78451": { name: "Ht Muscle Image SPECT Scan Sing", wrvu: 1.35 },
 "78452": { name: "Ht Muscle Image SPECT Scan Mult", wrvu: 1.58 },
 "78453": { name: "Ht Muscle Image Planar Sing", wrvu: 0.98 },
 "78454": { name: "Ht Muscle Image Planar Mult", wrvu: 1.31 },
 "78456": { name: "Acute Venous Thrombus Image", wrvu: 0.98 },
 "78457": { name: "Venous Thrombosis Imaging", wrvu: 0.75 },
 "78458": { name: "Ven Thrombosis Images Bilateral", wrvu: 0.88 },
 "78459": { name: "Myocrd Imaging PET Scan Single Study", wrvu: 0.00 },
 "78466": { name: "Heart Infarct Image", wrvu: 0.67 },
 "78468": { name: "Heart Infarct Image (ef)", wrvu: 0.78 },
 "78469": { name: "Heart Infarct Image (3d)", wrvu: 0.90 },
 "78472": { name: "Gated Heart Planar Single", wrvu: 0.96 },
 "78473": { name: "Gated Heart Multiple", wrvu: 1.43 },
 "78481": { name: "Heart First Pass Single", wrvu: 0.96 },
 "78483": { name: "Heart First Pass Multiple", wrvu: 1.43 },
 "78491": { name: "Myocrd Imaging PET Scan STD Rst/strs", wrvu: 0.00 },
 "78492": { name: "Myocrd Imaging PET Scan Mlt Rst and strs", wrvu: 0.00 },
 "78494": { name: "Heart Image SPECT Scan", wrvu: 1.16 },
 "78496": { name: "Heart First Pass Add-on", wrvu: 0.49 },
 "78499": { name: "Unlisted Cv Procedure Diagnosis Nuclear Medial", wrvu: 0.00 },
 "78579": { name: "Lung Ventilation Imaging", wrvu: 0.48 },
 "78580": { name: "Lung Perfusion Imaging", wrvu: 0.72 },
 "78582": { name: "Lung Ventilat and perfus Imaging", wrvu: 1.04 },
 "78597": { name: "Lung Perfusion Differential", wrvu: 0.73 },
 "78598": { name: "Lung Perf and ventilat Diferentl", wrvu: 0.83 },
 "78599": { name: "Unlisted Resp Procedure Diagnosis Nuclear Medial", wrvu: 0.00 },
 "78600": { name: "Brain Image < 4 Views", wrvu: 0.43 },
 "78601": { name: "Brain Image With Flow < 4 Views", wrvu: 0.50 },
 "78605": { name: "Brain Image 4+ Views", wrvu: 0.52 },
 "78606": { name: "Brain Image With Flow 4 + Views", wrvu: 0.62 },
 "78608": { name: "Brain Imaging PET", wrvu: 0.00 },
 "78609": { name: "Brain Imaging PET", wrvu: 1.46 },
 "78610": { name: "Brain Flow Imaging Only", wrvu: 0.29 },
 "78630": { name: "Cerebrospinal Fluid Scan", wrvu: 0.66 },
 "78635": { name: "Cerebrospinal Fluid Ventriculography", wrvu: 0.59 },
 "78645": { name: "Cerebrospinal Fluid Shunt Evaluation", wrvu: 0.56 },
 "78650": { name: "Cerebrospinal Fluid Leakage Imaging", wrvu: 0.59 },
 "78660": { name: "Nuclear Exam Of Tear Flow", wrvu: 0.52 },
 "78699": { name: "Unlisted Nrvs System Procedure Diagnosis Nuclear", wrvu: 0.00 },
 "78700": { name: "Kidney Imaging Morphol", wrvu: 0.44 },
 "78701": { name: "Kidney Imaging With Flow", wrvu: 0.48 },
 "78707": { name: "K Flow/funct Image Without Drug", wrvu: 0.94 },
 "78708": { name: "K Flow/funct Image With Drug", wrvu: 1.18 },
 "78709": { name: "K Flow/funct Image Multiple", wrvu: 1.37 },
 "78725": { name: "Kidney Function Study", wrvu: 0.37 },
 "78730": { name: "Urinary Bladder Retention", wrvu: 0.15 },
 "78740": { name: "Ureteral Reflux Study", wrvu: 0.56 },
 "78761": { name: "Testicular Imaging With Flow", wrvu: 0.69 },
 "78799": { name: "Unlisted Gu Procedure Diagnosis Nuclear Medial", wrvu: 0.00 },
 "78800": { name: "Rp Localization Tumor 1 Area 1 D Imaging", wrvu: 0.62 },
 "78801": { name: "Rp Localization Tumor 2+area 1+d Imaging", wrvu: 0.71 },
 "78802": { name: "Rp Localization Tumor Whbdy 1 D Imaging", wrvu: 0.78 },
 "78803": { name: "Rp Localization Tumor SPECT Scan 1 Area", wrvu: 1.06 },
 "78804": { name: "Rp Localization Tumor Whbdy 2+d Imaging", wrvu: 0.98 },
 "78808": { name: "Intravenous Injection Ra Drug Diagnosis Study", wrvu: 0.18 },
 "78811": { name: "PET Scan Image Ltd Area", wrvu: 0.00 },
 "78812": { name: "PET Scan Image Skull-thigh", wrvu: 0.00 },
 "78813": { name: "PET Scan Image Full Body", wrvu: 0.00 },
 "78814": { name: "PET Scan Image With CT Lmtd", wrvu: 0.00 },
 "78815": { name: "PET Scan Image With CT Skull-thigh", wrvu: 0.00 },
 "78816": { name: "PET Scan Image With CT Full Body", wrvu: 0.00 },
 "78830": { name: "Rp Localization Tumor SPECT Scan With CT 1", wrvu: 1.45 },
 "78831": { name: "Rp Localization Tumor SPECT Scan 2 Areas", wrvu: 1.77 },
 "78832": { name: "Rp Localization Tumor SPECT Scan With CT 2", wrvu: 2.07 },
 "78835": { name: "Rp Quan Meas Single Area", wrvu: 0.46 },
 "78999": { name: "Unlisted Misc Procedure Diagnosis Nuclear Medial", wrvu: 0.00 },
 "79005": { name: "Nuclear Prescription Oral Administration", wrvu: 1.76 },
 "79101": { name: "Nuclear Prescription Intravenous Administration", wrvu: 1.91 },
 "79200": { name: "Nuclear Prescription Intracavitary Administration", wrvu: 1.94 },
 "79300": { name: "Nuclear Prescription Interstit Colloid", wrvu: 0.00 },
 "79403": { name: "Hematopoietic Nuclear Treatment", wrvu: 2.19 },
 "79440": { name: "Nuclear Prescription Intra-articular", wrvu: 1.94 },
 "79445": { name: "Nuclear Prescription Intra-arterial", wrvu: 0.00 },
 "79999": { name: "Rp Therapy Unlisted Procedure", wrvu: 0.00 },
 "80047": { name: "Basic Metablc Panel Ionized Ca", wrvu: 0.00 },
 "80048": { name: "Basic Metabolic Panel Total Ca", wrvu: 0.00 },
 "80050": { name: "General Health Panel", wrvu: 0.00 },
 "80051": { name: "Electrolyte Panel", wrvu: 0.00 },
 "80053": { name: "Comprehensive Metabolic Panel", wrvu: 0.00 },
 "80055": { name: "Obstetric Panel", wrvu: 0.00 },
 "80061": { name: "Lipid Panel", wrvu: 0.00 },
 "80069": { name: "Renal Function Panel", wrvu: 0.00 },
 "80074": { name: "Acute Hepatitis Panel", wrvu: 0.00 },
 "80076": { name: "Hepatectomy Function Panel", wrvu: 0.00 },
 "80081": { name: "Obstetric Panel Inc HIV Tstg", wrvu: 0.00 },
 "80143": { name: "Drug Assay Acetaminophen", wrvu: 0.00 },
 "80145": { name: "Drug Assay Adalimumab", wrvu: 0.00 },
 "80150": { name: "Assay Of Amikacin", wrvu: 0.00 },
 "80151": { name: "Drug Assay Amiodarone", wrvu: 0.00 },
 "80155": { name: "Drug Assay Caffeine", wrvu: 0.00 },
 "80156": { name: "Assay Carbamazepine Total", wrvu: 0.00 },
 "80157": { name: "Assay Carbamazepine Free", wrvu: 0.00 },
 "80158": { name: "Drug Assay Cyclosporine", wrvu: 0.00 },
 "80159": { name: "Drug Assay Clozapine", wrvu: 0.00 },
 "80161": { name: "Asy Carbamazepin 10,11-epxid", wrvu: 0.00 },
 "80162": { name: "Assay Of Digoxin Total", wrvu: 0.00 },
 "80163": { name: "Assay Of Digoxin Free", wrvu: 0.00 },
 "80164": { name: "Assay Dipropylacetic Acd Tot", wrvu: 0.00 },
 "80165": { name: "Dipropylacetic Acid Free", wrvu: 0.00 },
 "80167": { name: "Drug Assay Felbamate", wrvu: 0.00 },
 "80168": { name: "Assay Of Ethosuximide", wrvu: 0.00 },
 "80169": { name: "Drug Assay Everolimus", wrvu: 0.00 },
 "80170": { name: "Assay Of Gentamicin", wrvu: 0.00 },
 "80171": { name: "Drug Screen Quant Gabapentin", wrvu: 0.00 },
 "80173": { name: "Assay Of Haloperidol", wrvu: 0.00 },
 "80175": { name: "Drug Screen Quan Lamotrigine", wrvu: 0.00 },
 "80176": { name: "Assay Of Lidocaine", wrvu: 0.00 },
 "80177": { name: "Drug Scrn Quan Levetiracetam", wrvu: 0.00 },
 "80178": { name: "Assay Of Lithium", wrvu: 0.00 },
 "80179": { name: "Drug Assay Salicylate", wrvu: 0.00 },
 "80180": { name: "Drug Scrn Quan Mycophenolate", wrvu: 0.00 },
 "80181": { name: "Drug Assay Flecainide", wrvu: 0.00 },
 "80183": { name: "Drug Scrn Quant Oxcarbazepin", wrvu: 0.00 },
 "80184": { name: "Assay Of Phenobarbital", wrvu: 0.00 },
 "80185": { name: "Assay Of Phenytoin Total", wrvu: 0.00 },
 "80186": { name: "Assay Of Phenytoin Free", wrvu: 0.00 },
 "80187": { name: "Drug Assay Posaconazole", wrvu: 0.00 },
 "80188": { name: "Assay Of Primidone", wrvu: 0.00 },
 "80189": { name: "Drug Assay Itraconazole", wrvu: 0.00 },
 "80190": { name: "Assay Of Procainamide", wrvu: 0.00 },
 "80192": { name: "Assay Of Procainamide", wrvu: 0.00 },
 "80193": { name: "Drug Assay Leflunomide", wrvu: 0.00 },
 "80194": { name: "Assay Of Quinidine", wrvu: 0.00 },
 "80195": { name: "Assay Of Sirolimus", wrvu: 0.00 },
 "80197": { name: "Assay Of Tacrolimus", wrvu: 0.00 },
 "80198": { name: "Assay Of Theophylline", wrvu: 0.00 },
 "80199": { name: "Drug Screen Quant Tiagabine", wrvu: 0.00 },
 "80200": { name: "Assay Of Tobramycin", wrvu: 0.00 },
 "80201": { name: "Assay Of Topiramate", wrvu: 0.00 },
 "80202": { name: "Assay Of Vancomycin", wrvu: 0.00 },
 "80203": { name: "Drug Screen Quant Zonisamide", wrvu: 0.00 },
 "80204": { name: "Drug Assay Methotrexate", wrvu: 0.00 },
 "80210": { name: "Drug Assay Rufinamide", wrvu: 0.00 },
 "80220": { name: "Drug Asy Hydroxychloroquine", wrvu: 0.00 },
 "80230": { name: "Drug Assay Infliximab", wrvu: 0.00 },
 "80235": { name: "Drug Assay Lacosamide", wrvu: 0.00 },
 "80280": { name: "Drug Assay Vedolizumab", wrvu: 0.00 },
 "80285": { name: "Drug Assay Voriconazole", wrvu: 0.00 },
 "80299": { name: "Quantitative Assay Drug", wrvu: 0.00 },
 "80305": { name: "Drug Test Prsmv Dir Opt Obs", wrvu: 0.00 },
 "80306": { name: "Drug Test Prsmv Instrmnt", wrvu: 0.00 },
 "80307": { name: "Drug Test Prsmv Chem Anlyzr", wrvu: 0.00 },
 "80320": { name: "Drug Screen Quantalcohols", wrvu: 0.00 },
 "80321": { name: "Alcohols Biomarkers 1or 2", wrvu: 0.00 },
 "80322": { name: "Alcohols Biomarkers 3/more", wrvu: 0.00 },
 "80323": { name: "Alkaloids Not Otherwise Specified", wrvu: 0.00 },
 "80324": { name: "Drug Screen Amphetamines 1/2", wrvu: 0.00 },
 "80325": { name: "Amphetamines 3or 4", wrvu: 0.00 },
 "80326": { name: "Amphetamines 5 Or More", wrvu: 0.00 },
 "80327": { name: "Anabolic Steroid 1 Or 2", wrvu: 0.00 },
 "80328": { name: "Anabolic Steroid 3 Or More", wrvu: 0.00 },
 "80329": { name: "Analgesics Non-opioid 1 Or 2", wrvu: 0.00 },
 "80330": { name: "Analgesics Non-opioid 3-5", wrvu: 0.00 },
 "80331": { name: "Analgesics Non-opioid 6/more", wrvu: 0.00 },
 "80332": { name: "Antidepressants Class 1 Or 2", wrvu: 0.00 },
 "80333": { name: "Antidepressants Class 3-5", wrvu: 0.00 },
 "80334": { name: "Antidepressants Class 6/more", wrvu: 0.00 },
 "80335": { name: "Antidepressant Tricyclic 1/2", wrvu: 0.00 },
 "80336": { name: "Antidepressant Tricyclic 3-5", wrvu: 0.00 },
 "80337": { name: "Tricyclic & Cyclicals 6/more", wrvu: 0.00 },
 "80338": { name: "Antidepressant Not Specified", wrvu: 0.00 },
 "80339": { name: "Antiepileptics Not Otherwise Specified 1-3", wrvu: 0.00 },
 "80340": { name: "Antiepileptics Not Otherwise Specified 4-6", wrvu: 0.00 },
 "80341": { name: "Antiepileptics Not Otherwise Specified 7/more", wrvu: 0.00 },
 "80342": { name: "Antipsychotics Not Otherwise Specified 1-3", wrvu: 0.00 },
 "80343": { name: "Antipsychotics Not Otherwise Specified 4-6", wrvu: 0.00 },
 "80344": { name: "Antipsychotics Not Otherwise Specified 7/more", wrvu: 0.00 },
 "80345": { name: "Drug Screening Barbiturates", wrvu: 0.00 },
 "80346": { name: "Benzodiazepines1-12", wrvu: 0.00 },
 "80347": { name: "Benzodiazepines 13 Or More", wrvu: 0.00 },
 "80348": { name: "Drug Screening Buprenorphine", wrvu: 0.00 },
 "80349": { name: "Cannabinoids Natural", wrvu: 0.00 },
 "80350": { name: "Cannabinoids Synthetic 1-3", wrvu: 0.00 },
 "80351": { name: "Cannabinoids Synthetic 4-6", wrvu: 0.00 },
 "80352": { name: "Cannabinoid Synthetic 7/more", wrvu: 0.00 },
 "80353": { name: "Drug Screening Cocaine", wrvu: 0.00 },
 "80354": { name: "Drug Screening Fentanyl", wrvu: 0.00 },
 "80355": { name: "Gabapentin Non-blood", wrvu: 0.00 },
 "80356": { name: "Heroin Metabolite", wrvu: 0.00 },
 "80357": { name: "Ketamine And Norketamine", wrvu: 0.00 },
 "80358": { name: "Drug Screening Methadone", wrvu: 0.00 },
 "80359": { name: "Methylenedioxyamphetamines", wrvu: 0.00 },
 "80360": { name: "Methylphenidate", wrvu: 0.00 },
 "80361": { name: "Opiates 1 Or More", wrvu: 0.00 },
 "80362": { name: "Opioids & Opiate Analogs 1/2", wrvu: 0.00 },
 "80363": { name: "Opioids & Opiate Analogs 3/4", wrvu: 0.00 },
 "80364": { name: "Opioid &opiate Analog 5/more", wrvu: 0.00 },
 "80365": { name: "Drug Screening Oxycodone", wrvu: 0.00 },
 "80366": { name: "Drug Screening Pregabalin", wrvu: 0.00 },
 "80367": { name: "Drug Screening Propoxyphene", wrvu: 0.00 },
 "80368": { name: "Sedative Hypnotics", wrvu: 0.00 },
 "80369": { name: "Skeletal Muscle Relaxant 1/2", wrvu: 0.00 },
 "80370": { name: "Skel Muscle Relaxant 3 Or More", wrvu: 0.00 },
 "80371": { name: "Stimulants Synthetic", wrvu: 0.00 },
 "80372": { name: "Drug Screening Tapentadol", wrvu: 0.00 },
 "80373": { name: "Drug Screening Tramadol", wrvu: 0.00 },
 "80374": { name: "Stereoisomer Analysis", wrvu: 0.00 },
 "80375": { name: "Drug/substance Not Otherwise Specified 1-3", wrvu: 0.00 },
 "80376": { name: "Drug/substance Not Otherwise Specified 4-6", wrvu: 0.00 },
 "80377": { name: "Drug/substance Not Otherwise Specified 7/more", wrvu: 0.00 },
 "80400": { name: "ACTH Stimulation Panel", wrvu: 0.00 },
 "80402": { name: "ACTH Stimulation Panel", wrvu: 0.00 },
 "80406": { name: "ACTH Stimulation Panel", wrvu: 0.00 },
 "80408": { name: "Aldosterone Suppression Evaluation", wrvu: 0.00 },
 "80410": { name: "Calcitonin Stimul Panel", wrvu: 0.00 },
 "80412": { name: "Crh Stimulation Panel", wrvu: 0.00 },
 "80414": { name: "Testosterone Response Panel", wrvu: 0.00 },
 "80415": { name: "Tot Estradiol Response Panel", wrvu: 0.00 },
 "80416": { name: "Renin Stimulation Panel", wrvu: 0.00 },
 "80417": { name: "Renin Stimulation Panel", wrvu: 0.00 },
 "80418": { name: "Pituitary Evaluation Panel", wrvu: 0.00 },
 "80420": { name: "Dexamethasone Panel", wrvu: 0.00 },
 "80422": { name: "Glucagon Tolerance Panel", wrvu: 0.00 },
 "80424": { name: "Glucagon Tolerance Panel", wrvu: 0.00 },
 "80426": { name: "Gonadotropin Hormone Panel", wrvu: 0.00 },
 "80428": { name: "Growth Hormone Panel", wrvu: 0.00 },
 "80430": { name: "Growth Hormone Panel", wrvu: 0.00 },
 "80432": { name: "Insulin Suppression Panel", wrvu: 0.00 },
 "80434": { name: "Insulin Tolerance Panel", wrvu: 0.00 },
 "80435": { name: "Insulin Tolerance Panel", wrvu: 0.00 },
 "80436": { name: "Metyrapone Panel", wrvu: 0.00 },
 "80438": { name: "Trh Stimulation Panel", wrvu: 0.00 },
 "80439": { name: "Trh Stimulation Panel", wrvu: 0.00 },
 "80503": { name: "Pathology Clin Consltj Sf 5-20", wrvu: 0.43 },
 "80504": { name: "Pathology Clin Consltj Moderate 21-40", wrvu: 0.91 },
 "80505": { name: "Pathology Clin Consltj High 41-60", wrvu: 1.71 },
 "80506": { name: "Pathology Clin Consltj Prolng Svc", wrvu: 0.80 },
 "81000": { name: "Urinalysis, Non-Automated, with Microscopy", wrvu: 0.00 },
 "81001": { name: "Urinalysis, Automated, with Microscopy", wrvu: 0.00 },
 "81002": { name: "Urinalysis, Non-Automated, without Microscopy", wrvu: 0.00 },
 "81003": { name: "Urinalysis, Automated, without Microscopy", wrvu: 0.00 },
 "81005": { name: "Urinalysis", wrvu: 0.00 },
 "81007": { name: "Urine Screen For Bacteria", wrvu: 0.00 },
 "81015": { name: "Microscopic Exam Of Urine", wrvu: 0.00 },
 "81020": { name: "Urinalysis Glass Test", wrvu: 0.00 },
 "81025": { name: "Urine Pregnancy Test", wrvu: 0.00 },
 "81050": { name: "Urinalysis Volume Measure", wrvu: 0.00 },
 "81099": { name: "Unlisted Urinalysis Procedure", wrvu: 0.00 },
 "81105": { name: "Hpa-1 Genotyping", wrvu: 0.00 },
 "81106": { name: "Hpa-2 Genotyping", wrvu: 0.00 },
 "81107": { name: "Hpa-3 Genotyping", wrvu: 0.00 },
 "81108": { name: "Hpa-4 Genotyping", wrvu: 0.00 },
 "81109": { name: "Hpa-5 Genotyping", wrvu: 0.00 },
 "81110": { name: "Hpa-6 Genotyping", wrvu: 0.00 },
 "81111": { name: "Hpa-9 Genotyping", wrvu: 0.00 },
 "81112": { name: "Hpa-15 Genotyping", wrvu: 0.00 },
 "81120": { name: "Idh1 Common Variants", wrvu: 0.00 },
 "81121": { name: "Idh2 Common Variants", wrvu: 0.00 },
 "81161": { name: "DMD Gene (Duchenne Muscular Dystrophy) Duplication/Deletion Analysis", wrvu: 0.00 },
 "81162": { name: "Brca1 and 2 Genital Full Seq Duplication/Deletion", wrvu: 0.00 },
 "81163": { name: "Brca1 and 2 Gene Full Seq Alys", wrvu: 0.00 },
 "81164": { name: "Brca1 and 2 Genital Ful Duplication/Deletion Alys", wrvu: 0.00 },
 "81165": { name: "Brca1 Gene Full Seq Alys", wrvu: 0.00 },
 "81166": { name: "Brca1 Gene Full Duplication/Deletion Alys", wrvu: 0.00 },
 "81167": { name: "Brca2 Gene Full Duplication/Deletion Alys", wrvu: 0.00 },
 "81168": { name: "Ccnd1/igh Translocation Alys", wrvu: 0.00 },
 "81170": { name: "Abl1 Gene", wrvu: 0.00 },
 "81171": { name: "Aff2 Genital Aly Detc Abnl Allel", wrvu: 0.00 },
 "81172": { name: "Aff2 Genital Alys Charac Alleles", wrvu: 0.00 },
 "81173": { name: "Ar Gene Full Gene Sequence", wrvu: 0.00 },
 "81174": { name: "Ar Gene Known Famil Variant", wrvu: 0.00 },
 "81175": { name: "Asxl1 Full Gene Sequence", wrvu: 0.00 },
 "81176": { name: "Asxl1 Gene Target Seq Alys", wrvu: 0.00 },
 "81177": { name: "Atn1 Gene Detc Abnor Alleles", wrvu: 0.00 },
 "81178": { name: "Atxn1 Gene Detc Abnor Allele", wrvu: 0.00 },
 "81179": { name: "Atxn2 Gene Detc Abnor Allele", wrvu: 0.00 },
 "81180": { name: "Atxn3 Gene Detc Abnor Allele", wrvu: 0.00 },
 "81181": { name: "Atxn7 Gene Detc Abnor Allele", wrvu: 0.00 },
 "81182": { name: "Atxn8os Genital Detc Abnor Allel", wrvu: 0.00 },
 "81183": { name: "Atxn10 Gene Detc Abnor Allel", wrvu: 0.00 },
 "81184": { name: "Cacna1a Genital Detc Abnor Allel", wrvu: 0.00 },
 "81185": { name: "Cacna1a Gene Full Gene Seq", wrvu: 0.00 },
 "81186": { name: "Cacna1a Genital Known Famil Vrnt", wrvu: 0.00 },
 "81187": { name: "Cnbp Gene Detc Abnor Allele", wrvu: 0.00 },
 "81188": { name: "Cstb Gene Detc Abnor Allele", wrvu: 0.00 },
 "81189": { name: "Cstb Gene Full Gene Sequence", wrvu: 0.00 },
 "81190": { name: "Cstb Gene Known Famil Vrnt", wrvu: 0.00 },
 "81191": { name: "Ntrk1 Translocation Analysis", wrvu: 0.00 },
 "81192": { name: "Ntrk2 Translocation Analysis", wrvu: 0.00 },
 "81193": { name: "Ntrk3 Translocation Analysis", wrvu: 0.00 },
 "81194": { name: "Ntrk Translocation Analysis", wrvu: 0.00 },
 "81195": { name: "Cytog Genom-wid Alys Hem Mal", wrvu: 0.00 },
 "81200": { name: "Aspa Gene", wrvu: 0.00 },
 "81201": { name: "APC Gene Gene Full Sequence", wrvu: 0.00 },
 "81202": { name: "APC Gene Gene Known Fam Variants", wrvu: 0.00 },
 "81203": { name: "APC Gene Gene Duplication/Deletion Variants", wrvu: 0.00 },
 "81204": { name: "Ar Gene Charac Alleles", wrvu: 0.00 },
 "81205": { name: "Bckdhb Gene", wrvu: 0.00 },
 "81206": { name: "Bcr/abl1 Gene Major Bp", wrvu: 0.00 },
 "81207": { name: "Bcr/abl1 Gene Minor Bp", wrvu: 0.00 },
 "81208": { name: "Bcr/abl1 Gene Other Bp", wrvu: 0.00 },
 "81209": { name: "Blm Gene", wrvu: 0.00 },
 "81210": { name: "BRAF Gene", wrvu: 0.00 },
 "81212": { name: "Brca1 and 2 185 and 5385 and 6174 Vrnt", wrvu: 0.00 },
 "81215": { name: "Brca1 Gene Known Famil Vrnt", wrvu: 0.00 },
 "81216": { name: "Brca2 Gene Full Seq Alys", wrvu: 0.00 },
 "81217": { name: "Brca2 Gene Known Famil Vrnt", wrvu: 0.00 },
 "81218": { name: "Cebpa Gene Full Sequence", wrvu: 0.00 },
 "81219": { name: "Calr Gene Com Variants", wrvu: 0.00 },
 "81220": { name: "CFTR (Cystic Fibrosis) Gene Com Variants", wrvu: 0.00 },
 "81221": { name: "CFTR (Cystic Fibrosis) Gene Known Fam Variants", wrvu: 0.00 },
 "81222": { name: "CFTR (Cystic Fibrosis) Gene Duplication/Deletion Variants", wrvu: 0.00 },
 "81223": { name: "CFTR (Cystic Fibrosis) Gene Full Sequence", wrvu: 0.00 },
 "81224": { name: "CFTR (Cystic Fibrosis) Gene Intron Poly T", wrvu: 0.00 },
 "81225": { name: "CYP2C19 Gene Com Variants", wrvu: 0.00 },
 "81226": { name: "CYP2D6 Gene Com Variants", wrvu: 0.00 },
 "81227": { name: "CYP2C9 Gene Com Variants", wrvu: 0.00 },
 "81228": { name: "Cytog Alys Chrml Abnr Cgh", wrvu: 0.00 },
 "81229": { name: "Cytog Alys Chrml Abnr Snpcgh", wrvu: 0.00 },
 "81230": { name: "Cyp3a4 Gene Common Variants", wrvu: 0.00 },
 "81231": { name: "Cyp3a5 Gene Common Variants", wrvu: 0.00 },
 "81232": { name: "Dpyd Gene Common Variants", wrvu: 0.00 },
 "81233": { name: "Btk Gene Common Variants", wrvu: 0.00 },
 "81234": { name: "Dmpk Gene Detc Abnor Allele", wrvu: 0.00 },
 "81235": { name: "EGFR Gene Com Variants", wrvu: 0.00 },
 "81236": { name: "Ezh2 Gene Full Gene Sequence", wrvu: 0.00 },
 "81237": { name: "Ezh2 Gene Common Variants", wrvu: 0.00 },
 "81238": { name: "F9 Full Gene Sequence", wrvu: 0.00 },
 "81239": { name: "Dmpk Gene Charac Alleles", wrvu: 0.00 },
 "81240": { name: "F2 Gene", wrvu: 0.00 },
 "81241": { name: "F5 Gene", wrvu: 0.00 },
 "81242": { name: "Fancc Gene", wrvu: 0.00 },
 "81243": { name: "FMR1 (Fragile X) Genital Aly Detc Abnl Allel", wrvu: 0.00 },
 "81244": { name: "FMR1 (Fragile X) Genital Alys Charac Alleles", wrvu: 0.00 },
 "81245": { name: "Flt3 Gene", wrvu: 0.00 },
 "81246": { name: "Flt3 Gene Analysis", wrvu: 0.00 },
 "81247": { name: "G6pd Gene Alys Cmn Variant", wrvu: 0.00 },
 "81248": { name: "G6pd Known Familial Variant", wrvu: 0.00 },
 "81249": { name: "G6pd Full Gene Sequence", wrvu: 0.00 },
 "81250": { name: "G6pc Gene", wrvu: 0.00 },
 "81251": { name: "Gba Gene", wrvu: 0.00 },
 "81252": { name: "Gjb2 Gene Full Sequence", wrvu: 0.00 },
 "81253": { name: "Gjb2 Gene Known Fam Variants", wrvu: 0.00 },
 "81254": { name: "Gjb6 Gene Com Variants", wrvu: 0.00 },
 "81255": { name: "Hexa Gene", wrvu: 0.00 },
 "81256": { name: "Hfe Gene", wrvu: 0.00 },
 "81257": { name: "Hba1/hba2 Gene", wrvu: 0.00 },
 "81258": { name: "Hba1/hba2 Gene Fam Vrnt", wrvu: 0.00 },
 "81259": { name: "Hba1/hba2 Full Gene Sequence", wrvu: 0.00 },
 "81260": { name: "Ikbkap Gene", wrvu: 0.00 },
 "81261": { name: "Igh Gene Rearrange Amp Meth", wrvu: 0.00 },
 "81262": { name: "Igh Gene Rearrang Dir Probe", wrvu: 0.00 },
 "81263": { name: "Igh Vari Regional Mutation", wrvu: 0.00 },
 "81264": { name: "Igk Rearrangeabn Clonal Pop", wrvu: 0.00 },
 "81265": { name: "Str Markers Specimen Anal", wrvu: 0.00 },
 "81266": { name: "Str Markers Specimen Anal Additional", wrvu: 0.00 },
 "81267": { name: "Chimerism Anal No Cell Selec", wrvu: 0.00 },
 "81268": { name: "Chimerism Anal With Cell Select", wrvu: 0.00 },
 "81269": { name: "Hba1/hba2 Gene Duplication/Deletion Vrnts", wrvu: 0.00 },
 "81270": { name: "Jak2 Gene", wrvu: 0.00 },
 "81271": { name: "Htt Gene Detc Abnor Alleles", wrvu: 0.00 },
 "81272": { name: "Kit Gene Targeted Seq Analys", wrvu: 0.00 },
 "81273": { name: "Kit Gene Analys D816 Variant", wrvu: 0.00 },
 "81274": { name: "Htt Gene Charac Alleles", wrvu: 0.00 },
 "81275": { name: "KRAS Gene Variants Exon 2", wrvu: 0.00 },
 "81276": { name: "KRAS Gene Additional Variants", wrvu: 0.00 },
 "81277": { name: "Cytogenomic Neo Microra Alys", wrvu: 0.00 },
 "81278": { name: "Igh@/bcl2 Translocation Alys", wrvu: 0.00 },
 "81279": { name: "Jak2 Gene Trgt Sequence Alys", wrvu: 0.00 },
 "81283": { name: "Ifnl3 Gene", wrvu: 0.00 },
 "81284": { name: "Fxn Gene Detc Abnor Alleles", wrvu: 0.00 },
 "81285": { name: "Fxn Gene Charac Alleles", wrvu: 0.00 },
 "81286": { name: "Fxn Gene Full Gene Sequence", wrvu: 0.00 },
 "81287": { name: "Management Gene Prmtr Mthyltn Alys", wrvu: 0.00 },
 "81288": { name: "MLH1 Gene", wrvu: 0.00 },
 "81289": { name: "Fxn Gene Known Famil Variant", wrvu: 0.00 },
 "81290": { name: "Mcoln1 Gene", wrvu: 0.00 },
 "81291": { name: "Mthfr Gene", wrvu: 0.00 },
 "81292": { name: "MLH1 Gene Full Seq", wrvu: 0.00 },
 "81293": { name: "MLH1 Gene Known Variants", wrvu: 0.00 },
 "81294": { name: "MLH1 Gene Dup/delete Variant", wrvu: 0.00 },
 "81295": { name: "MSH2 Gene Full Seq", wrvu: 0.00 },
 "81296": { name: "MSH2 Gene Known Variants", wrvu: 0.00 },
 "81297": { name: "MSH2 Gene Dup/delete Variant", wrvu: 0.00 },
 "81298": { name: "MSH6 Gene Full Seq", wrvu: 0.00 },
 "81299": { name: "MSH6 Gene Known Variants", wrvu: 0.00 },
 "81300": { name: "MSH6 Gene Dup/delete Variant", wrvu: 0.00 },
 "81301": { name: "Microsatellite Instability", wrvu: 0.00 },
 "81302": { name: "Mecp2 Gene Full Seq", wrvu: 0.00 },
 "81303": { name: "Mecp2 Gene Known Variant", wrvu: 0.00 },
 "81304": { name: "Mecp2 Gene Duplication/Deletion Variant", wrvu: 0.00 },
 "81305": { name: "Myd88 Gene P.leu265pro Vrnt", wrvu: 0.00 },
 "81306": { name: "Nudt15 Gene Common Variants", wrvu: 0.00 },
 "81307": { name: "Palb2 Gene Full Gene Seq", wrvu: 0.00 },
 "81308": { name: "Palb2 Gene Known Famil Vrnt", wrvu: 0.00 },
 "81309": { name: "Pik3ca Gene Trgt Seq Alys", wrvu: 0.00 },
 "81310": { name: "Npm1 Gene", wrvu: 0.00 },
 "81311": { name: "Nras Gene Variants Exon 2 and 3", wrvu: 0.00 },
 "81312": { name: "Pabpn1 Gene Detc Abnor Allel", wrvu: 0.00 },
 "81313": { name: "Pca3/klk3 Antigen", wrvu: 0.00 },
 "81314": { name: "Pdgfra Gene", wrvu: 0.00 },
 "81315": { name: "Pml/raralpha Com Breakpoints", wrvu: 0.00 },
 "81316": { name: "Pml/raralpha 1 Breakpoint", wrvu: 0.00 },
 "81317": { name: "Pms2 Gene Full Seq Analysis", wrvu: 0.00 },
 "81318": { name: "Pms2 Known Familial Variants", wrvu: 0.00 },
 "81319": { name: "Pms2 Gene Duplication/Deletion Variants", wrvu: 0.00 },
 "81320": { name: "Plcg2 Gene Common Variants", wrvu: 0.00 },
 "81321": { name: "Pten Gene Full Sequence", wrvu: 0.00 },
 "81322": { name: "Pten Gene Known Fam Variant", wrvu: 0.00 },
 "81323": { name: "Pten Gene Duplication/Deletion Variant", wrvu: 0.00 },
 "81324": { name: "Pmp22 Gene Duplication/Deletion", wrvu: 0.00 },
 "81325": { name: "Pmp22 Gene Full Sequence", wrvu: 0.00 },
 "81326": { name: "Pmp22 Gene Known Fam Variant", wrvu: 0.00 },
 "81327": { name: "Sept9 Genital Prmtr Mthyltn Alys", wrvu: 0.00 },
 "81328": { name: "Slco1b1 Gene Com Variants", wrvu: 0.00 },
 "81329": { name: "Smn1 Gene Dos/deletion Alys", wrvu: 0.00 },
 "81330": { name: "Smpd1 Gene Common Variants", wrvu: 0.00 },
 "81331": { name: "Snrpn/ube3a Gene", wrvu: 0.00 },
 "81332": { name: "Serpina1 Gene", wrvu: 0.00 },
 "81333": { name: "Tgfbi Gene Common Variants", wrvu: 0.00 },
 "81334": { name: "Runx1 Gene Targeted Seq Alys", wrvu: 0.00 },
 "81335": { name: "Tpmt Gene Com Variants", wrvu: 0.00 },
 "81336": { name: "Smn1 Gene Full Gene Sequence", wrvu: 0.00 },
 "81337": { name: "Smn1 Genital Nown Famil Seq Vrnt", wrvu: 0.00 },
 "81338": { name: "Mpl Gene Common Variants", wrvu: 0.00 },
 "81339": { name: "Mpl Gene Seq Alys Exon 10", wrvu: 0.00 },
 "81340": { name: "Trb@ Gene Rearrange Amplify", wrvu: 0.00 },
 "81341": { name: "Trb@ Gene Rearrange Dirprobe", wrvu: 0.00 },
 "81342": { name: "Trg Gene Rearrangement Anal", wrvu: 0.00 },
 "81343": { name: "Ppp2r2b Genital Detc Abnor Allel", wrvu: 0.00 },
 "81344": { name: "Tbp Gene Detc Abnor Alleles", wrvu: 0.00 },
 "81345": { name: "Tert Gene Targeted Seq Alys", wrvu: 0.00 },
 "81346": { name: "Tyms Gene Com Variants", wrvu: 0.00 },
 "81347": { name: "Sf3b1 Gene Common Variants", wrvu: 0.00 },
 "81348": { name: "Srsf2 Gene Common Variants", wrvu: 0.00 },
 "81349": { name: "Cytog Alys Chrml Abnr Lw-ps", wrvu: 0.00 },
 "81350": { name: "Ugt1a1 Gene Common Variants", wrvu: 0.00 },
 "81351": { name: "Tp53 Gene Full Gene Sequence", wrvu: 0.00 },
 "81352": { name: "Tp53 Gene Trgt Sequence Alys", wrvu: 0.00 },
 "81353": { name: "Tp53 Gene Known Famil Vrnt", wrvu: 0.00 },
 "81354": { name: "Cytog Alys Chrml Abnor Ogm", wrvu: 0.00 },
 "81355": { name: "VKORC1 Gene", wrvu: 0.00 },
 "81357": { name: "U2af1 Gene Common Variants", wrvu: 0.00 },
 "81360": { name: "Zrsr2 Gene Common Variants", wrvu: 0.00 },
 "81361": { name: "Hbb Gene Com Variants", wrvu: 0.00 },
 "81362": { name: "Hbb Gene Known Fam Variant", wrvu: 0.00 },
 "81363": { name: "Hbb Gene Duplication/Deletion Variants", wrvu: 0.00 },
 "81364": { name: "Hbb Full Gene Sequence", wrvu: 0.00 },
 "81370": { name: "Hla I & Ii Typing Lr", wrvu: 0.00 },
 "81371": { name: "Hla I & Ii Type Verify Lr", wrvu: 0.00 },
 "81372": { name: "Hla I Typing Complete Lr", wrvu: 0.00 },
 "81373": { name: "Hla I Typing 1 Locus Lr", wrvu: 0.00 },
 "81374": { name: "Hla I Typing 1 Antigen Lr", wrvu: 0.00 },
 "81375": { name: "Hla Ii Typing Ag Equiv Lr", wrvu: 0.00 },
 "81376": { name: "Hla Ii Typing 1 Locus Lr", wrvu: 0.00 },
 "81377": { name: "Hla Ii Type 1 Ag Equiv Lr", wrvu: 0.00 },
 "81378": { name: "Hla I & Ii Typing Hr", wrvu: 0.00 },
 "81379": { name: "Hla I Typing Complete Hr", wrvu: 0.00 },
 "81380": { name: "Hla I Typing 1 Locus Hr", wrvu: 0.00 },
 "81381": { name: "Hla I Typing 1 Allele Hr", wrvu: 0.00 },
 "81382": { name: "Hla Ii Typing 1 Loc Hr", wrvu: 0.00 },
 "81383": { name: "Hla Ii Typing 1 Allele Hr", wrvu: 0.00 },
 "81400": { name: "Mopath Procedure Level 1", wrvu: 0.00 },
 "81401": { name: "Mopath Procedure Level 2", wrvu: 0.00 },
 "81402": { name: "Mopath Procedure Level 3", wrvu: 0.00 },
 "81403": { name: "Mopath Procedure Level 4", wrvu: 0.00 },
 "81404": { name: "Mopath Procedure Level 5", wrvu: 0.00 },
 "81405": { name: "Mopath Procedure Level 6", wrvu: 0.00 },
 "81406": { name: "Mopath Procedure Level 7", wrvu: 0.00 },
 "81407": { name: "Mopath Procedure Level 8", wrvu: 0.00 },
 "81408": { name: "Mopath Procedure Level 9", wrvu: 0.00 },
 "81410": { name: "Aortic Dysfunction/dilation", wrvu: 0.00 },
 "81411": { name: "Aortic Dysfunction/dilation", wrvu: 0.00 },
 "81412": { name: "Ashkenazi Jewish Assoc Dis", wrvu: 0.00 },
 "81413": { name: "Car Ion Chnnlpath Inc 10 Gns", wrvu: 0.00 },
 "81414": { name: "Car Ion Chnnlpath Inc 2 Gns", wrvu: 0.00 },
 "81415": { name: "Exome Sequence Analysis", wrvu: 0.00 },
 "81416": { name: "Exome Sequence Analysis", wrvu: 0.00 },
 "81417": { name: "Exome Re-evaluation", wrvu: 0.00 },
 "81418": { name: "Prescription Metab Genital Seq Alys Panel 6", wrvu: 0.00 },
 "81419": { name: "Epilepsy Genital Seq Alys Panel", wrvu: 0.00 },
 "81420": { name: "Fetal Chrmoml Aneuploidy", wrvu: 0.00 },
 "81422": { name: "Fetal Chrmoml Microdeltj", wrvu: 0.00 },
 "81425": { name: "Genome Sequence Analysis", wrvu: 0.00 },
 "81426": { name: "Genome Sequence Analysis", wrvu: 0.00 },
 "81427": { name: "Genome Re-evaluation", wrvu: 0.00 },
 "81430": { name: "Hearing Loss Sequence Analys", wrvu: 0.00 },
 "81431": { name: "Hearing Loss Duplication/Deletion Analys", wrvu: 0.00 },
 "81432": { name: "Hrdtry Breast Ca-rlatd Do 5+", wrvu: 0.00 },
 "81434": { name: "Hered Rta Do Genital Seq 15", wrvu: 0.00 },
 "81435": { name: "Hered Colon Ca-rlatd Do 5+", wrvu: 0.00 },
 "81437": { name: "Hered Neuroend Tumor-rlt Do 5+", wrvu: 0.00 },
 "81439": { name: "Hrdtry Cardmypy Gene Panel", wrvu: 0.00 },
 "81440": { name: "Mitochondrial Gene", wrvu: 0.00 },
 "81441": { name: "Ibmfs Seq Alys Panel 30 Genes", wrvu: 0.00 },
 "81442": { name: "Noonan Spectrum Disorders", wrvu: 0.00 },
 "81443": { name: "Genetic Tstg Severe Inh Cond", wrvu: 0.00 },
 "81445": { name: "So Neo Gsap 5-50dna/dna and rna", wrvu: 0.00 },
 "81448": { name: "Hrdtry Perph Neurphy Panel", wrvu: 0.00 },
 "81449": { name: "So Neo Gsap 5-50 Rna Alys", wrvu: 0.00 },
 "81450": { name: "Hodgkin Lymphoma Neo Gsap 5-50dna/dna and rna", wrvu: 0.00 },
 "81451": { name: "Hodgkin Lymphoma Neo Gsap 5-50 Rna Alys", wrvu: 0.00 },
 "81455": { name: "So/Hodgkin Lymphoma 51/>gsap Dna/dna and rna", wrvu: 0.00 },
 "81456": { name: "So/Hodgkin Lymphoma 51/>gsap Rna Alys", wrvu: 0.00 },
 "81457": { name: "So Neo Gsap Dna Mcrstl Ins", wrvu: 0.00 },
 "81458": { name: "So Gsap Dna Cpy Nmbr and mcrstl", wrvu: 0.00 },
 "81459": { name: "So Neo Gsap Dna/dna and rna", wrvu: 0.00 },
 "81460": { name: "Whole Mitochondrial Genome", wrvu: 0.00 },
 "81462": { name: "So Gsap Chronic Lymphocytic Leukemia Fr Dna/dna and rna", wrvu: 0.00 },
 "81463": { name: "So Gsap Clinical Fr Cpy Nmbr and mcrst", wrvu: 0.00 },
 "81464": { name: "So Gsap Chronic Lymphocytic Leukemia Fr Mcrstl Ins", wrvu: 0.00 },
 "81465": { name: "Whole Mitochondrial Genome", wrvu: 0.00 },
 "81470": { name: "X-linked Intellectual Dblt", wrvu: 0.00 },
 "81471": { name: "X-linked Intellectual Dblt", wrvu: 0.00 },
 "81479": { name: "Unlisted Molecular Pathology", wrvu: 0.00 },
 "81490": { name: "Autoimmune Ra Alys 12 Bmrk", wrvu: 0.00 },
 "81493": { name: "Cor Artery Disease Mrna", wrvu: 0.00 },
 "81500": { name: "Onco (ovar) Two Proteins", wrvu: 0.00 },
 "81503": { name: "Onco (ovar) Five Proteins", wrvu: 0.00 },
 "81504": { name: "Oncology Tissue Of Origin", wrvu: 0.00 },
 "81506": { name: "Endoscopic Assay Seven Anal", wrvu: 0.00 },
 "81507": { name: "Fetal Aneuploidy Trisom Risk", wrvu: 0.00 },
 "81508": { name: "Fetal Cgen Abnor Two Proteins", wrvu: 0.00 },
 "81509": { name: "Fetal Cgen Abnor 3 Proteins", wrvu: 0.00 },
 "81510": { name: "Fetal Cgen Abnor Three Anal", wrvu: 0.00 },
 "81511": { name: "Fetal Cgen Abnor Four Anal", wrvu: 0.00 },
 "81512": { name: "Fetal Cgen Abnor Five Anal", wrvu: 0.00 },
 "81513": { name: "Nfct Ds Bv Rna Vaginal Flu Alg", wrvu: 0.00 },
 "81514": { name: "Nfct Ds Bv and vaginitis Dna Alg", wrvu: 0.00 },
 "81515": { name: "Nfct Ds Bv and vaginitis Dna Alg", wrvu: 0.00 },
 "81517": { name: "Liver Ds Alys 3 Bmrk Serum Alg", wrvu: 0.00 },
 "81518": { name: "Oncology Breast Mrna 11 Genes", wrvu: 0.00 },
 "81519": { name: "Oncology Breast Mrna", wrvu: 0.00 },
 "81520": { name: "Oncology Breast Mrna 58 Genes", wrvu: 0.00 },
 "81521": { name: "Oncology Breast Mrna 70 Genes", wrvu: 0.00 },
 "81522": { name: "Oncology Breast Mrna 12 Genes", wrvu: 0.00 },
 "81523": { name: "Oncology Breast Mrna 70 Cnt 31 Gene", wrvu: 0.00 },
 "81524": { name: "Oncology Cns Tumor Dna Mthyl 10,000", wrvu: 0.00 },
 "81525": { name: "Oncology Colon Mrna", wrvu: 0.00 },
 "81528": { name: "Oncology Colorectal Scr", wrvu: 0.00 },
 "81529": { name: "Oncology Cutan Melanoma Mrna 31 Gene", wrvu: 0.00 },
 "81535": { name: "Oncology Gynecologic", wrvu: 0.00 },
 "81536": { name: "Oncology Gynecologic", wrvu: 0.00 },
 "81538": { name: "Oncology Lung", wrvu: 0.00 },
 "81539": { name: "Oncology Prostate Prob Score", wrvu: 0.00 },
 "81540": { name: "Oncology Tumor Unknown Origin", wrvu: 0.00 },
 "81541": { name: "Oncology Prostate Mrna 46 Genes", wrvu: 0.00 },
 "81542": { name: "Oncology Prostate Mrna 22 Cnt Genital", wrvu: 0.00 },
 "81546": { name: "Oncology Thyroid Mrna 10,196 Genital Alg", wrvu: 0.00 },
 "81551": { name: "Oncology Prostate 3 Genes", wrvu: 0.00 },
 "81552": { name: "Oncology Uveal Melanoma Mrna 15 Gene", wrvu: 0.00 },
 "81554": { name: "Pulm Ds Ipf Mrna 190 Genital Alg", wrvu: 0.00 },
 "81558": { name: "Transplant Rej Kdn Mrna Qpcr 139", wrvu: 0.00 },
 "81560": { name: "Trnsplj Pd Liver and bwl Cd154+Chronic Lymphocytic Leukemia", wrvu: 0.00 },
 "81595": { name: "Cardiology Heart Transplant Mrna", wrvu: 0.00 },
 "81596": { name: "Nfct Ds Chrnc Hepatitis C 6 Assays", wrvu: 0.00 },
 "81599": { name: "Unlisted Maaa", wrvu: 0.00 },
 "82009": { name: "Ketone Bodys Qual", wrvu: 0.00 },
 "82010": { name: "Ketone Bodys Quan", wrvu: 0.00 },
 "82013": { name: "Acetylcholinesterase Assay", wrvu: 0.00 },
 "82016": { name: "Acylcarnitines Qual", wrvu: 0.00 },
 "82017": { name: "Acylcarnitines Quant", wrvu: 0.00 },
 "82024": { name: "Assay Of ACTH", wrvu: 0.00 },
 "82030": { name: "Assay Of Adp & Amp", wrvu: 0.00 },
 "82040": { name: "Assay Of Serum Albumin", wrvu: 0.00 },
 "82042": { name: "Other Source Albumin Quan Each", wrvu: 0.00 },
 "82043": { name: "Ur Albumin Quantitative", wrvu: 0.00 },
 "82044": { name: "Ur Albumin Semiquantitative", wrvu: 0.00 },
 "82045": { name: "Albumin Ischemia Modified", wrvu: 0.00 },
 "82075": { name: "Assay Of Breath Ethanol", wrvu: 0.00 },
 "82077": { name: "Assay Specimen Xcp Ur and breath Ia", wrvu: 0.00 },
 "82085": { name: "Assay Of Aldolase", wrvu: 0.00 },
 "82088": { name: "Assay Of Aldosterone", wrvu: 0.00 },
 "82103": { name: "Alpha-1-antitrypsin Total", wrvu: 0.00 },
 "82104": { name: "Alpha-1-antitrypsin Pheno", wrvu: 0.00 },
 "82105": { name: "Alpha-fetoprotein Serum", wrvu: 0.00 },
 "82106": { name: "Alpha-fetoprotein Amniotic", wrvu: 0.00 },
 "82107": { name: "Alpha-fetoprotein L3", wrvu: 0.00 },
 "82108": { name: "Assay Of Aluminum", wrvu: 0.00 },
 "82120": { name: "Amines Vaginal Fluid Qual", wrvu: 0.00 },
 "82127": { name: "Amino Acid Single Qual", wrvu: 0.00 },
 "82128": { name: "Amino Acids Mult Qual", wrvu: 0.00 },
 "82131": { name: "Amino Acids Single Quant", wrvu: 0.00 },
 "82135": { name: "Assay Aminolevulinic Acid", wrvu: 0.00 },
 "82136": { name: "Amino Acids Quant 2-5", wrvu: 0.00 },
 "82139": { name: "Amino Acids Quan 6 Or More", wrvu: 0.00 },
 "82140": { name: "Assay Of Ammonia", wrvu: 0.00 },
 "82143": { name: "Amniotic Fluid Scan", wrvu: 0.00 },
 "82150": { name: "Assay Of Amylase", wrvu: 0.00 },
 "82154": { name: "Androstanediol Glucuronide", wrvu: 0.00 },
 "82157": { name: "Assay Of Androstenedione", wrvu: 0.00 },
 "82160": { name: "Assay Of Androsterone", wrvu: 0.00 },
 "82163": { name: "Assay Of Angiotensin Ii", wrvu: 0.00 },
 "82164": { name: "Angiotensin I Enzyme Test", wrvu: 0.00 },
 "82166": { name: "Assay Anti-mullerian Horm", wrvu: 0.00 },
 "82172": { name: "Assay Of Apolipoprotein", wrvu: 0.00 },
 "82175": { name: "Assay Of Arsenic", wrvu: 0.00 },
 "82180": { name: "Assay Of Ascorbic Acid", wrvu: 0.00 },
 "82190": { name: "Atomic Absorption", wrvu: 0.00 },
 "82232": { name: "Assay Of Beta-2 Protein", wrvu: 0.00 },
 "82233": { name: "Beta-amyloid 1-40 (abeta 40)", wrvu: 0.00 },
 "82234": { name: "Beta-amyloid 1-42 (abeta 42)", wrvu: 0.00 },
 "82239": { name: "Bile Acids Total", wrvu: 0.00 },
 "82240": { name: "Bile Acids Cholylglycine", wrvu: 0.00 },
 "82247": { name: "Bilirubin Total", wrvu: 0.00 },
 "82248": { name: "Bilirubin Direct", wrvu: 0.00 },
 "82252": { name: "Fecal Bilirubin Test", wrvu: 0.00 },
 "82261": { name: "Assay Of Biotinidase", wrvu: 0.00 },
 "82270": { name: "Occult Blood Feces", wrvu: 0.00 },
 "82271": { name: "Occult Blood Other Sources", wrvu: 0.00 },
 "82272": { name: "Occult Bld Feces 1-3 Tests", wrvu: 0.00 },
 "82274": { name: "Assay Test For Blood Fecal", wrvu: 0.00 },
 "82286": { name: "Assay Of Bradykinin", wrvu: 0.00 },
 "82300": { name: "Assay Of Cadmium", wrvu: 0.00 },
 "82306": { name: "Vitamin D 25 Hydroxy", wrvu: 0.00 },
 "82308": { name: "Assay Of Calcitonin", wrvu: 0.00 },
 "82310": { name: "Assay Of Calcium", wrvu: 0.00 },
 "82330": { name: "Assay Of Calcium", wrvu: 0.00 },
 "82331": { name: "Calcium Infusion Test", wrvu: 0.00 },
 "82340": { name: "Assay Of Calcium In Urine", wrvu: 0.00 },
 "82355": { name: "Calculus Analysis Qual", wrvu: 0.00 },
 "82360": { name: "Calculus Assay Quant", wrvu: 0.00 },
 "82365": { name: "Calculus Spectroscopy", wrvu: 0.00 },
 "82370": { name: "X-ray Assay Calculus", wrvu: 0.00 },
 "82373": { name: "Assay C-d Transfer Measure", wrvu: 0.00 },
 "82374": { name: "Assay Blood Carbon Dioxide", wrvu: 0.00 },
 "82375": { name: "Assay Carboxyhb Quant", wrvu: 0.00 },
 "82376": { name: "Assay Carboxyhb Qual", wrvu: 0.00 },
 "82378": { name: "Carcinoembryonic Antigen", wrvu: 0.00 },
 "82379": { name: "Assay Of Carnitine", wrvu: 0.00 },
 "82380": { name: "Assay Of Carotene", wrvu: 0.00 },
 "82382": { name: "Assay Urine Catecholamines", wrvu: 0.00 },
 "82383": { name: "Assay Blood Catecholamines", wrvu: 0.00 },
 "82384": { name: "Assay Three Catecholamines", wrvu: 0.00 },
 "82387": { name: "Assay Of Cathepsin-d", wrvu: 0.00 },
 "82390": { name: "Assay Of Ceruloplasmin", wrvu: 0.00 },
 "82397": { name: "Chemiluminescent Assay", wrvu: 0.00 },
 "82415": { name: "Assay Of Chloramphenicol", wrvu: 0.00 },
 "82435": { name: "Assay Of Blood Chloride", wrvu: 0.00 },
 "82436": { name: "Assay Of Urine Chloride", wrvu: 0.00 },
 "82438": { name: "Assay Other Fluid Chlorides", wrvu: 0.00 },
 "82441": { name: "Test For Chlorohydrocarbons", wrvu: 0.00 },
 "82465": { name: "Assay Bld/serum Cholesterol", wrvu: 0.00 },
 "82480": { name: "Assay Serum Cholinesterase", wrvu: 0.00 },
 "82482": { name: "Assay Reduction Blood Cell Cholinesterase", wrvu: 0.00 },
 "82485": { name: "Assay Chondroitin Sulfate", wrvu: 0.00 },
 "82495": { name: "Assay Of Chromium", wrvu: 0.00 },
 "82507": { name: "Assay Of Citrate", wrvu: 0.00 },
 "82523": { name: "Collagen Crosslinks", wrvu: 0.00 },
 "82525": { name: "Assay Of Copper", wrvu: 0.00 },
 "82528": { name: "Assay Of Corticosterone", wrvu: 0.00 },
 "82530": { name: "Cortisol Free", wrvu: 0.00 },
 "82533": { name: "Total Cortisol", wrvu: 0.00 },
 "82540": { name: "Assay Of Creatine", wrvu: 0.00 },
 "82542": { name: "Col Chromotography Qual/quan", wrvu: 0.00 },
 "82550": { name: "Assay Of Creatine Kinase (cpk)", wrvu: 0.00 },
 "82552": { name: "Assay Of Cpk In Blood", wrvu: 0.00 },
 "82553": { name: "Creatine Mb Fraction", wrvu: 0.00 },
 "82554": { name: "Creatine Isoforms", wrvu: 0.00 },
 "82565": { name: "Assay Of Creatinine", wrvu: 0.00 },
 "82570": { name: "Assay Of Urine Creatinine", wrvu: 0.00 },
 "82575": { name: "Creatinine Clearance Test", wrvu: 0.00 },
 "82585": { name: "Assay Of Cryofibrinogen", wrvu: 0.00 },
 "82595": { name: "Assay Of Cryoglobulin", wrvu: 0.00 },
 "82600": { name: "Assay Of Cyanide", wrvu: 0.00 },
 "82607": { name: "Vitamin B-12", wrvu: 0.00 },
 "82608": { name: "B-12 Binding Capacity", wrvu: 0.00 },
 "82610": { name: "Cystatin C", wrvu: 0.00 },
 "82615": { name: "Test For Urine Cystines", wrvu: 0.00 },
 "82626": { name: "Dehydroepiandrosterone", wrvu: 0.00 },
 "82627": { name: "Dehydroepiandrosterone", wrvu: 0.00 },
 "82633": { name: "Desoxycorticosterone", wrvu: 0.00 },
 "82634": { name: "Deoxycortisol", wrvu: 0.00 },
 "82638": { name: "Assay Of Dibucaine Number", wrvu: 0.00 },
 "82642": { name: "Dihydrotestosterone", wrvu: 0.00 },
 "82652": { name: "Vit D 1 25-dihydroxy", wrvu: 0.00 },
 "82653": { name: "El-1 Fecal Quantitative", wrvu: 0.00 },
 "82656": { name: "El-1 Fecal Qual/semiq", wrvu: 0.00 },
 "82657": { name: "Enzyme Cell Activity", wrvu: 0.00 },
 "82658": { name: "Enzyme Cell Activity Ra", wrvu: 0.00 },
 "82664": { name: "Electrophoretic Test", wrvu: 0.00 },
 "82668": { name: "Assay Of Erythropoietin", wrvu: 0.00 },
 "82670": { name: "Assay Of Total Estradiol", wrvu: 0.00 },
 "82671": { name: "Assay Of Estrogens", wrvu: 0.00 },
 "82672": { name: "Assay Of Estrogen", wrvu: 0.00 },
 "82677": { name: "Assay Of Estriol", wrvu: 0.00 },
 "82679": { name: "Assay Of Estrone", wrvu: 0.00 },
 "82681": { name: "Assay Dir Meas Fr Estradiol", wrvu: 0.00 },
 "82693": { name: "Assay Of Ethylene Glycol", wrvu: 0.00 },
 "82696": { name: "Assay Of Etiocholanolone", wrvu: 0.00 },
 "82705": { name: "Fats/lipids Feces Qual", wrvu: 0.00 },
 "82710": { name: "Fats/lipids Feces Quant", wrvu: 0.00 },
 "82715": { name: "Assay Of Fecal Fat", wrvu: 0.00 },
 "82725": { name: "Assay Of Blood Fatty Acids", wrvu: 0.00 },
 "82726": { name: "Long Chain Fatty Acids", wrvu: 0.00 },
 "82728": { name: "Assay Of Ferritin", wrvu: 0.00 },
 "82731": { name: "Assay Of Fetal Fibronectin", wrvu: 0.00 },
 "82735": { name: "Assay Of Fluoride", wrvu: 0.00 },
 "82746": { name: "Assay Of Folic Acid Serum", wrvu: 0.00 },
 "82747": { name: "Assay Of Folic Acid Reduction Blood Cell", wrvu: 0.00 },
 "82757": { name: "Assay Of Semen Fructose", wrvu: 0.00 },
 "82759": { name: "Assay Of Reduction Blood Cell Galactokinase", wrvu: 0.00 },
 "82760": { name: "Assay Of Galactose", wrvu: 0.00 },
 "82775": { name: "Assay Galactose Transferase", wrvu: 0.00 },
 "82776": { name: "Galactose Transferase Test", wrvu: 0.00 },
 "82777": { name: "Galectin-3", wrvu: 0.00 },
 "82784": { name: "Assay Iga/igd/igg/igm Each", wrvu: 0.00 },
 "82785": { name: "Assay Of Ige", wrvu: 0.00 },
 "82787": { name: "Igg 1 2 3 Or 4 Each", wrvu: 0.00 },
 "82800": { name: "Blood Ph", wrvu: 0.00 },
 "82803": { name: "Blood Gases Any Combination", wrvu: 0.00 },
 "82805": { name: "Blood Gases With O2 Saturation", wrvu: 0.00 },
 "82810": { name: "Blood Gases O2 Sat Only", wrvu: 0.00 },
 "82820": { name: "Hemoglobin-oxygen Affinity", wrvu: 0.00 },
 "82930": { name: "Gastric Analy With Ph Each Specimen", wrvu: 0.00 },
 "82938": { name: "Gastrin Test", wrvu: 0.00 },
 "82941": { name: "Assay Of Gastrin", wrvu: 0.00 },
 "82943": { name: "Assay Of Glucagon", wrvu: 0.00 },
 "82945": { name: "Glucose Other Fluid", wrvu: 0.00 },
 "82946": { name: "Glucagon Tolerance Test", wrvu: 0.00 },
 "82947": { name: "Glucose, Quantitative (blood glucose)", wrvu: 0.00 },
 "82948": { name: "Glucose, Blood Reagent Strip", wrvu: 0.00 },
 "82950": { name: "Glucose Test", wrvu: 0.00 },
 "82951": { name: "Glucose Tolerance Test (gtt)", wrvu: 0.00 },
 "82952": { name: "Gtt-added Samples", wrvu: 0.00 },
 "82955": { name: "Assay Of G6pd Enzyme", wrvu: 0.00 },
 "82960": { name: "Test For G6pd Enzyme", wrvu: 0.00 },
 "82962": { name: "Glucose, Blood by Glucose Monitoring Device (glucometer)", wrvu: 0.00 },
 "82963": { name: "Assay Of Glucosidase", wrvu: 0.00 },
 "82965": { name: "Assay Of Gdh Enzyme", wrvu: 0.00 },
 "82977": { name: "Assay Of GGT", wrvu: 0.00 },
 "82978": { name: "Assay Of Glutathione", wrvu: 0.00 },
 "82979": { name: "Assay Reduction Blood Cell Glutathione", wrvu: 0.00 },
 "82985": { name: "Assay Of Glycated Protein", wrvu: 0.00 },
 "83001": { name: "Assay Of Gonadotropin (FSH)", wrvu: 0.00 },
 "83002": { name: "Assay Of Gonadotropin (lh)", wrvu: 0.00 },
 "83003": { name: "Assay Growth Hormone (hgh)", wrvu: 0.00 },
 "83006": { name: "Growth Stimulation Gene 2", wrvu: 0.00 },
 "83009": { name: "H Pylori (c-13) Blood", wrvu: 0.00 },
 "83010": { name: "Assay Of Haptoglobin Quant", wrvu: 0.00 },
 "83012": { name: "Assay Of Haptoglobins", wrvu: 0.00 },
 "83013": { name: "H Pylori (c-13) Breath", wrvu: 0.00 },
 "83014": { name: "H Pylori Drug Administration", wrvu: 0.00 },
 "83015": { name: "Heavy Metal Qual Any Number", wrvu: 0.00 },
 "83018": { name: "Heavy Metal Quan Each Nes", wrvu: 0.00 },
 "83020": { name: "Hemoglobin Electrophoresis", wrvu: 0.00 },
 "83021": { name: "Hemoglobin Chromotography", wrvu: 0.00 },
 "83026": { name: "Hemoglobin Copper Sulfate", wrvu: 0.00 },
 "83030": { name: "Hemoglobin F Fetal Chemical", wrvu: 0.00 },
 "83033": { name: "Hemoglobin Fetal F Assay Qual", wrvu: 0.00 },
 "83036": { name: "Hemoglobin HbA1c (HbA1c)", wrvu: 0.00 },
 "83037": { name: "Hb Glycosylated HbA1c Home Device", wrvu: 0.00 },
 "83045": { name: "Hemoglobin Methemoglobin Qual", wrvu: 0.00 },
 "83050": { name: "Hemoglobin Methemoglobin Quan", wrvu: 0.00 },
 "83051": { name: "Hemoglobin Plasma", wrvu: 0.00 },
 "83060": { name: "Hemoglobin Sulfhemoglobin Quan", wrvu: 0.00 },
 "83065": { name: "Hemoglobin Thermolabile", wrvu: 0.00 },
 "83068": { name: "Hemoglobin Unstable Screen", wrvu: 0.00 },
 "83069": { name: "Hemoglobin Urine", wrvu: 0.00 },
 "83070": { name: "Assay Of Hemosiderin Qual", wrvu: 0.00 },
 "83080": { name: "Assay Of B Hexosaminidase Each", wrvu: 0.00 },
 "83088": { name: "Assay Of Histamine", wrvu: 0.00 },
 "83090": { name: "Assay Of Homocysteine", wrvu: 0.00 },
 "83150": { name: "Assay Of Homovanillic Acid", wrvu: 0.00 },
 "83491": { name: "Asy Hydroxycorticosteroids17", wrvu: 0.00 },
 "83497": { name: "Assay Of 5-hiaa", wrvu: 0.00 },
 "83498": { name: "Asy Hydroxyprogesterone 17-d", wrvu: 0.00 },
 "83500": { name: "Assay Free Hydroxyproline", wrvu: 0.00 },
 "83505": { name: "Assay Total Hydroxyproline", wrvu: 0.00 },
 "83516": { name: "Immunoassay Nonantibody", wrvu: 0.00 },
 "83518": { name: "Immunoassay Dipstick", wrvu: 0.00 },
 "83519": { name: "Ria Nonantibody", wrvu: 0.00 },
 "83520": { name: "Immunoassay Quant Not Otherwise Specified Nonab", wrvu: 0.00 },
 "83521": { name: "Ig Light Chains Free Each", wrvu: 0.00 },
 "83525": { name: "Assay Of Insulin", wrvu: 0.00 },
 "83527": { name: "Assay Of Insulin", wrvu: 0.00 },
 "83528": { name: "Assay Of Intrinsic Factor", wrvu: 0.00 },
 "83529": { name: "Asay Of Interleukin-6 (il-6)", wrvu: 0.00 },
 "83540": { name: "Assay Of Iron", wrvu: 0.00 },
 "83550": { name: "Iron Binding Test", wrvu: 0.00 },
 "83570": { name: "Assay Of Idh Enzyme", wrvu: 0.00 },
 "83582": { name: "Assay Of Ketogenic Steroids", wrvu: 0.00 },
 "83586": { name: "Assay 17- Ketosteroids", wrvu: 0.00 },
 "83593": { name: "Fractionation Ketosteroids", wrvu: 0.00 },
 "83605": { name: "Assay Of Lactic Acid", wrvu: 0.00 },
 "83615": { name: "Lactate (ld) (Lactate Dehydrogenase) Enzyme", wrvu: 0.00 },
 "83625": { name: "Assay Of Lactate Dehydrogenase Enzymes", wrvu: 0.00 },
 "83630": { name: "Lactoferrin Fecal (qual)", wrvu: 0.00 },
 "83631": { name: "Lactoferrin Fecal (quant)", wrvu: 0.00 },
 "83632": { name: "Placental Lactogen", wrvu: 0.00 },
 "83633": { name: "Test Urine For Lactose", wrvu: 0.00 },
 "83655": { name: "Assay Of Lead", wrvu: 0.00 },
 "83661": { name: "Lumbar/Sacral Ratio Fetal Lung", wrvu: 0.00 },
 "83662": { name: "Foam Stability Fetal Lung", wrvu: 0.00 },
 "83663": { name: "Fluoroscopy Polarize Fetal Lung", wrvu: 0.00 },
 "83664": { name: "Lamellar Bdy Fetal Lung", wrvu: 0.00 },
 "83670": { name: "Assay Of Laparoscopic Enzyme", wrvu: 0.00 },
 "83690": { name: "Assay Of Lipase", wrvu: 0.00 },
 "83695": { name: "Assay Of Lipoprotein(a)", wrvu: 0.00 },
 "83698": { name: "Assay Lipoprotein Pla2", wrvu: 0.00 },
 "83700": { name: "Lipopro Bld Electrophoretic", wrvu: 0.00 },
 "83701": { name: "Lipoprotein Bld hr Fraction", wrvu: 0.00 },
 "83704": { name: "Lipoprotein Bld Quan Part", wrvu: 0.00 },
 "83718": { name: "Assay Of Lipoprotein", wrvu: 0.00 },
 "83719": { name: "Assay Of Blood Lipoprotein", wrvu: 0.00 },
 "83721": { name: "Assay Of Blood Lipoprotein", wrvu: 0.00 },
 "83722": { name: "Lipoprtn Dir Meas Sd Ldl Chl", wrvu: 0.00 },
 "83727": { name: "Assay Of Lrh Hormone", wrvu: 0.00 },
 "83735": { name: "Assay Of Magnesium", wrvu: 0.00 },
 "83775": { name: "Assay Malate Dehydrogenase", wrvu: 0.00 },
 "83785": { name: "Assay Of Manganese", wrvu: 0.00 },
 "83789": { name: "Mass Spectrometry Qual/quan", wrvu: 0.00 },
 "83825": { name: "Assay Of Mercury", wrvu: 0.00 },
 "83835": { name: "Assay Of Metanephrines", wrvu: 0.00 },
 "83857": { name: "Assay Of Methemalbumin", wrvu: 0.00 },
 "83861": { name: "Microfluid Analy Tears", wrvu: 0.00 },
 "83864": { name: "Mucopolysaccharides", wrvu: 0.00 },
 "83872": { name: "Assay Synovial Fluid Mucin", wrvu: 0.00 },
 "83873": { name: "Assay Of Cerebrospinal Fluid Protein", wrvu: 0.00 },
 "83874": { name: "Assay Of Myoglobin", wrvu: 0.00 },
 "83876": { name: "Assay Myeloperoxidase", wrvu: 0.00 },
 "83880": { name: "Assay Of Natriuretic Peptide", wrvu: 0.00 },
 "83883": { name: "Assay Nephelometry Not Specimen", wrvu: 0.00 },
 "83884": { name: "Assay Neurflmnt Light Chain", wrvu: 0.00 },
 "83885": { name: "Assay Of Nickel", wrvu: 0.00 },
 "83915": { name: "Assay Of Nucleotidase", wrvu: 0.00 },
 "83916": { name: "Oligoclonal Bands", wrvu: 0.00 },
 "83918": { name: "Organic Acids Total Quant", wrvu: 0.00 },
 "83919": { name: "Organic Acids Qual Each", wrvu: 0.00 },
 "83921": { name: "Organic Acid Single Quant", wrvu: 0.00 },
 "83930": { name: "Assay Of Blood Osmolality", wrvu: 0.00 },
 "83935": { name: "Assay Of Urine Osmolality", wrvu: 0.00 },
 "83937": { name: "Assay Of Osteocalcin", wrvu: 0.00 },
 "83945": { name: "Assay Of Oxalate", wrvu: 0.00 },
 "83950": { name: "Oncoprotein Her-2/neu", wrvu: 0.00 },
 "83951": { name: "Oncoprotein Dcp", wrvu: 0.00 },
 "83970": { name: "Assay Of Parathormone", wrvu: 0.00 },
 "83986": { name: "Assay Ph Body Fluid Not Otherwise Specified", wrvu: 0.00 },
 "83987": { name: "Exhaled Breath Condensate", wrvu: 0.00 },
 "83992": { name: "Assay For Phencyclidine", wrvu: 0.00 },
 "83993": { name: "Assay For Calprotectin Fecal", wrvu: 0.00 },
 "84030": { name: "Assay Of Blood Pku", wrvu: 0.00 },
 "84035": { name: "Assay Of Phenylketones", wrvu: 0.00 },
 "84060": { name: "Assay Acid Phosphatase", wrvu: 0.00 },
 "84066": { name: "Assay Prostate Phosphatase", wrvu: 0.00 },
 "84075": { name: "Assay Alkaline Phosphatase", wrvu: 0.00 },
 "84078": { name: "Assay Alkaline Phosphatase", wrvu: 0.00 },
 "84080": { name: "Assay Alkaline Phosphatases", wrvu: 0.00 },
 "84081": { name: "Assay Phosphatidylglycerol", wrvu: 0.00 },
 "84085": { name: "Assay Of Reduction Blood Cell Pg6d Enzyme", wrvu: 0.00 },
 "84087": { name: "Assay Phosphohexose Enzymes", wrvu: 0.00 },
 "84100": { name: "Assay Of Phosphorus", wrvu: 0.00 },
 "84105": { name: "Assay Of Urine Phosphorus", wrvu: 0.00 },
 "84106": { name: "Test For Porphobilinogen", wrvu: 0.00 },
 "84110": { name: "Assay Of Porphobilinogen", wrvu: 0.00 },
 "84112": { name: "Evaluation Amniotic Fluid Protein", wrvu: 0.00 },
 "84119": { name: "Test Urine For Porphyrins", wrvu: 0.00 },
 "84120": { name: "Assay Of Urine Porphyrins", wrvu: 0.00 },
 "84126": { name: "Assay Of Feces Porphyrins", wrvu: 0.00 },
 "84132": { name: "Assay Of Serum Potassium", wrvu: 0.00 },
 "84133": { name: "Assay Of Urine Potassium", wrvu: 0.00 },
 "84134": { name: "Assay Of Prealbumin", wrvu: 0.00 },
 "84135": { name: "Assay Of Pregnanediol", wrvu: 0.00 },
 "84138": { name: "Assay Of Pregnanetriol", wrvu: 0.00 },
 "84140": { name: "Assay Of Pregnenolone", wrvu: 0.00 },
 "84143": { name: "Assay Of 17-hydroxypregneno", wrvu: 0.00 },
 "84144": { name: "Assay Of Progesterone", wrvu: 0.00 },
 "84145": { name: "Procalcitonin (pct)", wrvu: 0.00 },
 "84146": { name: "Assay Of Prolactin", wrvu: 0.00 },
 "84150": { name: "Assay Of Prostaglandin", wrvu: 0.00 },
 "84152": { name: "Assay Of PSA Complexed", wrvu: 0.00 },
 "84153": { name: "Assay Of PSA Total", wrvu: 0.00 },
 "84154": { name: "Assay Of PSA Free", wrvu: 0.00 },
 "84155": { name: "Assay Of Protein Serum", wrvu: 0.00 },
 "84156": { name: "Assay Of Protein Urine", wrvu: 0.00 },
 "84157": { name: "Assay Of Protein Other", wrvu: 0.00 },
 "84160": { name: "Assay Of Protein Any Source", wrvu: 0.00 },
 "84163": { name: "Pappa Serum", wrvu: 0.00 },
 "84165": { name: "Protein E-phoresis Serum", wrvu: 0.00 },
 "84166": { name: "Protein E-phoresis/urine/cerebrospinal fluid", wrvu: 0.00 },
 "84181": { name: "Western Blot Test", wrvu: 0.00 },
 "84182": { name: "Protein Western Blot Test", wrvu: 0.00 },
 "84202": { name: "Assay Reduction Blood Cell Protoporphyrin", wrvu: 0.00 },
 "84203": { name: "Test Reduction Blood Cell Protoporphyrin", wrvu: 0.00 },
 "84206": { name: "Assay Of Proinsulin", wrvu: 0.00 },
 "84207": { name: "Assay Of Vitamin B-6", wrvu: 0.00 },
 "84210": { name: "Assay Of Pyruvate", wrvu: 0.00 },
 "84220": { name: "Assay Of Pyruvate Kinase", wrvu: 0.00 },
 "84228": { name: "Assay Of Quinine", wrvu: 0.00 },
 "84233": { name: "Assay Of Estrogen", wrvu: 0.00 },
 "84234": { name: "Assay Of Progesterone", wrvu: 0.00 },
 "84235": { name: "Assay Of Endocrine Hormone", wrvu: 0.00 },
 "84238": { name: "Assay Nonendocrine Receptor", wrvu: 0.00 },
 "84244": { name: "Assay Of Renin", wrvu: 0.00 },
 "84252": { name: "Assay Of Vitamin B-2", wrvu: 0.00 },
 "84255": { name: "Assay Of Selenium", wrvu: 0.00 },
 "84260": { name: "Assay Of Serotonin", wrvu: 0.00 },
 "84270": { name: "Assay Of Sex Hormone Globul", wrvu: 0.00 },
 "84275": { name: "Assay Of Sialic Acid", wrvu: 0.00 },
 "84285": { name: "Assay Of Silica", wrvu: 0.00 },
 "84295": { name: "Assay Of Serum Sodium", wrvu: 0.00 },
 "84300": { name: "Assay Of Urine Sodium", wrvu: 0.00 },
 "84302": { name: "Assay Of Sweat Sodium", wrvu: 0.00 },
 "84305": { name: "Assay Of Somatomedin", wrvu: 0.00 },
 "84307": { name: "Assay Of Somatostatin", wrvu: 0.00 },
 "84311": { name: "Spectrophotometry", wrvu: 0.00 },
 "84315": { name: "Body Fluid Specific Gravity", wrvu: 0.00 },
 "84375": { name: "Chromatogram Assay Sugars", wrvu: 0.00 },
 "84376": { name: "Sugars Single Qual", wrvu: 0.00 },
 "84377": { name: "Sugars Multiple Qual", wrvu: 0.00 },
 "84378": { name: "Sugars Single Quant", wrvu: 0.00 },
 "84379": { name: "Sugars Multiple Quant", wrvu: 0.00 },
 "84392": { name: "Assay Of Urine Sulfate", wrvu: 0.00 },
 "84393": { name: "Tau Phosphorylated Each", wrvu: 0.00 },
 "84394": { name: "Total Tau", wrvu: 0.00 },
 "84402": { name: "Assay Of Free Testosterone", wrvu: 0.00 },
 "84403": { name: "Assay Of Total Testosterone", wrvu: 0.00 },
 "84410": { name: "Testosterone Bioavailable", wrvu: 0.00 },
 "84425": { name: "Assay Of Vitamin B-1", wrvu: 0.00 },
 "84430": { name: "Assay Of Thiocyanate", wrvu: 0.00 },
 "84431": { name: "Thromboxane Urine", wrvu: 0.00 },
 "84432": { name: "Assay Of Thyroglobulin", wrvu: 0.00 },
 "84433": { name: "Asy Thiopurin S-mthyltrnsfrs", wrvu: 0.00 },
 "84436": { name: "Assay Of Total Thyroxine", wrvu: 0.00 },
 "84437": { name: "Assay Of Neonatal Thyroxine", wrvu: 0.00 },
 "84439": { name: "Assay Of Free Thyroxine", wrvu: 0.00 },
 "84442": { name: "Assay Of Thyroid Activity", wrvu: 0.00 },
 "84443": { name: "Assay Thyroid Stimulation Hormone", wrvu: 0.00 },
 "84445": { name: "Assay Of Tsi Globulin", wrvu: 0.00 },
 "84446": { name: "Assay Of Vitamin E", wrvu: 0.00 },
 "84449": { name: "Assay Of Transcortin", wrvu: 0.00 },
 "84450": { name: "Transferase AST (sgot)", wrvu: 0.00 },
 "84460": { name: "Alanine Amino ALT (sgpt)", wrvu: 0.00 },
 "84466": { name: "Assay Of Transferrin", wrvu: 0.00 },
 "84478": { name: "Assay Of Triglycerides", wrvu: 0.00 },
 "84479": { name: "Assay Of Thyroid (t3 Or T4)", wrvu: 0.00 },
 "84480": { name: "Assay Triiodothyronine (t3)", wrvu: 0.00 },
 "84481": { name: "Free Assay (ft-3)", wrvu: 0.00 },
 "84482": { name: "T3 Reverse", wrvu: 0.00 },
 "84484": { name: "Assay Of Troponin Quant", wrvu: 0.00 },
 "84485": { name: "Assay Duodenal Fluid Trypsin", wrvu: 0.00 },
 "84488": { name: "Test Feces For Trypsin", wrvu: 0.00 },
 "84490": { name: "Assay Of Feces For Trypsin", wrvu: 0.00 },
 "84510": { name: "Assay Of Tyrosine", wrvu: 0.00 },
 "84512": { name: "Assay Of Troponin Qual", wrvu: 0.00 },
 "84520": { name: "Assay Of Urea Nitrogen", wrvu: 0.00 },
 "84525": { name: "Urea Nitrogen Semi-quant", wrvu: 0.00 },
 "84540": { name: "Assay Of Urine/urea-n", wrvu: 0.00 },
 "84545": { name: "Urea-n Clearance Test", wrvu: 0.00 },
 "84550": { name: "Assay Of Blood/uric Acid", wrvu: 0.00 },
 "84560": { name: "Assay Of Urine/uric Acid", wrvu: 0.00 },
 "84577": { name: "Assay Of Feces/urobilinogen", wrvu: 0.00 },
 "84578": { name: "Test Urine Urobilinogen", wrvu: 0.00 },
 "84580": { name: "Assay Of Urine Urobilinogen", wrvu: 0.00 },
 "84583": { name: "Assay Of Urine Urobilinogen", wrvu: 0.00 },
 "84585": { name: "Assay Of Urine Vma", wrvu: 0.00 },
 "84586": { name: "Assay Of Vip", wrvu: 0.00 },
 "84588": { name: "Assay Of Vasopressin", wrvu: 0.00 },
 "84590": { name: "Assay Of Vitamin A", wrvu: 0.00 },
 "84591": { name: "Assay Of Not Otherwise Specified Vitamin", wrvu: 0.00 },
 "84597": { name: "Assay Of Vitamin K", wrvu: 0.00 },
 "84600": { name: "Assay Of Volatiles", wrvu: 0.00 },
 "84620": { name: "Xylose Tolerance Test", wrvu: 0.00 },
 "84630": { name: "Assay Of Zinc", wrvu: 0.00 },
 "84681": { name: "Assay Of C-peptide", wrvu: 0.00 },
 "84702": { name: "Chorionic Gonadotropin Test", wrvu: 0.00 },
 "84703": { name: "Chorionic Gonadotropin Assay", wrvu: 0.00 },
 "84704": { name: "hCG Free Betachain Test", wrvu: 0.00 },
 "84830": { name: "Ovulation Tests", wrvu: 0.00 },
 "84999": { name: "Unlisted Chemistry Procedure", wrvu: 0.00 },
 "85002": { name: "Bleeding Time Test", wrvu: 0.00 },
 "85004": { name: "Automated Diff White Blood Cell Count", wrvu: 0.00 },
 "85007": { name: "Bl Smear With Diff White Blood Cell Count", wrvu: 0.00 },
 "85008": { name: "Bl Smear Without Diff White Blood Cell Count", wrvu: 0.00 },
 "85009": { name: "Manual Diff White Blood Cell Count B-coat", wrvu: 0.00 },
 "85013": { name: "Hematocrit", wrvu: 0.00 },
 "85014": { name: "Hematocrit (spun microhematocrit)", wrvu: 0.00 },
 "85018": { name: "Hemoglobin", wrvu: 0.00 },
 "85025": { name: "Complete CBC With Auto Diff White Blood Cell", wrvu: 0.00 },
 "85027": { name: "Complete CBC Automated", wrvu: 0.00 },
 "85032": { name: "Manual Cell Count Each", wrvu: 0.00 },
 "85041": { name: "Automated Reduction Blood Cell Count", wrvu: 0.00 },
 "85044": { name: "Manual Reticulocyte Count", wrvu: 0.00 },
 "85045": { name: "Automated Reticulocyte Count", wrvu: 0.00 },
 "85046": { name: "Reticyte/Hemoglobin Concentrate", wrvu: 0.00 },
 "85048": { name: "Automated Leukocyte Count", wrvu: 0.00 },
 "85049": { name: "Automated Platelet Count", wrvu: 0.00 },
 "85055": { name: "Reticulated Platelet Assay", wrvu: 0.00 },
 "85060": { name: "Blood Smear Interpretation", wrvu: 0.44 },
 "85097": { name: "Bone Marrow Interpretation", wrvu: 0.92 },
 "85130": { name: "Chromogenic Substrate Assay", wrvu: 0.00 },
 "85170": { name: "Blood Clot Retraction", wrvu: 0.00 },
 "85175": { name: "Blood Clot Lysis Time", wrvu: 0.00 },
 "85210": { name: "Clot Factor Ii Prothrom Specimen", wrvu: 0.00 },
 "85220": { name: "Blooc Clot Factor V Test", wrvu: 0.00 },
 "85230": { name: "Clot Factor Vii Proconvertin", wrvu: 0.00 },
 "85240": { name: "Clot Factor Viii Ahg 1 Stage", wrvu: 0.00 },
 "85244": { name: "Clot Factor Viii Reltd Antgn", wrvu: 0.00 },
 "85245": { name: "Clot Factor Viii View Ristoctn", wrvu: 0.00 },
 "85246": { name: "Clot Factor Viii View Antigen", wrvu: 0.00 },
 "85247": { name: "Clot Factor Viii Multimetric", wrvu: 0.00 },
 "85250": { name: "Clot Factor Ix Ptc/chrstmas", wrvu: 0.00 },
 "85260": { name: "Clot Factor X Stuart-power", wrvu: 0.00 },
 "85270": { name: "Clot Factor Xi Pta", wrvu: 0.00 },
 "85280": { name: "Clot Factor Xii Hageman", wrvu: 0.00 },
 "85290": { name: "Clot Factor Xiii Fibrin Stab", wrvu: 0.00 },
 "85291": { name: "Clot Factor Xiii Fibrin Scrn", wrvu: 0.00 },
 "85292": { name: "Clot Factor Fletcher Fact", wrvu: 0.00 },
 "85293": { name: "Clot Factor Wght Kininogen", wrvu: 0.00 },
 "85300": { name: "Antithrombin Iii Activity", wrvu: 0.00 },
 "85301": { name: "Antithrombin Iii Antigen", wrvu: 0.00 },
 "85302": { name: "Clot Inhibit Prot C Antigen", wrvu: 0.00 },
 "85303": { name: "Clot Inhibit Prot C Activity", wrvu: 0.00 },
 "85305": { name: "Clot Inhibit Prot S Total", wrvu: 0.00 },
 "85306": { name: "Clot Inhibit Prot S Free", wrvu: 0.00 },
 "85307": { name: "Assay Activated Protein C", wrvu: 0.00 },
 "85335": { name: "Factor Inhibitor Test", wrvu: 0.00 },
 "85337": { name: "Thrombomodulin", wrvu: 0.00 },
 "85345": { name: "Coagulation Time Lee & White", wrvu: 0.00 },
 "85347": { name: "Coagulation Time Activated", wrvu: 0.00 },
 "85348": { name: "Coagulation Time Otr Method", wrvu: 0.00 },
 "85360": { name: "Euglobulin Lysis", wrvu: 0.00 },
 "85362": { name: "Fibrin Degradation Products", wrvu: 0.00 },
 "85366": { name: "Fibrinogen Test", wrvu: 0.00 },
 "85370": { name: "Fibrinogen Test", wrvu: 0.00 },
 "85378": { name: "Fibrin Degrade Semiquant", wrvu: 0.00 },
 "85379": { name: "Fibrin Degradation Quant", wrvu: 0.00 },
 "85380": { name: "Fibrin Degradj D-D-dimer", wrvu: 0.00 },
 "85384": { name: "Fibrinogen Activity", wrvu: 0.00 },
 "85385": { name: "Fibrinogen Antigen", wrvu: 0.00 },
 "85390": { name: "Fibrinolysins Screen I and r", wrvu: 0.00 },
 "85396": { name: "Clotting Assay Whole Blood", wrvu: 0.36 },
 "85397": { name: "Clotting Funct Activity", wrvu: 0.00 },
 "85400": { name: "Fibrinolytic Plasmin", wrvu: 0.00 },
 "85410": { name: "Fibrinolytic Antiplasmin", wrvu: 0.00 },
 "85415": { name: "Fibrinolytic Plasminogen", wrvu: 0.00 },
 "85420": { name: "Fibrinolytic Plasminogen", wrvu: 0.00 },
 "85421": { name: "Fibrinolytic Plasminogen", wrvu: 0.00 },
 "85441": { name: "Heinz Bodies Direct", wrvu: 0.00 },
 "85445": { name: "Heinz Bodies Induced", wrvu: 0.00 },
 "85460": { name: "Hemoglobin Fetal", wrvu: 0.00 },
 "85461": { name: "Hemoglobin Fetal", wrvu: 0.00 },
 "85475": { name: "Hemolysin Acid", wrvu: 0.00 },
 "85520": { name: "Heparin Assay", wrvu: 0.00 },
 "85525": { name: "Heparin Neutralization", wrvu: 0.00 },
 "85530": { name: "Heparin-protamine Tolerance", wrvu: 0.00 },
 "85536": { name: "Iron Stain Peripheral Blood", wrvu: 0.00 },
 "85540": { name: "White Blood Cell Alkaline Phosphatase", wrvu: 0.00 },
 "85547": { name: "Reduction Blood Cell Mechanical Fragility", wrvu: 0.00 },
 "85549": { name: "Muramidase", wrvu: 0.00 },
 "85555": { name: "Reduction Blood Cell Osmotic Fragility", wrvu: 0.00 },
 "85557": { name: "Reduction Blood Cell Osmotic Fragility", wrvu: 0.00 },
 "85576": { name: "Blood Platelet Aggregation", wrvu: 0.00 },
 "85597": { name: "Phospholipid Pltlt Neutraliz", wrvu: 0.00 },
 "85598": { name: "Hexagnal Phosph Pltlt Neutrl", wrvu: 0.00 },
 "85610": { name: "Prothrombin Time", wrvu: 0.00 },
 "85611": { name: "Prothrombin Test", wrvu: 0.00 },
 "85612": { name: "Viper Venom Prothrombin Time", wrvu: 0.00 },
 "85613": { name: "Russell Viper Venom Diluted", wrvu: 0.00 },
 "85635": { name: "Reptilase Test", wrvu: 0.00 },
 "85651": { name: "Reduction Blood Cell Sed Rate Nonautomated", wrvu: 0.00 },
 "85652": { name: "Reduction Blood Cell Sed Rate Automated", wrvu: 0.00 },
 "85660": { name: "Reduction Blood Cell Sickle Cell Test", wrvu: 0.00 },
 "85670": { name: "Thrombin Time Plasma", wrvu: 0.00 },
 "85675": { name: "Thrombin Time Titer", wrvu: 0.00 },
 "85705": { name: "Thromboplastin Inhibition", wrvu: 0.00 },
 "85730": { name: "Thromboplastin Time Partial", wrvu: 0.00 },
 "85732": { name: "Thromboplastin Time Partial", wrvu: 0.00 },
 "85810": { name: "Blood Viscosity Examination", wrvu: 0.00 },
 "85999": { name: "Unlisted Hematology and coagj Procedure", wrvu: 0.00 },
 "86000": { name: "Agglutinins Febrile Antigen", wrvu: 0.00 },
 "86001": { name: "Allergen Specific Igg", wrvu: 0.00 },
 "86003": { name: "Allg Specimen Ige Crude Xtrc Each", wrvu: 0.00 },
 "86005": { name: "Allg Specimen Ige Multiallg Scr", wrvu: 0.00 },
 "86008": { name: "Allg Specimen Ige Recomb Each", wrvu: 0.00 },
 "86015": { name: "Actin Antibody Each", wrvu: 0.00 },
 "86021": { name: "White Blood Cell Antibody Identification", wrvu: 0.00 },
 "86022": { name: "Platelet Antibodies", wrvu: 0.00 },
 "86023": { name: "Immunoglobulin Assay", wrvu: 0.00 },
 "86036": { name: "Anca Screen Each Antibody", wrvu: 0.00 },
 "86037": { name: "Anca Titer Each Antibody", wrvu: 0.00 },
 "86038": { name: "Antinuclear Antibodies", wrvu: 0.00 },
 "86039": { name: "Antinuclear Antibodies (Antinuclear Antibody)", wrvu: 0.00 },
 "86041": { name: "Acetylcholn Rcptr Bndng Antb", wrvu: 0.00 },
 "86042": { name: "Acetylcholn Rcptr Blckg Antb", wrvu: 0.00 },
 "86043": { name: "Acetylcholn Rcptr Modlg Antb", wrvu: 0.00 },
 "86051": { name: "Aquaporin-4 Antb Elisa", wrvu: 0.00 },
 "86052": { name: "Aquaporin-4 Antb Cba Each", wrvu: 0.00 },
 "86053": { name: "Aqaprn-4 Antb Flo Cytmtry Each", wrvu: 0.00 },
 "86060": { name: "Antistreptolysin O Titer", wrvu: 0.00 },
 "86063": { name: "Antistreptolysin O Screen", wrvu: 0.00 },
 "86077": { name: "Phys Blood Bank Serv Xmatch", wrvu: 0.92 },
 "86078": { name: "Phys Blood Bank Serv Reactj", wrvu: 0.92 },
 "86079": { name: "Phys Blood Bank Serv Authrj", wrvu: 0.92 },
 "86140": { name: "C-reactive Protein", wrvu: 0.00 },
 "86141": { name: "C-reactive Protein Hs", wrvu: 0.00 },
 "86146": { name: "Beta-2 Glycoprotein Antibody", wrvu: 0.00 },
 "86147": { name: "Cardiolipin Antibody Each Ig", wrvu: 0.00 },
 "86148": { name: "Anti-phospholipid Antibody", wrvu: 0.00 },
 "86152": { name: "Cell Enumeration & Id", wrvu: 0.00 },
 "86155": { name: "Chemotaxis Assay", wrvu: 0.00 },
 "86156": { name: "Cold Agglutinin Screen", wrvu: 0.00 },
 "86157": { name: "Cold Agglutinin Titer", wrvu: 0.00 },
 "86160": { name: "Complement Antigen", wrvu: 0.00 },
 "86161": { name: "Complement/function Activity", wrvu: 0.00 },
 "86162": { name: "Complement Total (ch50)", wrvu: 0.00 },
 "86171": { name: "Complement Fixation Each", wrvu: 0.00 },
 "86200": { name: "Ccp Antibody", wrvu: 0.00 },
 "86215": { name: "Deoxyribonuclease Antibody", wrvu: 0.00 },
 "86225": { name: "Dna Antibody Native", wrvu: 0.00 },
 "86226": { name: "Dna Antibody Single Strand", wrvu: 0.00 },
 "86231": { name: "Ema Each Ig Class", wrvu: 0.00 },
 "86235": { name: "Nuclear Antigen Antibody", wrvu: 0.00 },
 "86255": { name: "Fluorescent Antibody Screen", wrvu: 0.00 },
 "86256": { name: "Fluorescent Antibody Titer", wrvu: 0.00 },
 "86258": { name: "Dgp Antibody Each Ig Class", wrvu: 0.00 },
 "86277": { name: "Growth Hormone Antibody", wrvu: 0.00 },
 "86280": { name: "Hemagglutination Inhibition", wrvu: 0.00 },
 "86294": { name: "Immunoassay Tumor Qual", wrvu: 0.00 },
 "86300": { name: "Immunoassay Tumor Ca 15-3", wrvu: 0.00 },
 "86301": { name: "Immunoassay Tumor Ca 19-9", wrvu: 0.00 },
 "86304": { name: "Immunoassay Tumor Ca 125", wrvu: 0.00 },
 "86305": { name: "Human Epididymis Protein 4", wrvu: 0.00 },
 "86308": { name: "Heterophile Antibody Screen", wrvu: 0.00 },
 "86309": { name: "Heterophile Antibody Titer", wrvu: 0.00 },
 "86310": { name: "Heterophile Antibody Absrbj", wrvu: 0.00 },
 "86316": { name: "Immunoassay Tumor Other", wrvu: 0.00 },
 "86317": { name: "Immunoassay Infectious Agent", wrvu: 0.00 },
 "86318": { name: "Ia Infectious Agent Antibody", wrvu: 0.00 },
 "86320": { name: "Serum Immunoelectrophoresis", wrvu: 0.00 },
 "86325": { name: "Other Immunoelectrophoresis", wrvu: 0.00 },
 "86328": { name: "Ia Nfct Ab Sarscov2 Covid19", wrvu: 0.00 },
 "86329": { name: "Immunodiffusion Nes", wrvu: 0.00 },
 "86331": { name: "Immunodiffusion Ouchterlony", wrvu: 0.00 },
 "86332": { name: "Immune Complex Assay", wrvu: 0.00 },
 "86334": { name: "Immunofix E-phoresis Serum", wrvu: 0.00 },
 "86335": { name: "Immunfix E-phorsis/urine/cerebrospinal fluid", wrvu: 0.00 },
 "86336": { name: "Inhibin A", wrvu: 0.00 },
 "86337": { name: "Insulin Antibodies", wrvu: 0.00 },
 "86340": { name: "Intrinsic Factor Antibody", wrvu: 0.00 },
 "86341": { name: "Islet Cell Antibody", wrvu: 0.00 },
 "86343": { name: "Leukocyte Histamine Release", wrvu: 0.00 },
 "86344": { name: "Leukocyte Phagocytosis", wrvu: 0.00 },
 "86352": { name: "Cell Function Assay With Stimulation", wrvu: 0.00 },
 "86353": { name: "Lymphocyte Transformation", wrvu: 0.00 },
 "86355": { name: "B Cells Total Count", wrvu: 0.00 },
 "86356": { name: "Mononuclear Cell Antigen", wrvu: 0.00 },
 "86357": { name: "Nk Cells Total Count", wrvu: 0.00 },
 "86359": { name: "T Cells Total Count", wrvu: 0.00 },
 "86360": { name: "T Cell Absolute Count/ratio", wrvu: 0.00 },
 "86361": { name: "T Cell Absolute Count", wrvu: 0.00 },
 "86362": { name: "Mog-igg1 Antb Cba Each", wrvu: 0.00 },
 "86363": { name: "Mog-igg1 Antb Flo Cytmtry Each", wrvu: 0.00 },
 "86364": { name: "Tiss Trnsgltmnase Each Ig Clas", wrvu: 0.00 },
 "86366": { name: "Muscle-specific Kinase Antb", wrvu: 0.00 },
 "86367": { name: "Stem Cells Total Count", wrvu: 0.00 },
 "86376": { name: "Microsomal Antibody Each", wrvu: 0.00 },
 "86381": { name: "Mitochondrial Antibody Each", wrvu: 0.00 },
 "86382": { name: "Neutralization Test Viral", wrvu: 0.00 },
 "86384": { name: "Nitroblue Tetrazolium Dye", wrvu: 0.00 },
 "86386": { name: "Nuclear Matrix Protein 22", wrvu: 0.00 },
 "86403": { name: "Particle Agglut Antbdy Scrn", wrvu: 0.00 },
 "86406": { name: "Particle Agglut Antbdy Titr", wrvu: 0.00 },
 "86408": { name: "Neutrlzg Antb Sarscov2 Scr", wrvu: 0.00 },
 "86409": { name: "Neutrlzg Antb Sarscov2 Titer", wrvu: 0.00 },
 "86413": { name: "Sars-cov-2 Antb Quantitative", wrvu: 0.00 },
 "86430": { name: "Rheumatoid Factor Test Qual", wrvu: 0.00 },
 "86431": { name: "Rheumatoid Factor Quant", wrvu: 0.00 },
 "86480": { name: "TB Test Cell Immun Measure", wrvu: 0.00 },
 "86481": { name: "TB Ag Response T-cell Susp", wrvu: 0.00 },
 "86485": { name: "Skin Test Candida", wrvu: 0.00 },
 "86486": { name: "Skin Test Unlisted Antign Each", wrvu: 0.00 },
 "86510": { name: "Histoplasmosis Skin Test", wrvu: 0.00 },
 "86580": { name: "Tuberculosis Skin Test (PPD (TB Test)/Mantoux)", wrvu: 0.00 },
 "86581": { name: "Strptcs Pneum Antb Serot Ia", wrvu: 0.00 },
 "86590": { name: "Streptokinase Antibody", wrvu: 0.00 },
 "86592": { name: "Syphilis Test Non-trep Qual", wrvu: 0.00 },
 "86593": { name: "Syphilis Test Non-trep Quant", wrvu: 0.00 },
 "86596": { name: "Voltage-gtd Ca Chnl Antb Each", wrvu: 0.00 },
 "86602": { name: "Antinomyces Antibody", wrvu: 0.00 },
 "86603": { name: "Adenovirus Antibody", wrvu: 0.00 },
 "86606": { name: "Aspergillus Antibody", wrvu: 0.00 },
 "86609": { name: "Bacterium Antibody", wrvu: 0.00 },
 "86611": { name: "Bartonella Antibody", wrvu: 0.00 },
 "86612": { name: "Blastomyces Antibody", wrvu: 0.00 },
 "86615": { name: "Bordetella Antibody", wrvu: 0.00 },
 "86617": { name: "Lyme Disease Antibody", wrvu: 0.00 },
 "86618": { name: "Lyme Disease Antibody", wrvu: 0.00 },
 "86619": { name: "Borrelia Antibody", wrvu: 0.00 },
 "86622": { name: "Brucella Antibody", wrvu: 0.00 },
 "86625": { name: "Campylobacter Antibody", wrvu: 0.00 },
 "86628": { name: "Candida Antibody", wrvu: 0.00 },
 "86631": { name: "Chlamydia Antibody", wrvu: 0.00 },
 "86632": { name: "Chlamydia Igm Antibody", wrvu: 0.00 },
 "86635": { name: "Coccidioides Antibody", wrvu: 0.00 },
 "86638": { name: "Q Fever Antibody", wrvu: 0.00 },
 "86641": { name: "Cryptococcus Antibody", wrvu: 0.00 },
 "86644": { name: "Cytomegalovirus Antibody", wrvu: 0.00 },
 "86645": { name: "Cytomegalovirus Antibody Igm", wrvu: 0.00 },
 "86648": { name: "Diphtheria Antibody", wrvu: 0.00 },
 "86651": { name: "Encephalitis Californ Antbdy", wrvu: 0.00 },
 "86652": { name: "Encephaltis East Eqne Anbdy", wrvu: 0.00 },
 "86653": { name: "Encephaltis Speech Therapy Louis Antbody", wrvu: 0.00 },
 "86654": { name: "Encephaltis West Eqne Antbdy", wrvu: 0.00 },
 "86658": { name: "Enterovirus Antibody", wrvu: 0.00 },
 "86663": { name: "Epstein-barr Antibody", wrvu: 0.00 },
 "86664": { name: "Epstein-barr Nuclear Antigen", wrvu: 0.00 },
 "86665": { name: "Epstein-barr Capsid Vca", wrvu: 0.00 },
 "86666": { name: "Ehrlichia Antibody", wrvu: 0.00 },
 "86668": { name: "Francisella Tularensis", wrvu: 0.00 },
 "86671": { name: "Fungus Nes Antibody", wrvu: 0.00 },
 "86674": { name: "Giardia Lamblia Antibody", wrvu: 0.00 },
 "86677": { name: "Helicobacter Pylori Antibody", wrvu: 0.00 },
 "86682": { name: "Helminth Antibody", wrvu: 0.00 },
 "86684": { name: "Hemophilus Influenza Antibdy", wrvu: 0.00 },
 "86687": { name: "Htlv-i Antibody", wrvu: 0.00 },
 "86688": { name: "Htlv-ii Antibody", wrvu: 0.00 },
 "86689": { name: "Htlv/HIV Confirmj Antibody", wrvu: 0.00 },
 "86692": { name: "Hepatitis Delta Agent Antbdy", wrvu: 0.00 },
 "86694": { name: "Herpes Simplex Nes Antbdy", wrvu: 0.00 },
 "86695": { name: "Herpes Simplex Type 1 Test", wrvu: 0.00 },
 "86696": { name: "Herpes Simplex Type 2 Test", wrvu: 0.00 },
 "86698": { name: "Histoplasma Antibody", wrvu: 0.00 },
 "86701": { name: "HIV-1antibody", wrvu: 0.00 },
 "86702": { name: "HIV Antibody", wrvu: 0.00 },
 "86703": { name: "HIV-1/HIV-2 1 Result Antbdy", wrvu: 0.00 },
 "86704": { name: "Hep B Core Antibody Total", wrvu: 0.00 },
 "86705": { name: "Hep B Core Antibody Igm", wrvu: 0.00 },
 "86706": { name: "Hep B Surface Antibody", wrvu: 0.00 },
 "86707": { name: "Hepatitis Be Antibody", wrvu: 0.00 },
 "86708": { name: "Hepatitis A Antibody", wrvu: 0.00 },
 "86709": { name: "Hepatitis A Igm Antibody", wrvu: 0.00 },
 "86710": { name: "Influenza Virus Antibody", wrvu: 0.00 },
 "86711": { name: "John Cunningham Antibody", wrvu: 0.00 },
 "86713": { name: "Legionella Antibody", wrvu: 0.00 },
 "86717": { name: "Leishmania Antibody", wrvu: 0.00 },
 "86720": { name: "Leptospira Antibody", wrvu: 0.00 },
 "86723": { name: "Listeria Monocytogenes", wrvu: 0.00 },
 "86727": { name: "Lymphatic Choriomeningitis Ab", wrvu: 0.00 },
 "86732": { name: "Mucormycosis Antibody", wrvu: 0.00 },
 "86735": { name: "Mumps Antibody", wrvu: 0.00 },
 "86738": { name: "Mycoplasma Antibody", wrvu: 0.00 },
 "86741": { name: "Neisseria Meningitidis", wrvu: 0.00 },
 "86744": { name: "Nocardia Antibody", wrvu: 0.00 },
 "86747": { name: "Parvovirus Antibody", wrvu: 0.00 },
 "86750": { name: "Malaria Antibody", wrvu: 0.00 },
 "86753": { name: "Protozoa Antibody Not Otherwise Specified", wrvu: 0.00 },
 "86756": { name: "Respiratory Virus Antibody", wrvu: 0.00 },
 "86757": { name: "Rickettsia Antibody", wrvu: 0.00 },
 "86759": { name: "Rotavirus Antibody", wrvu: 0.00 },
 "86762": { name: "Rubella Antibody", wrvu: 0.00 },
 "86765": { name: "Rubeola Antibody", wrvu: 0.00 },
 "86768": { name: "Salmonella Antibody", wrvu: 0.00 },
 "86769": { name: "Sars-cov-2 COVID-19-19 Antibody", wrvu: 0.00 },
 "86771": { name: "Shigella Antibody", wrvu: 0.00 },
 "86774": { name: "Tetanus Antibody", wrvu: 0.00 },
 "86777": { name: "Toxoplasma Antibody", wrvu: 0.00 },
 "86778": { name: "Toxoplasma Antibody Igm", wrvu: 0.00 },
 "86780": { name: "Treponema Pallidum", wrvu: 0.00 },
 "86784": { name: "Trichinella Antibody", wrvu: 0.00 },
 "86787": { name: "Varicella-zoster Antibody", wrvu: 0.00 },
 "86788": { name: "West Nile Virus Ab Igm", wrvu: 0.00 },
 "86789": { name: "West Nile Virus Antibody", wrvu: 0.00 },
 "86790": { name: "Virus Antibody Not Otherwise Specified", wrvu: 0.00 },
 "86793": { name: "Yersinia Antibody", wrvu: 0.00 },
 "86794": { name: "Zika Virus Igm Antibody", wrvu: 0.00 },
 "86800": { name: "Thyroglobulin Antibody", wrvu: 0.00 },
 "86803": { name: "Hepatitis C Ab Test", wrvu: 0.00 },
 "86804": { name: "Hep C Ab Test Confirm", wrvu: 0.00 },
 "86805": { name: "Lymphocytotoxicity Assay", wrvu: 0.00 },
 "86806": { name: "Lymphocytotoxicity Assay", wrvu: 0.00 },
 "86807": { name: "Cytotoxic Antibody Screening", wrvu: 0.00 },
 "86808": { name: "Cytotoxic Antibody Screening", wrvu: 0.00 },
 "86812": { name: "Hla Typing A B Or C", wrvu: 0.00 },
 "86813": { name: "Hla Typing A B Or C", wrvu: 0.00 },
 "86816": { name: "Hla Typing Dr/dq", wrvu: 0.00 },
 "86817": { name: "Hla Typing Dr/dq", wrvu: 0.00 },
 "86821": { name: "Lymphocyte Culture Mixed", wrvu: 0.00 },
 "86825": { name: "Hla X-math Non-cytotoxic", wrvu: 0.00 },
 "86826": { name: "Hla X-match Noncytotoxc Additional", wrvu: 0.00 },
 "86828": { name: "Hla Class I and ii Antibody Qual", wrvu: 0.00 },
 "86829": { name: "Hla Class I/ii Antibody Qual", wrvu: 0.00 },
 "86830": { name: "Hla Class I Phenotype Qual", wrvu: 0.00 },
 "86831": { name: "Hla Class Ii Phenotype Qual", wrvu: 0.00 },
 "86832": { name: "Hla Class I High Defin Qual", wrvu: 0.00 },
 "86833": { name: "Hla Class Ii High Defin Qual", wrvu: 0.00 },
 "86834": { name: "Hla Class I Semiquant Panel", wrvu: 0.00 },
 "86835": { name: "Hla Class Ii Semiquant Panel", wrvu: 0.00 },
 "86849": { name: "Immunology Procedure", wrvu: 0.00 },
 "86850": { name: "Reduction Blood Cell Antibody Screen", wrvu: 0.00 },
 "86860": { name: "Reduction Blood Cell Antibody Elution", wrvu: 0.00 },
 "86870": { name: "Reduction Blood Cell Antibody Identification", wrvu: 0.00 },
 "86880": { name: "Coombs Test Direct", wrvu: 0.00 },
 "86885": { name: "Coombs Test Indirect Qual", wrvu: 0.00 },
 "86886": { name: "Coombs Test Indirect Titer", wrvu: 0.00 },
 "86890": { name: "Autologous Blood Process", wrvu: 0.00 },
 "86891": { name: "Autologous Blood Op Salvage", wrvu: 0.00 },
 "86900": { name: "Blood Typing Serologic Abo", wrvu: 0.00 },
 "86901": { name: "Blood Typing Serologic Rh(d)", wrvu: 0.00 },
 "86902": { name: "Blood Type Antigen Donor Each", wrvu: 0.00 },
 "86904": { name: "Blood Typing Patient Serum", wrvu: 0.00 },
 "86905": { name: "Blood Typing Reduction Blood Cell Antigens", wrvu: 0.00 },
 "86906": { name: "Bld Typing Serologic Rh Phnt", wrvu: 0.00 },
 "86910": { name: "Blood Typing Paternity Test", wrvu: 0.00 },
 "86911": { name: "Blood Typing Antigen System", wrvu: 0.00 },
 "86920": { name: "Compatibility Test Spin", wrvu: 0.00 },
 "86921": { name: "Compatibility Test Incubate", wrvu: 0.00 },
 "86922": { name: "Compatibility Test Antiglob", wrvu: 0.00 },
 "86923": { name: "Compatibility Test Electric", wrvu: 0.00 },
 "86927": { name: "Plasma Fresh Frozen", wrvu: 0.00 },
 "86930": { name: "Frozen Blood Prep", wrvu: 0.00 },
 "86931": { name: "Frozen Blood Thaw", wrvu: 0.00 },
 "86932": { name: "Frozen Blood Freeze/thaw", wrvu: 0.00 },
 "86940": { name: "Hemolysins/agglutinins Auto", wrvu: 0.00 },
 "86941": { name: "Hemolysins/agglutinins", wrvu: 0.00 },
 "86945": { name: "Blood Product/irradiation", wrvu: 0.00 },
 "86950": { name: "Leukacyte Transfusion", wrvu: 0.00 },
 "86960": { name: "Vol Reduction Of Blood/prod", wrvu: 0.00 },
 "86965": { name: "Pooling Blood Platelets", wrvu: 0.00 },
 "86970": { name: "Reduction Blood Cell Pretx Incubatj With Chemicl", wrvu: 0.00 },
 "86971": { name: "Reduction Blood Cell Pretx Incubatj With Enzymes", wrvu: 0.00 },
 "86972": { name: "Reduction Blood Cell Pretx Incubatj With Density", wrvu: 0.00 },
 "86975": { name: "Reduction Blood Cell Serum Pretx Incubj Drugs", wrvu: 0.00 },
 "86976": { name: "Reduction Blood Cell Serum Pretx Id Dilution", wrvu: 0.00 },
 "86977": { name: "Reduction Blood Cell Serum Pretx Incubj/inhib", wrvu: 0.00 },
 "86978": { name: "Reduction Blood Cell Pretreatment Serum", wrvu: 0.00 },
 "86985": { name: "Split Blood Or Products", wrvu: 0.00 },
 "86999": { name: "Unlisted Transfusion Medial Procedure", wrvu: 0.00 },
 "87003": { name: "Small Animal Inoculation", wrvu: 0.00 },
 "87015": { name: "Specimen Infect Agnt Concntj", wrvu: 0.00 },
 "87040": { name: "Blood Culture For Bacteria", wrvu: 0.00 },
 "87045": { name: "Feces Culture Aerobic Bact", wrvu: 0.00 },
 "87046": { name: "Stool Culture Aerobic Bact Each", wrvu: 0.00 },
 "87070": { name: "Culture Othr Specimn Aerobic", wrvu: 0.00 },
 "87071": { name: "Culture Aerobic Quant Other", wrvu: 0.00 },
 "87073": { name: "Culture Bacteria Anaerobic", wrvu: 0.00 },
 "87075": { name: "Culture Bacteria Except Blood", wrvu: 0.00 },
 "87076": { name: "Culture Anaerobe Ident Each", wrvu: 0.00 },
 "87077": { name: "Culture Aerobic Identify", wrvu: 0.00 },
 "87081": { name: "Culture Screen Only", wrvu: 0.00 },
 "87084": { name: "Culture Of Specimen By Kit", wrvu: 0.00 },
 "87086": { name: "Urine Culture/colony Count", wrvu: 0.00 },
 "87088": { name: "Urine Bacteria Culture", wrvu: 0.00 },
 "87101": { name: "Skin Fungi Culture", wrvu: 0.00 },
 "87102": { name: "Fungus Isolation Culture", wrvu: 0.00 },
 "87103": { name: "Blood Fungus Culture", wrvu: 0.00 },
 "87106": { name: "Fungi Identification Yeast", wrvu: 0.00 },
 "87107": { name: "Fungi Identification Mold", wrvu: 0.00 },
 "87109": { name: "Mycoplasma", wrvu: 0.00 },
 "87110": { name: "Chlamydia Culture", wrvu: 0.00 },
 "87116": { name: "Mycobacteria Culture", wrvu: 0.00 },
 "87118": { name: "Mycobacteric Identification", wrvu: 0.00 },
 "87140": { name: "Culture Type Immunofluoresc", wrvu: 0.00 },
 "87143": { name: "Culture Typing Glc/hplc", wrvu: 0.00 },
 "87147": { name: "Culture Type Immunologic", wrvu: 0.00 },
 "87149": { name: "DNA/RNA Direct Probe", wrvu: 0.00 },
 "87150": { name: "DNA/RNA Amplified Probe", wrvu: 0.00 },
 "87152": { name: "Culture Type Pulse Field Gel", wrvu: 0.00 },
 "87153": { name: "DNA/RNA Sequencing", wrvu: 0.00 },
 "87154": { name: "Cul Typ Id Bld Pthgn 6+ Trgt", wrvu: 0.00 },
 "87158": { name: "Culture Typing Added Method", wrvu: 0.00 },
 "87164": { name: "Dark Field Exam Specimen Collj", wrvu: 0.00 },
 "87166": { name: "Dark Field Exam Without Collj", wrvu: 0.00 },
 "87168": { name: "Macroscopic Exam Arthropod", wrvu: 0.00 },
 "87169": { name: "Macroscopic Exam Parasite", wrvu: 0.00 },
 "87172": { name: "Pinworm Exam", wrvu: 0.00 },
 "87176": { name: "Tissue Homogenization Culture", wrvu: 0.00 },
 "87177": { name: "Ova And Parasites Smears", wrvu: 0.00 },
 "87181": { name: "Subcutaneous STD Agar Dilution Per Agt", wrvu: 0.00 },
 "87182": { name: "Subcutaneous STD Carbapenemase Nzm Det", wrvu: 0.00 },
 "87183": { name: "Subcutaneous STD Carbapenem Resist Genital", wrvu: 0.00 },
 "87184": { name: "Subcutaneous STD Disk Method Per Plate", wrvu: 0.00 },
 "87185": { name: "Subcutaneous STD Enzyme Detcj Per Nzm", wrvu: 0.00 },
 "87186": { name: "Subcutaneous STD Microdil/agar Dil", wrvu: 0.00 },
 "87187": { name: "Subcutaneous STD Microdil/agar Mlc", wrvu: 0.00 },
 "87188": { name: "Subcutaneous STD Macrobroth Dil Meth", wrvu: 0.00 },
 "87190": { name: "Subcutaneous STD Myobacteria Prop Meth", wrvu: 0.00 },
 "87197": { name: "Serum Bactericidal Titer", wrvu: 0.00 },
 "87205": { name: "Smear Gram Stain", wrvu: 0.00 },
 "87206": { name: "Smear Fluorescent/acid Stai", wrvu: 0.00 },
 "87207": { name: "Smear Special Stain", wrvu: 0.00 },
 "87209": { name: "Smear Complex Stain", wrvu: 0.00 },
 "87210": { name: "Smear Wet Mount Saline/ink", wrvu: 0.00 },
 "87220": { name: "Tissue Exam For Fungi", wrvu: 0.00 },
 "87230": { name: "Toxin/antitoxin Asy Tiss Cul", wrvu: 0.00 },
 "87250": { name: "Virus Inoculate Eggs/animal", wrvu: 0.00 },
 "87252": { name: "Virus Inoculation Tissue", wrvu: 0.00 },
 "87253": { name: "Virus Inoculate Tissue Additional", wrvu: 0.00 },
 "87254": { name: "Virus Inoculation Shell Via", wrvu: 0.00 },
 "87255": { name: "Genet Virus Isolate Herpes Simplex", wrvu: 0.00 },
 "87260": { name: "Adenovirus Ag If", wrvu: 0.00 },
 "87265": { name: "Pertussis Ag If", wrvu: 0.00 },
 "87267": { name: "Enterovirus Antibody Dfa", wrvu: 0.00 },
 "87269": { name: "Giardia Ag If", wrvu: 0.00 },
 "87270": { name: "Chlamydia Trachomatis Ag If", wrvu: 0.00 },
 "87271": { name: "Cytomegalovirus Dfa", wrvu: 0.00 },
 "87272": { name: "Cryptosporidium Ag If", wrvu: 0.00 },
 "87273": { name: "Herpes Simplex 2 Ag If", wrvu: 0.00 },
 "87274": { name: "Herpes Simplex 1 Ag If", wrvu: 0.00 },
 "87275": { name: "Influenza B Ag If", wrvu: 0.00 },
 "87276": { name: "Influenza A Ag If", wrvu: 0.00 },
 "87278": { name: "Legion Pneumophilia Ag If", wrvu: 0.00 },
 "87279": { name: "Parainfluenza Ag If", wrvu: 0.00 },
 "87280": { name: "Respiratory Syncytial Ag If", wrvu: 0.00 },
 "87281": { name: "Pneumocystis Carinii Ag If", wrvu: 0.00 },
 "87283": { name: "Rubeola Ag If", wrvu: 0.00 },
 "87285": { name: "Treponema Pallidum Ag If", wrvu: 0.00 },
 "87290": { name: "Varicella Zoster Ag If", wrvu: 0.00 },
 "87299": { name: "Antibody Detection Not Otherwise Specified If", wrvu: 0.00 },
 "87300": { name: "Ag Detection Polyval If", wrvu: 0.00 },
 "87301": { name: "Adenovirus Ag Ia", wrvu: 0.00 },
 "87305": { name: "Aspergillus Ag Ia", wrvu: 0.00 },
 "87320": { name: "Chlmyd Trach Ag Ia", wrvu: 0.00 },
 "87324": { name: "Clostridium Ag Ia", wrvu: 0.00 },
 "87327": { name: "Cryptococcus Neoform Ag Ia", wrvu: 0.00 },
 "87328": { name: "Cryptosporidium Ag Ia", wrvu: 0.00 },
 "87329": { name: "Giardia Ag Ia", wrvu: 0.00 },
 "87332": { name: "Cytomegalovirus Ag Ia", wrvu: 0.00 },
 "87335": { name: "E Coli 0157 Ag Ia", wrvu: 0.00 },
 "87336": { name: "Entamoeb Hist Dispr Ag Ia", wrvu: 0.00 },
 "87337": { name: "Entamoeb Hist Group Ag Ia", wrvu: 0.00 },
 "87338": { name: "Hpylori Stool Ag Ia", wrvu: 0.00 },
 "87339": { name: "H Pylori Ag Ia", wrvu: 0.00 },
 "87340": { name: "Hepatitis B Surface Ag Ia", wrvu: 0.00 },
 "87341": { name: "Hep B Surface Ag Neutrlzj Ia", wrvu: 0.00 },
 "87350": { name: "Hepatitis Be Ag Ia", wrvu: 0.00 },
 "87380": { name: "Hepatitis Delta Agent Ag Ia", wrvu: 0.00 },
 "87385": { name: "Histoplasma Capsule Ag Ia", wrvu: 0.00 },
 "87389": { name: "HIV Ag With HIV Ab Ag Ia", wrvu: 0.00 },
 "87390": { name: "HIV Ag Ia", wrvu: 0.00 },
 "87391": { name: "HIV Ag Ia", wrvu: 0.00 },
 "87400": { name: "Influenza A/b Each Ag Ia", wrvu: 0.00 },
 "87420": { name: "Resp Syncytial Virus Ag Ia", wrvu: 0.00 },
 "87425": { name: "Rotavirus Ag Ia", wrvu: 0.00 },
 "87426": { name: "COVID-19-19 Antigen Test", wrvu: 0.00 },
 "87427": { name: "Shiga-like Toxin Ag Ia", wrvu: 0.00 },
 "87428": { name: "Sarscov & Inferior Vir A and b Ag Ia", wrvu: 0.00 },
 "87430": { name: "Strep A Ag Ia", wrvu: 0.00 },
 "87449": { name: "Not Otherwise Specified Each Organism Ag Ia", wrvu: 0.00 },
 "87451": { name: "Polyvalent Mult Org Each Ag Ia", wrvu: 0.00 },
 "87467": { name: "Hepatitis B Surface Ag Quan", wrvu: 0.00 },
 "87468": { name: "Anaplsma Phgcytophlm Amp Prb", wrvu: 0.00 },
 "87469": { name: "Babesia Microti Amp Prb", wrvu: 0.00 },
 "87471": { name: "Bartonella Dna Amp Probe", wrvu: 0.00 },
 "87472": { name: "Bartonella Dna Quant", wrvu: 0.00 },
 "87475": { name: "Lyme Dis Dna Dir Probe", wrvu: 0.00 },
 "87476": { name: "Lyme Dis Dna Amp Probe", wrvu: 0.00 },
 "87478": { name: "Borrelia Miyamotoi Amp Prb", wrvu: 0.00 },
 "87480": { name: "Candida Dna Dir Probe", wrvu: 0.00 },
 "87481": { name: "Candida Dna Amp Probe", wrvu: 0.00 },
 "87482": { name: "Candida Dna Quant", wrvu: 0.00 },
 "87483": { name: "Cns Dna Amp Probe Type 12-25", wrvu: 0.00 },
 "87484": { name: "Ehrlicha Chaffeensis Amp Prb", wrvu: 0.00 },
 "87485": { name: "Chlmyd Pneum Dna Dir Probe", wrvu: 0.00 },
 "87486": { name: "Chlmyd Pneum Dna Amp Probe", wrvu: 0.00 },
 "87487": { name: "Chlmyd Pneum Dna Quant", wrvu: 0.00 },
 "87490": { name: "Chlmyd Trach Dna Dir Probe", wrvu: 0.00 },
 "87491": { name: "Chlmyd Trach Dna Amp Probe", wrvu: 0.00 },
 "87492": { name: "Chlmyd Trach Dna Quant", wrvu: 0.00 },
 "87493": { name: "C. Difficile Amplified Probe", wrvu: 0.00 },
 "87494": { name: "Chlmy Trachea and neisra Gonor Mult", wrvu: 0.00 },
 "87495": { name: "Cytomeg Dna Dir Probe", wrvu: 0.00 },
 "87496": { name: "Cytomeg Dna Amp Probe", wrvu: 0.00 },
 "87497": { name: "Cytomeg Dna Quant", wrvu: 0.00 },
 "87498": { name: "Enterovirus Probe and revrs Trns", wrvu: 0.00 },
 "87500": { name: "Vanomycin Dna Amp Probe", wrvu: 0.00 },
 "87501": { name: "Influenza Dna Amp Prob 1+", wrvu: 0.00 },
 "87502": { name: "Influenza Dna Amp Probe", wrvu: 0.00 },
 "87503": { name: "Influenza Dna Amp Prob Additional", wrvu: 0.00 },
 "87505": { name: "Nfct Agent Detection Gastrointestinal", wrvu: 0.00 },
 "87506": { name: "Iadna-DNA/RNA Probe Tq 6-11", wrvu: 0.00 },
 "87507": { name: "Iadna-DNA/RNA Probe Tq 12-25", wrvu: 0.00 },
 "87510": { name: "Gardner Vaginal Dna Dir Probe", wrvu: 0.00 },
 "87511": { name: "Gardner Vaginal Dna Amp Probe", wrvu: 0.00 },
 "87512": { name: "Gardner Vaginal Dna Quant", wrvu: 0.00 },
 "87513": { name: "H Pylri Clrthmcn Rst Amp Prb", wrvu: 0.00 },
 "87516": { name: "Hepatitis B Dna Amp Probe", wrvu: 0.00 },
 "87517": { name: "Hepatitis B Dna Quant", wrvu: 0.00 },
 "87520": { name: "Hepatitis C Rna Dir Probe", wrvu: 0.00 },
 "87521": { name: "Hepatitis C Probe and rvrs Trnsc", wrvu: 0.00 },
 "87522": { name: "Hepatitis C Revrs Trnscrpj", wrvu: 0.00 },
 "87523": { name: "Hepatitis D Quantification", wrvu: 0.00 },
 "87525": { name: "Hepatitis G Dna Dir Probe", wrvu: 0.00 },
 "87526": { name: "Hepatitis G Dna Amp Probe", wrvu: 0.00 },
 "87527": { name: "Hepatitis G Dna Quant", wrvu: 0.00 },
 "87528": { name: "Herpes Simplex Dna Dir Probe", wrvu: 0.00 },
 "87529": { name: "Herpes Simplex Dna Amp Probe", wrvu: 0.00 },
 "87530": { name: "Herpes Simplex Dna Quant", wrvu: 0.00 },
 "87531": { name: "Hhv-6 Dna Dir Probe", wrvu: 0.00 },
 "87532": { name: "Hhv-6 Dna Amp Probe", wrvu: 0.00 },
 "87533": { name: "Hhv-6 Dna Quant", wrvu: 0.00 },
 "87534": { name: "HIV Dna Dir Probe", wrvu: 0.00 },
 "87535": { name: "HIV Probe and reverse Trnscrpj", wrvu: 0.00 },
 "87536": { name: "HIV Quant and revrse Trnscrpj", wrvu: 0.00 },
 "87537": { name: "HIV Dna Dir Probe", wrvu: 0.00 },
 "87538": { name: "HIV Probe and revrse Trnscripj", wrvu: 0.00 },
 "87539": { name: "HIV Quant and revrse Trnscripj", wrvu: 0.00 },
 "87540": { name: "Legion Pneumococcal Dna Dir Prob", wrvu: 0.00 },
 "87541": { name: "Legion Pneumococcal Dna Amp Prob", wrvu: 0.00 },
 "87542": { name: "Legion Pneumococcal Dna Quant", wrvu: 0.00 },
 "87550": { name: "Mycobacteria Dna Dir Probe", wrvu: 0.00 },
 "87551": { name: "Mycobacteria Dna Amp Probe", wrvu: 0.00 },
 "87552": { name: "Mycobacteria Dna Quant", wrvu: 0.00 },
 "87555": { name: "M.tuberculo Dna Dir Probe", wrvu: 0.00 },
 "87556": { name: "M.tuberculo Dna Amp Probe", wrvu: 0.00 },
 "87557": { name: "M.tuberculo Dna Quant", wrvu: 0.00 },
 "87560": { name: "M.avium-intra Dna Dir Prob", wrvu: 0.00 },
 "87561": { name: "M.avium-intra Dna Amp Prob", wrvu: 0.00 },
 "87562": { name: "M.avium-intra Dna Quant", wrvu: 0.00 },
 "87563": { name: "M. Genitalium Amp Probe", wrvu: 0.00 },
 "87564": { name: "Mtb Rifampin Rst Amp Prb Tq", wrvu: 0.00 },
 "87580": { name: "M.pneumon Dna Dir Probe", wrvu: 0.00 },
 "87581": { name: "M.pneumon Dna Amp Probe", wrvu: 0.00 },
 "87582": { name: "M.pneumon Dna Quant", wrvu: 0.00 },
 "87590": { name: "N.gonorrhoeae Dna Dir Prob", wrvu: 0.00 },
 "87591": { name: "N.gonorrhoeae Dna Amp Prob", wrvu: 0.00 },
 "87592": { name: "N.gonorrhoeae Dna Quant", wrvu: 0.00 },
 "87593": { name: "Orthopoxvirus Amp Prb Each", wrvu: 0.00 },
 "87594": { name: "Pneumcysts Jirovecii Amp Prb", wrvu: 0.00 },
 "87623": { name: "HPV Low-risk Types", wrvu: 0.00 },
 "87624": { name: "HPV High-risk Typ Pooled Rslt", wrvu: 0.00 },
 "87625": { name: "HPV Types 16 & 18 Only", wrvu: 0.00 },
 "87626": { name: "HPV Sep High-rsk Typ and pool Rslt", wrvu: 0.00 },
 "87627": { name: "Joint Spc Pthgn and Prescription Rsist Gen26+", wrvu: 0.00 },
 "87631": { name: "Resp Virus 3-5 Targets", wrvu: 0.00 },
 "87632": { name: "Resp Virus 6-11 Targets", wrvu: 0.00 },
 "87633": { name: "Resp Virus 12-25 Targets", wrvu: 0.00 },
 "87634": { name: "RSV DNA/RNA Amp Probe", wrvu: 0.00 },
 "87635": { name: "Sars-cov-2 COVID-19-19 Amp Prb", wrvu: 0.00 },
 "87636": { name: "Sarscov2 & Inferior A and b Amp Prb", wrvu: 0.00 },
 "87637": { name: "Sarscov2 and inferior A and b and RSV Amp Prb", wrvu: 0.00 },
 "87640": { name: "Staph A Dna Amp Probe", wrvu: 0.00 },
 "87641": { name: "Mr-staph Dna Amp Probe", wrvu: 0.00 },
 "87650": { name: "Strep A Dna Dir Probe", wrvu: 0.00 },
 "87651": { name: "Strep A Dna Amp Probe", wrvu: 0.00 },
 "87652": { name: "Strep A Dna Quant", wrvu: 0.00 },
 "87653": { name: "Strep B Dna Amp Probe", wrvu: 0.00 },
 "87660": { name: "Trichomonas Vagin Dir Probe", wrvu: 0.00 },
 "87661": { name: "Trichomonas Vaginalis Amplif", wrvu: 0.00 },
 "87662": { name: "Zika Virus DNA/RNA Amp Probe", wrvu: 0.00 },
 "87797": { name: "Detect Agent Not Otherwise Specified Dna Dir", wrvu: 0.00 },
 "87798": { name: "Detect Agent Not Otherwise Specified Dna Amp", wrvu: 0.00 },
 "87799": { name: "Detect Agent Not Otherwise Specified Dna Quant", wrvu: 0.00 },
 "87800": { name: "Detect Agnt Mult Dna Direc", wrvu: 0.00 },
 "87801": { name: "Detect Agnt Mult Dna Ampli", wrvu: 0.00 },
 "87802": { name: "Strep B Assay With Optic", wrvu: 0.00 },
 "87803": { name: "Clostridium Toxin A With Optic", wrvu: 0.00 },
 "87804": { name: "Influenza Rapid Test", wrvu: 0.00 },
 "87806": { name: "HIV Ag With HIV Antb With Optic", wrvu: 0.00 },
 "87807": { name: "RSV Assay With Optic", wrvu: 0.00 },
 "87808": { name: "Trichomonas Assay With Optic", wrvu: 0.00 },
 "87809": { name: "Adenovirus Assay With Optic", wrvu: 0.00 },
 "87810": { name: "Chlmyd Trach Assay With Optic", wrvu: 0.00 },
 "87811": { name: "Sars-cov-2 Covid19 With Optic", wrvu: 0.00 },
 "87812": { name: "Sarscov2 and inferior Typ A and b With Optic", wrvu: 0.00 },
 "87850": { name: "N. Gonorrhoeae Assay With Optic", wrvu: 0.00 },
 "87880": { name: "Strep Test (Rapid Strep A)", wrvu: 0.00 },
 "87899": { name: "Agent Not Otherwise Specified Assay With Optic", wrvu: 0.00 },
 "87900": { name: "Phenotype Infect Agent Drug", wrvu: 0.00 },
 "87901": { name: "Nfct Agt Gntyp Alys HIV Revision", wrvu: 0.00 },
 "87902": { name: "Nfct Agt Gntyp Alys Hep C", wrvu: 0.00 },
 "87903": { name: "Phenotype Dna HIV With Culture", wrvu: 0.00 },
 "87904": { name: "Phenotype Dna HIV With Clt Add", wrvu: 0.00 },
 "87905": { name: "Ia Nzmtc Actv Other Than Virus", wrvu: 0.00 },
 "87906": { name: "Nfct Agt Gntyp Alys HIV", wrvu: 0.00 },
 "87910": { name: "Nfct Agt Gntyp Alys Cytomegalovirus", wrvu: 0.00 },
 "87912": { name: "Nfct Agt Gntyp Alys Hep B", wrvu: 0.00 },
 "87913": { name: "Nfct Agt Gntyp Alys Sarscov2", wrvu: 0.00 },
 "87999": { name: "Unlisted Microbiology Procedure", wrvu: 0.00 },
 "88000": { name: "Autopsy (necropsy) Gross", wrvu: 0.00 },
 "88005": { name: "Autopsy (necropsy) Gross", wrvu: 0.00 },
 "88007": { name: "Autopsy (necropsy) Gross", wrvu: 0.00 },
 "88012": { name: "Autopsy (necropsy) Gross", wrvu: 0.00 },
 "88014": { name: "Autopsy (necropsy) Gross", wrvu: 0.00 },
 "88016": { name: "Autopsy (necropsy) Gross", wrvu: 0.00 },
 "88020": { name: "Autopsy (necropsy) Complete", wrvu: 0.00 },
 "88025": { name: "Autopsy (necropsy) Complete", wrvu: 0.00 },
 "88027": { name: "Autopsy (necropsy) Complete", wrvu: 0.00 },
 "88028": { name: "Autopsy (necropsy) Complete", wrvu: 0.00 },
 "88029": { name: "Autopsy (necropsy) Complete", wrvu: 0.00 },
 "88036": { name: "Limited Autopsy", wrvu: 0.00 },
 "88037": { name: "Limited Autopsy", wrvu: 0.00 },
 "88040": { name: "Forensic Autopsy (necropsy)", wrvu: 0.00 },
 "88045": { name: "Coroners Autopsy (necropsy)", wrvu: 0.00 },
 "88099": { name: "Unlisted Necropsy (autopsy)", wrvu: 0.00 },
 "88104": { name: "Cytopathology Fl Nongyn Smears", wrvu: 0.55 },
 "88106": { name: "Cytopathology Fl Nongyn Filter", wrvu: 0.36 },
 "88108": { name: "Cytopathology Concentrate Tech", wrvu: 0.43 },
 "88112": { name: "Cytopathology Cell Enhance Tech", wrvu: 0.55 },
 "88120": { name: "Cytp Urne 3-5 Probes Each Specimen", wrvu: 1.17 },
 "88121": { name: "Cytp Urine 3-5 Probes Cmptr", wrvu: 0.98 },
 "88125": { name: "Forensic Cytopathology", wrvu: 0.25 },
 "88130": { name: "Sex Chromatin Identification", wrvu: 0.00 },
 "88140": { name: "Sex Chromatin Identification", wrvu: 0.00 },
 "88141": { name: "Cytopathology Cervical/Vaginal Interpret", wrvu: 0.25 },
 "88142": { name: "Cytopathology Cervical/Vaginal Thin Layer", wrvu: 0.00 },
 "88143": { name: "Cytopathology Cervical/Vaginal Thin Layer Redo", wrvu: 0.00 },
 "88147": { name: "Cytopathology Cervical/Vaginal Automated", wrvu: 0.00 },
 "88148": { name: "Cytopathology Cervical/Vaginal Auto Rescreen", wrvu: 0.00 },
 "88150": { name: "Cytopathology Cervical/Vaginal Manual", wrvu: 0.00 },
 "88152": { name: "Cytopathology Cervical/Vaginal Auto Redo", wrvu: 0.00 },
 "88153": { name: "Cytopathology Cervical/Vaginal Redo", wrvu: 0.00 },
 "88155": { name: "Cytopathology Cervical/Vaginal Index Add-on", wrvu: 0.00 },
 "88160": { name: "Cytopathology Smear Other Source", wrvu: 0.49 },
 "88161": { name: "Cytopathology Smear Other Source", wrvu: 0.49 },
 "88162": { name: "Cytopathology Smear Other Source", wrvu: 0.74 },
 "88164": { name: "Cytopathology Tbs Cervical/Vaginal Manual", wrvu: 0.00 },
 "88165": { name: "Cytopathology Tbs Cervical/Vaginal Redo", wrvu: 0.00 },
 "88166": { name: "Cytopathology Tbs Cervical/Vaginal Auto Redo", wrvu: 0.00 },
 "88167": { name: "Cytopathology Tbs Cervical/Vaginal Select", wrvu: 0.00 },
 "88172": { name: "Cytp Diagnosis Evaluation FNA 1st Each Site", wrvu: 0.67 },
 "88173": { name: "Cytopathology Evaluation FNA Report", wrvu: 1.36 },
 "88174": { name: "Cytopathology Cervical/Vaginal Auto In Fluid", wrvu: 0.00 },
 "88175": { name: "Cytopathology Cervical/Vaginal Auto Fluid Redo", wrvu: 0.00 },
 "88177": { name: "Cytp FNA Evaluation Each Additional", wrvu: 0.41 },
 "88182": { name: "Cell Marker Study", wrvu: 0.75 },
 "88184": { name: "Flowcytometry/ Tc 1 Marker", wrvu: 0.00 },
 "88185": { name: "Flowcytometry/tc Add-on", wrvu: 0.00 },
 "88187": { name: "Flowcytometry/read 2-8", wrvu: 0.72 },
 "88188": { name: "Flowcytometry/read 9-15", wrvu: 1.17 },
 "88189": { name: "Flowcytometry/read 16 & >", wrvu: 1.66 },
 "88199": { name: "Unlisted Cytopathology Procedure", wrvu: 0.00 },
 "88230": { name: "Tissue Culture Lymphocyte", wrvu: 0.00 },
 "88233": { name: "Tissue Culture Skin/biopsy", wrvu: 0.00 },
 "88235": { name: "Tissue Culture Placenta", wrvu: 0.00 },
 "88237": { name: "Tissue Culture Bone Marrow", wrvu: 0.00 },
 "88239": { name: "Tissue Culture Tumor", wrvu: 0.00 },
 "88240": { name: "Cell Cryopreserve/storage", wrvu: 0.00 },
 "88241": { name: "Frozen Cell Preparation", wrvu: 0.00 },
 "88245": { name: "Chromosome Analysis 20-25", wrvu: 0.00 },
 "88248": { name: "Chromosome Analysis 50-100", wrvu: 0.00 },
 "88249": { name: "Chromosome Analysis 100", wrvu: 0.00 },
 "88261": { name: "Chromosome Analysis 5", wrvu: 0.00 },
 "88262": { name: "Chromosome Analysis 15-20", wrvu: 0.00 },
 "88263": { name: "Chromosome Analysis 45", wrvu: 0.00 },
 "88264": { name: "Chromosome Analysis 20-25", wrvu: 0.00 },
 "88267": { name: "Chromosome Analys Placenta", wrvu: 0.00 },
 "88269": { name: "Chromosome Analys Amniotic", wrvu: 0.00 },
 "88271": { name: "Cytogenetics Dna Probe", wrvu: 0.00 },
 "88272": { name: "Cytogenetics 3-5", wrvu: 0.00 },
 "88273": { name: "Cytogenetics 10-30", wrvu: 0.00 },
 "88274": { name: "Cytogenetics 25-99", wrvu: 0.00 },
 "88275": { name: "Cytogenetics 100-300", wrvu: 0.00 },
 "88280": { name: "Chromosome Karyotype Study", wrvu: 0.00 },
 "88283": { name: "Chromosome Banding Study", wrvu: 0.00 },
 "88285": { name: "Chromosome Count Additional", wrvu: 0.00 },
 "88289": { name: "Chromosome Study Additional", wrvu: 0.00 },
 "88291": { name: "Cytology/molecular Report", wrvu: 0.51 },
 "88299": { name: "Unlisted Cytogenetic Study", wrvu: 0.00 },
 "88300": { name: "Surgical Pathology Gross", wrvu: 0.08 },
 "88302": { name: "Tissue Exam By Pathologist", wrvu: 0.13 },
 "88304": { name: "Tissue Exam By Pathologist", wrvu: 0.21 },
 "88305": { name: "Tissue Exam By Pathologist", wrvu: 0.73 },
 "88307": { name: "Tissue Exam By Pathologist", wrvu: 1.55 },
 "88309": { name: "Tissue Exam By Pathologist", wrvu: 2.73 },
 "88311": { name: "Decalcify Tissue", wrvu: 0.23 },
 "88312": { name: "Special Stains Group 1", wrvu: 0.53 },
 "88313": { name: "Special Stains Group 2", wrvu: 0.23 },
 "88314": { name: "Histochemical Stains Add-on", wrvu: 0.44 },
 "88319": { name: "Enzyme Histochemistry", wrvu: 0.52 },
 "88321": { name: "Consltj and reprt Sld Prep Elswr", wrvu: 1.59 },
 "88323": { name: "Consltj and reprt Matrl Prep Sld", wrvu: 1.78 },
 "88325": { name: "Consltj Compre Rvw Rec Reprt", wrvu: 2.78 },
 "88329": { name: "Pathology Consltj Drainage Surgery", wrvu: 0.65 },
 "88331": { name: "Pathology Consltj Surgery 1 Blk 1spc", wrvu: 1.16 },
 "88332": { name: "Pathology Consltj Surgery Each Add Blk", wrvu: 0.58 },
 "88333": { name: "Pathology Consltj Surgery Cytology Xm 1", wrvu: 1.17 },
 "88334": { name: "Pathology Consltj Surgery Cytology Xm Each", wrvu: 0.71 },
 "88341": { name: "Imhchem/imcytchm Each Add Antb", wrvu: 0.55 },
 "88342": { name: "Imhchem/imcytchm 1st Antb", wrvu: 0.68 },
 "88344": { name: "Imhchem/imcytchm Each Mlt Antb", wrvu: 0.75 },
 "88346": { name: "Imfluor 1st 1antb Stain Procedure", wrvu: 0.72 },
 "88348": { name: "Electron Microscopy Diagnosis", wrvu: 1.47 },
 "88350": { name: "Imfluor Each Additional 1antb Stn Procedure", wrvu: 0.58 },
 "88355": { name: "M/phmtrc Alys Skeletal Muscle", wrvu: 1.80 },
 "88356": { name: "Analysis Nerve", wrvu: 2.73 },
 "88358": { name: "Analysis Tumor", wrvu: 0.93 },
 "88360": { name: "Tumor Immunohistochem/manual", wrvu: 0.83 },
 "88361": { name: "Tumor Immunohistochem/comput", wrvu: 0.93 },
 "88362": { name: "Nerve Teasing Preparations", wrvu: 2.12 },
 "88363": { name: "Xm Archive Tissue Molec Anal", wrvu: 0.36 },
 "88364": { name: "Insitu Hybridization (Fluorescence In Situ Hybridization)", wrvu: 0.68 },
 "88365": { name: "Insitu Hybridization (Fluorescence In Situ Hybridization)", wrvu: 0.86 },
 "88366": { name: "Insitu Hybridization (Fluorescence In Situ Hybridization)", wrvu: 1.21 },
 "88367": { name: "Insitu Hybridization Auto", wrvu: 0.71 },
 "88368": { name: "Insitu Hybridization Manual", wrvu: 0.86 },
 "88369": { name: "M/phmtrc Alysishquant/semiq", wrvu: 0.68 },
 "88371": { name: "Protein Western Blot Tissue", wrvu: 0.00 },
 "88372": { name: "Protein Analysis With Probe", wrvu: 0.00 },
 "88373": { name: "M/phmtrc Alys Ishquant/semiq", wrvu: 0.57 },
 "88374": { name: "M/phmtrc Alys Ishquant/semiq", wrvu: 0.91 },
 "88375": { name: "Optical Endomicroscpy Interpretation", wrvu: 0.89 },
 "88377": { name: "M/phmtrc Alys Ishquant/semiq", wrvu: 1.37 },
 "88380": { name: "Microdissection Laser", wrvu: 1.11 },
 "88381": { name: "Microdissection Manual", wrvu: 0.52 },
 "88387": { name: "Macroscopic Xm Dissection and prep Tiss", wrvu: 0.60 },
 "88399": { name: "Unlisted Surgical Pathology Procedure", wrvu: 0.00 },
 "88720": { name: "Bilirubin Total Transcut", wrvu: 0.00 },
 "88738": { name: "Hemoglobin Quant Transcutaneous", wrvu: 0.00 },
 "88740": { name: "Transcutaneous Carboxyhb", wrvu: 0.00 },
 "88741": { name: "Transcutaneous Methb", wrvu: 0.00 },
 "88749": { name: "Unlisted In Vivo Laboratory Service", wrvu: 0.00 },
 "89049": { name: "Chct For Malignant Hyperthermia", wrvu: 1.37 },
 "89050": { name: "Body Fluid Cell Count", wrvu: 0.00 },
 "89051": { name: "Body Fluid Cell Count", wrvu: 0.00 },
 "89055": { name: "Leukocyte Assessment Fecal", wrvu: 0.00 },
 "89060": { name: "Exam Synovial Fluid Crystals", wrvu: 0.00 },
 "89125": { name: "Specimen Fat Stain", wrvu: 0.00 },
 "89160": { name: "Exam Feces For Meat Fibers", wrvu: 0.00 },
 "89190": { name: "Nasal Smear For Eosinophils", wrvu: 0.00 },
 "89220": { name: "Sputum Specimen Collection", wrvu: 0.00 },
 "89230": { name: "Collect Sweat For Test", wrvu: 0.00 },
 "89240": { name: "Unlisted Misc Pathology Test", wrvu: 0.00 },
 "89250": { name: "Culture Oocyte/embryo <4 Days", wrvu: 0.00 },
 "89251": { name: "Culture Oocyte/embryo <4 Days", wrvu: 0.00 },
 "89253": { name: "Embryo Hatching", wrvu: 0.00 },
 "89254": { name: "Oocyte Identification", wrvu: 0.00 },
 "89255": { name: "Prepare Embryo For Transfer", wrvu: 0.00 },
 "89257": { name: "Sperm Identification", wrvu: 0.00 },
 "89258": { name: "Cryopreservation Embryo(s)", wrvu: 0.00 },
 "89259": { name: "Cryopreservation Sperm", wrvu: 0.00 },
 "89260": { name: "Sperm Isolation Simple", wrvu: 0.00 },
 "89261": { name: "Sperm Isolation Complex", wrvu: 0.00 },
 "89264": { name: "Identify Sperm Tissue", wrvu: 0.00 },
 "89268": { name: "Insemination Of Oocytes", wrvu: 0.00 },
 "89272": { name: "Extended Culture Of Oocytes", wrvu: 0.00 },
 "89280": { name: "Assist Oocyte Fertilization", wrvu: 0.00 },
 "89281": { name: "Assist Oocyte Fertilization", wrvu: 0.00 },
 "89290": { name: "Biopsy Oocyte Polar Body <=5", wrvu: 0.00 },
 "89291": { name: "Biopsy Oocyte Polar Body", wrvu: 0.00 },
 "89300": { name: "Semen Analysis With Huhner", wrvu: 0.00 },
 "89310": { name: "Semen Analysis With Count", wrvu: 0.00 },
 "89320": { name: "Semen Anal Vol/count/mot", wrvu: 0.00 },
 "89321": { name: "Semen Anal Sperm Detection", wrvu: 0.00 },
 "89322": { name: "Semen Anal Strict Criteria", wrvu: 0.00 },
 "89325": { name: "Sperm Antibody Test", wrvu: 0.00 },
 "89329": { name: "Sperm Evaluation Test", wrvu: 0.00 },
 "89330": { name: "Evaluation Cervical Mucus", wrvu: 0.00 },
 "89331": { name: "Retrograde Ejaculation Anal", wrvu: 0.00 },
 "89335": { name: "Cryopreserve Testicular Tiss", wrvu: 0.00 },
 "89337": { name: "Cryopreservation Oocyte(s)", wrvu: 0.00 },
 "89342": { name: "Storage/year Embryo(s)", wrvu: 0.00 },
 "89343": { name: "Storage/year Sperm/semen", wrvu: 0.00 },
 "89344": { name: "Storage/year Reprod Tissue", wrvu: 0.00 },
 "89346": { name: "Storage/year Oocyte(s)", wrvu: 0.00 },
 "89352": { name: "Thawing Cryopresrved Embryo", wrvu: 0.00 },
 "89353": { name: "Thawing Cryopresrved Sperm", wrvu: 0.00 },
 "89354": { name: "Thaw Cryoprsvrd Reprod Tiss", wrvu: 0.00 },
 "89356": { name: "Thawing Cryopresrved Oocyte", wrvu: 0.00 },
 "89398": { name: "Unlisted Reprod Medial Laboratory Procedure", wrvu: 0.00 },
 "90281": { name: "Human Ig Intramuscular", wrvu: 0.00 },
 "90283": { name: "Human Ig Intravenous", wrvu: 0.00 },
 "90284": { name: "Human Ig SC", wrvu: 0.00 },
 "90287": { name: "Botulinum Antitoxin", wrvu: 0.00 },
 "90288": { name: "Botulism Ig Intravenous", wrvu: 0.00 },
 "90291": { name: "Cytomegalovirus Ig Intravenous", wrvu: 0.00 },
 "90296": { name: "Diphtheria Antitoxin", wrvu: 0.00 },
 "90371": { name: "Hep B Ig Intramuscular", wrvu: 0.00 },
 "90375": { name: "Rabies Ig Intramuscular/sc", wrvu: 0.00 },
 "90376": { name: "Rabies Ig Heat Treated", wrvu: 0.00 },
 "90377": { name: "Rabies Ig Ht and sol Human Intramuscular/sc", wrvu: 0.00 },
 "90378": { name: "RSV Mab Intramuscular 50mg", wrvu: 0.00 },
 "90380": { name: "RSV Monoc Antb Seasn .5ml Intramuscular", wrvu: 0.00 },
 "90381": { name: "RSV Monoc Antb Seasn 1 mL Intramuscular", wrvu: 0.00 },
 "90382": { name: "RSV Monoc Antb Seasn .7ml Intramuscular", wrvu: 0.00 },
 "90384": { name: "Rh Ig Full-dose Intramuscular", wrvu: 0.00 },
 "90385": { name: "Rh Ig Minidose Intramuscular", wrvu: 0.00 },
 "90386": { name: "Rh Ig Intravenous", wrvu: 0.00 },
 "90389": { name: "Tetanus Ig Intramuscular", wrvu: 0.00 },
 "90393": { name: "Vaccina Ig Intramuscular", wrvu: 0.00 },
 "90396": { name: "Varicella-zoster Ig Intramuscular", wrvu: 0.00 },
 "90399": { name: "Unlisted Immune Globulin", wrvu: 0.00 },
 "90460": { name: "Intramuscular Administration 1st/only Component", wrvu: 0.23 },
 "90461": { name: "Intramuscular Administration Each Additional Component", wrvu: 0.18 },
 "90471": { name: "Immunization Administration, First Vaccine (Percutaneous/ID/SC/Intramuscular)", wrvu: 0.17 },
 "90472": { name: "Immunization Administration, Each Additional Vaccine", wrvu: 0.15 },
 "90473": { name: "Immunization Administration, First Vaccine (Intranasal/Oral)", wrvu: 0.17 },
 "90474": { name: "Immunization Administration, Each Additional Intranasal/Oral", wrvu: 0.15 },
 "90476": { name: "Adenovirus Vaccine Type 4", wrvu: 0.00 },
 "90477": { name: "Adenovirus Vaccine Type 7", wrvu: 0.00 },
 "90480": { name: "Admn Sarscov2 Vac 1/only Comprehensive Metabolic Panel", wrvu: 0.24 },
 "90481": { name: "Admn Sarscov2 Vac Each Add Comprehensive Metabolic Panel", wrvu: 0.00 },
 "90482": { name: "Imm Cnsl Not Admn Sm 3<10", wrvu: 0.24 },
 "90483": { name: "Imm Cnsl Not Admn Sm>10<20", wrvu: 0.50 },
 "90484": { name: "Imm Cnsl Not Admn Sm>20", wrvu: 0.75 },
 "90581": { name: "Anthrax Vaccine Subcutaneous Or Intramuscular", wrvu: 0.00 },
 "90584": { name: "Dengue Vacc Quad 2 Dose Subcutaneous", wrvu: 0.00 },
 "90585": { name: "Bcg Vaccine Percutaneous", wrvu: 0.00 },
 "90586": { name: "Bcg Vaccine Intravesical", wrvu: 0.00 },
 "90587": { name: "Dengue Vacc Quad 3 Dose Subcutaneous", wrvu: 0.00 },
 "90589": { name: "Chikungunya Vaccine Live Intramuscular", wrvu: 0.00 },
 "90593": { name: "Chikungunya Vacc Recomb Intramuscular", wrvu: 0.00 },
 "90611": { name: "Smallpox and monkeypox Vac 0.5ml", wrvu: 0.00 },
 "90612": { name: "Inferior and sarscov2 Vacc 31.7/.32im", wrvu: 0.00 },
 "90613": { name: "Inferior and sarscov2 Vacc 40/0.4 Intramuscular", wrvu: 0.00 },
 "90619": { name: "Menacwy-tt Vaccine Intramuscular", wrvu: 0.00 },
 "90620": { name: "Menb-4c Vaccine Intramuscular", wrvu: 0.00 },
 "90621": { name: "Menb-fhbp Vacc 2/3 Dose Intramuscular", wrvu: 0.00 },
 "90622": { name: "Vaccinia Vrs Vac 0.3 mL Percutaneous", wrvu: 0.00 },
 "90623": { name: "Menacwy-tt Menb-fhbp Vacc Intramuscular", wrvu: 0.00 },
 "90624": { name: "Menb-4c and menacwy Vacc Intramuscular", wrvu: 0.00 },
 "90625": { name: "Cholera Vaccine Live Oral", wrvu: 0.00 },
 "90626": { name: "Tic-brn Enceph Vac 0.25ml Intramuscular", wrvu: 0.00 },
 "90627": { name: "Tic-brn Enceph Vac 0.5ml Intramuscular", wrvu: 0.00 },
 "90631": { name: "H5 Vaccine Pandemic Intramuscular Use", wrvu: 0.00 },
 "90632": { name: "Hepa Vaccine Adult Intramuscular", wrvu: 0.00 },
 "90633": { name: "Hepa Vacc Ped/adol 2 Dose Intramuscular", wrvu: 0.00 },
 "90634": { name: "Hepa Vacc Ped/adol 3 Dose", wrvu: 0.00 },
 "90635": { name: "H5n1 Vacc Drv Chronic Lymphocytic Leukemia Cul Adjustment Intramuscular", wrvu: 0.00 },
 "90636": { name: "Hep A/hep B Vacc Adult Intramuscular", wrvu: 0.00 },
 "90637": { name: "Vacc Qirv Mrna 30mcg/.5ml Intramuscular", wrvu: 0.00 },
 "90638": { name: "Vacc Qirv Mrna 60mcg/.5ml Intramuscular", wrvu: 0.00 },
 "90644": { name: "Hib-mency Vacc 6wk-18m0 Intramuscular", wrvu: 0.00 },
 "90647": { name: "Hib Prp-omp Vacc 3 Dose Intramuscular", wrvu: 0.00 },
 "90648": { name: "Hib Prp-t Vaccine 4 Dose Intramuscular", wrvu: 0.00 },
 "90649": { name: "4vhpv Vaccine 3 Dose Intramuscular", wrvu: 0.00 },
 "90650": { name: "2vhpv Vaccine 3 Dose Intramuscular", wrvu: 0.00 },
 "90651": { name: "9vhpv Vaccine 2/3 Dose Intramuscular", wrvu: 0.00 },
 "90653": { name: "Iiv Adjuvant Vaccine Intramuscular", wrvu: 0.00 },
 "90655": { name: "Iiv3 Vacc No Prsv 0.25 mL Intramuscular", wrvu: 0.00 },
 "90656": { name: "Iiv3 Vacc No Prsv 0.5 mL Intramuscular", wrvu: 0.00 },
 "90657": { name: "Iiv3 Vaccine Split Thickness 0.25 mL Intramuscular", wrvu: 0.00 },
 "90658": { name: "Iiv3 Vaccine Split Thickness 0.5 mL Intramuscular", wrvu: 0.00 },
 "90660": { name: "Laiv3 Vaccine Intranasal", wrvu: 0.00 },
 "90661": { name: "Cciiv3 Vac Abx Fr 0.5 mL Intramuscular", wrvu: 0.00 },
 "90662": { name: "Iiv No Prsv Increased Ag Intramuscular", wrvu: 0.00 },
 "90664": { name: "Laiv Vacc Pandemic Intranasl", wrvu: 0.00 },
 "90666": { name: "Flu Vac Pandem Prsrv Free Intramuscular", wrvu: 0.00 },
 "90667": { name: "Iiv Vacc Pandemic Adjuvt Intramuscular", wrvu: 0.00 },
 "90668": { name: "Iiv Vaccine Pandemic Intramuscular", wrvu: 0.00 },
 "90670": { name: "Pcv13 Vaccine Intramuscular", wrvu: 0.00 },
 "90671": { name: "Pcv15 Vaccine Intramuscular", wrvu: 0.00 },
 "90672": { name: "Laiv4 Vaccine Intranasal", wrvu: 0.00 },
 "90673": { name: "Riv3 Vaccine No Preserv Intramuscular", wrvu: 0.00 },
 "90674": { name: "Cciiv4 Vac No Prsv 0.5 mL Intramuscular", wrvu: 0.00 },
 "90675": { name: "Rabies Vaccine Intramuscular", wrvu: 0.00 },
 "90676": { name: "Rabies Vaccine Id", wrvu: 0.00 },
 "90677": { name: "Pcv20 Vaccine Intramuscular", wrvu: 0.00 },
 "90678": { name: "RSV Vacc Pref Bivalent Intramuscular", wrvu: 0.00 },
 "90679": { name: "RSV Vacc Pref Recomb Adjt Intramuscular", wrvu: 0.00 },
 "90680": { name: "Rv5 Vacc 3 Dose Live Oral", wrvu: 0.00 },
 "90681": { name: "Rv1 Vacc 2 Dose Live Oral", wrvu: 0.00 },
 "90682": { name: "Riv4 Vacc Recombinant Dna Intramuscular", wrvu: 0.00 },
 "90683": { name: "RSV Vacc Mrna Lipid Nano Intramuscular", wrvu: 0.00 },
 "90684": { name: "Pcv21 Vaccine Intramuscular", wrvu: 0.00 },
 "90685": { name: "Iiv4 Vacc No Prsv 0.25 mL Intramuscular", wrvu: 0.00 },
 "90686": { name: "Iiv4 Vacc No Prsv 0.5 mL Intramuscular", wrvu: 0.00 },
 "90687": { name: "Iiv4 Vaccine Split Thickness 0.25 mL Intramuscular", wrvu: 0.00 },
 "90688": { name: "Iiv4 Vaccine Split Thickness 0.5 mL Intramuscular", wrvu: 0.00 },
 "90689": { name: "Vacc Iiv4 No Prsrv 0.25ml Intramuscular", wrvu: 0.00 },
 "90690": { name: "Typhoid Vaccine Oral", wrvu: 0.00 },
 "90691": { name: "Typhoid Vaccine Intramuscular", wrvu: 0.00 },
 "90694": { name: "Vacc Aiiv4 No Prsrv 0.5ml Intramuscular", wrvu: 0.00 },
 "90695": { name: "H5n8 Vacc Drv Chronic Lymphocytic Leukemia Cul Adjustment Intramuscular", wrvu: 0.00 },
 "90696": { name: "Dtap-ipv Vaccine 4-6 Years Intramuscular", wrvu: 0.00 },
 "90697": { name: "Dtap-ipv-hib-hepb Vaccine Intramuscular", wrvu: 0.00 },
 "90698": { name: "Dtap-ipv/hib Vaccine Intramuscular", wrvu: 0.00 },
 "90700": { name: "Dtap Vaccine < 7 Years Intramuscular", wrvu: 0.00 },
 "90702": { name: "Dt Vaccine Under 7 Years Intramuscular", wrvu: 0.00 },
 "90707": { name: "Mmr Vaccine SC", wrvu: 0.00 },
 "90710": { name: "Mmrv Vaccine SC", wrvu: 0.00 },
 "90713": { name: "Poliovirus Ipv SC/Intramuscular", wrvu: 0.00 },
 "90714": { name: "Td Vacc No Presv 7 Years+ Intramuscular", wrvu: 0.00 },
 "90715": { name: "Tdap Vaccine 7 Years/> Intramuscular", wrvu: 0.00 },
 "90716": { name: "Var Vaccine Live Subcutaneous", wrvu: 0.00 },
 "90717": { name: "Yellow Fever Vaccine Subcutaneous", wrvu: 0.00 },
 "90723": { name: "Dtap-hep B-ipv Vaccine Intramuscular", wrvu: 0.00 },
 "90732": { name: "Ppsv23 Vacc 2 Years+ Subcutaneous/intramuscular", wrvu: 0.00 },
 "90733": { name: "Mpsv4 Vaccine Subcutaneous", wrvu: 0.00 },
 "90734": { name: "Menacwyd/menacwycrm Vacc Intramuscular", wrvu: 0.00 },
 "90736": { name: "Herpes Zoster Vaccine Live Subcutaneous", wrvu: 0.00 },
 "90738": { name: "Inactivated Je Vacc Intramuscular", wrvu: 0.00 },
 "90739": { name: "Hepb Vacc 2/4 Dose Adult Intramuscular", wrvu: 0.00 },
 "90740": { name: "Hepb Vacc 3 Dose Immunsup Intramuscular", wrvu: 0.00 },
 "90743": { name: "Hepb Vacc 2 Dose Adolesc Intramuscular", wrvu: 0.00 },
 "90744": { name: "Hepb Vacc 3 Dose Ped/adol Intramuscular", wrvu: 0.00 },
 "90746": { name: "Hepb Vaccine 3 Dose Adult Intramuscular", wrvu: 0.00 },
 "90747": { name: "Hepb Vacc 4 Dose Immunsup Intramuscular", wrvu: 0.00 },
 "90748": { name: "Hib-hepb Vaccine Intramuscular", wrvu: 0.00 },
 "90749": { name: "Unlisted Vaccine/toxoid", wrvu: 0.00 },
 "90750": { name: "Herpes Zoster Vacc Recombinant Intramuscular", wrvu: 0.00 },
 "90756": { name: "Cciiv4 Vacc Abx Free Intramuscular", wrvu: 0.00 },
 "90758": { name: "Zaire Ebolavirus Vac Live Intramuscular", wrvu: 0.00 },
 "90759": { name: "Hep B Vac 3ag 10mcg 3 Dos Intramuscular", wrvu: 0.00 },
 "90785": { name: "Psychotherapy Complex Interactive", wrvu: 0.33 },
 "90791": { name: "Psych Diagnostic Evaluation", wrvu: 3.84 },
 "90792": { name: "Psych Diagnostic Evaluation With Medial Srvcs", wrvu: 4.16 },
 "90832": { name: "Psychotherapy, 30 minutes (16-37 minutes)", wrvu: 1.94 },
 "90833": { name: "Psychotherapy W Prothrombin Time W E and M 30 Minutes", wrvu: 1.71 },
 "90834": { name: "Psychotherapy, 45 minutes (38-52 minutes)", wrvu: 2.56 },
 "90836": { name: "Psychotherapy W Prothrombin Time W E and M 45 Minutes", wrvu: 2.17 },
 "90837": { name: "Psychotherapy, 60 minutes (53+ minutes)", wrvu: 3.78 },
 "90838": { name: "Psychotherapy W Prothrombin Time W E and M 60 Minutes", wrvu: 2.86 },
 "90839": { name: "Psychotherapy for Crisis, First 60 minutes", wrvu: 3.58 },
 "90840": { name: "Psychotherapy for Crisis, Each Additional 30 minutes", wrvu: 1.71 },
 "90845": { name: "Psychoanalysis", wrvu: 2.40 },
 "90846": { name: "Family Psychotherapy without Patient Present, 50 minutes", wrvu: 2.74 },
 "90847": { name: "Family Psychotherapy with Patient Present, 50 minutes", wrvu: 2.86 },
 "90849": { name: "Multiple Family Group Psychotherapy", wrvu: 0.67 },
 "90853": { name: "Group Psychotherapy", wrvu: 0.67 },
 "90863": { name: "Pharmacologic Management With Psychotherapy", wrvu: 0.48 },
 "90865": { name: "Narcosynthesis", wrvu: 2.84 },
 "90867": { name: "Tcranial Magn Stimulation Treatment Plan", wrvu: 0.00 },
 "90868": { name: "Tcranial Magn Stimulation Treatment Deli", wrvu: 0.00 },
 "90869": { name: "Tcran Magn Stimulation Redetemine", wrvu: 0.00 },
 "90870": { name: "Electroconvulsive Therapy", wrvu: 2.50 },
 "90875": { name: "Psychophysiological Therapy", wrvu: 1.20 },
 "90876": { name: "Psychophysiological Therapy", wrvu: 1.90 },
 "90880": { name: "Hypnotherapy", wrvu: 2.19 },
 "90882": { name: "Envrn Ivntj Medial Management Psyc Patient", wrvu: 0.00 },
 "90885": { name: "Psy Evaluation Of Records", wrvu: 0.97 },
 "90887": { name: "Interpj/explnaj Rslt Psyc Xm", wrvu: 1.48 },
 "90889": { name: "Preparation Of Report", wrvu: 0.00 },
 "90899": { name: "Unlisted Psyc Svc/therapy", wrvu: 0.00 },
 "90901": { name: "Biofeedback Train Any Meth", wrvu: 0.41 },
 "90912": { name: "Bfb Training 1st 15 Minutes", wrvu: 0.90 },
 "90913": { name: "Bfb Training Each Additional 15 Minutes", wrvu: 0.50 },
 "90935": { name: "Hemodialysis One Evaluation", wrvu: 1.44 },
 "90937": { name: "Hemodialysis Repeated Evaluation", wrvu: 2.06 },
 "90940": { name: "Hemodialysis Access Study", wrvu: 0.00 },
 "90945": { name: "Dialysis One Evaluation", wrvu: 1.52 },
 "90947": { name: "Dialysis Repeated Evaluation", wrvu: 2.46 },
 "90951": { name: "Esrd Serv 4 Visits P Month <2yr", wrvu: 23.92 },
 "90952": { name: "Esrd Serv 2-3 Vsts P Month <2yr", wrvu: 0.00 },
 "90953": { name: "Esrd Serv 1 Visit P Month <2yrs", wrvu: 0.00 },
 "90954": { name: "Esrd Serv 4 Vsts P Month 2-11", wrvu: 20.86 },
 "90955": { name: "Esrd Srv 2-3 Vsts P Month 2-11", wrvu: 10.32 },
 "90956": { name: "Esrd Srv 1 Visit P Month 2-11", wrvu: 6.64 },
 "90957": { name: "Esrd Srv 4 Vsts P Month 12-19", wrvu: 15.46 },
 "90958": { name: "Esrd Srv 2-3 Vsts P Month 12-19", wrvu: 9.87 },
 "90959": { name: "Esrd Serv 1 Visit P Month 12-19", wrvu: 6.19 },
 "90960": { name: "Esrd Srv 4 Visits P Month 20+", wrvu: 6.77 },
 "90961": { name: "Esrd Srv 2-3 Vsts P Month 20+", wrvu: 5.52 },
 "90962": { name: "Esrd Serv 1 Visit P Month 20+", wrvu: 3.57 },
 "90963": { name: "Esrd Home Prothrombin Time Serv P Month <2yrs", wrvu: 12.09 },
 "90964": { name: "Esrd Home Prothrombin Time Serv P Month 2-11", wrvu: 10.25 },
 "90965": { name: "Esrd Home Prothrombin Time Serv P Month 12-19", wrvu: 9.80 },
 "90966": { name: "Esrd Home Prothrombin Time Serv P Month 20+", wrvu: 5.52 },
 "90967": { name: "Esrd Svc Per Day Prothrombin Time <2", wrvu: 0.35 },
 "90968": { name: "Esrd Svc Per Day Prothrombin Time 2-11", wrvu: 0.34 },
 "90969": { name: "Esrd Svc Per Day Prothrombin Time 12-19", wrvu: 0.33 },
 "90970": { name: "Esrd Svc Per Day Prothrombin Time 20+", wrvu: 0.18 },
 "90989": { name: "Dialysis Training Complete", wrvu: 0.00 },
 "90993": { name: "Dialysis Training Incompl", wrvu: 0.00 },
 "90997": { name: "Hemoperfusion", wrvu: 1.79 },
 "90999": { name: "Unlisted Dialysis Procedure", wrvu: 0.00 },
 "91010": { name: "Esophagus Motility Study", wrvu: 1.25 },
 "91013": { name: "Esophgl Motil With Stimulation/perfus", wrvu: 0.18 },
 "91020": { name: "Gastric Motility Studies", wrvu: 1.40 },
 "91022": { name: "Duodenal Motility Study", wrvu: 1.40 },
 "91030": { name: "Acid Perfusion Of Esophagus", wrvu: 0.89 },
 "91034": { name: "Gastroesophageal Reflux Test", wrvu: 0.95 },
 "91035": { name: "G-Esophageal Reflx Tst With Electrod", wrvu: 1.55 },
 "91037": { name: "Esophageal Imped Function Test", wrvu: 0.95 },
 "91038": { name: "Esophageal Imped Funct Test > 1hr", wrvu: 1.10 },
 "91040": { name: "Esophageal Balloon Distension Tst", wrvu: 0.95 },
 "91065": { name: "Breath Hydrogen/methane Test", wrvu: 0.20 },
 "91110": { name: "Gastrointestinal Trc Imaging Intral Esophageal-ile", wrvu: 2.18 },
 "91111": { name: "Gastrointestinal Trc Imaging Intral Esophagus", wrvu: 0.88 },
 "91112": { name: "Gastrointestinal Wireless Capsule Measure", wrvu: 2.05 },
 "91113": { name: "Gastrointestinal Trc Imaging Intral Colon I and r", wrvu: 2.35 },
 "91117": { name: "Colon Motility 6 hr Study", wrvu: 2.39 },
 "91124": { name: "Rct Snsatn Tone and cmplianc STD", wrvu: 3.05 },
 "91125": { name: "Anrct Mano Rct Snsatn and balo", wrvu: 2.70 },
 "91132": { name: "Electrogastrography", wrvu: 0.51 },
 "91133": { name: "Electrogastrography With Test", wrvu: 0.64 },
 "91200": { name: "Liver Elastography", wrvu: 0.20 },
 "91299": { name: "Unlisted Diagnosis Gastrointestinal Procedure", wrvu: 0.00 },
 "91304": { name: "Sarscov2 Vac 5mcg/0.5ml Intramuscular", wrvu: 0.00 },
 "91318": { name: "Sarscov2 Vac 3mcg Trs-suc Intramuscular", wrvu: 0.00 },
 "91319": { name: "Sarscv2 Vac 10mcg Trs-suc Intramuscular", wrvu: 0.00 },
 "91320": { name: "Sarscv2 Vac 30mcg Trs-suc Intramuscular", wrvu: 0.00 },
 "91321": { name: "Sarscov2 Vac 25 mcg/.25ml Intramuscular", wrvu: 0.00 },
 "91322": { name: "Sarscov2 Vac 50 mcg/0.5ml Intramuscular", wrvu: 0.00 },
 "91323": { name: "Sarscov2 Vac 10 mcg/0.2ml Intramuscular", wrvu: 0.00 },
 "92002": { name: "Intrm Oph Exam New Patient", wrvu: 0.88 },
 "92004": { name: "Compre Oph Exam New Patient 1/>", wrvu: 1.82 },
 "92012": { name: "Intrm Oph Exam Established Patient", wrvu: 0.92 },
 "92014": { name: "Compre Oph Exam Established Prothrombin Time 1/>", wrvu: 1.42 },
 "92015": { name: "Determine Refractive State", wrvu: 0.37 },
 "92018": { name: "Compl Oph Exam General Anesthesia", wrvu: 2.44 },
 "92019": { name: "Lmtd Oph Exam General Anesthesia", wrvu: 1.28 },
 "92020": { name: "Gonioscopy", wrvu: 0.36 },
 "92025": { name: "Cptrized Corneal Topography", wrvu: 0.34 },
 "92060": { name: "Sensorimotor Examination", wrvu: 0.67 },
 "92065": { name: "Orthop Traing Pfrmd Physician/Qualified Health Professional Health Professional", wrvu: 0.69 },
 "92066": { name: "Orthop Traing Supvj Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "92071": { name: "Contact Lens Fitting For Treatment", wrvu: 0.59 },
 "92072": { name: "Fitg C-lens Keratoconus 1st", wrvu: 1.92 },
 "92081": { name: "Limited Visual Field Xm", wrvu: 0.29 },
 "92082": { name: "Intermediate Visual Field Xm", wrvu: 0.39 },
 "92083": { name: "Extended Visual Field Xm", wrvu: 0.49 },
 "92100": { name: "Serial Tonometry", wrvu: 0.59 },
 "92132": { name: "Cptrzd Oph Diagnosis Imaging Anterior Sgm", wrvu: 0.28 },
 "92133": { name: "Cptrzd Oph Diagnosis Imaging Pst Sgm On", wrvu: 0.30 },
 "92134": { name: "Cptrz Oph Diagnosis Imaging Pst Sgm Rta", wrvu: 0.31 },
 "92136": { name: "Ophthalmic Biometry", wrvu: 0.53 },
 "92137": { name: "Cptrz Oph Imaging Pst Sg Rta Oct", wrvu: 0.62 },
 "92145": { name: "Corneal Hysteresis Deter", wrvu: 0.10 },
 "92201": { name: "Opscpy Extnd Rta Draw Uni/bi", wrvu: 0.39 },
 "92202": { name: "Opscpy Extnd On/Monitored Anesthesia Care Draw", wrvu: 0.25 },
 "92227": { name: "Imaging Rta Detcj/mntr Ds Staff", wrvu: 0.00 },
 "92228": { name: "Imaging Rta Detc/mntr Ds Physician/Qualified Health Professional Health Professional", wrvu: 0.31 },
 "92229": { name: "Imaging Rta Detc/mntr Ds Poc Aly", wrvu: 0.00 },
 "92230": { name: "Fluorescein Angioscopy I and r", wrvu: 0.59 },
 "92235": { name: "Fluorescein Angrph Mltiframe", wrvu: 0.73 },
 "92240": { name: "Icg Angiography I and r Uni/bi", wrvu: 0.78 },
 "92242": { name: "Fluorescein and icg Angiography", wrvu: 0.93 },
 "92250": { name: "Fundus Photography With I and r", wrvu: 0.39 },
 "92260": { name: "Ophthalmodynamometry", wrvu: 0.20 },
 "92265": { name: "Needle Oculoelectromyography 1+", wrvu: 0.79 },
 "92270": { name: "Electro-oculography With I and r", wrvu: 0.79 },
 "92273": { name: "Full Field Erg With I and r", wrvu: 0.67 },
 "92274": { name: "Multifocal Erg With I and r", wrvu: 0.59 },
 "92283": { name: "Extnd Color Vision Xm", wrvu: 0.17 },
 "92284": { name: "Diagnosis Dark Adaptation Exam I and r", wrvu: 0.28 },
 "92285": { name: "External Ocular Photography", wrvu: 0.05 },
 "92286": { name: "Anterior Sgm Imaging I and r Speclr Mic", wrvu: 0.39 },
 "92287": { name: "Anterior Sgm Imaging Ir Flrscn Angrph", wrvu: 0.39 },
 "92288": { name: "Scr Dark Adaptation Meas I and r", wrvu: 0.17 },
 "92310": { name: "Contact Lens Fitting Ou", wrvu: 1.14 },
 "92311": { name: "Contact Lens Fitg Aphakia 1", wrvu: 1.05 },
 "92312": { name: "Contact Lens Fitg Aphakia Ou", wrvu: 1.23 },
 "92313": { name: "C-lens Fitg Corneosclrl Lens", wrvu: 0.90 },
 "92314": { name: "C-lens Fitg Tech Ou", wrvu: 0.67 },
 "92315": { name: "C-lens Fitg Tech Aphakia 1", wrvu: 0.44 },
 "92316": { name: "C-lens Fitg Tech Aphakia Ou", wrvu: 0.66 },
 "92317": { name: "C-lens Fitg Tech Corneosclrl", wrvu: 0.44 },
 "92325": { name: "Modification Of Contact Lens", wrvu: 0.00 },
 "92326": { name: "Replacement Of Contact Lens", wrvu: 0.00 },
 "92340": { name: "Fit Spectacles Monofocal", wrvu: 0.36 },
 "92341": { name: "Fit Spectacles Bifocal", wrvu: 0.46 },
 "92342": { name: "Fit Spectacles Multifocal", wrvu: 0.52 },
 "92352": { name: "Fit Aphakia Spectcl Monofocl", wrvu: 0.36 },
 "92353": { name: "Fit Aphakia Spectcl Multifoc", wrvu: 0.49 },
 "92354": { name: "Fitg SPECT Scan Low Vis 1system", wrvu: 0.00 },
 "92355": { name: "Fitg SPECT Scan Lw Vis Cmpnd Lens", wrvu: 0.00 },
 "92358": { name: "Aphakia Prosth Service Temp", wrvu: 0.00 },
 "92370": { name: "Repair and refitg SPECT Scan Xcp Aphakia", wrvu: 0.31 },
 "92371": { name: "Repair and refit Spct Prosthesis Aphakia", wrvu: 0.00 },
 "92499": { name: "Unlisted Oph Svc/procedure", wrvu: 0.00 },
 "92502": { name: "Ear And Throat Examination", wrvu: 1.47 },
 "92504": { name: "Ear Microscopy Examination", wrvu: 0.18 },
 "92507": { name: "Treatment Sp Lang Voice Comm Indiv", wrvu: 1.30 },
 "92508": { name: "Treatment Sp Lang Voice Comm Group", wrvu: 0.33 },
 "92511": { name: "Nasopharyngoscopy", wrvu: 0.59 },
 "92512": { name: "Nasal Function Studies", wrvu: 0.54 },
 "92516": { name: "Facial Nerve Function Test", wrvu: 0.42 },
 "92517": { name: "Vemp Test I and r Cervical", wrvu: 0.78 },
 "92518": { name: "Vemp Test I and r Ocular", wrvu: 0.78 },
 "92519": { name: "Vemp Tst I and r Cervical and ocular", wrvu: 1.17 },
 "92520": { name: "Laryngeal Function Studies", wrvu: 0.73 },
 "92521": { name: "Evaluation Of Speech Fluency", wrvu: 2.24 },
 "92522": { name: "Evaluate Speech Production", wrvu: 1.92 },
 "92523": { name: "Speech Sound Lang Comprehensive", wrvu: 3.84 },
 "92524": { name: "Behavral Qualit Analys Voice", wrvu: 1.92 },
 "92526": { name: "Oral Function Therapy", wrvu: 1.34 },
 "92531": { name: "Spontaneous Nystagmus Study", wrvu: 0.00 },
 "92532": { name: "Positional Nystagmus Test", wrvu: 0.00 },
 "92533": { name: "Caloric Vestibular Test", wrvu: 0.00 },
 "92534": { name: "Optokinetic Nystagmus Test", wrvu: 0.00 },
 "92537": { name: "Caloric Vstblr Test With Rec", wrvu: 0.59 },
 "92538": { name: "Caloric Vstblr Test With Rec", wrvu: 0.29 },
 "92540": { name: "Basic Vestibular Evaluation", wrvu: 1.46 },
 "92541": { name: "Spontaneous Nystagmus Test", wrvu: 0.39 },
 "92542": { name: "Positional Nystagmus Test", wrvu: 0.47 },
 "92544": { name: "Optokinetic Nystagmus Test", wrvu: 0.26 },
 "92545": { name: "Oscillating Tracking Test", wrvu: 0.24 },
 "92546": { name: "Sinusoidal Rotational Test", wrvu: 0.28 },
 "92547": { name: "Supplemental Electrical Test", wrvu: 0.00 },
 "92548": { name: "Cdp-sot 6 Cond With I and r", wrvu: 0.65 },
 "92549": { name: "Cdp-sot 6 Cond With I and r Mct and adt", wrvu: 0.85 },
 "92550": { name: "Tympanometry & Reflex Thresh", wrvu: 0.35 },
 "92551": { name: "Pure Tone Hearing Test Air", wrvu: 0.00 },
 "92552": { name: "Pure Tone Audiometry Air", wrvu: 0.00 },
 "92553": { name: "Audiometry Air & Bone", wrvu: 0.00 },
 "92555": { name: "Speech Threshold Audiometry", wrvu: 0.00 },
 "92556": { name: "Speech Audiometry Complete", wrvu: 0.00 },
 "92557": { name: "Comprehensive Hearing Test", wrvu: 0.60 },
 "92558": { name: "Evoked Auditory Test Qual", wrvu: 0.17 },
 "92562": { name: "Loudness Balance Test", wrvu: 0.00 },
 "92563": { name: "Tone Decay Hearing Test", wrvu: 0.00 },
 "92565": { name: "Stenger Test Pure Tone", wrvu: 0.00 },
 "92567": { name: "Tympanometry", wrvu: 0.20 },
 "92568": { name: "Acoustic Refl Threshold Tst", wrvu: 0.29 },
 "92570": { name: "Acoustic Immitance Testing", wrvu: 0.55 },
 "92571": { name: "Filtered Speech Test", wrvu: 0.00 },
 "92572": { name: "Staggered Spondaic Word Test", wrvu: 0.00 },
 "92575": { name: "Sensorineural Acuity Lvl Tst", wrvu: 0.00 },
 "92576": { name: "Synthetic Sentence Id Test", wrvu: 0.00 },
 "92577": { name: "Stenger Test Speech", wrvu: 0.00 },
 "92579": { name: "Visual Audiometry (vra)", wrvu: 0.68 },
 "92582": { name: "Conditioning Play Audiometry", wrvu: 0.00 },
 "92583": { name: "Select Picture Audiometry", wrvu: 0.00 },
 "92584": { name: "Electrocochleography", wrvu: 0.98 },
 "92587": { name: "Evoked Auditory Test Limited", wrvu: 0.35 },
 "92588": { name: "Evoked Auditory Tst Complete", wrvu: 0.55 },
 "92596": { name: "Ear Protector Evaluation", wrvu: 0.00 },
 "92597": { name: "Oral Speech Device Evaluation", wrvu: 1.23 },
 "92601": { name: "Cochlear Implt F/up Exam <7", wrvu: 2.30 },
 "92602": { name: "Reprogram Cochlear Implt <7", wrvu: 1.30 },
 "92603": { name: "Cochlear Implt F/up Exam 7/>", wrvu: 2.25 },
 "92604": { name: "Reprogram Cochlear Implt 7/>", wrvu: 1.25 },
 "92605": { name: "Excision For Nonspeech Device Prescription", wrvu: 1.75 },
 "92606": { name: "Non-speech Device Service", wrvu: 1.37 },
 "92607": { name: "Excision For Speech Device Prescription 1hr", wrvu: 1.85 },
 "92608": { name: "Excision For Speech Device Prescription Additional", wrvu: 0.70 },
 "92609": { name: "Use Of Speech Device Service", wrvu: 1.50 },
 "92610": { name: "Evaluate Swallowing Function", wrvu: 1.30 },
 "92611": { name: "Motion Fluoroscopy/swallow", wrvu: 1.31 },
 "92612": { name: "Endoscopy Swallow (fees) Vid", wrvu: 1.24 },
 "92613": { name: "Endoscopy Swallow (fees) I and r", wrvu: 0.69 },
 "92614": { name: "Laryngoscopic Sensory Vid", wrvu: 1.24 },
 "92615": { name: "Laryngoscopic Sensory I and r", wrvu: 0.61 },
 "92616": { name: "Fees With Laryngeal Sense Test", wrvu: 1.83 },
 "92617": { name: "Fees With Laryngeal Sense I and r", wrvu: 0.77 },
 "92618": { name: "Excision For Nonspeech Device Prescription Add", wrvu: 0.65 },
 "92620": { name: "Auditory Function 60 Minutes", wrvu: 1.50 },
 "92621": { name: "Auditory Function + 15 Minutes", wrvu: 0.35 },
 "92622": { name: "Diagnosis Aly Aud Oi Snd Prcsr 1st", wrvu: 1.25 },
 "92623": { name: "Diagnosis Aly Aud Oi Snd Prcsr Each", wrvu: 0.33 },
 "92625": { name: "Tinnitus Assessment", wrvu: 1.15 },
 "92626": { name: "Evaluation Aud Funcj 1st Hour", wrvu: 1.40 },
 "92627": { name: "Evaluation Aud Funcj Each Additional 15", wrvu: 0.33 },
 "92628": { name: "Evaluation Hearing Aid Cand 1st 30", wrvu: 0.00 },
 "92629": { name: "Evaluation Hearing Aid Cand Each Add", wrvu: 0.00 },
 "92630": { name: "Aud Rehabilitation Pre-ling Hear Loss", wrvu: 0.00 },
 "92631": { name: "Hearing Aid Slctn Svc 1st 30", wrvu: 0.00 },
 "92632": { name: "Hearing Aid Slctn Svc Each Add", wrvu: 0.00 },
 "92633": { name: "Aud Rehabilitation Postling Hear Loss", wrvu: 0.00 },
 "92634": { name: "Hearing Aid Fitg Svc 1st 60", wrvu: 0.00 },
 "92635": { name: "Hearing Aid Fitg Svc Each Additional", wrvu: 0.00 },
 "92636": { name: "Hearing Aid Posterior-fitg F-up 1", wrvu: 0.00 },
 "92637": { name: "Hearing Aid Pst-fitg F-up Each", wrvu: 0.00 },
 "92638": { name: "Bhvl Verif Of Amplification", wrvu: 0.00 },
 "92639": { name: "Hearing Aid Meas Verif", wrvu: 0.00 },
 "92640": { name: "Aud Brainstem Implt Programg", wrvu: 1.76 },
 "92641": { name: "Hearing Device Verif Eacous Aly", wrvu: 0.00 },
 "92642": { name: "Hearing Asstv Device Fitg Svc", wrvu: 0.00 },
 "92650": { name: "Aep Scr Auditory Potential", wrvu: 0.24 },
 "92651": { name: "Aep Hearing Status Deter I and r", wrvu: 0.98 },
 "92652": { name: "Aep Thrshld Established Mlt Freq I and r", wrvu: 1.46 },
 "92653": { name: "Aep Neurodiagnostic I and r", wrvu: 1.02 },
 "92700": { name: "Unlisted Orl Service/Procedure", wrvu: 0.00 },
 "92920": { name: "Prq Trluml C Angiop 1art&/br", wrvu: 8.14 },
 "92924": { name: "Prq Trluml C Athrc 1 Artery&/br", wrvu: 9.88 },
 "92928": { name: "Prq Tcat Placement Ntrac Speech Therapy 1 Lesion", wrvu: 9.75 },
 "92930": { name: "Prq Tcat Placement Ntrac Speech Therapy 2+Lesion", wrvu: 12.00 },
 "92933": { name: "Prq Trlml C Athrc Speech Therapy Angiop1", wrvu: 11.64 },
 "92937": { name: "Prq Trluml Revsc Cab Grf 1", wrvu: 11.02 },
 "92941": { name: "Prq Trlml Revsc Tot Occl Ami", wrvu: 12.40 },
 "92943": { name: "Prq Trluml Revsc Chest Occ Anterior", wrvu: 13.35 },
 "92945": { name: "Prq Trl Rvs Chest Occ Anterior and rtrgr", wrvu: 15.00 },
 "92950": { name: "Heart/lung Resuscitation Cpr", wrvu: 3.90 },
 "92953": { name: "Temporary External Pacing", wrvu: 0.01 },
 "92960": { name: "Cardioversion Electric External", wrvu: 1.95 },
 "92961": { name: "Cardioversion Electric Int", wrvu: 4.23 },
 "92970": { name: "Cardioassist Internal", wrvu: 3.42 },
 "92971": { name: "Cardioassist External", wrvu: 1.73 },
 "92972": { name: "Percutaneous Trluml Coronry Lithotrp", wrvu: 2.90 },
 "92973": { name: "Prq Trluml C Mchn Aspiration Thrmbc", wrvu: 1.71 },
 "92974": { name: "Catheter Place Cardio Brachytx", wrvu: 2.93 },
 "92978": { name: "Endoluminl Ivus Oct C 1st", wrvu: 0.00 },
 "92979": { name: "Endoluminl Ivus Oct C Each", wrvu: 0.00 },
 "92986": { name: "Revision Of Aortic Valve", wrvu: 22.04 },
 "92987": { name: "Revision Of Mitral Valve", wrvu: 22.80 },
 "92990": { name: "Revision Of Pulmonary Valve", wrvu: 17.81 },
 "92997": { name: "Pul Artery Balloon Repr Percutaneous", wrvu: 11.68 },
 "92998": { name: "Pul Artery Balloon Repr Percutaneous", wrvu: 5.84 },
 "93000": { name: "Electrocardiogram (ECG/EKG), Complete (global)", wrvu: 0.17 },
 "93005": { name: "Electrocardiogram (ECG/EKG), Tracing Only", wrvu: 0.00 },
 "93010": { name: "Electrocardiogram (ECG/EKG), Interpretation & Report Only", wrvu: 0.17 },
 "93015": { name: "Cv Stress Test Supvj I and r", wrvu: 0.73 },
 "93016": { name: "Cv Stress Test Supvj Only", wrvu: 0.44 },
 "93017": { name: "Cv Stress Test Tracing Only", wrvu: 0.00 },
 "93018": { name: "Cv Stress Test I and r Only", wrvu: 0.29 },
 "93024": { name: "Ergonovine Provocation Test", wrvu: 1.14 },
 "93025": { name: "Microvolt T-wave Assess", wrvu: 0.73 },
 "93040": { name: "Rhythm ECG With Report", wrvu: 0.15 },
 "93041": { name: "Rhythm ECG Tracing", wrvu: 0.00 },
 "93042": { name: "Rhythm ECG Report", wrvu: 0.15 },
 "93050": { name: "Artery Pressure Waveform Analys", wrvu: 0.17 },
 "93145": { name: "Interrog Crtd Sinus Bat Ip Without", wrvu: 0.65 },
 "93146": { name: "Interrog Crtd Sinus Bat Ip W/", wrvu: 0.90 },
 "93150": { name: "Therapy Activation Ipnss", wrvu: 0.83 },
 "93151": { name: "Interrog and prgrmg Ipnss", wrvu: 0.78 },
 "93152": { name: "Interrog and prgrmg Ipnss Polysm", wrvu: 1.77 },
 "93153": { name: "Interrog Without Prgrmg Ipnss", wrvu: 0.42 },
 "93224": { name: "Xtrnl ECG Rec Up To 48 Hours", wrvu: 0.38 },
 "93225": { name: "Xtrnl ECG Rec<48 Hours Rec", wrvu: 0.00 },
 "93226": { name: "Xtrnl ECG Rec<48 hr Scan A/r", wrvu: 0.00 },
 "93227": { name: "Xtrnl ECG Rec<48 hr R and i", wrvu: 0.38 },
 "93228": { name: "Remote 30 Day ECG Revision/report", wrvu: 0.47 },
 "93229": { name: "Remote 30 Day ECG Tech Supp", wrvu: 0.00 },
 "93241": { name: "Xtrnl ECG Rec>48hr<7d", wrvu: 0.49 },
 "93242": { name: "External Ecg>48hr<7d Recording", wrvu: 0.00 },
 "93243": { name: "External Ecg>48hr<7d Scan A/r", wrvu: 0.00 },
 "93244": { name: "External Ecg>48hr<7d Revision and interpj", wrvu: 0.49 },
 "93245": { name: "External Ecg>7d<15d Rec Scan A/r", wrvu: 0.54 },
 "93246": { name: "External Ecg>7d<15d Recording", wrvu: 0.00 },
 "93247": { name: "External Ecg>7d<15d Scan A/r", wrvu: 0.00 },
 "93248": { name: "External Ecg>7d<15d Revision and interpj", wrvu: 0.54 },
 "93260": { name: "Prgrmg Device Evaluation Impltbl System", wrvu: 0.83 },
 "93261": { name: "Interrogate Subcutaneous Defib", wrvu: 0.72 },
 "93264": { name: "Rem Mntr Wrls P-Artery Prs Snr", wrvu: 0.68 },
 "93268": { name: "ECG Record/review", wrvu: 0.51 },
 "93270": { name: "Remote 30 Day ECG Revision/report", wrvu: 0.00 },
 "93271": { name: "Ecg/monitoring And Analysis", wrvu: 0.00 },
 "93272": { name: "Ecg/review Interpret Only", wrvu: 0.51 },
 "93278": { name: "Ecg/signal-averaged", wrvu: 0.24 },
 "93279": { name: "Prgrmg Device Evaluation Pacemaker/ldls Pacemaker", wrvu: 0.63 },
 "93280": { name: "Pacemaker Device Progr Evaluation Dual", wrvu: 0.75 },
 "93281": { name: "Pacemaker Device Progr Evaluation Multi", wrvu: 0.83 },
 "93282": { name: "Prgrmg Evaluation Implantable Dfb", wrvu: 0.83 },
 "93283": { name: "Prgrmg Evaluation Implantable Dfb", wrvu: 1.12 },
 "93284": { name: "Prgrmg Evaluation Implantable Dfb", wrvu: 1.22 },
 "93285": { name: "Prgrmg Device Evaluation Scrms Ip", wrvu: 0.51 },
 "93286": { name: "Peri-Procedure Evaluation Pacemaker/ldls Pacemaker Ip", wrvu: 0.29 },
 "93287": { name: "Peri-Procedure Device Evaluation & Prgr", wrvu: 0.44 },
 "93288": { name: "Interrog Evl Pacemaker/ldls Pacemaker Ip", wrvu: 0.42 },
 "93289": { name: "Interrog Device Evaluation Heart", wrvu: 0.73 },
 "93290": { name: "Interrog Device Evaluation Icpms Ip", wrvu: 0.42 },
 "93291": { name: "Interrog Device Evaluation Scrms Ip", wrvu: 0.36 },
 "93292": { name: "Wcd Device Interrogate", wrvu: 0.42 },
 "93293": { name: "Pacemaker Phone R-strip Device Evaluation", wrvu: 0.30 },
 "93294": { name: "Rem Interrog Evl Pacemaker/ldls Pacemaker", wrvu: 0.59 },
 "93295": { name: "Device Interrog Remote 1/2/mlt", wrvu: 0.72 },
 "93296": { name: "Rem Interrog Evl Pacemaker/ids", wrvu: 0.00 },
 "93297": { name: "Rem Interrog Device Evaluation Icpms", wrvu: 0.51 },
 "93298": { name: "Rem Interrog Device Evaluation Scrms", wrvu: 0.51 },
 "93303": { name: "Echocardiographic Transthoracic", wrvu: 1.27 },
 "93304": { name: "Echocardiographic Transthoracic", wrvu: 0.73 },
 "93306": { name: "Transthoracic Echocardiographic With Doppler Complete", wrvu: 1.42 },
 "93307": { name: "Transthoracic Echocardiographic Without Doppler Complete", wrvu: 0.90 },
 "93308": { name: "Transthoracic Echocardiographic F-up Or Lmtd", wrvu: 0.52 },
 "93312": { name: "Echocardiographic Transesophageal", wrvu: 2.24 },
 "93313": { name: "Echocardiographic Transesophageal", wrvu: 0.25 },
 "93314": { name: "Echocardiographic Transesophageal", wrvu: 1.80 },
 "93315": { name: "Echocardiographic Transesophageal", wrvu: 0.00 },
 "93316": { name: "Echocardiographic Transesophageal", wrvu: 0.59 },
 "93317": { name: "Echocardiographic Transesophageal", wrvu: 0.00 },
 "93318": { name: "Echocardiographic Transesophageal Intraop", wrvu: 0.00 },
 "93319": { name: "3d Echocardiographic Imaging Cgen Car Anomal", wrvu: 0.49 },
 "93320": { name: "Doppler Echocardiographic Complete", wrvu: 0.37 },
 "93321": { name: "Doppler Echocardiographic F-up/lmtd STD", wrvu: 0.15 },
 "93325": { name: "Doppler Echocardiographic Color Flow Mapg", wrvu: 0.07 },
 "93350": { name: "Stress Transthoracic Echocardiographic Only", wrvu: 1.42 },
 "93351": { name: "Stress Transthoracic Echocardiographic Complete", wrvu: 1.71 },
 "93352": { name: "Administration ECG Contrast Agent", wrvu: 0.19 },
 "93355": { name: "Echocardiographic Transesophageal (Transesophageal Echocardiographic)", wrvu: 4.54 },
 "93356": { name: "Myocrd Strain Imaging Spckl Trck", wrvu: 0.23 },
 "93451": { name: "Right Heart Catheter", wrvu: 2.41 },
 "93452": { name: "Left Heart Catheter With Ventrclgrphy", wrvu: 4.39 },
 "93453": { name: "R and l Heart Catheter With Ventriclgrphy", wrvu: 5.84 },
 "93454": { name: "Coronary Artery Angiography S and i", wrvu: 4.43 },
 "93455": { name: "Coronary Artery/Graft Angiography S and i", wrvu: 5.16 },
 "93456": { name: "R Heart Coronary Artery Angiography", wrvu: 5.75 },
 "93457": { name: "R Heart Artery/Graft Angiography", wrvu: 6.47 },
 "93458": { name: "L Heart Artery/ventricle Angiography", wrvu: 5.46 },
 "93459": { name: "L Heart Artery/Graft Angiography", wrvu: 6.19 },
 "93460": { name: "R and l Heart Artery/ventricle Angiography", wrvu: 6.92 },
 "93461": { name: "R and l Heart Artery/ventricle Angiography", wrvu: 7.65 },
 "93462": { name: "L Heart Catheter Trnsptl Puncture", wrvu: 3.64 },
 "93463": { name: "Drug Administration & Hemodynmic Meas", wrvu: 1.95 },
 "93464": { name: "Exercise With Hemodynamic Meas", wrvu: 1.76 },
 "93503": { name: "Insert/place Heart Catheter", wrvu: 1.95 },
 "93505": { name: "Endomyocardial Biopsy", wrvu: 4.02 },
 "93563": { name: "Injection Cgen Car Catheter Slctv C Ang", wrvu: 0.98 },
 "93564": { name: "Injection Cgen Car Catheter Slctv Opac", wrvu: 1.00 },
 "93565": { name: "Injection Car Catheter Slctv Lv/la Ang", wrvu: 0.49 },
 "93566": { name: "Injection Car Catheter Slctv Rv/ra Ang", wrvu: 0.49 },
 "93567": { name: "Injection Car Catheter Sprvlv Aortgrphy", wrvu: 0.68 },
 "93568": { name: "Injection Car Catheter Nslc P-Artery Angrp", wrvu: 0.86 },
 "93569": { name: "Injection Catheter Slct P-Artery Angrp Uni", wrvu: 0.76 },
 "93571": { name: "Intravenous Dop Vel&/pressure C Flo 1st", wrvu: 0.00 },
 "93572": { name: "Intravenous Dop Vel&/pressure C Flo Each", wrvu: 0.00 },
 "93573": { name: "Injection Catheter Slct P-Artery Angrp Bi", wrvu: 1.27 },
 "93574": { name: "Injection Catheter Slct Pulm Vein Angrph", wrvu: 1.40 },
 "93575": { name: "Injection Catheter Slct P Angrph Mapca", wrvu: 1.87 },
 "93580": { name: "Transcath Closure Of Asd", wrvu: 17.52 },
 "93581": { name: "Transcath Closure Of Vsd", wrvu: 23.78 },
 "93582": { name: "Percutaneous Transcath Closure Pda", wrvu: 12.00 },
 "93583": { name: "Percutaneous Transcath Septal Reduxn", wrvu: 13.41 },
 "93584": { name: "Vngrph Chd Anom/persist Svc", wrvu: 1.17 },
 "93585": { name: "Vngrph Chd Azygs/hemiazygs", wrvu: 1.10 },
 "93586": { name: "Vngrph Chd Coronary Sinus", wrvu: 1.39 },
 "93587": { name: "Vngrph Chd Vnvn Cltrl At/abv", wrvu: 2.06 },
 "93588": { name: "Vngrph Chd Vnvn Cltrl Below", wrvu: 2.08 },
 "93590": { name: "Percutaneous Transcath Cls Mitral", wrvu: 21.16 },
 "93591": { name: "Percutaneous Transcath Cls Aortic", wrvu: 17.52 },
 "93592": { name: "Percutaneous Transcath Closure Each", wrvu: 7.80 },
 "93593": { name: "R Heart Catheter Chd Nml Nt Conjunctiva", wrvu: 0.00 },
 "93594": { name: "R Heart Catheter Chd Abnl Nt Conjunctiva", wrvu: 0.00 },
 "93595": { name: "L Heart Catheter Chd Nm/abn Nt Conjunctiva", wrvu: 0.00 },
 "93596": { name: "R and l Heart Catheter Chd Nml Nt Conjunctiva", wrvu: 0.00 },
 "93597": { name: "R and l Heart Catheter Chd Abnl Nt Conjunctiva", wrvu: 0.00 },
 "93598": { name: "Car Outp Meas Drainage Catheter Chd", wrvu: 0.00 },
 "93600": { name: "Bundle Of His Recording", wrvu: 0.00 },
 "93602": { name: "Intra-atrial Recording", wrvu: 0.00 },
 "93603": { name: "Right Ventricular Recording", wrvu: 0.00 },
 "93609": { name: "Intra-vntr Mapg Tchycar Site", wrvu: 0.00 },
 "93610": { name: "Intra-atrial Pacing", wrvu: 0.00 },
 "93612": { name: "Intraventricular Pacing", wrvu: 0.00 },
 "93613": { name: "Intracranial Ephys 3d Mapg", wrvu: 5.10 },
 "93615": { name: "Esophageal Recording", wrvu: 0.00 },
 "93616": { name: "Esophageal Recording With Pacg", wrvu: 0.00 },
 "93618": { name: "Indctj Arrhythmia Elec Pacg", wrvu: 0.00 },
 "93619": { name: "Comprehensive Electrophysiology Evaluation", wrvu: 0.00 },
 "93620": { name: "Comp Electrophysiology Evl R At Ven Pac and rec", wrvu: 0.00 },
 "93621": { name: "Comp Electrophysiology Evl L Pac and rec C Sinus", wrvu: 0.00 },
 "93622": { name: "Comp Electrophysiology Evaluation L Ventr Pac and rec", wrvu: 0.00 },
 "93623": { name: "Prgrmd Stimj and pacg Intravenous Prescription Nfs", wrvu: 0.00 },
 "93624": { name: "Electrophysiology F-up Study Pacg and rec", wrvu: 0.00 },
 "93631": { name: "Ntraop Epicar and endcar Pac and map", wrvu: 0.00 },
 "93640": { name: "Electrophysiology Evaluation 1/2chmbr Pacg Cardioverter-Defibrillator", wrvu: 0.00 },
 "93641": { name: "Electrophysiology Evl 1/2chmb Pac Cardioverter-Defibrillator Tst", wrvu: 0.00 },
 "93642": { name: "Electrophysiology Evl 1/2chmb Trnsvns Cardioverter-Defibrillator", wrvu: 4.51 },
 "93644": { name: "Electrophysiology Evaluation Subcutaneous Impl Dfb", wrvu: 2.96 },
 "93650": { name: "Icar Catheter Abltj Av Node Func", wrvu: 9.98 },
 "93653": { name: "Compre Electrophysiology Evaluation Treatment Svt", wrvu: 14.63 },
 "93654": { name: "Compre Electrophysiology Evaluation Treatment Vt", wrvu: 17.65 },
 "93655": { name: "Icar Catheter Abltj Dscrt Arrhythmia", wrvu: 5.36 },
 "93656": { name: "Compre Electrophysiology Evaluation Abltj Atr Fibular", wrvu: 16.58 },
 "93657": { name: "Treatment L/r Atrial Fibular Additional", wrvu: 5.36 },
 "93660": { name: "Tilt Table Evaluation", wrvu: 1.84 },
 "93662": { name: "Intracranial ECG (ice)", wrvu: 0.00 },
 "93668": { name: "Peripheral Vascular Rehabilitation", wrvu: 0.00 },
 "93701": { name: "Bioimpedance Cv Analysis", wrvu: 0.00 },
 "93702": { name: "Bis Xtracell Fluid Analysis", wrvu: 0.00 },
 "93724": { name: "Elec Alys Antitchycar Pacemaker System", wrvu: 4.76 },
 "93740": { name: "Temperature Gradient Studies", wrvu: 0.16 },
 "93745": { name: "Set-up Cardiovert-defibrill", wrvu: 0.00 },
 "93750": { name: "Interrogation Vad In Person", wrvu: 0.75 },
 "93770": { name: "Determination Venous Pressure", wrvu: 0.16 },
 "93784": { name: "Ambl Bp Mntr With Software", wrvu: 0.37 },
 "93786": { name: "Ambl Bp Mntr With Sw Rec Only", wrvu: 0.00 },
 "93788": { name: "Ambl Bp Mntr With Sw A/r", wrvu: 0.00 },
 "93790": { name: "Ambl Bp Mntr With Sw I and r", wrvu: 0.37 },
 "93792": { name: "Patient/caregiver Traing Home INR", wrvu: 0.00 },
 "93793": { name: "Anticoag Management Prothrombin Time Warfarin", wrvu: 0.18 },
 "93797": { name: "Cardiac Rehabilitation Services, without ECG monitoring", wrvu: 0.18 },
 "93798": { name: "Cardiac Rehabilitation Services, with ECG monitoring", wrvu: 0.28 },
 "93799": { name: "Unlisted Cv Svc/procedure", wrvu: 0.00 },
 "93880": { name: "Extracranial Bilateral Study", wrvu: 0.78 },
 "93882": { name: "Extracranial Uni/ltd Study", wrvu: 0.49 },
 "93886": { name: "Intracranial Complete Study", wrvu: 0.88 },
 "93888": { name: "Intracranial Limited Study", wrvu: 0.71 },
 "93892": { name: "Tcd Emboli Detect Without Injection", wrvu: 1.12 },
 "93893": { name: "Tcd STD Intracranial Artery Ven-Artery Shunt", wrvu: 1.12 },
 "93895": { name: "Carotid Intima Atheroma Evaluation", wrvu: 0.00 },
 "93896": { name: "Vsrctv STD Tcd Intracranial Artery Compl", wrvu: 0.79 },
 "93897": { name: "Emboli Detcj without Intravenous Mbubb Injection", wrvu: 0.71 },
 "93898": { name: "Ven-artl Shunt Det Mbubb Injection", wrvu: 0.83 },
 "93922": { name: "Upper/l Xtremity Artery 2 Levels", wrvu: 0.24 },
 "93923": { name: "Upper/lxtr Artery Stdy 3+ Lvls", wrvu: 0.44 },
 "93924": { name: "Lower Xtr Vasc Stdy Bilateral", wrvu: 0.49 },
 "93925": { name: "Lower Extremity Study", wrvu: 0.78 },
 "93926": { name: "Lower Extremity Study", wrvu: 0.49 },
 "93930": { name: "Upper Extremity Study", wrvu: 0.78 },
 "93931": { name: "Upper Extremity Study", wrvu: 0.49 },
 "93970": { name: "Extremity Study", wrvu: 0.68 },
 "93971": { name: "Extremity Study", wrvu: 0.44 },
 "93975": { name: "Vascular Study", wrvu: 1.13 },
 "93976": { name: "Vascular Study", wrvu: 0.78 },
 "93978": { name: "Vascular Study", wrvu: 0.78 },
 "93979": { name: "Vascular Study", wrvu: 0.49 },
 "93980": { name: "Penile Vascular Study", wrvu: 1.22 },
 "93981": { name: "Penile Vascular Study", wrvu: 0.43 },
 "93985": { name: "Dup-scan Hemo Compl Bi STD", wrvu: 0.78 },
 "93986": { name: "Dup-scan Hemo Compl Uni STD", wrvu: 0.49 },
 "93990": { name: "Doppler Flow Testing", wrvu: 0.49 },
 "93998": { name: "Unlistd Noninvas Vasc Diagnosis STD", wrvu: 0.00 },
 "94002": { name: "Ventilation Management Inpat Init Day", wrvu: 1.99 },
 "94003": { name: "Ventilation Management Inpat Subcutaneous Day", wrvu: 1.37 },
 "94004": { name: "Ventilation Management Nf Per Day", wrvu: 1.00 },
 "94005": { name: "Home Ventilation Management Supervision", wrvu: 1.50 },
 "94010": { name: "Spirometry (includes graph)", wrvu: 0.17 },
 "94011": { name: "Spirometry Up To 2 Years Old", wrvu: 1.71 },
 "94012": { name: "Spirmtry With Brnchdil Inferior-2 Year", wrvu: 2.78 },
 "94013": { name: "Meas Lung Vol Thru 2 Years", wrvu: 0.40 },
 "94014": { name: "Patient Recorded Spirometry", wrvu: 0.51 },
 "94015": { name: "Patient Recorded Spirometry", wrvu: 0.00 },
 "94016": { name: "Review Patient Spirometry", wrvu: 0.51 },
 "94060": { name: "Bronchodilation Responsiveness (pre & Posterior bronchodilator)", wrvu: 0.21 },
 "94070": { name: "Evaluation Of Wheezing", wrvu: 0.59 },
 "94150": { name: "Vital Capacity Test", wrvu: 0.07 },
 "94200": { name: "Lung Function Test (mbc/mvv)", wrvu: 0.05 },
 "94375": { name: "Respiratory Flow Volume Loop", wrvu: 0.30 },
 "94450": { name: "Breathing Response Hypoxia", wrvu: 0.39 },
 "94452": { name: "Hast With I and r Physician/Qualified Health Professional Health Professional", wrvu: 0.30 },
 "94453": { name: "Hast With Suppl Oxygen Titrj", wrvu: 0.39 },
 "94610": { name: "Intrapulm Surfactant Admn", wrvu: 1.13 },
 "94617": { name: "Exercise Tst Brncspsm With ECG", wrvu: 0.68 },
 "94618": { name: "Pulmonary Stress Testing", wrvu: 0.47 },
 "94619": { name: "Exercise Tst Brncspsm without ECG", wrvu: 0.48 },
 "94621": { name: "Cardiopulm Exercise Testing", wrvu: 1.38 },
 "94625": { name: "Physician/Qualified Health Professional Health Professional Op Pulm Rhb Without Mntr", wrvu: 0.36 },
 "94626": { name: "Physician/Qualified Health Professional Health Professional Op Pulm Rhb With Mntr", wrvu: 0.56 },
 "94640": { name: "Pressurized/Nonpressurized Inhalation Treatment (nebulizer)", wrvu: 0.00 },
 "94642": { name: "Aerosol Inhalation Treatment", wrvu: 0.00 },
 "94644": { name: "Cont Inhlj Treatment 1st Hour", wrvu: 0.00 },
 "94645": { name: "Cont Inhlj Treatment Each Additional Hour", wrvu: 0.00 },
 "94660": { name: "Cpap Initiation and Management", wrvu: 0.74 },
 "94664": { name: "Aerosol/Vapor Inhalation Instruction & Demonstration", wrvu: 0.00 },
 "94667": { name: "Manipulation Chest Wall 1st", wrvu: 0.00 },
 "94668": { name: "Manipulation Chest Wall Subsequent", wrvu: 0.00 },
 "94669": { name: "Mechanical Chest Wall Oscill", wrvu: 0.00 },
 "94680": { name: "O2 Uptk Rst and xers Dir Simple", wrvu: 0.25 },
 "94681": { name: "O2 Uptk Co2 Outp % O2 Xtrc", wrvu: 0.20 },
 "94690": { name: "O2 Uptk Rest Indirect", wrvu: 0.07 },
 "94726": { name: "Plethysmography Lung Volumes", wrvu: 0.25 },
 "94727": { name: "Gas Dil/wshot Deter Lung Vol", wrvu: 0.25 },
 "94728": { name: "Airwy Resist By Oscillometry", wrvu: 0.25 },
 "94729": { name: "Diffusing Capacity", wrvu: 0.19 },
 "94760": { name: "Pulse Oximetry, Single Determination", wrvu: 0.00 },
 "94761": { name: "Pulse Oximetry, Multiple Determinations", wrvu: 0.00 },
 "94762": { name: "N-invas Ear/pls Oximtry Cont", wrvu: 0.00 },
 "94772": { name: "Circadian Respir Pattern Rec", wrvu: 0.00 },
 "94774": { name: "Ped Home Apnea Mntr Evnt Rec", wrvu: 0.00 },
 "94775": { name: "Ped Home Apnea Mntr Att Only", wrvu: 0.00 },
 "94776": { name: "Ped Home Apnea Mntr Dl and alys", wrvu: 0.00 },
 "94777": { name: "Ped Home Apnea Mntr Rvw I and r", wrvu: 0.00 },
 "94780": { name: "Cars/bd Tst Inft-12mo 60 Minutes", wrvu: 0.48 },
 "94781": { name: "Cars/bd Tst Inft-12mo +30min", wrvu: 0.17 },
 "94799": { name: "Unlisted Pulmonary Svc/Procedure", wrvu: 0.00 },
 "95004": { name: "Percutaneous Tests With Alrgnc Xtrcs", wrvu: 0.01 },
 "95012": { name: "Nitric Oxide Exp Gas Deter", wrvu: 0.00 },
 "95017": { name: "Acute Lymphoblastic Leukemia Tstg Percutaneous and iq With Venoms", wrvu: 0.07 },
 "95018": { name: "Acute Lymphoblastic Leukemia Tstg Percutaneous and iq Drugs/biol", wrvu: 0.14 },
 "95024": { name: "Iq Tests With Allergenic Xtrcs", wrvu: 0.01 },
 "95027": { name: "Iq Tsts Seql and incrl Airborne", wrvu: 0.01 },
 "95028": { name: "Iq Tsts Allergy Delayed Rxn", wrvu: 0.00 },
 "95044": { name: "Patch/application Tests", wrvu: 0.00 },
 "95052": { name: "Photo Patch Tests", wrvu: 0.00 },
 "95056": { name: "Photo Tests", wrvu: 0.00 },
 "95060": { name: "Oph Mucous Membrane Tests", wrvu: 0.00 },
 "95065": { name: "Dir Nasal Mucous Membrane Test", wrvu: 0.00 },
 "95070": { name: "Inhlj Brncl Challenge Tstg", wrvu: 0.00 },
 "95076": { name: "Ingest Challenge Ini 120 Minutes", wrvu: 1.50 },
 "95079": { name: "Ingest Challenge Additional 60 Minutes", wrvu: 1.38 },
 "95115": { name: "Immunotherapy One Injection", wrvu: 0.00 },
 "95117": { name: "Immunotherapy Injections", wrvu: 0.00 },
 "95120": { name: "Immunotherapy One Injection", wrvu: 0.00 },
 "95125": { name: "Immunotherapy 2/> Injections", wrvu: 0.00 },
 "95130": { name: "Immntx 1 Sting Insect", wrvu: 0.00 },
 "95131": { name: "Immntx 2 Sting Insects", wrvu: 0.00 },
 "95132": { name: "Immntx 3 Sting Insects", wrvu: 0.00 },
 "95133": { name: "Immntx 4 Sting Insects", wrvu: 0.00 },
 "95134": { name: "Immntx 5 Sting Insects", wrvu: 0.00 },
 "95144": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95145": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95146": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95147": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95148": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95149": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95165": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95170": { name: "Antigen Therapy Services", wrvu: 0.06 },
 "95180": { name: "Rapid Desensitization", wrvu: 2.01 },
 "95199": { name: "Unlisted Acute Lymphoblastic Leukemia/immlg Svc/Procedure", wrvu: 0.00 },
 "95249": { name: "Cont Gluc Mntr Prothrombin Time Prov Eqp", wrvu: 0.00 },
 "95250": { name: "Cont Gluc Mntr Physician/Qualified Health Professional Health Professional Eqp", wrvu: 0.00 },
 "95251": { name: "Cont Gluc Mntr Analysis I and r", wrvu: 0.68 },
 "95700": { name: "Eeg Cont Rec With Vid Eeg Tech", wrvu: 0.00 },
 "95705": { name: "Eeg Without Vid 2-12 hr Unmntr", wrvu: 0.00 },
 "95706": { name: "Eeg without Vid 2-12hr Intmt Mntr", wrvu: 0.00 },
 "95707": { name: "Eeg Without Vid 2-12hr Cont Mntr", wrvu: 0.00 },
 "95708": { name: "Eeg without Vid Each 12-26hr Unmntr", wrvu: 0.00 },
 "95709": { name: "Eeg Without Vid Each 12-26hr Intmt", wrvu: 0.00 },
 "95710": { name: "Eeg Without Vid Each 12-26hr Cont", wrvu: 0.00 },
 "95711": { name: "Veeg 2-12 hr Unmonitored", wrvu: 0.00 },
 "95712": { name: "Veeg 2-12 hr Intmt Mntr", wrvu: 0.00 },
 "95713": { name: "Veeg 2-12 hr Cont Mntr", wrvu: 0.00 },
 "95714": { name: "Veeg Each 12-26 hr Unmntr", wrvu: 0.00 },
 "95715": { name: "Veeg Each 12-26hr Intmt Mntr", wrvu: 0.00 },
 "95716": { name: "Veeg Each 12-26hr Cont Mntr", wrvu: 0.00 },
 "95717": { name: "Eeg Physician/Qualified Health Professional Health Professional 2-12 hr Without Vid", wrvu: 1.95 },
 "95718": { name: "Eeg Physician/Qualified Health Professional Health Professional 2-12 hr With Veeg", wrvu: 2.44 },
 "95719": { name: "Eeg Physician/Qualified Health Professional Health Professional Each Incr Without Vid", wrvu: 2.93 },
 "95720": { name: "Eeg Physician/Qualified Health Professional Health Professional Each Incr With Veeg", wrvu: 3.76 },
 "95721": { name: "Eeg Physician/Qualified Health Professional Health Professional>36<60 hr Without Vid", wrvu: 3.86 },
 "95722": { name: "Eeg Physician/Qualified Health Professional Health Professional>36<60 hr With Veeg", wrvu: 4.70 },
 "95723": { name: "Eeg Physician/Qualified Health Professional Health Professional>60<84 hr Without Vid", wrvu: 4.75 },
 "95724": { name: "Eeg Physician/Qualified Health Professional Health Professional>60<84 hr With Veeg", wrvu: 6.00 },
 "95725": { name: "Eeg Physician/Qualified Health Professional Health Professional>84 hr Without Vid", wrvu: 5.40 },
 "95726": { name: "Eeg Physician/Qualified Health Professional Health Professional>84 hr With Veeg", wrvu: 7.58 },
 "95782": { name: "Polysom <6 Years 4/> Paramtrs", wrvu: 2.54 },
 "95783": { name: "Polysom <6 Years Cpap/bilvl", wrvu: 2.76 },
 "95800": { name: "Slp Stdy Unattended", wrvu: 0.83 },
 "95801": { name: "Slp Stdy Unatnd With Anal", wrvu: 0.83 },
 "95803": { name: "Actigraphy Testing", wrvu: 0.88 },
 "95805": { name: "Multiple Sleep Latency Test", wrvu: 1.17 },
 "95806": { name: "Sleep Study Unatt and resp Efft", wrvu: 0.91 },
 "95807": { name: "Sleep Study Attended", wrvu: 1.25 },
 "95808": { name: "Polysom Any Age 1-3> Param", wrvu: 1.70 },
 "95810": { name: "Polysom 6/> Years 4/> Param", wrvu: 2.44 },
 "95811": { name: "Polysom 6/>years Cpap 4/> Parm", wrvu: 2.54 },
 "95812": { name: "Eeg 41-60 Minutes", wrvu: 1.08 },
 "95813": { name: "Eeg Extnd Mntr 61-119 Minutes", wrvu: 1.63 },
 "95816": { name: "Eeg Awake And Drowsy", wrvu: 1.05 },
 "95819": { name: "Eeg Awake And Asleep", wrvu: 1.05 },
 "95822": { name: "Eeg Coma Or Sleep Only", wrvu: 1.05 },
 "95824": { name: "Eeg Cerebral Death Only", wrvu: 0.00 },
 "95829": { name: "Surgery Electrocorticogram", wrvu: 6.05 },
 "95830": { name: "Insert Electrodes For Eeg", wrvu: 1.66 },
 "95836": { name: "Ecog Impltd Brn Npgt <30 D", wrvu: 1.93 },
 "95851": { name: "Range Of Motion Measurements", wrvu: 0.16 },
 "95852": { name: "Range Of Motion Measurements", wrvu: 0.11 },
 "95857": { name: "Cholinesterase Challenge", wrvu: 0.52 },
 "95860": { name: "Needle Emg 1 Extremity", wrvu: 0.94 },
 "95861": { name: "Needle Emg 2 Extremities", wrvu: 1.50 },
 "95863": { name: "Needle Emg 3 Extremities", wrvu: 1.82 },
 "95864": { name: "Needle Emg 4 Extremities", wrvu: 1.94 },
 "95865": { name: "Needle Emg Larynx", wrvu: 1.53 },
 "95866": { name: "Needle Emg Hemidiaphragm", wrvu: 1.22 },
 "95867": { name: "Needle Emg Cranial Nerve Muscle Uni", wrvu: 0.77 },
 "95868": { name: "Needle Emg Cranial Nerve Muscle Bi", wrvu: 1.15 },
 "95869": { name: "Needle Emg Thoracic Paraspinal Muscle", wrvu: 0.36 },
 "95870": { name: "Needle Emg Lmtd STD Muscle 1 Xtr", wrvu: 0.36 },
 "95872": { name: "Needle Emg Single Fiber Eltrd", wrvu: 2.81 },
 "95873": { name: "Guide Nerv Destr Elec Stimulation", wrvu: 0.36 },
 "95874": { name: "Guide Nerv Destr Needle Emg", wrvu: 0.36 },
 "95875": { name: "Limb Exercise Test", wrvu: 1.07 },
 "95885": { name: "Muscle Tst Done With Nerv Tst Lim", wrvu: 0.34 },
 "95886": { name: "Muscle Test Done With N Test Comp", wrvu: 0.84 },
 "95887": { name: "Muscle Tst Done With N Tst Nonext", wrvu: 0.69 },
 "95905": { name: "Motor &/ Sens Nrve Cndj Test", wrvu: 0.05 },
 "95907": { name: "Nvr Cndj Tst 1-2 Studies", wrvu: 0.98 },
 "95908": { name: "Nerve Cndj Tst 3-4 Studies", wrvu: 1.22 },
 "95909": { name: "Nerve Cndj Tst 5-6 Studies", wrvu: 1.46 },
 "95910": { name: "Nerve Cndj Test 7-8 Studies", wrvu: 1.95 },
 "95911": { name: "Nerve Cndj Test 9-10 Studies", wrvu: 2.44 },
 "95912": { name: "Nerve Cndj Test 11-12 Studies", wrvu: 2.93 },
 "95913": { name: "Nerve Cndj Test 13/> Studies", wrvu: 3.47 },
 "95919": { name: "Quan Puplmtry Physician/Qualified Health Professional Health Professional Uni/bi", wrvu: 0.18 },
 "95921": { name: "Autonomic Nerve Parasym Inervj", wrvu: 0.88 },
 "95922": { name: "Autonomic Nerve Adrenrg Inervj", wrvu: 0.96 },
 "95923": { name: "Autonomic Nerve Syst Funj Test", wrvu: 0.88 },
 "95924": { name: "Anus Parasymp & Symp With Tilt", wrvu: 1.73 },
 "95925": { name: "Somatosensory Testing", wrvu: 0.53 },
 "95926": { name: "Somatosensory Testing", wrvu: 0.53 },
 "95927": { name: "Somatosensory Testing", wrvu: 0.53 },
 "95928": { name: "C Motor Evoked Uppr Limbs", wrvu: 1.46 },
 "95929": { name: "C Motor Evoked Lower Limbs", wrvu: 1.46 },
 "95930": { name: "Visual Electrophysiology Test Cns With I and r", wrvu: 0.34 },
 "95933": { name: "Blink Reflex Test", wrvu: 0.58 },
 "95937": { name: "Neuromuscular Junction Test", wrvu: 0.63 },
 "95938": { name: "Somatosensory Testing", wrvu: 0.84 },
 "95939": { name: "C Motor Evoked Upper and Lower Limbs", wrvu: 2.19 },
 "95940": { name: "Ionm In Operatng Room 15 Minutes", wrvu: 0.60 },
 "95941": { name: "Ionm Remote/>1 Prothrombin Time Or Per Hr", wrvu: 0.00 },
 "95954": { name: "Eeg Monitoring/giving Drugs", wrvu: 2.39 },
 "95955": { name: "Eeg During Surgery", wrvu: 0.98 },
 "95957": { name: "Eeg Digital Analysis", wrvu: 1.93 },
 "95958": { name: "Eeg Monitoring/function Test", wrvu: 4.13 },
 "95961": { name: "Electrode Stimulation Brain", wrvu: 2.97 },
 "95962": { name: "Electrode Stimulation Brain Add-on", wrvu: 3.21 },
 "95965": { name: "Meg Spontaneous", wrvu: 0.00 },
 "95966": { name: "Meg Evoked Single", wrvu: 0.00 },
 "95967": { name: "Meg Evoked Each Additional", wrvu: 0.00 },
 "95970": { name: "Alys Npgt Without Prgrmg", wrvu: 0.35 },
 "95971": { name: "Alys Simple Sp/pn Npgt With Prgrm", wrvu: 0.78 },
 "95972": { name: "Alys Cplx Sp/pn Npgt With Prgrm", wrvu: 0.80 },
 "95976": { name: "Alys Simple Cn Npgt Prgrmg", wrvu: 0.71 },
 "95977": { name: "Alys Cplx Cn Npgt Prgrmg", wrvu: 0.95 },
 "95980": { name: "Io Anal Gast N-Stimulation Init", wrvu: 0.78 },
 "95981": { name: "Io Anal Gast N-Stimulation Subsq", wrvu: 0.29 },
 "95982": { name: "Io Ga N-Stimulation Subsq With Reprog", wrvu: 0.63 },
 "95983": { name: "Alys Brn Npgt Prgrmg 15 Minutes", wrvu: 0.91 },
 "95984": { name: "Alys Brn Npgt Prgrmg Additional 15", wrvu: 0.80 },
 "95990": { name: "Spin/brain Pump Refil & Main", wrvu: 0.00 },
 "95991": { name: "Spin/brain Pump Refil & Main", wrvu: 0.75 },
 "95992": { name: "Canalith Repositioning Procedure", wrvu: 0.73 },
 "95999": { name: "Unlisted Neurological Diagnosis Procedure", wrvu: 0.00 },
 "96000": { name: "Motion Analysis Video/3d", wrvu: 1.76 },
 "96001": { name: "Motion Test With Ft Pressure Meas", wrvu: 2.10 },
 "96002": { name: "Dynamic Surface Emg", wrvu: 0.40 },
 "96004": { name: "Phys Review Of Motion Tests", wrvu: 2.09 },
 "96020": { name: "Functional Brain Mapping", wrvu: 0.00 },
 "96041": { name: "Genetic Counseling Svc Each 30", wrvu: 0.00 },
 "96105": { name: "Assessment Of Aphasia", wrvu: 1.75 },
 "96110": { name: "Developmental Screening (e.g., ASQ, PEDS), with scoring", wrvu: 0.00 },
 "96112": { name: "Developmental Test Administration, First Hour", wrvu: 2.56 },
 "96113": { name: "Developmental Test Administration, Each Add'l 30 minutes", wrvu: 1.16 },
 "96116": { name: "Nubhvl Xm Physician/Qualified Health Professional Health Professional 1st Hr", wrvu: 1.86 },
 "96121": { name: "Nubhvl Xm Physician/Qualified Health Professional Health Professional Each Additional Hr", wrvu: 1.71 },
 "96125": { name: "Cognitive Test By Hc Pro", wrvu: 1.70 },
 "96127": { name: "Brief Emotional/Behavioral Assessment", wrvu: 0.00 },
 "96130": { name: "Psycl Tst Evaluation Physician/Qualified Health Professional Health Professional 1st", wrvu: 2.56 },
 "96131": { name: "Psycl Tst Evaluation Physician/Qualified Health Professional Health Professional Each", wrvu: 1.96 },
 "96132": { name: "Nrpsyc Tst Evaluation Physician/Qualified Health Professional Health Professional 1st", wrvu: 2.56 },
 "96133": { name: "Nrpsyc Tst Evaluation Physician/Qualified Health Professional Health Professional Each", wrvu: 1.96 },
 "96136": { name: "Psycl/nrpsyc Tst Physician/Qualified Health Professional Health Professional 1st", wrvu: 0.55 },
 "96137": { name: "Psycl/nrpsyc Tst Physician/Qualified Health Professional Health Professional Each", wrvu: 0.46 },
 "96138": { name: "Psycl/nrpsyc Tech 1st", wrvu: 0.00 },
 "96139": { name: "Psycl/nrpsyc Tst Tech Each", wrvu: 0.00 },
 "96146": { name: "Psycl/nrpsyc Tst Auto Result", wrvu: 0.00 },
 "96156": { name: "Hlth Behavioral Assmt/reassessment", wrvu: 2.40 },
 "96158": { name: "Hlth Behavioral Ivntj Indiv 1st 30", wrvu: 1.66 },
 "96159": { name: "Hlth Behavioral Ivntj Indiv Each Additional", wrvu: 0.57 },
 "96160": { name: "Health Risk Assessment Instrument Administration", wrvu: 0.00 },
 "96161": { name: "Caregiver Health Risk Assessment Administration", wrvu: 0.00 },
 "96164": { name: "Hlth Behavioral Ivntj Grp 1st 30", wrvu: 0.24 },
 "96165": { name: "Hlth Behavioral Ivntj Grp Each Additional", wrvu: 0.11 },
 "96167": { name: "Hlth Behavioral Ivntj Fam 1st 30", wrvu: 1.77 },
 "96168": { name: "Hlth Behavioral Ivntj Fam Each Additional", wrvu: 0.63 },
 "96170": { name: "Hlth Behavioral Ivntj Fam without Prothrombin Time 1st", wrvu: 1.50 },
 "96171": { name: "Hlth Behavioral Ivntj Fam Without Prothrombin Time Each", wrvu: 0.54 },
 "96202": { name: "Mlt Fam Grp Behavioral Train 1st 60", wrvu: 0.43 },
 "96203": { name: "Mlt Fam Grp Behavioral Train Each Add", wrvu: 0.12 },
 "96360": { name: "Hydration Intravenous Infusion Init", wrvu: 0.17 },
 "96361": { name: "Hydrate Intravenous Infusion Add-on", wrvu: 0.09 },
 "96365": { name: "Therapeutic/Prophylactic/Diagnostic Intravenous Inferior Init", wrvu: 0.21 },
 "96366": { name: "Therapeutic/Prophylactic/Diagnostic Intravenous Inferior Addon", wrvu: 0.18 },
 "96367": { name: "Treatment/Prophylactic/dg Additional Seq Intravenous Inferior", wrvu: 0.19 },
 "96368": { name: "Therapeutic/Diagnostic Concurrent Inferior", wrvu: 0.17 },
 "96369": { name: "Subcutaneous Therapeutic Infusion Up To 1 Hr", wrvu: 0.21 },
 "96370": { name: "Subcutaneous Therapeutic Infusion Additional Hr", wrvu: 0.18 },
 "96371": { name: "Subcutaneous Therapeutic Infusion Reset Pump", wrvu: 0.00 },
 "96372": { name: "Therapeutic/Prophylactic/Diagnostic Injection, Subcutaneous/Intramuscular", wrvu: 0.17 },
 "96373": { name: "Therapeutic/Prophylactic/Diagnostic Injection, Intra-arterial", wrvu: 0.17 },
 "96374": { name: "Therapeutic/Prophylactic/Diagnostic Injection, Intravenous Push, Single", wrvu: 0.18 },
 "96375": { name: "Therapeutic/Prophylactic/Diagnostic Injection, Intravenous Push, Each Additional", wrvu: 0.10 },
 "96376": { name: "Therapeutic/Prophylactic/Diagnostic Injection, Intravenous Push, Each Additional Sequence", wrvu: 0.00 },
 "96377": { name: "Applicaton On-body Injector", wrvu: 0.17 },
 "96379": { name: "Unl Therapeutic/prop/Diagnostic Injection/inferior", wrvu: 0.00 },
 "96380": { name: "Admn RSV Monoc Antb Intramuscular Cnsl", wrvu: 0.28 },
 "96381": { name: "Admn RSV Monoc Antb Intramuscular Injection", wrvu: 0.17 },
 "96401": { name: "Chemo Anti-neopl Subcutaneous/intramuscular", wrvu: 0.21 },
 "96402": { name: "Chemo Hormon Antineopl Subcutaneous/intramuscular", wrvu: 0.19 },
 "96405": { name: "Chemo Intralesional Up To 7", wrvu: 0.52 },
 "96406": { name: "Chemo Intralesional Over 7", wrvu: 0.80 },
 "96409": { name: "Chemo Intravenous Push Sngl Drug", wrvu: 0.24 },
 "96411": { name: "Chemo Intravenous Push Additional Drug", wrvu: 0.20 },
 "96413": { name: "Chemo Intravenous Infusion 1 Hr", wrvu: 0.28 },
 "96415": { name: "Chemo Intravenous Infusion Additional Hr", wrvu: 0.19 },
 "96416": { name: "Chemo Prolong Infuse With Pump", wrvu: 0.21 },
 "96417": { name: "Chemo Intravenous Infusion Each Additional Seq", wrvu: 0.21 },
 "96420": { name: "Chemo Ia Push Tecnique", wrvu: 0.17 },
 "96422": { name: "Chemo Ia Infusion Up To 1 Hr", wrvu: 0.17 },
 "96423": { name: "Chemo Ia Infuse Each Additional Hr", wrvu: 0.17 },
 "96425": { name: "Chemotherapy Infusion Method", wrvu: 0.17 },
 "96440": { name: "Chmotx Admn Pleural Cav Thrcnts", wrvu: 2.12 },
 "96446": { name: "Chemotx Admn Pertl Cav Impl", wrvu: 0.37 },
 "96450": { name: "Chemotherapy Into Cns", wrvu: 1.53 },
 "96521": { name: "Refill/maint Portable Pump", wrvu: 0.21 },
 "96522": { name: "Refill/maint Pump/resvr Syst", wrvu: 0.21 },
 "96523": { name: "Irrig Drug Delivery Device", wrvu: 0.04 },
 "96542": { name: "Chemotherapy Injection", wrvu: 0.75 },
 "96547": { name: "Intraop Hipec Procedure 1st 60 Minutes", wrvu: 6.53 },
 "96548": { name: "Ntraop Hipec Procedure Each Add 30min", wrvu: 3.00 },
 "96549": { name: "Unlisted Chemotherapy Procedure", wrvu: 0.00 },
 "96567": { name: "Pdt Dstr Prmlg Lesion Skin", wrvu: 0.00 },
 "96570": { name: "Photodynmc Treatment 30 minutes Add-on", wrvu: 1.10 },
 "96571": { name: "Photodynamic Treatment Additional 15 Minutes", wrvu: 0.55 },
 "96573": { name: "Pdt Dstr Prmlg Lesion Physician/Qualified Health Professional Health Professional", wrvu: 0.47 },
 "96574": { name: "Dbrdmt Prmlg Lesion With Pdt", wrvu: 0.98 },
 "96900": { name: "Actinotherapy Uv Light", wrvu: 0.00 },
 "96902": { name: "Microscopy Xm Hair Pluck/clipped", wrvu: 0.40 },
 "96904": { name: "Whole Body Photography", wrvu: 0.00 },
 "96910": { name: "Photchmtx Tar and uvb/ptrltm and uvb", wrvu: 0.00 },
 "96912": { name: "Photochemotherapy Puva", wrvu: 0.00 },
 "96913": { name: "Photochemotx Sev Dermatoses", wrvu: 0.00 },
 "96920": { name: "Excimer Lsr Psriasis<250sqcm", wrvu: 0.81 },
 "96921": { name: "Excimer Lsr Psriasis 250-500", wrvu: 0.88 },
 "96922": { name: "Excimer Lsr Psriasis>500sqcm", wrvu: 1.12 },
 "96931": { name: "Rcm Imaging Acquisj and i and r 1st Lesion", wrvu: 0.78 },
 "96932": { name: "Rcm Imaging Acquisj Only 1st Lesion", wrvu: 0.00 },
 "96933": { name: "Rcm I and r Only 1st Lesion", wrvu: 0.78 },
 "96934": { name: "Rcm Imaging Acquisj and i and r Each Additional", wrvu: 0.74 },
 "96935": { name: "Rcm Imaging Acquisj Only Each Additional", wrvu: 0.00 },
 "96936": { name: "Rcm I and r Only Each Additional Lesion", wrvu: 0.74 },
 "96999": { name: "Unlisted Specimen Derm Svc/Procedure", wrvu: 0.00 },
 "97007": { name: "Mchnl Scalp Cool Meas Fitg", wrvu: 0.00 },
 "97008": { name: "Mchnl Scalp Cool Prep Placement", wrvu: 0.00 },
 "97009": { name: "Mchnl Scalp Cool After Chemo", wrvu: 0.00 },
 "97010": { name: "Hot Or Cold Packs Therapy", wrvu: 0.06 },
 "97012": { name: "Mechanical Traction Therapy", wrvu: 0.24 },
 "97014": { name: "Electric Stimulation Therapy", wrvu: 0.18 },
 "97016": { name: "Vasopneumatic Device Therapy", wrvu: 0.18 },
 "97018": { name: "Paraffin Bath Therapy", wrvu: 0.06 },
 "97022": { name: "Whirlpool Therapy", wrvu: 0.17 },
 "97024": { name: "Diathermy Eg Microwave", wrvu: 0.06 },
 "97026": { name: "Infrared Therapy", wrvu: 0.06 },
 "97028": { name: "Ultraviolet Therapy", wrvu: 0.08 },
 "97032": { name: "Application Modality 1+estim Each 15", wrvu: 0.25 },
 "97033": { name: "Application Mdlty 1+iontphrsis Each 15", wrvu: 0.26 },
 "97034": { name: "Application Mdlty 1+Contrast Bth Each 15", wrvu: 0.21 },
 "97035": { name: "Application Mdlty 1+ultrasound Each 15", wrvu: 0.21 },
 "97036": { name: "Application Mdlty 1+hubbrd Tnk Each 15", wrvu: 0.28 },
 "97037": { name: "Application Modality 1+lllt Po Pain", wrvu: 0.00 },
 "97039": { name: "Unlisted Modality", wrvu: 0.00 },
 "97110": { name: "Therapeutic Exercises, Each 15 minutes", wrvu: 0.45 },
 "97112": { name: "Neuromuscular Reeducation, Each 15 minutes", wrvu: 0.50 },
 "97113": { name: "Aquatic Therapy/exercises", wrvu: 0.48 },
 "97116": { name: "Gait Training, Each 15 minutes", wrvu: 0.45 },
 "97124": { name: "Massage Therapy", wrvu: 0.35 },
 "97129": { name: "Therapeutic Ivntj 1st 15 Minutes", wrvu: 0.50 },
 "97130": { name: "Therapeutic Ivntj Each Additional 15 Minutes", wrvu: 0.48 },
 "97139": { name: "Unlisted Therapeutic Procedure", wrvu: 0.00 },
 "97140": { name: "Manual Therapy Techniques, Each 15 minutes", wrvu: 0.43 },
 "97150": { name: "Group Therapeutic Procedures", wrvu: 0.29 },
 "97151": { name: "Behavioral Id Assmt By Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "97152": { name: "Behavioral Id Suprt Assmt By 1 Tech", wrvu: 0.00 },
 "97153": { name: "Adaptive Behavior Treatment By Tech", wrvu: 0.00 },
 "97154": { name: "Grp Adapt Behavioral Treatment By Tech", wrvu: 0.00 },
 "97155": { name: "Adapt Behavior Treatment Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "97156": { name: "Fam Adapt Behavioral Treatment Guidance Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "97157": { name: "Mult Fam Adapt Behavioral Treatment Guidance", wrvu: 0.00 },
 "97158": { name: "Grp Adapt Behavioral Treatment By Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "97161": { name: "Prothrombin Time Evaluation Low Complex 20 Minutes", wrvu: 1.54 },
 "97162": { name: "Prothrombin Time Evaluation Moderate Complex 30 Minutes", wrvu: 1.54 },
 "97163": { name: "Prothrombin Time Evaluation High Complex 45 Minutes", wrvu: 1.54 },
 "97164": { name: "Prothrombin Time Re-Evaluation Established Plan Care", wrvu: 0.96 },
 "97165": { name: "Occupational Therapy Evaluation Low Complex 30 Minutes", wrvu: 1.54 },
 "97166": { name: "Occupational Therapy Evaluation Moderate Complex 45 Minutes", wrvu: 1.54 },
 "97167": { name: "Occupational Therapy Evaluation High Complex 60 Minutes", wrvu: 1.54 },
 "97168": { name: "Occupational Therapy Re-Evaluation Established Plan Care", wrvu: 0.96 },
 "97169": { name: "Athletic Trn Evaluation Low Complex", wrvu: 0.00 },
 "97170": { name: "Athletic Trn Evaluation Moderate Complex", wrvu: 0.00 },
 "97171": { name: "Athletic Trn Evaluation High Complex", wrvu: 0.00 },
 "97172": { name: "Athletic Trn Re-Evaluation Plan Cr", wrvu: 0.00 },
 "97530": { name: "Therapeutic Activities, Each 15 minutes", wrvu: 0.44 },
 "97533": { name: "Sensory Integration", wrvu: 0.48 },
 "97535": { name: "Self-Care/Home Management Training, Each 15 minutes", wrvu: 0.45 },
 "97537": { name: "Community/work Reintegration", wrvu: 0.48 },
 "97542": { name: "Wheelchair Mngment Training", wrvu: 0.48 },
 "97545": { name: "Work Hardening", wrvu: 0.00 },
 "97546": { name: "Work Hardening Add-on", wrvu: 0.00 },
 "97550": { name: "Caregiver Traing 1st 30 Minutes", wrvu: 1.00 },
 "97551": { name: "Caregiver Traing Each Additional 15", wrvu: 0.54 },
 "97552": { name: "Group Caregiver Training", wrvu: 0.23 },
 "97597": { name: "Dbrdmt Open Wound 1st 20 Cm/<", wrvu: 0.75 },
 "97598": { name: "Dbrdmt Open Wound Additional 20cm/<", wrvu: 0.49 },
 "97602": { name: "Wound(s) Care Non-selective", wrvu: 0.00 },
 "97605": { name: "Neg Prs Wound Therapeutic Dme<=50sqcm", wrvu: 0.54 },
 "97606": { name: "Neg Prs Wound Therapeutic Dme>50 Sqcm", wrvu: 0.59 },
 "97607": { name: "Neg Prs Wound Thr Ndme<=50sqcm", wrvu: 0.40 },
 "97608": { name: "Neg Prs Wound Therapeutic Ndme>50sqcm", wrvu: 0.45 },
 "97610": { name: "Low Frequency Non-thermal Ultrasound", wrvu: 0.39 },
 "97750": { name: "Physical Performance Test", wrvu: 0.45 },
 "97755": { name: "Assistive Technology Assess", wrvu: 0.62 },
 "97760": { name: "Orthotic Management and traing 1st Enc", wrvu: 0.50 },
 "97761": { name: "Prosthetic Traing 1st Enc", wrvu: 0.50 },
 "97763": { name: "Orthc/prostc Management Subsequent Enc", wrvu: 0.48 },
 "97799": { name: "Unlisted Physcl Medial/Rehabilitation Procedure", wrvu: 0.00 },
 "97802": { name: "Medical Nutrition Therapy, Initial, Individual, 15 minutes", wrvu: 0.53 },
 "97803": { name: "Medical Nutrition Therapy, Re-assessment, Individual, 15 minutes", wrvu: 0.45 },
 "97804": { name: "Medical Nutrition Therapy, Group (2+ patients), 30 minutes", wrvu: 0.25 },
 "97810": { name: "Acup 1/> without Estim 1st 15 Minutes", wrvu: 0.61 },
 "97811": { name: "Acup 1/> Without Estim Each Add 15", wrvu: 0.46 },
 "97813": { name: "Acup 1/> With Estim 1st 15 Minutes", wrvu: 0.74 },
 "97814": { name: "Acup 1/> With Estim Each Additional 15", wrvu: 0.47 },
 "98000": { name: "Synch Audio-video New Sf 15", wrvu: 0.93 },
 "98001": { name: "Synch Audio-video New Low 30", wrvu: 1.60 },
 "98002": { name: "Synch Audio-video New Moderate 45", wrvu: 2.60 },
 "98003": { name: "Synch Audio-video New High 60", wrvu: 3.50 },
 "98004": { name: "Synch Audio-video Established Sf 10", wrvu: 0.70 },
 "98005": { name: "Synch Audio-video Established Low 20", wrvu: 1.30 },
 "98006": { name: "Synch Audio-video Established Moderate 30", wrvu: 1.92 },
 "98007": { name: "Synch Audio-video Established High 40", wrvu: 2.60 },
 "98008": { name: "Synch Audio-only New Sf 15", wrvu: 0.90 },
 "98009": { name: "Synch Audio-only New Low 30", wrvu: 1.55 },
 "98010": { name: "Synch Audio-only New Moderate 45", wrvu: 2.42 },
 "98011": { name: "Synch Audio-only New High 60", wrvu: 3.20 },
 "98012": { name: "Synch Audio-only Established Sf 10", wrvu: 0.65 },
 "98013": { name: "Synch Audio-only Established Low 20", wrvu: 1.20 },
 "98014": { name: "Synch Audio-only Established Moderate 30", wrvu: 1.75 },
 "98015": { name: "Synch Audio-only Established High 40", wrvu: 2.60 },
 "98016": { name: "Brief Comunicaj Tech-bsd Svc", wrvu: 0.30 },
 "98925": { name: "Osteopath Manj 1-2 Regions", wrvu: 0.45 },
 "98926": { name: "Osteopath Manj 3-4 Regions", wrvu: 0.69 },
 "98927": { name: "Osteopath Manj 5-6 Regions", wrvu: 0.94 },
 "98928": { name: "Osteopath Manj 7-8 Regions", wrvu: 1.18 },
 "98929": { name: "Osteopath Manj 9-10 Regions", wrvu: 1.42 },
 "98940": { name: "Chiropract Manj 1-2 Regions", wrvu: 0.45 },
 "98941": { name: "Chiropract Manj 3-4 Regions", wrvu: 0.69 },
 "98942": { name: "Chiropractic Manj 5 Regions", wrvu: 0.94 },
 "98943": { name: "Chiropract Manj Xtrspinl 1/>", wrvu: 0.45 },
 "98960": { name: "Edu and trn Prothrombin Time Self-Management Nqhp 1", wrvu: 0.00 },
 "98961": { name: "Edu and trn Prothrombin Time Slf-Management Nqhp 2-4", wrvu: 0.00 },
 "98962": { name: "Edu and trn Prothrombin Time Slf-Management Nqhp 5-8", wrvu: 0.00 },
 "98966": { name: "Phone Assmt and Management Nqhp 5-10", wrvu: 0.25 },
 "98967": { name: "Phone Assmt and Management Nqhp 11-20", wrvu: 0.50 },
 "98968": { name: "Phone Assmt and Management Nqhp 21-30", wrvu: 0.75 },
 "98970": { name: "Nqhp Ol Dig Assmt and Management 5-10", wrvu: 0.25 },
 "98971": { name: "Nqhp Ol Dig Assmt and Management 11-20", wrvu: 0.44 },
 "98972": { name: "Nqhp Ol Dig Assmt and Management 21+", wrvu: 0.69 },
 "98975": { name: "Rtm 1st Set-up and Prothrombin Time Educaj Eqp", wrvu: 0.00 },
 "98976": { name: "Rtm Device Sply Resp System 16-30d", wrvu: 0.00 },
 "98977": { name: "Rtm Device Sply Mscskl 16-30 D", wrvu: 0.00 },
 "98978": { name: "Rtm Device Sply CBT 16-30 D", wrvu: 0.00 },
 "98979": { name: "Rtm Treatment Management 1st 10 Minutes", wrvu: 0.31 },
 "98980": { name: "Rtm Treatment Management 1st 20 Minutes", wrvu: 0.62 },
 "98981": { name: "Rtm Treatment Management Each Additional 20 Minutes", wrvu: 0.61 },
 "98984": { name: "Rtm Device Sply Resp System 2-15 D", wrvu: 0.00 },
 "98985": { name: "Rtm Device Sply Mscsk System 2-15d", wrvu: 0.00 },
 "98986": { name: "Rtm Device Sply CBT 2-15 D", wrvu: 0.00 },
 "99000": { name: "Specimen Handling, Transfer to Laboratory", wrvu: 0.00 },
 "99001": { name: "Specimen Handling, Transfer from Off-Site", wrvu: 0.00 },
 "99002": { name: "Device Handling Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "99024": { name: "Postop Follow-up Visit", wrvu: 0.00 },
 "99026": { name: "In-hospital On Call Service", wrvu: 0.00 },
 "99027": { name: "Out-of-Hospital On Call Service", wrvu: 0.00 },
 "99050": { name: "Services Provided Outside Regular Office Hours", wrvu: 0.00 },
 "99051": { name: "Services Provided During Regular Evening/Weekend Hours", wrvu: 0.00 },
 "99053": { name: "Services Provided Between 10pm-8am", wrvu: 0.00 },
 "99056": { name: "Services Provided at Request in Location Other than Office", wrvu: 0.00 },
 "99058": { name: "Services Provided on Emergency Basis (interrupts other services)", wrvu: 0.00 },
 "99060": { name: "Services Provided to Patient Out of Office Using Sync Telemedicine", wrvu: 0.00 },
 "99070": { name: "Special Supplies Physician/Qualified Health Professional Health Professional", wrvu: 0.00 },
 "99071": { name: "Patient Education Materials", wrvu: 0.00 },
 "99072": { name: "Additional Supl Matrl and staf Tm Phe", wrvu: 0.00 },
 "99075": { name: "Medical Testimony", wrvu: 0.00 },
 "99078": { name: "Group Health Education", wrvu: 0.00 },
 "99080": { name: "Special Reports Or Forms", wrvu: 0.00 },
 "99082": { name: "Unusual Physician Travel", wrvu: 0.00 },
 "99091": { name: "Collj & Interpj Data Each 30 D", wrvu: 1.10 },
 "99100": { name: "Anesthesia Prothrombin Time Exteme Age<1 Year&>70", wrvu: 0.00 },
 "99116": { name: "Anesthesia Comp Tot Bdy Hypthrm", wrvu: 0.00 },
 "99135": { name: "Anesthesia Comp Ctrld Hypotension", wrvu: 0.00 },
 "99140": { name: "Anesthesia Comp Emergency Cond", wrvu: 0.00 },
 "99151": { name: "Moderate Sed Same Physician/Qualified Health Professional Health Professional <5 Years", wrvu: 0.50 },
 "99152": { name: "Moderate Sed Same Physician/Qualified Health Professional Health Professional 5/>years", wrvu: 0.25 },
 "99153": { name: "Moderate Sed Same Physician/Qualified Health Professional Health Professional Each", wrvu: 0.00 },
 "99155": { name: "Moderate Sed Oth Physician/Qualified Health Professional Health Professional <5 Years", wrvu: 1.90 },
 "99156": { name: "Moderate Sed Oth Physician/Qualified Health Professional Health Professional 5/>years", wrvu: 1.65 },
 "99157": { name: "Moderate Sed Other Physician/Qualified Health Professional Health Professional Each", wrvu: 1.25 },
 "99170": { name: "Anogenital Exam Child W Imag", wrvu: 1.71 },
 "99172": { name: "Ocular Function Screen", wrvu: 0.00 },
 "99173": { name: "Visual Acuity Screen", wrvu: 0.00 },
 "99174": { name: "Ocular Instrumnt Screen Bil", wrvu: 0.00 },
 "99175": { name: "Induction Of Vomiting", wrvu: 0.00 },
 "99177": { name: "Ocular Instrumnt Screen Bil", wrvu: 0.00 },
 "99183": { name: "Hyperbaric Oxygen Therapy", wrvu: 2.06 },
 "99184": { name: "Hypothermia Ill Neonate", wrvu: 4.39 },
 "99188": { name: "Application Topical Fluoride Varnish", wrvu: 0.20 },
 "99190": { name: "Special Pump Services", wrvu: 0.00 },
 "99191": { name: "Special Pump Services", wrvu: 0.00 },
 "99192": { name: "Special Pump Services", wrvu: 0.00 },
 "99195": { name: "Phlebotomy", wrvu: 0.00 },
 "99199": { name: "Unlisted Special Svc Procedure/Report", wrvu: 0.00 },
 "99202": { name: "Office Visit, New, Level 2 (Straightforward Medical Decision Making, 15-29 minutes)", wrvu: 0.93 },
 "99203": { name: "Office Visit, New, Level 3 (Low Medical Decision Making, 30-44 minutes)", wrvu: 1.60 },
 "99204": { name: "Office Visit, New, Level 4 (Moderate Medical Decision Making, 45-59 minutes)", wrvu: 2.60 },
 "99205": { name: "Office Visit, New, Level 5 (High Medical Decision Making, 60-74 minutes)", wrvu: 3.50 },
 "99211": { name: "Office Visit, Established, Level 1 (May not require physician presence)", wrvu: 0.18 },
 "99212": { name: "Office Visit, Established, Level 2 (Straightforward Medical Decision Making, 10-19 minutes)", wrvu: 0.70 },
 "99213": { name: "Office Visit, Established, Level 3 (Low Medical Decision Making, 20-29 minutes)", wrvu: 1.30 },
 "99214": { name: "Office Visit, Established, Level 4 (Moderate Medical Decision Making, 30-39 minutes)", wrvu: 1.92 },
 "99215": { name: "Office Visit, Established, Level 5 (High Medical Decision Making, 40-54 minutes)", wrvu: 2.80 },
 "99221": { name: "Initial Hospital Care, Level 1 (Straightforward/Low Medical Decision Making, 40 minutes)", wrvu: 1.63 },
 "99222": { name: "Initial Hospital Care, Level 2 (Moderate Medical Decision Making, 55 minutes)", wrvu: 2.60 },
 "99223": { name: "Initial Hospital Care, Level 3 (High Medical Decision Making, 75 minutes)", wrvu: 3.50 },
 "99231": { name: "Subsequent Hospital Care, Level 1 (Straightforward/Low Medical Decision Making, 25 minutes)", wrvu: 1.00 },
 "99232": { name: "Subsequent Hospital Care, Level 2 (Moderate Medical Decision Making, 35 minutes)", wrvu: 1.59 },
 "99233": { name: "Subsequent Hospital Care, Level 3 (High Medical Decision Making, 50 minutes)", wrvu: 2.40 },
 "99234": { name: "Observation/Inpatient Same Day Admit & Discharge (Straightforward/Low Medical Decision Making, 45 minutes)", wrvu: 2.00 },
 "99235": { name: "Observation/Inpatient Same Day Admit & Discharge (Moderate Medical Decision Making, 70 minutes)", wrvu: 3.24 },
 "99236": { name: "Observation/Inpatient Same Day Admit & Discharge (High Medical Decision Making, 85 minutes)", wrvu: 4.30 },
 "99238": { name: "Hospital Discharge Day Management, 30 minutes or less", wrvu: 1.50 },
 "99239": { name: "Hospital Discharge Day Management, more than 30 minutes", wrvu: 2.15 },
 "99242": { name: "Office Consultation, Level 2 (Straightforward Medical Decision Making, 20 minutes)", wrvu: 1.08 },
 "99243": { name: "Office Consultation, Level 3 (Low Medical Decision Making, 30 minutes)", wrvu: 1.80 },
 "99244": { name: "Office Consultation, Level 4 (Moderate Medical Decision Making, 40 minutes)", wrvu: 2.69 },
 "99245": { name: "Office Consultation, Level 5 (High Medical Decision Making, 55 minutes)", wrvu: 3.75 },
 "99252": { name: "Inpatient Consultation, Level 2 (Straightforward Medical Decision Making, 35 minutes)", wrvu: 1.50 },
 "99253": { name: "Inpatient Consultation, Level 3 (Low Medical Decision Making, 45 minutes)", wrvu: 2.00 },
 "99254": { name: "Inpatient Consultation, Level 4 (Moderate Medical Decision Making, 60 minutes)", wrvu: 2.72 },
 "99255": { name: "Inpatient Consultation, Level 5 (High Medical Decision Making, 80 minutes)", wrvu: 3.86 },
 "99281": { name: "Emergency Department Visit, Level 1 (Self-limited/minor problem)", wrvu: 0.25 },
 "99282": { name: "Emergency Department Visit, Level 2 (Low to moderate severity)", wrvu: 0.93 },
 "99283": { name: "Emergency Department Visit, Level 3 (Moderate severity)", wrvu: 1.60 },
 "99284": { name: "Emergency Department Visit, Level 4 (High severity, urgent evaluation)", wrvu: 2.74 },
 "99285": { name: "Emergency Department Visit, Level 5 (High severity, immediate threat to life/function)", wrvu: 4.00 },
 "99288": { name: "Direct Advanced Life Support", wrvu: 0.00 },
 "99291": { name: "Critical Care, First 30-74 minutes", wrvu: 4.50 },
 "99292": { name: "Critical Care, Each Additional 30 minutes", wrvu: 2.25 },
 "99304": { name: "Nursing Facility Initial, Level 1 (Straightforward/Low Medical Decision Making, 25 minutes)", wrvu: 1.50 },
 "99305": { name: "Nursing Facility Initial, Level 2 (Moderate Medical Decision Making, 35 minutes)", wrvu: 2.50 },
 "99306": { name: "Nursing Facility Initial, Level 3 (High Medical Decision Making, 45 minutes)", wrvu: 3.50 },
 "99307": { name: "Nursing Facility Subsequent, Level 1 (Straightforward Medical Decision Making, 10 minutes)", wrvu: 0.70 },
 "99308": { name: "Nursing Facility Subsequent, Level 2 (Low Medical Decision Making, 15 minutes)", wrvu: 1.30 },
 "99309": { name: "Nursing Facility Subsequent, Level 3 (Moderate Medical Decision Making, 30 minutes)", wrvu: 1.92 },
 "99310": { name: "Nursing Facility Subsequent, Level 4 (High Medical Decision Making, 45 minutes)", wrvu: 2.80 },
 "99315": { name: "Nf Discharge Management 30 Minutes/less", wrvu: 1.50 },
 "99316": { name: "Nf Discharge Management 30 Minutes+", wrvu: 2.50 },
 "99339": { name: "Care Plan Oversight, Domiciliary/Rest Home, 15-29 minutes/month", wrvu: 0.96 },
 "99340": { name: "Care Plan Oversight, Domiciliary/Rest Home, 30+ minutes/month", wrvu: 1.35 },
 "99341": { name: "Home Visit, New, Level 1 (Straightforward Medical Decision Making, 15 minutes)", wrvu: 1.00 },
 "99342": { name: "Home Visit, New, Level 2 (Low Medical Decision Making, 30 minutes)", wrvu: 1.65 },
 "99343": { name: "Home Visit, New, Level 3 (Moderate Medical Decision Making, 45 minutes)", wrvu: 2.35 },
 "99344": { name: "Home Visit, New, Level 4 (Moderate-High Medical Decision Making, 60 minutes)", wrvu: 2.87 },
 "99345": { name: "Home Visit, New, Level 5 (High Medical Decision Making, 75 minutes)", wrvu: 3.88 },
 "99347": { name: "Home Visit, Established, Level 1 (Straightforward Medical Decision Making, 15 minutes)", wrvu: 0.90 },
 "99348": { name: "Home Visit, Established, Level 2 (Low Medical Decision Making, 25 minutes)", wrvu: 1.50 },
 "99349": { name: "Home Visit, Established, Level 3 (Moderate Medical Decision Making, 40 minutes)", wrvu: 2.44 },
 "99350": { name: "Home Visit, Established, Level 4 (High Medical Decision Making, 60 minutes)", wrvu: 3.60 },
 "99354": { name: "Prolonged Service, Office/Outpatient, First Hour (with direct contact)", wrvu: 1.77 },
 "99355": { name: "Prolonged Service, Office/Outpatient, Each Add'l 30 minutes", wrvu: 1.77 },
 "99356": { name: "Prolonged Service, Inpatient/Observation, First Hour", wrvu: 1.71 },
 "99357": { name: "Prolonged Service, Inpatient/Observation, Each Add'l 30 minutes", wrvu: 1.71 },
 "99358": { name: "Prolong Service Without Contact", wrvu: 1.80 },
 "99359": { name: "Prolong Serv Without Contact Add", wrvu: 0.75 },
 "99360": { name: "Physician Standby Services", wrvu: 1.20 },
 "99366": { name: "Team Conf With Pat By Hc Prof", wrvu: 0.82 },
 "99367": { name: "Team Conf Without Pat By Phys", wrvu: 1.10 },
 "99368": { name: "Team Conf Without Pat By Hc Pro", wrvu: 0.72 },
 "99374": { name: "Home Health Care Supervision", wrvu: 1.10 },
 "99375": { name: "Home Health Care Supervision", wrvu: 1.73 },
 "99377": { name: "Hospice Care Supervision", wrvu: 1.10 },
 "99378": { name: "Hospice Care Supervision", wrvu: 1.73 },
 "99379": { name: "Nursing Fac Care Supervision", wrvu: 1.10 },
 "99380": { name: "Nursing Fac Care Supervision", wrvu: 1.73 },
 "99381": { name: "Preventive Visit, New, Infant (< 1 year)", wrvu: 1.50 },
 "99382": { name: "Preventive Visit, New, Early Childhood (1-4 years)", wrvu: 1.60 },
 "99383": { name: "Preventive Visit, New, Late Childhood (5-11 years)", wrvu: 1.70 },
 "99384": { name: "Preventive Visit, New, Adolescent (12-17 years)", wrvu: 2.00 },
 "99385": { name: "Preventive Visit, New, Adult (18-39 years)", wrvu: 1.92 },
 "99386": { name: "Preventive Visit, New, Adult (40-64 years)", wrvu: 2.33 },
 "99387": { name: "Preventive Visit, New, Adult (65+ years)", wrvu: 2.50 },
 "99391": { name: "Preventive Visit, Established, Infant (< 1 year)", wrvu: 1.37 },
 "99392": { name: "Preventive Visit, Established, Early Childhood (1-4 years)", wrvu: 1.50 },
 "99393": { name: "Preventive Visit, Established, Late Childhood (5-11 years)", wrvu: 1.50 },
 "99394": { name: "Preventive Visit, Established, Adolescent (12-17 years)", wrvu: 1.70 },
 "99395": { name: "Preventive Visit, Established, Adult (18-39 years)", wrvu: 1.75 },
 "99396": { name: "Preventive Visit, Established, Adult (40-64 years)", wrvu: 1.90 },
 "99397": { name: "Preventive Visit, Established, Adult (65+ years)", wrvu: 2.00 },
 "99401": { name: "Prev Medial Cnsl Indiv Apprx 15", wrvu: 0.48 },
 "99402": { name: "Prev Medial Cnsl Indiv Apprx 30", wrvu: 0.98 },
 "99403": { name: "Prev Medial Cnsl Indiv Apprx 45", wrvu: 1.46 },
 "99404": { name: "Prev Medial Cnsl Indiv Apprx 60", wrvu: 1.95 },
 "99406": { name: "Smoking/Tobacco Cessation Counseling, 3-10 minutes", wrvu: 0.24 },
 "99407": { name: "Smoking/Tobacco Cessation Counseling, >10 minutes", wrvu: 0.50 },
 "99408": { name: "Alcohol/Substance Abuse Screening & Intervention, 15-30 minutes", wrvu: 0.65 },
 "99409": { name: "Alcohol/Substance Abuse Screening & Intervention, >30 minutes", wrvu: 1.30 },
 "99411": { name: "Preventive Counseling Group", wrvu: 0.15 },
 "99412": { name: "Preventive Counseling Group", wrvu: 0.25 },
 "99415": { name: "Prolng Clin Staff Svc 1st Hr", wrvu: 0.00 },
 "99416": { name: "Prolng Clin Staff Svc Each Add", wrvu: 0.00 },
 "99417": { name: "Prolonged Office/Outpatient E and M, Each 15 minutes beyond threshold", wrvu: 0.61 },
 "99418": { name: "Prolonged Inpatient/Observation E and M, Each 15 minutes beyond threshold", wrvu: 0.81 },
 "99421": { name: "Ol Dig E and M Svc 5-10 Minutes", wrvu: 0.25 },
 "99422": { name: "Ol Dig E and M Svc 11-20 Minutes", wrvu: 0.50 },
 "99423": { name: "Ol Dig E and M Svc 21+ Minutes", wrvu: 0.80 },
 "99424": { name: "Principal Care Management, First 30 minutes/month", wrvu: 1.45 },
 "99425": { name: "Principal Care Management, Each Add'l 30 minutes/month", wrvu: 1.00 },
 "99426": { name: "Principal Care Management (Clinical Staff), First 30 minutes/month", wrvu: 1.00 },
 "99427": { name: "Principal Care Management (Clinical Staff), Each Add'l 30 minutes", wrvu: 0.71 },
 "99429": { name: "Unlisted Preventive Service", wrvu: 0.00 },
 "99437": { name: "Chronic Care Management, Each Add'l 30 minutes/month (clinical staff)", wrvu: 1.00 },
 "99439": { name: "Chronic Care Management, Each Add'l 20 minutes/month (clinical staff)", wrvu: 0.70 },
 "99441": { name: "Telephone E and M, 5-10 minutes (Medical discussion)", wrvu: 0.25 },
 "99442": { name: "Telephone E and M, 11-20 minutes (Medical discussion)", wrvu: 0.50 },
 "99443": { name: "Telephone E and M, 21-30 minutes (Medical discussion)", wrvu: 0.75 },
 "99445": { name: "Rem Mntr Physiol Param 2-15", wrvu: 0.00 },
 "99446": { name: "Interprofessional Phone/Internet/EHR 5-10", wrvu: 0.35 },
 "99447": { name: "Interprofessional Phone/Internet/EHR 11-20", wrvu: 0.70 },
 "99448": { name: "Interprofessional Phone/Internet/EHR 21-30", wrvu: 1.05 },
 "99449": { name: "Interprofessional Phone/Internet/EHR 31/>", wrvu: 1.40 },
 "99450": { name: "Basic Life Disability Exam", wrvu: 0.00 },
 "99451": { name: "Interprofessional Phone/Internet/EHR 5/>", wrvu: 0.70 },
 "99452": { name: "Interprofessional Phone/Internet/EHR Rfrl", wrvu: 0.70 },
 "99453": { name: "Remote Patient Monitoring, Initial Setup & Education", wrvu: 0.00 },
 "99454": { name: "Remote Patient Monitoring, Device Supply (30 days)", wrvu: 0.00 },
 "99455": { name: "Work Related Disability Exam", wrvu: 0.00 },
 "99456": { name: "Disability Examination", wrvu: 0.00 },
 "99457": { name: "Remote Physiologic Monitoring Treatment, First 20 minutes/month", wrvu: 0.61 },
 "99458": { name: "Remote Physiologic Monitoring Treatment, Each Add'l 20 minutes", wrvu: 0.61 },
 "99459": { name: "Pelvic Examination", wrvu: 0.00 },
 "99460": { name: "Init Nb Em Per Day Hospital", wrvu: 1.92 },
 "99461": { name: "Init Nb Em Per Day Non-fac", wrvu: 1.26 },
 "99462": { name: "Subsequent Nb Em Per Day Hospital", wrvu: 0.84 },
 "99463": { name: "Same Day Nb Discharge", wrvu: 2.13 },
 "99464": { name: "Attendance At Delivery", wrvu: 1.50 },
 "99465": { name: "Nb Resuscitation", wrvu: 2.93 },
 "99466": { name: "Ped Critical Care Transport", wrvu: 4.79 },
 "99467": { name: "Ped Critical Care Transport Additional", wrvu: 2.40 },
 "99468": { name: "Neonate Critical Care Initial", wrvu: 18.46 },
 "99469": { name: "Neonate Critical Care Subsq", wrvu: 7.99 },
 "99470": { name: "Remote Patient Monitoring Treatment Management 1st 10 Minutes", wrvu: 0.31 },
 "99471": { name: "Ped Critical Care Initial", wrvu: 15.98 },
 "99472": { name: "Ped Critical Care Subsq", wrvu: 7.99 },
 "99473": { name: "Self-meas Bp Prothrombin Time Educaj/train", wrvu: 0.00 },
 "99474": { name: "Self-meas Bp 2 Readg Bid 30d", wrvu: 0.18 },
 "99475": { name: "Ped Critical Care Age 2-5 Init", wrvu: 11.25 },
 "99476": { name: "Ped Critical Care Age 2-5 Subsq", wrvu: 6.75 },
 "99477": { name: "Init Day Hospital Neonate Care", wrvu: 7.00 },
 "99478": { name: "Subsequent Ic Vlbw Inferior<1,500 Gm", wrvu: 2.75 },
 "99479": { name: "Subsequent Ic Lbw Inferior 1,500-2,500", wrvu: 2.50 },
 "99480": { name: "Subsequent Ic Inferior Pbw 2,501-5,000", wrvu: 2.40 },
 "99483": { name: "Cognitive Assessment & Care Planning, 50+ minutes", wrvu: 3.84 },
 "99484": { name: "Care Management for Behavioral Health, 20+ minutes/month", wrvu: 0.93 },
 "99485": { name: "Suprv Interfacilty Transport", wrvu: 1.50 },
 "99486": { name: "Suprv Interfac Trnsport Additional", wrvu: 1.30 },
 "99487": { name: "Complex Chronic Care Management, First 60 minutes/month", wrvu: 1.81 },
 "99489": { name: "Complex Chronic Care Management, Each Add'l 30 minutes/month", wrvu: 1.00 },
 "99490": { name: "Chronic Care Management, First 20 minutes/month (clinical staff)", wrvu: 1.00 },
 "99491": { name: "Chronic Care Management, First 30 minutes/month (physician/Qualified Health Professional)", wrvu: 1.50 },
 "99492": { name: "Psychiatric Collaborative Care, Initial Month (70 minutes)", wrvu: 1.88 },
 "99493": { name: "Psychiatric Collaborative Care, Subsequent Month (60 minutes)", wrvu: 2.05 },
 "99494": { name: "Psychiatric Collaborative Care, Add'l 30 minutes/month", wrvu: 0.82 },
 "99495": { name: "Transitional Care Management, Moderate Complexity (face-to-face within 14 days)", wrvu: 2.78 },
 "99496": { name: "Transitional Care Management, High Complexity (face-to-face within 7 days)", wrvu: 3.79 },
 "99497": { name: "Advance Care Planning, First 30 minutes (face-to-face)", wrvu: 1.50 },
 "99498": { name: "Advance Care Planning, Each Add'l 30 minutes", wrvu: 1.40 },
 "99499": { name: "Unlisted E and m Service", wrvu: 0.00 },
 "99500": { name: "Home Visit Prenatal", wrvu: 0.00 },
 "99501": { name: "Home Visit Postnatal", wrvu: 0.00 },
 "99502": { name: "Home Visit Nb Care", wrvu: 0.00 },
 "99503": { name: "Home Visit Resp Therapy", wrvu: 0.00 },
 "99504": { name: "Home Visit Mech Ventilator", wrvu: 0.00 },
 "99505": { name: "Home Visit Stoma Care", wrvu: 0.00 },
 "99506": { name: "Home Visit Intramuscular Injection", wrvu: 0.00 },
 "99507": { name: "Home Visit Catheter Maintain", wrvu: 0.00 },
 "99509": { name: "Home Visit Day Life Activity", wrvu: 0.00 },
 "99510": { name: "Home Visit SinGroin/Mid/Footam Couns", wrvu: 0.00 },
 "99511": { name: "Home Visit Fecal/enema Management", wrvu: 0.00 },
 "99512": { name: "Home Visit For Hemodialysis", wrvu: 0.00 },
 "99600": { name: "Unlisted Home Visit Svc/Procedure", wrvu: 0.00 },
 "99601": { name: "Home Nfs Visit <2 Hours", wrvu: 0.00 },
 "99602": { name: "Home Nfs Visit Each Additional Hr", wrvu: 0.00 },
 "99605": { name: "Mtms By Pharm NP 15 Minutes", wrvu: 0.00 },
 "99606": { name: "Mtms By Pharm Established 15 Minutes", wrvu: 0.00 },
 "99607": { name: "Mtms By Pharm Additional 15 Minutes", wrvu: 0.00 },
 "G0008": { name: "Administration Influenza Virus Vac", wrvu: 0.00 },
 "G0009": { name: "Administration Pneumococcal Vaccine", wrvu: 0.00 },
 "G0010": { name: "Administration Hepatitis B Vaccine", wrvu: 0.00 },
 "G0011": { name: "HIV Prep Counsel, Md 15-30m", wrvu: 0.45 },
 "G0012": { name: "Injection Of HIV Prep Drug", wrvu: 0.17 },
 "G0013": { name: "HIV Prep Counsel, Clin Staff", wrvu: 0.18 },
 "G0017": { name: "Crisis Psychotherapy 60m", wrvu: 4.70 },
 "G0018": { name: "Crisis Psychotherapy Add 30m", wrvu: 2.25 },
 "G0019": { name: "Comm Hlth Intg Svs Sdoh 60mn", wrvu: 1.00 },
 "G0022": { name: "Comm Hlth Intg Svs Add 30 M", wrvu: 0.70 },
 "G0023": { name: "Pin Service 60m Per Month", wrvu: 1.00 },
 "G0024": { name: "Pin Srv Add 30 minutes Per M", wrvu: 0.70 },
 "G0027": { name: "Semen Analysis", wrvu: 0.00 },
 "G0029": { name: "No Tob Scr/cess Int", wrvu: 0.00 },
 "G0030": { name: "Prothrombin Time Scr Tob & Cess Int", wrvu: 0.00 },
 "G0031": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G0032": { name: "2+ Antipsy Schiz", wrvu: 0.00 },
 "G0033": { name: "2+ Benzo Seiz", wrvu: 0.00 },
 "G0034": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G0035": { name: "Prothrombin Time Emergency Department Pos 23", wrvu: 0.00 },
 "G0036": { name: "Patient/ptn Decln Assess", wrvu: 0.00 },
 "G0037": { name: "Prothrombin Time Not Able To Participate", wrvu: 0.00 },
 "G0038": { name: "Clin Prothrombin Time No Ref", wrvu: 0.00 },
 "G0039": { name: "Prothrombin Time No Ref, Rn Specimen", wrvu: 0.00 },
 "G0040": { name: "Prothrombin Time Phys/occ Therapy", wrvu: 0.00 },
 "G0041": { name: "Patient/ptn Decln Referral", wrvu: 0.00 },
 "G0042": { name: "Ref To Therapy", wrvu: 0.00 },
 "G0043": { name: "Prothrombin Time Mech Pros Ht Valv", wrvu: 0.00 },
 "G0044": { name: "Prothrombin Time Mitral Stenosis", wrvu: 0.00 },
 "G0045": { name: "Mrs 90 Days Posterior Stk", wrvu: 0.00 },
 "G0046": { name: "No Mrs 90 Days Posterior Stk", wrvu: 0.00 },
 "G0047": { name: "Ped Blunt Hd Traum", wrvu: 0.00 },
 "G0048": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G0049": { name: "Main Hemo In-Counter", wrvu: 0.00 },
 "G0050": { name: "Prothrombin Time W/ Lmted Life Expec", wrvu: 0.00 },
 "G0051": { name: "Prothrombin Time Hospice Month", wrvu: 0.00 },
 "G0052": { name: "Prothrombin Time Peri Dialysis Dur Month", wrvu: 0.00 },
 "G0053": { name: "Adv Rheum Prothrombin Time Care Mvp", wrvu: 0.00 },
 "G0054": { name: "Strk Cr Prev Pos Outcme Mvp", wrvu: 0.00 },
 "G0055": { name: "Adv Care Heart Diagnosis Mvp", wrvu: 0.00 },
 "G0057": { name: "Best Pct Prothrombin Time Safety Em Mvp", wrvu: 0.00 },
 "G0058": { name: "Imprv Care Le Jnt Repr Mvp", wrvu: 0.00 },
 "G0059": { name: "Prothrombin Time Sfty Pos Exp W Aneth Mvp", wrvu: 0.00 },
 "G0060": { name: "Allergy/immunology Ss", wrvu: 0.00 },
 "G0061": { name: "Anesthesiology Ss", wrvu: 0.00 },
 "G0062": { name: "Audiology Ss", wrvu: 0.00 },
 "G0063": { name: "Cardiology Ss", wrvu: 0.00 },
 "G0064": { name: "Cert Nurse Midwife Ss", wrvu: 0.00 },
 "G0065": { name: "Chiropractic Ss", wrvu: 0.00 },
 "G0066": { name: "Clinical Social Work Ss", wrvu: 0.00 },
 "G0067": { name: "Dentistry Ss", wrvu: 0.00 },
 "G0068": { name: "Adm Intravenous Infusion Drug In Home", wrvu: 0.00 },
 "G0069": { name: "Adm Subcutaneous Infusion Drug In Home", wrvu: 0.00 },
 "G0070": { name: "Adm Of Chemo Drug In Home", wrvu: 0.00 },
 "G0076": { name: "Care Manag H Visit New Patient 20 M", wrvu: 1.01 },
 "G0077": { name: "Care Manag H Visit New Patient 30 M", wrvu: 1.52 },
 "G0078": { name: "Care Manag H Visit New Patient 45 M", wrvu: 2.53 },
 "G0079": { name: "Care Manag H Visit New Patient 60 M", wrvu: 3.38 },
 "G0080": { name: "Care Manag H Visit New Patient 75 M", wrvu: 4.09 },
 "G0081": { name: "Care Man H V External Prothrombin Time 20 Mi", wrvu: 1.00 },
 "G0082": { name: "Care Man H V External Prothrombin Time 30 M", wrvu: 1.56 },
 "G0083": { name: "Care Man H V External Prothrombin Time 45 M", wrvu: 2.33 },
 "G0084": { name: "Care Man H V External Prothrombin Time 60 M", wrvu: 3.28 },
 "G0085": { name: "Care Man H V External Prothrombin Time 75 M", wrvu: 4.09 },
 "G0086": { name: "Care Man Home Care Plan 30 M", wrvu: 1.25 },
 "G0087": { name: "Care Man Home Care Plan 60 M", wrvu: 1.80 },
 "G0088": { name: "Adm Intravenous Drug 1st Home Visit", wrvu: 0.00 },
 "G0089": { name: "Adm Subcutaneous Drug 1st Home Visit", wrvu: 0.00 },
 "G0090": { name: "Adm Intravenous Chemo 1st Home Visit", wrvu: 0.00 },
 "G0101": { name: "Ca Screen;pelvic/breast Exam", wrvu: 0.44 },
 "G0102": { name: "Prostate Ca Screening; Dre", wrvu: 0.18 },
 "G0103": { name: "PSA Screening", wrvu: 0.00 },
 "G0104": { name: "Ca Screen;flexi Sigmoidscope", wrvu: 0.82 },
 "G0105": { name: "Colorectal Scrn; High Risk Ind", wrvu: 3.18 },
 "G0108": { name: "Diabetes Self-Management Training, Individual, 30 minutes", wrvu: 0.90 },
 "G0109": { name: "Diabetes Self-Management Training, Group (2+ patients), 30 minutes", wrvu: 0.25 },
 "G0117": { name: "Glaucoma Scrn Hgh Risk Direc", wrvu: 0.44 },
 "G0118": { name: "Glaucoma Scrn Hgh Risk Direc", wrvu: 0.17 },
 "G0121": { name: "Colon Ca Scrn Not High Rsk Ind", wrvu: 3.18 },
 "G0123": { name: "Screen Cervical/Vaginal Thin Layer", wrvu: 0.00 },
 "G0124": { name: "Screen Cervical/Vaginal Thin Layer By Md", wrvu: 0.25 },
 "G0127": { name: "Trim Nail(s)", wrvu: 0.17 },
 "G0128": { name: "Corf Skilled Nursing Service", wrvu: 0.00 },
 "G0129": { name: "Php/Intraocular Pressure Occupational Therapy Service", wrvu: 0.00 },
 "G0130": { name: "Single Energy X-ray Study", wrvu: 0.21 },
 "G0136": { name: "Adm Of Pa/n Assess 5-15 M", wrvu: 0.18 },
 "G0137": { name: "Inten Outpt Svs,minutes 9 Per 7 D", wrvu: 0.00 },
 "G0138": { name: "Intravenous Cipaglucosidase Alfa-atga", wrvu: 0.21 },
 "G0140": { name: "Navigation Srv Peer Superior 60 minutes Per M", wrvu: 1.00 },
 "G0141": { name: "Scr Cervical/Vaginal Cytology,autosys And Md", wrvu: 0.25 },
 "G0143": { name: "Scr Cervical/Vaginal Cytology,thinlayer,rescr", wrvu: 0.00 },
 "G0144": { name: "Scr Cervical/Vaginal Cytology,thinlayer,rescr", wrvu: 0.00 },
 "G0145": { name: "Scr Cervical/Vaginal Cytology,thinlayer,rescr", wrvu: 0.00 },
 "G0146": { name: "Navigation Srv Peer Superior Add 30 Per M", wrvu: 0.70 },
 "G0147": { name: "Scr Cervical/Vaginal Cytology, Automated System", wrvu: 0.00 },
 "G0148": { name: "Scr Cervical/Vaginal Cytology, Autosys, Rescr", wrvu: 0.00 },
 "G0151": { name: "Hhcp-serv Of Patient,Each 15 Minutes", wrvu: 0.00 },
 "G0152": { name: "Hhcp-serv Of Ot,Each 15 Minutes", wrvu: 0.00 },
 "G0153": { name: "Hhcp-svs Of S/l Pathology,Each 15mn", wrvu: 0.00 },
 "G0155": { name: "Hhcp-svs Of Csw,Each 15 Minutes", wrvu: 0.00 },
 "G0156": { name: "Hhcp-svs Of Aide,Each 15 Minutes", wrvu: 0.00 },
 "G0157": { name: "Hhc Prothrombin Time Assistant Each 15", wrvu: 0.00 },
 "G0158": { name: "Hhc Occupational Therapy Assistant Each 15", wrvu: 0.00 },
 "G0159": { name: "Hhc Prothrombin Time Maint Each 15 Minutes", wrvu: 0.00 },
 "G0160": { name: "Hhc Occup Therapy Each 15", wrvu: 0.00 },
 "G0161": { name: "Hhc Slp Each 15 Minutes", wrvu: 0.00 },
 "G0162": { name: "Hhc Rn E and m Plan Svs, 15 Minutes", wrvu: 0.00 },
 "G0166": { name: "Extrnl Counterpulse, Per Treatment", wrvu: 0.00 },
 "G0168": { name: "Wound Closure By Adhesive", wrvu: 0.30 },
 "G0175": { name: "Opps Service,Scheduled Team Conf", wrvu: 0.00 },
 "G0176": { name: "Opps/php/Intraocular Pressure; Activity Thrpy", wrvu: 0.00 },
 "G0177": { name: "Opps/php/Intraocular Pressure; Train & Educ", wrvu: 0.00 },
 "G0179": { name: "Md Recertification Hha Patient", wrvu: 0.44 },
 "G0180": { name: "Md Certification Hha Patient", wrvu: 0.65 },
 "G0181": { name: "Home Health Care Supervision", wrvu: 1.73 },
 "G0182": { name: "Hospice Care Supervision", wrvu: 1.73 },
 "G0183": { name: "Software Meas Of Cardiac Vol", wrvu: 0.00 },
 "G0186": { name: "Dstry Eye Lesn,fdr Vssl Tech", wrvu: 0.00 },
 "G0219": { name: "PET Scan Imaging Wholbod Melano Nonco", wrvu: 0.00 },
 "G0235": { name: "PET Scan Not Otherwise Specified", wrvu: 0.00 },
 "G0237": { name: "Therapeutic Procedure Strg Endur", wrvu: 0.00 },
 "G0238": { name: "Oth Resp Procedure, Indiv", wrvu: 0.00 },
 "G0239": { name: "Oth Resp Procedure, Group", wrvu: 0.00 },
 "G0245": { name: "Initial Foot Exam Prothrombin Time Lops", wrvu: 0.86 },
 "G0246": { name: "Followup Evaluation Of Foot Prothrombin Time Lop", wrvu: 0.44 },
 "G0247": { name: "Routine Footcare Prothrombin Time W Lops", wrvu: 0.49 },
 "G0248": { name: "Demonstrate Use Home INR Mon", wrvu: 0.00 },
 "G0249": { name: "Provide INR Test Mater/equip", wrvu: 0.00 },
 "G0250": { name: "Md INR Test Revie Inter Management", wrvu: 0.18 },
 "G0252": { name: "PET Scan Imaging Initial Diagnosis", wrvu: 0.00 },
 "G0255": { name: "Current Percep Threshold Tst", wrvu: 0.00 },
 "G0257": { name: "Unsched Dialysis Esrd Prothrombin Time Hos", wrvu: 0.00 },
 "G0259": { name: "Inject For Sacroiliac Joint", wrvu: 0.00 },
 "G0260": { name: "Injection For Sacroiliac Joint Anesth", wrvu: 0.00 },
 "G0268": { name: "Removal Of Impacted Wax Md", wrvu: 0.59 },
 "G0269": { name: "Occlusive Device In Vein Artery", wrvu: 0.00 },
 "G0270": { name: "Medical Nutrition Therapy Reassessment, Subsequent to G0271", wrvu: 0.45 },
 "G0271": { name: "Medical Nutrition Therapy, Group (2+ patients)", wrvu: 0.25 },
 "G0276": { name: "Pild/placebo Control Clin Tr", wrvu: 6.99 },
 "G0277": { name: "Hbot, Full Body Chamber, 30m", wrvu: 0.00 },
 "G0278": { name: "Iliac Artery Angiography,cardiac Catheter", wrvu: 0.24 },
 "G0279": { name: "Tomosynthesis, Mammo", wrvu: 0.59 },
 "G0281": { name: "Elec Stimulation Unattend For Pressure", wrvu: 0.18 },
 "G0282": { name: "Elect Stimulation Wound Care Not Pd", wrvu: 0.00 },
 "G0283": { name: "Elec Stimulation Other Than Wound", wrvu: 0.18 },
 "G0288": { name: "Recon, Cta For Surgery Plan", wrvu: 0.00 },
 "G0289": { name: "Arthroscopic, Loose Body + Chondro", wrvu: 1.44 },
 "G0293": { name: "Non-cov Surgery Procedure,clin Trial", wrvu: 0.00 },
 "G0294": { name: "Non-cov Procedure, Clinical Trial", wrvu: 0.00 },
 "G0295": { name: "Electromagnetic Therapy Oncology", wrvu: 0.00 },
 "G0296": { name: "Visit To Determ Ldct Elig", wrvu: 0.52 },
 "G0299": { name: "Hhs/hospice Of Rn Each 15 Minutes", wrvu: 0.00 },
 "G0300": { name: "Hhs/hospice Of Lpn Each 15 Minutes", wrvu: 0.00 },
 "G0302": { name: "Pre-op Service Lvrs Complete", wrvu: 0.00 },
 "G0303": { name: "Pre-op Service Lvrs 10-15dos", wrvu: 0.00 },
 "G0304": { name: "Pre-op Service Lvrs 1-9 Dos", wrvu: 0.00 },
 "G0305": { name: "Posterior Op Service Lvrs minutes 6", wrvu: 0.00 },
 "G0306": { name: "Cbc/diffwbc Without Platelet", wrvu: 0.00 },
 "G0307": { name: "CBC Without Platelet", wrvu: 0.00 },
 "G0310": { name: "Immunize Counsel 5-15 Minutes", wrvu: 0.00 },
 "G0311": { name: "Immunize Counsel 16-30 Mins", wrvu: 0.00 },
 "G0312": { name: "Immunize Couns < 21yr 5-15 M", wrvu: 0.00 },
 "G0313": { name: "Immunize Couns < 21yr 6-30 M", wrvu: 0.00 },
 "G0314": { name: "Counsel Immune <21 16-30 M", wrvu: 0.00 },
 "G0315": { name: "Counsel Immune <21 5-15 M", wrvu: 0.00 },
 "G0316": { name: "Prolong Inpt Evaluation Add15 M", wrvu: 0.61 },
 "G0317": { name: "Prolong Nursin Fac Evaluation 15m", wrvu: 0.61 },
 "G0318": { name: "Prolong Home Evaluation Add 15m", wrvu: 0.61 },
 "G0320": { name: "Two-way Audio And Video Hhs", wrvu: 0.00 },
 "G0321": { name: "Audio-only Hhs", wrvu: 0.00 },
 "G0322": { name: "Home H Physio Data Collec Tr", wrvu: 0.00 },
 "G0323": { name: "Care Manage Beh Svs 20mins", wrvu: 0.93 },
 "G0327": { name: "Colon Ca Scrn;bld-bsd Biomrk", wrvu: 0.00 },
 "G0328": { name: "Fecal Blood Scrn Immunoassay", wrvu: 0.00 },
 "G0329": { name: "Electromagntic Treatment For Ulcers", wrvu: 0.06 },
 "G0330": { name: "Facility Svs Dental Rehabilitation", wrvu: 0.00 },
 "G0333": { name: "Dispense Fee Initial 30 Day", wrvu: 0.00 },
 "G0337": { name: "Hospice Evaluation Preelecti", wrvu: 1.42 },
 "G0339": { name: "Robotic Lin-radsurg Com, First", wrvu: 0.00 },
 "G0340": { name: "Robt Lin-radsurg Fractx 2-5", wrvu: 0.00 },
 "G0341": { name: "Percutaneous Islet Celltrans", wrvu: 6.81 },
 "G0342": { name: "Laparoscopy Islet Cell Trans", wrvu: 11.62 },
 "G0343": { name: "Laparotomy Islet Cell Transp", wrvu: 19.35 },
 "G0372": { name: "Md Service Required For Pmd", wrvu: 0.17 },
 "G0378": { name: "Hospital Observation Per Hr", wrvu: 0.00 },
 "G0379": { name: "Direct Refer Hospital Observ", wrvu: 0.00 },
 "G0380": { name: "Lev 1 Hospital Type B Emergency Department Visit", wrvu: 0.00 },
 "G0381": { name: "Lev 2 Hospital Type B Emergency Department Visit", wrvu: 0.00 },
 "G0382": { name: "Lev 3 Hospital Type B Emergency Department Visit", wrvu: 0.00 },
 "G0383": { name: "Lev 4 Hospital Type B Emergency Department Visit", wrvu: 0.00 },
 "G0384": { name: "Lev 5 Hospital Type B Emergency Department Visit", wrvu: 0.00 },
 "G0390": { name: "Trauma Respons With Hospital Criti", wrvu: 0.00 },
 "G0396": { name: "Alcohol/subs Interv 15-30mn", wrvu: 0.65 },
 "G0397": { name: "Alcohol/subs Interv >30 Minutes", wrvu: 1.30 },
 "G0398": { name: "Home Sleep Test/type 2 Porta", wrvu: 0.00 },
 "G0399": { name: "Home Sleep Test/type 3 Porta", wrvu: 0.00 },
 "G0400": { name: "Home Sleep Test/type 4 Porta", wrvu: 0.00 },
 "G0402": { name: "Initial Preventive Exam", wrvu: 2.60 },
 "G0403": { name: "EKG For Initial Prevent Exam", wrvu: 0.17 },
 "G0404": { name: "EKG Tracing For Initial Prev", wrvu: 0.00 },
 "G0405": { name: "EKG Interpret & Report Preve", wrvu: 0.17 },
 "G0406": { name: "Inpt/tele Follow Up 15", wrvu: 0.76 },
 "G0407": { name: "Inpt/tele Follow Up 25", wrvu: 1.39 },
 "G0408": { name: "Inpt/tele Follow Up 35", wrvu: 2.00 },
 "G0409": { name: "Corf Related Serv 15 Mins Each", wrvu: 0.00 },
 "G0410": { name: "Grp Psych Php/Intraocular Pressure 45-50", wrvu: 0.00 },
 "G0411": { name: "Interactive Grp Psyc Php/Intraocular Pressure", wrvu: 0.00 },
 "G0412": { name: "Open Treatment Iliac Spine Uni/bil", wrvu: 10.19 },
 "G0413": { name: "Pelvic Ring Fracture Uni/bil", wrvu: 15.34 },
 "G0414": { name: "Pelvic Ring Fracture Treat Int Fix", wrvu: 14.28 },
 "G0415": { name: "Open Treatment Posterior Pelvic Fxcture", wrvu: 20.41 },
 "G0416": { name: "Prostate Biopsy, Any Mthd", wrvu: 3.51 },
 "G0420": { name: "Emergency Department Svc Ckd Ind Per Session", wrvu: 2.12 },
 "G0421": { name: "Emergency Department Svc Ckd Grp Per Session", wrvu: 0.50 },
 "G0422": { name: "Intens Cardiac Rehabilitation With Exerc", wrvu: 2.05 },
 "G0423": { name: "Intens Cardiac Rehabilitation No Exer", wrvu: 2.05 },
 "G0424": { name: "Pulmonary Rehabilitation, 1 hour (with exercise)", wrvu: 0.33 },
 "G0425": { name: "Inpt/Emergency Department Teleconsult30", wrvu: 1.92 },
 "G0426": { name: "Inpt/Emergency Department Teleconsult50", wrvu: 2.61 },
 "G0427": { name: "Inpt/Emergency Department Teleconsult70", wrvu: 3.86 },
 "G0428": { name: "Collagen Meniscus Implant", wrvu: 0.00 },
 "G0429": { name: "Dermal Filler Injection(s)", wrvu: 1.16 },
 "G0432": { name: "Eia HIV-1/HIV-2 Screen", wrvu: 0.00 },
 "G0433": { name: "Elisa HIV-1/HIV-2 Screen", wrvu: 0.00 },
 "G0435": { name: "Oral HIV-1/HIV-2 Screen", wrvu: 0.00 },
 "G0438": { name: "Annual Annual Wellness Visit, Initial (Welcome to Medicare)", wrvu: 2.60 },
 "G0439": { name: "Annual Annual Wellness Visit, Subsequent", wrvu: 1.92 },
 "G0442": { name: "Annual Alcohol Misuse Screening, 15 minutes", wrvu: 0.18 },
 "G0443": { name: "Alcohol Misuse Counseling, 15 minutes (up to 4 per year)", wrvu: 0.60 },
 "G0444": { name: "Annual Depression Screening, 15 minutes", wrvu: 0.18 },
 "G0445": { name: "High Inten Beh Couns STD 30m", wrvu: 0.60 },
 "G0446": { name: "Intens Behave Therapeutic Cardio Diagnosis", wrvu: 0.60 },
 "G0447": { name: "Behavioral Counseling for Obesity, 15 minutes", wrvu: 0.60 },
 "G0448": { name: "Place Permanent Pacing Cardiovert", wrvu: 0.00 },
 "G0451": { name: "Devlopment Test Interpt and rep", wrvu: 0.00 },
 "G0452": { name: "Molecular Pathology Interpr", wrvu: 0.91 },
 "G0453": { name: "Cont Intraop Neuro Monitor", wrvu: 0.60 },
 "G0454": { name: "Md Document Visit By Npp", wrvu: 0.18 },
 "G0455": { name: "Fecal Microbiota Prep Instil", wrvu: 1.31 },
 "G0458": { name: "Ldr Prostate Brachy Comp Rat", wrvu: 0.00 },
 "G0459": { name: "Telehealth Inpt Pharm Management", wrvu: 0.95 },
 "G0460": { name: "Autolog PRP Not Diab Ulcer", wrvu: 0.00 },
 "G0463": { name: "Hospital Outpt Clinic Visit", wrvu: 0.00 },
 "G0465": { name: "Autolog PRP Diab Wound Ulcer", wrvu: 1.78 },
 "G0466": { name: "Fqhc Visit New Patient", wrvu: 0.00 },
 "G0467": { name: "Fqhc Visit, Estab Patient", wrvu: 0.00 },
 "G0468": { name: "Fqhc Visit, Initial Preventive Physical Exam Or Annual Wellness Visit", wrvu: 0.00 },
 "G0469": { name: "Fqhc Visit, Mh New Patient", wrvu: 0.00 },
 "G0470": { name: "Fqhc Visit, Mh Estab Patient", wrvu: 0.00 },
 "G0471": { name: "Ven Blood Collection Skilled Nursing Facility/hha", wrvu: 0.00 },
 "G0472": { name: "Hep C Screen High Risk/other", wrvu: 0.00 },
 "G0473": { name: "Behavioral Counseling for Obesity, Group (2-10 patients), 30 minutes", wrvu: 0.23 },
 "G0475": { name: "HIV Combination Assay", wrvu: 0.00 },
 "G0476": { name: "HPV Combo Assay Ca Screen", wrvu: 0.00 },
 "G0480": { name: "Drug Test Def 1-7 Classes", wrvu: 0.00 },
 "G0481": { name: "Drug Test Def 8-14 Classes", wrvu: 0.00 },
 "G0482": { name: "Drug Test Def 15-21 Classes", wrvu: 0.00 },
 "G0483": { name: "Drug Test Def 22+ Classes", wrvu: 0.00 },
 "G0490": { name: "Home Visit Rn, Lpn By Rhc/fq", wrvu: 0.00 },
 "G0491": { name: "Dialysis Acu Kidney No Esrd", wrvu: 0.00 },
 "G0492": { name: "Md/oth Evaluation Acut Kid No Esrd", wrvu: 0.00 },
 "G0493": { name: "Rn Care Each 15 minutes Hh/hospice", wrvu: 0.00 },
 "G0494": { name: "Lpn Care Each 15min Hh/hospice", wrvu: 0.00 },
 "G0495": { name: "Rn Care Train/edu In Hh", wrvu: 0.00 },
 "G0496": { name: "Lpn Care Train/edu In Hh", wrvu: 0.00 },
 "G0498": { name: "Chemo Extend Intravenous Infusion With Pump", wrvu: 0.00 },
 "G0499": { name: "Hepb Screen High Risk Indiv", wrvu: 0.00 },
 "G0500": { name: "Moderate Sedat Endoscopic Service >5yrs", wrvu: 0.10 },
 "G0501": { name: "Resource-inten Svc During Ov", wrvu: 0.00 },
 "G0506": { name: "Comp Asses Care Plan Chronic Care Management Svc", wrvu: 0.87 },
 "G0508": { name: "Critical Care Telehea Consult 60", wrvu: 4.00 },
 "G0509": { name: "Critical Care Telehea Consult 50", wrvu: 3.86 },
 "G0513": { name: "Prolong Prev Services, First 30m", wrvu: 1.17 },
 "G0514": { name: "Prolong Prev Services, Additional 30m", wrvu: 1.17 },
 "G0516": { name: "Insert Drug Del Implant, >=4", wrvu: 1.77 },
 "G0517": { name: "Remove Drug Implant", wrvu: 2.05 },
 "G0518": { name: "Remove W Insert Drug Implant", wrvu: 3.46 },
 "G0519": { name: "New Patient-cg Dyad Dem Low Complex", wrvu: 0.00 },
 "G0520": { name: "New Patient-cg Dyad Dem Moderate Complex", wrvu: 0.00 },
 "G0521": { name: "New Patient-cg Dyad Dem Hig Complex", wrvu: 0.00 },
 "G0522": { name: "Mgt Nw Prothrombin Time Dementia Low Complex", wrvu: 0.00 },
 "G0523": { name: "Mgt Nw Prothrombin Time Dem Moderate-high Complex", wrvu: 0.00 },
 "G0524": { name: "Established Patient-cg Dyad Dem Low Complex", wrvu: 0.00 },
 "G0525": { name: "Established Patient-cg Dyad Dem Moderate Complex", wrvu: 0.00 },
 "G0526": { name: "Established Patient-cg Dyad Dem Hig Complex", wrvu: 0.00 },
 "G0527": { name: "Mgt Established Prothrombin Time Dmentia Low Complex", wrvu: 0.00 },
 "G0528": { name: "Mgt Established Prothrombin Time Dem Moderate-High Complex", wrvu: 0.00 },
 "G0529": { name: "In Home Respite Care, 4 hr U", wrvu: 0.00 },
 "G0530": { name: "Adult Daycare Center, 8 hr U", wrvu: 0.00 },
 "G0531": { name: "Fclty-based Respite, 24 hr U", wrvu: 0.00 },
 "G0532": { name: "Take Home Supp Nasal Spray", wrvu: 0.00 },
 "G0533": { name: "Buprenorphone Injection Weekly", wrvu: 0.00 },
 "G0534": { name: "Coordinated Care/or Referral", wrvu: 0.00 },
 "G0535": { name: "Prothrombin Time Navigation Svs Direct/ref", wrvu: 0.00 },
 "G0536": { name: "Peer Recover Support Svs", wrvu: 0.00 },
 "G0537": { name: "Risk Ascvd Tst Once Per 12 Month", wrvu: 0.18 },
 "G0538": { name: "Ascvd Rsk Mng Clin Stf Per Month", wrvu: 0.18 },
 "G0539": { name: "Initial Care Training 30 M", wrvu: 1.00 },
 "G0540": { name: "Train For Caregiver Add 15", wrvu: 0.54 },
 "G0541": { name: "No Prothrombin Time Prsnt Train Initial 30", wrvu: 1.00 },
 "G0542": { name: "No Prothrombin Time Prsnt Train Add 15", wrvu: 0.54 },
 "G0543": { name: "Group Train Without Patient", wrvu: 0.23 },
 "G0544": { name: "Posterior Discharge Phone Follow Up", wrvu: 0.98 },
 "G0545": { name: "Inherent Visit To Inpt", wrvu: 0.89 },
 "G0546": { name: "Phone/internet EHR Assess", wrvu: 0.35 },
 "G0547": { name: "Phone/internet Svs 11-20 M", wrvu: 0.70 },
 "G0548": { name: "Phone/inter Svs 21-30 M", wrvu: 1.05 },
 "G0549": { name: "Phone/inter For Treat>31m", wrvu: 1.40 },
 "G0550": { name: "Phone/inter For Diagnosis/treat >5m", wrvu: 0.70 },
 "G0551": { name: "Phn/intr Svs Fr Diagnosis Treat 30m", wrvu: 0.70 },
 "G0552": { name: "Supply Of Digital Device", wrvu: 0.00 },
 "G0553": { name: "Monthly Treatment For Dmht 20mins", wrvu: 0.62 },
 "G0554": { name: "Add 20 M Of Monthly Treatment", wrvu: 0.61 },
 "G0555": { name: "Replacment Prothrombin Time Electronic System", wrvu: 0.00 },
 "G0556": { name: "Adv Prim Care Management Lvl 1", wrvu: 0.25 },
 "G0557": { name: "Adv Prim Care Management Lvl 2", wrvu: 0.77 },
 "G0558": { name: "Adv Prim Care Management Lvl 3", wrvu: 1.67 },
 "G0559": { name: "Unrelat Prac Follow Up Visit", wrvu: 0.16 },
 "G0560": { name: "Safety Plan Interven", wrvu: 1.09 },
 "G0561": { name: "Temp Tube Delivery, Unil", wrvu: 0.00 },
 "G0562": { name: "Complex Simulation With Pet-ct", wrvu: 0.00 },
 "G0563": { name: "Stereotactic Body Radiation Therapy With Positron Emission Del", wrvu: 0.00 },
 "G0566": { name: "3d Bone Imaging Algor Drvd Fr MRI", wrvu: 0.00 },
 "G0567": { name: "Screening Hep C Detect", wrvu: 0.00 },
 "G0568": { name: "Int Psych Care Mng, 1 Cal Month", wrvu: 1.88 },
 "G0569": { name: "Subs Psych Care Mng, Subs Month", wrvu: 2.05 },
 "G0570": { name: "Care Manage Serv, Per Cal Month", wrvu: 0.93 },
 "G0571": { name: "Intraop Nerve Cryoablation", wrvu: 1.36 },
 "G0659": { name: "Drug Test Def Simple Acute Lymphoblastic Leukemia Cl", wrvu: 0.00 },
 "G0660": { name: "Team Remote E and M New Patient 10 Mn", wrvu: 0.00 },
 "G0661": { name: "Team Remote E and M New Patient 20 Mn", wrvu: 0.00 },
 "G0662": { name: "Team Remote E and M New Patient 30 Mn", wrvu: 0.00 },
 "G0663": { name: "Team Remote E and M New Patient 45 Mn", wrvu: 0.00 },
 "G0664": { name: "Team Remote E and M New Patient 60 Mn", wrvu: 0.00 },
 "G0665": { name: "Team Remote E and M Established Prothrombin Time 10 Mn", wrvu: 0.00 },
 "G0666": { name: "Team Remote E and M Established Prothrombin Time 15 Mn", wrvu: 0.00 },
 "G0667": { name: "Team Remote E and M Established Prothrombin Time 25 Mn", wrvu: 0.00 },
 "G0668": { name: "Team Remote E and M Established Prothrombin Time 40 Mn", wrvu: 0.00 },
 "G0913": { name: "Improve Visual Funct", wrvu: 0.00 },
 "G0914": { name: "Survey Not Complete", wrvu: 0.00 },
 "G0915": { name: "No Improve Visual Funct", wrvu: 0.00 },
 "G0916": { name: "Satisfy With Care", wrvu: 0.00 },
 "G0917": { name: "Care Survey Not Complete", wrvu: 0.00 },
 "G0918": { name: "No Satisfy With Care", wrvu: 0.00 },
 "G1025": { name: "Prothrombin Time Month 1 Mcp Prov", wrvu: 0.00 },
 "G1026": { name: "Prothrombin Time Hemo > 3mo", wrvu: 0.00 },
 "G1027": { name: "Prothrombin Time Hemo < 3mo", wrvu: 0.00 },
 "G1028": { name: "Take Home Supply 8mg Per 0.1", wrvu: 0.00 },
 "G2000": { name: "Blinded Conv. Treatment Mdd Clin Tr", wrvu: 0.00 },
 "G2001": { name: "Posterior Discharge H Visit New Patient 20 M", wrvu: 1.01 },
 "G2002": { name: "Posterior-Discharge H Visit New Patient 30 M", wrvu: 1.52 },
 "G2003": { name: "Posterior-Discharge H Visit New Patient 45 M", wrvu: 2.53 },
 "G2004": { name: "Posterior-Discharge H Visit New Patient 60 M", wrvu: 3.38 },
 "G2005": { name: "Posterior-Discharge H Visit New Patient 75 M", wrvu: 4.09 },
 "G2006": { name: "Posterior-Discharge H Visit External Prothrombin Time 20 M", wrvu: 1.00 },
 "G2007": { name: "Posterior-Discharge H Visit External Prothrombin Time 30 M", wrvu: 1.56 },
 "G2008": { name: "Posterior-Discharge H Visit External Prothrombin Time 45 M", wrvu: 2.33 },
 "G2009": { name: "Posterior-Discharge H Visit External Prothrombin Time 60 M", wrvu: 3.28 },
 "G2010": { name: "Remot Image Submit By Patient", wrvu: 0.18 },
 "G2011": { name: "Alcohol/sub Misuse Assess", wrvu: 0.33 },
 "G2013": { name: "Posterior-Discharge H Visit External Prothrombin Time 75 M", wrvu: 4.09 },
 "G2014": { name: "Posterior-Discharge Care Plan Overs 30m", wrvu: 1.25 },
 "G2015": { name: "Posterior-Discharge Care Plan Overs 60m", wrvu: 1.80 },
 "G2020": { name: "High Inten Serv For Sip Model", wrvu: 0.00 },
 "G2021": { name: "Hea Care Pract Treatment In Place", wrvu: 0.00 },
 "G2022": { name: "Benef Refuses Service, Moderate", wrvu: 0.00 },
 "G2025": { name: "Dis Site Tele Services Rhc/fqhc", wrvu: 1.44 },
 "G2067": { name: "Medial Assist Treatment Meth Week", wrvu: 0.00 },
 "G2068": { name: "Medial Assist Treatment Bupre Oral", wrvu: 0.00 },
 "G2069": { name: "Medial Assist Treatment Inject", wrvu: 0.00 },
 "G2073": { name: "Medial Treatment Naltrexone", wrvu: 0.00 },
 "G2074": { name: "Medial Assist Treatment No Drug", wrvu: 0.00 },
 "G2075": { name: "Medial Treatment Meds Not Otherwise Specified", wrvu: 0.00 },
 "G2076": { name: "Intake Act With Medial Exam", wrvu: 0.00 },
 "G2077": { name: "Periodic Assessment", wrvu: 0.00 },
 "G2078": { name: "Take-home Meth", wrvu: 0.00 },
 "G2079": { name: "Take-hom Buprenorphine", wrvu: 0.00 },
 "G2080": { name: "Add 30 Mins Counsel", wrvu: 0.00 },
 "G2081": { name: "Prothrombin Time 66+ Single Nucleotide Polymorphism Or Ltc Pos > 90d", wrvu: 0.00 },
 "G2082": { name: "Visit Esketamine 56m Or Less", wrvu: 0.70 },
 "G2083": { name: "Visit Esketamine, > 56m", wrvu: 0.70 },
 "G2086": { name: "Office-Based Opioid Use Disorder Treatment, Initial Month", wrvu: 8.36 },
 "G2087": { name: "Office-Based Opioid Use Disorder Treatment, Subsequent Month", wrvu: 8.19 },
 "G2088": { name: "Office-Based Opioid Use Disorder Treatment, Add'l 30 minutes", wrvu: 0.82 },
 "G2090": { name: "Prothrombin Time 66+ Frailty And Medial Dem", wrvu: 0.00 },
 "G2091": { name: "Prothrombin Time 66+ Frailty And Adv Ill", wrvu: 0.00 },
 "G2092": { name: "Ace Arb Arni", wrvu: 0.00 },
 "G2093": { name: "Medial Documentation Rsn No Ace Arn Arni", wrvu: 0.00 },
 "G2094": { name: "Prothrombin Time Rsn No Ace Arn Arni", wrvu: 0.00 },
 "G2096": { name: "No Rsn Ace Arb Arni", wrvu: 0.00 },
 "G2097": { name: "Diagnosis Uri 3d After Other Diagnosis", wrvu: 0.00 },
 "G2098": { name: "Prothrombin Time 66+ Frailty And Medial Dem", wrvu: 0.00 },
 "G2099": { name: "Prothrombin Time 66+ Frailty And Adv Ill", wrvu: 0.00 },
 "G2100": { name: "Prothrombin Time 66+ Frailty And Medial Dem", wrvu: 0.00 },
 "G2101": { name: "Prothrombin Time 66+ Frailty And Adv Ill", wrvu: 0.00 },
 "G2105": { name: "Prothrombin Time 66+ Single Nucleotide Polymorphism Or Ltc Pos > 90d", wrvu: 0.00 },
 "G2106": { name: "Prothrombin Time 66+ Frailty And Medial Dem", wrvu: 0.00 },
 "G2107": { name: "Prothrombin Time 66+ Frailty And Adv Ill", wrvu: 0.00 },
 "G2112": { name: "Pred<=5 mg Ra Glu <6m", wrvu: 0.00 },
 "G2113": { name: "Pred>5 mg >6m, No Chg Da", wrvu: 0.00 },
 "G2115": { name: "Prothrombin Time 66-80 Frailty And Medial Dem", wrvu: 0.00 },
 "G2116": { name: "Prothrombin Time 66-80 Frailty And Adv Ill", wrvu: 0.00 },
 "G2118": { name: "Prothrombin Time 81+ Frailty", wrvu: 0.00 },
 "G2121": { name: "Psy Dilatation and Evacuation Procedure Anx Ap And Implantable Cardioverter-Defibrillator Asse", wrvu: 0.00 },
 "G2122": { name: "Psy/Dilatation and Evacuation Procedure/anx/apandicd Noasse", wrvu: 0.00 },
 "G2125": { name: "Prothrombin Time 81+ Frailty", wrvu: 0.00 },
 "G2126": { name: "Prothrombin Time 66-80 Frailty And Adv Ill", wrvu: 0.00 },
 "G2127": { name: "Prothrombin Time 66-80 Frailty And Medial Dem", wrvu: 0.00 },
 "G2128": { name: "No Aspirin Medial Rsn", wrvu: 0.00 },
 "G2129": { name: "No Bp Outpt", wrvu: 0.00 },
 "G2136": { name: "Bk Pain Vas 6-20wk <= 3", wrvu: 0.00 },
 "G2137": { name: "Bk Pain Vas 6-20wk > 3", wrvu: 0.00 },
 "G2138": { name: "Bk Pain Vas 9-15mo <= 3", wrvu: 0.00 },
 "G2139": { name: "Bk Pain Vas 9-15mo > 3", wrvu: 0.00 },
 "G2140": { name: "Leg Pain Vas 6-20wk <= 3", wrvu: 0.00 },
 "G2141": { name: "Leg Pain Vas 6-20wk > 3", wrvu: 0.00 },
 "G2142": { name: "Fs Odi 9-15mo Postop<= 22", wrvu: 0.00 },
 "G2143": { name: "Fs Odi 9-15mo > 22", wrvu: 0.00 },
 "G2144": { name: "Fs Odi 6-20wk Postop <= 22", wrvu: 0.00 },
 "G2145": { name: "Fsodi 6-20wk >22 Or Chg 30pt", wrvu: 0.00 },
 "G2146": { name: "Leg Pain Vas 9-15mo <= 3", wrvu: 0.00 },
 "G2147": { name: "Leg Pain Vas 9-15mo > 3", wrvu: 0.00 },
 "G2148": { name: "Mpm Used", wrvu: 0.00 },
 "G2149": { name: "No Mpm Medial Rsn", wrvu: 0.00 },
 "G2150": { name: "No Mpm", wrvu: 0.00 },
 "G2151": { name: "Diagnosis Degen Neuro", wrvu: 0.00 },
 "G2152": { name: "Res Change Subcutaneous >=0", wrvu: 0.00 },
 "G2167": { name: "Res Change Subcutaneous < 0", wrvu: 0.00 },
 "G2168": { name: "Svs By Prothrombin Time In Home Health", wrvu: 0.00 },
 "G2169": { name: "Svs By Occupational Therapy In Home Health", wrvu: 0.00 },
 "G2172": { name: "Treatment For Opioid Use Demo Proj", wrvu: 0.00 },
 "G2173": { name: "Uri W Comorb 12m Oth Diagnosis", wrvu: 0.00 },
 "G2174": { name: "Uri New Prescription Antibiotic 30d", wrvu: 0.00 },
 "G2175": { name: "Prothrombin Time Comorb Diagnosis 12m Of Epi", wrvu: 0.00 },
 "G2176": { name: "Outpt Emergency Department Obs W Inpt Admit", wrvu: 0.00 },
 "G2177": { name: "Bronch W Prescription Antibx 30d", wrvu: 0.00 },
 "G2178": { name: "Prothrombin Time Not Elig Low Neuro Ex", wrvu: 0.00 },
 "G2179": { name: "Medial Documentation Rsn No Low Ex", wrvu: 0.00 },
 "G2180": { name: "Inelig Footwr Evaluation", wrvu: 0.00 },
 "G2181": { name: "Bmi Not Documentation Medrsn Ptref", wrvu: 0.00 },
 "G2182": { name: "Prothrombin Time 1st Biolog Antirheum", wrvu: 0.00 },
 "G2183": { name: "Documentation Prothrombin Time Unable Comm", wrvu: 0.00 },
 "G2184": { name: "No Caregiver", wrvu: 0.00 },
 "G2185": { name: "Caregiver Dem Trained", wrvu: 0.00 },
 "G2186": { name: "Prothrombin Time Ref Application Rsrcs", wrvu: 0.00 },
 "G2187": { name: "Clin Ind Imaging Hd Trauma", wrvu: 0.00 },
 "G2188": { name: "Prothrombin Time 50 Years With Clin Ind Hd", wrvu: 0.00 },
 "G2189": { name: "Imaging Hd Abnml Neuro Exam", wrvu: 0.00 },
 "G2190": { name: "Ind Imaging Hd Radical Neck", wrvu: 0.00 },
 "G2191": { name: "Ind Imaging Hd Pos Hd Ache", wrvu: 0.00 },
 "G2192": { name: ">55 Years Temp Hd Ache", wrvu: 0.00 },
 "G2193": { name: "<6yr New Onset Hd Ache", wrvu: 0.00 },
 "G2194": { name: "New Hdache Ped Prothrombin Time Dis", wrvu: 0.00 },
 "G2195": { name: "Occip Hdache Child", wrvu: 0.00 },
 "G2196": { name: "Screen Unhlthy Etoh Use", wrvu: 0.00 },
 "G2197": { name: "Screen Hlthy Etoh Use", wrvu: 0.00 },
 "G2199": { name: "Not Scrn Etoh No Rsn", wrvu: 0.00 },
 "G2200": { name: "Unhlthy Etoh Rcvd Couns", wrvu: 0.00 },
 "G2202": { name: "No Rsn No Brief Couns", wrvu: 0.00 },
 "G2204": { name: "Prothrombin Time 45-85 W/ Scope", wrvu: 0.00 },
 "G2205": { name: "Preg Drng Adjv Trtmt", wrvu: 0.00 },
 "G2206": { name: "Adjv Trtmt Chemo HER2", wrvu: 0.00 },
 "G2207": { name: "Rsn No Trtmt Chem HER2", wrvu: 0.00 },
 "G2208": { name: "No Trtmt Chemo And HER2", wrvu: 0.00 },
 "G2209": { name: "Refused To Participate", wrvu: 0.00 },
 "G2210": { name: "No Neck Fs Prom No Rsn", wrvu: 0.00 },
 "G2211": { name: "Complex E and M Visit Add On", wrvu: 0.33 },
 "G2212": { name: "Prolong Outpt/office Vis", wrvu: 0.61 },
 "G2213": { name: "Initiat Medial Assist Treatment In Er", wrvu: 1.27 },
 "G2214": { name: "Init/sub Psych Care M 1st 30", wrvu: 0.77 },
 "G2215": { name: "Home Supply Nasal Naloxone", wrvu: 0.00 },
 "G2216": { name: "Home Supply Inject Naloxon", wrvu: 0.00 },
 "G2250": { name: "Remot Imaging Sub By Patient, Non E and M", wrvu: 0.18 },
 "G2251": { name: "Brief Chkin, 5-10, Non-E and M", wrvu: 0.25 },
 "G2252": { name: "Brief Chkin By Md/Qualified Health Professional, 11-20", wrvu: 0.50 },
 "G3002": { name: "Chronic Pain Management 30 Mins", wrvu: 1.45 },
 "G3003": { name: "Chronic Pain Management Additional 15m", wrvu: 0.50 },
 "G4000": { name: "Dermatology Ss", wrvu: 0.00 },
 "G4001": { name: "Diagnostic Radical Ss", wrvu: 0.00 },
 "G4002": { name: "Electrophysiology Cardio Ss", wrvu: 0.00 },
 "G4003": { name: "Emergency Medial Ss", wrvu: 0.00 },
 "G4004": { name: "Endocrinology Ss", wrvu: 0.00 },
 "G4005": { name: "Family Medicine Ss", wrvu: 0.00 },
 "G4006": { name: "Gastroenterology Ss", wrvu: 0.00 },
 "G4007": { name: "General Surgery Ss", wrvu: 0.00 },
 "G4008": { name: "Geriatrics Ss", wrvu: 0.00 },
 "G4009": { name: "Hospitalists Ss", wrvu: 0.00 },
 "G4010": { name: "Infectious Disease Ss", wrvu: 0.00 },
 "G4011": { name: "Internal Medicine Ss", wrvu: 0.00 },
 "G4012": { name: "Interventional Radical Ss", wrvu: 0.00 },
 "G4013": { name: "Mntal/Behavioral/psych Hlth Ss", wrvu: 0.00 },
 "G4014": { name: "Nephrology Ss", wrvu: 0.00 },
 "G4015": { name: "Neurology Ss", wrvu: 0.00 },
 "G4016": { name: "Neurosurgical Ss", wrvu: 0.00 },
 "G4017": { name: "Nutrition/dietician Ss", wrvu: 0.00 },
 "G4018": { name: "Ob/gyn Ss", wrvu: 0.00 },
 "G4019": { name: "Oncology/hema Ss", wrvu: 0.00 },
 "G4020": { name: "Ophthalmology/optometry Ss", wrvu: 0.00 },
 "G4021": { name: "Orthopedic Surgery Ss", wrvu: 0.00 },
 "G4022": { name: "Otolaryngology Ss", wrvu: 0.00 },
 "G4023": { name: "Pathology Ss", wrvu: 0.00 },
 "G4024": { name: "Pediatrics Ss", wrvu: 0.00 },
 "G4025": { name: "Physical Medicine Ss", wrvu: 0.00 },
 "G4026": { name: "Phys/occ Therapy Ss", wrvu: 0.00 },
 "G4027": { name: "Plastic Surgery Ss", wrvu: 0.00 },
 "G4028": { name: "Podiatry Ss", wrvu: 0.00 },
 "G4029": { name: "Preventive Medicine Ss", wrvu: 0.00 },
 "G4030": { name: "Pulmonology Ss", wrvu: 0.00 },
 "G4031": { name: "Radiation Oncology Ss", wrvu: 0.00 },
 "G4032": { name: "Rheumatology Ss", wrvu: 0.00 },
 "G4033": { name: "Skilled Nursing Facility Ss", wrvu: 0.00 },
 "G4034": { name: "Speech Language Pathology Ss", wrvu: 0.00 },
 "G4035": { name: "Thoracic Surgery Ss", wrvu: 0.00 },
 "G4036": { name: "Urgent Care Ss", wrvu: 0.00 },
 "G4037": { name: "Urology Ss", wrvu: 0.00 },
 "G4038": { name: "Vascular Surgery Ss", wrvu: 0.00 },
 "G8395": { name: "Lvef>=40% Documentation Normal Or Mild", wrvu: 0.00 },
 "G8396": { name: "Lvef Not Performed", wrvu: 0.00 },
 "G8397": { name: "Dil Macula/fundus Exam/w Documentation", wrvu: 0.00 },
 "G8399": { name: "Prothrombin Time With Dxa Results Document", wrvu: 0.00 },
 "G8400": { name: "Prothrombin Time With Dxa No Results Documentation", wrvu: 0.00 },
 "G8404": { name: "Low Extemity Neur Exam Docum", wrvu: 0.00 },
 "G8405": { name: "Low Extemity Neur Not Perfor", wrvu: 0.00 },
 "G8410": { name: "Evaluation On Foot Documented", wrvu: 0.00 },
 "G8415": { name: "Evaluation On Foot Not Performed", wrvu: 0.00 },
 "G8416": { name: "Prothrombin Time Inelig Footwear Evaluatio", wrvu: 0.00 },
 "G8417": { name: "Calc Bmi Abv Up Param Follow-up", wrvu: 0.00 },
 "G8418": { name: "Calc Bmi Blw Low Param Follow-up", wrvu: 0.00 },
 "G8419": { name: "Calc Bmi Out Nrm Param Nof/u", wrvu: 0.00 },
 "G8420": { name: "Calc Bmi Norm Parameters", wrvu: 0.00 },
 "G8421": { name: "Bmi Not Calculated", wrvu: 0.00 },
 "G8427": { name: "Docrev Cur Meds By Elig Clin", wrvu: 0.00 },
 "G8428": { name: "Cur Meds Not Document", wrvu: 0.00 },
 "G8430": { name: "Documentation Medial Rsn No Medrec", wrvu: 0.00 },
 "G8431": { name: "Pos Clin Depres Scrn Follow-up Documentation", wrvu: 0.00 },
 "G8432": { name: "Dilatation and Evacuation Procedure Scr Not Documentation, Rng", wrvu: 0.00 },
 "G8433": { name: "Scr For Dilatation and Evacuation Procedure Not Cpt Documentation Rsn", wrvu: 0.00 },
 "G8450": { name: "Beta-bloc Prescription Prothrombin Time With Abn Lvef", wrvu: 0.00 },
 "G8451": { name: "Prothrombin Time With Abn Lvef Inelig B-bloc", wrvu: 0.00 },
 "G8452": { name: "Prothrombin Time With Abn Lvef B-bloc No Prescription", wrvu: 0.00 },
 "G8465": { name: "High Risk Recurrence Pro Ca", wrvu: 0.00 },
 "G8473": { name: "Ace/arb Thxpy Prescription'd", wrvu: 0.00 },
 "G8474": { name: "Ace/arb Not Prescription'd; Documentation Reas", wrvu: 0.00 },
 "G8475": { name: "Ace/arb Thxpy Not Prescription'd", wrvu: 0.00 },
 "G8476": { name: "Bp System <140 And Dias <90", wrvu: 0.00 },
 "G8477": { name: "Bp System>=140 And/or Dias >=90", wrvu: 0.00 },
 "G8478": { name: "Bp Not Performed/Documentation", wrvu: 0.00 },
 "G8510": { name: "Scr Dilatation and Evacuation Procedure Neg, No Plan Reqd", wrvu: 0.00 },
 "G8511": { name: "Scr Dilatation and Evacuation Procedure Pos, No Plan Documentation Rng", wrvu: 0.00 },
 "G8535": { name: "Eld Maltreatment Not Documentation", wrvu: 0.00 },
 "G8536": { name: "No Documentation Elder Malignant Scrn", wrvu: 0.00 },
 "G8539": { name: "Documentation Funct And Care Plan", wrvu: 0.00 },
 "G8540": { name: "Foa Not Documentation As Being Perf", wrvu: 0.00 },
 "G8541": { name: "No Documentation Cur Funct Assess", wrvu: 0.00 },
 "G8542": { name: "Documentation Funct No Deficiencies", wrvu: 0.00 },
 "G8543": { name: "Cur Funct Asses; No Care Pln", wrvu: 0.00 },
 "G8559": { name: "Prothrombin Time Ref Documentation Oto Evaluation", wrvu: 0.00 },
 "G8560": { name: "Prothrombin Time History Act Drain Prev 90 Days", wrvu: 0.00 },
 "G8561": { name: "Prothrombin Time Inelig For Ref Oto Evaluation", wrvu: 0.00 },
 "G8562": { name: "Prothrombin Time No History Act Drain 90 D", wrvu: 0.00 },
 "G8563": { name: "Prothrombin Time No Ref Oto Reas No Specimen", wrvu: 0.00 },
 "G8564": { name: "Prothrombin Time Ref Oto Evaluation", wrvu: 0.00 },
 "G8565": { name: "Ver Documentation Hear Loss", wrvu: 0.00 },
 "G8566": { name: "Prothrombin Time Inelig Ref Oto Evaluation", wrvu: 0.00 },
 "G8567": { name: "Prothrombin Time No Documentation Hear Loss", wrvu: 0.00 },
 "G8568": { name: "Prothrombin Time No Ref Otolo No Specimen", wrvu: 0.00 },
 "G8569": { name: "Prol Intubation Req", wrvu: 0.00 },
 "G8570": { name: "No Prol Intub Req", wrvu: 0.00 },
 "G8575": { name: "Postop Ren Fail", wrvu: 0.00 },
 "G8576": { name: "No Postop Ren Fail", wrvu: 0.00 },
 "G8577": { name: "Reop Req Bld Graft Oth", wrvu: 0.00 },
 "G8578": { name: "No Reop Req Bld Graft Oth", wrvu: 0.00 },
 "G8598": { name: "Asa/antiplat Therapeutic Used", wrvu: 0.00 },
 "G8599": { name: "No Asa/antiplat Therapeutic Use Rng", wrvu: 0.00 },
 "G8600": { name: "Tpa Initi With In 4.5 Hr", wrvu: 0.00 },
 "G8601": { name: "No Elig Tpa Init With In 4.5 Hr", wrvu: 0.00 },
 "G8602": { name: "No Tpa Init With In 4.5 Hr", wrvu: 0.00 },
 "G8633": { name: "Pharm Therapeutic Osteo Prescription", wrvu: 0.00 },
 "G8635": { name: "No Pharm Therapeutic Osteo Prescription", wrvu: 0.00 },
 "G8647": { name: "Rafscrs Ki Scor >= 0", wrvu: 0.00 },
 "G8648": { name: "Rafscrs Ki Scor < 0", wrvu: 0.00 },
 "G8650": { name: "Rafs Crs Ki No Scor No Rsn", wrvu: 0.00 },
 "G8651": { name: "Rafscrs High Scor >=0", wrvu: 0.00 },
 "G8652": { name: "Rafscrs High Scor < 0", wrvu: 0.00 },
 "G8654": { name: "Rafs Crs High No Scor No Surv", wrvu: 0.00 },
 "G8655": { name: "Rafscrs Llfai Scor >= 0", wrvu: 0.00 },
 "G8656": { name: "Rafscrs Llfai Scor < 0", wrvu: 0.00 },
 "G8658": { name: "Rafscrs Llfai No Scor + Surv", wrvu: 0.00 },
 "G8659": { name: "Rafscrs Lbi Scor >= 0", wrvu: 0.00 },
 "G8660": { name: "Rafscrs Lbi Scor < 0", wrvu: 0.00 },
 "G8661": { name: "Rafscrs Lbi No Scor", wrvu: 0.00 },
 "G8662": { name: "Rafs Crs Lbi No Scor No Surv", wrvu: 0.00 },
 "G8663": { name: "Rafscrs Si Scor >= 0", wrvu: 0.00 },
 "G8664": { name: "Rafscrs Si Scor < 0", wrvu: 0.00 },
 "G8666": { name: "Rafs Crs Si No Scor No Surv", wrvu: 0.00 },
 "G8667": { name: "Rafscrs Ewh Scor >= 0", wrvu: 0.00 },
 "G8668": { name: "Rafscrs Ewh Scor < 0", wrvu: 0.00 },
 "G8670": { name: "Rafs Crs Ewh No Scor No Surv", wrvu: 0.00 },
 "G8694": { name: "Lvef <=40%", wrvu: 0.00 },
 "G8708": { name: "Antibiotic Not Pressure", wrvu: 0.00 },
 "G8709": { name: "Uri Electrophysiology Compete Diagnostic", wrvu: 0.00 },
 "G8710": { name: "Prothrombin Time Pressure Antibiotic", wrvu: 0.00 },
 "G8711": { name: "Pressure Antibx On/within 3 Day", wrvu: 0.00 },
 "G8712": { name: "Not Pressure Antibiotic", wrvu: 0.00 },
 "G8721": { name: "Patient, Pn, Hist Grade Documentation", wrvu: 0.00 },
 "G8722": { name: "Medial Reas Patient, Pn, Not Documentation", wrvu: 0.00 },
 "G8723": { name: "Specimen Sit Not Prim Tumor", wrvu: 0.00 },
 "G8724": { name: "Patient, Pn, Hist Grade Not Documentation", wrvu: 0.00 },
 "G8733": { name: "Documentation Pos Elder Malignant Scrn Plan", wrvu: 0.00 },
 "G8734": { name: "Documentation Neg Eld Req", wrvu: 0.00 },
 "G8735": { name: "Eld Malignant Scrn Pos No Plan", wrvu: 0.00 },
 "G8749": { name: "No Signs Melanoma", wrvu: 0.00 },
 "G8752": { name: "System Bp Less 140", wrvu: 0.00 },
 "G8753": { name: "System Bp > Or = 140", wrvu: 0.00 },
 "G8754": { name: "Dias Bp Less 90", wrvu: 0.00 },
 "G8755": { name: "Dias Bp > Or = 90", wrvu: 0.00 },
 "G8756": { name: "No Bp Measure Documentation", wrvu: 0.00 },
 "G8783": { name: "Bp Scrn Perf Rec Interval", wrvu: 0.00 },
 "G8785": { name: "Bp Scrn No Perf At Interval", wrvu: 0.00 },
 "G8797": { name: "Specimen Site Not Esophagus", wrvu: 0.00 },
 "G8798": { name: "Specimen Site Not Prostate", wrvu: 0.00 },
 "G8806": { name: "Perf Ultrasound To Lct Preg Documentation", wrvu: 0.00 },
 "G8807": { name: "No Ta Tv Ultrasound", wrvu: 0.00 },
 "G8808": { name: "Ultrasound Not Perf, Rng", wrvu: 0.00 },
 "G8815": { name: "Documentation Reas No Statin Therapy", wrvu: 0.00 },
 "G8816": { name: "Statin Medial Pressure At Disch", wrvu: 0.00 },
 "G8817": { name: "Documentation Reas No Statin Medial Disch", wrvu: 0.00 },
 "G8826": { name: "Prothrombin Time Disch Home Day #2 Evar", wrvu: 0.00 },
 "G8833": { name: "Prothrombin Time Not Disch Home Day#2 Evar", wrvu: 0.00 },
 "G8834": { name: "Prothrombin Time Disch Home Day #2 Cea", wrvu: 0.00 },
 "G8838": { name: "Not Disch Home By Day #2", wrvu: 0.00 },
 "G8839": { name: "Sleep Apnea Assess", wrvu: 0.00 },
 "G8840": { name: "Documentation Reas No Sleep Apnea", wrvu: 0.00 },
 "G8841": { name: "No Sleep Apnea Assess", wrvu: 0.00 },
 "G8842": { name: "Ahi Rdi Rei Documentation Win 2mo", wrvu: 0.00 },
 "G8843": { name: "Documentation Reas No Ahi Rdi Rei", wrvu: 0.00 },
 "G8844": { name: "No Ahi Rdi Rei Ini Diagnosis No Rsn", wrvu: 0.00 },
 "G8845": { name: "Pos Airway Pressure Prescribed", wrvu: 0.00 },
 "G8846": { name: "Moderate Or Severe Osa", wrvu: 0.00 },
 "G8849": { name: "Documentation Reas No Pos Air Pressure", wrvu: 0.00 },
 "G8850": { name: "No Pap Smear Prescribed", wrvu: 0.00 },
 "G8851": { name: "Adhere Treatment Assess At Lst Ann", wrvu: 0.00 },
 "G8854": { name: "Reas No Adhere Therapy", wrvu: 0.00 },
 "G8855": { name: "Therapeutic Not Assessed Annually", wrvu: 0.00 },
 "G8856": { name: "Ref For Oto Evaluation", wrvu: 0.00 },
 "G8857": { name: "No Elig Ref For Oto Evaluation", wrvu: 0.00 },
 "G8858": { name: "Not Ref For Oto Evaluation", wrvu: 0.00 },
 "G8863": { name: "No Assess Bone Loss", wrvu: 0.00 },
 "G8864": { name: "Pneumococcal Vaccine Administration", wrvu: 0.00 },
 "G8865": { name: "Documentation Medial Reas No Pneumococcal", wrvu: 0.00 },
 "G8866": { name: "Documentation Prothrombin Time Reas No Pneumococcal", wrvu: 0.00 },
 "G8867": { name: "No Pneumococcal Administration", wrvu: 0.00 },
 "G8869": { name: "Documentation Immune Hep B Antitnf", wrvu: 0.00 },
 "G8875": { name: "Breast Cancer Diagnosis minutes Invsive", wrvu: 0.00 },
 "G8876": { name: "Documentation Reas No minutes Inv Diagnosis", wrvu: 0.00 },
 "G8877": { name: "No Breast Cncr Diagnosis minutes Invasive", wrvu: 0.00 },
 "G8878": { name: "Sent Lymphatic Node Biopsy", wrvu: 0.00 },
 "G8880": { name: "Sen Lym P Node Biop Not Perf", wrvu: 0.00 },
 "G8881": { name: "Breast Cncr Stage > T1n0m0", wrvu: 0.00 },
 "G8882": { name: "No Sent Lymphatic Node Biopsy", wrvu: 0.00 },
 "G8907": { name: "Prothrombin Time Documentation No Events On Discharg", wrvu: 0.00 },
 "G8908": { name: "Prothrombin Time Documentation W Burn Prior To Discharge", wrvu: 0.00 },
 "G8909": { name: "Prothrombin Time Documentation No Burn Prior To Discharge", wrvu: 0.00 },
 "G8910": { name: "Prothrombin Time Documentation To Have Fall In Asc", wrvu: 0.00 },
 "G8911": { name: "Prothrombin Time Documentation No Fall In Asc", wrvu: 0.00 },
 "G8912": { name: "Prothrombin Time Documentation With Wrong Event", wrvu: 0.00 },
 "G8913": { name: "Prothrombin Time Documentation No Wrong Event", wrvu: 0.00 },
 "G8914": { name: "Prothrombin Time Trans To Hospital Posterior Discharge", wrvu: 0.00 },
 "G8915": { name: "Prothrombin Time Not Trans To Hospital At Discharge", wrvu: 0.00 },
 "G8916": { name: "Prothrombin Time W Intravenous Ab Given On Time", wrvu: 0.00 },
 "G8917": { name: "Prothrombin Time W Intravenous Ab Not Given On Time", wrvu: 0.00 },
 "G8918": { name: "Prothrombin Time Without Preop Order Intravenous Ab Pro", wrvu: 0.00 },
 "G8923": { name: "Lvef <= 40% Or Lvsd", wrvu: 0.00 },
 "G8924": { name: "Spir Res Documentation Fev1/fvc<70%", wrvu: 0.00 },
 "G8934": { name: "Lvef <=40% Or Dilatation and Evacuation Procedure Lv System Fcn", wrvu: 0.00 },
 "G8935": { name: "Prescription Ace Or Arb Therapy", wrvu: 0.00 },
 "G8936": { name: "Prothrombin Time Not Eligible Ace/arb", wrvu: 0.00 },
 "G8937": { name: "No Prescription Ace/arb Therapy", wrvu: 0.00 },
 "G8942": { name: "Documentation Fcn/care Plan With 30 Days", wrvu: 0.00 },
 "G8944": { name: "Ajcc Mel Cnr Stg 0 - Iic", wrvu: 0.00 },
 "G8946": { name: "Mibm But No Diagnosis Of Breast Ca", wrvu: 0.00 },
 "G8950": { name: "Pre-htn Or Htn Documentation, Follow-up Indc", wrvu: 0.00 },
 "G8952": { name: "Pre-htn/htn, No Follow-up, Not Gvn", wrvu: 0.00 },
 "G8955": { name: "Most Recent Assess Vol Management", wrvu: 0.00 },
 "G8956": { name: "Prothrombin Time Rcv Hedia Outpt Dyls Fac", wrvu: 0.00 },
 "G8958": { name: "Assess Vol Management Not Documentation", wrvu: 0.00 },
 "G8961": { name: "Csit Lowrisk Surgery Pts Preop", wrvu: 0.00 },
 "G8962": { name: "Csit On Prothrombin Time Any Reas 30 Days", wrvu: 0.00 },
 "G8967": { name: "Warf Or Other Fda Drug Presc", wrvu: 0.00 },
 "G8968": { name: "Documentation Medial Not Presb", wrvu: 0.00 },
 "G8969": { name: "Documentation Prothrombin Time Rsn No Presc Warf/fda", wrvu: 0.00 },
 "G8970": { name: "No Rsk Fac Or 1 Moderate Risk Te", wrvu: 0.00 },
 "G9001": { name: "Mccd, Initial Rate", wrvu: 0.00 },
 "G9002": { name: "Mccd,maintenance Rate", wrvu: 0.00 },
 "G9003": { name: "Mccd, Risk Adjustment High, Initial", wrvu: 0.00 },
 "G9004": { name: "Mccd, Risk Adjustment Lo, Initial", wrvu: 0.00 },
 "G9005": { name: "Mccd, Risk Adjustment, Maintenance", wrvu: 0.00 },
 "G9006": { name: "Mccd, Home Monitoring", wrvu: 0.00 },
 "G9007": { name: "Mccd, Sch Team Conf", wrvu: 0.00 },
 "G9008": { name: "Mccd,phys Coor-care Ovrsght", wrvu: 0.00 },
 "G9009": { name: "Mccd, Risk Adjustment, Level 3", wrvu: 0.00 },
 "G9010": { name: "Mccd, Risk Adjustment, Level 4", wrvu: 0.00 },
 "G9011": { name: "Mccd, Risk Adjustment, Level 5", wrvu: 0.00 },
 "G9012": { name: "Other Specified Case Management", wrvu: 0.00 },
 "G9013": { name: "Esrd Demo Bundle Level I", wrvu: 0.00 },
 "G9014": { name: "Esrd Demo Bundle-level Ii", wrvu: 0.00 },
 "G9016": { name: "Demo-smoking Cessation Coun", wrvu: 0.00 },
 "G9050": { name: "Oncology Work-up Evaluation", wrvu: 0.00 },
 "G9051": { name: "Oncology Treatment Decision-Management", wrvu: 0.00 },
 "G9052": { name: "Oncology Surveillance For Disease", wrvu: 0.00 },
 "G9053": { name: "Oncology Expectant Management Patient", wrvu: 0.00 },
 "G9054": { name: "Oncology Supervision Palliative", wrvu: 0.00 },
 "G9055": { name: "Oncology Visit Unspecified Not Otherwise Specified", wrvu: 0.00 },
 "G9056": { name: "Oncology Prac Management Adheres Guide", wrvu: 0.00 },
 "G9057": { name: "Oncology Pract Management Differs Trial", wrvu: 0.00 },
 "G9058": { name: "Oncology Prac Management Disagree With Gui", wrvu: 0.00 },
 "G9059": { name: "Oncology Prac Management Prothrombin Time Opt Alterna", wrvu: 0.00 },
 "G9060": { name: "Oncology Prac Management Dif Prothrombin Time Comorb", wrvu: 0.00 },
 "G9061": { name: "Oncology Prac Cond Noadd By Guide", wrvu: 0.00 },
 "G9062": { name: "Oncology Prac Guide Differs Not Otherwise Specified", wrvu: 0.00 },
 "G9063": { name: "Oncology Diagnosis Nsclc Stgi No Progres", wrvu: 0.00 },
 "G9064": { name: "Oncology Diagnosis Nsclc Stg2 No Progres", wrvu: 0.00 },
 "G9065": { name: "Oncology Diagnosis Nsclc Stg3a No Progre", wrvu: 0.00 },
 "G9066": { name: "Oncology Diagnosis Nsclc Stg3b-4 Metasta", wrvu: 0.00 },
 "G9067": { name: "Oncology Diagnosis Nsclc Diagnosis Unknown Not Otherwise Specified", wrvu: 0.00 },
 "G9068": { name: "Oncology Diagnosis Sclc/nsclc Limited", wrvu: 0.00 },
 "G9069": { name: "Oncology Diagnosis Sclc/nsclc External At Diagnosis", wrvu: 0.00 },
 "G9070": { name: "Oncology Diagnosis Sclc/nsclc External Unknwn", wrvu: 0.00 },
 "G9071": { name: "Oncology Diagnosis Breast Stg1-2b hr,nopro", wrvu: 0.00 },
 "G9072": { name: "Oncology Diagnosis Breast Stg1-2 Noprogres", wrvu: 0.00 },
 "G9073": { name: "Oncology Diagnosis Breast Stg3-hr, No Pro", wrvu: 0.00 },
 "G9074": { name: "Oncology Diagnosis Breast Stg3-noprogress", wrvu: 0.00 },
 "G9075": { name: "Oncology Diagnosis Breast Metastic/ Recur", wrvu: 0.00 },
 "G9077": { name: "Oncology Diagnosis Prostate T1no Progres", wrvu: 0.00 },
 "G9078": { name: "Oncology Diagnosis Prostate T2no Progres", wrvu: 0.00 },
 "G9079": { name: "Oncology Diagnosis Prostate T3b-t4noprog", wrvu: 0.00 },
 "G9080": { name: "Oncology Diagnosis Prostate With Rise PSA", wrvu: 0.00 },
 "G9083": { name: "Oncology Diagnosis Prostate Unknwn Not Otherwise Specified", wrvu: 0.00 },
 "G9084": { name: "Oncology Diagnosis Colon T1-3,n1-2,no Pr", wrvu: 0.00 },
 "G9085": { name: "Oncology Diagnosis Colon T4, N0 Without Prog", wrvu: 0.00 },
 "G9086": { name: "Oncology Diagnosis Colon T1-4 No Diagnosis Prog", wrvu: 0.00 },
 "G9087": { name: "Oncology Diagnosis Colon Metas Evid Diagnosis", wrvu: 0.00 },
 "G9088": { name: "Oncology Diagnosis Colon Metas Noevid Diagnosis", wrvu: 0.00 },
 "G9089": { name: "Oncology Diagnosis Colon Extent Unknown", wrvu: 0.00 },
 "G9090": { name: "Oncology Diagnosis Rectal T1-2 No Progr", wrvu: 0.00 },
 "G9091": { name: "Oncology Diagnosis Rectal T3 N0 No Prog", wrvu: 0.00 },
 "G9092": { name: "Oncology Diagnosis Rectal T1-3,n1-2noprg", wrvu: 0.00 },
 "G9093": { name: "Oncology Diagnosis Rectal T4,n,m0 No Prg", wrvu: 0.00 },
 "G9094": { name: "Oncology Diagnosis Rectal M1 With Metastasis Prog", wrvu: 0.00 },
 "G9095": { name: "Oncology Diagnosis Rectal Extent Unknwn", wrvu: 0.00 },
 "G9096": { name: "Oncology Diagnosis Esophag T1-t3 Noprog", wrvu: 0.00 },
 "G9097": { name: "Oncology Diagnosis Esophageal T4 No Prog", wrvu: 0.00 },
 "G9098": { name: "Oncology Diagnosis Esophageal Metastasis Recur", wrvu: 0.00 },
 "G9099": { name: "Oncology Diagnosis Esophageal Unknown", wrvu: 0.00 },
 "G9100": { name: "Oncology Diagnosis Gastric No Recurrence", wrvu: 0.00 },
 "G9101": { name: "Oncology Diagnosis Gastric P R1-r2noprog", wrvu: 0.00 },
 "G9102": { name: "Oncology Diagnosis Gastric Unresectable", wrvu: 0.00 },
 "G9103": { name: "Oncology Diagnosis Gastric Recurrent", wrvu: 0.00 },
 "G9104": { name: "Oncology Diagnosis Gastric Unknown Not Otherwise Specified", wrvu: 0.00 },
 "G9105": { name: "Oncology Diagnosis Pancreatc P R0 Res No", wrvu: 0.00 },
 "G9106": { name: "Oncology Diagnosis Pancreatc P R1/r2 No", wrvu: 0.00 },
 "G9107": { name: "Oncology Diagnosis Pancreatic Unresectab", wrvu: 0.00 },
 "G9108": { name: "Oncology Diagnosis Pancreatic Unknwn Not Otherwise Specified", wrvu: 0.00 },
 "G9109": { name: "Oncology Diagnosis Head/neck T1-t2no Prg", wrvu: 0.00 },
 "G9110": { name: "Oncology Diagnosis Head/neck T3-4 Noprog", wrvu: 0.00 },
 "G9111": { name: "Oncology Diagnosis Head/neck M1 Metastasis Rec", wrvu: 0.00 },
 "G9112": { name: "Oncology Diagnosis Head/neck External Unknown", wrvu: 0.00 },
 "G9113": { name: "Oncology Diagnosis Ovarian Stg1a-b No Pr", wrvu: 0.00 },
 "G9114": { name: "Oncology Diagnosis Ovarian Stg1a-b Or 2", wrvu: 0.00 },
 "G9115": { name: "Oncology Diagnosis Ovarian Stg3/4 Noprog", wrvu: 0.00 },
 "G9116": { name: "Oncology Diagnosis Ovarian Recurrence", wrvu: 0.00 },
 "G9117": { name: "Oncology Diagnosis Ovarian Unknown Not Otherwise Specified", wrvu: 0.00 },
 "G9123": { name: "Oncology Diagnosis Chronic Myeloid Leukemia Chronic Phase", wrvu: 0.00 },
 "G9124": { name: "Oncology Diagnosis Chronic Myeloid Leukemia Acceler Phase", wrvu: 0.00 },
 "G9125": { name: "Oncology Diagnosis Chronic Myeloid Leukemia Blast Phase", wrvu: 0.00 },
 "G9126": { name: "Oncology Diagnosis Chronic Myeloid Leukemia Remission", wrvu: 0.00 },
 "G9128": { name: "Oncology Diagnosis Multi Myeloma Stage I", wrvu: 0.00 },
 "G9129": { name: "Oncology Diagnosis Mult Myeloma Stg2 Hig", wrvu: 0.00 },
 "G9130": { name: "Oncology Diagnosis Multi Myeloma Unknown", wrvu: 0.00 },
 "G9131": { name: "Oncology Diagnosis Breast Unknown Not Otherwise Specified", wrvu: 0.00 },
 "G9132": { name: "Oncology Diagnosis Prostate Metastasis No Cast", wrvu: 0.00 },
 "G9133": { name: "Oncology Diagnosis Prostate Clinical Met", wrvu: 0.00 },
 "G9134": { name: "Oncology Nhlstg 1-2 No Relap No", wrvu: 0.00 },
 "G9135": { name: "Oncology Diagnosis Non-Hodgkin Lymphoma Stg 3-4 Not Relap", wrvu: 0.00 },
 "G9136": { name: "Oncology Diagnosis Non-Hodgkin Lymphoma Trans To Lg Bcell", wrvu: 0.00 },
 "G9137": { name: "Oncology Diagnosis Non-Hodgkin Lymphoma Relapse/refractor", wrvu: 0.00 },
 "G9138": { name: "Oncology Diagnosis Non-Hodgkin Lymphoma Stg Unknown", wrvu: 0.00 },
 "G9139": { name: "Oncology Diagnosis Chronic Myeloid Leukemia Diagnosis Status Unknown", wrvu: 0.00 },
 "G9140": { name: "Frontier Extended Stay Demo", wrvu: 0.00 },
 "G9143": { name: "Warfarin Respon Genetic Test", wrvu: 0.00 },
 "G9147": { name: "Outpt Intravenous Insulin Treatment Any Mea", wrvu: 0.00 },
 "G9148": { name: "Medical Home Level 1", wrvu: 0.00 },
 "G9149": { name: "Medical Home Level Ii", wrvu: 0.00 },
 "G9150": { name: "Medical Home Level Iii", wrvu: 0.00 },
 "G9151": { name: "Mapcp Demo State", wrvu: 0.00 },
 "G9152": { name: "Mapcp Demo Community", wrvu: 0.00 },
 "G9153": { name: "Mapcp Demo Physician", wrvu: 0.00 },
 "G9156": { name: "Evaluation For Wheelchair", wrvu: 0.00 },
 "G9157": { name: "Transesoph Doppler Cardiac Mon", wrvu: 2.15 },
 "G9187": { name: "Bpci Home Visit", wrvu: 0.18 },
 "G9188": { name: "Beta Not Given No Reason", wrvu: 0.00 },
 "G9189": { name: "Beta Pressure Or Already Taking", wrvu: 0.00 },
 "G9190": { name: "Medical Reason For No Beta", wrvu: 0.00 },
 "G9191": { name: "Prothrombin Time Reason For No Beta", wrvu: 0.00 },
 "G9212": { name: "Documentation Of Dsm-intravenous Init Evaluation", wrvu: 0.00 },
 "G9213": { name: "No Documentation Of Dsm-intravenous", wrvu: 0.00 },
 "G9223": { name: "Pjp Prophylactic Ordered Cd4 Low", wrvu: 0.00 },
 "G9225": { name: "Norsn No Foot Exam", wrvu: 0.00 },
 "G9226": { name: "3 Comp Foot Exam Completed", wrvu: 0.00 },
 "G9227": { name: "Foa Documentation, Care Plan Not Documentation", wrvu: 0.00 },
 "G9228": { name: "Gonorrhea Chl Syp Documented", wrvu: 0.00 },
 "G9230": { name: "Norsn For Gonorrhea Chl Syp Test", wrvu: 0.00 },
 "G9231": { name: "Documentation Esrd Dia Trans Preg", wrvu: 0.00 },
 "G9242": { name: "Documentation Viral Load >=200", wrvu: 0.00 },
 "G9243": { name: "Documentation Viral Load <200", wrvu: 0.00 },
 "G9246": { name: "No Enc Or Enc/vir Ld 90days", wrvu: 0.00 },
 "G9247": { name: "2 Enc Enc/vir Ld 90d", wrvu: 0.00 },
 "G9254": { name: "Documentation Prothrombin Time Dischg >2d", wrvu: 0.00 },
 "G9255": { name: "Prothrombin Time Dc Home 2nd Po Day", wrvu: 0.00 },
 "G9273": { name: "System<140 And Dia<90", wrvu: 0.00 },
 "G9274": { name: "Bp Out Of Nrml Limits", wrvu: 0.00 },
 "G9275": { name: "Documentation Of Non Tobacco User", wrvu: 0.00 },
 "G9276": { name: "Documentation Of Tobacco User", wrvu: 0.00 },
 "G9277": { name: "Documentation Daily Aspirin Or Contra", wrvu: 0.00 },
 "G9278": { name: "Documentation No Daily Aspirin", wrvu: 0.00 },
 "G9279": { name: "Pne Scrn Done Documentation Vac Done", wrvu: 0.00 },
 "G9280": { name: "Pne Not Given Norsn", wrvu: 0.00 },
 "G9281": { name: "Pne Scrn Done Documentation Not Ind", wrvu: 0.00 },
 "G9282": { name: "Documentation Medrsn No Histology Type", wrvu: 0.00 },
 "G9283": { name: "Hist Type Documentation On Report", wrvu: 0.00 },
 "G9284": { name: "No Hist Type Documentation On Report", wrvu: 0.00 },
 "G9285": { name: "Site Not Small Cell Lung Ca", wrvu: 0.00 },
 "G9286": { name: "Antibio Prescription W In 10d Of Sympt", wrvu: 0.00 },
 "G9287": { name: "No Antibio W In 10d Of Sympt", wrvu: 0.00 },
 "G9288": { name: "Documentation Medrsn No Hist Type Rpt", wrvu: 0.00 },
 "G9289": { name: "Documentation Type Nsm Lung Ca", wrvu: 0.00 },
 "G9290": { name: "No Documentation Type Nsm Lung Ca", wrvu: 0.00 },
 "G9291": { name: "Not Nsm Lung Ca", wrvu: 0.00 },
 "G9292": { name: "Medrsn No Prothrombin Time Category", wrvu: 0.00 },
 "G9293": { name: "No Prothrombin Time Category On Report", wrvu: 0.00 },
 "G9294": { name: "Prothrombin Time Cat And Thck On Report", wrvu: 0.00 },
 "G9295": { name: "Non Cutaneous Loc", wrvu: 0.00 },
 "G9296": { name: "Documentation Share Decubitus Prior Procedure", wrvu: 0.00 },
 "G9297": { name: "No Documentation Share Decubitus Prior Procedure", wrvu: 0.00 },
 "G9298": { name: "Evaluation Risk Vte Card 30d Prior", wrvu: 0.00 },
 "G9299": { name: "No Evaluation Risk Vte Card Prior", wrvu: 0.00 },
 "G9305": { name: "No Interv Req For Leak", wrvu: 0.00 },
 "G9306": { name: "Interv Req For Leak", wrvu: 0.00 },
 "G9307": { name: "No Ret For Surgery W In 30d", wrvu: 0.00 },
 "G9308": { name: "Unpl Ret Or With Compl With In 30d", wrvu: 0.00 },
 "G9309": { name: "No Unplnd Hospital Readm In 30d", wrvu: 0.00 },
 "G9310": { name: "Unplnd Hospital Readm In 30d", wrvu: 0.00 },
 "G9311": { name: "No Surgery Site Infection", wrvu: 0.00 },
 "G9312": { name: "Surgical Site Infection", wrvu: 0.00 },
 "G9313": { name: "Amoxic Not Presc As 1st Line", wrvu: 0.00 },
 "G9314": { name: "Norsn Not First Line Amox", wrvu: 0.00 },
 "G9315": { name: "Amox With without Clavicle Prescription", wrvu: 0.00 },
 "G9316": { name: "Documentation Comm Risk Calc", wrvu: 0.00 },
 "G9317": { name: "No Documentation Comm Risk Calc", wrvu: 0.00 },
 "G9318": { name: "Image STD Nomenclature", wrvu: 0.00 },
 "G9319": { name: "Image Not STD Nomenclature", wrvu: 0.00 },
 "G9321": { name: "Prev CT Nuclear Medial Cnt Documentation 12mo", wrvu: 0.00 },
 "G9322": { name: "No Cnt CT Nuclear Medial Documentation 12mo", wrvu: 0.00 },
 "G9341": { name: "Srch For CT W In 12 Months", wrvu: 0.00 },
 "G9342": { name: "No Srch For CT In 12mo Norsn", wrvu: 0.00 },
 "G9344": { name: "Sysrsn No Dicom Srch", wrvu: 0.00 },
 "G9345": { name: "Follow Up Pulm Nod", wrvu: 0.00 },
 "G9347": { name: "No Follow Up Pulm Nod Norsn", wrvu: 0.00 },
 "G9351": { name: "Documentation >1 Sinus CT W 90d Diagnosis", wrvu: 0.00 },
 "G9352": { name: "Not >1 Sinus CT W 90d Diagnosis", wrvu: 0.00 },
 "G9353": { name: "Medrsn >1 Sinus CT W 90d Diagnosis", wrvu: 0.00 },
 "G9354": { name: "1 Or No CT Sinus With In 90d Diagnosis", wrvu: 0.00 },
 "G9355": { name: "No Early Ind/delivery", wrvu: 0.00 },
 "G9356": { name: "Early Ind/delivery", wrvu: 0.00 },
 "G9357": { name: "Pp Evaluation/edu Perf", wrvu: 0.00 },
 "G9358": { name: "Pp Evaluation/edu Not Perf", wrvu: 0.00 },
 "G9361": { name: "Documentation Rsn Elect C-sec/induct", wrvu: 0.00 },
 "G9364": { name: "Sinus Caus Bac Inx", wrvu: 0.00 },
 "G9367": { name: ">= 2 Same High-rsk Medial Ord", wrvu: 0.00 },
 "G9368": { name: ">= 2 Same High-rsk Medial Not Ord", wrvu: 0.00 },
 "G9380": { name: "Off Assis Eol Iss", wrvu: 0.00 },
 "G9382": { name: "No Off Assis Eol", wrvu: 0.00 },
 "G9383": { name: "Recd Scrn Hepatitis C Infec", wrvu: 0.00 },
 "G9384": { name: "Documentation Medial Rsn No Hepatitis C Scrn", wrvu: 0.00 },
 "G9385": { name: "Documentation Prothrombin Time Reas Not Rec Hepatitis C Srn", wrvu: 0.00 },
 "G9386": { name: "Scrn Hepatitis C Infec Not Recd", wrvu: 0.00 },
 "G9393": { name: "Ini Phq9 >9 Remiss <5", wrvu: 0.00 },
 "G9394": { name: "Diagnosis Bipol, Death, Nhres, Hospital", wrvu: 0.00 },
 "G9395": { name: "Ini Phq9 >9 No Remiss >=5", wrvu: 0.00 },
 "G9396": { name: "Ini Phq9 >9 Not Assess", wrvu: 0.00 },
 "G9408": { name: "Card Tamp With In 30d", wrvu: 0.00 },
 "G9409": { name: "No Card Tamp E/in 30d", wrvu: 0.00 },
 "G9410": { name: "Admit With In 180d Req Remov", wrvu: 0.00 },
 "G9411": { name: "No Admit With In 180d Req Remov", wrvu: 0.00 },
 "G9412": { name: "Admit With In 180d Req Surgery Revision", wrvu: 0.00 },
 "G9413": { name: "No Admit Req Surgery Revision", wrvu: 0.00 },
 "G9414": { name: "1dose Menig Vac Btwn 10 & 13", wrvu: 0.00 },
 "G9415": { name: "No 1dose Meni Vac Btwn 10 and 13", wrvu: 0.00 },
 "G9416": { name: "Prothrombin Time 1 Tdap Betw 10-13 Years", wrvu: 0.00 },
 "G9417": { name: "Prothrombin Time Not 1 Tdap Betw 10-13 Years", wrvu: 0.00 },
 "G9418": { name: "Lungcx Biopsy Report Documentation Class", wrvu: 0.00 },
 "G9419": { name: "Medial Reas Not Incl Histology Type", wrvu: 0.00 },
 "G9420": { name: "Specimen Site No Lung", wrvu: 0.00 },
 "G9421": { name: "Lung Cervix Biopsy Report No Documentation Class", wrvu: 0.00 },
 "G9422": { name: "Report Documentation Class Histology Type", wrvu: 0.00 },
 "G9423": { name: "Medial Reas Report No Histology Type", wrvu: 0.00 },
 "G9424": { name: "Site No Lung Or Lung Cx", wrvu: 0.00 },
 "G9425": { name: "Specimen Report No Documentation Class Histology", wrvu: 0.00 },
 "G9426": { name: "Impr Medial Time Edarr Pain Medial", wrvu: 0.00 },
 "G9427": { name: "No Impro Medial Time Pain Medial", wrvu: 0.00 },
 "G9428": { name: "Patho Report Incl Prothrombin Time Ctg", wrvu: 0.00 },
 "G9429": { name: "Documentation Medial Rsn No Prothrombin Time Cat", wrvu: 0.00 },
 "G9430": { name: "Specimen Site No Cutaneous", wrvu: 0.00 },
 "G9431": { name: "Patho Report No Prothrombin Time Ctg", wrvu: 0.00 },
 "G9432": { name: "Asth Controlled", wrvu: 0.00 },
 "G9434": { name: "Asth Not Controlled", wrvu: 0.00 },
 "G9452": { name: "Documentation Medial Reas No Hepatitis C Test", wrvu: 0.00 },
 "G9455": { name: "Abdominal Imag With Ultrasound CT Or MRI", wrvu: 0.00 },
 "G9456": { name: "Documentation Medial Prothrombin Time Reas No Hcc Scrn", wrvu: 0.00 },
 "G9457": { name: "Prothrombin Time No Abdominal Imaging No Documentation Rsn", wrvu: 0.00 },
 "G9468": { name: "No Recd Cortico>=10mg/d >60d", wrvu: 0.00 },
 "G9470": { name: "No Rec Cortico>60d 1rx 600mg", wrvu: 0.00 },
 "G9471": { name: "With In 2yr Dxa Not Order", wrvu: 0.00 },
 "G9473": { name: "Chap Services At Hospice", wrvu: 0.00 },
 "G9474": { name: "Diet Counsel At Hospice", wrvu: 0.00 },
 "G9475": { name: "Other Counselor At Hospice", wrvu: 0.00 },
 "G9476": { name: "Volun Service At Hospice", wrvu: 0.00 },
 "G9477": { name: "Care Coord At Hospice", wrvu: 0.00 },
 "G9478": { name: "Othe Therapist At Hospice", wrvu: 0.00 },
 "G9479": { name: "Pharmacist At Hospice", wrvu: 0.00 },
 "G9480": { name: "Admission To Mccm", wrvu: 0.00 },
 "G9481": { name: "Remote E and M New Patient 10mins", wrvu: 0.48 },
 "G9482": { name: "Remote E and M New Patient 20mins", wrvu: 0.93 },
 "G9483": { name: "Remote E and M New Patient 30mins", wrvu: 1.42 },
 "G9484": { name: "Remote E and M New Patient 45mins", wrvu: 2.43 },
 "G9485": { name: "Remote E and M New Patient 60mins", wrvu: 3.17 },
 "G9486": { name: "Remote E and M Established. Prothrombin Time 10mins", wrvu: 0.48 },
 "G9487": { name: "Remote E and M Established. Prothrombin Time 15mins", wrvu: 0.97 },
 "G9488": { name: "Remote E and M Established. Prothrombin Time 25mins", wrvu: 1.50 },
 "G9489": { name: "Remote E and M Established. Prothrombin Time 40mins", wrvu: 2.11 },
 "G9490": { name: "Cmmi Moderate Home Visit", wrvu: 0.18 },
 "G9497": { name: "Rec Inst No Smoke Day Surgery", wrvu: 0.00 },
 "G9498": { name: "Abx Reg Prescribed", wrvu: 0.00 },
 "G9500": { name: "Radical Expos Ind/exp Tm Documentation", wrvu: 0.00 },
 "G9501": { name: "Radical Expos Ind/exp Tm No Documentation", wrvu: 0.00 },
 "G9502": { name: "Medial Reas No Perf Foot Exam", wrvu: 0.00 },
 "G9504": { name: "Documentation Rsn Hep B Stat Not Asses", wrvu: 0.00 },
 "G9505": { name: "Abx Pressure With In 10 Dys Of Symp", wrvu: 0.00 },
 "G9507": { name: "Documentation Reas On Statin Or Contra", wrvu: 0.00 },
 "G9508": { name: "Documentation Prothrombin Time Not On Statin", wrvu: 0.00 },
 "G9509": { name: "Adit Mdd Dys Rem 12 Mnths", wrvu: 0.00 },
 "G9510": { name: "Remis12m Not Phq-9 Score <5", wrvu: 0.00 },
 "G9511": { name: "Idx Evt Dte Phq>9 Documentation 12 Month", wrvu: 0.00 },
 "G9512": { name: "Indiv Pdc > 0.8", wrvu: 0.00 },
 "G9513": { name: "Indiv Pdc Not > 0.8", wrvu: 0.00 },
 "G9514": { name: "Req Ret Or With In 90d Of Surgery", wrvu: 0.00 },
 "G9515": { name: "No Reas, No Ret Or With In 90d", wrvu: 0.00 },
 "G9516": { name: "Impr Vis Acuit With In 90d", wrvu: 0.00 },
 "G9517": { name: "No Impr Vis Acuit With In 90d", wrvu: 0.00 },
 "G9518": { name: "Documentation Active Injection Drug Use", wrvu: 0.00 },
 "G9519": { name: "Final Ref +/- 1.0 With In 90d", wrvu: 0.00 },
 "G9520": { name: "Refract Not +/- 1.0 With In 90d", wrvu: 0.00 },
 "G9521": { name: "Er And Ip Hospital <2 In 12 Months", wrvu: 0.00 },
 "G9522": { name: "Er/ip Hospital =/>2 In 12 Months", wrvu: 0.00 },
 "G9529": { name: "Minor Blunt Trauma With Head CT", wrvu: 0.00 },
 "G9530": { name: "Prothrombin Time Mbht Hd CT Ord Ec Prov", wrvu: 0.00 },
 "G9531": { name: "Prothrombin Time Documentation", wrvu: 0.00 },
 "G9533": { name: "Indic For Head CT Not Valid", wrvu: 0.00 },
 "G9537": { name: "Imaging Hd Clin Trial", wrvu: 0.00 },
 "G9539": { name: "Intent Pot Remv Time Placemt", wrvu: 0.00 },
 "G9540": { name: "Prothrombin Time Alive 3 Months Posterior Procedure", wrvu: 0.00 },
 "G9541": { name: "Filter Rem 3 Mon Placement", wrvu: 0.00 },
 "G9542": { name: "Documentation Reass Appr Remo Filt 3ms", wrvu: 0.00 },
 "G9543": { name: "Documentation 2x Re-assess Filt Remov", wrvu: 0.00 },
 "G9544": { name: "No Filt Remov With In 3mos Plcm", wrvu: 0.00 },
 "G9547": { name: "Cys Ren Lesion Or Adren", wrvu: 0.00 },
 "G9548": { name: "No Follow-up Rec Image Study", wrvu: 0.00 },
 "G9549": { name: "Documentation Medial Rsn For Follow-up Imag", wrvu: 0.00 },
 "G9550": { name: "Imag Rec", wrvu: 0.00 },
 "G9551": { name: "Imag No Lesion", wrvu: 0.00 },
 "G9552": { name: "Inc Thyroid Node <1.0 In Rpt", wrvu: 0.00 },
 "G9553": { name: "Prior Thyroid Dise Diagnosis", wrvu: 0.00 },
 "G9554": { name: "CT/cta/mri/a Chst Foll Rec", wrvu: 0.00 },
 "G9555": { name: "Documentation Medial Rsn For Follup Image", wrvu: 0.00 },
 "G9556": { name: "CT/cta/mri/a No Follup Imag", wrvu: 0.00 },
 "G9557": { name: "CT/cta/mri/a No Thyroid <1.0cm", wrvu: 0.00 },
 "G9580": { name: "Door To Punc Time <2hrs", wrvu: 0.00 },
 "G9582": { name: "Door To Punc Time >2hr, Nrg", wrvu: 0.00 },
 "G9593": { name: "Low Pecarn Ped Head Trauma", wrvu: 0.00 },
 "G9594": { name: "Prothrombin Time Mbht Hd CT Ord Ec Prov", wrvu: 0.00 },
 "G9595": { name: "Documentation Shunt/tumor/coag", wrvu: 0.00 },
 "G9597": { name: "No Low Pecarn Ped Head Traum", wrvu: 0.00 },
 "G9598": { name: "Aor Ane 5.5-5.9 cm Max Diam", wrvu: 0.00 },
 "G9599": { name: "Aor Ane >=6.0 cm Max Diam", wrvu: 0.00 },
 "G9603": { name: "Prothrombin Time Surv Improv Bsline Treatment", wrvu: 0.00 },
 "G9605": { name: "Surv Score No Improv With Treatment", wrvu: 0.00 },
 "G9606": { name: "Intraop Cyst Evaluation Trac Injection", wrvu: 0.00 },
 "G9607": { name: "Documentation Medial Rsn Not Perf Cystosc", wrvu: 0.00 },
 "G9608": { name: "Intraop Cyst Evaluation Not Done", wrvu: 0.00 },
 "G9609": { name: "Documentation Order Anti-plat", wrvu: 0.00 },
 "G9610": { name: "Documentation Md Rsn No Antipla", wrvu: 0.00 },
 "G9611": { name: "No Documentation Order Anti-plat Rng", wrvu: 0.00 },
 "G9621": { name: "Scr Unheal Etoh With Counsel", wrvu: 0.00 },
 "G9622": { name: "No Unheal Etoh User", wrvu: 0.00 },
 "G9624": { name: "Prothrombin Time Not Scrn Or No Counseling", wrvu: 0.00 },
 "G9625": { name: "Prothrombin Time Bl Srg 30 Day Pst Srg", wrvu: 0.00 },
 "G9626": { name: "Medial Rsn No Report Bladder Injection", wrvu: 0.00 },
 "G9627": { name: "Prothrombin Time No Bl Srg 30 Day Pst Srg", wrvu: 0.00 },
 "G9628": { name: "Prothrombin Time Bwli Srg 30 Day Pst Srg", wrvu: 0.00 },
 "G9629": { name: "Medial Rsn No Report Bowel Injection", wrvu: 0.00 },
 "G9630": { name: "Prothrombin Time No Bwli Srg 30 Day Srg", wrvu: 0.00 },
 "G9637": { name: "Documentation >1 Dose Reduction Tech", wrvu: 0.00 },
 "G9638": { name: "No Documentation >1 Dose Reduction Tech", wrvu: 0.00 },
 "G9642": { name: "Current Smoker", wrvu: 0.00 },
 "G9643": { name: "Elective Surgery", wrvu: 0.00 },
 "G9644": { name: "No Smok B/4 Anesthesia Day Of Surgery", wrvu: 0.00 },
 "G9645": { name: "Had Smoke B/4 Anesthesia Day Surgery", wrvu: 0.00 },
 "G9646": { name: "Prothrombin Time With 90d Mrs 0-2", wrvu: 0.00 },
 "G9648": { name: "Prothrombin Time With 90d Mrs >2", wrvu: 0.00 },
 "G9649": { name: "Psor As Documentation Spc Bm", wrvu: 0.00 },
 "G9651": { name: "Psor As Documentation No Spc Bm", wrvu: 0.00 },
 "G9654": { name: "Mon Anesth Care", wrvu: 0.00 },
 "G9655": { name: "Toc Tool Incl Key Elem", wrvu: 0.00 },
 "G9656": { name: "Prothrombin Time Trans From Anest To Pacu", wrvu: 0.00 },
 "G9658": { name: "Toc Tool Incl Elem Not Used", wrvu: 0.00 },
 "G9659": { name: ">=86y Scr Colo Nomed Rsn", wrvu: 0.00 },
 "G9660": { name: "Documentation Medial Rsn Colo Prothrombin Time >= 86y", wrvu: 0.00 },
 "G9661": { name: "Prothrombin Time >= 86 W/ High Risk", wrvu: 0.00 },
 "G9662": { name: "Prior Diagnosis/active Clin Ascvd", wrvu: 0.00 },
 "G9663": { name: "Fast/dir Ldl >= 190 Mg/dl", wrvu: 0.00 },
 "G9664": { name: "Taking Statin Or Rec'd Order", wrvu: 0.00 },
 "G9665": { name: "No Statin/no Order Statin", wrvu: 0.00 },
 "G9674": { name: "Prothrombin Time With Clin Ascvd Diagnosis", wrvu: 0.00 },
 "G9675": { name: "Prothrombin Time With Fast/dir Laboratory Ldl-c >190", wrvu: 0.00 },
 "G9676": { name: "40-75y With Type 1/2 With Ldl-c Rs", wrvu: 0.00 },
 "G9679": { name: "Acute Care Pneumonia", wrvu: 0.00 },
 "G9680": { name: "Acute Care Congestive Heart", wrvu: 0.00 },
 "G9681": { name: "Acute Care Chronic Obstruct", wrvu: 0.00 },
 "G9682": { name: "Acute Care Skin Infection", wrvu: 0.00 },
 "G9683": { name: "Acute Fluid/electro Disorder", wrvu: 0.00 },
 "G9684": { name: "Acute Care Urinary Tract Inferior", wrvu: 0.00 },
 "G9685": { name: "Acute Nursing Facility Care", wrvu: 3.50 },
 "G9687": { name: "Hospice Anytime Msmt Per", wrvu: 0.00 },
 "G9688": { name: "Prothrombin Time With Hospital Anytime Msmt Per", wrvu: 0.00 },
 "G9689": { name: "Inpt Elect Carotid Intervent", wrvu: 0.00 },
 "G9690": { name: "Prothrombin Time In Hos", wrvu: 0.00 },
 "G9691": { name: "Prothrombin Time Hospital Dur Msmt Period", wrvu: 0.00 },
 "G9692": { name: "Hospital Recd By Prothrombin Time Dur Msmt Per", wrvu: 0.00 },
 "G9693": { name: "Prothrombin Time Use Hospital During Msmt Per", wrvu: 0.00 },
 "G9694": { name: "Hospital Srv Used Prothrombin Time In Msmt Per", wrvu: 0.00 },
 "G9695": { name: "Long Act Inhal Bronchdil Pre", wrvu: 0.00 },
 "G9696": { name: "Medial Rsn No Presc Bronchdil", wrvu: 0.00 },
 "G9698": { name: "System Rsn No Presc Bronchdil", wrvu: 0.00 },
 "G9699": { name: "Long Inhal Bronchdil No Pressure", wrvu: 0.00 },
 "G9700": { name: "Prothrombin Time Is With Hospital During Msmt Per", wrvu: 0.00 },
 "G9702": { name: "Prothrombin Time Use Hospital During Msmt Per", wrvu: 0.00 },
 "G9703": { name: "Anbx 30 Prior To Episode", wrvu: 0.00 },
 "G9704": { name: "Ajcc Br Ca Stg I: T1 Mic/t1a", wrvu: 0.00 },
 "G9705": { name: "Ajcc Br Ca Stg Ib", wrvu: 0.00 },
 "G9706": { name: "Low Recur Prost Ca", wrvu: 0.00 },
 "G9708": { name: "Bilateral Mast/History Bi /unilateral Mas", wrvu: 0.00 },
 "G9709": { name: "Hospital Srv Used Prothrombin Time In Msmt Per", wrvu: 0.00 },
 "G9710": { name: "Prothrombin Time Prov Hospital Srv Msmt Per", wrvu: 0.00 },
 "G9711": { name: "Prothrombin Time History Tot Col Or Colon Ca", wrvu: 0.00 },
 "G9712": { name: "Documentation Medial Rsn Presc Anbx", wrvu: 0.00 },
 "G9713": { name: "Prothrombin Time Use Hospital During Msmt Per", wrvu: 0.00 },
 "G9714": { name: "Prothrombin Time Is With Hospital During Msmt Per", wrvu: 0.00 },
 "G9716": { name: "Bmi Documentation Onl Fup Not Cmpltd", wrvu: 0.00 },
 "G9717": { name: "Documentation Prothrombin Time Diagnosis Bipol", wrvu: 0.00 },
 "G9719": { name: "Prothrombin Time Not Ambul/immob/wc", wrvu: 0.00 },
 "G9720": { name: "Hospice Anytime Msmt Per", wrvu: 0.00 },
 "G9721": { name: "Prothrombin Time Not Ambul/immob/wc", wrvu: 0.00 },
 "G9722": { name: "Documentation History Renal Fail Or Cr+ >=4", wrvu: 0.00 },
 "G9723": { name: "Hospital Recd By Prothrombin Time Dur Msmt Per", wrvu: 0.00 },
 "G9724": { name: "Prothrombin Time With Documentation Use Anticoag Mst Year", wrvu: 0.00 },
 "G9726": { name: "Refused To Participate", wrvu: 0.00 },
 "G9727": { name: "Prothrombin Time Unable Cmplt Lepf Prom", wrvu: 0.00 },
 "G9728": { name: "Refused To Participate", wrvu: 0.00 },
 "G9729": { name: "Prothrombin Time Unbl Cmplt Lepf Prom", wrvu: 0.00 },
 "G9730": { name: "Refused To Participate", wrvu: 0.00 },
 "G9731": { name: "Prothrombin Time Unbl Cmplt Lepf Prom", wrvu: 0.00 },
 "G9732": { name: "Refused To Participate", wrvu: 0.00 },
 "G9733": { name: "Prothrombin Time Unbl Cmplt Lb Fs Prom", wrvu: 0.00 },
 "G9734": { name: "Refused To Participate", wrvu: 0.00 },
 "G9735": { name: "Prothrombin Time Unbl Cmplt Shld Fs Prom", wrvu: 0.00 },
 "G9736": { name: "Refused To Participate", wrvu: 0.00 },
 "G9737": { name: "Prothrombin Time Unbl Cmplt Ewh Fs Prom", wrvu: 0.00 },
 "G9740": { name: "Hospital Srv To Prothrombin Time Dur Msmt Per", wrvu: 0.00 },
 "G9741": { name: "Prothrombin Time With Hospital Anytime Msmt Per", wrvu: 0.00 },
 "G9744": { name: "Prothrombin Time Not Eli D/t Act Dig Htn", wrvu: 0.00 },
 "G9745": { name: "Documentation Rsn No Hbp Scrn Or Follow-up", wrvu: 0.00 },
 "G9746": { name: "Mit Sten, Valve Or Trans Af", wrvu: 0.00 },
 "G9752": { name: "Urgent Surgery", wrvu: 0.00 },
 "G9753": { name: "Documentation No Dicom, CT Other Fac", wrvu: 0.00 },
 "G9754": { name: "Incid Pulm Nodule", wrvu: 0.00 },
 "G9755": { name: "Documentation Medial Rsn No Fllw Up", wrvu: 0.00 },
 "G9756": { name: "Surgery Procedure With Silicone Oil", wrvu: 0.00 },
 "G9757": { name: "Surgery Procedure With Silicone Oil", wrvu: 0.00 },
 "G9758": { name: "Prothrombin Time In Hos", wrvu: 0.00 },
 "G9761": { name: "Prothrombin Time With Hospital Anytime Msmt Per", wrvu: 0.00 },
 "G9762": { name: "Prothrombin Time Had >= 2-3 HPV Vaccines", wrvu: 0.00 },
 "G9763": { name: "Prothrombin Time Not Have 2-3 HPV Vaccines", wrvu: 0.00 },
 "G9764": { name: "Prothrombin Time Treatd With Oral Syst Or Bio", wrvu: 0.00 },
 "G9765": { name: "Documentation Pat Declined Therapy", wrvu: 0.00 },
 "G9766": { name: "Cva Stroke Diagnosis Treatment Transf Fac", wrvu: 0.00 },
 "G9767": { name: "Hospital New Diagnosis Cva Consid Evst", wrvu: 0.00 },
 "G9768": { name: "Prothrombin Time With Hospital Anytime Msmt Per", wrvu: 0.00 },
 "G9769": { name: "Bone Den 2yr/got Ost Medial/Therapeutic", wrvu: 0.00 },
 "G9770": { name: "Perip Nerve Block", wrvu: 0.00 },
 "G9771": { name: "Anesthesia End, 1 Temp >35.5(95.9)", wrvu: 0.00 },
 "G9772": { name: "Documentation Medial Rsn No Temp >= 35.5", wrvu: 0.00 },
 "G9773": { name: "1 Bod Temp >=35.5", wrvu: 0.00 },
 "G9775": { name: "Recd 2 Anti-emet Pre/intraop", wrvu: 0.00 },
 "G9776": { name: "Documentation Medial Rsn No Prophylactic Antiem", wrvu: 0.00 },
 "G9777": { name: "Prothrombin Time No Antiemet Pre/intraop", wrvu: 0.00 },
 "G9779": { name: "Pts Breastfeeding", wrvu: 0.00 },
 "G9780": { name: "Pts Diagnosis With Rhabdomyolysis", wrvu: 0.00 },
 "G9781": { name: "Documentation Rsn No Statin", wrvu: 0.00 },
 "G9782": { name: "History Diagnosis Fam/pure Hypercholes", wrvu: 0.00 },
 "G9784": { name: "Pathology/derm Prov 2nd Biop Opin", wrvu: 0.00 },
 "G9785": { name: "Pathology Report Sent", wrvu: 0.00 },
 "G9786": { name: "Pathology Report Not Sent", wrvu: 0.00 },
 "G9787": { name: "Prothrombin Time Alive", wrvu: 0.00 },
 "G9788": { name: "Most Rct Bp </= 130/80", wrvu: 0.00 },
 "G9789": { name: "Record Bp Ip, Er, Urg/self", wrvu: 0.00 },
 "G9790": { name: "Most Rct Bp >/= 130/80", wrvu: 0.00 },
 "G9791": { name: "Most Rct Tob Stat Free", wrvu: 0.00 },
 "G9792": { name: "Most Rct Tob Stat Not Free", wrvu: 0.00 },
 "G9793": { name: "Prothrombin Time On Daily Asa/antiplat", wrvu: 0.00 },
 "G9794": { name: "Documentation Medial Rsn No Daily Aspirin", wrvu: 0.00 },
 "G9795": { name: "Prothrombin Time No Daily Asa/antiplat", wrvu: 0.00 },
 "G9796": { name: "Prothrombin Time Currently On Statin", wrvu: 0.00 },
 "G9797": { name: "Prothrombin Time Not Currently On Statin", wrvu: 0.00 },
 "G9805": { name: "Prothrombin Time With Hospital Anytime Msmt Per", wrvu: 0.00 },
 "G9806": { name: "Prothrombin Time Recd Cervical Cytology/HPV", wrvu: 0.00 },
 "G9807": { name: "Prothrombin Time No Recd Cervical Cytology/HPV", wrvu: 0.00 },
 "G9812": { name: "Prothrombin Time Died During Inpt/30d Aft", wrvu: 0.00 },
 "G9813": { name: "Prothrombin Time Not Died With In 30d Of Procedure", wrvu: 0.00 },
 "G9818": { name: "Documentation Sex Activity", wrvu: 0.00 },
 "G9819": { name: "Prothrombin Time With Hospital Anytime Msmt Per", wrvu: 0.00 },
 "G9820": { name: "Documentation Chlam Scr Test With Follow", wrvu: 0.00 },
 "G9821": { name: "No Documentation Chlam Scr Ts With Follow", wrvu: 0.00 },
 "G9822": { name: "Endoscopic Abl Procedure Year Prev Ind Dt", wrvu: 0.00 },
 "G9823": { name: "Endoscopic Simple/hyst Biopsy Res Documentation", wrvu: 0.00 },
 "G9824": { name: "Endoscopic Simple/hyst Biopsy Res No Documentation", wrvu: 0.00 },
 "G9830": { name: "Her-2 Pos", wrvu: 0.00 },
 "G9831": { name: "Ajcc Stg Brt Ca Diagnosis Ii Or Iii", wrvu: 0.00 },
 "G9832": { name: "Br Ca Stg = 1 T Stg = T1c", wrvu: 0.00 },
 "G9838": { name: "Prothrombin Time Met Dis At Diagnosis", wrvu: 0.00 },
 "G9839": { name: "Anti-EGFR Mon Anti Therapeutic", wrvu: 0.00 },
 "G9840": { name: "Gene Testing Performed", wrvu: 0.00 },
 "G9841": { name: "Gene Testing Not Performed", wrvu: 0.00 },
 "G9842": { name: "Prothrombin Time Met Dis At Diagnosis", wrvu: 0.00 },
 "G9843": { name: "KRAS Or Nras Gene Mutation", wrvu: 0.00 },
 "G9844": { name: "Prothrombin Time No Recd Anti-EGFR Therapeutic", wrvu: 0.00 },
 "G9845": { name: "Prothrombin Time Recd Anti-EGFR Therapeutic", wrvu: 0.00 },
 "G9846": { name: "Prothrombin Time Died From Cancer", wrvu: 0.00 },
 "G9847": { name: "Prothrombin Time Recd Chemo Last 14d Life", wrvu: 0.00 },
 "G9848": { name: "Prothrombin Time No Chemo Last 14d Life", wrvu: 0.00 },
 "G9858": { name: "Prothrombin Time Enroll Hospice", wrvu: 0.00 },
 "G9859": { name: "Prothrombin Time Died From Cancer", wrvu: 0.00 },
 "G9860": { name: "Prothrombin Time Less 3d Hospice", wrvu: 0.00 },
 "G9861": { name: "Prothrombin Time More Than 3d Hospice", wrvu: 0.00 },
 "G9862": { name: "Documentation Rsn No 10 Year Follow", wrvu: 0.00 },
 "G9868": { name: "Cmmi Asyntelehealth <10min", wrvu: 0.80 },
 "G9869": { name: "Cmmi Asyntelehealth 10-20min", wrvu: 1.07 },
 "G9870": { name: "Cmmi Asyntelehealth >20min", wrvu: 1.34 },
 "G9871": { name: "Behavioral Couns Dm Prev, Onln 60 M", wrvu: 0.00 },
 "G9873": { name: "1 Em Core Session", wrvu: 0.00 },
 "G9874": { name: "4 Em Core Sessions", wrvu: 0.00 },
 "G9875": { name: "9 Em Core Sessions", wrvu: 0.00 },
 "G9876": { name: "2 Em Core Ms Month 7-9 No Wl", wrvu: 0.00 },
 "G9877": { name: "2 Em Core Ms Month 10-12 No Wl", wrvu: 0.00 },
 "G9878": { name: "2 Em Core Ms Month 7-9 Wl", wrvu: 0.00 },
 "G9879": { name: "2 Em Core Ms Month 10-12 Wl", wrvu: 0.00 },
 "G9880": { name: "Em 5 Percent Wl", wrvu: 0.00 },
 "G9881": { name: "Em 9 Percent Wl", wrvu: 0.00 },
 "G9882": { name: "2 Em Ongoing Ms Month 13-15 Wl", wrvu: 0.00 },
 "G9883": { name: "2 Em Ongoing Ms Month 16-18 Wl", wrvu: 0.00 },
 "G9884": { name: "2 Em Ongoing Ms Month 19-21 Wl", wrvu: 0.00 },
 "G9885": { name: "2 Em Ongoing Ms Month 22-24 Wl", wrvu: 0.00 },
 "G9886": { name: "In-person Attendance G Code", wrvu: 0.00 },
 "G9887": { name: "Distance Learning Attendance", wrvu: 0.00 },
 "G9888": { name: "5% Wl Maintnd From Bsline Wt", wrvu: 0.00 },
 "G9890": { name: "Em Bridge Payment", wrvu: 0.00 },
 "G9891": { name: "Em Session Reporting", wrvu: 0.00 },
 "G9894": { name: "Adr Dilatation and Evacuation Procedure Thrpy Prescribed", wrvu: 0.00 },
 "G9895": { name: "Documentation Medial Rsn No Adr Dilatation and Evacuation Procedure Thrpy", wrvu: 0.00 },
 "G9896": { name: "Documentation Prothrombin Time Rsn No Adr Dilatation and Evacuation Procedure Thrpy", wrvu: 0.00 },
 "G9897": { name: "Prothrombin Time Nt Prsc Adr Dilatation and Evacuation Procedure Thrpy Rng", wrvu: 0.00 },
 "G9898": { name: "Prothrombin Time 66+ Single Nucleotide Polymorphism Or Ltc Pos > 90d", wrvu: 0.00 },
 "G9899": { name: "Scrn Mam Perf Rslts Documentation", wrvu: 0.00 },
 "G9900": { name: "Scrn Mam Perf Rslts Not Documentation", wrvu: 0.00 },
 "G9901": { name: "Prothrombin Time 66+ Single Nucleotide Polymorphism Or Ltc Pos > 90d", wrvu: 0.00 },
 "G9902": { name: "Prothrombin Time Scrn Tbco And Id As User", wrvu: 0.00 },
 "G9903": { name: "Prothrombin Time Scrn Tbco Id As Non User", wrvu: 0.00 },
 "G9905": { name: "No Prothrombin Time Tbco Scrn Rng", wrvu: 0.00 },
 "G9906": { name: "Prothrombin Time Recv Tbco Cess Interv", wrvu: 0.00 },
 "G9908": { name: "No Prothrombin Time Tbco Cess Interv Rng", wrvu: 0.00 },
 "G9910": { name: "Prothrombin Time 66+ Single Nucleotide Polymorphism Or Ltc Pos > 90d", wrvu: 0.00 },
 "G9911": { name: "Node Neg Pre/Posterior Syst Therapeutic", wrvu: 0.00 },
 "G9912": { name: "Hepatitis B Status Assesed And Int", wrvu: 0.00 },
 "G9913": { name: "No Hepatitis B Status Assesd And Int", wrvu: 0.00 },
 "G9914": { name: "Prothrombin Time Initiated Anti-tnf Agent", wrvu: 0.00 },
 "G9915": { name: "No Documntd Hepatitis B Results Rcd", wrvu: 0.00 },
 "G9916": { name: "Funct Status Past 12 Months", wrvu: 0.00 },
 "G9917": { name: "Adv Dem Crgvr Limited", wrvu: 0.00 },
 "G9918": { name: "No Funct Stat Perf, Rsn Not Otherwise Specified", wrvu: 0.00 },
 "G9919": { name: "Scrn Nd Pos Nd Prov Of Rec", wrvu: 0.00 },
 "G9920": { name: "Scrning Perf And Negative", wrvu: 0.00 },
 "G9922": { name: "Sfty Cncrns Scrn Nd Mit Recs", wrvu: 0.00 },
 "G9923": { name: "Safty Cncrns Scrn And Neg", wrvu: 0.00 },
 "G9925": { name: "No Scrn Prov Rsn Not Otherwise Specified", wrvu: 0.00 },
 "G9926": { name: "Sfty Cncrns Scrn But No Recs", wrvu: 0.00 },
 "G9928": { name: "No Warf Or Fda Drug Presc", wrvu: 0.00 },
 "G9929": { name: "Trs/revision Af", wrvu: 0.00 },
 "G9930": { name: "Com Care", wrvu: 0.00 },
 "G9931": { name: "No Chad Or Chad Scr 0 Or 1", wrvu: 0.00 },
 "G9938": { name: "Prothrombin Time 66+ Single Nucleotide Polymorphism Or Ltc Pos > 90d", wrvu: 0.00 },
 "G9939": { name: "Same Pathology/derm Perf Biopsy", wrvu: 0.00 },
 "G9940": { name: "Documentation Reas No Statin Therapy", wrvu: 0.00 },
 "G9943": { name: "Bk Pn Nt Msr Vas Scl Pre/pst", wrvu: 0.00 },
 "G9945": { name: "Prothrombin Time With Cancer Scoliosis", wrvu: 0.00 },
 "G9946": { name: "Bk Pain No Vas", wrvu: 0.00 },
 "G9949": { name: "Leg Pain No Vas", wrvu: 0.00 },
 "G9954": { name: "Prothrombin Time >2 Rsk Fac Posterior-op Vomit", wrvu: 0.00 },
 "G9955": { name: "Inhlnt Anesth Only For Induc", wrvu: 0.00 },
 "G9956": { name: "Combo Thrpy Of >= 2 Prophly", wrvu: 0.00 },
 "G9957": { name: "Documentation Medial Rsn No Combo Thrpy", wrvu: 0.00 },
 "G9958": { name: "No Combo Prohpyl Thrp For Patient", wrvu: 0.00 },
 "G9959": { name: "Systemic Antimicro Not Presc", wrvu: 0.00 },
 "G9960": { name: "Medial Rsn System Antimi Nt Prescription", wrvu: 0.00 },
 "G9961": { name: "Systemic Antimicro Presc", wrvu: 0.00 },
 "G9962": { name: "Embolization Documentation Separatly", wrvu: 0.00 },
 "G9963": { name: "Embolization Not Documentation Separat", wrvu: 0.00 },
 "G9964": { name: "Prothrombin Time Recv >=1 Well-chld Visit", wrvu: 0.00 },
 "G9965": { name: "No Well-chld Vist Recv By Patient", wrvu: 0.00 },
 "G9968": { name: "Prothrombin Time Refrd 2 Pvdr/spclst In Pp", wrvu: 0.00 },
 "G9969": { name: "Pvdr Rfrd Prothrombin Time Report Rcvd", wrvu: 0.00 },
 "G9970": { name: "Pvdr Rfrd Prothrombin Time No Report Rcvd", wrvu: 0.00 },
 "G9978": { name: "Remote E and M New Patient 10mins", wrvu: 0.48 },
 "G9979": { name: "Remote E and M New Patient 20mins", wrvu: 0.93 },
 "G9980": { name: "Remote E and M New Patient 30 Mins", wrvu: 1.42 },
 "G9981": { name: "Remote E and M New Patient 45mins", wrvu: 2.43 },
 "G9982": { name: "Remote E and M New Patient 60mins", wrvu: 3.17 },
 "G9983": { name: "Remote E and M Established. Prothrombin Time 10mins", wrvu: 0.48 },
 "G9984": { name: "Remote E and M Established. Prothrombin Time 15mins", wrvu: 0.97 },
 "G9985": { name: "Remote E and M Established. Prothrombin Time 25mins", wrvu: 1.50 },
 "G9986": { name: "Remote E and M Established. Prothrombin Time 40mins", wrvu: 2.11 },
 "G9987": { name: "Bpci Advanced In Home Visit", wrvu: 0.18 },
 "G9988": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G9992": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G9993": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G9994": { name: "Pall Serv During Meas", wrvu: 0.00 },
 "G9996": { name: "Documentation Prothrombin Time Palate Or Hospice", wrvu: 0.00 },
 "G9997": { name: "Documentation Prothrombin Time Preg Dur Msrmt Pd", wrvu: 0.00 },
 "G9998": { name: "Documentation Medial Rsn <3 Colon", wrvu: 0.00 },
 "G9999": { name: "Documentation System Rsn <3 Colon", wrvu: 0.00 },
 "Q0035": { name: "Cardiokymography", wrvu: 0.17 },
 "Q0081": { name: "Infusion Therapeutic Other Than Che", wrvu: 0.00 },
 "Q0083": { name: "Chemo By Other Than Infusion", wrvu: 0.00 },
 "Q0084": { name: "Chemotherapy By Infusion", wrvu: 0.00 },
 "Q0085": { name: "Chemo By Both Infusion And O", wrvu: 0.00 },
 "Q0091": { name: "Screening Pap Smear Smear, Obtaining/Preparing Specimen", wrvu: 0.36 },
 "Q0092": { name: "Set Up Port X-ray Equipment", wrvu: 0.00 },
 "Q0111": { name: "Wet Mounts/ W Preparations", wrvu: 0.00 },
 "Q0112": { name: "Potassium Hydroxide Preps", wrvu: 0.00 },
 "Q0113": { name: "Pinworm Examinations", wrvu: 0.00 },
 "Q0114": { name: "Fern Test", wrvu: 0.00 },
 "Q0115": { name: "Posterior-coital Mucous Exam", wrvu: 0.00 },
 "Q0138": { name: "Ferumoxytol, Non-esrd", wrvu: 0.00 },
 "Q0139": { name: "Ferumoxytol, Esrd Use", wrvu: 0.00 },
 "Q0144": { name: "Azithromycin Dihydrate, Oral", wrvu: 0.00 },
 "Q0155": { name: "Dronabinol (syndros) 0.1 Mg", wrvu: 0.00 },
 "Q0161": { name: "Chlorpromazine Hcl 5mg Oral", wrvu: 0.00 },
 "Q0162": { name: "Ondansetron Oral", wrvu: 0.00 },
 "Q0163": { name: "Diphenhydramine Hcl 50mg", wrvu: 0.00 },
 "Q0164": { name: "Prochlorperazine Maleate 5mg", wrvu: 0.00 },
 "Q0166": { name: "Granisetron Hcl 1 mg Oral", wrvu: 0.00 },
 "Q0167": { name: "Dronabinol 2.5mg Oral", wrvu: 0.00 },
 "Q0169": { name: "Promethazine Hcl 12.5mg Oral", wrvu: 0.00 },
 "Q0173": { name: "Trimethobenzamide Hcl 250mg", wrvu: 0.00 },
 "Q0175": { name: "Perphenazine 4mg Oral", wrvu: 0.00 },
 "Q0177": { name: "Hydroxyzine Pamoate 25mg", wrvu: 0.00 },
 "Q0180": { name: "Dolasetron Mesylate Oral", wrvu: 0.00 },
 "Q0181": { name: "Unspecified Oral Anti-emetic", wrvu: 0.00 },
 "Q0224": { name: "Injection, Pemivibart, 4500 Mg", wrvu: 0.00 },
 "Q0235": { name: "Injection, Monoclon Antibody, 1 Mg", wrvu: 0.00 },
 "Q0237": { name: "Injection, Tocilizumab-anoh, Hospi", wrvu: 0.00 },
 "Q0249": { name: "Tocilizumab For COVID-19-19", wrvu: 0.00 },
 "Q0477": { name: "Pwr Module Prothrombin Time Cable Lvad Rpl", wrvu: 0.00 },
 "Q0478": { name: "Power Adapter, Combo Vad", wrvu: 0.00 },
 "Q0479": { name: "Power Module Combo Vad, Rep", wrvu: 0.00 },
 "Q0480": { name: "Driver Pneumatic Vad, Rep", wrvu: 0.00 },
 "Q0481": { name: "Microprcsr Cu Elec Vad, Rep", wrvu: 0.00 },
 "Q0482": { name: "Microprcsr Cu Combo Vad, Rep", wrvu: 0.00 },
 "Q0483": { name: "Monitor Elec Vad, Rep", wrvu: 0.00 },
 "Q0484": { name: "Monitor Elec Or Comb Vad Rep", wrvu: 0.00 },
 "Q0485": { name: "Monitor Cable Elec Vad, Rep", wrvu: 0.00 },
 "Q0486": { name: "Mon Cable Elec/pneum Vad Rep", wrvu: 0.00 },
 "Q0487": { name: "Leads Any Type Vad, Rep Only", wrvu: 0.00 },
 "Q0488": { name: "Pwr Pack Base Elec Vad, Rep", wrvu: 0.00 },
 "Q0489": { name: "Pwr Pck Base Combo Vad, Rep", wrvu: 0.00 },
 "Q0490": { name: "Emr Pwr Source Elec Vad, Rep", wrvu: 0.00 },
 "Q0491": { name: "Emr Pwr Source Combo Vad Rep", wrvu: 0.00 },
 "Q0492": { name: "Emr Pwr Cbl Elec Vad, Rep", wrvu: 0.00 },
 "Q0493": { name: "Emr Pwr Cbl Combo Vad, Rep", wrvu: 0.00 },
 "Q0494": { name: "Emr Hd Pump Electrode/Combination, Rep", wrvu: 0.00 },
 "Q0495": { name: "Charger Electrode/Combination Vad, Rep", wrvu: 0.00 },
 "Q0496": { name: "Battery Electrode/Combination Vad, Rep", wrvu: 0.00 },
 "Q0497": { name: "Bat Clps Elec/comb Vad, Rep", wrvu: 0.00 },
 "Q0498": { name: "Holster Electrode/Combination Vad, Rep", wrvu: 0.00 },
 "Q0499": { name: "Belt/vest Electrode/Combination Vad Rep", wrvu: 0.00 },
 "Q0500": { name: "Filters Electrode/Combination Vad, Rep", wrvu: 0.00 },
 "Q0501": { name: "Shwr Cov Electrode/Combination Vad, Rep", wrvu: 0.00 },
 "Q0502": { name: "Mobility Cartilage Pneum Vad, Rep", wrvu: 0.00 },
 "Q0503": { name: "Battery Pneum Vad Replacemnt", wrvu: 0.00 },
 "Q0504": { name: "Pwr Adpt Pneum Vad, Rep Veh", wrvu: 0.00 },
 "Q0506": { name: "Lith-ion Batt Elec/pneum Vad", wrvu: 0.00 },
 "Q0507": { name: "Misc Superior/acc External Vad", wrvu: 0.00 },
 "Q0508": { name: "Mis Superior/acc Imp Vad", wrvu: 0.00 },
 "Q0509": { name: "Mis Superior/ac Imp Vad Nopay Medial", wrvu: 0.00 },
 "Q0510": { name: "Dispens Fee Immunosupressive", wrvu: 0.00 },
 "Q0511": { name: "Superior Fee Antiem,antica,immuno", wrvu: 0.00 },
 "Q0512": { name: "Procedure Superior Fee Anti-can Sub Pressure", wrvu: 0.00 },
 "Q0513": { name: "Disp Fee Inhal Drugs/30 Days", wrvu: 0.00 },
 "Q0514": { name: "Disp Fee Inhal Drugs/90 Days", wrvu: 0.00 },
 "Q0515": { name: "Sermorelin Acetate Injection", wrvu: 0.00 },
 "Q0521": { name: "Supply Fee HIV Prep Fda Appr", wrvu: 0.00 },
 "Q1004": { name: "Ntiol Category 4", wrvu: 0.00 },
 "Q1005": { name: "Ntiol Category 5", wrvu: 0.00 },
 "Q2004": { name: "Bladder Calculi Irrig Sol", wrvu: 0.00 },
 "Q2009": { name: "Fosphenytoin Injection Pe", wrvu: 0.00 },
 "Q2026": { name: "Radiesse Injection", wrvu: 0.00 },
 "Q2028": { name: "Injection, Sculptra, 0.5mg", wrvu: 0.00 },
 "Q2034": { name: "Agriflu Vaccine", wrvu: 0.00 },
 "Q2035": { name: "Afluria Vacc, 3 Years & >, Intramuscular", wrvu: 0.00 },
 "Q2036": { name: "Flulaval Vacc, 3 Years & >, Intramuscular", wrvu: 0.00 },
 "Q2037": { name: "Fluvirin Vacc, 3 Years & >, Intramuscular", wrvu: 0.00 },
 "Q2038": { name: "Fluzone Vacc, 3 Years & >, Intramuscular", wrvu: 0.00 },
 "Q2039": { name: "Influenza Virus Vaccine, Not Otherwise Specified", wrvu: 0.00 },
 "Q2041": { name: "Axicabtagene Ciloleucel Car+", wrvu: 0.00 },
 "Q2042": { name: "Tisagenlecleucel Car-pos T", wrvu: 0.00 },
 "Q2043": { name: "Sipuleucel-t Auto Cd54+", wrvu: 0.00 },
 "Q2049": { name: "Imported Lipodox Injection", wrvu: 0.00 },
 "Q2050": { name: "Doxorubicin Injection 10mg", wrvu: 0.00 },
 "Q2052": { name: "Home Intravenous Immunoglobulin, Services/supplies", wrvu: 0.00 },
 "Q2053": { name: "Brexucabtagene Car Pos T", wrvu: 0.00 },
 "Q2054": { name: "Lisocabtagene Mara Car Pos T", wrvu: 0.00 },
 "Q2055": { name: "Idecabtagene Vicleucel Car", wrvu: 0.00 },
 "Q2056": { name: "Ciltacabtagene Car-pos T", wrvu: 0.00 },
 "Q2057": { name: "Afamitresgene Autoleucel", wrvu: 0.00 },
 "Q2058": { name: "Obecbtge Autol Up To 400 Mil", wrvu: 0.00 },
 "Q3001": { name: "Brachytherapy Radioelements", wrvu: 0.00 },
 "Q3014": { name: "Telehealth Facility Fee", wrvu: 0.00 },
 "Q3027": { name: "Injection Beta Interferon Intramuscular 1 mcg", wrvu: 0.00 },
 "Q3028": { name: "Injection Beta Interferon Subcutaneous 1 mcg", wrvu: 0.00 },
 "Q3031": { name: "Collagen Skin Test", wrvu: 0.00 },
 "Q4001": { name: "Cast Superior Body Cast Plaster", wrvu: 0.00 },
 "Q4002": { name: "Cast Superior Body Cast Fiberglas", wrvu: 0.00 },
 "Q4003": { name: "Cast Superior Shoulder Cast Plstr", wrvu: 0.00 },
 "Q4004": { name: "Cast Superior Shoulder Cast Fbrgl", wrvu: 0.00 },
 "Q4005": { name: "Cast Superior Long Arm Adult Plst", wrvu: 0.00 },
 "Q4006": { name: "Cast Superior Long Arm Adult Fbrg", wrvu: 0.00 },
 "Q4007": { name: "Cast Superior Long Arm Ped Plster", wrvu: 0.00 },
 "Q4008": { name: "Cast Superior Long Arm Ped Fbrgls", wrvu: 0.00 },
 "Q4009": { name: "Cast Superior Sht Arm Adult Plstr", wrvu: 0.00 },
 "Q4010": { name: "Cast Superior Sht Arm Adult Fbrgl", wrvu: 0.00 },
 "Q4011": { name: "Cast Superior Sht Arm Ped Plaster", wrvu: 0.00 },
 "Q4012": { name: "Cast Superior Sht Arm Ped Fbrglas", wrvu: 0.00 },
 "Q4013": { name: "Cast Superior Gauntlet Plaster", wrvu: 0.00 },
 "Q4014": { name: "Cast Superior Gauntlet Fiberglass", wrvu: 0.00 },
 "Q4015": { name: "Cast Superior Gauntlet Ped Plster", wrvu: 0.00 },
 "Q4016": { name: "Cast Superior Gauntlet Ped Fbrgls", wrvu: 0.00 },
 "Q4017": { name: "Cast Superior Lung Arm Splint Plst", wrvu: 0.00 },
 "Q4018": { name: "Cast Superior Lung Arm Splint Fbrg", wrvu: 0.00 },
 "Q4019": { name: "Cast Superior Lung Arm Splinting Ped P", wrvu: 0.00 },
 "Q4020": { name: "Cast Superior Lung Arm Splinting Ped F", wrvu: 0.00 },
 "Q4021": { name: "Cast Superior Sht Arm Splint Plst", wrvu: 0.00 },
 "Q4022": { name: "Cast Superior Sht Arm Splint Fbrg", wrvu: 0.00 },
 "Q4023": { name: "Cast Superior Sht Arm Splinting Ped P", wrvu: 0.00 },
 "Q4024": { name: "Cast Superior Sht Arm Splinting Ped F", wrvu: 0.00 },
 "Q4025": { name: "Cast Superior Hip Spica Plaster", wrvu: 0.00 },
 "Q4026": { name: "Cast Superior Hip Spica Fiberglas", wrvu: 0.00 },
 "Q4027": { name: "Cast Superior Hip Spica Ped Plstr", wrvu: 0.00 },
 "Q4028": { name: "Cast Superior Hip Spica Ped Fbrgl", wrvu: 0.00 },
 "Q4029": { name: "Cast Superior Long Leg Plaster", wrvu: 0.00 },
 "Q4030": { name: "Cast Superior Long Leg Fiberglass", wrvu: 0.00 },
 "Q4031": { name: "Cast Superior Lung Leg Ped Plaster", wrvu: 0.00 },
 "Q4032": { name: "Cast Superior Lung Leg Ped Fbrgls", wrvu: 0.00 },
 "Q4033": { name: "Cast Superior Lung Leg Cylinder Pl", wrvu: 0.00 },
 "Q4034": { name: "Cast Superior Lung Leg Cylinder Fb", wrvu: 0.00 },
 "Q4035": { name: "Cast Superior Lngleg Cylndr Ped P", wrvu: 0.00 },
 "Q4036": { name: "Cast Superior Lngleg Cylndr Ped F", wrvu: 0.00 },
 "Q4037": { name: "Cast Superior Shrt Leg Plaster", wrvu: 0.00 },
 "Q4038": { name: "Cast Superior Shrt Leg Fiberglass", wrvu: 0.00 },
 "Q4039": { name: "Cast Superior Shrt Leg Ped Plster", wrvu: 0.00 },
 "Q4040": { name: "Cast Superior Shrt Leg Ped Fbrgls", wrvu: 0.00 },
 "Q4041": { name: "Cast Superior Lung Leg Splinting Plstr", wrvu: 0.00 },
 "Q4042": { name: "Cast Superior Lung Leg Splinting Fbrgl", wrvu: 0.00 },
 "Q4043": { name: "Cast Superior Lung Leg Splinting Ped P", wrvu: 0.00 },
 "Q4044": { name: "Cast Superior Lung Leg Splinting Ped F", wrvu: 0.00 },
 "Q4045": { name: "Cast Superior Sht Leg Splinting Plstr", wrvu: 0.00 },
 "Q4046": { name: "Cast Superior Sht Leg Splinting Fbrgl", wrvu: 0.00 },
 "Q4047": { name: "Cast Superior Sht Leg Splinting Ped P", wrvu: 0.00 },
 "Q4048": { name: "Cast Superior Sht Leg Splinting Ped F", wrvu: 0.00 },
 "Q4049": { name: "Finger Splint, Static", wrvu: 0.00 },
 "Q4050": { name: "Cast Supplies Unlisted", wrvu: 0.00 },
 "Q4051": { name: "Splint Supplies Misc", wrvu: 0.00 },
 "Q4074": { name: "Iloprost Non-comp Unit-Dose Dose", wrvu: 0.00 },
 "Q4081": { name: "Epoetin Alfa, 100 Units Esrd", wrvu: 0.00 },
 "Q4082": { name: "Drug/bio Noc Part B Drug Cap", wrvu: 0.00 },
 "Q4101": { name: "Apligraf", wrvu: 0.00 },
 "Q4102": { name: "Oasis Wound Matrix", wrvu: 0.00 },
 "Q4103": { name: "Oasis Burn Matrix", wrvu: 0.00 },
 "Q4104": { name: "Integra Bmwd", wrvu: 0.00 },
 "Q4105": { name: "Integra Drt Or Omnigraft", wrvu: 0.00 },
 "Q4107": { name: "Graftjacket", wrvu: 0.00 },
 "Q4108": { name: "Integra Matrix", wrvu: 0.00 },
 "Q4110": { name: "Primatrix", wrvu: 0.00 },
 "Q4111": { name: "Gammagraft", wrvu: 0.00 },
 "Q4112": { name: "Cymetra Injectable", wrvu: 0.00 },
 "Q4113": { name: "Graftjacket Xpress", wrvu: 0.00 },
 "Q4114": { name: "Integra Flowable Wound Matri", wrvu: 0.00 },
 "Q4115": { name: "Alloskin", wrvu: 0.00 },
 "Q4116": { name: "Alloderm", wrvu: 0.00 },
 "Q4117": { name: "Hyalomatrix", wrvu: 0.00 },
 "Q4118": { name: "Matristem Micromatrix", wrvu: 0.00 },
 "Q4121": { name: "Theraskin", wrvu: 0.00 },
 "Q4122": { name: "Dermacell, Awm, Porous subcutaneous cm", wrvu: 0.00 },
 "Q4123": { name: "Alloskin", wrvu: 0.00 },
 "Q4124": { name: "Oasis Tri-layer Wound Matrix", wrvu: 0.00 },
 "Q4125": { name: "Arthroflex", wrvu: 0.00 },
 "Q4126": { name: "Memoderm/derma/tranz/integup", wrvu: 0.00 },
 "Q4127": { name: "Talymed", wrvu: 0.00 },
 "Q4128": { name: "Flexhd/allopatchhd/subcutaneous cm", wrvu: 0.00 },
 "Q4130": { name: "Strattice Tm", wrvu: 0.00 },
 "Q4132": { name: "Grafix Core, Grafixpl Core", wrvu: 0.00 },
 "Q4133": { name: "Grafix Stravix Prime Pl Sqcm", wrvu: 0.00 },
 "Q4134": { name: "Hmatrix", wrvu: 0.00 },
 "Q4135": { name: "Mediskin", wrvu: 0.00 },
 "Q4136": { name: "Ezderm", wrvu: 0.00 },
 "Q4137": { name: "Amnioexcel Biodexcel 1sq Cm", wrvu: 0.00 },
 "Q4138": { name: "Biodfence Dryflex, 1cm", wrvu: 0.00 },
 "Q4139": { name: "Amnio Or Biodmatrix, Injection 1cc", wrvu: 0.00 },
 "Q4140": { name: "Biodfence 1cm", wrvu: 0.00 },
 "Q4141": { name: "Alloskin Ac, 1 Cm", wrvu: 0.00 },
 "Q4142": { name: "Xcm Biologic Tiss Matrix 1cm", wrvu: 0.00 },
 "Q4143": { name: "Repriza, 1cm", wrvu: 0.00 },
 "Q4145": { name: "Epifix, Injection, 1mg", wrvu: 0.00 },
 "Q4146": { name: "Tensix, 1cm", wrvu: 0.00 },
 "Q4147": { name: "Architect Ecm Procedure Fracture 1 subcutaneous cm", wrvu: 0.00 },
 "Q4148": { name: "Neox Neox Right Or Clarix Cord", wrvu: 0.00 },
 "Q4149": { name: "Excellagen, 0.1 Cc", wrvu: 0.00 },
 "Q4150": { name: "Allowrap Ds Or Dry 1 subcutaneous cm", wrvu: 0.00 },
 "Q4151": { name: "Amnioband, Guardian 1 subcutaneous cm", wrvu: 0.00 },
 "Q4152": { name: "Dermapure 1 Square Cm", wrvu: 0.00 },
 "Q4153": { name: "Dermavest, Plurivest subcutaneous cm", wrvu: 0.00 },
 "Q4154": { name: "Biovance 1 Square Cm", wrvu: 0.00 },
 "Q4155": { name: "Neoxflo Or Clarixflo 1 Mg", wrvu: 0.00 },
 "Q4156": { name: "Neox 100 Or Clarix 100", wrvu: 0.00 },
 "Q4157": { name: "Revitalon 1 Square Cm", wrvu: 0.00 },
 "Q4158": { name: "Kerecis Omega3, Per subcutaneous cm", wrvu: 0.00 },
 "Q4159": { name: "Affinity1 Square Cm", wrvu: 0.00 },
 "Q4160": { name: "Nushield 1 Square Cm", wrvu: 0.00 },
 "Q4161": { name: "Bio-connekt Per Square Cm", wrvu: 0.00 },
 "Q4162": { name: "Wndex Flw, Bioskn Flw, 0.5cc", wrvu: 0.00 },
 "Q4163": { name: "Woundex, Bioskin, Per subcutaneous cm", wrvu: 0.00 },
 "Q4164": { name: "Helicoll, Per Square Cm", wrvu: 0.00 },
 "Q4165": { name: "Keramatrix, Kerasorb subcutaneous cm", wrvu: 0.00 },
 "Q4166": { name: "Cytal, Per Square Centimeter", wrvu: 0.00 },
 "Q4167": { name: "Truskin, Per Subcutaneous Centimeter", wrvu: 0.00 },
 "Q4168": { name: "Amnioband, 1 Mg", wrvu: 0.00 },
 "Q4169": { name: "Artacent Wound, Per subcutaneous cm", wrvu: 0.00 },
 "Q4170": { name: "Cygnus, Per subcutaneous cm", wrvu: 0.00 },
 "Q4171": { name: "Interfyl, 1 Mg", wrvu: 0.00 },
 "Q4173": { name: "Palingen Or Palingen Xplus", wrvu: 0.00 },
 "Q4174": { name: "Palingen Or Promatrx", wrvu: 0.00 },
 "Q4175": { name: "Miroderm", wrvu: 0.00 },
 "Q4176": { name: "Neopatch Or Therion, 1 subcutaneous cm", wrvu: 0.00 },
 "Q4177": { name: "Floweramnioflo, 0.1 Cc", wrvu: 0.00 },
 "Q4178": { name: "Floweramniopatch, Per subcutaneous cm", wrvu: 0.00 },
 "Q4179": { name: "Flowerderm, Per subcutaneous cm", wrvu: 0.00 },
 "Q4180": { name: "Revita, Per subcutaneous cm", wrvu: 0.00 },
 "Q4181": { name: "Amnio Wound, Per Square Cm", wrvu: 0.00 },
 "Q4182": { name: "Transcyte, Per Subcutaneous Centimeter", wrvu: 0.00 },
 "Q4183": { name: "Surgigraft, 1 subcutaneous cm", wrvu: 0.00 },
 "Q4184": { name: "Cellesta Or Duo Per subcutaneous cm", wrvu: 0.00 },
 "Q4185": { name: "Cellesta Flowab Amnion 0.5cc", wrvu: 0.00 },
 "Q4186": { name: "Epifix 1 subcutaneous cm", wrvu: 0.00 },
 "Q4187": { name: "Epicord 1 subcutaneous cm", wrvu: 0.00 },
 "Q4188": { name: "Amnioarmor 1 subcutaneous cm", wrvu: 0.00 },
 "Q4189": { name: "Artacent Ac, 1 Mg", wrvu: 0.00 },
 "Q4190": { name: "Artacent Ac 1 subcutaneous cm", wrvu: 0.00 },
 "Q4191": { name: "Restorigin 1 subcutaneous cm", wrvu: 0.00 },
 "Q4192": { name: "Restorigin, 1 Cc", wrvu: 0.00 },
 "Q4193": { name: "Collection-e-derm 1 subcutaneous cm", wrvu: 0.00 },
 "Q4194": { name: "Novachor 1 subcutaneous cm", wrvu: 0.00 },
 "Q4195": { name: "Puraply 1 subcutaneous cm", wrvu: 0.00 },
 "Q4196": { name: "Puraply Am 1 subcutaneous cm", wrvu: 0.00 },
 "Q4197": { name: "Puraply Xt 1 subcutaneous cm", wrvu: 0.00 },
 "Q4198": { name: "Genesis Amnio Membrane 1sqcm", wrvu: 0.00 },
 "Q4199": { name: "Cygnus Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4200": { name: "Skin Te 1 subcutaneous cm", wrvu: 0.00 },
 "Q4201": { name: "Matrion 1 subcutaneous cm", wrvu: 0.00 },
 "Q4202": { name: "Keroxx (2.5g/cc), 1cc", wrvu: 0.00 },
 "Q4203": { name: "Derma-gide, 1 subcutaneous cm", wrvu: 0.00 },
 "Q4204": { name: "Xwrap 1 subcutaneous cm", wrvu: 0.00 },
 "Q4205": { name: "Membrane Graft Or Wrapping subcutaneous cm", wrvu: 0.00 },
 "Q4206": { name: "Fluid Flow Or Fluid Gf 1 Cc", wrvu: 0.00 },
 "Q4208": { name: "Novafix Per subcutaneous cm", wrvu: 0.00 },
 "Q4209": { name: "Surgraft Per subcutaneous cm", wrvu: 0.00 },
 "Q4211": { name: "Amnion Bio Or Axobio subcutaneous cm", wrvu: 0.00 },
 "Q4212": { name: "Allogen, Per Cc", wrvu: 0.00 },
 "Q4213": { name: "Ascent, 0.5 Mg", wrvu: 0.00 },
 "Q4214": { name: "Cellesta Cord Per subcutaneous cm", wrvu: 0.00 },
 "Q4215": { name: "Axolotl Ambient, Cryo 0.1 Mg", wrvu: 0.00 },
 "Q4216": { name: "Artacent Cord Per subcutaneous cm", wrvu: 0.00 },
 "Q4217": { name: "Woundfix Biowound Plus Xplus", wrvu: 0.00 },
 "Q4218": { name: "Surgicord Per subcutaneous cm", wrvu: 0.00 },
 "Q4219": { name: "Surgigraft Dual Per subcutaneous cm", wrvu: 0.00 },
 "Q4220": { name: "Bellacell Hd, Surederm subcutaneous cm", wrvu: 0.00 },
 "Q4221": { name: "Amniowrap2 Per subcutaneous cm", wrvu: 0.00 },
 "Q4222": { name: "Progenamatrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4224": { name: "Hhf10-p Per subcutaneous cm", wrvu: 0.00 },
 "Q4225": { name: "Amnio Or Derma Tl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4226": { name: "Myown Harv Prep Procedure subcutaneous cm", wrvu: 0.00 },
 "Q4227": { name: "Amniocore Per subcutaneous cm", wrvu: 0.00 },
 "Q4229": { name: "Cogenex Amnio Memb Per subcutaneous cm", wrvu: 0.00 },
 "Q4230": { name: "Cogenex Flow Amnion 0.5 Cc", wrvu: 0.00 },
 "Q4232": { name: "Corplex, Per subcutaneous cm", wrvu: 0.00 },
 "Q4233": { name: "Surfactor /nudyn Per 0.5 Cc", wrvu: 0.00 },
 "Q4234": { name: "Xcellerate, Per subcutaneous cm", wrvu: 0.00 },
 "Q4235": { name: "Amniorepair Or Altiply subcutaneous cm", wrvu: 0.00 },
 "Q4236": { name: "Carepatch Per subcutaneous cm", wrvu: 0.00 },
 "Q4237": { name: "Cryo-cord, Per subcutaneous cm", wrvu: 0.00 },
 "Q4238": { name: "Derm-maxx, Per subcutaneous cm", wrvu: 0.00 },
 "Q4239": { name: "Amnio-maxx Or Lite Per subcutaneous cm", wrvu: 0.00 },
 "Q4240": { name: "Corecyte Topical Only 0.5 Cc", wrvu: 0.00 },
 "Q4241": { name: "Polycyte, Topical Only 0.5cc", wrvu: 0.00 },
 "Q4242": { name: "Amniocyte Plus, Per 0.5 Cc", wrvu: 0.00 },
 "Q4245": { name: "Amniotext, Per Cc", wrvu: 0.00 },
 "Q4246": { name: "Coretext Or Protext, Per Cc", wrvu: 0.00 },
 "Q4247": { name: "Amniotext Patch, Per subcutaneous cm", wrvu: 0.00 },
 "Q4248": { name: "Dermacyte Amn Mem Allo subcutaneous cm", wrvu: 0.00 },
 "Q4249": { name: "Amniply, Per subcutaneous cm", wrvu: 0.00 },
 "Q4250": { name: "Amnioamp-mp Per subcutaneous cm", wrvu: 0.00 },
 "Q4251": { name: "Vim, Per Square Centimeter", wrvu: 0.00 },
 "Q4252": { name: "Vendaje, Per Square Centimet", wrvu: 0.00 },
 "Q4253": { name: "Zenith Amniotic Membrane Psc", wrvu: 0.00 },
 "Q4254": { name: "Novafix Dl Per subcutaneous cm", wrvu: 0.00 },
 "Q4255": { name: "Reguard, Topical Use Per Subcutaneous", wrvu: 0.00 },
 "Q4256": { name: "Mlg Complet, Per subcutaneous cm", wrvu: 0.00 },
 "Q4257": { name: "Relese, Per subcutaneous cm", wrvu: 0.00 },
 "Q4258": { name: "Enverse, Per subcutaneous cm", wrvu: 0.00 },
 "Q4259": { name: "Celera Per subcutaneous cm", wrvu: 0.00 },
 "Q4260": { name: "Signature Apatch, Per subcutaneous cm", wrvu: 0.00 },
 "Q4261": { name: "Tag, Per Square Centimeter", wrvu: 0.00 },
 "Q4262": { name: "Dual Layer Impax, Per subcutaneous cm", wrvu: 0.00 },
 "Q4263": { name: "Surgraft Tl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4264": { name: "Cocoon Membrane, Per subcutaneous cm", wrvu: 0.00 },
 "Q4265": { name: "Neostim Tl Per subcutaneous cm", wrvu: 0.00 },
 "Q4266": { name: "Neostim Per subcutaneous cm", wrvu: 0.00 },
 "Q4267": { name: "Neostim Dl Per subcutaneous cm", wrvu: 0.00 },
 "Q4268": { name: "Surgraft Ft Per subcutaneous cm", wrvu: 0.00 },
 "Q4269": { name: "Surgraft Xt Per subcutaneous cm", wrvu: 0.00 },
 "Q4270": { name: "Complete Sl Per subcutaneous cm", wrvu: 0.00 },
 "Q4271": { name: "Complete Ft Per subcutaneous cm", wrvu: 0.00 },
 "Q4272": { name: "Esano A, Per subcutaneous cm", wrvu: 0.00 },
 "Q4273": { name: "Esano Aaa, Per subcutaneous cm", wrvu: 0.00 },
 "Q4274": { name: "Esano Ac, Per subcutaneous cm", wrvu: 0.00 },
 "Q4275": { name: "Esano Aca, Per subcutaneous cm", wrvu: 0.00 },
 "Q4276": { name: "Orion, Per subcutaneous cm", wrvu: 0.00 },
 "Q4278": { name: "Epieffect, Per subcutaneous cm", wrvu: 0.00 },
 "Q4279": { name: "Vendaje Ac, Per subcutaneous cm", wrvu: 0.00 },
 "Q4280": { name: "Xcell Amnio Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4281": { name: "Barrera Slor Dl Per subcutaneous cm", wrvu: 0.00 },
 "Q4282": { name: "Cygnus Dual Per subcutaneous cm", wrvu: 0.00 },
 "Q4283": { name: "Biovance Tri Or 3l, subcutaneous cm", wrvu: 0.00 },
 "Q4284": { name: "Dermabind Sl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4285": { name: "Nudyn Dl Or Dl Mesh Per subcutaneous cm", wrvu: 0.00 },
 "Q4286": { name: "Nudyn Sl Or Slw, Per subcutaneous cm", wrvu: 0.00 },
 "Q4287": { name: "Dermabind Dl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4288": { name: "Dermabind Chest, Per subcutaneous cm", wrvu: 0.00 },
 "Q4289": { name: "Revoshield+ Amnio, Per subcutaneous cm", wrvu: 0.00 },
 "Q4290": { name: "Membrane Wrapping Hydr Per subcutaneous cm", wrvu: 0.00 },
 "Q4291": { name: "Lamellas Xt, Per subcutaneous cm", wrvu: 0.00 },
 "Q4292": { name: "Lamellas, Per subcutaneous cm", wrvu: 0.00 },
 "Q4293": { name: "Acesso Dl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4294": { name: "Amnio Quad-core, Per subcutaneous cm", wrvu: 0.00 },
 "Q4295": { name: "Amnio Tri-core, Per subcutaneous cm", wrvu: 0.00 },
 "Q4296": { name: "Rebound Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4297": { name: "Emerge Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4298": { name: "Amniocore Pro, Per subcutaneous cm", wrvu: 0.00 },
 "Q4299": { name: "Amniocore Pro+, Per subcutaneous cm", wrvu: 0.00 },
 "Q4300": { name: "Acesso Tl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4301": { name: "Activate Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4302": { name: "Complete Aca, Per subcutaneous cm", wrvu: 0.00 },
 "Q4303": { name: "Complete Aa, Per subcutaneous cm", wrvu: 0.00 },
 "Q4304": { name: "Grafix Plus, Per subcutaneous cm", wrvu: 0.00 },
 "Q4305": { name: "Amer Am Ac Tri-lay Per subcutaneous cm", wrvu: 0.00 },
 "Q4306": { name: "Americ Amnion Ac Per subcutaneous cm", wrvu: 0.00 },
 "Q4307": { name: "American Amnion, Per subcutaneous cm", wrvu: 0.00 },
 "Q4308": { name: "Sanopellis, Per subcutaneous cm", wrvu: 0.00 },
 "Q4309": { name: "Via Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4310": { name: "Procenta, Per 100 Mg", wrvu: 0.00 },
 "Q4311": { name: "Acesso, Per subcutaneous cm", wrvu: 0.00 },
 "Q4312": { name: "Acesso Ac, Per subcutaneous cm", wrvu: 0.00 },
 "Q4313": { name: "Dermabind Fm, Per subcutaneous cm", wrvu: 0.00 },
 "Q4314": { name: "Reeva, Per subcutaneous cm", wrvu: 0.00 },
 "Q4315": { name: "Regenelink Amniotic Mem Allo", wrvu: 0.00 },
 "Q4316": { name: "Amchoplast, Per subcutaneous cm", wrvu: 0.00 },
 "Q4317": { name: "Vitograft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4318": { name: "E-graft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4319": { name: "Sanograft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4320": { name: "Pellograft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4321": { name: "Renograft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4322": { name: "Caregraft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4323": { name: "Alloply, Per subcutaneous cm", wrvu: 0.00 },
 "Q4324": { name: "Amniotx, Per subcutaneous cm", wrvu: 0.00 },
 "Q4325": { name: "Acapatch, Per subcutaneous cm", wrvu: 0.00 },
 "Q4326": { name: "Woundplus, Per subcutaneous cm", wrvu: 0.00 },
 "Q4327": { name: "Duoamnion, Per subcutaneous cm", wrvu: 0.00 },
 "Q4328": { name: "Most, Per subcutaneous cm", wrvu: 0.00 },
 "Q4329": { name: "Singlay, Per subcutaneous cm", wrvu: 0.00 },
 "Q4330": { name: "Total, Per subcutaneous cm", wrvu: 0.00 },
 "Q4331": { name: "Axolotl Graft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4332": { name: "Axolotl Dualgraft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4333": { name: "Ardeograft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4334": { name: "Amnioplast 1, Per subcutaneous cm", wrvu: 0.00 },
 "Q4335": { name: "Amnioplast 2, Per subcutaneous cm", wrvu: 0.00 },
 "Q4336": { name: "Artecent C, Per subcutaneous cm", wrvu: 0.00 },
 "Q4337": { name: "Artecent Trident, Per subcutaneous cm", wrvu: 0.00 },
 "Q4338": { name: "Artacent Velos, Per subcutaneous cm", wrvu: 0.00 },
 "Q4339": { name: "Artacent Vericlen, Per subcutaneous cm", wrvu: 0.00 },
 "Q4340": { name: "Simpligraft, Per subcutaneous cm", wrvu: 0.00 },
 "Q4341": { name: "Simplimax, Per subcutaneous cm", wrvu: 0.00 },
 "Q4342": { name: "Theramend, Per subcutaneous cm", wrvu: 0.00 },
 "Q4343": { name: "Dermacyte Ac Matrx Per subcutaneous cm", wrvu: 0.00 },
 "Q4344": { name: "Tri Membrane Wrapping, Per subcutaneous cm", wrvu: 0.00 },
 "Q4345": { name: "Matrix Hd Allograft Per subcutaneous cm", wrvu: 0.00 },
 "Q4346": { name: "Shelter Dm Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4347": { name: "Rampart Dl Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4348": { name: "Sentry Sl Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4349": { name: "Mantle Dl Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4350": { name: "Palisade Dm Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4351": { name: "Enclose Tl Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4352": { name: "Overlay Sl Matrix, Per subcutaneous cm", wrvu: 0.00 },
 "Q4353": { name: "Xceed Tl Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4354": { name: "Palingen Dl-palingen Dl-x", wrvu: 0.00 },
 "Q4355": { name: "Abio Xpl Abio Xpl Hy P subcutaneous cm", wrvu: 0.00 },
 "Q4356": { name: "Abio Mem Abio Hyd Per subcutaneous cm", wrvu: 0.00 },
 "Q4357": { name: "Xwrap Plus, Per subcutaneous cm", wrvu: 0.00 },
 "Q4358": { name: "Xwrap Dual, Per subcutaneous cm", wrvu: 0.00 },
 "Q4359": { name: "Choriply, Per subcutaneous cm", wrvu: 0.00 },
 "Q4360": { name: "Amchoplast Fd Per subcutaneous cm", wrvu: 0.00 },
 "Q4361": { name: "Epixpress, Per subcutaneous cm", wrvu: 0.00 },
 "Q4362": { name: "Cygnus Disk, Per subcutaneous cm", wrvu: 0.00 },
 "Q4363": { name: "Am Bur Mem Hydro Per subcutaneous cm", wrvu: 0.00 },
 "Q4364": { name: "Am Bur Xp Mem Xpl Hy P subcutaneous cm", wrvu: 0.00 },
 "Q4365": { name: "Amnio Bur Dl Mem Per subcutaneous cm", wrvu: 0.00 },
 "Q4366": { name: "Dl Amnio Bur X-mem Per subcutaneous cm", wrvu: 0.00 },
 "Q4367": { name: "Amniocore Sl, Per subcutaneous cm", wrvu: 0.00 },
 "Q4368": { name: "Amchothick Per subcutaneous cm", wrvu: 0.00 },
 "Q4369": { name: "Amnioplast 3 Per subcutaneous cm", wrvu: 0.00 },
 "Q4370": { name: "Aeroguard Per subcutaneous cm", wrvu: 0.00 },
 "Q4371": { name: "Neoguard Per subcutaneous cm", wrvu: 0.00 },
 "Q4372": { name: "Amchoplast Excl Per subcutaneous cm", wrvu: 0.00 },
 "Q4373": { name: "Membrane Wrp Left Per subcutaneous cm", wrvu: 0.00 },
 "Q4375": { name: "Duograft Ac Per subcutaneous cm", wrvu: 0.00 },
 "Q4376": { name: "Duograft Aa Per subcutaneous cm", wrvu: 0.00 },
 "Q4377": { name: "Trigraft Ft Per subcutaneous cm", wrvu: 0.00 },
 "Q4378": { name: "Renew Ft Matrix Per subcutaneous cm", wrvu: 0.00 },
 "Q4379": { name: "Amniodefend Ft Per subcutaneous cm", wrvu: 0.00 },
 "Q4380": { name: "Advograft One Per subcutaneous cm", wrvu: 0.00 },
 "Q4382": { name: "Advograft Dual Per subcutaneous cm", wrvu: 0.00 },
 "Q4383": { name: "Axolotl Graft Ult Per subcutaneous cm", wrvu: 0.00 },
 "Q4384": { name: "Axolotl Dual Ult Per subcutaneous cm", wrvu: 0.00 },
 "Q4385": { name: "Apollo Ft Per subcutaneous cm", wrvu: 0.00 },
 "Q4386": { name: "Acesso Trifaca Per subcutaneous cm", wrvu: 0.00 },
 "Q4387": { name: "Neothelium Ft Per subcutaneous cm", wrvu: 0.00 },
 "Q4388": { name: "Neothelium 4l Per subcutaneous cm", wrvu: 0.00 },
 "Q4389": { name: "Neothelium 4l+ Per subcutaneous cm", wrvu: 0.00 },
 "Q4390": { name: "Ascendion Per subcutaneous cm", wrvu: 0.00 },
 "Q4391": { name: "Amnioplast Double Per subcutaneous cm", wrvu: 0.00 },
 "Q4392": { name: "Grafix Duo Per subcutaneous cm", wrvu: 0.00 },
 "Q4393": { name: "Surgraft Ac Per subcutaneous cm", wrvu: 0.00 },
 "Q4394": { name: "Surgraft Aca Per subcutaneous cm", wrvu: 0.00 },
 "Q4395": { name: "Acelagraft Per subcutaneous cm", wrvu: 0.00 },
 "Q4396": { name: "Natalin Per subcutaneous cm", wrvu: 0.00 },
 "Q4397": { name: "Summit Aaa Per subcutaneous cm", wrvu: 0.00 },
 "Q4398": { name: "Summit Ac Per subcutaneous cm", wrvu: 0.00 },
 "Q4399": { name: "Summit Fracture Per subcutaneous cm", wrvu: 0.00 },
 "Q4400": { name: "Polygon3 Per subcutaneous cm", wrvu: 0.00 },
 "Q4401": { name: "Absolv3 Per subcutaneous cm", wrvu: 0.00 },
 "Q4402": { name: "Xwrap 2.0 Per subcutaneous cm", wrvu: 0.00 },
 "Q4403": { name: "Xwrap Dual Plus Per subcutaneous cm", wrvu: 0.00 },
 "Q4404": { name: "Xwrap Hydro Plus Per subcutaneous cm", wrvu: 0.00 },
 "Q4405": { name: "Xwrap Fenestra Plus subcutaneous cm", wrvu: 0.00 },
 "Q4406": { name: "Xwrap Fenestra Per subcutaneous cm", wrvu: 0.00 },
 "Q4407": { name: "Xwrap Tribus Per subcutaneous cm", wrvu: 0.00 },
 "Q4408": { name: "Xwrap Hydro Per subcutaneous cm", wrvu: 0.00 },
 "Q4409": { name: "Amniomatrixf3x Per subcutaneous cm", wrvu: 0.00 },
 "Q4410": { name: "Amchomatrixdl Per subcutaneous cm", wrvu: 0.00 },
 "Q4411": { name: "Amniomatrixf4x Per subcutaneous cm", wrvu: 0.00 },
 "Q4412": { name: "Choriofix Per subcutaneous cm", wrvu: 0.00 },
 "Q4413": { name: "Cygnus Solo Per subcutaneous cm", wrvu: 0.00 },
 "Q4414": { name: "Simplichor Per subcutaneous cm", wrvu: 0.00 },
 "Q4415": { name: "Alexiguard St-l Per subcutaneous cm", wrvu: 0.00 },
 "Q4416": { name: "Alexiguard Tl-t Per subcutaneous cm", wrvu: 0.00 },
 "Q4417": { name: "Alexiguard Dl-t Per subcutaneous cm", wrvu: 0.00 },
 "Q4420": { name: "Nuform Per subcutaneous cm", wrvu: 0.00 },
 "Q4431": { name: "Pma Skin Substitute, Not Otherwise Specified", wrvu: 0.00 },
 "Q4432": { name: "510(k) Skin Subs, Not Otherwise Specified", wrvu: 0.00 },
 "Q4433": { name: "361 Hematocrit/p Skin Subs, Not Otherwise Specified", wrvu: 0.00 },
 "Q5001": { name: "Hospice Or Home Hlth In Home", wrvu: 0.00 },
 "Q5002": { name: "Hospice/home Hlth In Asst Lv", wrvu: 0.00 },
 "Q5003": { name: "Hospice In Left/non-skilled Nf", wrvu: 0.00 },
 "Q5004": { name: "Hospice In Skilled Nursing Facility", wrvu: 0.00 },
 "Q5005": { name: "Hospice, Inpatient Hospital", wrvu: 0.00 },
 "Q5006": { name: "Hospice In Hospice Facility", wrvu: 0.00 },
 "Q5007": { name: "Hospice In Ltch", wrvu: 0.00 },
 "Q5008": { name: "Hospice In Inpatient Psych", wrvu: 0.00 },
 "Q5009": { name: "Hospice/home Hlth, Place Not Otherwise Specified", wrvu: 0.00 },
 "Q5010": { name: "Hospice Home Care In Hospice", wrvu: 0.00 },
 "Q5098": { name: "Injection Ustekinumab-srlf, 1 Mg", wrvu: 0.00 },
 "Q5099": { name: "Injection Ustekinumab-stba, 1 Mg", wrvu: 0.00 },
 "Q5100": { name: "Injection Ustekinumab-kfce, 1 Mg", wrvu: 0.00 },
 "Q5101": { name: "Injection, Zarxio", wrvu: 0.00 },
 "Q5103": { name: "Injection, Inflectra", wrvu: 0.00 },
 "Q5104": { name: "Injection, Renflexis", wrvu: 0.00 },
 "Q5105": { name: "Injection Retacrit Esrd On Dialysi", wrvu: 0.00 },
 "Q5106": { name: "Injection Retacrit Non-esrd Use", wrvu: 0.00 },
 "Q5107": { name: "Injection Mvasi 10 Mg", wrvu: 0.00 },
 "Q5108": { name: "Injection, Fulphila", wrvu: 0.00 },
 "Q5110": { name: "Nivestym", wrvu: 0.00 },
 "Q5111": { name: "Injection, Udenyca 0.5 Mg", wrvu: 0.00 },
 "Q5112": { name: "Injection Ontruzant 10 Mg", wrvu: 0.00 },
 "Q5113": { name: "Injection Herzuma 10 Mg", wrvu: 0.00 },
 "Q5114": { name: "Injection Ogivri 10 Mg", wrvu: 0.00 },
 "Q5115": { name: "Injection Truxima 10 Mg", wrvu: 0.00 },
 "Q5116": { name: "Injection., Trazimera, 10 Mg", wrvu: 0.00 },
 "Q5117": { name: "Injection., Kanjinti, 10 Mg", wrvu: 0.00 },
 "Q5118": { name: "Injection., Zirabev, 10 Mg", wrvu: 0.00 },
 "Q5119": { name: "Injection Ruxience, 10 Mg", wrvu: 0.00 },
 "Q5120": { name: "Injection Pegfilgrastim-bmez 0.5mg", wrvu: 0.00 },
 "Q5121": { name: "Injection. Avsola, 10 Mg", wrvu: 0.00 },
 "Q5122": { name: "Injection, Nyvepria", wrvu: 0.00 },
 "Q5123": { name: "Injection. Riabni, 10 Mg", wrvu: 0.00 },
 "Q5124": { name: "Injection. Byooviz, 0.1 Mg", wrvu: 0.00 },
 "Q5125": { name: "Injection, Releuko 1 mcg", wrvu: 0.00 },
 "Q5126": { name: "Injection Alymsys 10 Mg", wrvu: 0.00 },
 "Q5127": { name: "Injection, Stimufend, 0.5 Mg", wrvu: 0.00 },
 "Q5128": { name: "Injection, Cimerli, 0.1 Mg", wrvu: 0.00 },
 "Q5129": { name: "Injection, Vegzelma, 10 Mg", wrvu: 0.00 },
 "Q5130": { name: "Injection, Fylnetra, 0.5 Mg", wrvu: 0.00 },
 "Q5133": { name: "Injection, Tofidence, 1 Mg", wrvu: 0.00 },
 "Q5134": { name: "Injection, Tyruko, 1 Mg", wrvu: 0.00 },
 "Q5135": { name: "Injection, Tyenne, 1 Mg", wrvu: 0.00 },
 "Q5136": { name: "Injection. Denosumab-bbdz, 1 Mg", wrvu: 0.00 },
 "Q5137": { name: "Injection, Wezlana, Sub Cu, 1 Mg", wrvu: 0.00 },
 "Q5138": { name: "Injection, Wezlana, Intravenous 1 Mg", wrvu: 0.00 },
 "Q5140": { name: "Injection Adalimumab-fkjp, 1 Mg", wrvu: 0.00 },
 "Q5141": { name: "Injection Adalimumab-aaty, 1 Mg", wrvu: 0.00 },
 "Q5142": { name: "Injection Adalimumab-ryvk, 1 Mg", wrvu: 0.00 },
 "Q5143": { name: "Injection Adalimumab-adbm, 1 Mg", wrvu: 0.00 },
 "Q5144": { name: "Injection, Idacio, 1 Mg", wrvu: 0.00 },
 "Q5145": { name: "Injection, Abrilada, 1 Mg", wrvu: 0.00 },
 "Q5146": { name: "Injection, Hercessi, 10 Mg", wrvu: 0.00 },
 "Q5147": { name: "Injection, Aflibercept-ayyh, 1 Mg", wrvu: 0.00 },
 "Q5148": { name: "Injection, Nyposi 1 mcg", wrvu: 0.00 },
 "Q5149": { name: "Injection, Aflibercept-abzv, 1 Mg", wrvu: 0.00 },
 "Q5150": { name: "Injection, Aflibercept-mrbb, 1 Mg", wrvu: 0.00 },
 "Q5151": { name: "Injection, Eculizumab-aagh, 2 Mg", wrvu: 0.00 },
 "Q5152": { name: "Injection, Eculizumab-aeeb, 2 Mg", wrvu: 0.00 },
 "Q5153": { name: "Injection, Aflibercept-yszy, 1 Mg", wrvu: 0.00 },
 "Q5154": { name: "Injection, Omlyclo, 5 Mg", wrvu: 0.00 },
 "Q5155": { name: "Injection, Aflibercept-jbvf, 1 Mg", wrvu: 0.00 },
 "Q5156": { name: "Injection, Tocilizumab-anoh, 1 Mg", wrvu: 0.00 },
 "Q5157": { name: "Injection, Denosumab-bmwo, 1 Mg", wrvu: 0.00 },
 "Q5158": { name: "Injection, Denosumab-bnht, 1 Mg", wrvu: 0.00 },
 "Q5159": { name: "Injection, Denosumab-dssb, 1 Mg", wrvu: 0.00 },
 "Q5160": { name: "Injection, Jobevne, 10 Mg", wrvu: 0.00 },
 "Q9001": { name: "Chaplain Assessment", wrvu: 0.00 },
 "Q9002": { name: "Chaplain Counsel Individu", wrvu: 0.00 },
 "Q9003": { name: "Chaplain Counsel Group", wrvu: 0.00 },
 "Q9004": { name: "Va Whole Health Partner Serv", wrvu: 0.00 },
 "Q9950": { name: "Injection Sulf Hexa Lipid Microsph", wrvu: 0.00 },
 "Q9951": { name: "Locm >= 400 Mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9953": { name: "Injection Fe-based Mr Contrast,1ml", wrvu: 0.00 },
 "Q9954": { name: "Oral Mr Contrast, 100 Ml", wrvu: 0.00 },
 "Q9955": { name: "Injection Perflexane Lip Micros,ml", wrvu: 0.00 },
 "Q9956": { name: "Injection Octafluoropropane Mic,ml", wrvu: 0.00 },
 "Q9957": { name: "Injection Perflutren Lip Micros,ml", wrvu: 0.00 },
 "Q9958": { name: "Hocm <=149 Mg/mL Iodine, 1ml", wrvu: 0.00 },
 "Q9959": { name: "Hocm 150-199mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9960": { name: "Hocm 200-249mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9961": { name: "Hocm 250-299mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9962": { name: "Hocm 300-349mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9963": { name: "Hocm 350-399mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9964": { name: "Hocm>= 400mg/mL Iodine, 1ml", wrvu: 0.00 },
 "Q9965": { name: "Locm 100-199mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9966": { name: "Locm 200-299mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9967": { name: "Locm 300-399mg/mL Iodine,1ml", wrvu: 0.00 },
 "Q9968": { name: "Visualization Adjunct", wrvu: 0.00 },
 "Q9982": { name: "Flutemetamol F18 Diagnostic", wrvu: 0.00 },
 "Q9983": { name: "Florbetaben F18 Diagnostic", wrvu: 0.00 },
 "Q9991": { name: "Buprenorph X-ray 100 mg Or Less", wrvu: 0.00 },
 "Q9992": { name: "Buprenorphine X-ray Over 100 Mg", wrvu: 0.00 },
 "Q9996": { name: "Ustekinumab- Ttwe Sub Cu Injection", wrvu: 0.00 },
 "Q9997": { name: "Ustekinumab-ttwe Intravenous Injection 1 Mg", wrvu: 0.00 },
 "Q9998": { name: "Injection Ustekinumab-aekn, 1 Mg", wrvu: 0.00 },
 "Q9999": { name: "Injection Ustekinumab-aauz 1 Mg", wrvu: 0.00 },
};

/** Detect a CPT/HCPCS code in input text. Returns { code, name, wrvu } or null. */
export function detectCptCode(text) {
 const match = text.match(/\b([GQ]?\d{4,5})\b/i);
 if (match) {
 const code = match[1].toUpperCase();
 const entry = CPT_LOOKUP[code];
 if (entry) return { code, ...entry };
 }
 return null;
}

/**
 * Medical term synonym/stem map.
 * Maps user-typed variants to a common searchable stem so order-insensitive,
 * typo-tolerant queries work (e.g. "preventative" → matches "preventive").
 */
const MEDICAL_SYNONYMS = {
 // Preventive
 preventative: 'preventiv', preventive: 'preventiv', preventiv: 'preventiv',
 // Visit types
 established: 'established', establish: 'established', est: 'established',
 new: 'new', followup: 'subsequent', follow: 'subsequent', subsequent: 'subsequent',
 // Settings
 outpatient: 'outpatient', inpatient: 'inpatient',
 office: 'office', hospital: 'hospital', hosp: 'hospital',
 // Common procedures
 injection: 'injection', injection: 'injection', injx: 'injection',
 biopsy: 'biopsy', excision: 'excision', excis: 'excision',
 repair: 'repair', drainage: 'drainage', drain: 'drainage',
 removal: 'removal', debridement: 'debridement',
 colonoscopy: 'colonoscopy',
 endoscopy: 'endoscop', endoscopic: 'endoscop',
 laparoscopy: 'laparoscop', laparoscopic: 'laparoscop',
 arthroscopy: 'arthroscop', arthroscopic: 'arthroscop',
 arthroplasty: 'arthroplasty', replacement: 'arthroplasty', replace: 'arthroplasty',
 // Imaging
 ultrasound: 'ultrasound', echocardiographic: 'echocardiographic',
 echocardiogram: 'echocardiographic', echocardiography: 'echocardiographic',
 ekg: 'electrocardiogram', ecg: 'electrocardiogram',
 'x-ray': 'x-ray', xray: 'x-ray',
 mri: 'mri', ct: 'ct',
 // Age groups / patient types
 infant: 'infant', baby: 'infant',
 newborn: 'newborn', neonatal: 'newborn',
 child: 'child', pediatric: 'pediatric', peds: 'pediatric',
 adult: 'adult', geriatric: 'geriatric', elderly: 'geriatric',
 // Specialties
 anesthesia: 'anesthesia', anes: 'anesthesia',
 surgery: 'surgery', surgical: 'surgery',
 obstetric: 'obstetric', obstetrics: 'obstetric',
 psychiatric: 'psychiat', psychiatry: 'psychiat',
 // Care types
 critical: 'critical',
 evaluation: 'evaluation', evaluation: 'evaluation',
 management: 'management', management: 'management',
 counseling: 'counsel', counselling: 'counsel',
 therapy: 'therapy', therapeutic: 'therapeut',
 // Vaccines
 vaccine: 'vaccine', vaccination: 'vaccine', immunization: 'immuniz',
 flu: 'influenza', influenza: 'influenza',
};

/**
 * Search CPT codes by any combination of keywords in any order.
 * ALL tokens must be present (AND logic). Results are ranked by relevance.
 * Example: "infant preventative new" matches 99381 (Preventive Medicine New Patient Infant)
 */
export function searchCptCodes(query, limit = 20) {
 if (!query || query.trim().length < 2) return [];

 // Tokenize: split on whitespace and punctuation, keep tokens >= 2 chars
 const rawTokens = query
 .toLowerCase()
 .replace(/[,;.()\-\/]/g, ' ')
 .split(/\s+/)
 .filter(t => t.length >= 2);

 if (rawTokens.length === 0) return [];

 // Expand each token through synonym map (keep original AND mapped form)
 const tokens = rawTokens.map(t => MEDICAL_SYNONYMS[t] || t);

 // If single token and it looks like a code prefix, do a fast code-first scan
 const isSingleCodeLike = tokens.length === 1 && /^[0-9gq]\d*$/i.test(tokens[0]);

 const scored = [];

 for (const [code, data] of Object.entries(CPT_LOOKUP)) {
 const nameLower = data.name.toLowerCase();
 const haystack = `${code} ${nameLower}`;

 // All tokens must appear in the haystack
 if (!tokens.every(t => haystack.includes(t))) continue;

 // Relevance score (higher = better)
 let score = 0;
 if (code === tokens[0].toUpperCase()) score = 1000; // exact code match
 else if (code.startsWith(tokens[0].toUpperCase())) score = 800; // code prefix
 else if (isSingleCodeLike) score = 600;
 else {
 // Score by how well the name matches: shorter name with same tokens = tighter match
 const nameWords = nameLower.split(/\s+/).length;
 score = 500 - nameWords; // fewer words = more specific match
 // Bonus if name starts with any token
 if (tokens.some(t => nameLower.startsWith(t))) score += 50;
 // Bonus for high wRVU (commonly used procedures rank higher)
 if (data.wrvu > 0) score += Math.min(data.wrvu * 2, 20);
 }

 scored.push({ code, ...data, _score: score });
 }

 // Sort by score descending, then alphabetically by code for ties
 scored.sort((a, b) => b._score - a._score || a.code.localeCompare(b.code));

 // Return top results without the internal _score field
 return scored.slice(0, limit).map(({ _score, ...rest }) => rest);
}
